(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.simpleEditor = {}));
})(this, (function (exports) { 'use strict';

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function getDefaultExportFromCjs (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	var check$3 = function (it) {
	  return it && it.Math === Math && it;
	};

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global$G =
	  // eslint-disable-next-line es/no-global-this -- safe
	  check$3(typeof globalThis == 'object' && globalThis) ||
	  check$3(typeof window == 'object' && window) ||
	  // eslint-disable-next-line no-restricted-globals -- safe
	  check$3(typeof self == 'object' && self) ||
	  check$3(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
	  check$3(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
	  // eslint-disable-next-line no-new-func -- fallback
	  (function () { return this; })() || Function('return this')();

	var fails$T = function (exec) {
	  try {
	    return !!exec();
	  } catch (error) {
	    return true;
	  }
	};

	var fails$S = fails$T;

	var functionBindNative$1 = !fails$S(function () {
	  // eslint-disable-next-line es/no-function-prototype-bind -- safe
	  var test = (function () { /* empty */ }).bind();
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return typeof test != 'function' || test.hasOwnProperty('prototype');
	});

	var NATIVE_BIND$8 = functionBindNative$1;

	var FunctionPrototype$8 = Function.prototype;
	var apply$a = FunctionPrototype$8.apply;
	var call$w = FunctionPrototype$8.call;

	// eslint-disable-next-line es/no-reflect -- safe
	var functionApply$1 = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND$8 ? call$w.bind(apply$a) : function () {
	  return call$w.apply(apply$a, arguments);
	});

	var NATIVE_BIND$7 = functionBindNative$1;

	var FunctionPrototype$7 = Function.prototype;
	var call$v = FunctionPrototype$7.call;
	var uncurryThisWithBind$1 = NATIVE_BIND$7 && FunctionPrototype$7.bind.bind(call$v, call$v);

	var functionUncurryThis$1 = NATIVE_BIND$7 ? uncurryThisWithBind$1 : function (fn) {
	  return function () {
	    return call$v.apply(fn, arguments);
	  };
	};

	var uncurryThis$W = functionUncurryThis$1;

	var toString$t = uncurryThis$W({}.toString);
	var stringSlice$a = uncurryThis$W(''.slice);

	var classofRaw$5 = function (it) {
	  return stringSlice$a(toString$t(it), 8, -1);
	};

	var classofRaw$4 = classofRaw$5;
	var uncurryThis$V = functionUncurryThis$1;

	var functionUncurryThisClause$1 = function (fn) {
	  // Nashorn bug:
	  //   https://github.com/zloirock/core-js/issues/1128
	  //   https://github.com/zloirock/core-js/issues/1130
	  if (classofRaw$4(fn) === 'Function') return uncurryThis$V(fn);
	};

	var documentAll$5 = typeof document == 'object' && document.all;

	// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
	// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
	var IS_HTMLDDA$1 = typeof documentAll$5 == 'undefined' && documentAll$5 !== undefined;

	var documentAll_1$1 = {
	  all: documentAll$5,
	  IS_HTMLDDA: IS_HTMLDDA$1
	};

	var $documentAll$3 = documentAll_1$1;

	var documentAll$4 = $documentAll$3.all;

	// `IsCallable` abstract operation
	// https://tc39.es/ecma262/#sec-iscallable
	var isCallable$B = $documentAll$3.IS_HTMLDDA ? function (argument) {
	  return typeof argument == 'function' || argument === documentAll$4;
	} : function (argument) {
	  return typeof argument == 'function';
	};

	var objectGetOwnPropertyDescriptor$1 = {};

	var fails$R = fails$T;

	// Detect IE8's incomplete defineProperty implementation
	var descriptors$1 = !fails$R(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
	});

	var NATIVE_BIND$6 = functionBindNative$1;

	var call$u = Function.prototype.call;

	var functionCall$1 = NATIVE_BIND$6 ? call$u.bind(call$u) : function () {
	  return call$u.apply(call$u, arguments);
	};

	var objectPropertyIsEnumerable$1 = {};

	var $propertyIsEnumerable$2 = {}.propertyIsEnumerable;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getOwnPropertyDescriptor$9 = Object.getOwnPropertyDescriptor;

	// Nashorn ~ JDK8 bug
	var NASHORN_BUG$1 = getOwnPropertyDescriptor$9 && !$propertyIsEnumerable$2.call({ 1: 2 }, 1);

	// `Object.prototype.propertyIsEnumerable` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
	objectPropertyIsEnumerable$1.f = NASHORN_BUG$1 ? function propertyIsEnumerable(V) {
	  var descriptor = getOwnPropertyDescriptor$9(this, V);
	  return !!descriptor && descriptor.enumerable;
	} : $propertyIsEnumerable$2;

	var createPropertyDescriptor$b = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};

	var uncurryThis$U = functionUncurryThis$1;
	var fails$Q = fails$T;
	var classof$l = classofRaw$5;

	var $Object$9 = Object;
	var split$1 = uncurryThis$U(''.split);

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var indexedObject$1 = fails$Q(function () {
	  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return !$Object$9('z').propertyIsEnumerable(0);
	}) ? function (it) {
	  return classof$l(it) === 'String' ? split$1(it, '') : $Object$9(it);
	} : $Object$9;

	// we can't use just `it == null` since of `document.all` special case
	// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
	var isNullOrUndefined$e = function (it) {
	  return it === null || it === undefined;
	};

	var isNullOrUndefined$d = isNullOrUndefined$e;

	var $TypeError$n = TypeError;

	// `RequireObjectCoercible` abstract operation
	// https://tc39.es/ecma262/#sec-requireobjectcoercible
	var requireObjectCoercible$g = function (it) {
	  if (isNullOrUndefined$d(it)) throw new $TypeError$n("Can't call method on " + it);
	  return it;
	};

	// toObject with fallback for non-array-like ES3 strings
	var IndexedObject$5 = indexedObject$1;
	var requireObjectCoercible$f = requireObjectCoercible$g;

	var toIndexedObject$g = function (it) {
	  return IndexedObject$5(requireObjectCoercible$f(it));
	};

	var isCallable$A = isCallable$B;
	var $documentAll$2 = documentAll_1$1;

	var documentAll$3 = $documentAll$2.all;

	var isObject$B = $documentAll$2.IS_HTMLDDA ? function (it) {
	  return typeof it == 'object' ? it !== null : isCallable$A(it) || it === documentAll$3;
	} : function (it) {
	  return typeof it == 'object' ? it !== null : isCallable$A(it);
	};

	var path$q = {};

	var path$p = path$q;
	var global$F = global$G;
	var isCallable$z = isCallable$B;

	var aFunction$1 = function (variable) {
	  return isCallable$z(variable) ? variable : undefined;
	};

	var getBuiltIn$k = function (namespace, method) {
	  return arguments.length < 2 ? aFunction$1(path$p[namespace]) || aFunction$1(global$F[namespace])
	    : path$p[namespace] && path$p[namespace][method] || global$F[namespace] && global$F[namespace][method];
	};

	var uncurryThis$T = functionUncurryThis$1;

	var objectIsPrototypeOf$1 = uncurryThis$T({}.isPrototypeOf);

	var engineUserAgent$1 = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

	var global$E = global$G;
	var userAgent$4 = engineUserAgent$1;

	var process$5 = global$E.process;
	var Deno$2 = global$E.Deno;
	var versions$1 = process$5 && process$5.versions || Deno$2 && Deno$2.version;
	var v8$1 = versions$1 && versions$1.v8;
	var match$1, version$1;

	if (v8$1) {
	  match$1 = v8$1.split('.');
	  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
	  // but their correct versions are not interesting for us
	  version$1 = match$1[0] > 0 && match$1[0] < 4 ? 1 : +(match$1[0] + match$1[1]);
	}

	// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
	// so check `userAgent` even if `.v8` exists, but 0
	if (!version$1 && userAgent$4) {
	  match$1 = userAgent$4.match(/Edge\/(\d+)/);
	  if (!match$1 || match$1[1] >= 74) {
	    match$1 = userAgent$4.match(/Chrome\/(\d+)/);
	    if (match$1) version$1 = +match$1[1];
	  }
	}

	var engineV8Version$1 = version$1;

	/* eslint-disable es/no-symbol -- required for testing */
	var V8_VERSION$5 = engineV8Version$1;
	var fails$P = fails$T;
	var global$D = global$G;

	var $String$b = global$D.String;

	// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
	var symbolConstructorDetection$1 = !!Object.getOwnPropertySymbols && !fails$P(function () {
	  var symbol = Symbol('symbol detection');
	  // Chrome 38 Symbol has incorrect toString conversion
	  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
	  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
	  // of course, fail.
	  return !$String$b(symbol) || !(Object(symbol) instanceof Symbol) ||
	    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
	    !Symbol.sham && V8_VERSION$5 && V8_VERSION$5 < 41;
	});

	/* eslint-disable es/no-symbol -- required for testing */
	var NATIVE_SYMBOL$7 = symbolConstructorDetection$1;

	var useSymbolAsUid$1 = NATIVE_SYMBOL$7
	  && !Symbol.sham
	  && typeof Symbol.iterator == 'symbol';

	var getBuiltIn$j = getBuiltIn$k;
	var isCallable$y = isCallable$B;
	var isPrototypeOf$l = objectIsPrototypeOf$1;
	var USE_SYMBOL_AS_UID$3 = useSymbolAsUid$1;

	var $Object$8 = Object;

	var isSymbol$b = USE_SYMBOL_AS_UID$3 ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  var $Symbol = getBuiltIn$j('Symbol');
	  return isCallable$y($Symbol) && isPrototypeOf$l($Symbol.prototype, $Object$8(it));
	};

	var $String$a = String;

	var tryToString$8 = function (argument) {
	  try {
	    return $String$a(argument);
	  } catch (error) {
	    return 'Object';
	  }
	};

	var isCallable$x = isCallable$B;
	var tryToString$7 = tryToString$8;

	var $TypeError$m = TypeError;

	// `Assert: IsCallable(argument) is true`
	var aCallable$e = function (argument) {
	  if (isCallable$x(argument)) return argument;
	  throw new $TypeError$m(tryToString$7(argument) + ' is not a function');
	};

	var aCallable$d = aCallable$e;
	var isNullOrUndefined$c = isNullOrUndefined$e;

	// `GetMethod` abstract operation
	// https://tc39.es/ecma262/#sec-getmethod
	var getMethod$8 = function (V, P) {
	  var func = V[P];
	  return isNullOrUndefined$c(func) ? undefined : aCallable$d(func);
	};

	var call$t = functionCall$1;
	var isCallable$w = isCallable$B;
	var isObject$A = isObject$B;

	var $TypeError$l = TypeError;

	// `OrdinaryToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-ordinarytoprimitive
	var ordinaryToPrimitive$3 = function (input, pref) {
	  var fn, val;
	  if (pref === 'string' && isCallable$w(fn = input.toString) && !isObject$A(val = call$t(fn, input))) return val;
	  if (isCallable$w(fn = input.valueOf) && !isObject$A(val = call$t(fn, input))) return val;
	  if (pref !== 'string' && isCallable$w(fn = input.toString) && !isObject$A(val = call$t(fn, input))) return val;
	  throw new $TypeError$l("Can't convert object to primitive value");
	};

	var shared$c = {exports: {}};

	var isPure = true;

	var global$C = global$G;

	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var defineProperty$j = Object.defineProperty;

	var defineGlobalProperty$5 = function (key, value) {
	  try {
	    defineProperty$j(global$C, key, { value: value, configurable: true, writable: true });
	  } catch (error) {
	    global$C[key] = value;
	  } return value;
	};

	var global$B = global$G;
	var defineGlobalProperty$4 = defineGlobalProperty$5;

	var SHARED$1 = '__core-js_shared__';
	var store$7 = global$B[SHARED$1] || defineGlobalProperty$4(SHARED$1, {});

	var sharedStore$1 = store$7;

	var store$6 = sharedStore$1;

	(shared$c.exports = function (key, value) {
	  return store$6[key] || (store$6[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: '3.33.3',
	  mode: 'pure' ,
	  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
	  license: 'https://github.com/zloirock/core-js/blob/v3.33.3/LICENSE',
	  source: 'https://github.com/zloirock/core-js'
	});

	var sharedExports$1 = shared$c.exports;

	var requireObjectCoercible$e = requireObjectCoercible$g;

	var $Object$7 = Object;

	// `ToObject` abstract operation
	// https://tc39.es/ecma262/#sec-toobject
	var toObject$f = function (argument) {
	  return $Object$7(requireObjectCoercible$e(argument));
	};

	var uncurryThis$S = functionUncurryThis$1;
	var toObject$e = toObject$f;

	var hasOwnProperty$7 = uncurryThis$S({}.hasOwnProperty);

	// `HasOwnProperty` abstract operation
	// https://tc39.es/ecma262/#sec-hasownproperty
	// eslint-disable-next-line es/no-object-hasown -- safe
	var hasOwnProperty_1$1 = Object.hasOwn || function hasOwn(it, key) {
	  return hasOwnProperty$7(toObject$e(it), key);
	};

	var uncurryThis$R = functionUncurryThis$1;

	var id$3 = 0;
	var postfix$1 = Math.random();
	var toString$s = uncurryThis$R(1.0.toString);

	var uid$7 = function (key) {
	  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$s(++id$3 + postfix$1, 36);
	};

	var global$A = global$G;
	var shared$b = sharedExports$1;
	var hasOwn$p = hasOwnProperty_1$1;
	var uid$6 = uid$7;
	var NATIVE_SYMBOL$6 = symbolConstructorDetection$1;
	var USE_SYMBOL_AS_UID$2 = useSymbolAsUid$1;

	var Symbol$a = global$A.Symbol;
	var WellKnownSymbolsStore$3 = shared$b('wks');
	var createWellKnownSymbol$1 = USE_SYMBOL_AS_UID$2 ? Symbol$a['for'] || Symbol$a : Symbol$a && Symbol$a.withoutSetter || uid$6;

	var wellKnownSymbol$A = function (name) {
	  if (!hasOwn$p(WellKnownSymbolsStore$3, name)) {
	    WellKnownSymbolsStore$3[name] = NATIVE_SYMBOL$6 && hasOwn$p(Symbol$a, name)
	      ? Symbol$a[name]
	      : createWellKnownSymbol$1('Symbol.' + name);
	  } return WellKnownSymbolsStore$3[name];
	};

	var call$s = functionCall$1;
	var isObject$z = isObject$B;
	var isSymbol$a = isSymbol$b;
	var getMethod$7 = getMethod$8;
	var ordinaryToPrimitive$2 = ordinaryToPrimitive$3;
	var wellKnownSymbol$z = wellKnownSymbol$A;

	var $TypeError$k = TypeError;
	var TO_PRIMITIVE$1 = wellKnownSymbol$z('toPrimitive');

	// `ToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-toprimitive
	var toPrimitive$8 = function (input, pref) {
	  if (!isObject$z(input) || isSymbol$a(input)) return input;
	  var exoticToPrim = getMethod$7(input, TO_PRIMITIVE$1);
	  var result;
	  if (exoticToPrim) {
	    if (pref === undefined) pref = 'default';
	    result = call$s(exoticToPrim, input, pref);
	    if (!isObject$z(result) || isSymbol$a(result)) return result;
	    throw new $TypeError$k("Can't convert object to primitive value");
	  }
	  if (pref === undefined) pref = 'number';
	  return ordinaryToPrimitive$2(input, pref);
	};

	var toPrimitive$7 = toPrimitive$8;
	var isSymbol$9 = isSymbol$b;

	// `ToPropertyKey` abstract operation
	// https://tc39.es/ecma262/#sec-topropertykey
	var toPropertyKey$8 = function (argument) {
	  var key = toPrimitive$7(argument, 'string');
	  return isSymbol$9(key) ? key : key + '';
	};

	var global$z = global$G;
	var isObject$y = isObject$B;

	var document$4 = global$z.document;
	// typeof document.createElement is 'object' in old IE
	var EXISTS$3 = isObject$y(document$4) && isObject$y(document$4.createElement);

	var documentCreateElement$3 = function (it) {
	  return EXISTS$3 ? document$4.createElement(it) : {};
	};

	var DESCRIPTORS$q = descriptors$1;
	var fails$O = fails$T;
	var createElement$3 = documentCreateElement$3;

	// Thanks to IE8 for its funny defineProperty
	var ie8DomDefine$1 = !DESCRIPTORS$q && !fails$O(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty(createElement$3('div'), 'a', {
	    get: function () { return 7; }
	  }).a !== 7;
	});

	var DESCRIPTORS$p = descriptors$1;
	var call$r = functionCall$1;
	var propertyIsEnumerableModule$3 = objectPropertyIsEnumerable$1;
	var createPropertyDescriptor$a = createPropertyDescriptor$b;
	var toIndexedObject$f = toIndexedObject$g;
	var toPropertyKey$7 = toPropertyKey$8;
	var hasOwn$o = hasOwnProperty_1$1;
	var IE8_DOM_DEFINE$3 = ie8DomDefine$1;

	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var $getOwnPropertyDescriptor$4 = Object.getOwnPropertyDescriptor;

	// `Object.getOwnPropertyDescriptor` method
	// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
	objectGetOwnPropertyDescriptor$1.f = DESCRIPTORS$p ? $getOwnPropertyDescriptor$4 : function getOwnPropertyDescriptor(O, P) {
	  O = toIndexedObject$f(O);
	  P = toPropertyKey$7(P);
	  if (IE8_DOM_DEFINE$3) try {
	    return $getOwnPropertyDescriptor$4(O, P);
	  } catch (error) { /* empty */ }
	  if (hasOwn$o(O, P)) return createPropertyDescriptor$a(!call$r(propertyIsEnumerableModule$3.f, O, P), O[P]);
	};

	var fails$N = fails$T;
	var isCallable$v = isCallable$B;

	var replacement$1 = /#|\.prototype\./;

	var isForced$4 = function (feature, detection) {
	  var value = data$1[normalize$2(feature)];
	  return value === POLYFILL$1 ? true
	    : value === NATIVE$1 ? false
	    : isCallable$v(detection) ? fails$N(detection)
	    : !!detection;
	};

	var normalize$2 = isForced$4.normalize = function (string) {
	  return String(string).replace(replacement$1, '.').toLowerCase();
	};

	var data$1 = isForced$4.data = {};
	var NATIVE$1 = isForced$4.NATIVE = 'N';
	var POLYFILL$1 = isForced$4.POLYFILL = 'P';

	var isForced_1$1 = isForced$4;

	var uncurryThis$Q = functionUncurryThisClause$1;
	var aCallable$c = aCallable$e;
	var NATIVE_BIND$5 = functionBindNative$1;

	var bind$j = uncurryThis$Q(uncurryThis$Q.bind);

	// optional / simple context binding
	var functionBindContext$1 = function (fn, that) {
	  aCallable$c(fn);
	  return that === undefined ? fn : NATIVE_BIND$5 ? bind$j(fn, that) : function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};

	var objectDefineProperty$1 = {};

	var DESCRIPTORS$o = descriptors$1;
	var fails$M = fails$T;

	// V8 ~ Chrome 36-
	// https://bugs.chromium.org/p/v8/issues/detail?id=3334
	var v8PrototypeDefineBug$1 = DESCRIPTORS$o && fails$M(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
	    value: 42,
	    writable: false
	  }).prototype !== 42;
	});

	var isObject$x = isObject$B;

	var $String$9 = String;
	var $TypeError$j = TypeError;

	// `Assert: Type(argument) is Object`
	var anObject$q = function (argument) {
	  if (isObject$x(argument)) return argument;
	  throw new $TypeError$j($String$9(argument) + ' is not an object');
	};

	var DESCRIPTORS$n = descriptors$1;
	var IE8_DOM_DEFINE$2 = ie8DomDefine$1;
	var V8_PROTOTYPE_DEFINE_BUG$3 = v8PrototypeDefineBug$1;
	var anObject$p = anObject$q;
	var toPropertyKey$6 = toPropertyKey$8;

	var $TypeError$i = TypeError;
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var $defineProperty$2 = Object.defineProperty;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var $getOwnPropertyDescriptor$3 = Object.getOwnPropertyDescriptor;
	var ENUMERABLE$1 = 'enumerable';
	var CONFIGURABLE$3 = 'configurable';
	var WRITABLE$1 = 'writable';

	// `Object.defineProperty` method
	// https://tc39.es/ecma262/#sec-object.defineproperty
	objectDefineProperty$1.f = DESCRIPTORS$n ? V8_PROTOTYPE_DEFINE_BUG$3 ? function defineProperty(O, P, Attributes) {
	  anObject$p(O);
	  P = toPropertyKey$6(P);
	  anObject$p(Attributes);
	  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE$1 in Attributes && !Attributes[WRITABLE$1]) {
	    var current = $getOwnPropertyDescriptor$3(O, P);
	    if (current && current[WRITABLE$1]) {
	      O[P] = Attributes.value;
	      Attributes = {
	        configurable: CONFIGURABLE$3 in Attributes ? Attributes[CONFIGURABLE$3] : current[CONFIGURABLE$3],
	        enumerable: ENUMERABLE$1 in Attributes ? Attributes[ENUMERABLE$1] : current[ENUMERABLE$1],
	        writable: false
	      };
	    }
	  } return $defineProperty$2(O, P, Attributes);
	} : $defineProperty$2 : function defineProperty(O, P, Attributes) {
	  anObject$p(O);
	  P = toPropertyKey$6(P);
	  anObject$p(Attributes);
	  if (IE8_DOM_DEFINE$2) try {
	    return $defineProperty$2(O, P, Attributes);
	  } catch (error) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$i('Accessors not supported');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};

	var DESCRIPTORS$m = descriptors$1;
	var definePropertyModule$9 = objectDefineProperty$1;
	var createPropertyDescriptor$9 = createPropertyDescriptor$b;

	var createNonEnumerableProperty$d = DESCRIPTORS$m ? function (object, key, value) {
	  return definePropertyModule$9.f(object, key, createPropertyDescriptor$9(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};

	var global$y = global$G;
	var apply$9 = functionApply$1;
	var uncurryThis$P = functionUncurryThisClause$1;
	var isCallable$u = isCallable$B;
	var getOwnPropertyDescriptor$8 = objectGetOwnPropertyDescriptor$1.f;
	var isForced$3 = isForced_1$1;
	var path$o = path$q;
	var bind$i = functionBindContext$1;
	var createNonEnumerableProperty$c = createNonEnumerableProperty$d;
	var hasOwn$n = hasOwnProperty_1$1;

	var wrapConstructor = function (NativeConstructor) {
	  var Wrapper = function (a, b, c) {
	    if (this instanceof Wrapper) {
	      switch (arguments.length) {
	        case 0: return new NativeConstructor();
	        case 1: return new NativeConstructor(a);
	        case 2: return new NativeConstructor(a, b);
	      } return new NativeConstructor(a, b, c);
	    } return apply$9(NativeConstructor, this, arguments);
	  };
	  Wrapper.prototype = NativeConstructor.prototype;
	  return Wrapper;
	};

	/*
	  options.target         - name of the target object
	  options.global         - target is the global object
	  options.stat           - export as static methods of target
	  options.proto          - export as prototype methods of target
	  options.real           - real prototype method for the `pure` version
	  options.forced         - export even if the native feature is available
	  options.bind           - bind methods to the target, required for the `pure` version
	  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
	  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
	  options.sham           - add a flag to not completely full polyfills
	  options.enumerable     - export as enumerable property
	  options.dontCallGetSet - prevent calling a getter on target
	  options.name           - the .name of the function if it does not match the key
	*/
	var _export$1 = function (options, source) {
	  var TARGET = options.target;
	  var GLOBAL = options.global;
	  var STATIC = options.stat;
	  var PROTO = options.proto;

	  var nativeSource = GLOBAL ? global$y : STATIC ? global$y[TARGET] : (global$y[TARGET] || {}).prototype;

	  var target = GLOBAL ? path$o : path$o[TARGET] || createNonEnumerableProperty$c(path$o, TARGET, {})[TARGET];
	  var targetPrototype = target.prototype;

	  var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
	  var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;

	  for (key in source) {
	    FORCED = isForced$3(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
	    // contains in native
	    USE_NATIVE = !FORCED && nativeSource && hasOwn$n(nativeSource, key);

	    targetProperty = target[key];

	    if (USE_NATIVE) if (options.dontCallGetSet) {
	      descriptor = getOwnPropertyDescriptor$8(nativeSource, key);
	      nativeProperty = descriptor && descriptor.value;
	    } else nativeProperty = nativeSource[key];

	    // export native or implementation
	    sourceProperty = (USE_NATIVE && nativeProperty) ? nativeProperty : source[key];

	    if (USE_NATIVE && typeof targetProperty == typeof sourceProperty) continue;

	    // bind methods to global for calling from export context
	    if (options.bind && USE_NATIVE) resultProperty = bind$i(sourceProperty, global$y);
	    // wrap global constructors for prevent changes in this version
	    else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor(sourceProperty);
	    // make static versions for prototype methods
	    else if (PROTO && isCallable$u(sourceProperty)) resultProperty = uncurryThis$P(sourceProperty);
	    // default case
	    else resultProperty = sourceProperty;

	    // add a flag to not completely full polyfills
	    if (options.sham || (sourceProperty && sourceProperty.sham) || (targetProperty && targetProperty.sham)) {
	      createNonEnumerableProperty$c(resultProperty, 'sham', true);
	    }

	    createNonEnumerableProperty$c(target, key, resultProperty);

	    if (PROTO) {
	      VIRTUAL_PROTOTYPE = TARGET + 'Prototype';
	      if (!hasOwn$n(path$o, VIRTUAL_PROTOTYPE)) {
	        createNonEnumerableProperty$c(path$o, VIRTUAL_PROTOTYPE, {});
	      }
	      // export virtual prototype methods
	      createNonEnumerableProperty$c(path$o[VIRTUAL_PROTOTYPE], key, sourceProperty);
	      // export real prototype methods
	      if (options.real && targetPrototype && (FORCED || !targetPrototype[key])) {
	        createNonEnumerableProperty$c(targetPrototype, key, sourceProperty);
	      }
	    }
	  }
	};

	var ceil$1 = Math.ceil;
	var floor$3 = Math.floor;

	// `Math.trunc` method
	// https://tc39.es/ecma262/#sec-math.trunc
	// eslint-disable-next-line es/no-math-trunc -- safe
	var mathTrunc$1 = Math.trunc || function trunc(x) {
	  var n = +x;
	  return (n > 0 ? floor$3 : ceil$1)(n);
	};

	var trunc$1 = mathTrunc$1;

	// `ToIntegerOrInfinity` abstract operation
	// https://tc39.es/ecma262/#sec-tointegerorinfinity
	var toIntegerOrInfinity$a = function (argument) {
	  var number = +argument;
	  // eslint-disable-next-line no-self-compare -- NaN check
	  return number !== number || number === 0 ? 0 : trunc$1(number);
	};

	var toIntegerOrInfinity$9 = toIntegerOrInfinity$a;

	var max$5 = Math.max;
	var min$7 = Math.min;

	// Helper for a popular repeating case of the spec:
	// Let integer be ? ToInteger(index).
	// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
	var toAbsoluteIndex$6 = function (index, length) {
	  var integer = toIntegerOrInfinity$9(index);
	  return integer < 0 ? max$5(integer + length, 0) : min$7(integer, length);
	};

	var toIntegerOrInfinity$8 = toIntegerOrInfinity$a;

	var min$6 = Math.min;

	// `ToLength` abstract operation
	// https://tc39.es/ecma262/#sec-tolength
	var toLength$8 = function (argument) {
	  return argument > 0 ? min$6(toIntegerOrInfinity$8(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
	};

	var toLength$7 = toLength$8;

	// `LengthOfArrayLike` abstract operation
	// https://tc39.es/ecma262/#sec-lengthofarraylike
	var lengthOfArrayLike$c = function (obj) {
	  return toLength$7(obj.length);
	};

	var toIndexedObject$e = toIndexedObject$g;
	var toAbsoluteIndex$5 = toAbsoluteIndex$6;
	var lengthOfArrayLike$b = lengthOfArrayLike$c;

	// `Array.prototype.{ indexOf, includes }` methods implementation
	var createMethod$6 = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIndexedObject$e($this);
	    var length = lengthOfArrayLike$b(O);
	    var index = toAbsoluteIndex$5(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare -- NaN check
	    if (IS_INCLUDES && el !== el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare -- NaN check
	      if (value !== value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) {
	      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

	var arrayIncludes$1 = {
	  // `Array.prototype.includes` method
	  // https://tc39.es/ecma262/#sec-array.prototype.includes
	  includes: createMethod$6(true),
	  // `Array.prototype.indexOf` method
	  // https://tc39.es/ecma262/#sec-array.prototype.indexof
	  indexOf: createMethod$6(false)
	};

	var hiddenKeys$b = {};

	var uncurryThis$O = functionUncurryThis$1;
	var hasOwn$m = hasOwnProperty_1$1;
	var toIndexedObject$d = toIndexedObject$g;
	var indexOf$6 = arrayIncludes$1.indexOf;
	var hiddenKeys$a = hiddenKeys$b;

	var push$f = uncurryThis$O([].push);

	var objectKeysInternal$1 = function (object, names) {
	  var O = toIndexedObject$d(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) !hasOwn$m(hiddenKeys$a, key) && hasOwn$m(O, key) && push$f(result, key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (hasOwn$m(O, key = names[i++])) {
	    ~indexOf$6(result, key) || push$f(result, key);
	  }
	  return result;
	};

	// IE8- don't enum bug keys
	var enumBugKeys$7 = [
	  'constructor',
	  'hasOwnProperty',
	  'isPrototypeOf',
	  'propertyIsEnumerable',
	  'toLocaleString',
	  'toString',
	  'valueOf'
	];

	var internalObjectKeys$3 = objectKeysInternal$1;
	var enumBugKeys$6 = enumBugKeys$7;

	// `Object.keys` method
	// https://tc39.es/ecma262/#sec-object.keys
	// eslint-disable-next-line es/no-object-keys -- safe
	var objectKeys$5 = Object.keys || function keys(O) {
	  return internalObjectKeys$3(O, enumBugKeys$6);
	};

	var $$14 = _export$1;
	var toObject$d = toObject$f;
	var nativeKeys$3 = objectKeys$5;
	var fails$L = fails$T;

	var FAILS_ON_PRIMITIVES$3 = fails$L(function () { nativeKeys$3(1); });

	// `Object.keys` method
	// https://tc39.es/ecma262/#sec-object.keys
	$$14({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES$3 }, {
	  keys: function keys(it) {
	    return nativeKeys$3(toObject$d(it));
	  }
	});

	var path$n = path$q;

	var keys$8 = path$n.Object.keys;

	var parent$1b = keys$8;

	var keys$7 = parent$1b;

	var keys$6 = keys$7;

	var _Object$keys = /*@__PURE__*/getDefaultExportFromCjs(keys$6);

	var wellKnownSymbol$y = wellKnownSymbol$A;

	var TO_STRING_TAG$6 = wellKnownSymbol$y('toStringTag');
	var test$2 = {};

	test$2[TO_STRING_TAG$6] = 'z';

	var toStringTagSupport$1 = String(test$2) === '[object z]';

	var TO_STRING_TAG_SUPPORT$5 = toStringTagSupport$1;
	var isCallable$t = isCallable$B;
	var classofRaw$3 = classofRaw$5;
	var wellKnownSymbol$x = wellKnownSymbol$A;

	var TO_STRING_TAG$5 = wellKnownSymbol$x('toStringTag');
	var $Object$6 = Object;

	// ES3 wrong here
	var CORRECT_ARGUMENTS$1 = classofRaw$3(function () { return arguments; }()) === 'Arguments';

	// fallback for IE11 Script Access Denied error
	var tryGet$1 = function (it, key) {
	  try {
	    return it[key];
	  } catch (error) { /* empty */ }
	};

	// getting tag from ES6+ `Object.prototype.toString`
	var classof$k = TO_STRING_TAG_SUPPORT$5 ? classofRaw$3 : function (it) {
	  var O, tag, result;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (tag = tryGet$1(O = $Object$6(it), TO_STRING_TAG$5)) == 'string' ? tag
	    // builtinTag case
	    : CORRECT_ARGUMENTS$1 ? classofRaw$3(O)
	    // ES3 arguments fallback
	    : (result = classofRaw$3(O)) === 'Object' && isCallable$t(O.callee) ? 'Arguments' : result;
	};

	var classof$j = classof$k;

	var $String$8 = String;

	var toString$r = function (argument) {
	  if (classof$j(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
	  return $String$8(argument);
	};

	var objectDefineProperties$1 = {};

	var DESCRIPTORS$l = descriptors$1;
	var V8_PROTOTYPE_DEFINE_BUG$2 = v8PrototypeDefineBug$1;
	var definePropertyModule$8 = objectDefineProperty$1;
	var anObject$o = anObject$q;
	var toIndexedObject$c = toIndexedObject$g;
	var objectKeys$4 = objectKeys$5;

	// `Object.defineProperties` method
	// https://tc39.es/ecma262/#sec-object.defineproperties
	// eslint-disable-next-line es/no-object-defineproperties -- safe
	objectDefineProperties$1.f = DESCRIPTORS$l && !V8_PROTOTYPE_DEFINE_BUG$2 ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject$o(O);
	  var props = toIndexedObject$c(Properties);
	  var keys = objectKeys$4(Properties);
	  var length = keys.length;
	  var index = 0;
	  var key;
	  while (length > index) definePropertyModule$8.f(O, key = keys[index++], props[key]);
	  return O;
	};

	var getBuiltIn$i = getBuiltIn$k;

	var html$5 = getBuiltIn$i('document', 'documentElement');

	var shared$a = sharedExports$1;
	var uid$5 = uid$7;

	var keys$5 = shared$a('keys');

	var sharedKey$7 = function (key) {
	  return keys$5[key] || (keys$5[key] = uid$5(key));
	};

	/* global ActiveXObject -- old IE, WSH */
	var anObject$n = anObject$q;
	var definePropertiesModule$2 = objectDefineProperties$1;
	var enumBugKeys$5 = enumBugKeys$7;
	var hiddenKeys$9 = hiddenKeys$b;
	var html$4 = html$5;
	var documentCreateElement$2 = documentCreateElement$3;
	var sharedKey$6 = sharedKey$7;

	var GT$1 = '>';
	var LT$1 = '<';
	var PROTOTYPE$2 = 'prototype';
	var SCRIPT$1 = 'script';
	var IE_PROTO$2 = sharedKey$6('IE_PROTO');

	var EmptyConstructor$1 = function () { /* empty */ };

	var scriptTag$1 = function (content) {
	  return LT$1 + SCRIPT$1 + GT$1 + content + LT$1 + '/' + SCRIPT$1 + GT$1;
	};

	// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
	var NullProtoObjectViaActiveX$1 = function (activeXDocument) {
	  activeXDocument.write(scriptTag$1(''));
	  activeXDocument.close();
	  var temp = activeXDocument.parentWindow.Object;
	  activeXDocument = null; // avoid memory leak
	  return temp;
	};

	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var NullProtoObjectViaIFrame$1 = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = documentCreateElement$2('iframe');
	  var JS = 'java' + SCRIPT$1 + ':';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  html$4.appendChild(iframe);
	  // https://github.com/zloirock/core-js/issues/475
	  iframe.src = String(JS);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(scriptTag$1('document.F=Object'));
	  iframeDocument.close();
	  return iframeDocument.F;
	};

	// Check for document.domain and active x support
	// No need to use active x approach when document.domain is not set
	// see https://github.com/es-shims/es5-shim/issues/150
	// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
	// avoid IE GC bug
	var activeXDocument$1;
	var NullProtoObject$1 = function () {
	  try {
	    activeXDocument$1 = new ActiveXObject('htmlfile');
	  } catch (error) { /* ignore */ }
	  NullProtoObject$1 = typeof document != 'undefined'
	    ? document.domain && activeXDocument$1
	      ? NullProtoObjectViaActiveX$1(activeXDocument$1) // old IE
	      : NullProtoObjectViaIFrame$1()
	    : NullProtoObjectViaActiveX$1(activeXDocument$1); // WSH
	  var length = enumBugKeys$5.length;
	  while (length--) delete NullProtoObject$1[PROTOTYPE$2][enumBugKeys$5[length]];
	  return NullProtoObject$1();
	};

	hiddenKeys$9[IE_PROTO$2] = true;

	// `Object.create` method
	// https://tc39.es/ecma262/#sec-object.create
	// eslint-disable-next-line es/no-object-create -- safe
	var objectCreate$1 = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    EmptyConstructor$1[PROTOTYPE$2] = anObject$n(O);
	    result = new EmptyConstructor$1();
	    EmptyConstructor$1[PROTOTYPE$2] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO$2] = O;
	  } else result = NullProtoObject$1();
	  return Properties === undefined ? result : definePropertiesModule$2.f(result, Properties);
	};

	var objectGetOwnPropertyNames$1 = {};

	var internalObjectKeys$2 = objectKeysInternal$1;
	var enumBugKeys$4 = enumBugKeys$7;

	var hiddenKeys$8 = enumBugKeys$4.concat('length', 'prototype');

	// `Object.getOwnPropertyNames` method
	// https://tc39.es/ecma262/#sec-object.getownpropertynames
	// eslint-disable-next-line es/no-object-getownpropertynames -- safe
	objectGetOwnPropertyNames$1.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return internalObjectKeys$2(O, hiddenKeys$8);
	};

	var objectGetOwnPropertyNamesExternal = {};

	var toPropertyKey$5 = toPropertyKey$8;
	var definePropertyModule$7 = objectDefineProperty$1;
	var createPropertyDescriptor$8 = createPropertyDescriptor$b;

	var createProperty$7 = function (object, key, value) {
	  var propertyKey = toPropertyKey$5(key);
	  if (propertyKey in object) definePropertyModule$7.f(object, propertyKey, createPropertyDescriptor$8(0, value));
	  else object[propertyKey] = value;
	};

	var toAbsoluteIndex$4 = toAbsoluteIndex$6;
	var lengthOfArrayLike$a = lengthOfArrayLike$c;
	var createProperty$6 = createProperty$7;

	var $Array$5 = Array;
	var max$4 = Math.max;

	var arraySliceSimple$1 = function (O, start, end) {
	  var length = lengthOfArrayLike$a(O);
	  var k = toAbsoluteIndex$4(start, length);
	  var fin = toAbsoluteIndex$4(end === undefined ? length : end, length);
	  var result = $Array$5(max$4(fin - k, 0));
	  var n = 0;
	  for (; k < fin; k++, n++) createProperty$6(result, n, O[k]);
	  result.length = n;
	  return result;
	};

	/* eslint-disable es/no-object-getownpropertynames -- safe */
	var classof$i = classofRaw$5;
	var toIndexedObject$b = toIndexedObject$g;
	var $getOwnPropertyNames$1 = objectGetOwnPropertyNames$1.f;
	var arraySlice$6 = arraySliceSimple$1;

	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];

	var getWindowNames = function (it) {
	  try {
	    return $getOwnPropertyNames$1(it);
	  } catch (error) {
	    return arraySlice$6(windowNames);
	  }
	};

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	objectGetOwnPropertyNamesExternal.f = function getOwnPropertyNames(it) {
	  return windowNames && classof$i(it) === 'Window'
	    ? getWindowNames(it)
	    : $getOwnPropertyNames$1(toIndexedObject$b(it));
	};

	var objectGetOwnPropertySymbols$1 = {};

	// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
	objectGetOwnPropertySymbols$1.f = Object.getOwnPropertySymbols;

	var createNonEnumerableProperty$b = createNonEnumerableProperty$d;

	var defineBuiltIn$b = function (target, key, value, options) {
	  if (options && options.enumerable) target[key] = value;
	  else createNonEnumerableProperty$b(target, key, value);
	  return target;
	};

	var defineProperty$i = objectDefineProperty$1;

	var defineBuiltInAccessor$5 = function (target, name, descriptor) {
	  return defineProperty$i.f(target, name, descriptor);
	};

	var wellKnownSymbolWrapped = {};

	var wellKnownSymbol$w = wellKnownSymbol$A;

	wellKnownSymbolWrapped.f = wellKnownSymbol$w;

	var path$m = path$q;
	var hasOwn$l = hasOwnProperty_1$1;
	var wrappedWellKnownSymbolModule$1 = wellKnownSymbolWrapped;
	var defineProperty$h = objectDefineProperty$1.f;

	var wellKnownSymbolDefine = function (NAME) {
	  var Symbol = path$m.Symbol || (path$m.Symbol = {});
	  if (!hasOwn$l(Symbol, NAME)) defineProperty$h(Symbol, NAME, {
	    value: wrappedWellKnownSymbolModule$1.f(NAME)
	  });
	};

	var call$q = functionCall$1;
	var getBuiltIn$h = getBuiltIn$k;
	var wellKnownSymbol$v = wellKnownSymbol$A;
	var defineBuiltIn$a = defineBuiltIn$b;

	var symbolDefineToPrimitive = function () {
	  var Symbol = getBuiltIn$h('Symbol');
	  var SymbolPrototype = Symbol && Symbol.prototype;
	  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
	  var TO_PRIMITIVE = wellKnownSymbol$v('toPrimitive');

	  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
	    // `Symbol.prototype[@@toPrimitive]` method
	    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
	    // eslint-disable-next-line no-unused-vars -- required for .length
	    defineBuiltIn$a(SymbolPrototype, TO_PRIMITIVE, function (hint) {
	      return call$q(valueOf, this);
	    }, { arity: 1 });
	  }
	};

	var TO_STRING_TAG_SUPPORT$4 = toStringTagSupport$1;
	var classof$h = classof$k;

	// `Object.prototype.toString` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.tostring
	var objectToString$3 = TO_STRING_TAG_SUPPORT$4 ? {}.toString : function toString() {
	  return '[object ' + classof$h(this) + ']';
	};

	var TO_STRING_TAG_SUPPORT$3 = toStringTagSupport$1;
	var defineProperty$g = objectDefineProperty$1.f;
	var createNonEnumerableProperty$a = createNonEnumerableProperty$d;
	var hasOwn$k = hasOwnProperty_1$1;
	var toString$q = objectToString$3;
	var wellKnownSymbol$u = wellKnownSymbol$A;

	var TO_STRING_TAG$4 = wellKnownSymbol$u('toStringTag');

	var setToStringTag$7 = function (it, TAG, STATIC, SET_METHOD) {
	  if (it) {
	    var target = STATIC ? it : it.prototype;
	    if (!hasOwn$k(target, TO_STRING_TAG$4)) {
	      defineProperty$g(target, TO_STRING_TAG$4, { configurable: true, value: TAG });
	    }
	    if (SET_METHOD && !TO_STRING_TAG_SUPPORT$3) {
	      createNonEnumerableProperty$a(target, 'toString', toString$q);
	    }
	  }
	};

	var global$x = global$G;
	var isCallable$s = isCallable$B;

	var WeakMap$6 = global$x.WeakMap;

	var weakMapBasicDetection$1 = isCallable$s(WeakMap$6) && /native code/.test(String(WeakMap$6));

	var NATIVE_WEAK_MAP$2 = weakMapBasicDetection$1;
	var global$w = global$G;
	var isObject$w = isObject$B;
	var createNonEnumerableProperty$9 = createNonEnumerableProperty$d;
	var hasOwn$j = hasOwnProperty_1$1;
	var shared$9 = sharedStore$1;
	var sharedKey$5 = sharedKey$7;
	var hiddenKeys$7 = hiddenKeys$b;

	var OBJECT_ALREADY_INITIALIZED$1 = 'Object already initialized';
	var TypeError$4 = global$w.TypeError;
	var WeakMap$5 = global$w.WeakMap;
	var set$6, get$1, has$2;

	var enforce$1 = function (it) {
	  return has$2(it) ? get$1(it) : set$6(it, {});
	};

	var getterFor$1 = function (TYPE) {
	  return function (it) {
	    var state;
	    if (!isObject$w(it) || (state = get$1(it)).type !== TYPE) {
	      throw new TypeError$4('Incompatible receiver, ' + TYPE + ' required');
	    } return state;
	  };
	};

	if (NATIVE_WEAK_MAP$2 || shared$9.state) {
	  var store$5 = shared$9.state || (shared$9.state = new WeakMap$5());
	  /* eslint-disable no-self-assign -- prototype methods protection */
	  store$5.get = store$5.get;
	  store$5.has = store$5.has;
	  store$5.set = store$5.set;
	  /* eslint-enable no-self-assign -- prototype methods protection */
	  set$6 = function (it, metadata) {
	    if (store$5.has(it)) throw new TypeError$4(OBJECT_ALREADY_INITIALIZED$1);
	    metadata.facade = it;
	    store$5.set(it, metadata);
	    return metadata;
	  };
	  get$1 = function (it) {
	    return store$5.get(it) || {};
	  };
	  has$2 = function (it) {
	    return store$5.has(it);
	  };
	} else {
	  var STATE$1 = sharedKey$5('state');
	  hiddenKeys$7[STATE$1] = true;
	  set$6 = function (it, metadata) {
	    if (hasOwn$j(it, STATE$1)) throw new TypeError$4(OBJECT_ALREADY_INITIALIZED$1);
	    metadata.facade = it;
	    createNonEnumerableProperty$9(it, STATE$1, metadata);
	    return metadata;
	  };
	  get$1 = function (it) {
	    return hasOwn$j(it, STATE$1) ? it[STATE$1] : {};
	  };
	  has$2 = function (it) {
	    return hasOwn$j(it, STATE$1);
	  };
	}

	var internalState$1 = {
	  set: set$6,
	  get: get$1,
	  has: has$2,
	  enforce: enforce$1,
	  getterFor: getterFor$1
	};

	var classof$g = classofRaw$5;

	// `IsArray` abstract operation
	// https://tc39.es/ecma262/#sec-isarray
	// eslint-disable-next-line es/no-array-isarray -- safe
	var isArray$l = Array.isArray || function isArray(argument) {
	  return classof$g(argument) === 'Array';
	};

	var uncurryThis$N = functionUncurryThis$1;
	var isCallable$r = isCallable$B;
	var store$4 = sharedStore$1;

	var functionToString$3 = uncurryThis$N(Function.toString);

	// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
	if (!isCallable$r(store$4.inspectSource)) {
	  store$4.inspectSource = function (it) {
	    return functionToString$3(it);
	  };
	}

	var inspectSource$5 = store$4.inspectSource;

	var uncurryThis$M = functionUncurryThis$1;
	var fails$K = fails$T;
	var isCallable$q = isCallable$B;
	var classof$f = classof$k;
	var getBuiltIn$g = getBuiltIn$k;
	var inspectSource$4 = inspectSource$5;

	var noop$2 = function () { /* empty */ };
	var empty$2 = [];
	var construct$5 = getBuiltIn$g('Reflect', 'construct');
	var constructorRegExp$1 = /^\s*(?:class|function)\b/;
	var exec$5 = uncurryThis$M(constructorRegExp$1.exec);
	var INCORRECT_TO_STRING$1 = !constructorRegExp$1.test(noop$2);

	var isConstructorModern$1 = function isConstructor(argument) {
	  if (!isCallable$q(argument)) return false;
	  try {
	    construct$5(noop$2, empty$2, argument);
	    return true;
	  } catch (error) {
	    return false;
	  }
	};

	var isConstructorLegacy$1 = function isConstructor(argument) {
	  if (!isCallable$q(argument)) return false;
	  switch (classof$f(argument)) {
	    case 'AsyncFunction':
	    case 'GeneratorFunction':
	    case 'AsyncGeneratorFunction': return false;
	  }
	  try {
	    // we can't check .prototype since constructors produced by .bind haven't it
	    // `Function#toString` throws on some built-it function in some legacy engines
	    // (for example, `DOMQuad` and similar in FF41-)
	    return INCORRECT_TO_STRING$1 || !!exec$5(constructorRegExp$1, inspectSource$4(argument));
	  } catch (error) {
	    return true;
	  }
	};

	isConstructorLegacy$1.sham = true;

	// `IsConstructor` abstract operation
	// https://tc39.es/ecma262/#sec-isconstructor
	var isConstructor$7 = !construct$5 || fails$K(function () {
	  var called;
	  return isConstructorModern$1(isConstructorModern$1.call)
	    || !isConstructorModern$1(Object)
	    || !isConstructorModern$1(function () { called = true; })
	    || called;
	}) ? isConstructorLegacy$1 : isConstructorModern$1;

	var isArray$k = isArray$l;
	var isConstructor$6 = isConstructor$7;
	var isObject$v = isObject$B;
	var wellKnownSymbol$t = wellKnownSymbol$A;

	var SPECIES$9 = wellKnownSymbol$t('species');
	var $Array$4 = Array;

	// a part of `ArraySpeciesCreate` abstract operation
	// https://tc39.es/ecma262/#sec-arrayspeciescreate
	var arraySpeciesConstructor$3 = function (originalArray) {
	  var C;
	  if (isArray$k(originalArray)) {
	    C = originalArray.constructor;
	    // cross-realm fallback
	    if (isConstructor$6(C) && (C === $Array$4 || isArray$k(C.prototype))) C = undefined;
	    else if (isObject$v(C)) {
	      C = C[SPECIES$9];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? $Array$4 : C;
	};

	var arraySpeciesConstructor$2 = arraySpeciesConstructor$3;

	// `ArraySpeciesCreate` abstract operation
	// https://tc39.es/ecma262/#sec-arrayspeciescreate
	var arraySpeciesCreate$4 = function (originalArray, length) {
	  return new (arraySpeciesConstructor$2(originalArray))(length === 0 ? 0 : length);
	};

	var bind$h = functionBindContext$1;
	var uncurryThis$L = functionUncurryThis$1;
	var IndexedObject$4 = indexedObject$1;
	var toObject$c = toObject$f;
	var lengthOfArrayLike$9 = lengthOfArrayLike$c;
	var arraySpeciesCreate$3 = arraySpeciesCreate$4;

	var push$e = uncurryThis$L([].push);

	// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
	var createMethod$5 = function (TYPE) {
	  var IS_MAP = TYPE === 1;
	  var IS_FILTER = TYPE === 2;
	  var IS_SOME = TYPE === 3;
	  var IS_EVERY = TYPE === 4;
	  var IS_FIND_INDEX = TYPE === 6;
	  var IS_FILTER_REJECT = TYPE === 7;
	  var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
	  return function ($this, callbackfn, that, specificCreate) {
	    var O = toObject$c($this);
	    var self = IndexedObject$4(O);
	    var boundFunction = bind$h(callbackfn, that);
	    var length = lengthOfArrayLike$9(self);
	    var index = 0;
	    var create = specificCreate || arraySpeciesCreate$3;
	    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
	    var value, result;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      value = self[index];
	      result = boundFunction(value, index, O);
	      if (TYPE) {
	        if (IS_MAP) target[index] = result; // map
	        else if (result) switch (TYPE) {
	          case 3: return true;              // some
	          case 5: return value;             // find
	          case 6: return index;             // findIndex
	          case 2: push$e(target, value);      // filter
	        } else switch (TYPE) {
	          case 4: return false;             // every
	          case 7: push$e(target, value);      // filterReject
	        }
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
	  };
	};

	var arrayIteration$1 = {
	  // `Array.prototype.forEach` method
	  // https://tc39.es/ecma262/#sec-array.prototype.foreach
	  forEach: createMethod$5(0),
	  // `Array.prototype.map` method
	  // https://tc39.es/ecma262/#sec-array.prototype.map
	  map: createMethod$5(1),
	  // `Array.prototype.filter` method
	  // https://tc39.es/ecma262/#sec-array.prototype.filter
	  filter: createMethod$5(2),
	  // `Array.prototype.some` method
	  // https://tc39.es/ecma262/#sec-array.prototype.some
	  some: createMethod$5(3),
	  // `Array.prototype.every` method
	  // https://tc39.es/ecma262/#sec-array.prototype.every
	  every: createMethod$5(4),
	  // `Array.prototype.find` method
	  // https://tc39.es/ecma262/#sec-array.prototype.find
	  find: createMethod$5(5),
	  // `Array.prototype.findIndex` method
	  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
	  findIndex: createMethod$5(6),
	  // `Array.prototype.filterReject` method
	  // https://github.com/tc39/proposal-array-filtering
	  filterReject: createMethod$5(7)
	};

	var $$13 = _export$1;
	var global$v = global$G;
	var call$p = functionCall$1;
	var uncurryThis$K = functionUncurryThis$1;
	var DESCRIPTORS$k = descriptors$1;
	var NATIVE_SYMBOL$5 = symbolConstructorDetection$1;
	var fails$J = fails$T;
	var hasOwn$i = hasOwnProperty_1$1;
	var isPrototypeOf$k = objectIsPrototypeOf$1;
	var anObject$m = anObject$q;
	var toIndexedObject$a = toIndexedObject$g;
	var toPropertyKey$4 = toPropertyKey$8;
	var $toString$1 = toString$r;
	var createPropertyDescriptor$7 = createPropertyDescriptor$b;
	var nativeObjectCreate = objectCreate$1;
	var objectKeys$3 = objectKeys$5;
	var getOwnPropertyNamesModule$3 = objectGetOwnPropertyNames$1;
	var getOwnPropertyNamesExternal = objectGetOwnPropertyNamesExternal;
	var getOwnPropertySymbolsModule$4 = objectGetOwnPropertySymbols$1;
	var getOwnPropertyDescriptorModule$3 = objectGetOwnPropertyDescriptor$1;
	var definePropertyModule$6 = objectDefineProperty$1;
	var definePropertiesModule$1 = objectDefineProperties$1;
	var propertyIsEnumerableModule$2 = objectPropertyIsEnumerable$1;
	var defineBuiltIn$9 = defineBuiltIn$b;
	var defineBuiltInAccessor$4 = defineBuiltInAccessor$5;
	var shared$8 = sharedExports$1;
	var sharedKey$4 = sharedKey$7;
	var hiddenKeys$6 = hiddenKeys$b;
	var uid$4 = uid$7;
	var wellKnownSymbol$s = wellKnownSymbol$A;
	var wrappedWellKnownSymbolModule = wellKnownSymbolWrapped;
	var defineWellKnownSymbol$l = wellKnownSymbolDefine;
	var defineSymbolToPrimitive$1 = symbolDefineToPrimitive;
	var setToStringTag$6 = setToStringTag$7;
	var InternalStateModule$7 = internalState$1;
	var $forEach$1 = arrayIteration$1.forEach;

	var HIDDEN = sharedKey$4('hidden');
	var SYMBOL = 'Symbol';
	var PROTOTYPE$1 = 'prototype';

	var setInternalState$6 = InternalStateModule$7.set;
	var getInternalState$4 = InternalStateModule$7.getterFor(SYMBOL);

	var ObjectPrototype$2 = Object[PROTOTYPE$1];
	var $Symbol = global$v.Symbol;
	var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE$1];
	var RangeError$1 = global$v.RangeError;
	var TypeError$3 = global$v.TypeError;
	var QObject = global$v.QObject;
	var nativeGetOwnPropertyDescriptor$1 = getOwnPropertyDescriptorModule$3.f;
	var nativeDefineProperty = definePropertyModule$6.f;
	var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
	var nativePropertyIsEnumerable = propertyIsEnumerableModule$2.f;
	var push$d = uncurryThis$K([].push);

	var AllSymbols = shared$8('symbols');
	var ObjectPrototypeSymbols = shared$8('op-symbols');
	var WellKnownSymbolsStore$2 = shared$8('wks');

	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var USE_SETTER = !QObject || !QObject[PROTOTYPE$1] || !QObject[PROTOTYPE$1].findChild;

	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var fallbackDefineProperty = function (O, P, Attributes) {
	  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor$1(ObjectPrototype$2, P);
	  if (ObjectPrototypeDescriptor) delete ObjectPrototype$2[P];
	  nativeDefineProperty(O, P, Attributes);
	  if (ObjectPrototypeDescriptor && O !== ObjectPrototype$2) {
	    nativeDefineProperty(ObjectPrototype$2, P, ObjectPrototypeDescriptor);
	  }
	};

	var setSymbolDescriptor = DESCRIPTORS$k && fails$J(function () {
	  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
	    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
	  })).a !== 7;
	}) ? fallbackDefineProperty : nativeDefineProperty;

	var wrap = function (tag, description) {
	  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
	  setInternalState$6(symbol, {
	    type: SYMBOL,
	    tag: tag,
	    description: description
	  });
	  if (!DESCRIPTORS$k) symbol.description = description;
	  return symbol;
	};

	var $defineProperty$1 = function defineProperty(O, P, Attributes) {
	  if (O === ObjectPrototype$2) $defineProperty$1(ObjectPrototypeSymbols, P, Attributes);
	  anObject$m(O);
	  var key = toPropertyKey$4(P);
	  anObject$m(Attributes);
	  if (hasOwn$i(AllSymbols, key)) {
	    if (!Attributes.enumerable) {
	      if (!hasOwn$i(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor$7(1, {}));
	      O[HIDDEN][key] = true;
	    } else {
	      if (hasOwn$i(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
	      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor$7(0, false) });
	    } return setSymbolDescriptor(O, key, Attributes);
	  } return nativeDefineProperty(O, key, Attributes);
	};

	var $defineProperties = function defineProperties(O, Properties) {
	  anObject$m(O);
	  var properties = toIndexedObject$a(Properties);
	  var keys = objectKeys$3(properties).concat($getOwnPropertySymbols(properties));
	  $forEach$1(keys, function (key) {
	    if (!DESCRIPTORS$k || call$p($propertyIsEnumerable$1, properties, key)) $defineProperty$1(O, key, properties[key]);
	  });
	  return O;
	};

	var $create = function create(O, Properties) {
	  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
	};

	var $propertyIsEnumerable$1 = function propertyIsEnumerable(V) {
	  var P = toPropertyKey$4(V);
	  var enumerable = call$p(nativePropertyIsEnumerable, this, P);
	  if (this === ObjectPrototype$2 && hasOwn$i(AllSymbols, P) && !hasOwn$i(ObjectPrototypeSymbols, P)) return false;
	  return enumerable || !hasOwn$i(this, P) || !hasOwn$i(AllSymbols, P) || hasOwn$i(this, HIDDEN) && this[HIDDEN][P]
	    ? enumerable : true;
	};

	var $getOwnPropertyDescriptor$2 = function getOwnPropertyDescriptor(O, P) {
	  var it = toIndexedObject$a(O);
	  var key = toPropertyKey$4(P);
	  if (it === ObjectPrototype$2 && hasOwn$i(AllSymbols, key) && !hasOwn$i(ObjectPrototypeSymbols, key)) return;
	  var descriptor = nativeGetOwnPropertyDescriptor$1(it, key);
	  if (descriptor && hasOwn$i(AllSymbols, key) && !(hasOwn$i(it, HIDDEN) && it[HIDDEN][key])) {
	    descriptor.enumerable = true;
	  }
	  return descriptor;
	};

	var $getOwnPropertyNames = function getOwnPropertyNames(O) {
	  var names = nativeGetOwnPropertyNames(toIndexedObject$a(O));
	  var result = [];
	  $forEach$1(names, function (key) {
	    if (!hasOwn$i(AllSymbols, key) && !hasOwn$i(hiddenKeys$6, key)) push$d(result, key);
	  });
	  return result;
	};

	var $getOwnPropertySymbols = function (O) {
	  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype$2;
	  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject$a(O));
	  var result = [];
	  $forEach$1(names, function (key) {
	    if (hasOwn$i(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn$i(ObjectPrototype$2, key))) {
	      push$d(result, AllSymbols[key]);
	    }
	  });
	  return result;
	};

	// `Symbol` constructor
	// https://tc39.es/ecma262/#sec-symbol-constructor
	if (!NATIVE_SYMBOL$5) {
	  $Symbol = function Symbol() {
	    if (isPrototypeOf$k(SymbolPrototype, this)) throw new TypeError$3('Symbol is not a constructor');
	    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString$1(arguments[0]);
	    var tag = uid$4(description);
	    var setter = function (value) {
	      var $this = this === undefined ? global$v : this;
	      if ($this === ObjectPrototype$2) call$p(setter, ObjectPrototypeSymbols, value);
	      if (hasOwn$i($this, HIDDEN) && hasOwn$i($this[HIDDEN], tag)) $this[HIDDEN][tag] = false;
	      var descriptor = createPropertyDescriptor$7(1, value);
	      try {
	        setSymbolDescriptor($this, tag, descriptor);
	      } catch (error) {
	        if (!(error instanceof RangeError$1)) throw error;
	        fallbackDefineProperty($this, tag, descriptor);
	      }
	    };
	    if (DESCRIPTORS$k && USE_SETTER) setSymbolDescriptor(ObjectPrototype$2, tag, { configurable: true, set: setter });
	    return wrap(tag, description);
	  };

	  SymbolPrototype = $Symbol[PROTOTYPE$1];

	  defineBuiltIn$9(SymbolPrototype, 'toString', function toString() {
	    return getInternalState$4(this).tag;
	  });

	  defineBuiltIn$9($Symbol, 'withoutSetter', function (description) {
	    return wrap(uid$4(description), description);
	  });

	  propertyIsEnumerableModule$2.f = $propertyIsEnumerable$1;
	  definePropertyModule$6.f = $defineProperty$1;
	  definePropertiesModule$1.f = $defineProperties;
	  getOwnPropertyDescriptorModule$3.f = $getOwnPropertyDescriptor$2;
	  getOwnPropertyNamesModule$3.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
	  getOwnPropertySymbolsModule$4.f = $getOwnPropertySymbols;

	  wrappedWellKnownSymbolModule.f = function (name) {
	    return wrap(wellKnownSymbol$s(name), name);
	  };

	  if (DESCRIPTORS$k) {
	    // https://github.com/tc39/proposal-Symbol-description
	    defineBuiltInAccessor$4(SymbolPrototype, 'description', {
	      configurable: true,
	      get: function description() {
	        return getInternalState$4(this).description;
	      }
	    });
	  }
	}

	$$13({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL$5, sham: !NATIVE_SYMBOL$5 }, {
	  Symbol: $Symbol
	});

	$forEach$1(objectKeys$3(WellKnownSymbolsStore$2), function (name) {
	  defineWellKnownSymbol$l(name);
	});

	$$13({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL$5 }, {
	  useSetter: function () { USE_SETTER = true; },
	  useSimple: function () { USE_SETTER = false; }
	});

	$$13({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL$5, sham: !DESCRIPTORS$k }, {
	  // `Object.create` method
	  // https://tc39.es/ecma262/#sec-object.create
	  create: $create,
	  // `Object.defineProperty` method
	  // https://tc39.es/ecma262/#sec-object.defineproperty
	  defineProperty: $defineProperty$1,
	  // `Object.defineProperties` method
	  // https://tc39.es/ecma262/#sec-object.defineproperties
	  defineProperties: $defineProperties,
	  // `Object.getOwnPropertyDescriptor` method
	  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor$2
	});

	$$13({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL$5 }, {
	  // `Object.getOwnPropertyNames` method
	  // https://tc39.es/ecma262/#sec-object.getownpropertynames
	  getOwnPropertyNames: $getOwnPropertyNames
	});

	// `Symbol.prototype[@@toPrimitive]` method
	// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
	defineSymbolToPrimitive$1();

	// `Symbol.prototype[@@toStringTag]` property
	// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
	setToStringTag$6($Symbol, SYMBOL);

	hiddenKeys$6[HIDDEN] = true;

	var NATIVE_SYMBOL$4 = symbolConstructorDetection$1;

	/* eslint-disable es/no-symbol -- safe */
	var symbolRegistryDetection = NATIVE_SYMBOL$4 && !!Symbol['for'] && !!Symbol.keyFor;

	var $$12 = _export$1;
	var getBuiltIn$f = getBuiltIn$k;
	var hasOwn$h = hasOwnProperty_1$1;
	var toString$p = toString$r;
	var shared$7 = sharedExports$1;
	var NATIVE_SYMBOL_REGISTRY$1 = symbolRegistryDetection;

	var StringToSymbolRegistry = shared$7('string-to-symbol-registry');
	var SymbolToStringRegistry$1 = shared$7('symbol-to-string-registry');

	// `Symbol.for` method
	// https://tc39.es/ecma262/#sec-symbol.for
	$$12({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY$1 }, {
	  'for': function (key) {
	    var string = toString$p(key);
	    if (hasOwn$h(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
	    var symbol = getBuiltIn$f('Symbol')(string);
	    StringToSymbolRegistry[string] = symbol;
	    SymbolToStringRegistry$1[symbol] = string;
	    return symbol;
	  }
	});

	var $$11 = _export$1;
	var hasOwn$g = hasOwnProperty_1$1;
	var isSymbol$8 = isSymbol$b;
	var tryToString$6 = tryToString$8;
	var shared$6 = sharedExports$1;
	var NATIVE_SYMBOL_REGISTRY = symbolRegistryDetection;

	var SymbolToStringRegistry = shared$6('symbol-to-string-registry');

	// `Symbol.keyFor` method
	// https://tc39.es/ecma262/#sec-symbol.keyfor
	$$11({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
	  keyFor: function keyFor(sym) {
	    if (!isSymbol$8(sym)) throw new TypeError(tryToString$6(sym) + ' is not a symbol');
	    if (hasOwn$g(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
	  }
	});

	var uncurryThis$J = functionUncurryThis$1;

	var arraySlice$5 = uncurryThis$J([].slice);

	var uncurryThis$I = functionUncurryThis$1;
	var isArray$j = isArray$l;
	var isCallable$p = isCallable$B;
	var classof$e = classofRaw$5;
	var toString$o = toString$r;

	var push$c = uncurryThis$I([].push);

	var getJsonReplacerFunction = function (replacer) {
	  if (isCallable$p(replacer)) return replacer;
	  if (!isArray$j(replacer)) return;
	  var rawLength = replacer.length;
	  var keys = [];
	  for (var i = 0; i < rawLength; i++) {
	    var element = replacer[i];
	    if (typeof element == 'string') push$c(keys, element);
	    else if (typeof element == 'number' || classof$e(element) === 'Number' || classof$e(element) === 'String') push$c(keys, toString$o(element));
	  }
	  var keysLength = keys.length;
	  var root = true;
	  return function (key, value) {
	    if (root) {
	      root = false;
	      return value;
	    }
	    if (isArray$j(this)) return value;
	    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
	  };
	};

	var $$10 = _export$1;
	var getBuiltIn$e = getBuiltIn$k;
	var apply$8 = functionApply$1;
	var call$o = functionCall$1;
	var uncurryThis$H = functionUncurryThis$1;
	var fails$I = fails$T;
	var isCallable$o = isCallable$B;
	var isSymbol$7 = isSymbol$b;
	var arraySlice$4 = arraySlice$5;
	var getReplacerFunction = getJsonReplacerFunction;
	var NATIVE_SYMBOL$3 = symbolConstructorDetection$1;

	var $String$7 = String;
	var $stringify = getBuiltIn$e('JSON', 'stringify');
	var exec$4 = uncurryThis$H(/./.exec);
	var charAt$6 = uncurryThis$H(''.charAt);
	var charCodeAt$2 = uncurryThis$H(''.charCodeAt);
	var replace$6 = uncurryThis$H(''.replace);
	var numberToString = uncurryThis$H(1.0.toString);

	var tester = /[\uD800-\uDFFF]/g;
	var low = /^[\uD800-\uDBFF]$/;
	var hi = /^[\uDC00-\uDFFF]$/;

	var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL$3 || fails$I(function () {
	  var symbol = getBuiltIn$e('Symbol')('stringify detection');
	  // MS Edge converts symbol values to JSON as {}
	  return $stringify([symbol]) !== '[null]'
	    // WebKit converts symbol values to JSON as null
	    || $stringify({ a: symbol }) !== '{}'
	    // V8 throws on boxed symbols
	    || $stringify(Object(symbol)) !== '{}';
	});

	// https://github.com/tc39/proposal-well-formed-stringify
	var ILL_FORMED_UNICODE = fails$I(function () {
	  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
	    || $stringify('\uDEAD') !== '"\\udead"';
	});

	var stringifyWithSymbolsFix = function (it, replacer) {
	  var args = arraySlice$4(arguments);
	  var $replacer = getReplacerFunction(replacer);
	  if (!isCallable$o($replacer) && (it === undefined || isSymbol$7(it))) return; // IE8 returns string on undefined
	  args[1] = function (key, value) {
	    // some old implementations (like WebKit) could pass numbers as keys
	    if (isCallable$o($replacer)) value = call$o($replacer, this, $String$7(key), value);
	    if (!isSymbol$7(value)) return value;
	  };
	  return apply$8($stringify, null, args);
	};

	var fixIllFormed = function (match, offset, string) {
	  var prev = charAt$6(string, offset - 1);
	  var next = charAt$6(string, offset + 1);
	  if ((exec$4(low, match) && !exec$4(hi, next)) || (exec$4(hi, match) && !exec$4(low, prev))) {
	    return '\\u' + numberToString(charCodeAt$2(match, 0), 16);
	  } return match;
	};

	if ($stringify) {
	  // `JSON.stringify` method
	  // https://tc39.es/ecma262/#sec-json.stringify
	  $$10({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
	    // eslint-disable-next-line no-unused-vars -- required for `.length`
	    stringify: function stringify(it, replacer, space) {
	      var args = arraySlice$4(arguments);
	      var result = apply$8(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
	      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace$6(result, tester, fixIllFormed) : result;
	    }
	  });
	}

	var $$$ = _export$1;
	var NATIVE_SYMBOL$2 = symbolConstructorDetection$1;
	var fails$H = fails$T;
	var getOwnPropertySymbolsModule$3 = objectGetOwnPropertySymbols$1;
	var toObject$b = toObject$f;

	// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FORCED$8 = !NATIVE_SYMBOL$2 || fails$H(function () { getOwnPropertySymbolsModule$3.f(1); });

	// `Object.getOwnPropertySymbols` method
	// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
	$$$({ target: 'Object', stat: true, forced: FORCED$8 }, {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    var $getOwnPropertySymbols = getOwnPropertySymbolsModule$3.f;
	    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject$b(it)) : [];
	  }
	});

	var path$l = path$q;

	var getOwnPropertySymbols$2 = path$l.Object.getOwnPropertySymbols;

	var parent$1a = getOwnPropertySymbols$2;

	var getOwnPropertySymbols$1 = parent$1a;

	var getOwnPropertySymbols = getOwnPropertySymbols$1;

	var _Object$getOwnPropertySymbols = /*@__PURE__*/getDefaultExportFromCjs(getOwnPropertySymbols);

	var fails$G = fails$T;
	var wellKnownSymbol$r = wellKnownSymbol$A;
	var V8_VERSION$4 = engineV8Version$1;

	var SPECIES$8 = wellKnownSymbol$r('species');

	var arrayMethodHasSpeciesSupport$6 = function (METHOD_NAME) {
	  // We can't use this feature detection in V8 since it causes
	  // deoptimization and serious performance degradation
	  // https://github.com/zloirock/core-js/issues/677
	  return V8_VERSION$4 >= 51 || !fails$G(function () {
	    var array = [];
	    var constructor = array.constructor = {};
	    constructor[SPECIES$8] = function () {
	      return { foo: 1 };
	    };
	    return array[METHOD_NAME](Boolean).foo !== 1;
	  });
	};

	var $$_ = _export$1;
	var $filter$1 = arrayIteration$1.filter;
	var arrayMethodHasSpeciesSupport$5 = arrayMethodHasSpeciesSupport$6;

	var HAS_SPECIES_SUPPORT$3 = arrayMethodHasSpeciesSupport$5('filter');

	// `Array.prototype.filter` method
	// https://tc39.es/ecma262/#sec-array.prototype.filter
	// with adding support of @@species
	$$_({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$3 }, {
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

	var global$u = global$G;
	var path$k = path$q;

	var getBuiltInPrototypeMethod$g = function (CONSTRUCTOR, METHOD) {
	  var Namespace = path$k[CONSTRUCTOR + 'Prototype'];
	  var pureMethod = Namespace && Namespace[METHOD];
	  if (pureMethod) return pureMethod;
	  var NativeConstructor = global$u[CONSTRUCTOR];
	  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
	  return NativePrototype && NativePrototype[METHOD];
	};

	var getBuiltInPrototypeMethod$f = getBuiltInPrototypeMethod$g;

	var filter$4 = getBuiltInPrototypeMethod$f('Array', 'filter');

	var isPrototypeOf$j = objectIsPrototypeOf$1;
	var method$d = filter$4;

	var ArrayPrototype$c = Array.prototype;

	var filter$3 = function (it) {
	  var own = it.filter;
	  return it === ArrayPrototype$c || (isPrototypeOf$j(ArrayPrototype$c, it) && own === ArrayPrototype$c.filter) ? method$d : own;
	};

	var parent$19 = filter$3;

	var filter$2 = parent$19;

	var filter$1 = filter$2;

	var _filterInstanceProperty = /*@__PURE__*/getDefaultExportFromCjs(filter$1);

	var getOwnPropertyDescriptor$7 = {exports: {}};

	var $$Z = _export$1;
	var fails$F = fails$T;
	var toIndexedObject$9 = toIndexedObject$g;
	var nativeGetOwnPropertyDescriptor = objectGetOwnPropertyDescriptor$1.f;
	var DESCRIPTORS$j = descriptors$1;

	var FORCED$7 = !DESCRIPTORS$j || fails$F(function () { nativeGetOwnPropertyDescriptor(1); });

	// `Object.getOwnPropertyDescriptor` method
	// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
	$$Z({ target: 'Object', stat: true, forced: FORCED$7, sham: !DESCRIPTORS$j }, {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
	    return nativeGetOwnPropertyDescriptor(toIndexedObject$9(it), key);
	  }
	});

	var path$j = path$q;

	var Object$4 = path$j.Object;

	var getOwnPropertyDescriptor$6 = getOwnPropertyDescriptor$7.exports = function getOwnPropertyDescriptor(it, key) {
	  return Object$4.getOwnPropertyDescriptor(it, key);
	};

	if (Object$4.getOwnPropertyDescriptor.sham) getOwnPropertyDescriptor$6.sham = true;

	var getOwnPropertyDescriptorExports = getOwnPropertyDescriptor$7.exports;

	var parent$18 = getOwnPropertyDescriptorExports;

	var getOwnPropertyDescriptor$5 = parent$18;

	var getOwnPropertyDescriptor$4 = getOwnPropertyDescriptor$5;

	var _Object$getOwnPropertyDescriptor = /*@__PURE__*/getDefaultExportFromCjs(getOwnPropertyDescriptor$4);

	var fails$E = fails$T;

	var arrayMethodIsStrict$5 = function (METHOD_NAME, argument) {
	  var method = [][METHOD_NAME];
	  return !!method && fails$E(function () {
	    // eslint-disable-next-line no-useless-call -- required for testing
	    method.call(null, argument || function () { return 1; }, 1);
	  });
	};

	var $forEach = arrayIteration$1.forEach;
	var arrayMethodIsStrict$4 = arrayMethodIsStrict$5;

	var STRICT_METHOD$1 = arrayMethodIsStrict$4('forEach');

	// `Array.prototype.forEach` method implementation
	// https://tc39.es/ecma262/#sec-array.prototype.foreach
	var arrayForEach = !STRICT_METHOD$1 ? function forEach(callbackfn /* , thisArg */) {
	  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	// eslint-disable-next-line es/no-array-prototype-foreach -- safe
	} : [].forEach;

	var $$Y = _export$1;
	var forEach$b = arrayForEach;

	// `Array.prototype.forEach` method
	// https://tc39.es/ecma262/#sec-array.prototype.foreach
	// eslint-disable-next-line es/no-array-prototype-foreach -- safe
	$$Y({ target: 'Array', proto: true, forced: [].forEach !== forEach$b }, {
	  forEach: forEach$b
	});

	var getBuiltInPrototypeMethod$e = getBuiltInPrototypeMethod$g;

	var forEach$a = getBuiltInPrototypeMethod$e('Array', 'forEach');

	var parent$17 = forEach$a;

	var forEach$9 = parent$17;

	var classof$d = classof$k;
	var hasOwn$f = hasOwnProperty_1$1;
	var isPrototypeOf$i = objectIsPrototypeOf$1;
	var method$c = forEach$9;


	var ArrayPrototype$b = Array.prototype;

	var DOMIterables$1 = {
	  DOMTokenList: true,
	  NodeList: true
	};

	var forEach$8 = function (it) {
	  var own = it.forEach;
	  return it === ArrayPrototype$b || (isPrototypeOf$i(ArrayPrototype$b, it) && own === ArrayPrototype$b.forEach)
	    || hasOwn$f(DOMIterables$1, classof$d(it)) ? method$c : own;
	};

	var forEach$7 = forEach$8;

	var _forEachInstanceProperty = /*@__PURE__*/getDefaultExportFromCjs(forEach$7);

	var getBuiltIn$d = getBuiltIn$k;
	var uncurryThis$G = functionUncurryThis$1;
	var getOwnPropertyNamesModule$2 = objectGetOwnPropertyNames$1;
	var getOwnPropertySymbolsModule$2 = objectGetOwnPropertySymbols$1;
	var anObject$l = anObject$q;

	var concat$8 = uncurryThis$G([].concat);

	// all object keys, includes non-enumerable and symbols
	var ownKeys$h = getBuiltIn$d('Reflect', 'ownKeys') || function ownKeys(it) {
	  var keys = getOwnPropertyNamesModule$2.f(anObject$l(it));
	  var getOwnPropertySymbols = getOwnPropertySymbolsModule$2.f;
	  return getOwnPropertySymbols ? concat$8(keys, getOwnPropertySymbols(it)) : keys;
	};

	var $$X = _export$1;
	var DESCRIPTORS$i = descriptors$1;
	var ownKeys$g = ownKeys$h;
	var toIndexedObject$8 = toIndexedObject$g;
	var getOwnPropertyDescriptorModule$2 = objectGetOwnPropertyDescriptor$1;
	var createProperty$5 = createProperty$7;

	// `Object.getOwnPropertyDescriptors` method
	// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
	$$X({ target: 'Object', stat: true, sham: !DESCRIPTORS$i }, {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIndexedObject$8(object);
	    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule$2.f;
	    var keys = ownKeys$g(O);
	    var result = {};
	    var index = 0;
	    var key, descriptor;
	    while (keys.length > index) {
	      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
	      if (descriptor !== undefined) createProperty$5(result, key, descriptor);
	    }
	    return result;
	  }
	});

	var path$i = path$q;

	var getOwnPropertyDescriptors$2 = path$i.Object.getOwnPropertyDescriptors;

	var parent$16 = getOwnPropertyDescriptors$2;

	var getOwnPropertyDescriptors$1 = parent$16;

	var getOwnPropertyDescriptors = getOwnPropertyDescriptors$1;

	var _Object$getOwnPropertyDescriptors = /*@__PURE__*/getDefaultExportFromCjs(getOwnPropertyDescriptors);

	var defineProperties$4 = {exports: {}};

	var $$W = _export$1;
	var DESCRIPTORS$h = descriptors$1;
	var defineProperties$3 = objectDefineProperties$1.f;

	// `Object.defineProperties` method
	// https://tc39.es/ecma262/#sec-object.defineproperties
	// eslint-disable-next-line es/no-object-defineproperties -- safe
	$$W({ target: 'Object', stat: true, forced: Object.defineProperties !== defineProperties$3, sham: !DESCRIPTORS$h }, {
	  defineProperties: defineProperties$3
	});

	var path$h = path$q;

	var Object$3 = path$h.Object;

	var defineProperties$2 = defineProperties$4.exports = function defineProperties(T, D) {
	  return Object$3.defineProperties(T, D);
	};

	if (Object$3.defineProperties.sham) defineProperties$2.sham = true;

	var definePropertiesExports = defineProperties$4.exports;

	var parent$15 = definePropertiesExports;

	var defineProperties$1 = parent$15;

	var defineProperties = defineProperties$1;

	var _Object$defineProperties = /*@__PURE__*/getDefaultExportFromCjs(defineProperties);

	var defineProperty$f = {exports: {}};

	var $$V = _export$1;
	var DESCRIPTORS$g = descriptors$1;
	var defineProperty$e = objectDefineProperty$1.f;

	// `Object.defineProperty` method
	// https://tc39.es/ecma262/#sec-object.defineproperty
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	$$V({ target: 'Object', stat: true, forced: Object.defineProperty !== defineProperty$e, sham: !DESCRIPTORS$g }, {
	  defineProperty: defineProperty$e
	});

	var path$g = path$q;

	var Object$2 = path$g.Object;

	var defineProperty$d = defineProperty$f.exports = function defineProperty(it, key, desc) {
	  return Object$2.defineProperty(it, key, desc);
	};

	if (Object$2.defineProperty.sham) defineProperty$d.sham = true;

	var definePropertyExports = defineProperty$f.exports;

	var parent$14 = definePropertyExports;

	var defineProperty$c = parent$14;

	var defineProperty$b = defineProperty$c;

	var _Object$defineProperty$1 = /*@__PURE__*/getDefaultExportFromCjs(defineProperty$b);

	var $$U = _export$1;
	var isArray$i = isArray$l;

	// `Array.isArray` method
	// https://tc39.es/ecma262/#sec-array.isarray
	$$U({ target: 'Array', stat: true }, {
	  isArray: isArray$i
	});

	var path$f = path$q;

	var isArray$h = path$f.Array.isArray;

	var parent$13 = isArray$h;

	var isArray$g = parent$13;

	var parent$12 = isArray$g;

	var isArray$f = parent$12;

	var parent$11 = isArray$f;

	var isArray$e = parent$11;

	var isArray$d = isArray$e;

	var _Array$isArray$1 = /*@__PURE__*/getDefaultExportFromCjs(isArray$d);

	function _arrayLikeToArray$6(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;
	  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
	  return arr2;
	}

	function _arrayWithoutHoles(arr) {
	  if (_Array$isArray$1(arr)) return _arrayLikeToArray$6(arr);
	}

	var $TypeError$h = TypeError;
	var MAX_SAFE_INTEGER$2 = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

	var doesNotExceedSafeInteger$2 = function (it) {
	  if (it > MAX_SAFE_INTEGER$2) throw $TypeError$h('Maximum allowed index exceeded');
	  return it;
	};

	var $$T = _export$1;
	var fails$D = fails$T;
	var isArray$c = isArray$l;
	var isObject$u = isObject$B;
	var toObject$a = toObject$f;
	var lengthOfArrayLike$8 = lengthOfArrayLike$c;
	var doesNotExceedSafeInteger$1 = doesNotExceedSafeInteger$2;
	var createProperty$4 = createProperty$7;
	var arraySpeciesCreate$2 = arraySpeciesCreate$4;
	var arrayMethodHasSpeciesSupport$4 = arrayMethodHasSpeciesSupport$6;
	var wellKnownSymbol$q = wellKnownSymbol$A;
	var V8_VERSION$3 = engineV8Version$1;

	var IS_CONCAT_SPREADABLE = wellKnownSymbol$q('isConcatSpreadable');

	// We can't use this feature detection in V8 since it causes
	// deoptimization and serious performance degradation
	// https://github.com/zloirock/core-js/issues/679
	var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION$3 >= 51 || !fails$D(function () {
	  var array = [];
	  array[IS_CONCAT_SPREADABLE] = false;
	  return array.concat()[0] !== array;
	});

	var isConcatSpreadable = function (O) {
	  if (!isObject$u(O)) return false;
	  var spreadable = O[IS_CONCAT_SPREADABLE];
	  return spreadable !== undefined ? !!spreadable : isArray$c(O);
	};

	var FORCED$6 = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport$4('concat');

	// `Array.prototype.concat` method
	// https://tc39.es/ecma262/#sec-array.prototype.concat
	// with adding support of @@isConcatSpreadable and @@species
	$$T({ target: 'Array', proto: true, arity: 1, forced: FORCED$6 }, {
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  concat: function concat(arg) {
	    var O = toObject$a(this);
	    var A = arraySpeciesCreate$2(O, 0);
	    var n = 0;
	    var i, k, length, len, E;
	    for (i = -1, length = arguments.length; i < length; i++) {
	      E = i === -1 ? O : arguments[i];
	      if (isConcatSpreadable(E)) {
	        len = lengthOfArrayLike$8(E);
	        doesNotExceedSafeInteger$1(n + len);
	        for (k = 0; k < len; k++, n++) if (k in E) createProperty$4(A, n, E[k]);
	      } else {
	        doesNotExceedSafeInteger$1(n + 1);
	        createProperty$4(A, n++, E);
	      }
	    }
	    A.length = n;
	    return A;
	  }
	});

	var defineWellKnownSymbol$k = wellKnownSymbolDefine;

	// `Symbol.asyncIterator` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.asynciterator
	defineWellKnownSymbol$k('asyncIterator');

	var defineWellKnownSymbol$j = wellKnownSymbolDefine;

	// `Symbol.hasInstance` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.hasinstance
	defineWellKnownSymbol$j('hasInstance');

	var defineWellKnownSymbol$i = wellKnownSymbolDefine;

	// `Symbol.isConcatSpreadable` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
	defineWellKnownSymbol$i('isConcatSpreadable');

	var defineWellKnownSymbol$h = wellKnownSymbolDefine;

	// `Symbol.iterator` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.iterator
	defineWellKnownSymbol$h('iterator');

	var defineWellKnownSymbol$g = wellKnownSymbolDefine;

	// `Symbol.match` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.match
	defineWellKnownSymbol$g('match');

	var defineWellKnownSymbol$f = wellKnownSymbolDefine;

	// `Symbol.matchAll` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.matchall
	defineWellKnownSymbol$f('matchAll');

	var defineWellKnownSymbol$e = wellKnownSymbolDefine;

	// `Symbol.replace` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.replace
	defineWellKnownSymbol$e('replace');

	var defineWellKnownSymbol$d = wellKnownSymbolDefine;

	// `Symbol.search` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.search
	defineWellKnownSymbol$d('search');

	var defineWellKnownSymbol$c = wellKnownSymbolDefine;

	// `Symbol.species` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.species
	defineWellKnownSymbol$c('species');

	var defineWellKnownSymbol$b = wellKnownSymbolDefine;

	// `Symbol.split` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.split
	defineWellKnownSymbol$b('split');

	var defineWellKnownSymbol$a = wellKnownSymbolDefine;
	var defineSymbolToPrimitive = symbolDefineToPrimitive;

	// `Symbol.toPrimitive` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.toprimitive
	defineWellKnownSymbol$a('toPrimitive');

	// `Symbol.prototype[@@toPrimitive]` method
	// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
	defineSymbolToPrimitive();

	var getBuiltIn$c = getBuiltIn$k;
	var defineWellKnownSymbol$9 = wellKnownSymbolDefine;
	var setToStringTag$5 = setToStringTag$7;

	// `Symbol.toStringTag` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.tostringtag
	defineWellKnownSymbol$9('toStringTag');

	// `Symbol.prototype[@@toStringTag]` property
	// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
	setToStringTag$5(getBuiltIn$c('Symbol'), 'Symbol');

	var defineWellKnownSymbol$8 = wellKnownSymbolDefine;

	// `Symbol.unscopables` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.unscopables
	defineWellKnownSymbol$8('unscopables');

	var global$t = global$G;
	var setToStringTag$4 = setToStringTag$7;

	// JSON[@@toStringTag] property
	// https://tc39.es/ecma262/#sec-json-@@tostringtag
	setToStringTag$4(global$t.JSON, 'JSON', true);

	var path$e = path$q;

	var symbol$5 = path$e.Symbol;

	var iterators = {};

	var DESCRIPTORS$f = descriptors$1;
	var hasOwn$e = hasOwnProperty_1$1;

	var FunctionPrototype$6 = Function.prototype;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getDescriptor$1 = DESCRIPTORS$f && Object.getOwnPropertyDescriptor;

	var EXISTS$2 = hasOwn$e(FunctionPrototype$6, 'name');
	// additional protection from minified / mangled / dropped function names
	var PROPER$1 = EXISTS$2 && (function something() { /* empty */ }).name === 'something';
	var CONFIGURABLE$2 = EXISTS$2 && (!DESCRIPTORS$f || (DESCRIPTORS$f && getDescriptor$1(FunctionPrototype$6, 'name').configurable));

	var functionName$1 = {
	  EXISTS: EXISTS$2,
	  PROPER: PROPER$1,
	  CONFIGURABLE: CONFIGURABLE$2
	};

	var fails$C = fails$T;

	var correctPrototypeGetter = !fails$C(function () {
	  function F() { /* empty */ }
	  F.prototype.constructor = null;
	  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
	  return Object.getPrototypeOf(new F()) !== F.prototype;
	});

	var hasOwn$d = hasOwnProperty_1$1;
	var isCallable$n = isCallable$B;
	var toObject$9 = toObject$f;
	var sharedKey$3 = sharedKey$7;
	var CORRECT_PROTOTYPE_GETTER$1 = correctPrototypeGetter;

	var IE_PROTO$1 = sharedKey$3('IE_PROTO');
	var $Object$5 = Object;
	var ObjectPrototype$1 = $Object$5.prototype;

	// `Object.getPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.getprototypeof
	// eslint-disable-next-line es/no-object-getprototypeof -- safe
	var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER$1 ? $Object$5.getPrototypeOf : function (O) {
	  var object = toObject$9(O);
	  if (hasOwn$d(object, IE_PROTO$1)) return object[IE_PROTO$1];
	  var constructor = object.constructor;
	  if (isCallable$n(constructor) && object instanceof constructor) {
	    return constructor.prototype;
	  } return object instanceof $Object$5 ? ObjectPrototype$1 : null;
	};

	var fails$B = fails$T;
	var isCallable$m = isCallable$B;
	var isObject$t = isObject$B;
	var create$e = objectCreate$1;
	var getPrototypeOf$8 = objectGetPrototypeOf;
	var defineBuiltIn$8 = defineBuiltIn$b;
	var wellKnownSymbol$p = wellKnownSymbol$A;

	var ITERATOR$5 = wellKnownSymbol$p('iterator');
	var BUGGY_SAFARI_ITERATORS$1 = false;

	// `%IteratorPrototype%` object
	// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
	var IteratorPrototype$1, PrototypeOfArrayIteratorPrototype, arrayIterator;

	/* eslint-disable es/no-array-prototype-keys -- safe */
	if ([].keys) {
	  arrayIterator = [].keys();
	  // Safari 8 has buggy iterators w/o `next`
	  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
	  else {
	    PrototypeOfArrayIteratorPrototype = getPrototypeOf$8(getPrototypeOf$8(arrayIterator));
	    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$1 = PrototypeOfArrayIteratorPrototype;
	  }
	}

	var NEW_ITERATOR_PROTOTYPE = !isObject$t(IteratorPrototype$1) || fails$B(function () {
	  var test = {};
	  // FF44- legacy iterators case
	  return IteratorPrototype$1[ITERATOR$5].call(test) !== test;
	});

	if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$1 = {};
	else IteratorPrototype$1 = create$e(IteratorPrototype$1);

	// `%IteratorPrototype%[@@iterator]()` method
	// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
	if (!isCallable$m(IteratorPrototype$1[ITERATOR$5])) {
	  defineBuiltIn$8(IteratorPrototype$1, ITERATOR$5, function () {
	    return this;
	  });
	}

	var iteratorsCore = {
	  IteratorPrototype: IteratorPrototype$1,
	  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
	};

	var IteratorPrototype = iteratorsCore.IteratorPrototype;
	var create$d = objectCreate$1;
	var createPropertyDescriptor$6 = createPropertyDescriptor$b;
	var setToStringTag$3 = setToStringTag$7;
	var Iterators$5 = iterators;

	var returnThis$1 = function () { return this; };

	var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
	  var TO_STRING_TAG = NAME + ' Iterator';
	  IteratorConstructor.prototype = create$d(IteratorPrototype, { next: createPropertyDescriptor$6(+!ENUMERABLE_NEXT, next) });
	  setToStringTag$3(IteratorConstructor, TO_STRING_TAG, false, true);
	  Iterators$5[TO_STRING_TAG] = returnThis$1;
	  return IteratorConstructor;
	};

	var uncurryThis$F = functionUncurryThis$1;
	var aCallable$b = aCallable$e;

	var functionUncurryThisAccessor = function (object, key, method) {
	  try {
	    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	    return uncurryThis$F(aCallable$b(Object.getOwnPropertyDescriptor(object, key)[method]));
	  } catch (error) { /* empty */ }
	};

	var isCallable$l = isCallable$B;

	var $String$6 = String;
	var $TypeError$g = TypeError;

	var aPossiblePrototype$1 = function (argument) {
	  if (typeof argument == 'object' || isCallable$l(argument)) return argument;
	  throw new $TypeError$g("Can't set " + $String$6(argument) + ' as a prototype');
	};

	/* eslint-disable no-proto -- safe */
	var uncurryThisAccessor = functionUncurryThisAccessor;
	var anObject$k = anObject$q;
	var aPossiblePrototype = aPossiblePrototype$1;

	// `Object.setPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.setprototypeof
	// Works with __proto__ only. Old v8 can't work with null proto objects.
	// eslint-disable-next-line es/no-object-setprototypeof -- safe
	var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
	  var CORRECT_SETTER = false;
	  var test = {};
	  var setter;
	  try {
	    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
	    setter(test, []);
	    CORRECT_SETTER = test instanceof Array;
	  } catch (error) { /* empty */ }
	  return function setPrototypeOf(O, proto) {
	    anObject$k(O);
	    aPossiblePrototype(proto);
	    if (CORRECT_SETTER) setter(O, proto);
	    else O.__proto__ = proto;
	    return O;
	  };
	}() : undefined);

	var $$S = _export$1;
	var call$n = functionCall$1;
	var FunctionName = functionName$1;
	var createIteratorConstructor = iteratorCreateConstructor;
	var getPrototypeOf$7 = objectGetPrototypeOf;
	var setToStringTag$2 = setToStringTag$7;
	var defineBuiltIn$7 = defineBuiltIn$b;
	var wellKnownSymbol$o = wellKnownSymbol$A;
	var Iterators$4 = iterators;
	var IteratorsCore = iteratorsCore;

	var PROPER_FUNCTION_NAME$2 = FunctionName.PROPER;
	FunctionName.CONFIGURABLE;
	IteratorsCore.IteratorPrototype;
	var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
	var ITERATOR$4 = wellKnownSymbol$o('iterator');
	var KEYS = 'keys';
	var VALUES = 'values';
	var ENTRIES = 'entries';

	var returnThis = function () { return this; };

	var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
	  createIteratorConstructor(IteratorConstructor, NAME, next);

	  var getIterationMethod = function (KIND) {
	    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
	    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

	    switch (KIND) {
	      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
	      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
	      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
	    }

	    return function () { return new IteratorConstructor(this); };
	  };

	  var TO_STRING_TAG = NAME + ' Iterator';
	  var INCORRECT_VALUES_NAME = false;
	  var IterablePrototype = Iterable.prototype;
	  var nativeIterator = IterablePrototype[ITERATOR$4]
	    || IterablePrototype['@@iterator']
	    || DEFAULT && IterablePrototype[DEFAULT];
	  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
	  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
	  var CurrentIteratorPrototype, methods, KEY;

	  // fix native
	  if (anyNativeIterator) {
	    CurrentIteratorPrototype = getPrototypeOf$7(anyNativeIterator.call(new Iterable()));
	    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag$2(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
	      Iterators$4[TO_STRING_TAG] = returnThis;
	    }
	  }

	  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
	  if (PROPER_FUNCTION_NAME$2 && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
	    {
	      INCORRECT_VALUES_NAME = true;
	      defaultIterator = function values() { return call$n(nativeIterator, this); };
	    }
	  }

	  // export additional methods
	  if (DEFAULT) {
	    methods = {
	      values: getIterationMethod(VALUES),
	      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
	      entries: getIterationMethod(ENTRIES)
	    };
	    if (FORCED) for (KEY in methods) {
	      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
	        defineBuiltIn$7(IterablePrototype, KEY, methods[KEY]);
	      }
	    } else $$S({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
	  }

	  // define iterator
	  if ((FORCED) && IterablePrototype[ITERATOR$4] !== defaultIterator) {
	    defineBuiltIn$7(IterablePrototype, ITERATOR$4, defaultIterator, { name: DEFAULT });
	  }
	  Iterators$4[NAME] = defaultIterator;

	  return methods;
	};

	// `CreateIterResultObject` abstract operation
	// https://tc39.es/ecma262/#sec-createiterresultobject
	var createIterResultObject$3 = function (value, done) {
	  return { value: value, done: done };
	};

	var toIndexedObject$7 = toIndexedObject$g;
	var Iterators$3 = iterators;
	var InternalStateModule$6 = internalState$1;
	objectDefineProperty$1.f;
	var defineIterator$2 = iteratorDefine;
	var createIterResultObject$2 = createIterResultObject$3;

	var ARRAY_ITERATOR = 'Array Iterator';
	var setInternalState$5 = InternalStateModule$6.set;
	var getInternalState$3 = InternalStateModule$6.getterFor(ARRAY_ITERATOR);

	// `Array.prototype.entries` method
	// https://tc39.es/ecma262/#sec-array.prototype.entries
	// `Array.prototype.keys` method
	// https://tc39.es/ecma262/#sec-array.prototype.keys
	// `Array.prototype.values` method
	// https://tc39.es/ecma262/#sec-array.prototype.values
	// `Array.prototype[@@iterator]` method
	// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
	// `CreateArrayIterator` internal method
	// https://tc39.es/ecma262/#sec-createarrayiterator
	defineIterator$2(Array, 'Array', function (iterated, kind) {
	  setInternalState$5(this, {
	    type: ARRAY_ITERATOR,
	    target: toIndexedObject$7(iterated), // target
	    index: 0,                          // next index
	    kind: kind                         // kind
	  });
	// `%ArrayIteratorPrototype%.next` method
	// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
	}, function () {
	  var state = getInternalState$3(this);
	  var target = state.target;
	  var index = state.index++;
	  if (!target || index >= target.length) {
	    state.target = undefined;
	    return createIterResultObject$2(undefined, true);
	  }
	  switch (state.kind) {
	    case 'keys': return createIterResultObject$2(index, false);
	    case 'values': return createIterResultObject$2(target[index], false);
	  } return createIterResultObject$2([index, target[index]], false);
	}, 'values');

	// argumentsList[@@iterator] is %ArrayProto_values%
	// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
	// https://tc39.es/ecma262/#sec-createmappedargumentsobject
	Iterators$3.Arguments = Iterators$3.Array;

	// iterable DOM collections
	// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
	var domIterables = {
	  CSSRuleList: 0,
	  CSSStyleDeclaration: 0,
	  CSSValueList: 0,
	  ClientRectList: 0,
	  DOMRectList: 0,
	  DOMStringList: 0,
	  DOMTokenList: 1,
	  DataTransferItemList: 0,
	  FileList: 0,
	  HTMLAllCollection: 0,
	  HTMLCollection: 0,
	  HTMLFormElement: 0,
	  HTMLSelectElement: 0,
	  MediaList: 0,
	  MimeTypeArray: 0,
	  NamedNodeMap: 0,
	  NodeList: 1,
	  PaintRequestList: 0,
	  Plugin: 0,
	  PluginArray: 0,
	  SVGLengthList: 0,
	  SVGNumberList: 0,
	  SVGPathSegList: 0,
	  SVGPointList: 0,
	  SVGStringList: 0,
	  SVGTransformList: 0,
	  SourceBufferList: 0,
	  StyleSheetList: 0,
	  TextTrackCueList: 0,
	  TextTrackList: 0,
	  TouchList: 0
	};

	var DOMIterables = domIterables;
	var global$s = global$G;
	var classof$c = classof$k;
	var createNonEnumerableProperty$8 = createNonEnumerableProperty$d;
	var Iterators$2 = iterators;
	var wellKnownSymbol$n = wellKnownSymbol$A;

	var TO_STRING_TAG$3 = wellKnownSymbol$n('toStringTag');

	for (var COLLECTION_NAME in DOMIterables) {
	  var Collection = global$s[COLLECTION_NAME];
	  var CollectionPrototype = Collection && Collection.prototype;
	  if (CollectionPrototype && classof$c(CollectionPrototype) !== TO_STRING_TAG$3) {
	    createNonEnumerableProperty$8(CollectionPrototype, TO_STRING_TAG$3, COLLECTION_NAME);
	  }
	  Iterators$2[COLLECTION_NAME] = Iterators$2.Array;
	}

	var parent$10 = symbol$5;


	var symbol$4 = parent$10;

	var wellKnownSymbol$m = wellKnownSymbol$A;
	var defineProperty$a = objectDefineProperty$1.f;

	var METADATA$1 = wellKnownSymbol$m('metadata');
	var FunctionPrototype$5 = Function.prototype;

	// Function.prototype[@@metadata]
	// https://github.com/tc39/proposal-decorator-metadata
	if (FunctionPrototype$5[METADATA$1] === undefined) {
	  defineProperty$a(FunctionPrototype$5, METADATA$1, {
	    value: null
	  });
	}

	var defineWellKnownSymbol$7 = wellKnownSymbolDefine;

	// `Symbol.asyncDispose` well-known symbol
	// https://github.com/tc39/proposal-async-explicit-resource-management
	defineWellKnownSymbol$7('asyncDispose');

	var defineWellKnownSymbol$6 = wellKnownSymbolDefine;

	// `Symbol.dispose` well-known symbol
	// https://github.com/tc39/proposal-explicit-resource-management
	defineWellKnownSymbol$6('dispose');

	var defineWellKnownSymbol$5 = wellKnownSymbolDefine;

	// `Symbol.metadata` well-known symbol
	// https://github.com/tc39/proposal-decorators
	defineWellKnownSymbol$5('metadata');

	var parent$$ = symbol$4;






	var symbol$3 = parent$$;

	var getBuiltIn$b = getBuiltIn$k;
	var uncurryThis$E = functionUncurryThis$1;

	var Symbol$9 = getBuiltIn$b('Symbol');
	var keyFor = Symbol$9.keyFor;
	var thisSymbolValue$1 = uncurryThis$E(Symbol$9.prototype.valueOf);

	// `Symbol.isRegisteredSymbol` method
	// https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
	var symbolIsRegistered = Symbol$9.isRegisteredSymbol || function isRegisteredSymbol(value) {
	  try {
	    return keyFor(thisSymbolValue$1(value)) !== undefined;
	  } catch (error) {
	    return false;
	  }
	};

	var $$R = _export$1;
	var isRegisteredSymbol$1 = symbolIsRegistered;

	// `Symbol.isRegisteredSymbol` method
	// https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
	$$R({ target: 'Symbol', stat: true }, {
	  isRegisteredSymbol: isRegisteredSymbol$1
	});

	var shared$5 = sharedExports$1;
	var getBuiltIn$a = getBuiltIn$k;
	var uncurryThis$D = functionUncurryThis$1;
	var isSymbol$6 = isSymbol$b;
	var wellKnownSymbol$l = wellKnownSymbol$A;

	var Symbol$8 = getBuiltIn$a('Symbol');
	var $isWellKnownSymbol = Symbol$8.isWellKnownSymbol;
	var getOwnPropertyNames = getBuiltIn$a('Object', 'getOwnPropertyNames');
	var thisSymbolValue = uncurryThis$D(Symbol$8.prototype.valueOf);
	var WellKnownSymbolsStore$1 = shared$5('wks');

	for (var i = 0, symbolKeys = getOwnPropertyNames(Symbol$8), symbolKeysLength = symbolKeys.length; i < symbolKeysLength; i++) {
	  // some old engines throws on access to some keys like `arguments` or `caller`
	  try {
	    var symbolKey = symbolKeys[i];
	    if (isSymbol$6(Symbol$8[symbolKey])) wellKnownSymbol$l(symbolKey);
	  } catch (error) { /* empty */ }
	}

	// `Symbol.isWellKnownSymbol` method
	// https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
	// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
	var symbolIsWellKnown = function isWellKnownSymbol(value) {
	  if ($isWellKnownSymbol && $isWellKnownSymbol(value)) return true;
	  try {
	    var symbol = thisSymbolValue(value);
	    for (var j = 0, keys = getOwnPropertyNames(WellKnownSymbolsStore$1), keysLength = keys.length; j < keysLength; j++) {
	      // eslint-disable-next-line eqeqeq -- polyfilled symbols case
	      if (WellKnownSymbolsStore$1[keys[j]] == symbol) return true;
	    }
	  } catch (error) { /* empty */ }
	  return false;
	};

	var $$Q = _export$1;
	var isWellKnownSymbol$1 = symbolIsWellKnown;

	// `Symbol.isWellKnownSymbol` method
	// https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
	// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
	$$Q({ target: 'Symbol', stat: true, forced: true }, {
	  isWellKnownSymbol: isWellKnownSymbol$1
	});

	var defineWellKnownSymbol$4 = wellKnownSymbolDefine;

	// `Symbol.matcher` well-known symbol
	// https://github.com/tc39/proposal-pattern-matching
	defineWellKnownSymbol$4('matcher');

	var defineWellKnownSymbol$3 = wellKnownSymbolDefine;

	// `Symbol.observable` well-known symbol
	// https://github.com/tc39/proposal-observable
	defineWellKnownSymbol$3('observable');

	var $$P = _export$1;
	var isRegisteredSymbol = symbolIsRegistered;

	// `Symbol.isRegistered` method
	// obsolete version of https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
	$$P({ target: 'Symbol', stat: true, name: 'isRegisteredSymbol' }, {
	  isRegistered: isRegisteredSymbol
	});

	var $$O = _export$1;
	var isWellKnownSymbol = symbolIsWellKnown;

	// `Symbol.isWellKnown` method
	// obsolete version of https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
	// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
	$$O({ target: 'Symbol', stat: true, name: 'isWellKnownSymbol', forced: true }, {
	  isWellKnown: isWellKnownSymbol
	});

	// TODO: Remove from `core-js@4`
	var defineWellKnownSymbol$2 = wellKnownSymbolDefine;

	// `Symbol.metadataKey` well-known symbol
	// https://github.com/tc39/proposal-decorator-metadata
	defineWellKnownSymbol$2('metadataKey');

	// TODO: remove from `core-js@4`
	var defineWellKnownSymbol$1 = wellKnownSymbolDefine;

	// `Symbol.patternMatch` well-known symbol
	// https://github.com/tc39/proposal-pattern-matching
	defineWellKnownSymbol$1('patternMatch');

	// TODO: remove from `core-js@4`
	var defineWellKnownSymbol = wellKnownSymbolDefine;

	defineWellKnownSymbol('replaceAll');

	var parent$_ = symbol$3;




	// TODO: Remove from `core-js@4`






	var symbol$2 = parent$_;

	var symbol$1 = symbol$2;

	var _Symbol$2 = /*@__PURE__*/getDefaultExportFromCjs(symbol$1);

	var uncurryThis$C = functionUncurryThis$1;
	var toIntegerOrInfinity$7 = toIntegerOrInfinity$a;
	var toString$n = toString$r;
	var requireObjectCoercible$d = requireObjectCoercible$g;

	var charAt$5 = uncurryThis$C(''.charAt);
	var charCodeAt$1 = uncurryThis$C(''.charCodeAt);
	var stringSlice$9 = uncurryThis$C(''.slice);

	var createMethod$4 = function (CONVERT_TO_STRING) {
	  return function ($this, pos) {
	    var S = toString$n(requireObjectCoercible$d($this));
	    var position = toIntegerOrInfinity$7(pos);
	    var size = S.length;
	    var first, second;
	    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
	    first = charCodeAt$1(S, position);
	    return first < 0xD800 || first > 0xDBFF || position + 1 === size
	      || (second = charCodeAt$1(S, position + 1)) < 0xDC00 || second > 0xDFFF
	        ? CONVERT_TO_STRING
	          ? charAt$5(S, position)
	          : first
	        : CONVERT_TO_STRING
	          ? stringSlice$9(S, position, position + 2)
	          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
	  };
	};

	var stringMultibyte$1 = {
	  // `String.prototype.codePointAt` method
	  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
	  codeAt: createMethod$4(false),
	  // `String.prototype.at` method
	  // https://github.com/mathiasbynens/String.prototype.at
	  charAt: createMethod$4(true)
	};

	var charAt$4 = stringMultibyte$1.charAt;
	var toString$m = toString$r;
	var InternalStateModule$5 = internalState$1;
	var defineIterator$1 = iteratorDefine;
	var createIterResultObject$1 = createIterResultObject$3;

	var STRING_ITERATOR = 'String Iterator';
	var setInternalState$4 = InternalStateModule$5.set;
	var getInternalState$2 = InternalStateModule$5.getterFor(STRING_ITERATOR);

	// `String.prototype[@@iterator]` method
	// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
	defineIterator$1(String, 'String', function (iterated) {
	  setInternalState$4(this, {
	    type: STRING_ITERATOR,
	    string: toString$m(iterated),
	    index: 0
	  });
	// `%StringIteratorPrototype%.next` method
	// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
	}, function next() {
	  var state = getInternalState$2(this);
	  var string = state.string;
	  var index = state.index;
	  var point;
	  if (index >= string.length) return createIterResultObject$1(undefined, true);
	  point = charAt$4(string, index);
	  state.index += point.length;
	  return createIterResultObject$1(point, false);
	});

	var classof$b = classof$k;
	var getMethod$6 = getMethod$8;
	var isNullOrUndefined$b = isNullOrUndefined$e;
	var Iterators$1 = iterators;
	var wellKnownSymbol$k = wellKnownSymbol$A;

	var ITERATOR$3 = wellKnownSymbol$k('iterator');

	var getIteratorMethod$9 = function (it) {
	  if (!isNullOrUndefined$b(it)) return getMethod$6(it, ITERATOR$3)
	    || getMethod$6(it, '@@iterator')
	    || Iterators$1[classof$b(it)];
	};

	var getIteratorMethod$8 = getIteratorMethod$9;

	var getIteratorMethod_1 = getIteratorMethod$8;

	var parent$Z = getIteratorMethod_1;


	var getIteratorMethod$7 = parent$Z;

	var parent$Y = getIteratorMethod$7;

	var getIteratorMethod$6 = parent$Y;

	var parent$X = getIteratorMethod$6;

	var getIteratorMethod$5 = parent$X;

	var getIteratorMethod$4 = getIteratorMethod$5;

	var _getIteratorMethod$1 = /*@__PURE__*/getDefaultExportFromCjs(getIteratorMethod$4);

	var call$m = functionCall$1;
	var anObject$j = anObject$q;
	var getMethod$5 = getMethod$8;

	var iteratorClose$2 = function (iterator, kind, value) {
	  var innerResult, innerError;
	  anObject$j(iterator);
	  try {
	    innerResult = getMethod$5(iterator, 'return');
	    if (!innerResult) {
	      if (kind === 'throw') throw value;
	      return value;
	    }
	    innerResult = call$m(innerResult, iterator);
	  } catch (error) {
	    innerError = true;
	    innerResult = error;
	  }
	  if (kind === 'throw') throw value;
	  if (innerError) throw innerResult;
	  anObject$j(innerResult);
	  return value;
	};

	var anObject$i = anObject$q;
	var iteratorClose$1 = iteratorClose$2;

	// call something on iterator step with safe closing on error
	var callWithSafeIterationClosing$1 = function (iterator, fn, value, ENTRIES) {
	  try {
	    return ENTRIES ? fn(anObject$i(value)[0], value[1]) : fn(value);
	  } catch (error) {
	    iteratorClose$1(iterator, 'throw', error);
	  }
	};

	var wellKnownSymbol$j = wellKnownSymbol$A;
	var Iterators = iterators;

	var ITERATOR$2 = wellKnownSymbol$j('iterator');
	var ArrayPrototype$a = Array.prototype;

	// check on default Array iterator
	var isArrayIteratorMethod$2 = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayPrototype$a[ITERATOR$2] === it);
	};

	var call$l = functionCall$1;
	var aCallable$a = aCallable$e;
	var anObject$h = anObject$q;
	var tryToString$5 = tryToString$8;
	var getIteratorMethod$3 = getIteratorMethod$9;

	var $TypeError$f = TypeError;

	var getIterator$2 = function (argument, usingIterator) {
	  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$3(argument) : usingIterator;
	  if (aCallable$a(iteratorMethod)) return anObject$h(call$l(iteratorMethod, argument));
	  throw new $TypeError$f(tryToString$5(argument) + ' is not iterable');
	};

	var bind$g = functionBindContext$1;
	var call$k = functionCall$1;
	var toObject$8 = toObject$f;
	var callWithSafeIterationClosing = callWithSafeIterationClosing$1;
	var isArrayIteratorMethod$1 = isArrayIteratorMethod$2;
	var isConstructor$5 = isConstructor$7;
	var lengthOfArrayLike$7 = lengthOfArrayLike$c;
	var createProperty$3 = createProperty$7;
	var getIterator$1 = getIterator$2;
	var getIteratorMethod$2 = getIteratorMethod$9;

	var $Array$3 = Array;

	// `Array.from` method implementation
	// https://tc39.es/ecma262/#sec-array.from
	var arrayFrom = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	  var O = toObject$8(arrayLike);
	  var IS_CONSTRUCTOR = isConstructor$5(this);
	  var argumentsLength = arguments.length;
	  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
	  var mapping = mapfn !== undefined;
	  if (mapping) mapfn = bind$g(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
	  var iteratorMethod = getIteratorMethod$2(O);
	  var index = 0;
	  var length, result, step, iterator, next, value;
	  // if the target is not iterable or it's an array with the default iterator - use a simple case
	  if (iteratorMethod && !(this === $Array$3 && isArrayIteratorMethod$1(iteratorMethod))) {
	    iterator = getIterator$1(O, iteratorMethod);
	    next = iterator.next;
	    result = IS_CONSTRUCTOR ? new this() : [];
	    for (;!(step = call$k(next, iterator)).done; index++) {
	      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
	      createProperty$3(result, index, value);
	    }
	  } else {
	    length = lengthOfArrayLike$7(O);
	    result = IS_CONSTRUCTOR ? new this(length) : $Array$3(length);
	    for (;length > index; index++) {
	      value = mapping ? mapfn(O[index], index) : O[index];
	      createProperty$3(result, index, value);
	    }
	  }
	  result.length = index;
	  return result;
	};

	var wellKnownSymbol$i = wellKnownSymbol$A;

	var ITERATOR$1 = wellKnownSymbol$i('iterator');
	var SAFE_CLOSING = false;

	try {
	  var called = 0;
	  var iteratorWithReturn = {
	    next: function () {
	      return { done: !!called++ };
	    },
	    'return': function () {
	      SAFE_CLOSING = true;
	    }
	  };
	  iteratorWithReturn[ITERATOR$1] = function () {
	    return this;
	  };
	  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
	  Array.from(iteratorWithReturn, function () { throw 2; });
	} catch (error) { /* empty */ }

	var checkCorrectnessOfIteration$2 = function (exec, SKIP_CLOSING) {
	  try {
	    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
	  } catch (error) { return false; } // workaround of old WebKit + `eval` bug
	  var ITERATION_SUPPORT = false;
	  try {
	    var object = {};
	    object[ITERATOR$1] = function () {
	      return {
	        next: function () {
	          return { done: ITERATION_SUPPORT = true };
	        }
	      };
	    };
	    exec(object);
	  } catch (error) { /* empty */ }
	  return ITERATION_SUPPORT;
	};

	var $$N = _export$1;
	var from$6 = arrayFrom;
	var checkCorrectnessOfIteration$1 = checkCorrectnessOfIteration$2;

	var INCORRECT_ITERATION = !checkCorrectnessOfIteration$1(function (iterable) {
	  // eslint-disable-next-line es/no-array-from -- required for testing
	  Array.from(iterable);
	});

	// `Array.from` method
	// https://tc39.es/ecma262/#sec-array.from
	$$N({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
	  from: from$6
	});

	var path$d = path$q;

	var from$5 = path$d.Array.from;

	var parent$W = from$5;

	var from$4 = parent$W;

	var parent$V = from$4;

	var from$3 = parent$V;

	var parent$U = from$3;

	var from$2 = parent$U;

	var from$1 = from$2;

	var _Array$from$1 = /*@__PURE__*/getDefaultExportFromCjs(from$1);

	function _iterableToArray(iter) {
	  if (typeof _Symbol$2 !== "undefined" && _getIteratorMethod$1(iter) != null || iter["@@iterator"] != null) return _Array$from$1(iter);
	}

	var $$M = _export$1;
	var isArray$b = isArray$l;
	var isConstructor$4 = isConstructor$7;
	var isObject$s = isObject$B;
	var toAbsoluteIndex$3 = toAbsoluteIndex$6;
	var lengthOfArrayLike$6 = lengthOfArrayLike$c;
	var toIndexedObject$6 = toIndexedObject$g;
	var createProperty$2 = createProperty$7;
	var wellKnownSymbol$h = wellKnownSymbol$A;
	var arrayMethodHasSpeciesSupport$3 = arrayMethodHasSpeciesSupport$6;
	var nativeSlice = arraySlice$5;

	var HAS_SPECIES_SUPPORT$2 = arrayMethodHasSpeciesSupport$3('slice');

	var SPECIES$7 = wellKnownSymbol$h('species');
	var $Array$2 = Array;
	var max$3 = Math.max;

	// `Array.prototype.slice` method
	// https://tc39.es/ecma262/#sec-array.prototype.slice
	// fallback for not array-like ES3 strings and DOM objects
	$$M({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$2 }, {
	  slice: function slice(start, end) {
	    var O = toIndexedObject$6(this);
	    var length = lengthOfArrayLike$6(O);
	    var k = toAbsoluteIndex$3(start, length);
	    var fin = toAbsoluteIndex$3(end === undefined ? length : end, length);
	    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
	    var Constructor, result, n;
	    if (isArray$b(O)) {
	      Constructor = O.constructor;
	      // cross-realm fallback
	      if (isConstructor$4(Constructor) && (Constructor === $Array$2 || isArray$b(Constructor.prototype))) {
	        Constructor = undefined;
	      } else if (isObject$s(Constructor)) {
	        Constructor = Constructor[SPECIES$7];
	        if (Constructor === null) Constructor = undefined;
	      }
	      if (Constructor === $Array$2 || Constructor === undefined) {
	        return nativeSlice(O, k, fin);
	      }
	    }
	    result = new (Constructor === undefined ? $Array$2 : Constructor)(max$3(fin - k, 0));
	    for (n = 0; k < fin; k++, n++) if (k in O) createProperty$2(result, n, O[k]);
	    result.length = n;
	    return result;
	  }
	});

	var getBuiltInPrototypeMethod$d = getBuiltInPrototypeMethod$g;

	var slice$7 = getBuiltInPrototypeMethod$d('Array', 'slice');

	var isPrototypeOf$h = objectIsPrototypeOf$1;
	var method$b = slice$7;

	var ArrayPrototype$9 = Array.prototype;

	var slice$6 = function (it) {
	  var own = it.slice;
	  return it === ArrayPrototype$9 || (isPrototypeOf$h(ArrayPrototype$9, it) && own === ArrayPrototype$9.slice) ? method$b : own;
	};

	var parent$T = slice$6;

	var slice$5 = parent$T;

	var parent$S = slice$5;

	var slice$4 = parent$S;

	var parent$R = slice$4;

	var slice$3 = parent$R;

	var slice$2 = slice$3;

	var _sliceInstanceProperty$1 = /*@__PURE__*/getDefaultExportFromCjs(slice$2);

	function _unsupportedIterableToArray$6(o, minLen) {
	  var _context;
	  if (!o) return;
	  if (typeof o === "string") return _arrayLikeToArray$6(o, minLen);
	  var n = _sliceInstanceProperty$1(_context = Object.prototype.toString.call(o)).call(_context, 8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return _Array$from$1(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen);
	}

	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}

	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$6(arr) || _nonIterableSpread();
	}

	var parent$Q = defineProperty$c;

	var defineProperty$9 = parent$Q;

	var parent$P = defineProperty$9;

	var defineProperty$8 = parent$P;

	var defineProperty$7 = defineProperty$8;

	var _Object$defineProperty = /*@__PURE__*/getDefaultExportFromCjs(defineProperty$7);

	var WrappedWellKnownSymbolModule$2 = wellKnownSymbolWrapped;

	var iterator$5 = WrappedWellKnownSymbolModule$2.f('iterator');

	var parent$O = iterator$5;


	var iterator$4 = parent$O;

	var parent$N = iterator$4;

	var iterator$3 = parent$N;

	var parent$M = iterator$3;

	var iterator$2 = parent$M;

	var iterator$1 = iterator$2;

	var _Symbol$iterator$1 = /*@__PURE__*/getDefaultExportFromCjs(iterator$1);

	function _typeof$2(o) {
	  "@babel/helpers - typeof";

	  return _typeof$2 = "function" == typeof _Symbol$2 && "symbol" == typeof _Symbol$iterator$1 ? function (o) {
	    return typeof o;
	  } : function (o) {
	    return o && "function" == typeof _Symbol$2 && o.constructor === _Symbol$2 && o !== _Symbol$2.prototype ? "symbol" : typeof o;
	  }, _typeof$2(o);
	}

	var WrappedWellKnownSymbolModule$1 = wellKnownSymbolWrapped;

	var toPrimitive$6 = WrappedWellKnownSymbolModule$1.f('toPrimitive');

	var parent$L = toPrimitive$6;

	var toPrimitive$5 = parent$L;

	var parent$K = toPrimitive$5;

	var toPrimitive$4 = parent$K;

	var parent$J = toPrimitive$4;

	var toPrimitive$3 = parent$J;

	var toPrimitive$2 = toPrimitive$3;

	var _Symbol$toPrimitive = /*@__PURE__*/getDefaultExportFromCjs(toPrimitive$2);

	function _toPrimitive$1(input, hint) {
	  if (_typeof$2(input) !== "object" || input === null) return input;
	  var prim = input[_Symbol$toPrimitive];
	  if (prim !== undefined) {
	    var res = prim.call(input, hint || "default");
	    if (_typeof$2(res) !== "object") return res;
	    throw new TypeError("@@toPrimitive must return a primitive value.");
	  }
	  return (hint === "string" ? String : Number)(input);
	}

	function _toPropertyKey$1(arg) {
	  var key = _toPrimitive$1(arg, "string");
	  return _typeof$2(key) === "symbol" ? key : String(key);
	}

	function _defineProperty$1(obj, key, value) {
	  key = _toPropertyKey$1(key);
	  if (key in obj) {
	    _Object$defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	  return obj;
	}

	var getBuiltInPrototypeMethod$c = getBuiltInPrototypeMethod$g;

	var concat$7 = getBuiltInPrototypeMethod$c('Array', 'concat');

	var isPrototypeOf$g = objectIsPrototypeOf$1;
	var method$a = concat$7;

	var ArrayPrototype$8 = Array.prototype;

	var concat$6 = function (it) {
	  var own = it.concat;
	  return it === ArrayPrototype$8 || (isPrototypeOf$g(ArrayPrototype$8, it) && own === ArrayPrototype$8.concat) ? method$a : own;
	};

	var parent$I = concat$6;

	var concat$5 = parent$I;

	var concat$4 = concat$5;

	var _concatInstanceProperty = /*@__PURE__*/getDefaultExportFromCjs(concat$4);

	/*!
	 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */

	function isObject$r(o) {
	  return Object.prototype.toString.call(o) === '[object Object]';
	}

	function isPlainObject$1(o) {
	  var ctor,prot;

	  if (isObject$r(o) === false) return false;

	  // If has modified constructor
	  ctor = o.constructor;
	  if (ctor === undefined) return true;

	  // If has modified prototype
	  prot = ctor.prototype;
	  if (isObject$r(prot) === false) return false;

	  // If constructor does not have an Object-specific method
	  if (prot.hasOwnProperty('isPrototypeOf') === false) {
	    return false;
	  }

	  // Most likely a plain Object
	  return true;
	}

	// src/utils/env.ts
	var NOTHING = Symbol.for("immer-nothing");
	var DRAFTABLE = Symbol.for("immer-draftable");
	var DRAFT_STATE = Symbol.for("immer-state");

	// src/utils/errors.ts
	var errors = [
	  // All error codes, starting by 0:
	  function(plugin) {
	    return `The plugin for '${plugin}' has not been loaded into Immer. To enable the plugin, import and call \`enable${plugin}()\` when initializing your application.`;
	  },
	  function(thing) {
	    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${thing}'`;
	  },
	  "This object has been frozen and should not be mutated",
	  function(data) {
	    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + data;
	  },
	  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
	  "Immer forbids circular references",
	  "The first or second argument to `produce` must be a function",
	  "The third argument to `produce` must be a function or undefined",
	  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
	  "First argument to `finishDraft` must be a draft returned by `createDraft`",
	  function(thing) {
	    return `'current' expects a draft, got: ${thing}`;
	  },
	  "Object.defineProperty() cannot be used on an Immer draft",
	  "Object.setPrototypeOf() cannot be used on an Immer draft",
	  "Immer only supports deleting array indices",
	  "Immer only supports setting array indices and the 'length' property",
	  function(thing) {
	    return `'original' expects a draft, got: ${thing}`;
	  }
	  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
	  // See Patches.ts for additional errors
	] ;
	function die(error, ...args) {
	  {
	    const e = errors[error];
	    const msg = typeof e === "function" ? e.apply(null, args) : e;
	    throw new Error(`[Immer] ${msg}`);
	  }
	}

	// src/utils/common.ts
	var getPrototypeOf$6 = Object.getPrototypeOf;
	function isDraft(value) {
	  return !!value && !!value[DRAFT_STATE];
	}
	function isDraftable(value) {
	  if (!value)
	    return false;
	  return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!value.constructor?.[DRAFTABLE] || isMap(value) || isSet(value);
	}
	var objectCtorString = Object.prototype.constructor.toString();
	function isPlainObject(value) {
	  if (!value || typeof value !== "object")
	    return false;
	  const proto = getPrototypeOf$6(value);
	  if (proto === null) {
	    return true;
	  }
	  const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
	  if (Ctor === Object)
	    return true;
	  return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString;
	}
	function each$1(obj, iter) {
	  if (getArchtype(obj) === 0 /* Object */) {
	    Object.entries(obj).forEach(([key, value]) => {
	      iter(key, value, obj);
	    });
	  } else {
	    obj.forEach((entry, index) => iter(index, entry, obj));
	  }
	}
	function getArchtype(thing) {
	  const state = thing[DRAFT_STATE];
	  return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */ : isMap(thing) ? 2 /* Map */ : isSet(thing) ? 3 /* Set */ : 0 /* Object */;
	}
	function has$1(thing, prop) {
	  return getArchtype(thing) === 2 /* Map */ ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
	}
	function set$5(thing, propOrOldValue, value) {
	  const t = getArchtype(thing);
	  if (t === 2 /* Map */)
	    thing.set(propOrOldValue, value);
	  else if (t === 3 /* Set */) {
	    thing.add(value);
	  } else
	    thing[propOrOldValue] = value;
	}
	function is$6(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	function isMap(target) {
	  return target instanceof Map;
	}
	function isSet(target) {
	  return target instanceof Set;
	}
	function latest(state) {
	  return state.copy_ || state.base_;
	}
	function shallowCopy(base, strict) {
	  if (isMap(base)) {
	    return new Map(base);
	  }
	  if (isSet(base)) {
	    return new Set(base);
	  }
	  if (Array.isArray(base))
	    return Array.prototype.slice.call(base);
	  if (!strict && isPlainObject(base)) {
	    if (!getPrototypeOf$6(base)) {
	      const obj = /* @__PURE__ */ Object.create(null);
	      return Object.assign(obj, base);
	    }
	    return { ...base };
	  }
	  const descriptors = Object.getOwnPropertyDescriptors(base);
	  delete descriptors[DRAFT_STATE];
	  let keys = Reflect.ownKeys(descriptors);
	  for (let i = 0; i < keys.length; i++) {
	    const key = keys[i];
	    const desc = descriptors[key];
	    if (desc.writable === false) {
	      desc.writable = true;
	      desc.configurable = true;
	    }
	    if (desc.get || desc.set)
	      descriptors[key] = {
	        configurable: true,
	        writable: true,
	        // could live with !!desc.set as well here...
	        enumerable: desc.enumerable,
	        value: base[key]
	      };
	  }
	  return Object.create(getPrototypeOf$6(base), descriptors);
	}
	function freeze$1(obj, deep = false) {
	  if (isFrozen$1(obj) || isDraft(obj) || !isDraftable(obj))
	    return obj;
	  if (getArchtype(obj) > 1) {
	    obj.set = obj.add = obj.clear = obj.delete = dontMutateFrozenCollections;
	  }
	  Object.freeze(obj);
	  if (deep)
	    each$1(obj, (_key, value) => freeze$1(value, true));
	  return obj;
	}
	function dontMutateFrozenCollections() {
	  die(2);
	}
	function isFrozen$1(obj) {
	  return Object.isFrozen(obj);
	}

	// src/utils/plugins.ts
	var plugins = {};
	function getPlugin(pluginKey) {
	  const plugin = plugins[pluginKey];
	  if (!plugin) {
	    die(0, pluginKey);
	  }
	  return plugin;
	}

	// src/core/scope.ts
	var currentScope;
	function getCurrentScope() {
	  return currentScope;
	}
	function createScope(parent_, immer_) {
	  return {
	    drafts_: [],
	    parent_,
	    immer_,
	    // Whenever the modified draft contains a draft from another scope, we
	    // need to prevent auto-freezing so the unowned draft can be finalized.
	    canAutoFreeze_: true,
	    unfinalizedDrafts_: 0
	  };
	}
	function usePatchesInScope(scope, patchListener) {
	  if (patchListener) {
	    getPlugin("Patches");
	    scope.patches_ = [];
	    scope.inversePatches_ = [];
	    scope.patchListener_ = patchListener;
	  }
	}
	function revokeScope(scope) {
	  leaveScope(scope);
	  scope.drafts_.forEach(revokeDraft);
	  scope.drafts_ = null;
	}
	function leaveScope(scope) {
	  if (scope === currentScope) {
	    currentScope = scope.parent_;
	  }
	}
	function enterScope(immer2) {
	  return currentScope = createScope(currentScope, immer2);
	}
	function revokeDraft(draft) {
	  const state = draft[DRAFT_STATE];
	  if (state.type_ === 0 /* Object */ || state.type_ === 1 /* Array */)
	    state.revoke_();
	  else
	    state.revoked_ = true;
	}

	// src/core/finalize.ts
	function processResult(result, scope) {
	  scope.unfinalizedDrafts_ = scope.drafts_.length;
	  const baseDraft = scope.drafts_[0];
	  const isReplaced = result !== void 0 && result !== baseDraft;
	  if (isReplaced) {
	    if (baseDraft[DRAFT_STATE].modified_) {
	      revokeScope(scope);
	      die(4);
	    }
	    if (isDraftable(result)) {
	      result = finalize(scope, result);
	      if (!scope.parent_)
	        maybeFreeze(scope, result);
	    }
	    if (scope.patches_) {
	      getPlugin("Patches").generateReplacementPatches_(
	        baseDraft[DRAFT_STATE].base_,
	        result,
	        scope.patches_,
	        scope.inversePatches_
	      );
	    }
	  } else {
	    result = finalize(scope, baseDraft, []);
	  }
	  revokeScope(scope);
	  if (scope.patches_) {
	    scope.patchListener_(scope.patches_, scope.inversePatches_);
	  }
	  return result !== NOTHING ? result : void 0;
	}
	function finalize(rootScope, value, path) {
	  if (isFrozen$1(value))
	    return value;
	  const state = value[DRAFT_STATE];
	  if (!state) {
	    each$1(
	      value,
	      (key, childValue) => finalizeProperty(rootScope, state, value, key, childValue, path));
	    return value;
	  }
	  if (state.scope_ !== rootScope)
	    return value;
	  if (!state.modified_) {
	    maybeFreeze(rootScope, state.base_, true);
	    return state.base_;
	  }
	  if (!state.finalized_) {
	    state.finalized_ = true;
	    state.scope_.unfinalizedDrafts_--;
	    const result = state.copy_;
	    let resultEach = result;
	    let isSet2 = false;
	    if (state.type_ === 3 /* Set */) {
	      resultEach = new Set(result);
	      result.clear();
	      isSet2 = true;
	    }
	    each$1(
	      resultEach,
	      (key, childValue) => finalizeProperty(rootScope, state, result, key, childValue, path, isSet2)
	    );
	    maybeFreeze(rootScope, result, false);
	    if (path && rootScope.patches_) {
	      getPlugin("Patches").generatePatches_(
	        state,
	        path,
	        rootScope.patches_,
	        rootScope.inversePatches_
	      );
	    }
	  }
	  return state.copy_;
	}
	function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
	  if (childValue === targetObject)
	    die(5);
	  if (isDraft(childValue)) {
	    const path = rootPath && parentState && parentState.type_ !== 3 /* Set */ && // Set objects are atomic since they have no keys.
	    !has$1(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
	    const res = finalize(rootScope, childValue, path);
	    set$5(targetObject, prop, res);
	    if (isDraft(res)) {
	      rootScope.canAutoFreeze_ = false;
	    } else
	      return;
	  } else if (targetIsSet) {
	    targetObject.add(childValue);
	  }
	  if (isDraftable(childValue) && !isFrozen$1(childValue)) {
	    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) {
	      return;
	    }
	    finalize(rootScope, childValue);
	    if (!parentState || !parentState.scope_.parent_)
	      maybeFreeze(rootScope, childValue);
	  }
	}
	function maybeFreeze(scope, value, deep = false) {
	  if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) {
	    freeze$1(value, deep);
	  }
	}

	// src/core/proxy.ts
	function createProxyProxy(base, parent) {
	  const isArray = Array.isArray(base);
	  const state = {
	    type_: isArray ? 1 /* Array */ : 0 /* Object */,
	    // Track which produce call this is associated with.
	    scope_: parent ? parent.scope_ : getCurrentScope(),
	    // True for both shallow and deep changes.
	    modified_: false,
	    // Used during finalization.
	    finalized_: false,
	    // Track which properties have been assigned (true) or deleted (false).
	    assigned_: {},
	    // The parent draft state.
	    parent_: parent,
	    // The base state.
	    base_: base,
	    // The base proxy.
	    draft_: null,
	    // set below
	    // The base copy with any updated values.
	    copy_: null,
	    // Called by the `produce` function.
	    revoke_: null,
	    isManual_: false
	  };
	  let target = state;
	  let traps = objectTraps;
	  if (isArray) {
	    target = [state];
	    traps = arrayTraps;
	  }
	  const { revoke, proxy } = Proxy.revocable(target, traps);
	  state.draft_ = proxy;
	  state.revoke_ = revoke;
	  return proxy;
	}
	var objectTraps = {
	  get(state, prop) {
	    if (prop === DRAFT_STATE)
	      return state;
	    const source = latest(state);
	    if (!has$1(source, prop)) {
	      return readPropFromProto(state, source, prop);
	    }
	    const value = source[prop];
	    if (state.finalized_ || !isDraftable(value)) {
	      return value;
	    }
	    if (value === peek(state.base_, prop)) {
	      prepareCopy(state);
	      return state.copy_[prop] = createProxy(value, state);
	    }
	    return value;
	  },
	  has(state, prop) {
	    return prop in latest(state);
	  },
	  ownKeys(state) {
	    return Reflect.ownKeys(latest(state));
	  },
	  set(state, prop, value) {
	    const desc = getDescriptorFromProto(latest(state), prop);
	    if (desc?.set) {
	      desc.set.call(state.draft_, value);
	      return true;
	    }
	    if (!state.modified_) {
	      const current2 = peek(latest(state), prop);
	      const currentState = current2?.[DRAFT_STATE];
	      if (currentState && currentState.base_ === value) {
	        state.copy_[prop] = value;
	        state.assigned_[prop] = false;
	        return true;
	      }
	      if (is$6(value, current2) && (value !== void 0 || has$1(state.base_, prop)))
	        return true;
	      prepareCopy(state);
	      markChanged(state);
	    }
	    if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
	    (value !== void 0 || prop in state.copy_) || // special case: NaN
	    Number.isNaN(value) && Number.isNaN(state.copy_[prop]))
	      return true;
	    state.copy_[prop] = value;
	    state.assigned_[prop] = true;
	    return true;
	  },
	  deleteProperty(state, prop) {
	    if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
	      state.assigned_[prop] = false;
	      prepareCopy(state);
	      markChanged(state);
	    } else {
	      delete state.assigned_[prop];
	    }
	    if (state.copy_) {
	      delete state.copy_[prop];
	    }
	    return true;
	  },
	  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
	  // the same guarantee in ES5 mode.
	  getOwnPropertyDescriptor(state, prop) {
	    const owner = latest(state);
	    const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
	    if (!desc)
	      return desc;
	    return {
	      writable: true,
	      configurable: state.type_ !== 1 /* Array */ || prop !== "length",
	      enumerable: desc.enumerable,
	      value: owner[prop]
	    };
	  },
	  defineProperty() {
	    die(11);
	  },
	  getPrototypeOf(state) {
	    return getPrototypeOf$6(state.base_);
	  },
	  setPrototypeOf() {
	    die(12);
	  }
	};
	var arrayTraps = {};
	each$1(objectTraps, (key, fn) => {
	  arrayTraps[key] = function() {
	    arguments[0] = arguments[0][0];
	    return fn.apply(this, arguments);
	  };
	});
	arrayTraps.deleteProperty = function(state, prop) {
	  if (isNaN(parseInt(prop)))
	    die(13);
	  return arrayTraps.set.call(this, state, prop, void 0);
	};
	arrayTraps.set = function(state, prop, value) {
	  if (prop !== "length" && isNaN(parseInt(prop)))
	    die(14);
	  return objectTraps.set.call(this, state[0], prop, value, state[0]);
	};
	function peek(draft, prop) {
	  const state = draft[DRAFT_STATE];
	  const source = state ? latest(state) : draft;
	  return source[prop];
	}
	function readPropFromProto(state, source, prop) {
	  const desc = getDescriptorFromProto(source, prop);
	  return desc ? `value` in desc ? desc.value : (
	    // This is a very special case, if the prop is a getter defined by the
	    // prototype, we should invoke it with the draft as context!
	    desc.get?.call(state.draft_)
	  ) : void 0;
	}
	function getDescriptorFromProto(source, prop) {
	  if (!(prop in source))
	    return void 0;
	  let proto = getPrototypeOf$6(source);
	  while (proto) {
	    const desc = Object.getOwnPropertyDescriptor(proto, prop);
	    if (desc)
	      return desc;
	    proto = getPrototypeOf$6(proto);
	  }
	  return void 0;
	}
	function markChanged(state) {
	  if (!state.modified_) {
	    state.modified_ = true;
	    if (state.parent_) {
	      markChanged(state.parent_);
	    }
	  }
	}
	function prepareCopy(state) {
	  if (!state.copy_) {
	    state.copy_ = shallowCopy(
	      state.base_,
	      state.scope_.immer_.useStrictShallowCopy_
	    );
	  }
	}

	// src/core/immerClass.ts
	var Immer2 = class {
	  constructor(config) {
	    this.autoFreeze_ = true;
	    this.useStrictShallowCopy_ = false;
	    /**
	     * The `produce` function takes a value and a "recipe function" (whose
	     * return value often depends on the base state). The recipe function is
	     * free to mutate its first argument however it wants. All mutations are
	     * only ever applied to a __copy__ of the base state.
	     *
	     * Pass only a function to create a "curried producer" which relieves you
	     * from passing the recipe function every time.
	     *
	     * Only plain objects and arrays are made mutable. All other objects are
	     * considered uncopyable.
	     *
	     * Note: This function is __bound__ to its `Immer` instance.
	     *
	     * @param {any} base - the initial state
	     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
	     * @param {Function} patchListener - optional function that will be called with all the patches produced here
	     * @returns {any} a new state, or the initial state if nothing was modified
	     */
	    this.produce = (base, recipe, patchListener) => {
	      if (typeof base === "function" && typeof recipe !== "function") {
	        const defaultBase = recipe;
	        recipe = base;
	        const self = this;
	        return function curriedProduce(base2 = defaultBase, ...args) {
	          return self.produce(base2, (draft) => recipe.call(this, draft, ...args));
	        };
	      }
	      if (typeof recipe !== "function")
	        die(6);
	      if (patchListener !== void 0 && typeof patchListener !== "function")
	        die(7);
	      let result;
	      if (isDraftable(base)) {
	        const scope = enterScope(this);
	        const proxy = createProxy(base, void 0);
	        let hasError = true;
	        try {
	          result = recipe(proxy);
	          hasError = false;
	        } finally {
	          if (hasError)
	            revokeScope(scope);
	          else
	            leaveScope(scope);
	        }
	        usePatchesInScope(scope, patchListener);
	        return processResult(result, scope);
	      } else if (!base || typeof base !== "object") {
	        result = recipe(base);
	        if (result === void 0)
	          result = base;
	        if (result === NOTHING)
	          result = void 0;
	        if (this.autoFreeze_)
	          freeze$1(result, true);
	        if (patchListener) {
	          const p = [];
	          const ip = [];
	          getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
	          patchListener(p, ip);
	        }
	        return result;
	      } else
	        die(1, base);
	    };
	    this.produceWithPatches = (base, recipe) => {
	      if (typeof base === "function") {
	        return (state, ...args) => this.produceWithPatches(state, (draft) => base(draft, ...args));
	      }
	      let patches, inversePatches;
	      const result = this.produce(base, recipe, (p, ip) => {
	        patches = p;
	        inversePatches = ip;
	      });
	      return [result, patches, inversePatches];
	    };
	    if (typeof config?.autoFreeze === "boolean")
	      this.setAutoFreeze(config.autoFreeze);
	    if (typeof config?.useStrictShallowCopy === "boolean")
	      this.setUseStrictShallowCopy(config.useStrictShallowCopy);
	  }
	  createDraft(base) {
	    if (!isDraftable(base))
	      die(8);
	    if (isDraft(base))
	      base = current(base);
	    const scope = enterScope(this);
	    const proxy = createProxy(base, void 0);
	    proxy[DRAFT_STATE].isManual_ = true;
	    leaveScope(scope);
	    return proxy;
	  }
	  finishDraft(draft, patchListener) {
	    const state = draft && draft[DRAFT_STATE];
	    if (!state || !state.isManual_)
	      die(9);
	    const { scope_: scope } = state;
	    usePatchesInScope(scope, patchListener);
	    return processResult(void 0, scope);
	  }
	  /**
	   * Pass true to automatically freeze all copies created by Immer.
	   *
	   * By default, auto-freezing is enabled.
	   */
	  setAutoFreeze(value) {
	    this.autoFreeze_ = value;
	  }
	  /**
	   * Pass true to enable strict shallow copy.
	   *
	   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
	   */
	  setUseStrictShallowCopy(value) {
	    this.useStrictShallowCopy_ = value;
	  }
	  applyPatches(base, patches) {
	    let i;
	    for (i = patches.length - 1; i >= 0; i--) {
	      const patch = patches[i];
	      if (patch.path.length === 0 && patch.op === "replace") {
	        base = patch.value;
	        break;
	      }
	    }
	    if (i > -1) {
	      patches = patches.slice(i + 1);
	    }
	    const applyPatchesImpl = getPlugin("Patches").applyPatches_;
	    if (isDraft(base)) {
	      return applyPatchesImpl(base, patches);
	    }
	    return this.produce(
	      base,
	      (draft) => applyPatchesImpl(draft, patches)
	    );
	  }
	};
	function createProxy(value, parent) {
	  const draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
	  const scope = parent ? parent.scope_ : getCurrentScope();
	  scope.drafts_.push(draft);
	  return draft;
	}

	// src/core/current.ts
	function current(value) {
	  if (!isDraft(value))
	    die(10, value);
	  return currentImpl(value);
	}
	function currentImpl(value) {
	  if (!isDraftable(value) || isFrozen$1(value))
	    return value;
	  const state = value[DRAFT_STATE];
	  let copy;
	  if (state) {
	    if (!state.modified_)
	      return state.base_;
	    state.finalized_ = true;
	    copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
	  } else {
	    copy = shallowCopy(value, true);
	  }
	  each$1(copy, (key, childValue) => {
	    set$5(copy, key, currentImpl(childValue));
	  });
	  if (state) {
	    state.finalized_ = false;
	  }
	  return copy;
	}

	// src/immer.ts
	var immer = new Immer2();
	var produce = immer.produce;
	immer.produceWithPatches.bind(
	  immer
	);
	immer.setAutoFreeze.bind(immer);
	immer.setUseStrictShallowCopy.bind(immer);
	immer.applyPatches.bind(immer);
	var createDraft = immer.createDraft.bind(immer);
	var finishDraft = immer.finishDraft.bind(immer);

	// eslint-disable-next-line no-redeclare
	var PathRef = {
	  transform(ref, op) {
	    var {
	      current,
	      affinity
	    } = ref;
	    if (current == null) {
	      return;
	    }
	    var path = Path.transform(current, op, {
	      affinity
	    });
	    ref.current = path;
	    if (path == null) {
	      ref.unref();
	    }
	  }
	};

	// eslint-disable-next-line no-redeclare
	var PointRef = {
	  transform(ref, op) {
	    var {
	      current,
	      affinity
	    } = ref;
	    if (current == null) {
	      return;
	    }
	    var point = Point.transform(current, op, {
	      affinity
	    });
	    ref.current = point;
	    if (point == null) {
	      ref.unref();
	    }
	  }
	};

	// eslint-disable-next-line no-redeclare
	var RangeRef = {
	  transform(ref, op) {
	    var {
	      current,
	      affinity
	    } = ref;
	    if (current == null) {
	      return;
	    }
	    var path = Range.transform(current, op, {
	      affinity
	    });
	    ref.current = path;
	    if (path == null) {
	      ref.unref();
	    }
	  }
	};

	var DIRTY_PATHS = new WeakMap();
	var DIRTY_PATH_KEYS = new WeakMap();
	var FLUSHING = new WeakMap();
	var NORMALIZING = new WeakMap();
	var PATH_REFS = new WeakMap();
	var POINT_REFS = new WeakMap();
	var RANGE_REFS = new WeakMap();

	// eslint-disable-next-line no-redeclare
	var Path = {
	  ancestors(path) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var {
	      reverse = false
	    } = options;
	    var paths = Path.levels(path, options);
	    if (reverse) {
	      paths = paths.slice(1);
	    } else {
	      paths = paths.slice(0, -1);
	    }
	    return paths;
	  },
	  common(path, another) {
	    var common = [];
	    for (var i = 0; i < path.length && i < another.length; i++) {
	      var av = path[i];
	      var bv = another[i];
	      if (av !== bv) {
	        break;
	      }
	      common.push(av);
	    }
	    return common;
	  },
	  compare(path, another) {
	    var min = Math.min(path.length, another.length);
	    for (var i = 0; i < min; i++) {
	      if (path[i] < another[i]) return -1;
	      if (path[i] > another[i]) return 1;
	    }
	    return 0;
	  },
	  endsAfter(path, another) {
	    var i = path.length - 1;
	    var as = path.slice(0, i);
	    var bs = another.slice(0, i);
	    var av = path[i];
	    var bv = another[i];
	    return Path.equals(as, bs) && av > bv;
	  },
	  endsAt(path, another) {
	    var i = path.length;
	    var as = path.slice(0, i);
	    var bs = another.slice(0, i);
	    return Path.equals(as, bs);
	  },
	  endsBefore(path, another) {
	    var i = path.length - 1;
	    var as = path.slice(0, i);
	    var bs = another.slice(0, i);
	    var av = path[i];
	    var bv = another[i];
	    return Path.equals(as, bs) && av < bv;
	  },
	  equals(path, another) {
	    return path.length === another.length && path.every((n, i) => n === another[i]);
	  },
	  hasPrevious(path) {
	    return path[path.length - 1] > 0;
	  },
	  isAfter(path, another) {
	    return Path.compare(path, another) === 1;
	  },
	  isAncestor(path, another) {
	    return path.length < another.length && Path.compare(path, another) === 0;
	  },
	  isBefore(path, another) {
	    return Path.compare(path, another) === -1;
	  },
	  isChild(path, another) {
	    return path.length === another.length + 1 && Path.compare(path, another) === 0;
	  },
	  isCommon(path, another) {
	    return path.length <= another.length && Path.compare(path, another) === 0;
	  },
	  isDescendant(path, another) {
	    return path.length > another.length && Path.compare(path, another) === 0;
	  },
	  isParent(path, another) {
	    return path.length + 1 === another.length && Path.compare(path, another) === 0;
	  },
	  isPath(value) {
	    return Array.isArray(value) && (value.length === 0 || typeof value[0] === 'number');
	  },
	  isSibling(path, another) {
	    if (path.length !== another.length) {
	      return false;
	    }
	    var as = path.slice(0, -1);
	    var bs = another.slice(0, -1);
	    var al = path[path.length - 1];
	    var bl = another[another.length - 1];
	    return al !== bl && Path.equals(as, bs);
	  },
	  levels(path) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var {
	      reverse = false
	    } = options;
	    var list = [];
	    for (var i = 0; i <= path.length; i++) {
	      list.push(path.slice(0, i));
	    }
	    if (reverse) {
	      list.reverse();
	    }
	    return list;
	  },
	  next(path) {
	    if (path.length === 0) {
	      throw new Error("Cannot get the next path of a root path [".concat(path, "], because it has no next index."));
	    }
	    var last = path[path.length - 1];
	    return path.slice(0, -1).concat(last + 1);
	  },
	  operationCanTransformPath(operation) {
	    switch (operation.type) {
	      case 'insert_node':
	      case 'remove_node':
	      case 'merge_node':
	      case 'split_node':
	      case 'move_node':
	        return true;
	      default:
	        return false;
	    }
	  },
	  parent(path) {
	    if (path.length === 0) {
	      throw new Error("Cannot get the parent path of the root path [".concat(path, "]."));
	    }
	    return path.slice(0, -1);
	  },
	  previous(path) {
	    if (path.length === 0) {
	      throw new Error("Cannot get the previous path of a root path [".concat(path, "], because it has no previous index."));
	    }
	    var last = path[path.length - 1];
	    if (last <= 0) {
	      throw new Error("Cannot get the previous path of a first child path [".concat(path, "] because it would result in a negative index."));
	    }
	    return path.slice(0, -1).concat(last - 1);
	  },
	  relative(path, ancestor) {
	    if (!Path.isAncestor(ancestor, path) && !Path.equals(path, ancestor)) {
	      throw new Error("Cannot get the relative path of [".concat(path, "] inside ancestor [").concat(ancestor, "], because it is not above or equal to the path."));
	    }
	    return path.slice(ancestor.length);
	  },
	  transform(path, operation) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    if (!path) return null;
	    // PERF: use destructing instead of immer
	    var p = [...path];
	    var {
	      affinity = 'forward'
	    } = options;
	    // PERF: Exit early if the operation is guaranteed not to have an effect.
	    if (path.length === 0) {
	      return p;
	    }
	    switch (operation.type) {
	      case 'insert_node':
	        {
	          var {
	            path: op
	          } = operation;
	          if (Path.equals(op, p) || Path.endsBefore(op, p) || Path.isAncestor(op, p)) {
	            p[op.length - 1] += 1;
	          }
	          break;
	        }
	      case 'remove_node':
	        {
	          var {
	            path: _op
	          } = operation;
	          if (Path.equals(_op, p) || Path.isAncestor(_op, p)) {
	            return null;
	          } else if (Path.endsBefore(_op, p)) {
	            p[_op.length - 1] -= 1;
	          }
	          break;
	        }
	      case 'merge_node':
	        {
	          var {
	            path: _op2,
	            position
	          } = operation;
	          if (Path.equals(_op2, p) || Path.endsBefore(_op2, p)) {
	            p[_op2.length - 1] -= 1;
	          } else if (Path.isAncestor(_op2, p)) {
	            p[_op2.length - 1] -= 1;
	            p[_op2.length] += position;
	          }
	          break;
	        }
	      case 'split_node':
	        {
	          var {
	            path: _op3,
	            position: _position
	          } = operation;
	          if (Path.equals(_op3, p)) {
	            if (affinity === 'forward') {
	              p[p.length - 1] += 1;
	            } else if (affinity === 'backward') ; else {
	              return null;
	            }
	          } else if (Path.endsBefore(_op3, p)) {
	            p[_op3.length - 1] += 1;
	          } else if (Path.isAncestor(_op3, p) && path[_op3.length] >= _position) {
	            p[_op3.length - 1] += 1;
	            p[_op3.length] -= _position;
	          }
	          break;
	        }
	      case 'move_node':
	        {
	          var {
	            path: _op4,
	            newPath: onp
	          } = operation;
	          // If the old and new path are the same, it's a no-op.
	          if (Path.equals(_op4, onp)) {
	            return p;
	          }
	          if (Path.isAncestor(_op4, p) || Path.equals(_op4, p)) {
	            var copy = onp.slice();
	            if (Path.endsBefore(_op4, onp) && _op4.length < onp.length) {
	              copy[_op4.length - 1] -= 1;
	            }
	            return copy.concat(p.slice(_op4.length));
	          } else if (Path.isSibling(_op4, onp) && (Path.isAncestor(onp, p) || Path.equals(onp, p))) {
	            if (Path.endsBefore(_op4, p)) {
	              p[_op4.length - 1] -= 1;
	            } else {
	              p[_op4.length - 1] += 1;
	            }
	          } else if (Path.endsBefore(onp, p) || Path.equals(onp, p) || Path.isAncestor(onp, p)) {
	            if (Path.endsBefore(_op4, p)) {
	              p[_op4.length - 1] -= 1;
	            }
	            p[onp.length - 1] += 1;
	          } else if (Path.endsBefore(_op4, p)) {
	            if (Path.equals(onp, p)) {
	              p[onp.length - 1] += 1;
	            }
	            p[_op4.length - 1] -= 1;
	          }
	          break;
	        }
	    }
	    return p;
	  }
	};

	function _typeof$1(o) {
	  "@babel/helpers - typeof";

	  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
	    return typeof o;
	  } : function (o) {
	    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	  }, _typeof$1(o);
	}

	function _toPrimitive(input, hint) {
	  if (_typeof$1(input) !== "object" || input === null) return input;
	  var prim = input[Symbol.toPrimitive];
	  if (prim !== undefined) {
	    var res = prim.call(input, hint || "default");
	    if (_typeof$1(res) !== "object") return res;
	    throw new TypeError("@@toPrimitive must return a primitive value.");
	  }
	  return (hint === "string" ? String : Number)(input);
	}

	function _toPropertyKey(arg) {
	  var key = _toPrimitive(arg, "string");
	  return _typeof$1(key) === "symbol" ? key : String(key);
	}

	function _defineProperty(obj, key, value) {
	  key = _toPropertyKey(key);
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	  return obj;
	}

	function ownKeys$e(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread$e(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$e(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$e(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	var applyToDraft = (editor, selection, op) => {
	  switch (op.type) {
	    case 'insert_node':
	      {
	        var {
	          path,
	          node
	        } = op;
	        var parent = Node.parent(editor, path);
	        var index = path[path.length - 1];
	        if (index > parent.children.length) {
	          throw new Error("Cannot apply an \"insert_node\" operation at path [".concat(path, "] because the destination is past the end of the node."));
	        }
	        parent.children.splice(index, 0, node);
	        if (selection) {
	          for (var [point, key] of Range.points(selection)) {
	            selection[key] = Point.transform(point, op);
	          }
	        }
	        break;
	      }
	    case 'insert_text':
	      {
	        var {
	          path: _path,
	          offset,
	          text
	        } = op;
	        if (text.length === 0) break;
	        var _node = Node.leaf(editor, _path);
	        var before = _node.text.slice(0, offset);
	        var after = _node.text.slice(offset);
	        _node.text = before + text + after;
	        if (selection) {
	          for (var [_point, _key] of Range.points(selection)) {
	            selection[_key] = Point.transform(_point, op);
	          }
	        }
	        break;
	      }
	    case 'merge_node':
	      {
	        var {
	          path: _path2
	        } = op;
	        var _node2 = Node.get(editor, _path2);
	        var prevPath = Path.previous(_path2);
	        var prev = Node.get(editor, prevPath);
	        var _parent = Node.parent(editor, _path2);
	        var _index = _path2[_path2.length - 1];
	        if (Text.isText(_node2) && Text.isText(prev)) {
	          prev.text += _node2.text;
	        } else if (!Text.isText(_node2) && !Text.isText(prev)) {
	          prev.children.push(..._node2.children);
	        } else {
	          throw new Error("Cannot apply a \"merge_node\" operation at path [".concat(_path2, "] to nodes of different interfaces: ").concat(Scrubber.stringify(_node2), " ").concat(Scrubber.stringify(prev)));
	        }
	        _parent.children.splice(_index, 1);
	        if (selection) {
	          for (var [_point2, _key2] of Range.points(selection)) {
	            selection[_key2] = Point.transform(_point2, op);
	          }
	        }
	        break;
	      }
	    case 'move_node':
	      {
	        var {
	          path: _path3,
	          newPath
	        } = op;
	        if (Path.isAncestor(_path3, newPath)) {
	          throw new Error("Cannot move a path [".concat(_path3, "] to new path [").concat(newPath, "] because the destination is inside itself."));
	        }
	        var _node3 = Node.get(editor, _path3);
	        var _parent2 = Node.parent(editor, _path3);
	        var _index2 = _path3[_path3.length - 1];
	        // This is tricky, but since the `path` and `newPath` both refer to
	        // the same snapshot in time, there's a mismatch. After either
	        // removing the original position, the second step's path can be out
	        // of date. So instead of using the `op.newPath` directly, we
	        // transform `op.path` to ascertain what the `newPath` would be after
	        // the operation was applied.
	        _parent2.children.splice(_index2, 1);
	        var truePath = Path.transform(_path3, op);
	        var newParent = Node.get(editor, Path.parent(truePath));
	        var newIndex = truePath[truePath.length - 1];
	        newParent.children.splice(newIndex, 0, _node3);
	        if (selection) {
	          for (var [_point3, _key3] of Range.points(selection)) {
	            selection[_key3] = Point.transform(_point3, op);
	          }
	        }
	        break;
	      }
	    case 'remove_node':
	      {
	        var {
	          path: _path4
	        } = op;
	        var _index3 = _path4[_path4.length - 1];
	        var _parent3 = Node.parent(editor, _path4);
	        _parent3.children.splice(_index3, 1);
	        // Transform all the points in the value, but if the point was in the
	        // node that was removed we need to update the range or remove it.
	        if (selection) {
	          for (var [_point4, _key4] of Range.points(selection)) {
	            var result = Point.transform(_point4, op);
	            if (selection != null && result != null) {
	              selection[_key4] = result;
	            } else {
	              var _prev = void 0;
	              var next = void 0;
	              for (var [n, p] of Node.texts(editor)) {
	                if (Path.compare(p, _path4) === -1) {
	                  _prev = [n, p];
	                } else {
	                  next = [n, p];
	                  break;
	                }
	              }
	              var preferNext = false;
	              if (_prev && next) {
	                if (Path.equals(next[1], _path4)) {
	                  preferNext = !Path.hasPrevious(next[1]);
	                } else {
	                  preferNext = Path.common(_prev[1], _path4).length < Path.common(next[1], _path4).length;
	                }
	              }
	              if (_prev && !preferNext) {
	                _point4.path = _prev[1];
	                _point4.offset = _prev[0].text.length;
	              } else if (next) {
	                _point4.path = next[1];
	                _point4.offset = 0;
	              } else {
	                selection = null;
	              }
	            }
	          }
	        }
	        break;
	      }
	    case 'remove_text':
	      {
	        var {
	          path: _path5,
	          offset: _offset,
	          text: _text
	        } = op;
	        if (_text.length === 0) break;
	        var _node4 = Node.leaf(editor, _path5);
	        var _before = _node4.text.slice(0, _offset);
	        var _after = _node4.text.slice(_offset + _text.length);
	        _node4.text = _before + _after;
	        if (selection) {
	          for (var [_point5, _key5] of Range.points(selection)) {
	            selection[_key5] = Point.transform(_point5, op);
	          }
	        }
	        break;
	      }
	    case 'set_node':
	      {
	        var {
	          path: _path6,
	          properties,
	          newProperties
	        } = op;
	        if (_path6.length === 0) {
	          throw new Error("Cannot set properties on the root node!");
	        }
	        var _node5 = Node.get(editor, _path6);
	        for (var _key6 in newProperties) {
	          if (_key6 === 'children' || _key6 === 'text') {
	            throw new Error("Cannot set the \"".concat(_key6, "\" property of nodes!"));
	          }
	          var value = newProperties[_key6];
	          if (value == null) {
	            delete _node5[_key6];
	          } else {
	            _node5[_key6] = value;
	          }
	        }
	        // properties that were previously defined, but are now missing, must be deleted
	        for (var _key7 in properties) {
	          if (!newProperties.hasOwnProperty(_key7)) {
	            delete _node5[_key7];
	          }
	        }
	        break;
	      }
	    case 'set_selection':
	      {
	        var {
	          newProperties: _newProperties
	        } = op;
	        if (_newProperties == null) {
	          selection = _newProperties;
	        } else {
	          if (selection == null) {
	            if (!Range.isRange(_newProperties)) {
	              throw new Error("Cannot apply an incomplete \"set_selection\" operation properties ".concat(Scrubber.stringify(_newProperties), " when there is no current selection."));
	            }
	            selection = _objectSpread$e({}, _newProperties);
	          }
	          for (var _key8 in _newProperties) {
	            var _value = _newProperties[_key8];
	            if (_value == null) {
	              if (_key8 === 'anchor' || _key8 === 'focus') {
	                throw new Error("Cannot remove the \"".concat(_key8, "\" selection property"));
	              }
	              delete selection[_key8];
	            } else {
	              selection[_key8] = _value;
	            }
	          }
	        }
	        break;
	      }
	    case 'split_node':
	      {
	        var {
	          path: _path7,
	          position,
	          properties: _properties
	        } = op;
	        if (_path7.length === 0) {
	          throw new Error("Cannot apply a \"split_node\" operation at path [".concat(_path7, "] because the root node cannot be split."));
	        }
	        var _node6 = Node.get(editor, _path7);
	        var _parent4 = Node.parent(editor, _path7);
	        var _index4 = _path7[_path7.length - 1];
	        var newNode;
	        if (Text.isText(_node6)) {
	          var _before2 = _node6.text.slice(0, position);
	          var _after2 = _node6.text.slice(position);
	          _node6.text = _before2;
	          newNode = _objectSpread$e(_objectSpread$e({}, _properties), {}, {
	            text: _after2
	          });
	        } else {
	          var _before3 = _node6.children.slice(0, position);
	          var _after3 = _node6.children.slice(position);
	          _node6.children = _before3;
	          newNode = _objectSpread$e(_objectSpread$e({}, _properties), {}, {
	            children: _after3
	          });
	        }
	        _parent4.children.splice(_index4 + 1, 0, newNode);
	        if (selection) {
	          for (var [_point6, _key9] of Range.points(selection)) {
	            selection[_key9] = Point.transform(_point6, op);
	          }
	        }
	        break;
	      }
	  }
	  return selection;
	};
	// eslint-disable-next-line no-redeclare
	var GeneralTransforms = {
	  transform(editor, op) {
	    editor.children = createDraft(editor.children);
	    var selection = editor.selection && createDraft(editor.selection);
	    try {
	      selection = applyToDraft(editor, selection, op);
	    } finally {
	      editor.children = finishDraft(editor.children);
	      if (selection) {
	        editor.selection = isDraft(selection) ? finishDraft(selection) : selection;
	      } else {
	        editor.selection = null;
	      }
	    }
	  }
	};

	// eslint-disable-next-line no-redeclare
	var NodeTransforms = {
	  insertNodes(editor, nodes, options) {
	    editor.insertNodes(nodes, options);
	  },
	  liftNodes(editor, options) {
	    editor.liftNodes(options);
	  },
	  mergeNodes(editor, options) {
	    editor.mergeNodes(options);
	  },
	  moveNodes(editor, options) {
	    editor.moveNodes(options);
	  },
	  removeNodes(editor, options) {
	    editor.removeNodes(options);
	  },
	  setNodes(editor, props, options) {
	    editor.setNodes(props, options);
	  },
	  splitNodes(editor, options) {
	    editor.splitNodes(options);
	  },
	  unsetNodes(editor, props, options) {
	    editor.unsetNodes(props, options);
	  },
	  unwrapNodes(editor, options) {
	    editor.unwrapNodes(options);
	  },
	  wrapNodes(editor, element, options) {
	    editor.wrapNodes(element, options);
	  }
	};

	// eslint-disable-next-line no-redeclare
	var SelectionTransforms = {
	  collapse(editor, options) {
	    editor.collapse(options);
	  },
	  deselect(editor) {
	    editor.deselect();
	  },
	  move(editor, options) {
	    editor.move(options);
	  },
	  select(editor, target) {
	    editor.select(target);
	  },
	  setPoint(editor, props, options) {
	    editor.setPoint(props, options);
	  },
	  setSelection(editor, props) {
	    editor.setSelection(props);
	  }
	};

	/*
	  Custom deep equal comparison for Slate nodes.

	  We don't need general purpose deep equality;
	  Slate only supports plain values, Arrays, and nested objects.
	  Complex values nested inside Arrays are not supported.

	  Slate objects are designed to be serialised, so
	  missing keys are deliberately normalised to undefined.
	 */
	var isDeepEqual = (node, another) => {
	  for (var key in node) {
	    var a = node[key];
	    var b = another[key];
	    if (isPlainObject$1(a) && isPlainObject$1(b)) {
	      if (!isDeepEqual(a, b)) return false;
	    } else if (Array.isArray(a) && Array.isArray(b)) {
	      if (a.length !== b.length) return false;
	      for (var i = 0; i < a.length; i++) {
	        if (a[i] !== b[i]) return false;
	      }
	    } else if (a !== b) {
	      return false;
	    }
	  }
	  /*
	    Deep object equality is only necessary in one direction; in the reverse direction
	    we are only looking for keys that are missing.
	    As above, undefined keys are normalised to missing.
	  */
	  for (var _key in another) {
	    if (node[_key] === undefined && another[_key] !== undefined) {
	      return false;
	    }
	  }
	  return true;
	};

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	  return target;
	}

	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = _objectWithoutPropertiesLoose(source, excluded);
	  var key, i;
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	  return target;
	}

	var _excluded$4 = ["anchor", "focus"];
	function ownKeys$d(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread$d(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$d(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$d(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	// eslint-disable-next-line no-redeclare
	var Range = {
	  edges(range) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var {
	      reverse = false
	    } = options;
	    var {
	      anchor,
	      focus
	    } = range;
	    return Range.isBackward(range) === reverse ? [anchor, focus] : [focus, anchor];
	  },
	  end(range) {
	    var [, end] = Range.edges(range);
	    return end;
	  },
	  equals(range, another) {
	    return Point.equals(range.anchor, another.anchor) && Point.equals(range.focus, another.focus);
	  },
	  includes(range, target) {
	    if (Range.isRange(target)) {
	      if (Range.includes(range, target.anchor) || Range.includes(range, target.focus)) {
	        return true;
	      }
	      var [rs, re] = Range.edges(range);
	      var [ts, te] = Range.edges(target);
	      return Point.isBefore(rs, ts) && Point.isAfter(re, te);
	    }
	    var [start, end] = Range.edges(range);
	    var isAfterStart = false;
	    var isBeforeEnd = false;
	    if (Point.isPoint(target)) {
	      isAfterStart = Point.compare(target, start) >= 0;
	      isBeforeEnd = Point.compare(target, end) <= 0;
	    } else {
	      isAfterStart = Path.compare(target, start.path) >= 0;
	      isBeforeEnd = Path.compare(target, end.path) <= 0;
	    }
	    return isAfterStart && isBeforeEnd;
	  },
	  intersection(range, another) {
	    var rest = _objectWithoutProperties(range, _excluded$4);
	    var [s1, e1] = Range.edges(range);
	    var [s2, e2] = Range.edges(another);
	    var start = Point.isBefore(s1, s2) ? s2 : s1;
	    var end = Point.isBefore(e1, e2) ? e1 : e2;
	    if (Point.isBefore(end, start)) {
	      return null;
	    } else {
	      return _objectSpread$d({
	        anchor: start,
	        focus: end
	      }, rest);
	    }
	  },
	  isBackward(range) {
	    var {
	      anchor,
	      focus
	    } = range;
	    return Point.isAfter(anchor, focus);
	  },
	  isCollapsed(range) {
	    var {
	      anchor,
	      focus
	    } = range;
	    return Point.equals(anchor, focus);
	  },
	  isExpanded(range) {
	    return !Range.isCollapsed(range);
	  },
	  isForward(range) {
	    return !Range.isBackward(range);
	  },
	  isRange(value) {
	    return isPlainObject$1(value) && Point.isPoint(value.anchor) && Point.isPoint(value.focus);
	  },
	  *points(range) {
	    yield [range.anchor, 'anchor'];
	    yield [range.focus, 'focus'];
	  },
	  start(range) {
	    var [start] = Range.edges(range);
	    return start;
	  },
	  transform(range, op) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return produce(range, r => {
	      if (r === null) {
	        return null;
	      }
	      var {
	        affinity = 'inward'
	      } = options;
	      var affinityAnchor;
	      var affinityFocus;
	      if (affinity === 'inward') {
	        // If the range is collapsed, make sure to use the same affinity to
	        // avoid the two points passing each other and expanding in the opposite
	        // direction
	        var isCollapsed = Range.isCollapsed(r);
	        if (Range.isForward(r)) {
	          affinityAnchor = 'forward';
	          affinityFocus = isCollapsed ? affinityAnchor : 'backward';
	        } else {
	          affinityAnchor = 'backward';
	          affinityFocus = isCollapsed ? affinityAnchor : 'forward';
	        }
	      } else if (affinity === 'outward') {
	        if (Range.isForward(r)) {
	          affinityAnchor = 'backward';
	          affinityFocus = 'forward';
	        } else {
	          affinityAnchor = 'forward';
	          affinityFocus = 'backward';
	        }
	      } else {
	        affinityAnchor = affinity;
	        affinityFocus = affinity;
	      }
	      var anchor = Point.transform(r.anchor, op, {
	        affinity: affinityAnchor
	      });
	      var focus = Point.transform(r.focus, op, {
	        affinity: affinityFocus
	      });
	      if (!anchor || !focus) {
	        return null;
	      }
	      r.anchor = anchor;
	      r.focus = focus;
	    });
	  }
	};

	/**
	 * Shared the function with isElementType utility
	 */
	var isElement$2 = value => {
	  return isPlainObject$1(value) && Node.isNodeList(value.children) && !Editor.isEditor(value);
	};
	// eslint-disable-next-line no-redeclare
	var Element = {
	  isAncestor(value) {
	    return isPlainObject$1(value) && Node.isNodeList(value.children);
	  },
	  isElement: isElement$2,
	  isElementList(value) {
	    return Array.isArray(value) && value.every(val => Element.isElement(val));
	  },
	  isElementProps(props) {
	    return props.children !== undefined;
	  },
	  isElementType: function isElementType(value, elementVal) {
	    var elementKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'type';
	    return isElement$2(value) && value[elementKey] === elementVal;
	  },
	  matches(element, props) {
	    for (var key in props) {
	      if (key === 'children') {
	        continue;
	      }
	      if (element[key] !== props[key]) {
	        return false;
	      }
	    }
	    return true;
	  }
	};

	var _excluded$3 = ["children"],
	  _excluded2$3 = ["text"];
	var IS_NODE_LIST_CACHE = new WeakMap();
	// eslint-disable-next-line no-redeclare
	var Node = {
	  ancestor(root, path) {
	    var node = Node.get(root, path);
	    if (Text.isText(node)) {
	      throw new Error("Cannot get the ancestor node at path [".concat(path, "] because it refers to a text node instead: ").concat(Scrubber.stringify(node)));
	    }
	    return node;
	  },
	  ancestors(root, path) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return function* () {
	      for (var p of Path.ancestors(path, options)) {
	        var n = Node.ancestor(root, p);
	        var entry = [n, p];
	        yield entry;
	      }
	    }();
	  },
	  child(root, index) {
	    if (Text.isText(root)) {
	      throw new Error("Cannot get the child of a text node: ".concat(Scrubber.stringify(root)));
	    }
	    var c = root.children[index];
	    if (c == null) {
	      throw new Error("Cannot get child at index `".concat(index, "` in node: ").concat(Scrubber.stringify(root)));
	    }
	    return c;
	  },
	  children(root, path) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return function* () {
	      var {
	        reverse = false
	      } = options;
	      var ancestor = Node.ancestor(root, path);
	      var {
	        children
	      } = ancestor;
	      var index = reverse ? children.length - 1 : 0;
	      while (reverse ? index >= 0 : index < children.length) {
	        var child = Node.child(ancestor, index);
	        var childPath = path.concat(index);
	        yield [child, childPath];
	        index = reverse ? index - 1 : index + 1;
	      }
	    }();
	  },
	  common(root, path, another) {
	    var p = Path.common(path, another);
	    var n = Node.get(root, p);
	    return [n, p];
	  },
	  descendant(root, path) {
	    var node = Node.get(root, path);
	    if (Editor.isEditor(node)) {
	      throw new Error("Cannot get the descendant node at path [".concat(path, "] because it refers to the root editor node instead: ").concat(Scrubber.stringify(node)));
	    }
	    return node;
	  },
	  descendants(root) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    return function* () {
	      for (var [node, path] of Node.nodes(root, options)) {
	        if (path.length !== 0) {
	          // NOTE: we have to coerce here because checking the path's length does
	          // guarantee that `node` is not a `Editor`, but TypeScript doesn't know.
	          yield [node, path];
	        }
	      }
	    }();
	  },
	  elements(root) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    return function* () {
	      for (var [node, path] of Node.nodes(root, options)) {
	        if (Element.isElement(node)) {
	          yield [node, path];
	        }
	      }
	    }();
	  },
	  extractProps(node) {
	    if (Element.isAncestor(node)) {
	      var properties = _objectWithoutProperties(node, _excluded$3);
	      return properties;
	    } else {
	      var properties = _objectWithoutProperties(node, _excluded2$3);
	      return properties;
	    }
	  },
	  first(root, path) {
	    var p = path.slice();
	    var n = Node.get(root, p);
	    while (n) {
	      if (Text.isText(n) || n.children.length === 0) {
	        break;
	      } else {
	        n = n.children[0];
	        p.push(0);
	      }
	    }
	    return [n, p];
	  },
	  fragment(root, range) {
	    if (Text.isText(root)) {
	      throw new Error("Cannot get a fragment starting from a root text node: ".concat(Scrubber.stringify(root)));
	    }
	    var newRoot = produce({
	      children: root.children
	    }, r => {
	      var [start, end] = Range.edges(range);
	      var nodeEntries = Node.nodes(r, {
	        reverse: true,
	        pass: _ref => {
	          var [, path] = _ref;
	          return !Range.includes(range, path);
	        }
	      });
	      for (var [, path] of nodeEntries) {
	        if (!Range.includes(range, path)) {
	          var parent = Node.parent(r, path);
	          var index = path[path.length - 1];
	          parent.children.splice(index, 1);
	        }
	        if (Path.equals(path, end.path)) {
	          var leaf = Node.leaf(r, path);
	          leaf.text = leaf.text.slice(0, end.offset);
	        }
	        if (Path.equals(path, start.path)) {
	          var _leaf = Node.leaf(r, path);
	          _leaf.text = _leaf.text.slice(start.offset);
	        }
	      }
	      if (Editor.isEditor(r)) {
	        r.selection = null;
	      }
	    });
	    return newRoot.children;
	  },
	  get(root, path) {
	    var node = root;
	    for (var i = 0; i < path.length; i++) {
	      var p = path[i];
	      if (Text.isText(node) || !node.children[p]) {
	        throw new Error("Cannot find a descendant at path [".concat(path, "] in node: ").concat(Scrubber.stringify(root)));
	      }
	      node = node.children[p];
	    }
	    return node;
	  },
	  has(root, path) {
	    var node = root;
	    for (var i = 0; i < path.length; i++) {
	      var p = path[i];
	      if (Text.isText(node) || !node.children[p]) {
	        return false;
	      }
	      node = node.children[p];
	    }
	    return true;
	  },
	  isNode(value) {
	    return Text.isText(value) || Element.isElement(value) || Editor.isEditor(value);
	  },
	  isNodeList(value) {
	    if (!Array.isArray(value)) {
	      return false;
	    }
	    var cachedResult = IS_NODE_LIST_CACHE.get(value);
	    if (cachedResult !== undefined) {
	      return cachedResult;
	    }
	    var isNodeList = value.every(val => Node.isNode(val));
	    IS_NODE_LIST_CACHE.set(value, isNodeList);
	    return isNodeList;
	  },
	  last(root, path) {
	    var p = path.slice();
	    var n = Node.get(root, p);
	    while (n) {
	      if (Text.isText(n) || n.children.length === 0) {
	        break;
	      } else {
	        var i = n.children.length - 1;
	        n = n.children[i];
	        p.push(i);
	      }
	    }
	    return [n, p];
	  },
	  leaf(root, path) {
	    var node = Node.get(root, path);
	    if (!Text.isText(node)) {
	      throw new Error("Cannot get the leaf node at path [".concat(path, "] because it refers to a non-leaf node: ").concat(Scrubber.stringify(node)));
	    }
	    return node;
	  },
	  levels(root, path) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return function* () {
	      for (var p of Path.levels(path, options)) {
	        var n = Node.get(root, p);
	        yield [n, p];
	      }
	    }();
	  },
	  matches(node, props) {
	    return Element.isElement(node) && Element.isElementProps(props) && Element.matches(node, props) || Text.isText(node) && Text.isTextProps(props) && Text.matches(node, props);
	  },
	  nodes(root) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    return function* () {
	      var {
	        pass,
	        reverse = false
	      } = options;
	      var {
	        from = [],
	        to
	      } = options;
	      var visited = new Set();
	      var p = [];
	      var n = root;
	      while (true) {
	        if (to && (reverse ? Path.isBefore(p, to) : Path.isAfter(p, to))) {
	          break;
	        }
	        if (!visited.has(n)) {
	          yield [n, p];
	        }
	        // If we're allowed to go downward and we haven't descended yet, do.
	        if (!visited.has(n) && !Text.isText(n) && n.children.length !== 0 && (pass == null || pass([n, p]) === false)) {
	          visited.add(n);
	          var nextIndex = reverse ? n.children.length - 1 : 0;
	          if (Path.isAncestor(p, from)) {
	            nextIndex = from[p.length];
	          }
	          p = p.concat(nextIndex);
	          n = Node.get(root, p);
	          continue;
	        }
	        // If we're at the root and we can't go down, we're done.
	        if (p.length === 0) {
	          break;
	        }
	        // If we're going forward...
	        if (!reverse) {
	          var newPath = Path.next(p);
	          if (Node.has(root, newPath)) {
	            p = newPath;
	            n = Node.get(root, p);
	            continue;
	          }
	        }
	        // If we're going backward...
	        if (reverse && p[p.length - 1] !== 0) {
	          var _newPath = Path.previous(p);
	          p = _newPath;
	          n = Node.get(root, p);
	          continue;
	        }
	        // Otherwise we're going upward...
	        p = Path.parent(p);
	        n = Node.get(root, p);
	        visited.add(n);
	      }
	    }();
	  },
	  parent(root, path) {
	    var parentPath = Path.parent(path);
	    var p = Node.get(root, parentPath);
	    if (Text.isText(p)) {
	      throw new Error("Cannot get the parent of path [".concat(path, "] because it does not exist in the root."));
	    }
	    return p;
	  },
	  string(node) {
	    if (Text.isText(node)) {
	      return node.text;
	    } else {
	      return node.children.map(Node.string).join('');
	    }
	  },
	  texts(root) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    return function* () {
	      for (var [node, path] of Node.nodes(root, options)) {
	        if (Text.isText(node)) {
	          yield [node, path];
	        }
	      }
	    }();
	  }
	};

	function ownKeys$c(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread$c(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$c(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$c(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	// eslint-disable-next-line no-redeclare
	var Operation = {
	  isNodeOperation(value) {
	    return Operation.isOperation(value) && value.type.endsWith('_node');
	  },
	  isOperation(value) {
	    if (!isPlainObject$1(value)) {
	      return false;
	    }
	    switch (value.type) {
	      case 'insert_node':
	        return Path.isPath(value.path) && Node.isNode(value.node);
	      case 'insert_text':
	        return typeof value.offset === 'number' && typeof value.text === 'string' && Path.isPath(value.path);
	      case 'merge_node':
	        return typeof value.position === 'number' && Path.isPath(value.path) && isPlainObject$1(value.properties);
	      case 'move_node':
	        return Path.isPath(value.path) && Path.isPath(value.newPath);
	      case 'remove_node':
	        return Path.isPath(value.path) && Node.isNode(value.node);
	      case 'remove_text':
	        return typeof value.offset === 'number' && typeof value.text === 'string' && Path.isPath(value.path);
	      case 'set_node':
	        return Path.isPath(value.path) && isPlainObject$1(value.properties) && isPlainObject$1(value.newProperties);
	      case 'set_selection':
	        return value.properties === null && Range.isRange(value.newProperties) || value.newProperties === null && Range.isRange(value.properties) || isPlainObject$1(value.properties) && isPlainObject$1(value.newProperties);
	      case 'split_node':
	        return Path.isPath(value.path) && typeof value.position === 'number' && isPlainObject$1(value.properties);
	      default:
	        return false;
	    }
	  },
	  isOperationList(value) {
	    return Array.isArray(value) && value.every(val => Operation.isOperation(val));
	  },
	  isSelectionOperation(value) {
	    return Operation.isOperation(value) && value.type.endsWith('_selection');
	  },
	  isTextOperation(value) {
	    return Operation.isOperation(value) && value.type.endsWith('_text');
	  },
	  inverse(op) {
	    switch (op.type) {
	      case 'insert_node':
	        {
	          return _objectSpread$c(_objectSpread$c({}, op), {}, {
	            type: 'remove_node'
	          });
	        }
	      case 'insert_text':
	        {
	          return _objectSpread$c(_objectSpread$c({}, op), {}, {
	            type: 'remove_text'
	          });
	        }
	      case 'merge_node':
	        {
	          return _objectSpread$c(_objectSpread$c({}, op), {}, {
	            type: 'split_node',
	            path: Path.previous(op.path)
	          });
	        }
	      case 'move_node':
	        {
	          var {
	            newPath,
	            path
	          } = op;
	          // PERF: in this case the move operation is a no-op anyways.
	          if (Path.equals(newPath, path)) {
	            return op;
	          }
	          // If the move happens completely within a single parent the path and
	          // newPath are stable with respect to each other.
	          if (Path.isSibling(path, newPath)) {
	            return _objectSpread$c(_objectSpread$c({}, op), {}, {
	              path: newPath,
	              newPath: path
	            });
	          }
	          // If the move does not happen within a single parent it is possible
	          // for the move to impact the true path to the location where the node
	          // was removed from and where it was inserted. We have to adjust for this
	          // and find the original path. We can accomplish this (only in non-sibling)
	          // moves by looking at the impact of the move operation on the node
	          // after the original move path.
	          var inversePath = Path.transform(path, op);
	          var inverseNewPath = Path.transform(Path.next(path), op);
	          return _objectSpread$c(_objectSpread$c({}, op), {}, {
	            path: inversePath,
	            newPath: inverseNewPath
	          });
	        }
	      case 'remove_node':
	        {
	          return _objectSpread$c(_objectSpread$c({}, op), {}, {
	            type: 'insert_node'
	          });
	        }
	      case 'remove_text':
	        {
	          return _objectSpread$c(_objectSpread$c({}, op), {}, {
	            type: 'insert_text'
	          });
	        }
	      case 'set_node':
	        {
	          var {
	            properties,
	            newProperties
	          } = op;
	          return _objectSpread$c(_objectSpread$c({}, op), {}, {
	            properties: newProperties,
	            newProperties: properties
	          });
	        }
	      case 'set_selection':
	        {
	          var {
	            properties: _properties,
	            newProperties: _newProperties
	          } = op;
	          if (_properties == null) {
	            return _objectSpread$c(_objectSpread$c({}, op), {}, {
	              properties: _newProperties,
	              newProperties: null
	            });
	          } else if (_newProperties == null) {
	            return _objectSpread$c(_objectSpread$c({}, op), {}, {
	              properties: null,
	              newProperties: _properties
	            });
	          } else {
	            return _objectSpread$c(_objectSpread$c({}, op), {}, {
	              properties: _newProperties,
	              newProperties: _properties
	            });
	          }
	        }
	      case 'split_node':
	        {
	          return _objectSpread$c(_objectSpread$c({}, op), {}, {
	            type: 'merge_node',
	            path: Path.next(op.path)
	          });
	        }
	    }
	  }
	};

	var IS_EDITOR_CACHE = new WeakMap();
	var isEditor = value => {
	  var cachedIsEditor = IS_EDITOR_CACHE.get(value);
	  if (cachedIsEditor !== undefined) {
	    return cachedIsEditor;
	  }
	  if (!isPlainObject$1(value)) {
	    return false;
	  }
	  var isEditor = typeof value.addMark === 'function' && typeof value.apply === 'function' && typeof value.deleteFragment === 'function' && typeof value.insertBreak === 'function' && typeof value.insertSoftBreak === 'function' && typeof value.insertFragment === 'function' && typeof value.insertNode === 'function' && typeof value.insertText === 'function' && typeof value.isElementReadOnly === 'function' && typeof value.isInline === 'function' && typeof value.isSelectable === 'function' && typeof value.isVoid === 'function' && typeof value.normalizeNode === 'function' && typeof value.onChange === 'function' && typeof value.removeMark === 'function' && typeof value.getDirtyPaths === 'function' && (value.marks === null || isPlainObject$1(value.marks)) && (value.selection === null || Range.isRange(value.selection)) && Node.isNodeList(value.children) && Operation.isOperationList(value.operations);
	  IS_EDITOR_CACHE.set(value, isEditor);
	  return isEditor;
	};

	// eslint-disable-next-line no-redeclare
	var Editor = {
	  above(editor, options) {
	    return editor.above(options);
	  },
	  addMark(editor, key, value) {
	    editor.addMark(key, value);
	  },
	  after(editor, at, options) {
	    return editor.after(at, options);
	  },
	  before(editor, at, options) {
	    return editor.before(at, options);
	  },
	  deleteBackward(editor) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var {
	      unit = 'character'
	    } = options;
	    editor.deleteBackward(unit);
	  },
	  deleteForward(editor) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var {
	      unit = 'character'
	    } = options;
	    editor.deleteForward(unit);
	  },
	  deleteFragment(editor, options) {
	    editor.deleteFragment(options);
	  },
	  edges(editor, at) {
	    return editor.edges(at);
	  },
	  elementReadOnly(editor) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    return editor.elementReadOnly(options);
	  },
	  end(editor, at) {
	    return editor.end(at);
	  },
	  first(editor, at) {
	    return editor.first(at);
	  },
	  fragment(editor, at) {
	    return editor.fragment(at);
	  },
	  hasBlocks(editor, element) {
	    return editor.hasBlocks(element);
	  },
	  hasInlines(editor, element) {
	    return editor.hasInlines(element);
	  },
	  hasPath(editor, path) {
	    return editor.hasPath(path);
	  },
	  hasTexts(editor, element) {
	    return editor.hasTexts(element);
	  },
	  insertBreak(editor) {
	    editor.insertBreak();
	  },
	  insertFragment(editor, fragment, options) {
	    editor.insertFragment(fragment, options);
	  },
	  insertNode(editor, node) {
	    editor.insertNode(node);
	  },
	  insertSoftBreak(editor) {
	    editor.insertSoftBreak();
	  },
	  insertText(editor, text) {
	    editor.insertText(text);
	  },
	  isBlock(editor, value) {
	    return editor.isBlock(value);
	  },
	  isEdge(editor, point, at) {
	    return editor.isEdge(point, at);
	  },
	  isEditor(value) {
	    return isEditor(value);
	  },
	  isElementReadOnly(editor, element) {
	    return editor.isElementReadOnly(element);
	  },
	  isEmpty(editor, element) {
	    return editor.isEmpty(element);
	  },
	  isEnd(editor, point, at) {
	    return editor.isEnd(point, at);
	  },
	  isInline(editor, value) {
	    return editor.isInline(value);
	  },
	  isNormalizing(editor) {
	    return editor.isNormalizing();
	  },
	  isSelectable(editor, value) {
	    return editor.isSelectable(value);
	  },
	  isStart(editor, point, at) {
	    return editor.isStart(point, at);
	  },
	  isVoid(editor, value) {
	    return editor.isVoid(value);
	  },
	  last(editor, at) {
	    return editor.last(at);
	  },
	  leaf(editor, at, options) {
	    return editor.leaf(at, options);
	  },
	  levels(editor, options) {
	    return editor.levels(options);
	  },
	  marks(editor) {
	    return editor.getMarks();
	  },
	  next(editor, options) {
	    return editor.next(options);
	  },
	  node(editor, at, options) {
	    return editor.node(at, options);
	  },
	  nodes(editor, options) {
	    return editor.nodes(options);
	  },
	  normalize(editor, options) {
	    editor.normalize(options);
	  },
	  parent(editor, at, options) {
	    return editor.parent(at, options);
	  },
	  path(editor, at, options) {
	    return editor.path(at, options);
	  },
	  pathRef(editor, path, options) {
	    return editor.pathRef(path, options);
	  },
	  pathRefs(editor) {
	    return editor.pathRefs();
	  },
	  point(editor, at, options) {
	    return editor.point(at, options);
	  },
	  pointRef(editor, point, options) {
	    return editor.pointRef(point, options);
	  },
	  pointRefs(editor) {
	    return editor.pointRefs();
	  },
	  positions(editor, options) {
	    return editor.positions(options);
	  },
	  previous(editor, options) {
	    return editor.previous(options);
	  },
	  range(editor, at, to) {
	    return editor.range(at, to);
	  },
	  rangeRef(editor, range, options) {
	    return editor.rangeRef(range, options);
	  },
	  rangeRefs(editor) {
	    return editor.rangeRefs();
	  },
	  removeMark(editor, key) {
	    editor.removeMark(key);
	  },
	  setNormalizing(editor, isNormalizing) {
	    editor.setNormalizing(isNormalizing);
	  },
	  start(editor, at) {
	    return editor.start(at);
	  },
	  string(editor, at, options) {
	    return editor.string(at, options);
	  },
	  unhangRange(editor, range, options) {
	    return editor.unhangRange(range, options);
	  },
	  void(editor, options) {
	    return editor.void(options);
	  },
	  withoutNormalizing(editor, fn) {
	    editor.withoutNormalizing(fn);
	  }
	};
	// eslint-disable-next-line no-redeclare
	var Span = {
	  isSpan(value) {
	    return Array.isArray(value) && value.length === 2 && value.every(Path.isPath);
	  }
	};

	function ownKeys$b(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread$b(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$b(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$b(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	// eslint-disable-next-line no-redeclare
	var Point = {
	  compare(point, another) {
	    var result = Path.compare(point.path, another.path);
	    if (result === 0) {
	      if (point.offset < another.offset) return -1;
	      if (point.offset > another.offset) return 1;
	      return 0;
	    }
	    return result;
	  },
	  isAfter(point, another) {
	    return Point.compare(point, another) === 1;
	  },
	  isBefore(point, another) {
	    return Point.compare(point, another) === -1;
	  },
	  equals(point, another) {
	    // PERF: ensure the offsets are equal first since they are cheaper to check.
	    return point.offset === another.offset && Path.equals(point.path, another.path);
	  },
	  isPoint(value) {
	    return isPlainObject$1(value) && typeof value.offset === 'number' && Path.isPath(value.path);
	  },
	  transform(point, op) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return produce(point, p => {
	      if (p === null) {
	        return null;
	      }
	      var {
	        affinity = 'forward'
	      } = options;
	      var {
	        path,
	        offset
	      } = p;
	      switch (op.type) {
	        case 'insert_node':
	        case 'move_node':
	          {
	            p.path = Path.transform(path, op, options);
	            break;
	          }
	        case 'insert_text':
	          {
	            if (Path.equals(op.path, path) && (op.offset < offset || op.offset === offset && affinity === 'forward')) {
	              p.offset += op.text.length;
	            }
	            break;
	          }
	        case 'merge_node':
	          {
	            if (Path.equals(op.path, path)) {
	              p.offset += op.position;
	            }
	            p.path = Path.transform(path, op, options);
	            break;
	          }
	        case 'remove_text':
	          {
	            if (Path.equals(op.path, path) && op.offset <= offset) {
	              p.offset -= Math.min(offset - op.offset, op.text.length);
	            }
	            break;
	          }
	        case 'remove_node':
	          {
	            if (Path.equals(op.path, path) || Path.isAncestor(op.path, path)) {
	              return null;
	            }
	            p.path = Path.transform(path, op, options);
	            break;
	          }
	        case 'split_node':
	          {
	            if (Path.equals(op.path, path)) {
	              if (op.position === offset && affinity == null) {
	                return null;
	              } else if (op.position < offset || op.position === offset && affinity === 'forward') {
	                p.offset -= op.position;
	                p.path = Path.transform(path, op, _objectSpread$b(_objectSpread$b({}, options), {}, {
	                  affinity: 'forward'
	                }));
	              }
	            } else {
	              p.path = Path.transform(path, op, options);
	            }
	            break;
	          }
	      }
	    });
	  }
	};

	var _scrubber = undefined;
	/**
	 * This interface implements a stringify() function, which is used by Slate
	 * internally when generating exceptions containing end user data. Developers
	 * using Slate may call Scrubber.setScrubber() to alter the behavior of this
	 * stringify() function.
	 *
	 * For example, to prevent the cleartext logging of 'text' fields within Nodes:
	 *
	 *    import { Scrubber } from 'slate';
	 *    Scrubber.setScrubber((key, val) => {
	 *      if (key === 'text') return '...scrubbed...'
	 *      return val
	 *    });
	 *
	 */
	// eslint-disable-next-line no-redeclare
	var Scrubber = {
	  setScrubber(scrubber) {
	    _scrubber = scrubber;
	  },
	  stringify(value) {
	    return JSON.stringify(value, _scrubber);
	  }
	};

	var _excluded$2 = ["text"],
	  _excluded2$2 = ["anchor", "focus"];
	function ownKeys$a(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread$a(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$a(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$a(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	// eslint-disable-next-line no-redeclare
	var Text = {
	  equals(text, another) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var {
	      loose = false
	    } = options;
	    function omitText(obj) {
	      var rest = _objectWithoutProperties(obj, _excluded$2);
	      return rest;
	    }
	    return isDeepEqual(loose ? omitText(text) : text, loose ? omitText(another) : another);
	  },
	  isText(value) {
	    return isPlainObject$1(value) && typeof value.text === 'string';
	  },
	  isTextList(value) {
	    return Array.isArray(value) && value.every(val => Text.isText(val));
	  },
	  isTextProps(props) {
	    return props.text !== undefined;
	  },
	  matches(text, props) {
	    for (var key in props) {
	      if (key === 'text') {
	        continue;
	      }
	      if (!text.hasOwnProperty(key) || text[key] !== props[key]) {
	        return false;
	      }
	    }
	    return true;
	  },
	  decorations(node, decorations) {
	    var leaves = [_objectSpread$a({}, node)];
	    for (var dec of decorations) {
	      var rest = _objectWithoutProperties(dec, _excluded2$2);
	      var [start, end] = Range.edges(dec);
	      var next = [];
	      var leafEnd = 0;
	      var decorationStart = start.offset;
	      var decorationEnd = end.offset;
	      for (var leaf of leaves) {
	        var {
	          length
	        } = leaf.text;
	        var leafStart = leafEnd;
	        leafEnd += length;
	        // If the range encompasses the entire leaf, add the range.
	        if (decorationStart <= leafStart && leafEnd <= decorationEnd) {
	          Object.assign(leaf, rest);
	          next.push(leaf);
	          continue;
	        }
	        // If the range expanded and match the leaf, or starts after, or ends before it, continue.
	        if (decorationStart !== decorationEnd && (decorationStart === leafEnd || decorationEnd === leafStart) || decorationStart > leafEnd || decorationEnd < leafStart || decorationEnd === leafStart && leafStart !== 0) {
	          next.push(leaf);
	          continue;
	        }
	        // Otherwise we need to split the leaf, at the start, end, or both,
	        // and add the range to the middle intersecting section. Do the end
	        // split first since we don't need to update the offset that way.
	        var middle = leaf;
	        var before = void 0;
	        var after = void 0;
	        if (decorationEnd < leafEnd) {
	          var off = decorationEnd - leafStart;
	          after = _objectSpread$a(_objectSpread$a({}, middle), {}, {
	            text: middle.text.slice(off)
	          });
	          middle = _objectSpread$a(_objectSpread$a({}, middle), {}, {
	            text: middle.text.slice(0, off)
	          });
	        }
	        if (decorationStart > leafStart) {
	          var _off = decorationStart - leafStart;
	          before = _objectSpread$a(_objectSpread$a({}, middle), {}, {
	            text: middle.text.slice(0, _off)
	          });
	          middle = _objectSpread$a(_objectSpread$a({}, middle), {}, {
	            text: middle.text.slice(_off)
	          });
	        }
	        Object.assign(middle, rest);
	        if (before) {
	          next.push(before);
	        }
	        next.push(middle);
	        if (after) {
	          next.push(after);
	        }
	      }
	      leaves = next;
	    }
	    return leaves;
	  }
	};

	/**
	 * Get the default location to insert content into the editor.
	 * By default, use the selection as the target location. But if there is
	 * no selection, insert at the end of the document since that is such a
	 * common use case when inserting from a non-selected state.
	 */
	var getDefaultInsertLocation = editor => {
	  if (editor.selection) {
	    return editor.selection;
	  } else if (editor.children.length > 0) {
	    return Editor.end(editor, []);
	  } else {
	    return [0];
	  }
	};

	var matchPath = (editor, path) => {
	  var [node] = Editor.node(editor, path);
	  return n => n === node;
	};

	// Character (grapheme cluster) boundaries are determined according to
	// the default grapheme cluster boundary specification, extended grapheme clusters variant[1].
	//
	// References:
	//
	// [1] https://www.unicode.org/reports/tr29/#Default_Grapheme_Cluster_Table
	// [2] https://www.unicode.org/Public/UCD/latest/ucd/auxiliary/GraphemeBreakProperty.txt
	// [3] https://www.unicode.org/Public/UCD/latest/ucd/auxiliary/GraphemeBreakTest.html
	// [4] https://www.unicode.org/Public/UCD/latest/ucd/auxiliary/GraphemeBreakTest.txt
	/**
	 * Get the distance to the end of the first character in a string of text.
	 */
	var getCharacterDistance = function getCharacterDistance(str) {
	  var isRTL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var isLTR = !isRTL;
	  var codepoints = isRTL ? codepointsIteratorRTL(str) : str;
	  var left = CodepointType.None;
	  var right = CodepointType.None;
	  var distance = 0;
	  // Evaluation of these conditions are deferred.
	  var gb11 = null; // Is GB11 applicable?
	  var gb12Or13 = null; // Is GB12 or GB13 applicable?
	  for (var char of codepoints) {
	    var code = char.codePointAt(0);
	    if (!code) break;
	    var type = getCodepointType(char, code);
	    [left, right] = isLTR ? [right, type] : [type, left];
	    if (intersects(left, CodepointType.ZWJ) && intersects(right, CodepointType.ExtPict)) {
	      if (isLTR) {
	        gb11 = endsWithEmojiZWJ(str.substring(0, distance));
	      } else {
	        gb11 = endsWithEmojiZWJ(str.substring(0, str.length - distance));
	      }
	      if (!gb11) break;
	    }
	    if (intersects(left, CodepointType.RI) && intersects(right, CodepointType.RI)) {
	      if (gb12Or13 !== null) {
	        gb12Or13 = !gb12Or13;
	      } else {
	        if (isLTR) {
	          gb12Or13 = true;
	        } else {
	          gb12Or13 = endsWithOddNumberOfRIs(str.substring(0, str.length - distance));
	        }
	      }
	      if (!gb12Or13) break;
	    }
	    if (left !== CodepointType.None && right !== CodepointType.None && isBoundaryPair(left, right)) {
	      break;
	    }
	    distance += char.length;
	  }
	  return distance || 1;
	};
	var SPACE = /\s/;
	var PUNCTUATION = /[\u0021-\u0023\u0025-\u002A\u002C-\u002F\u003A\u003B\u003F\u0040\u005B-\u005D\u005F\u007B\u007D\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;
	var CHAMELEON = /['\u2018\u2019]/;
	/**
	 * Get the distance to the end of the first word in a string of text.
	 */
	var getWordDistance = function getWordDistance(text) {
	  var isRTL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var dist = 0;
	  var started = false;
	  while (text.length > 0) {
	    var charDist = getCharacterDistance(text, isRTL);
	    var [char, remaining] = splitByCharacterDistance(text, charDist, isRTL);
	    if (isWordCharacter(char, remaining, isRTL)) {
	      started = true;
	      dist += charDist;
	    } else if (!started) {
	      dist += charDist;
	    } else {
	      break;
	    }
	    text = remaining;
	  }
	  return dist;
	};
	/**
	 * Split a string in two parts at a given distance starting from the end when
	 * `isRTL` is set to `true`.
	 */
	var splitByCharacterDistance = (str, dist, isRTL) => {
	  if (isRTL) {
	    var at = str.length - dist;
	    return [str.slice(at, str.length), str.slice(0, at)];
	  }
	  return [str.slice(0, dist), str.slice(dist)];
	};
	/**
	 * Check if a character is a word character. The `remaining` argument is used
	 * because sometimes you must read subsequent characters to truly determine it.
	 */
	var isWordCharacter = function isWordCharacter(char, remaining) {
	  var isRTL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	  if (SPACE.test(char)) {
	    return false;
	  }
	  // Chameleons count as word characters as long as they're in a word, so
	  // recurse to see if the next one is a word character or not.
	  if (CHAMELEON.test(char)) {
	    var charDist = getCharacterDistance(remaining, isRTL);
	    var [nextChar, nextRemaining] = splitByCharacterDistance(remaining, charDist, isRTL);
	    if (isWordCharacter(nextChar, nextRemaining, isRTL)) {
	      return true;
	    }
	  }
	  if (PUNCTUATION.test(char)) {
	    return false;
	  }
	  return true;
	};
	/**
	 * Iterate on codepoints from right to left.
	 */
	var codepointsIteratorRTL = function* codepointsIteratorRTL(str) {
	  var end = str.length - 1;
	  for (var i = 0; i < str.length; i++) {
	    var char1 = str.charAt(end - i);
	    if (isLowSurrogate(char1.charCodeAt(0))) {
	      var char2 = str.charAt(end - i - 1);
	      if (isHighSurrogate(char2.charCodeAt(0))) {
	        yield char2 + char1;
	        i++;
	        continue;
	      }
	    }
	    yield char1;
	  }
	};
	/**
	 * Is `charCode` a high surrogate.
	 *
	 * https://en.wikipedia.org/wiki/Universal_Character_Set_characters#Surrogates
	 */
	var isHighSurrogate = charCode => {
	  return charCode >= 0xd800 && charCode <= 0xdbff;
	};
	/**
	 * Is `charCode` a low surrogate.
	 *
	 * https://en.wikipedia.org/wiki/Universal_Character_Set_characters#Surrogates
	 */
	var isLowSurrogate = charCode => {
	  return charCode >= 0xdc00 && charCode <= 0xdfff;
	};
	var CodepointType;
	(function (CodepointType) {
	  CodepointType[CodepointType["None"] = 0] = "None";
	  CodepointType[CodepointType["Extend"] = 1] = "Extend";
	  CodepointType[CodepointType["ZWJ"] = 2] = "ZWJ";
	  CodepointType[CodepointType["RI"] = 4] = "RI";
	  CodepointType[CodepointType["Prepend"] = 8] = "Prepend";
	  CodepointType[CodepointType["SpacingMark"] = 16] = "SpacingMark";
	  CodepointType[CodepointType["L"] = 32] = "L";
	  CodepointType[CodepointType["V"] = 64] = "V";
	  CodepointType[CodepointType["T"] = 128] = "T";
	  CodepointType[CodepointType["LV"] = 256] = "LV";
	  CodepointType[CodepointType["LVT"] = 512] = "LVT";
	  CodepointType[CodepointType["ExtPict"] = 1024] = "ExtPict";
	  CodepointType[CodepointType["Any"] = 2048] = "Any";
	})(CodepointType || (CodepointType = {}));
	var reExtend = /^(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3C\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732\u1733\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ACE\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDEFD-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC01\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDE41\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4\uDF00\uDF01\uDF36-\uDF3A\uDF40\uDF42]|\uD80D[\uDC40\uDC47-\uDC55]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC8F\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDCEC-\uDCEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])$/;
	var rePrepend = /^(?:[\u0600-\u0605\u06DD\u070F\u0890\u0891\u08E2\u0D4E]|\uD804[\uDCBD\uDCCD\uDDC2\uDDC3]|\uD806[\uDD3F\uDD41\uDE3A\uDE84-\uDE89]|\uD807\uDD46)$/;
	var reSpacingMark = /^(?:[\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BF\u09C0\u09C7\u09C8\u09CB\u09CC\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0\u0CC1\u0CC3\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0D02\u0D03\u0D3F\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D82\u0D83\u0DD0\u0DD1\u0DD8-\u0DDE\u0DF2\u0DF3\u0E33\u0EB3\u0F3E\u0F3F\u0F7F\u1031\u103B\u103C\u1056\u1057\u1084\u1715\u1734\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A6D-\u1A72\u1B04\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF7\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BE-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC]|\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD45\uDD46\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDDCE\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB1\uDCB2\uDCB9\uDCBB\uDCBC\uDCBE\uDCC1\uDDB0\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF26]|\uD806[\uDC2C-\uDC2E\uDC38\uDD31-\uDD35\uDD37\uDD38\uDD3D\uDD40\uDD42\uDDD1-\uDDD3\uDDDC-\uDDDF\uDDE4\uDE39\uDE57\uDE58\uDE97]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4\uDD8A-\uDD8E\uDD93\uDD94\uDD96\uDEF5\uDEF6]|\uD81B[\uDF51-\uDF87\uDFF0\uDFF1]|\uD834[\uDD66\uDD6D])$/;
	var reL = /^[\u1100-\u115F\uA960-\uA97C]$/;
	var reV = /^[\u1160-\u11A7\uD7B0-\uD7C6]$/;
	var reT = /^[\u11A8-\u11FF\uD7CB-\uD7FB]$/;
	var reLV = /^[\uAC00\uAC1C\uAC38\uAC54\uAC70\uAC8C\uACA8\uACC4\uACE0\uACFC\uAD18\uAD34\uAD50\uAD6C\uAD88\uADA4\uADC0\uADDC\uADF8\uAE14\uAE30\uAE4C\uAE68\uAE84\uAEA0\uAEBC\uAED8\uAEF4\uAF10\uAF2C\uAF48\uAF64\uAF80\uAF9C\uAFB8\uAFD4\uAFF0\uB00C\uB028\uB044\uB060\uB07C\uB098\uB0B4\uB0D0\uB0EC\uB108\uB124\uB140\uB15C\uB178\uB194\uB1B0\uB1CC\uB1E8\uB204\uB220\uB23C\uB258\uB274\uB290\uB2AC\uB2C8\uB2E4\uB300\uB31C\uB338\uB354\uB370\uB38C\uB3A8\uB3C4\uB3E0\uB3FC\uB418\uB434\uB450\uB46C\uB488\uB4A4\uB4C0\uB4DC\uB4F8\uB514\uB530\uB54C\uB568\uB584\uB5A0\uB5BC\uB5D8\uB5F4\uB610\uB62C\uB648\uB664\uB680\uB69C\uB6B8\uB6D4\uB6F0\uB70C\uB728\uB744\uB760\uB77C\uB798\uB7B4\uB7D0\uB7EC\uB808\uB824\uB840\uB85C\uB878\uB894\uB8B0\uB8CC\uB8E8\uB904\uB920\uB93C\uB958\uB974\uB990\uB9AC\uB9C8\uB9E4\uBA00\uBA1C\uBA38\uBA54\uBA70\uBA8C\uBAA8\uBAC4\uBAE0\uBAFC\uBB18\uBB34\uBB50\uBB6C\uBB88\uBBA4\uBBC0\uBBDC\uBBF8\uBC14\uBC30\uBC4C\uBC68\uBC84\uBCA0\uBCBC\uBCD8\uBCF4\uBD10\uBD2C\uBD48\uBD64\uBD80\uBD9C\uBDB8\uBDD4\uBDF0\uBE0C\uBE28\uBE44\uBE60\uBE7C\uBE98\uBEB4\uBED0\uBEEC\uBF08\uBF24\uBF40\uBF5C\uBF78\uBF94\uBFB0\uBFCC\uBFE8\uC004\uC020\uC03C\uC058\uC074\uC090\uC0AC\uC0C8\uC0E4\uC100\uC11C\uC138\uC154\uC170\uC18C\uC1A8\uC1C4\uC1E0\uC1FC\uC218\uC234\uC250\uC26C\uC288\uC2A4\uC2C0\uC2DC\uC2F8\uC314\uC330\uC34C\uC368\uC384\uC3A0\uC3BC\uC3D8\uC3F4\uC410\uC42C\uC448\uC464\uC480\uC49C\uC4B8\uC4D4\uC4F0\uC50C\uC528\uC544\uC560\uC57C\uC598\uC5B4\uC5D0\uC5EC\uC608\uC624\uC640\uC65C\uC678\uC694\uC6B0\uC6CC\uC6E8\uC704\uC720\uC73C\uC758\uC774\uC790\uC7AC\uC7C8\uC7E4\uC800\uC81C\uC838\uC854\uC870\uC88C\uC8A8\uC8C4\uC8E0\uC8FC\uC918\uC934\uC950\uC96C\uC988\uC9A4\uC9C0\uC9DC\uC9F8\uCA14\uCA30\uCA4C\uCA68\uCA84\uCAA0\uCABC\uCAD8\uCAF4\uCB10\uCB2C\uCB48\uCB64\uCB80\uCB9C\uCBB8\uCBD4\uCBF0\uCC0C\uCC28\uCC44\uCC60\uCC7C\uCC98\uCCB4\uCCD0\uCCEC\uCD08\uCD24\uCD40\uCD5C\uCD78\uCD94\uCDB0\uCDCC\uCDE8\uCE04\uCE20\uCE3C\uCE58\uCE74\uCE90\uCEAC\uCEC8\uCEE4\uCF00\uCF1C\uCF38\uCF54\uCF70\uCF8C\uCFA8\uCFC4\uCFE0\uCFFC\uD018\uD034\uD050\uD06C\uD088\uD0A4\uD0C0\uD0DC\uD0F8\uD114\uD130\uD14C\uD168\uD184\uD1A0\uD1BC\uD1D8\uD1F4\uD210\uD22C\uD248\uD264\uD280\uD29C\uD2B8\uD2D4\uD2F0\uD30C\uD328\uD344\uD360\uD37C\uD398\uD3B4\uD3D0\uD3EC\uD408\uD424\uD440\uD45C\uD478\uD494\uD4B0\uD4CC\uD4E8\uD504\uD520\uD53C\uD558\uD574\uD590\uD5AC\uD5C8\uD5E4\uD600\uD61C\uD638\uD654\uD670\uD68C\uD6A8\uD6C4\uD6E0\uD6FC\uD718\uD734\uD750\uD76C\uD788]$/;
	var reLVT = /^[\uAC01-\uAC1B\uAC1D-\uAC37\uAC39-\uAC53\uAC55-\uAC6F\uAC71-\uAC8B\uAC8D-\uACA7\uACA9-\uACC3\uACC5-\uACDF\uACE1-\uACFB\uACFD-\uAD17\uAD19-\uAD33\uAD35-\uAD4F\uAD51-\uAD6B\uAD6D-\uAD87\uAD89-\uADA3\uADA5-\uADBF\uADC1-\uADDB\uADDD-\uADF7\uADF9-\uAE13\uAE15-\uAE2F\uAE31-\uAE4B\uAE4D-\uAE67\uAE69-\uAE83\uAE85-\uAE9F\uAEA1-\uAEBB\uAEBD-\uAED7\uAED9-\uAEF3\uAEF5-\uAF0F\uAF11-\uAF2B\uAF2D-\uAF47\uAF49-\uAF63\uAF65-\uAF7F\uAF81-\uAF9B\uAF9D-\uAFB7\uAFB9-\uAFD3\uAFD5-\uAFEF\uAFF1-\uB00B\uB00D-\uB027\uB029-\uB043\uB045-\uB05F\uB061-\uB07B\uB07D-\uB097\uB099-\uB0B3\uB0B5-\uB0CF\uB0D1-\uB0EB\uB0ED-\uB107\uB109-\uB123\uB125-\uB13F\uB141-\uB15B\uB15D-\uB177\uB179-\uB193\uB195-\uB1AF\uB1B1-\uB1CB\uB1CD-\uB1E7\uB1E9-\uB203\uB205-\uB21F\uB221-\uB23B\uB23D-\uB257\uB259-\uB273\uB275-\uB28F\uB291-\uB2AB\uB2AD-\uB2C7\uB2C9-\uB2E3\uB2E5-\uB2FF\uB301-\uB31B\uB31D-\uB337\uB339-\uB353\uB355-\uB36F\uB371-\uB38B\uB38D-\uB3A7\uB3A9-\uB3C3\uB3C5-\uB3DF\uB3E1-\uB3FB\uB3FD-\uB417\uB419-\uB433\uB435-\uB44F\uB451-\uB46B\uB46D-\uB487\uB489-\uB4A3\uB4A5-\uB4BF\uB4C1-\uB4DB\uB4DD-\uB4F7\uB4F9-\uB513\uB515-\uB52F\uB531-\uB54B\uB54D-\uB567\uB569-\uB583\uB585-\uB59F\uB5A1-\uB5BB\uB5BD-\uB5D7\uB5D9-\uB5F3\uB5F5-\uB60F\uB611-\uB62B\uB62D-\uB647\uB649-\uB663\uB665-\uB67F\uB681-\uB69B\uB69D-\uB6B7\uB6B9-\uB6D3\uB6D5-\uB6EF\uB6F1-\uB70B\uB70D-\uB727\uB729-\uB743\uB745-\uB75F\uB761-\uB77B\uB77D-\uB797\uB799-\uB7B3\uB7B5-\uB7CF\uB7D1-\uB7EB\uB7ED-\uB807\uB809-\uB823\uB825-\uB83F\uB841-\uB85B\uB85D-\uB877\uB879-\uB893\uB895-\uB8AF\uB8B1-\uB8CB\uB8CD-\uB8E7\uB8E9-\uB903\uB905-\uB91F\uB921-\uB93B\uB93D-\uB957\uB959-\uB973\uB975-\uB98F\uB991-\uB9AB\uB9AD-\uB9C7\uB9C9-\uB9E3\uB9E5-\uB9FF\uBA01-\uBA1B\uBA1D-\uBA37\uBA39-\uBA53\uBA55-\uBA6F\uBA71-\uBA8B\uBA8D-\uBAA7\uBAA9-\uBAC3\uBAC5-\uBADF\uBAE1-\uBAFB\uBAFD-\uBB17\uBB19-\uBB33\uBB35-\uBB4F\uBB51-\uBB6B\uBB6D-\uBB87\uBB89-\uBBA3\uBBA5-\uBBBF\uBBC1-\uBBDB\uBBDD-\uBBF7\uBBF9-\uBC13\uBC15-\uBC2F\uBC31-\uBC4B\uBC4D-\uBC67\uBC69-\uBC83\uBC85-\uBC9F\uBCA1-\uBCBB\uBCBD-\uBCD7\uBCD9-\uBCF3\uBCF5-\uBD0F\uBD11-\uBD2B\uBD2D-\uBD47\uBD49-\uBD63\uBD65-\uBD7F\uBD81-\uBD9B\uBD9D-\uBDB7\uBDB9-\uBDD3\uBDD5-\uBDEF\uBDF1-\uBE0B\uBE0D-\uBE27\uBE29-\uBE43\uBE45-\uBE5F\uBE61-\uBE7B\uBE7D-\uBE97\uBE99-\uBEB3\uBEB5-\uBECF\uBED1-\uBEEB\uBEED-\uBF07\uBF09-\uBF23\uBF25-\uBF3F\uBF41-\uBF5B\uBF5D-\uBF77\uBF79-\uBF93\uBF95-\uBFAF\uBFB1-\uBFCB\uBFCD-\uBFE7\uBFE9-\uC003\uC005-\uC01F\uC021-\uC03B\uC03D-\uC057\uC059-\uC073\uC075-\uC08F\uC091-\uC0AB\uC0AD-\uC0C7\uC0C9-\uC0E3\uC0E5-\uC0FF\uC101-\uC11B\uC11D-\uC137\uC139-\uC153\uC155-\uC16F\uC171-\uC18B\uC18D-\uC1A7\uC1A9-\uC1C3\uC1C5-\uC1DF\uC1E1-\uC1FB\uC1FD-\uC217\uC219-\uC233\uC235-\uC24F\uC251-\uC26B\uC26D-\uC287\uC289-\uC2A3\uC2A5-\uC2BF\uC2C1-\uC2DB\uC2DD-\uC2F7\uC2F9-\uC313\uC315-\uC32F\uC331-\uC34B\uC34D-\uC367\uC369-\uC383\uC385-\uC39F\uC3A1-\uC3BB\uC3BD-\uC3D7\uC3D9-\uC3F3\uC3F5-\uC40F\uC411-\uC42B\uC42D-\uC447\uC449-\uC463\uC465-\uC47F\uC481-\uC49B\uC49D-\uC4B7\uC4B9-\uC4D3\uC4D5-\uC4EF\uC4F1-\uC50B\uC50D-\uC527\uC529-\uC543\uC545-\uC55F\uC561-\uC57B\uC57D-\uC597\uC599-\uC5B3\uC5B5-\uC5CF\uC5D1-\uC5EB\uC5ED-\uC607\uC609-\uC623\uC625-\uC63F\uC641-\uC65B\uC65D-\uC677\uC679-\uC693\uC695-\uC6AF\uC6B1-\uC6CB\uC6CD-\uC6E7\uC6E9-\uC703\uC705-\uC71F\uC721-\uC73B\uC73D-\uC757\uC759-\uC773\uC775-\uC78F\uC791-\uC7AB\uC7AD-\uC7C7\uC7C9-\uC7E3\uC7E5-\uC7FF\uC801-\uC81B\uC81D-\uC837\uC839-\uC853\uC855-\uC86F\uC871-\uC88B\uC88D-\uC8A7\uC8A9-\uC8C3\uC8C5-\uC8DF\uC8E1-\uC8FB\uC8FD-\uC917\uC919-\uC933\uC935-\uC94F\uC951-\uC96B\uC96D-\uC987\uC989-\uC9A3\uC9A5-\uC9BF\uC9C1-\uC9DB\uC9DD-\uC9F7\uC9F9-\uCA13\uCA15-\uCA2F\uCA31-\uCA4B\uCA4D-\uCA67\uCA69-\uCA83\uCA85-\uCA9F\uCAA1-\uCABB\uCABD-\uCAD7\uCAD9-\uCAF3\uCAF5-\uCB0F\uCB11-\uCB2B\uCB2D-\uCB47\uCB49-\uCB63\uCB65-\uCB7F\uCB81-\uCB9B\uCB9D-\uCBB7\uCBB9-\uCBD3\uCBD5-\uCBEF\uCBF1-\uCC0B\uCC0D-\uCC27\uCC29-\uCC43\uCC45-\uCC5F\uCC61-\uCC7B\uCC7D-\uCC97\uCC99-\uCCB3\uCCB5-\uCCCF\uCCD1-\uCCEB\uCCED-\uCD07\uCD09-\uCD23\uCD25-\uCD3F\uCD41-\uCD5B\uCD5D-\uCD77\uCD79-\uCD93\uCD95-\uCDAF\uCDB1-\uCDCB\uCDCD-\uCDE7\uCDE9-\uCE03\uCE05-\uCE1F\uCE21-\uCE3B\uCE3D-\uCE57\uCE59-\uCE73\uCE75-\uCE8F\uCE91-\uCEAB\uCEAD-\uCEC7\uCEC9-\uCEE3\uCEE5-\uCEFF\uCF01-\uCF1B\uCF1D-\uCF37\uCF39-\uCF53\uCF55-\uCF6F\uCF71-\uCF8B\uCF8D-\uCFA7\uCFA9-\uCFC3\uCFC5-\uCFDF\uCFE1-\uCFFB\uCFFD-\uD017\uD019-\uD033\uD035-\uD04F\uD051-\uD06B\uD06D-\uD087\uD089-\uD0A3\uD0A5-\uD0BF\uD0C1-\uD0DB\uD0DD-\uD0F7\uD0F9-\uD113\uD115-\uD12F\uD131-\uD14B\uD14D-\uD167\uD169-\uD183\uD185-\uD19F\uD1A1-\uD1BB\uD1BD-\uD1D7\uD1D9-\uD1F3\uD1F5-\uD20F\uD211-\uD22B\uD22D-\uD247\uD249-\uD263\uD265-\uD27F\uD281-\uD29B\uD29D-\uD2B7\uD2B9-\uD2D3\uD2D5-\uD2EF\uD2F1-\uD30B\uD30D-\uD327\uD329-\uD343\uD345-\uD35F\uD361-\uD37B\uD37D-\uD397\uD399-\uD3B3\uD3B5-\uD3CF\uD3D1-\uD3EB\uD3ED-\uD407\uD409-\uD423\uD425-\uD43F\uD441-\uD45B\uD45D-\uD477\uD479-\uD493\uD495-\uD4AF\uD4B1-\uD4CB\uD4CD-\uD4E7\uD4E9-\uD503\uD505-\uD51F\uD521-\uD53B\uD53D-\uD557\uD559-\uD573\uD575-\uD58F\uD591-\uD5AB\uD5AD-\uD5C7\uD5C9-\uD5E3\uD5E5-\uD5FF\uD601-\uD61B\uD61D-\uD637\uD639-\uD653\uD655-\uD66F\uD671-\uD68B\uD68D-\uD6A7\uD6A9-\uD6C3\uD6C5-\uD6DF\uD6E1-\uD6FB\uD6FD-\uD717\uD719-\uD733\uD735-\uD74F\uD751-\uD76B\uD76D-\uD787\uD789-\uD7A3]$/;
	var reExtPict = /^(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])$/;
	var getCodepointType = (char, code) => {
	  var type = CodepointType.Any;
	  if (char.search(reExtend) !== -1) {
	    type |= CodepointType.Extend;
	  }
	  if (code === 0x200d) {
	    type |= CodepointType.ZWJ;
	  }
	  if (code >= 0x1f1e6 && code <= 0x1f1ff) {
	    type |= CodepointType.RI;
	  }
	  if (char.search(rePrepend) !== -1) {
	    type |= CodepointType.Prepend;
	  }
	  if (char.search(reSpacingMark) !== -1) {
	    type |= CodepointType.SpacingMark;
	  }
	  if (char.search(reL) !== -1) {
	    type |= CodepointType.L;
	  }
	  if (char.search(reV) !== -1) {
	    type |= CodepointType.V;
	  }
	  if (char.search(reT) !== -1) {
	    type |= CodepointType.T;
	  }
	  if (char.search(reLV) !== -1) {
	    type |= CodepointType.LV;
	  }
	  if (char.search(reLVT) !== -1) {
	    type |= CodepointType.LVT;
	  }
	  if (char.search(reExtPict) !== -1) {
	    type |= CodepointType.ExtPict;
	  }
	  return type;
	};
	function intersects(x, y) {
	  return (x & y) !== 0;
	}
	var NonBoundaryPairs = [
	// GB6
	[CodepointType.L, CodepointType.L | CodepointType.V | CodepointType.LV | CodepointType.LVT],
	// GB7
	[CodepointType.LV | CodepointType.V, CodepointType.V | CodepointType.T],
	// GB8
	[CodepointType.LVT | CodepointType.T, CodepointType.T],
	// GB9
	[CodepointType.Any, CodepointType.Extend | CodepointType.ZWJ],
	// GB9a
	[CodepointType.Any, CodepointType.SpacingMark],
	// GB9b
	[CodepointType.Prepend, CodepointType.Any],
	// GB11
	[CodepointType.ZWJ, CodepointType.ExtPict],
	// GB12 and GB13
	[CodepointType.RI, CodepointType.RI]];
	function isBoundaryPair(left, right) {
	  return NonBoundaryPairs.findIndex(r => intersects(left, r[0]) && intersects(right, r[1])) === -1;
	}
	var endingEmojiZWJ = /(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3C\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732\u1733\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ACE\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDEFD-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC01\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDE41\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4\uDF00\uDF01\uDF36-\uDF3A\uDF40\uDF42]|\uD80D[\uDC40\uDC47-\uDC55]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC8F\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDCEC-\uDCEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])*\u200D$/;
	var endsWithEmojiZWJ = str => {
	  return str.search(endingEmojiZWJ) !== -1;
	};
	var endingRIs = /(?:\uD83C[\uDDE6-\uDDFF])+$/g;
	var endsWithOddNumberOfRIs = str => {
	  var match = str.match(endingRIs);
	  if (match === null) {
	    return false;
	  } else {
	    // A RI is represented by a surrogate pair.
	    var numRIs = match[0].length / 2;
	    return numRIs % 2 === 1;
	  }
	};

	// eslint-disable-next-line no-redeclare
	var TextTransforms = {
	  delete(editor, options) {
	    editor.delete(options);
	  },
	  insertFragment(editor, fragment, options) {
	    editor.insertFragment(fragment, options);
	  },
	  insertText(editor, text) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    Editor.withoutNormalizing(editor, () => {
	      var {
	        voids = false
	      } = options;
	      var {
	        at = getDefaultInsertLocation(editor)
	      } = options;
	      if (Path.isPath(at)) {
	        at = Editor.range(editor, at);
	      }
	      if (Range.isRange(at)) {
	        if (Range.isCollapsed(at)) {
	          at = at.anchor;
	        } else {
	          var end = Range.end(at);
	          if (!voids && Editor.void(editor, {
	            at: end
	          })) {
	            return;
	          }
	          var start = Range.start(at);
	          var startRef = Editor.pointRef(editor, start);
	          var endRef = Editor.pointRef(editor, end);
	          Transforms.delete(editor, {
	            at,
	            voids
	          });
	          var startPoint = startRef.unref();
	          var endPoint = endRef.unref();
	          at = startPoint || endPoint;
	          Transforms.setSelection(editor, {
	            anchor: at,
	            focus: at
	          });
	        }
	      }
	      if (!voids && Editor.void(editor, {
	        at
	      }) || Editor.elementReadOnly(editor, {
	        at
	      })) {
	        return;
	      }
	      var {
	        path,
	        offset
	      } = at;
	      if (text.length > 0) editor.apply({
	        type: 'insert_text',
	        path,
	        offset,
	        text
	      });
	    });
	  }
	};

	function ownKeys$9$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread$9(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$9$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$9$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	var Transforms = _objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9({}, GeneralTransforms), NodeTransforms), SelectionTransforms), TextTransforms);

	var apply$7 = (editor, op) => {
	  for (var ref of Editor.pathRefs(editor)) {
	    PathRef.transform(ref, op);
	  }
	  for (var _ref of Editor.pointRefs(editor)) {
	    PointRef.transform(_ref, op);
	  }
	  for (var _ref2 of Editor.rangeRefs(editor)) {
	    RangeRef.transform(_ref2, op);
	  }
	  var oldDirtyPaths = DIRTY_PATHS.get(editor) || [];
	  var oldDirtyPathKeys = DIRTY_PATH_KEYS.get(editor) || new Set();
	  var dirtyPaths;
	  var dirtyPathKeys;
	  var add = path => {
	    if (path) {
	      var key = path.join(',');
	      if (!dirtyPathKeys.has(key)) {
	        dirtyPathKeys.add(key);
	        dirtyPaths.push(path);
	      }
	    }
	  };
	  if (Path.operationCanTransformPath(op)) {
	    dirtyPaths = [];
	    dirtyPathKeys = new Set();
	    for (var path of oldDirtyPaths) {
	      var newPath = Path.transform(path, op);
	      add(newPath);
	    }
	  } else {
	    dirtyPaths = oldDirtyPaths;
	    dirtyPathKeys = oldDirtyPathKeys;
	  }
	  var newDirtyPaths = editor.getDirtyPaths(op);
	  for (var _path of newDirtyPaths) {
	    add(_path);
	  }
	  DIRTY_PATHS.set(editor, dirtyPaths);
	  DIRTY_PATH_KEYS.set(editor, dirtyPathKeys);
	  Transforms.transform(editor, op);
	  editor.operations.push(op);
	  Editor.normalize(editor, {
	    operation: op
	  });
	  // Clear any formats applied to the cursor if the selection changes.
	  if (op.type === 'set_selection') {
	    editor.marks = null;
	  }
	  if (!FLUSHING.get(editor)) {
	    FLUSHING.set(editor, true);
	    Promise.resolve().then(() => {
	      FLUSHING.set(editor, false);
	      editor.onChange({
	        operation: op
	      });
	      editor.operations = [];
	    });
	  }
	};

	/**
	 * Get the "dirty" paths generated from an operation.
	 */
	var getDirtyPaths = (editor, op) => {
	  switch (op.type) {
	    case 'insert_text':
	    case 'remove_text':
	    case 'set_node':
	      {
	        var {
	          path
	        } = op;
	        return Path.levels(path);
	      }
	    case 'insert_node':
	      {
	        var {
	          node,
	          path: _path
	        } = op;
	        var levels = Path.levels(_path);
	        var descendants = Text.isText(node) ? [] : Array.from(Node.nodes(node), _ref => {
	          var [, p] = _ref;
	          return _path.concat(p);
	        });
	        return [...levels, ...descendants];
	      }
	    case 'merge_node':
	      {
	        var {
	          path: _path2
	        } = op;
	        var ancestors = Path.ancestors(_path2);
	        var previousPath = Path.previous(_path2);
	        return [...ancestors, previousPath];
	      }
	    case 'move_node':
	      {
	        var {
	          path: _path3,
	          newPath
	        } = op;
	        if (Path.equals(_path3, newPath)) {
	          return [];
	        }
	        var oldAncestors = [];
	        var newAncestors = [];
	        for (var ancestor of Path.ancestors(_path3)) {
	          var p = Path.transform(ancestor, op);
	          oldAncestors.push(p);
	        }
	        for (var _ancestor of Path.ancestors(newPath)) {
	          var _p = Path.transform(_ancestor, op);
	          newAncestors.push(_p);
	        }
	        var newParent = newAncestors[newAncestors.length - 1];
	        var newIndex = newPath[newPath.length - 1];
	        var resultPath = newParent.concat(newIndex);
	        return [...oldAncestors, ...newAncestors, resultPath];
	      }
	    case 'remove_node':
	      {
	        var {
	          path: _path4
	        } = op;
	        var _ancestors = Path.ancestors(_path4);
	        return [..._ancestors];
	      }
	    case 'split_node':
	      {
	        var {
	          path: _path5
	        } = op;
	        var _levels = Path.levels(_path5);
	        var nextPath = Path.next(_path5);
	        return [..._levels, nextPath];
	      }
	    default:
	      {
	        return [];
	      }
	  }
	};

	var getFragment = editor => {
	  var {
	    selection
	  } = editor;
	  if (selection) {
	    return Node.fragment(editor, selection);
	  }
	  return [];
	};

	var normalizeNode = (editor, entry) => {
	  var [node, path] = entry;
	  // There are no core normalizations for text nodes.
	  if (Text.isText(node)) {
	    return;
	  }
	  // Ensure that block and inline nodes have at least one text child.
	  if (Element.isElement(node) && node.children.length === 0) {
	    var child = {
	      text: ''
	    };
	    Transforms.insertNodes(editor, child, {
	      at: path.concat(0),
	      voids: true
	    });
	    return;
	  }
	  // Determine whether the node should have block or inline children.
	  var shouldHaveInlines = Editor.isEditor(node) ? false : Element.isElement(node) && (editor.isInline(node) || node.children.length === 0 || Text.isText(node.children[0]) || editor.isInline(node.children[0]));
	  // Since we'll be applying operations while iterating, keep track of an
	  // index that accounts for any added/removed nodes.
	  var n = 0;
	  for (var i = 0; i < node.children.length; i++, n++) {
	    var currentNode = Node.get(editor, path);
	    if (Text.isText(currentNode)) continue;
	    var _child = currentNode.children[n];
	    var prev = currentNode.children[n - 1];
	    var isLast = i === node.children.length - 1;
	    var isInlineOrText = Text.isText(_child) || Element.isElement(_child) && editor.isInline(_child);
	    // Only allow block nodes in the top-level children and parent blocks
	    // that only contain block nodes. Similarly, only allow inline nodes in
	    // other inline nodes, or parent blocks that only contain inlines and
	    // text.
	    if (isInlineOrText !== shouldHaveInlines) {
	      Transforms.removeNodes(editor, {
	        at: path.concat(n),
	        voids: true
	      });
	      n--;
	    } else if (Element.isElement(_child)) {
	      // Ensure that inline nodes are surrounded by text nodes.
	      if (editor.isInline(_child)) {
	        if (prev == null || !Text.isText(prev)) {
	          var newChild = {
	            text: ''
	          };
	          Transforms.insertNodes(editor, newChild, {
	            at: path.concat(n),
	            voids: true
	          });
	          n++;
	        } else if (isLast) {
	          var _newChild = {
	            text: ''
	          };
	          Transforms.insertNodes(editor, _newChild, {
	            at: path.concat(n + 1),
	            voids: true
	          });
	          n++;
	        }
	      }
	    } else {
	      // Merge adjacent text nodes that are empty or match.
	      if (prev != null && Text.isText(prev)) {
	        if (Text.equals(_child, prev, {
	          loose: true
	        })) {
	          Transforms.mergeNodes(editor, {
	            at: path.concat(n),
	            voids: true
	          });
	          n--;
	        } else if (prev.text === '') {
	          Transforms.removeNodes(editor, {
	            at: path.concat(n - 1),
	            voids: true
	          });
	          n--;
	        } else if (_child.text === '') {
	          Transforms.removeNodes(editor, {
	            at: path.concat(n),
	            voids: true
	          });
	          n--;
	        }
	      }
	    }
	  }
	};

	var shouldNormalize = (editor, _ref) => {
	  var {
	    iteration,
	    initialDirtyPathsLength
	  } = _ref;
	  var maxIterations = initialDirtyPathsLength * 42; // HACK: better way?
	  if (iteration > maxIterations) {
	    throw new Error("Could not completely normalize the editor after ".concat(maxIterations, " iterations! This is usually due to incorrect normalization logic that leaves a node in an invalid state."));
	  }
	  return true;
	};

	var above = function above(editor) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var {
	    voids = false,
	    mode = 'lowest',
	    at = editor.selection,
	    match
	  } = options;
	  if (!at) {
	    return;
	  }
	  var path = Editor.path(editor, at);
	  var reverse = mode === 'lowest';
	  for (var [n, p] of Editor.levels(editor, {
	    at: path,
	    voids,
	    match,
	    reverse
	  })) {
	    if (Text.isText(n)) continue;
	    if (Range.isRange(at)) {
	      if (Path.isAncestor(p, at.anchor.path) && Path.isAncestor(p, at.focus.path)) {
	        return [n, p];
	      }
	    } else {
	      if (!Path.equals(path, p)) {
	        return [n, p];
	      }
	    }
	  }
	};

	function ownKeys$8$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread$8(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$8$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$8$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	var addMark = (editor, key, value) => {
	  var {
	    selection
	  } = editor;
	  if (selection) {
	    var match = (node, path) => {
	      if (!Text.isText(node)) {
	        return false; // marks can only be applied to text
	      }

	      var [parentNode, parentPath] = Editor.parent(editor, path);
	      return !editor.isVoid(parentNode) || editor.markableVoid(parentNode);
	    };
	    var expandedSelection = Range.isExpanded(selection);
	    var markAcceptingVoidSelected = false;
	    if (!expandedSelection) {
	      var [selectedNode, selectedPath] = Editor.node(editor, selection);
	      if (selectedNode && match(selectedNode, selectedPath)) {
	        var [parentNode] = Editor.parent(editor, selectedPath);
	        markAcceptingVoidSelected = parentNode && editor.markableVoid(parentNode);
	      }
	    }
	    if (expandedSelection || markAcceptingVoidSelected) {
	      Transforms.setNodes(editor, {
	        [key]: value
	      }, {
	        match,
	        split: true,
	        voids: true
	      });
	    } else {
	      var marks = _objectSpread$8(_objectSpread$8({}, Editor.marks(editor) || {}), {}, {
	        [key]: value
	      });
	      editor.marks = marks;
	      if (!FLUSHING.get(editor)) {
	        editor.onChange();
	      }
	    }
	  }
	};

	function ownKeys$7$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread$7(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$7$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$7$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	var after = function after(editor, at) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var anchor = Editor.point(editor, at, {
	    edge: 'end'
	  });
	  var focus = Editor.end(editor, []);
	  var range = {
	    anchor,
	    focus
	  };
	  var {
	    distance = 1
	  } = options;
	  var d = 0;
	  var target;
	  for (var p of Editor.positions(editor, _objectSpread$7(_objectSpread$7({}, options), {}, {
	    at: range
	  }))) {
	    if (d > distance) {
	      break;
	    }
	    if (d !== 0) {
	      target = p;
	    }
	    d++;
	  }
	  return target;
	};

	function ownKeys$6$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread$6$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$6$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$6$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	var before = function before(editor, at) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var anchor = Editor.start(editor, []);
	  var focus = Editor.point(editor, at, {
	    edge: 'start'
	  });
	  var range = {
	    anchor,
	    focus
	  };
	  var {
	    distance = 1
	  } = options;
	  var d = 0;
	  var target;
	  for (var p of Editor.positions(editor, _objectSpread$6$1(_objectSpread$6$1({}, options), {}, {
	    at: range,
	    reverse: true
	  }))) {
	    if (d > distance) {
	      break;
	    }
	    if (d !== 0) {
	      target = p;
	    }
	    d++;
	  }
	  return target;
	};

	var deleteBackward = (editor, unit) => {
	  var {
	    selection
	  } = editor;
	  if (selection && Range.isCollapsed(selection)) {
	    Transforms.delete(editor, {
	      unit,
	      reverse: true
	    });
	  }
	};

	var deleteForward = (editor, unit) => {
	  var {
	    selection
	  } = editor;
	  if (selection && Range.isCollapsed(selection)) {
	    Transforms.delete(editor, {
	      unit
	    });
	  }
	};

	var deleteFragment = function deleteFragment(editor) {
	  var {
	    direction = 'forward'
	  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var {
	    selection
	  } = editor;
	  if (selection && Range.isExpanded(selection)) {
	    Transforms.delete(editor, {
	      reverse: direction === 'backward'
	    });
	  }
	};

	var edges = (editor, at) => {
	  return [Editor.start(editor, at), Editor.end(editor, at)];
	};

	function ownKeys$5$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread$5$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$5$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$5$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	var elementReadOnly = function elementReadOnly(editor) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return Editor.above(editor, _objectSpread$5$1(_objectSpread$5$1({}, options), {}, {
	    match: n => Element.isElement(n) && Editor.isElementReadOnly(editor, n)
	  }));
	};

	var end = (editor, at) => {
	  return Editor.point(editor, at, {
	    edge: 'end'
	  });
	};

	var first = (editor, at) => {
	  var path = Editor.path(editor, at, {
	    edge: 'start'
	  });
	  return Editor.node(editor, path);
	};

	var fragment = (editor, at) => {
	  var range = Editor.range(editor, at);
	  return Node.fragment(editor, range);
	};

	function ownKeys$4$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread$4$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$4$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	var getVoid = function getVoid(editor) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return Editor.above(editor, _objectSpread$4$1(_objectSpread$4$1({}, options), {}, {
	    match: n => Element.isElement(n) && Editor.isVoid(editor, n)
	  }));
	};

	var hasBlocks = (editor, element) => {
	  return element.children.some(n => Element.isElement(n) && Editor.isBlock(editor, n));
	};

	var hasInlines = (editor, element) => {
	  return element.children.some(n => Text.isText(n) || Editor.isInline(editor, n));
	};

	var hasPath = (editor, path) => {
	  return Node.has(editor, path);
	};

	var hasTexts = (editor, element) => {
	  return element.children.every(n => Text.isText(n));
	};

	var insertBreak = editor => {
	  Transforms.splitNodes(editor, {
	    always: true
	  });
	};

	var insertNode = (editor, node, options) => {
	  Transforms.insertNodes(editor, node, options);
	};

	var insertSoftBreak = editor => {
	  Transforms.splitNodes(editor, {
	    always: true
	  });
	};

	function ownKeys$3$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread$3$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	var insertText = function insertText(editor, text) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var {
	    selection,
	    marks
	  } = editor;
	  if (selection) {
	    if (marks) {
	      var node = _objectSpread$3$1({
	        text
	      }, marks);
	      Transforms.insertNodes(editor, node, {
	        at: options.at,
	        voids: options.voids
	      });
	    } else {
	      Transforms.insertText(editor, text, options);
	    }
	    editor.marks = null;
	  }
	};

	var isBlock = (editor, value) => {
	  return !editor.isInline(value);
	};

	var isEdge = (editor, point, at) => {
	  return Editor.isStart(editor, point, at) || Editor.isEnd(editor, point, at);
	};

	var isEmpty = (editor, element) => {
	  var {
	    children
	  } = element;
	  var [first] = children;
	  return children.length === 0 || children.length === 1 && Text.isText(first) && first.text === '' && !editor.isVoid(element);
	};

	var isEnd = (editor, point, at) => {
	  var end = Editor.end(editor, at);
	  return Point.equals(point, end);
	};

	var isNormalizing = editor => {
	  var isNormalizing = NORMALIZING.get(editor);
	  return isNormalizing === undefined ? true : isNormalizing;
	};

	var isStart = (editor, point, at) => {
	  // PERF: If the offset isn't `0` we know it's not the start.
	  if (point.offset !== 0) {
	    return false;
	  }
	  var start = Editor.start(editor, at);
	  return Point.equals(point, start);
	};

	var last = (editor, at) => {
	  var path = Editor.path(editor, at, {
	    edge: 'end'
	  });
	  return Editor.node(editor, path);
	};

	var leaf = function leaf(editor, at) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var path = Editor.path(editor, at, options);
	  var node = Node.leaf(editor, path);
	  return [node, path];
	};

	function levels(editor) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return function* () {
	    var {
	      at = editor.selection,
	      reverse = false,
	      voids = false
	    } = options;
	    var {
	      match
	    } = options;
	    if (match == null) {
	      match = () => true;
	    }
	    if (!at) {
	      return;
	    }
	    var levels = [];
	    var path = Editor.path(editor, at);
	    for (var [n, p] of Node.levels(editor, path)) {
	      if (!match(n, p)) {
	        continue;
	      }
	      levels.push([n, p]);
	      if (!voids && Element.isElement(n) && Editor.isVoid(editor, n)) {
	        break;
	      }
	    }
	    if (reverse) {
	      levels.reverse();
	    }
	    yield* levels;
	  }();
	}

	var _excluded$1 = ["text"],
	  _excluded2$1 = ["text"];
	var marks = function marks(editor) {
	  var {
	    marks,
	    selection
	  } = editor;
	  if (!selection) {
	    return null;
	  }
	  if (marks) {
	    return marks;
	  }
	  if (Range.isExpanded(selection)) {
	    var [match] = Editor.nodes(editor, {
	      match: Text.isText
	    });
	    if (match) {
	      var [_node] = match;
	      var _rest = _objectWithoutProperties(_node, _excluded$1);
	      return _rest;
	    } else {
	      return {};
	    }
	  }
	  var {
	    anchor
	  } = selection;
	  var {
	    path
	  } = anchor;
	  var [node] = Editor.leaf(editor, path);
	  if (anchor.offset === 0) {
	    var prev = Editor.previous(editor, {
	      at: path,
	      match: Text.isText
	    });
	    var markedVoid = Editor.above(editor, {
	      match: n => Element.isElement(n) && Editor.isVoid(editor, n) && editor.markableVoid(n)
	    });
	    if (!markedVoid) {
	      var block = Editor.above(editor, {
	        match: n => Element.isElement(n) && Editor.isBlock(editor, n)
	      });
	      if (prev && block) {
	        var [prevNode, prevPath] = prev;
	        var [, blockPath] = block;
	        if (Path.isAncestor(blockPath, prevPath)) {
	          node = prevNode;
	        }
	      }
	    }
	  }
	  var rest = _objectWithoutProperties(node, _excluded2$1);
	  return rest;
	};

	var next = function next(editor) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var {
	    mode = 'lowest',
	    voids = false
	  } = options;
	  var {
	    match,
	    at = editor.selection
	  } = options;
	  if (!at) {
	    return;
	  }
	  var pointAfterLocation = Editor.after(editor, at, {
	    voids
	  });
	  if (!pointAfterLocation) return;
	  var [, to] = Editor.last(editor, []);
	  var span = [pointAfterLocation.path, to];
	  if (Path.isPath(at) && at.length === 0) {
	    throw new Error("Cannot get the next node from the root node!");
	  }
	  if (match == null) {
	    if (Path.isPath(at)) {
	      var [parent] = Editor.parent(editor, at);
	      match = n => parent.children.includes(n);
	    } else {
	      match = () => true;
	    }
	  }
	  var [next] = Editor.nodes(editor, {
	    at: span,
	    match,
	    mode,
	    voids
	  });
	  return next;
	};

	var node$1 = function node(editor, at) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var path = Editor.path(editor, at, options);
	  var node = Node.get(editor, path);
	  return [node, path];
	};

	function nodes(editor) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return function* () {
	    var {
	      at = editor.selection,
	      mode = 'all',
	      universal = false,
	      reverse = false,
	      voids = false,
	      ignoreNonSelectable = false
	    } = options;
	    var {
	      match
	    } = options;
	    if (!match) {
	      match = () => true;
	    }
	    if (!at) {
	      return;
	    }
	    var from;
	    var to;
	    if (Span.isSpan(at)) {
	      from = at[0];
	      to = at[1];
	    } else {
	      var first = Editor.path(editor, at, {
	        edge: 'start'
	      });
	      var last = Editor.path(editor, at, {
	        edge: 'end'
	      });
	      from = reverse ? last : first;
	      to = reverse ? first : last;
	    }
	    var nodeEntries = Node.nodes(editor, {
	      reverse,
	      from,
	      to,
	      pass: _ref => {
	        var [node] = _ref;
	        if (!Element.isElement(node)) return false;
	        if (!voids && (Editor.isVoid(editor, node) || Editor.isElementReadOnly(editor, node))) return true;
	        if (ignoreNonSelectable && !Editor.isSelectable(editor, node)) return true;
	        return false;
	      }
	    });
	    var matches = [];
	    var hit;
	    for (var [node, path] of nodeEntries) {
	      if (ignoreNonSelectable && Element.isElement(node) && !Editor.isSelectable(editor, node)) {
	        continue;
	      }
	      var isLower = hit && Path.compare(path, hit[1]) === 0;
	      // In highest mode any node lower than the last hit is not a match.
	      if (mode === 'highest' && isLower) {
	        continue;
	      }
	      if (!match(node, path)) {
	        // If we've arrived at a leaf text node that is not lower than the last
	        // hit, then we've found a branch that doesn't include a match, which
	        // means the match is not universal.
	        if (universal && !isLower && Text.isText(node)) {
	          return;
	        } else {
	          continue;
	        }
	      }
	      // If there's a match and it's lower than the last, update the hit.
	      if (mode === 'lowest' && isLower) {
	        hit = [node, path];
	        continue;
	      }
	      // In lowest mode we emit the last hit, once it's guaranteed lowest.
	      var emit = mode === 'lowest' ? hit : [node, path];
	      if (emit) {
	        if (universal) {
	          matches.push(emit);
	        } else {
	          yield emit;
	        }
	      }
	      hit = [node, path];
	    }
	    // Since lowest is always emitting one behind, catch up at the end.
	    if (mode === 'lowest' && hit) {
	      if (universal) {
	        matches.push(hit);
	      } else {
	        yield hit;
	      }
	    }
	    // Universal defers to ensure that the match occurs in every branch, so we
	    // yield all of the matches after iterating.
	    if (universal) {
	      yield* matches;
	    }
	  }();
	}

	var normalize$1 = function normalize(editor) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var {
	    force = false,
	    operation
	  } = options;
	  var getDirtyPaths = editor => {
	    return DIRTY_PATHS.get(editor) || [];
	  };
	  var getDirtyPathKeys = editor => {
	    return DIRTY_PATH_KEYS.get(editor) || new Set();
	  };
	  var popDirtyPath = editor => {
	    var path = getDirtyPaths(editor).pop();
	    var key = path.join(',');
	    getDirtyPathKeys(editor).delete(key);
	    return path;
	  };
	  if (!Editor.isNormalizing(editor)) {
	    return;
	  }
	  if (force) {
	    var allPaths = Array.from(Node.nodes(editor), _ref => {
	      var [, p] = _ref;
	      return p;
	    });
	    var allPathKeys = new Set(allPaths.map(p => p.join(',')));
	    DIRTY_PATHS.set(editor, allPaths);
	    DIRTY_PATH_KEYS.set(editor, allPathKeys);
	  }
	  if (getDirtyPaths(editor).length === 0) {
	    return;
	  }
	  Editor.withoutNormalizing(editor, () => {
	    /*
	      Fix dirty elements with no children.
	      editor.normalizeNode() does fix this, but some normalization fixes also require it to work.
	      Running an initial pass avoids the catch-22 race condition.
	    */
	    for (var dirtyPath of getDirtyPaths(editor)) {
	      if (Node.has(editor, dirtyPath)) {
	        var entry = Editor.node(editor, dirtyPath);
	        var [node, _] = entry;
	        /*
	          The default normalizer inserts an empty text node in this scenario, but it can be customised.
	          So there is some risk here.
	                   As long as the normalizer only inserts child nodes for this case it is safe to do in any order;
	          by definition adding children to an empty node can't cause other paths to change.
	        */
	        if (Element.isElement(node) && node.children.length === 0) {
	          editor.normalizeNode(entry, {
	            operation
	          });
	        }
	      }
	    }
	    var dirtyPaths = getDirtyPaths(editor);
	    var initialDirtyPathsLength = dirtyPaths.length;
	    var iteration = 0;
	    while (dirtyPaths.length !== 0) {
	      if (!editor.shouldNormalize({
	        dirtyPaths,
	        iteration,
	        initialDirtyPathsLength,
	        operation
	      })) {
	        return;
	      }
	      var _dirtyPath = popDirtyPath(editor);
	      // If the node doesn't exist in the tree, it does not need to be normalized.
	      if (Node.has(editor, _dirtyPath)) {
	        var _entry = Editor.node(editor, _dirtyPath);
	        editor.normalizeNode(_entry, {
	          operation
	        });
	      }
	      iteration++;
	      dirtyPaths = getDirtyPaths(editor);
	    }
	  });
	};

	var parent$H = function parent(editor, at) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var path = Editor.path(editor, at, options);
	  var parentPath = Path.parent(path);
	  var entry = Editor.node(editor, parentPath);
	  return entry;
	};

	var pathRef = function pathRef(editor, path) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var {
	    affinity = 'forward'
	  } = options;
	  var ref = {
	    current: path,
	    affinity,
	    unref() {
	      var {
	        current
	      } = ref;
	      var pathRefs = Editor.pathRefs(editor);
	      pathRefs.delete(ref);
	      ref.current = null;
	      return current;
	    }
	  };
	  var refs = Editor.pathRefs(editor);
	  refs.add(ref);
	  return ref;
	};

	var pathRefs = editor => {
	  var refs = PATH_REFS.get(editor);
	  if (!refs) {
	    refs = new Set();
	    PATH_REFS.set(editor, refs);
	  }
	  return refs;
	};

	var path$c = function path(editor, at) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var {
	    depth,
	    edge
	  } = options;
	  if (Path.isPath(at)) {
	    if (edge === 'start') {
	      var [, firstPath] = Node.first(editor, at);
	      at = firstPath;
	    } else if (edge === 'end') {
	      var [, lastPath] = Node.last(editor, at);
	      at = lastPath;
	    }
	  }
	  if (Range.isRange(at)) {
	    if (edge === 'start') {
	      at = Range.start(at);
	    } else if (edge === 'end') {
	      at = Range.end(at);
	    } else {
	      at = Path.common(at.anchor.path, at.focus.path);
	    }
	  }
	  if (Point.isPoint(at)) {
	    at = at.path;
	  }
	  if (depth != null) {
	    at = at.slice(0, depth);
	  }
	  return at;
	};

	var pointRef = function pointRef(editor, point) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var {
	    affinity = 'forward'
	  } = options;
	  var ref = {
	    current: point,
	    affinity,
	    unref() {
	      var {
	        current
	      } = ref;
	      var pointRefs = Editor.pointRefs(editor);
	      pointRefs.delete(ref);
	      ref.current = null;
	      return current;
	    }
	  };
	  var refs = Editor.pointRefs(editor);
	  refs.add(ref);
	  return ref;
	};

	var pointRefs = editor => {
	  var refs = POINT_REFS.get(editor);
	  if (!refs) {
	    refs = new Set();
	    POINT_REFS.set(editor, refs);
	  }
	  return refs;
	};

	var point = function point(editor, at) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var {
	    edge = 'start'
	  } = options;
	  if (Path.isPath(at)) {
	    var path;
	    if (edge === 'end') {
	      var [, lastPath] = Node.last(editor, at);
	      path = lastPath;
	    } else {
	      var [, firstPath] = Node.first(editor, at);
	      path = firstPath;
	    }
	    var node = Node.get(editor, path);
	    if (!Text.isText(node)) {
	      throw new Error("Cannot get the ".concat(edge, " point in the node at path [").concat(at, "] because it has no ").concat(edge, " text node."));
	    }
	    return {
	      path,
	      offset: edge === 'end' ? node.text.length : 0
	    };
	  }
	  if (Range.isRange(at)) {
	    var [start, end] = Range.edges(at);
	    return edge === 'start' ? start : end;
	  }
	  return at;
	};

	function positions(editor) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return function* () {
	    var {
	      at = editor.selection,
	      unit = 'offset',
	      reverse = false,
	      voids = false,
	      ignoreNonSelectable = false
	    } = options;
	    if (!at) {
	      return;
	    }
	    /**
	     * Algorithm notes:
	     *
	     * Each step `distance` is dynamic depending on the underlying text
	     * and the `unit` specified.  Each step, e.g., a line or word, may
	     * span multiple text nodes, so we iterate through the text both on
	     * two levels in step-sync:
	     *
	     * `leafText` stores the text on a text leaf level, and is advanced
	     * through using the counters `leafTextOffset` and `leafTextRemaining`.
	     *
	     * `blockText` stores the text on a block level, and is shortened
	     * by `distance` every time it is advanced.
	     *
	     * We only maintain a window of one blockText and one leafText because
	     * a block node always appears before all of its leaf nodes.
	     */
	    var range = Editor.range(editor, at);
	    var [start, end] = Range.edges(range);
	    var first = reverse ? end : start;
	    var isNewBlock = false;
	    var blockText = '';
	    var distance = 0; // Distance for leafText to catch up to blockText.
	    var leafTextRemaining = 0;
	    var leafTextOffset = 0;
	    // Iterate through all nodes in range, grabbing entire textual content
	    // of block nodes in blockText, and text nodes in leafText.
	    // Exploits the fact that nodes are sequenced in such a way that we first
	    // encounter the block node, then all of its text nodes, so when iterating
	    // through the blockText and leafText we just need to remember a window of
	    // one block node and leaf node, respectively.
	    for (var [node, path] of Editor.nodes(editor, {
	      at,
	      reverse,
	      voids,
	      ignoreNonSelectable
	    })) {
	      /*
	       * ELEMENT NODE - Yield position(s) for voids, collect blockText for blocks
	       */
	      if (Element.isElement(node)) {
	        // Void nodes are a special case, so by default we will always
	        // yield their first point. If the `voids` option is set to true,
	        // then we will iterate over their content.
	        if (!voids && (editor.isVoid(node) || editor.isElementReadOnly(node))) {
	          yield Editor.start(editor, path);
	          continue;
	        }
	        // Inline element nodes are ignored as they don't themselves
	        // contribute to `blockText` or `leafText` - their parent and
	        // children do.
	        if (editor.isInline(node)) continue;
	        // Block element node - set `blockText` to its text content.
	        if (Editor.hasInlines(editor, node)) {
	          // We always exhaust block nodes before encountering a new one:
	          //   console.assert(blockText === '',
	          //     `blockText='${blockText}' - `+
	          //     `not exhausted before new block node`, path)
	          // Ensure range considered is capped to `range`, in the
	          // start/end edge cases where block extends beyond range.
	          // Equivalent to this, but presumably more performant:
	          //   blockRange = Editor.range(editor, ...Editor.edges(editor, path))
	          //   blockRange = Range.intersection(range, blockRange) // intersect
	          //   blockText = Editor.string(editor, blockRange, { voids })
	          var e = Path.isAncestor(path, end.path) ? end : Editor.end(editor, path);
	          var s = Path.isAncestor(path, start.path) ? start : Editor.start(editor, path);
	          blockText = Editor.string(editor, {
	            anchor: s,
	            focus: e
	          }, {
	            voids
	          });
	          isNewBlock = true;
	        }
	      }
	      /*
	       * TEXT LEAF NODE - Iterate through text content, yielding
	       * positions every `distance` offset according to `unit`.
	       */
	      if (Text.isText(node)) {
	        var isFirst = Path.equals(path, first.path);
	        // Proof that we always exhaust text nodes before encountering a new one:
	        //   console.assert(leafTextRemaining <= 0,
	        //     `leafTextRemaining=${leafTextRemaining} - `+
	        //     `not exhausted before new leaf text node`, path)
	        // Reset `leafText` counters for new text node.
	        if (isFirst) {
	          leafTextRemaining = reverse ? first.offset : node.text.length - first.offset;
	          leafTextOffset = first.offset; // Works for reverse too.
	        } else {
	          leafTextRemaining = node.text.length;
	          leafTextOffset = reverse ? leafTextRemaining : 0;
	        }
	        // Yield position at the start of node (potentially).
	        if (isFirst || isNewBlock || unit === 'offset') {
	          yield {
	            path,
	            offset: leafTextOffset
	          };
	          isNewBlock = false;
	        }
	        // Yield positions every (dynamically calculated) `distance` offset.
	        while (true) {
	          // If `leafText` has caught up with `blockText` (distance=0),
	          // and if blockText is exhausted, break to get another block node,
	          // otherwise advance blockText forward by the new `distance`.
	          if (distance === 0) {
	            if (blockText === '') break;
	            distance = calcDistance(blockText, unit, reverse);
	            // Split the string at the previously found distance and use the
	            // remaining string for the next iteration.
	            blockText = splitByCharacterDistance(blockText, distance, reverse)[1];
	          }
	          // Advance `leafText` by the current `distance`.
	          leafTextOffset = reverse ? leafTextOffset - distance : leafTextOffset + distance;
	          leafTextRemaining = leafTextRemaining - distance;
	          // If `leafText` is exhausted, break to get a new leaf node
	          // and set distance to the overflow amount, so we'll (maybe)
	          // catch up to blockText in the next leaf text node.
	          if (leafTextRemaining < 0) {
	            distance = -leafTextRemaining;
	            break;
	          }
	          // Successfully walked `distance` offsets through `leafText`
	          // to catch up with `blockText`, so we can reset `distance`
	          // and yield this position in this node.
	          distance = 0;
	          yield {
	            path,
	            offset: leafTextOffset
	          };
	        }
	      }
	    }
	    // Proof that upon completion, we've exahusted both leaf and block text:
	    //   console.assert(leafTextRemaining <= 0, "leafText wasn't exhausted")
	    //   console.assert(blockText === '', "blockText wasn't exhausted")
	    // Helper:
	    // Return the distance in offsets for a step of size `unit` on given string.
	    function calcDistance(text, unit, reverse) {
	      if (unit === 'character') {
	        return getCharacterDistance(text, reverse);
	      } else if (unit === 'word') {
	        return getWordDistance(text, reverse);
	      } else if (unit === 'line' || unit === 'block') {
	        return text.length;
	      }
	      return 1;
	    }
	  }();
	}

	var previous = function previous(editor) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var {
	    mode = 'lowest',
	    voids = false
	  } = options;
	  var {
	    match,
	    at = editor.selection
	  } = options;
	  if (!at) {
	    return;
	  }
	  var pointBeforeLocation = Editor.before(editor, at, {
	    voids
	  });
	  if (!pointBeforeLocation) {
	    return;
	  }
	  var [, to] = Editor.first(editor, []);
	  // The search location is from the start of the document to the path of
	  // the point before the location passed in
	  var span = [pointBeforeLocation.path, to];
	  if (Path.isPath(at) && at.length === 0) {
	    throw new Error("Cannot get the previous node from the root node!");
	  }
	  if (match == null) {
	    if (Path.isPath(at)) {
	      var [parent] = Editor.parent(editor, at);
	      match = n => parent.children.includes(n);
	    } else {
	      match = () => true;
	    }
	  }
	  var [previous] = Editor.nodes(editor, {
	    reverse: true,
	    at: span,
	    match,
	    mode,
	    voids
	  });
	  return previous;
	};

	var rangeRef = function rangeRef(editor, range) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var {
	    affinity = 'forward'
	  } = options;
	  var ref = {
	    current: range,
	    affinity,
	    unref() {
	      var {
	        current
	      } = ref;
	      var rangeRefs = Editor.rangeRefs(editor);
	      rangeRefs.delete(ref);
	      ref.current = null;
	      return current;
	    }
	  };
	  var refs = Editor.rangeRefs(editor);
	  refs.add(ref);
	  return ref;
	};

	var rangeRefs = editor => {
	  var refs = RANGE_REFS.get(editor);
	  if (!refs) {
	    refs = new Set();
	    RANGE_REFS.set(editor, refs);
	  }
	  return refs;
	};

	var range = (editor, at, to) => {
	  if (Range.isRange(at) && !to) {
	    return at;
	  }
	  var start = Editor.start(editor, at);
	  var end = Editor.end(editor, to || at);
	  return {
	    anchor: start,
	    focus: end
	  };
	};

	function ownKeys$2$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread$2$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	var removeMark = (editor, key) => {
	  var {
	    selection
	  } = editor;
	  if (selection) {
	    var match = (node, path) => {
	      if (!Text.isText(node)) {
	        return false; // marks can only be applied to text
	      }

	      var [parentNode, parentPath] = Editor.parent(editor, path);
	      return !editor.isVoid(parentNode) || editor.markableVoid(parentNode);
	    };
	    var expandedSelection = Range.isExpanded(selection);
	    var markAcceptingVoidSelected = false;
	    if (!expandedSelection) {
	      var [selectedNode, selectedPath] = Editor.node(editor, selection);
	      if (selectedNode && match(selectedNode, selectedPath)) {
	        var [parentNode] = Editor.parent(editor, selectedPath);
	        markAcceptingVoidSelected = parentNode && editor.markableVoid(parentNode);
	      }
	    }
	    if (expandedSelection || markAcceptingVoidSelected) {
	      Transforms.unsetNodes(editor, key, {
	        match,
	        split: true,
	        voids: true
	      });
	    } else {
	      var marks = _objectSpread$2$1({}, Editor.marks(editor) || {});
	      delete marks[key];
	      editor.marks = marks;
	      if (!FLUSHING.get(editor)) {
	        editor.onChange();
	      }
	    }
	  }
	};

	var setNormalizing = (editor, isNormalizing) => {
	  NORMALIZING.set(editor, isNormalizing);
	};

	var start = (editor, at) => {
	  return Editor.point(editor, at, {
	    edge: 'start'
	  });
	};

	var string = function string(editor, at) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var {
	    voids = false
	  } = options;
	  var range = Editor.range(editor, at);
	  var [start, end] = Range.edges(range);
	  var text = '';
	  for (var [node, path] of Editor.nodes(editor, {
	    at: range,
	    match: Text.isText,
	    voids
	  })) {
	    var t = node.text;
	    if (Path.equals(path, end.path)) {
	      t = t.slice(0, end.offset);
	    }
	    if (Path.equals(path, start.path)) {
	      t = t.slice(start.offset);
	    }
	    text += t;
	  }
	  return text;
	};

	var unhangRange = function unhangRange(editor, range) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var {
	    voids = false
	  } = options;
	  var [start, end] = Range.edges(range);
	  // PERF: exit early if we can guarantee that the range isn't hanging.
	  if (start.offset !== 0 || end.offset !== 0 || Range.isCollapsed(range) || Path.hasPrevious(end.path)) {
	    return range;
	  }
	  var endBlock = Editor.above(editor, {
	    at: end,
	    match: n => Element.isElement(n) && Editor.isBlock(editor, n),
	    voids
	  });
	  var blockPath = endBlock ? endBlock[1] : [];
	  var first = Editor.start(editor, start);
	  var before = {
	    anchor: first,
	    focus: end
	  };
	  var skip = true;
	  for (var [node, path] of Editor.nodes(editor, {
	    at: before,
	    match: Text.isText,
	    reverse: true,
	    voids
	  })) {
	    if (skip) {
	      skip = false;
	      continue;
	    }
	    if (node.text !== '' || Path.isBefore(path, blockPath)) {
	      end = {
	        path,
	        offset: node.text.length
	      };
	      break;
	    }
	  }
	  return {
	    anchor: start,
	    focus: end
	  };
	};

	var withoutNormalizing = (editor, fn) => {
	  var value = Editor.isNormalizing(editor);
	  Editor.setNormalizing(editor, false);
	  try {
	    fn();
	  } finally {
	    Editor.setNormalizing(editor, value);
	  }
	  Editor.normalize(editor);
	};

	var deleteText = function deleteText(editor) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  Editor.withoutNormalizing(editor, () => {
	    var _Editor$void, _Editor$void2;
	    var {
	      reverse = false,
	      unit = 'character',
	      distance = 1,
	      voids = false
	    } = options;
	    var {
	      at = editor.selection,
	      hanging = false
	    } = options;
	    if (!at) {
	      return;
	    }
	    var isCollapsed = false;
	    if (Range.isRange(at) && Range.isCollapsed(at)) {
	      isCollapsed = true;
	      at = at.anchor;
	    }
	    if (Point.isPoint(at)) {
	      var furthestVoid = Editor.void(editor, {
	        at,
	        mode: 'highest'
	      });
	      if (!voids && furthestVoid) {
	        var [, voidPath] = furthestVoid;
	        at = voidPath;
	      } else {
	        var opts = {
	          unit,
	          distance
	        };
	        var target = reverse ? Editor.before(editor, at, opts) || Editor.start(editor, []) : Editor.after(editor, at, opts) || Editor.end(editor, []);
	        at = {
	          anchor: at,
	          focus: target
	        };
	        hanging = true;
	      }
	    }
	    if (Path.isPath(at)) {
	      Transforms.removeNodes(editor, {
	        at,
	        voids
	      });
	      return;
	    }
	    if (Range.isCollapsed(at)) {
	      return;
	    }
	    if (!hanging) {
	      var [, _end] = Range.edges(at);
	      var endOfDoc = Editor.end(editor, []);
	      if (!Point.equals(_end, endOfDoc)) {
	        at = Editor.unhangRange(editor, at, {
	          voids
	        });
	      }
	    }
	    var [start, end] = Range.edges(at);
	    var startBlock = Editor.above(editor, {
	      match: n => Element.isElement(n) && Editor.isBlock(editor, n),
	      at: start,
	      voids
	    });
	    var endBlock = Editor.above(editor, {
	      match: n => Element.isElement(n) && Editor.isBlock(editor, n),
	      at: end,
	      voids
	    });
	    var isAcrossBlocks = startBlock && endBlock && !Path.equals(startBlock[1], endBlock[1]);
	    var isSingleText = Path.equals(start.path, end.path);
	    var startNonEditable = voids ? null : (_Editor$void = Editor.void(editor, {
	      at: start,
	      mode: 'highest'
	    })) !== null && _Editor$void !== void 0 ? _Editor$void : Editor.elementReadOnly(editor, {
	      at: start,
	      mode: 'highest'
	    });
	    var endNonEditable = voids ? null : (_Editor$void2 = Editor.void(editor, {
	      at: end,
	      mode: 'highest'
	    })) !== null && _Editor$void2 !== void 0 ? _Editor$void2 : Editor.elementReadOnly(editor, {
	      at: end,
	      mode: 'highest'
	    });
	    // If the start or end points are inside an inline void, nudge them out.
	    if (startNonEditable) {
	      var before = Editor.before(editor, start);
	      if (before && startBlock && Path.isAncestor(startBlock[1], before.path)) {
	        start = before;
	      }
	    }
	    if (endNonEditable) {
	      var after = Editor.after(editor, end);
	      if (after && endBlock && Path.isAncestor(endBlock[1], after.path)) {
	        end = after;
	      }
	    }
	    // Get the highest nodes that are completely inside the range, as well as
	    // the start and end nodes.
	    var matches = [];
	    var lastPath;
	    for (var entry of Editor.nodes(editor, {
	      at,
	      voids
	    })) {
	      var [node, path] = entry;
	      if (lastPath && Path.compare(path, lastPath) === 0) {
	        continue;
	      }
	      if (!voids && Element.isElement(node) && (Editor.isVoid(editor, node) || Editor.isElementReadOnly(editor, node)) || !Path.isCommon(path, start.path) && !Path.isCommon(path, end.path)) {
	        matches.push(entry);
	        lastPath = path;
	      }
	    }
	    var pathRefs = Array.from(matches, _ref => {
	      var [, p] = _ref;
	      return Editor.pathRef(editor, p);
	    });
	    var startRef = Editor.pointRef(editor, start);
	    var endRef = Editor.pointRef(editor, end);
	    var removedText = '';
	    if (!isSingleText && !startNonEditable) {
	      var _point = startRef.current;
	      var [_node] = Editor.leaf(editor, _point);
	      var {
	        path: _path
	      } = _point;
	      var {
	        offset
	      } = start;
	      var text = _node.text.slice(offset);
	      if (text.length > 0) {
	        editor.apply({
	          type: 'remove_text',
	          path: _path,
	          offset,
	          text
	        });
	        removedText = text;
	      }
	    }
	    pathRefs.reverse().map(r => r.unref()).filter(r => r !== null).forEach(p => Transforms.removeNodes(editor, {
	      at: p,
	      voids
	    }));
	    if (!endNonEditable) {
	      var _point2 = endRef.current;
	      var [_node2] = Editor.leaf(editor, _point2);
	      var {
	        path: _path2
	      } = _point2;
	      var _offset = isSingleText ? start.offset : 0;
	      var _text = _node2.text.slice(_offset, end.offset);
	      if (_text.length > 0) {
	        editor.apply({
	          type: 'remove_text',
	          path: _path2,
	          offset: _offset,
	          text: _text
	        });
	        removedText = _text;
	      }
	    }
	    if (!isSingleText && isAcrossBlocks && endRef.current && startRef.current) {
	      Transforms.mergeNodes(editor, {
	        at: endRef.current,
	        hanging: true,
	        voids
	      });
	    }
	    // For Thai script, deleting N character(s) backward should delete
	    // N code point(s) instead of an entire grapheme cluster.
	    // Therefore, the remaining code points should be inserted back.
	    if (isCollapsed && reverse && unit === 'character' && removedText.length > 1 && removedText.match(/[\u0E00-\u0E7F]+/)) {
	      Transforms.insertText(editor, removedText.slice(0, removedText.length - distance));
	    }
	    var startUnref = startRef.unref();
	    var endUnref = endRef.unref();
	    var point = reverse ? startUnref || endUnref : endUnref || startUnref;
	    if (options.at == null && point) {
	      Transforms.select(editor, point);
	    }
	  });
	};

	var insertFragment = function insertFragment(editor, fragment) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  Editor.withoutNormalizing(editor, () => {
	    var {
	      hanging = false,
	      voids = false
	    } = options;
	    var {
	      at = getDefaultInsertLocation(editor)
	    } = options;
	    if (!fragment.length) {
	      return;
	    }
	    if (Range.isRange(at)) {
	      if (!hanging) {
	        at = Editor.unhangRange(editor, at, {
	          voids
	        });
	      }
	      if (Range.isCollapsed(at)) {
	        at = at.anchor;
	      } else {
	        var [, end] = Range.edges(at);
	        if (!voids && Editor.void(editor, {
	          at: end
	        })) {
	          return;
	        }
	        var pointRef = Editor.pointRef(editor, end);
	        Transforms.delete(editor, {
	          at
	        });
	        at = pointRef.unref();
	      }
	    } else if (Path.isPath(at)) {
	      at = Editor.start(editor, at);
	    }
	    if (!voids && Editor.void(editor, {
	      at
	    })) {
	      return;
	    }
	    // If the insert point is at the edge of an inline node, move it outside
	    // instead since it will need to be split otherwise.
	    var inlineElementMatch = Editor.above(editor, {
	      at,
	      match: n => Element.isElement(n) && Editor.isInline(editor, n),
	      mode: 'highest',
	      voids
	    });
	    if (inlineElementMatch) {
	      var [, _inlinePath] = inlineElementMatch;
	      if (Editor.isEnd(editor, at, _inlinePath)) {
	        var after = Editor.after(editor, _inlinePath);
	        at = after;
	      } else if (Editor.isStart(editor, at, _inlinePath)) {
	        var before = Editor.before(editor, _inlinePath);
	        at = before;
	      }
	    }
	    var blockMatch = Editor.above(editor, {
	      match: n => Element.isElement(n) && Editor.isBlock(editor, n),
	      at,
	      voids
	    });
	    var [, blockPath] = blockMatch;
	    var isBlockStart = Editor.isStart(editor, at, blockPath);
	    var isBlockEnd = Editor.isEnd(editor, at, blockPath);
	    var isBlockEmpty = isBlockStart && isBlockEnd;
	    var mergeStart = !isBlockStart || isBlockStart && isBlockEnd;
	    var mergeEnd = !isBlockEnd;
	    var [, firstPath] = Node.first({
	      children: fragment
	    }, []);
	    var [, lastPath] = Node.last({
	      children: fragment
	    }, []);
	    var matches = [];
	    var matcher = _ref => {
	      var [n, p] = _ref;
	      var isRoot = p.length === 0;
	      if (isRoot) {
	        return false;
	      }
	      if (isBlockEmpty) {
	        return true;
	      }
	      if (mergeStart && Path.isAncestor(p, firstPath) && Element.isElement(n) && !editor.isVoid(n) && !editor.isInline(n)) {
	        return false;
	      }
	      if (mergeEnd && Path.isAncestor(p, lastPath) && Element.isElement(n) && !editor.isVoid(n) && !editor.isInline(n)) {
	        return false;
	      }
	      return true;
	    };
	    for (var entry of Node.nodes({
	      children: fragment
	    }, {
	      pass: matcher
	    })) {
	      if (matcher(entry)) {
	        matches.push(entry);
	      }
	    }
	    var starts = [];
	    var middles = [];
	    var ends = [];
	    var starting = true;
	    var hasBlocks = false;
	    for (var [node] of matches) {
	      if (Element.isElement(node) && !editor.isInline(node)) {
	        starting = false;
	        hasBlocks = true;
	        middles.push(node);
	      } else if (starting) {
	        starts.push(node);
	      } else {
	        ends.push(node);
	      }
	    }
	    var [inlineMatch] = Editor.nodes(editor, {
	      at,
	      match: n => Text.isText(n) || Editor.isInline(editor, n),
	      mode: 'highest',
	      voids
	    });
	    var [, inlinePath] = inlineMatch;
	    var isInlineStart = Editor.isStart(editor, at, inlinePath);
	    var isInlineEnd = Editor.isEnd(editor, at, inlinePath);
	    var middleRef = Editor.pathRef(editor, isBlockEnd && !ends.length ? Path.next(blockPath) : blockPath);
	    var endRef = Editor.pathRef(editor, isInlineEnd ? Path.next(inlinePath) : inlinePath);
	    Transforms.splitNodes(editor, {
	      at,
	      match: n => hasBlocks ? Element.isElement(n) && Editor.isBlock(editor, n) : Text.isText(n) || Editor.isInline(editor, n),
	      mode: hasBlocks ? 'lowest' : 'highest',
	      always: hasBlocks && (!isBlockStart || starts.length > 0) && (!isBlockEnd || ends.length > 0),
	      voids
	    });
	    var startRef = Editor.pathRef(editor, !isInlineStart || isInlineStart && isInlineEnd ? Path.next(inlinePath) : inlinePath);
	    Transforms.insertNodes(editor, starts, {
	      at: startRef.current,
	      match: n => Text.isText(n) || Editor.isInline(editor, n),
	      mode: 'highest',
	      voids
	    });
	    if (isBlockEmpty && !starts.length && middles.length && !ends.length) {
	      Transforms.delete(editor, {
	        at: blockPath,
	        voids
	      });
	    }
	    Transforms.insertNodes(editor, middles, {
	      at: middleRef.current,
	      match: n => Element.isElement(n) && Editor.isBlock(editor, n),
	      mode: 'lowest',
	      voids
	    });
	    Transforms.insertNodes(editor, ends, {
	      at: endRef.current,
	      match: n => Text.isText(n) || Editor.isInline(editor, n),
	      mode: 'highest',
	      voids
	    });
	    if (!options.at) {
	      var path;
	      if (ends.length > 0 && endRef.current) {
	        path = Path.previous(endRef.current);
	      } else if (middles.length > 0 && middleRef.current) {
	        path = Path.previous(middleRef.current);
	      } else if (startRef.current) {
	        path = Path.previous(startRef.current);
	      }
	      if (path) {
	        var _end = Editor.end(editor, path);
	        Transforms.select(editor, _end);
	      }
	    }
	    startRef.unref();
	    middleRef.unref();
	    endRef.unref();
	  });
	};

	var collapse = function collapse(editor) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var {
	    edge = 'anchor'
	  } = options;
	  var {
	    selection
	  } = editor;
	  if (!selection) {
	    return;
	  } else if (edge === 'anchor') {
	    Transforms.select(editor, selection.anchor);
	  } else if (edge === 'focus') {
	    Transforms.select(editor, selection.focus);
	  } else if (edge === 'start') {
	    var [start] = Range.edges(selection);
	    Transforms.select(editor, start);
	  } else if (edge === 'end') {
	    var [, end] = Range.edges(selection);
	    Transforms.select(editor, end);
	  }
	};

	var deselect = editor => {
	  var {
	    selection
	  } = editor;
	  if (selection) {
	    editor.apply({
	      type: 'set_selection',
	      properties: selection,
	      newProperties: null
	    });
	  }
	};

	var move = function move(editor) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var {
	    selection
	  } = editor;
	  var {
	    distance = 1,
	    unit = 'character',
	    reverse = false
	  } = options;
	  var {
	    edge = null
	  } = options;
	  if (!selection) {
	    return;
	  }
	  if (edge === 'start') {
	    edge = Range.isBackward(selection) ? 'focus' : 'anchor';
	  }
	  if (edge === 'end') {
	    edge = Range.isBackward(selection) ? 'anchor' : 'focus';
	  }
	  var {
	    anchor,
	    focus
	  } = selection;
	  var opts = {
	    distance,
	    unit,
	    ignoreNonSelectable: true
	  };
	  var props = {};
	  if (edge == null || edge === 'anchor') {
	    var point = reverse ? Editor.before(editor, anchor, opts) : Editor.after(editor, anchor, opts);
	    if (point) {
	      props.anchor = point;
	    }
	  }
	  if (edge == null || edge === 'focus') {
	    var _point = reverse ? Editor.before(editor, focus, opts) : Editor.after(editor, focus, opts);
	    if (_point) {
	      props.focus = _point;
	    }
	  }
	  Transforms.setSelection(editor, props);
	};

	var select = (editor, target) => {
	  var {
	    selection
	  } = editor;
	  target = Editor.range(editor, target);
	  if (selection) {
	    Transforms.setSelection(editor, target);
	    return;
	  }
	  if (!Range.isRange(target)) {
	    throw new Error("When setting the selection and the current selection is `null` you must provide at least an `anchor` and `focus`, but you passed: ".concat(Scrubber.stringify(target)));
	  }
	  editor.apply({
	    type: 'set_selection',
	    properties: selection,
	    newProperties: target
	  });
	};

	function ownKeys$1$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread$1$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	var setPoint = function setPoint(editor, props) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var {
	    selection
	  } = editor;
	  var {
	    edge = 'both'
	  } = options;
	  if (!selection) {
	    return;
	  }
	  if (edge === 'start') {
	    edge = Range.isBackward(selection) ? 'focus' : 'anchor';
	  }
	  if (edge === 'end') {
	    edge = Range.isBackward(selection) ? 'anchor' : 'focus';
	  }
	  var {
	    anchor,
	    focus
	  } = selection;
	  var point = edge === 'anchor' ? anchor : focus;
	  Transforms.setSelection(editor, {
	    [edge === 'anchor' ? 'anchor' : 'focus']: _objectSpread$1$1(_objectSpread$1$1({}, point), props)
	  });
	};

	var setSelection = (editor, props) => {
	  var {
	    selection
	  } = editor;
	  var oldProps = {};
	  var newProps = {};
	  if (!selection) {
	    return;
	  }
	  for (var k in props) {
	    if (k === 'anchor' && props.anchor != null && !Point.equals(props.anchor, selection.anchor) || k === 'focus' && props.focus != null && !Point.equals(props.focus, selection.focus) || k !== 'anchor' && k !== 'focus' && props[k] !== selection[k]) {
	      oldProps[k] = selection[k];
	      newProps[k] = props[k];
	    }
	  }
	  if (Object.keys(oldProps).length > 0) {
	    editor.apply({
	      type: 'set_selection',
	      properties: oldProps,
	      newProperties: newProps
	    });
	  }
	};

	var insertNodes = function insertNodes(editor, nodes) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  Editor.withoutNormalizing(editor, () => {
	    var {
	      hanging = false,
	      voids = false,
	      mode = 'lowest'
	    } = options;
	    var {
	      at,
	      match,
	      select
	    } = options;
	    if (Node.isNode(nodes)) {
	      nodes = [nodes];
	    }
	    if (nodes.length === 0) {
	      return;
	    }
	    var [node] = nodes;
	    if (!at) {
	      at = getDefaultInsertLocation(editor);
	      if (select !== false) {
	        select = true;
	      }
	    }
	    if (select == null) {
	      select = false;
	    }
	    if (Range.isRange(at)) {
	      if (!hanging) {
	        at = Editor.unhangRange(editor, at, {
	          voids
	        });
	      }
	      if (Range.isCollapsed(at)) {
	        at = at.anchor;
	      } else {
	        var [, end] = Range.edges(at);
	        var pointRef = Editor.pointRef(editor, end);
	        Transforms.delete(editor, {
	          at
	        });
	        at = pointRef.unref();
	      }
	    }
	    if (Point.isPoint(at)) {
	      if (match == null) {
	        if (Text.isText(node)) {
	          match = n => Text.isText(n);
	        } else if (editor.isInline(node)) {
	          match = n => Text.isText(n) || Editor.isInline(editor, n);
	        } else {
	          match = n => Element.isElement(n) && Editor.isBlock(editor, n);
	        }
	      }
	      var [entry] = Editor.nodes(editor, {
	        at: at.path,
	        match,
	        mode,
	        voids
	      });
	      if (entry) {
	        var [, matchPath] = entry;
	        var pathRef = Editor.pathRef(editor, matchPath);
	        var isAtEnd = Editor.isEnd(editor, at, matchPath);
	        Transforms.splitNodes(editor, {
	          at,
	          match,
	          mode,
	          voids
	        });
	        var path = pathRef.unref();
	        at = isAtEnd ? Path.next(path) : path;
	      } else {
	        return;
	      }
	    }
	    var parentPath = Path.parent(at);
	    var index = at[at.length - 1];
	    if (!voids && Editor.void(editor, {
	      at: parentPath
	    })) {
	      return;
	    }
	    for (var _node of nodes) {
	      var _path = parentPath.concat(index);
	      index++;
	      editor.apply({
	        type: 'insert_node',
	        path: _path,
	        node: _node
	      });
	      at = Path.next(at);
	    }
	    at = Path.previous(at);
	    if (select) {
	      var point = Editor.end(editor, at);
	      if (point) {
	        Transforms.select(editor, point);
	      }
	    }
	  });
	};

	var liftNodes = function liftNodes(editor) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  Editor.withoutNormalizing(editor, () => {
	    var {
	      at = editor.selection,
	      mode = 'lowest',
	      voids = false
	    } = options;
	    var {
	      match
	    } = options;
	    if (match == null) {
	      match = Path.isPath(at) ? matchPath(editor, at) : n => Element.isElement(n) && Editor.isBlock(editor, n);
	    }
	    if (!at) {
	      return;
	    }
	    var matches = Editor.nodes(editor, {
	      at,
	      match,
	      mode,
	      voids
	    });
	    var pathRefs = Array.from(matches, _ref => {
	      var [, p] = _ref;
	      return Editor.pathRef(editor, p);
	    });
	    for (var pathRef of pathRefs) {
	      var path = pathRef.unref();
	      if (path.length < 2) {
	        throw new Error("Cannot lift node at a path [".concat(path, "] because it has a depth of less than `2`."));
	      }
	      var parentNodeEntry = Editor.node(editor, Path.parent(path));
	      var [parent, parentPath] = parentNodeEntry;
	      var index = path[path.length - 1];
	      var {
	        length
	      } = parent.children;
	      if (length === 1) {
	        var toPath = Path.next(parentPath);
	        Transforms.moveNodes(editor, {
	          at: path,
	          to: toPath,
	          voids
	        });
	        Transforms.removeNodes(editor, {
	          at: parentPath,
	          voids
	        });
	      } else if (index === 0) {
	        Transforms.moveNodes(editor, {
	          at: path,
	          to: parentPath,
	          voids
	        });
	      } else if (index === length - 1) {
	        var _toPath = Path.next(parentPath);
	        Transforms.moveNodes(editor, {
	          at: path,
	          to: _toPath,
	          voids
	        });
	      } else {
	        var splitPath = Path.next(path);
	        var _toPath2 = Path.next(parentPath);
	        Transforms.splitNodes(editor, {
	          at: splitPath,
	          voids
	        });
	        Transforms.moveNodes(editor, {
	          at: path,
	          to: _toPath2,
	          voids
	        });
	      }
	    }
	  });
	};

	var _excluded = ["text"],
	  _excluded2 = ["children"];
	var hasSingleChildNest = (editor, node) => {
	  if (Element.isElement(node)) {
	    var element = node;
	    if (Editor.isVoid(editor, node)) {
	      return true;
	    } else if (element.children.length === 1) {
	      return hasSingleChildNest(editor, element.children[0]);
	    } else {
	      return false;
	    }
	  } else if (Editor.isEditor(node)) {
	    return false;
	  } else {
	    return true;
	  }
	};
	var mergeNodes = function mergeNodes(editor) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  Editor.withoutNormalizing(editor, () => {
	    var {
	      match,
	      at = editor.selection
	    } = options;
	    var {
	      hanging = false,
	      voids = false,
	      mode = 'lowest'
	    } = options;
	    if (!at) {
	      return;
	    }
	    if (match == null) {
	      if (Path.isPath(at)) {
	        var [parent] = Editor.parent(editor, at);
	        match = n => parent.children.includes(n);
	      } else {
	        match = n => Element.isElement(n) && Editor.isBlock(editor, n);
	      }
	    }
	    if (!hanging && Range.isRange(at)) {
	      at = Editor.unhangRange(editor, at, {
	        voids
	      });
	    }
	    if (Range.isRange(at)) {
	      if (Range.isCollapsed(at)) {
	        at = at.anchor;
	      } else {
	        var [, end] = Range.edges(at);
	        var pointRef = Editor.pointRef(editor, end);
	        Transforms.delete(editor, {
	          at
	        });
	        at = pointRef.unref();
	        if (options.at == null) {
	          Transforms.select(editor, at);
	        }
	      }
	    }
	    var [current] = Editor.nodes(editor, {
	      at,
	      match,
	      voids,
	      mode
	    });
	    var prev = Editor.previous(editor, {
	      at,
	      match,
	      voids,
	      mode
	    });
	    if (!current || !prev) {
	      return;
	    }
	    var [node, path] = current;
	    var [prevNode, prevPath] = prev;
	    if (path.length === 0 || prevPath.length === 0) {
	      return;
	    }
	    var newPath = Path.next(prevPath);
	    var commonPath = Path.common(path, prevPath);
	    var isPreviousSibling = Path.isSibling(path, prevPath);
	    var levels = Array.from(Editor.levels(editor, {
	      at: path
	    }), _ref => {
	      var [n] = _ref;
	      return n;
	    }).slice(commonPath.length).slice(0, -1);
	    // Determine if the merge will leave an ancestor of the path empty as a
	    // result, in which case we'll want to remove it after merging.
	    var emptyAncestor = Editor.above(editor, {
	      at: path,
	      mode: 'highest',
	      match: n => levels.includes(n) && hasSingleChildNest(editor, n)
	    });
	    var emptyRef = emptyAncestor && Editor.pathRef(editor, emptyAncestor[1]);
	    var properties;
	    var position;
	    // Ensure that the nodes are equivalent, and figure out what the position
	    // and extra properties of the merge will be.
	    if (Text.isText(node) && Text.isText(prevNode)) {
	      var rest = _objectWithoutProperties(node, _excluded);
	      position = prevNode.text.length;
	      properties = rest;
	    } else if (Element.isElement(node) && Element.isElement(prevNode)) {
	      var rest = _objectWithoutProperties(node, _excluded2);
	      position = prevNode.children.length;
	      properties = rest;
	    } else {
	      throw new Error("Cannot merge the node at path [".concat(path, "] with the previous sibling because it is not the same kind: ").concat(Scrubber.stringify(node), " ").concat(Scrubber.stringify(prevNode)));
	    }
	    // If the node isn't already the next sibling of the previous node, move
	    // it so that it is before merging.
	    if (!isPreviousSibling) {
	      Transforms.moveNodes(editor, {
	        at: path,
	        to: newPath,
	        voids
	      });
	    }
	    // If there was going to be an empty ancestor of the node that was merged,
	    // we remove it from the tree.
	    if (emptyRef) {
	      Transforms.removeNodes(editor, {
	        at: emptyRef.current,
	        voids
	      });
	    }
	    // If the target node that we're merging with is empty, remove it instead
	    // of merging the two. This is a common rich text editor behavior to
	    // prevent losing formatting when deleting entire nodes when you have a
	    // hanging selection.
	    // if prevNode is first child in parent,don't remove it.
	    if (Element.isElement(prevNode) && Editor.isEmpty(editor, prevNode) || Text.isText(prevNode) && prevNode.text === '' && prevPath[prevPath.length - 1] !== 0) {
	      Transforms.removeNodes(editor, {
	        at: prevPath,
	        voids
	      });
	    } else {
	      editor.apply({
	        type: 'merge_node',
	        path: newPath,
	        position,
	        properties
	      });
	    }
	    if (emptyRef) {
	      emptyRef.unref();
	    }
	  });
	};

	var moveNodes = (editor, options) => {
	  Editor.withoutNormalizing(editor, () => {
	    var {
	      to,
	      at = editor.selection,
	      mode = 'lowest',
	      voids = false
	    } = options;
	    var {
	      match
	    } = options;
	    if (!at) {
	      return;
	    }
	    if (match == null) {
	      match = Path.isPath(at) ? matchPath(editor, at) : n => Element.isElement(n) && Editor.isBlock(editor, n);
	    }
	    var toRef = Editor.pathRef(editor, to);
	    var targets = Editor.nodes(editor, {
	      at,
	      match,
	      mode,
	      voids
	    });
	    var pathRefs = Array.from(targets, _ref => {
	      var [, p] = _ref;
	      return Editor.pathRef(editor, p);
	    });
	    for (var pathRef of pathRefs) {
	      var path = pathRef.unref();
	      var newPath = toRef.current;
	      if (path.length !== 0) {
	        editor.apply({
	          type: 'move_node',
	          path,
	          newPath
	        });
	      }
	      if (toRef.current && Path.isSibling(newPath, path) && Path.isAfter(newPath, path)) {
	        // When performing a sibling move to a later index, the path at the destination is shifted
	        // to before the insertion point instead of after. To ensure our group of nodes are inserted
	        // in the correct order we increment toRef to account for that
	        toRef.current = Path.next(toRef.current);
	      }
	    }
	    toRef.unref();
	  });
	};

	var removeNodes = function removeNodes(editor) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  Editor.withoutNormalizing(editor, () => {
	    var {
	      hanging = false,
	      voids = false,
	      mode = 'lowest'
	    } = options;
	    var {
	      at = editor.selection,
	      match
	    } = options;
	    if (!at) {
	      return;
	    }
	    if (match == null) {
	      match = Path.isPath(at) ? matchPath(editor, at) : n => Element.isElement(n) && Editor.isBlock(editor, n);
	    }
	    if (!hanging && Range.isRange(at)) {
	      at = Editor.unhangRange(editor, at, {
	        voids
	      });
	    }
	    var depths = Editor.nodes(editor, {
	      at,
	      match,
	      mode,
	      voids
	    });
	    var pathRefs = Array.from(depths, _ref => {
	      var [, p] = _ref;
	      return Editor.pathRef(editor, p);
	    });
	    for (var pathRef of pathRefs) {
	      var path = pathRef.unref();
	      if (path) {
	        var [node] = Editor.node(editor, path);
	        editor.apply({
	          type: 'remove_node',
	          path,
	          node
	        });
	      }
	    }
	  });
	};

	var setNodes = function setNodes(editor, props) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  Editor.withoutNormalizing(editor, () => {
	    var {
	      match,
	      at = editor.selection,
	      compare,
	      merge
	    } = options;
	    var {
	      hanging = false,
	      mode = 'lowest',
	      split = false,
	      voids = false
	    } = options;
	    if (!at) {
	      return;
	    }
	    if (match == null) {
	      match = Path.isPath(at) ? matchPath(editor, at) : n => Element.isElement(n) && Editor.isBlock(editor, n);
	    }
	    if (!hanging && Range.isRange(at)) {
	      at = Editor.unhangRange(editor, at, {
	        voids
	      });
	    }
	    if (split && Range.isRange(at)) {
	      if (Range.isCollapsed(at) && Editor.leaf(editor, at.anchor)[0].text.length > 0) {
	        // If the range is collapsed in a non-empty node and 'split' is true, there's nothing to
	        // set that won't get normalized away
	        return;
	      }
	      var rangeRef = Editor.rangeRef(editor, at, {
	        affinity: 'inward'
	      });
	      var [start, end] = Range.edges(at);
	      var splitMode = mode === 'lowest' ? 'lowest' : 'highest';
	      var endAtEndOfNode = Editor.isEnd(editor, end, end.path);
	      Transforms.splitNodes(editor, {
	        at: end,
	        match,
	        mode: splitMode,
	        voids,
	        always: !endAtEndOfNode
	      });
	      var startAtStartOfNode = Editor.isStart(editor, start, start.path);
	      Transforms.splitNodes(editor, {
	        at: start,
	        match,
	        mode: splitMode,
	        voids,
	        always: !startAtStartOfNode
	      });
	      at = rangeRef.unref();
	      if (options.at == null) {
	        Transforms.select(editor, at);
	      }
	    }
	    if (!compare) {
	      compare = (prop, nodeProp) => prop !== nodeProp;
	    }
	    for (var [node, path] of Editor.nodes(editor, {
	      at,
	      match,
	      mode,
	      voids
	    })) {
	      var properties = {};
	      // FIXME: is this correct?
	      var newProperties = {};
	      // You can't set properties on the editor node.
	      if (path.length === 0) {
	        continue;
	      }
	      var hasChanges = false;
	      for (var k in props) {
	        if (k === 'children' || k === 'text') {
	          continue;
	        }
	        if (compare(props[k], node[k])) {
	          hasChanges = true;
	          // Omit new properties from the old properties list
	          if (node.hasOwnProperty(k)) properties[k] = node[k];
	          // Omit properties that have been removed from the new properties list
	          if (merge) {
	            if (props[k] != null) newProperties[k] = merge(node[k], props[k]);
	          } else {
	            if (props[k] != null) newProperties[k] = props[k];
	          }
	        }
	      }
	      if (hasChanges) {
	        editor.apply({
	          type: 'set_node',
	          path,
	          properties,
	          newProperties
	        });
	      }
	    }
	  });
	};

	/**
	 * Convert a range into a point by deleting it's content.
	 */
	var deleteRange = (editor, range) => {
	  if (Range.isCollapsed(range)) {
	    return range.anchor;
	  } else {
	    var [, end] = Range.edges(range);
	    var pointRef = Editor.pointRef(editor, end);
	    Transforms.delete(editor, {
	      at: range
	    });
	    return pointRef.unref();
	  }
	};
	var splitNodes = function splitNodes(editor) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  Editor.withoutNormalizing(editor, () => {
	    var {
	      mode = 'lowest',
	      voids = false
	    } = options;
	    var {
	      match,
	      at = editor.selection,
	      height = 0,
	      always = false
	    } = options;
	    if (match == null) {
	      match = n => Element.isElement(n) && Editor.isBlock(editor, n);
	    }
	    if (Range.isRange(at)) {
	      at = deleteRange(editor, at);
	    }
	    // If the target is a path, the default height-skipping and position
	    // counters need to account for us potentially splitting at a non-leaf.
	    if (Path.isPath(at)) {
	      var path = at;
	      var point = Editor.point(editor, path);
	      var [parent] = Editor.parent(editor, path);
	      match = n => n === parent;
	      height = point.path.length - path.length + 1;
	      at = point;
	      always = true;
	    }
	    if (!at) {
	      return;
	    }
	    var beforeRef = Editor.pointRef(editor, at, {
	      affinity: 'backward'
	    });
	    var afterRef;
	    try {
	      var [highest] = Editor.nodes(editor, {
	        at,
	        match,
	        mode,
	        voids
	      });
	      if (!highest) {
	        return;
	      }
	      var voidMatch = Editor.void(editor, {
	        at,
	        mode: 'highest'
	      });
	      var nudge = 0;
	      if (!voids && voidMatch) {
	        var [voidNode, voidPath] = voidMatch;
	        if (Element.isElement(voidNode) && editor.isInline(voidNode)) {
	          var after = Editor.after(editor, voidPath);
	          if (!after) {
	            var text = {
	              text: ''
	            };
	            var afterPath = Path.next(voidPath);
	            Transforms.insertNodes(editor, text, {
	              at: afterPath,
	              voids
	            });
	            after = Editor.point(editor, afterPath);
	          }
	          at = after;
	          always = true;
	        }
	        var siblingHeight = at.path.length - voidPath.length;
	        height = siblingHeight + 1;
	        always = true;
	      }
	      afterRef = Editor.pointRef(editor, at);
	      var depth = at.path.length - height;
	      var [, highestPath] = highest;
	      var lowestPath = at.path.slice(0, depth);
	      var position = height === 0 ? at.offset : at.path[depth] + nudge;
	      for (var [node, _path] of Editor.levels(editor, {
	        at: lowestPath,
	        reverse: true,
	        voids
	      })) {
	        var split = false;
	        if (_path.length < highestPath.length || _path.length === 0 || !voids && Element.isElement(node) && Editor.isVoid(editor, node)) {
	          break;
	        }
	        var _point = beforeRef.current;
	        var isEnd = Editor.isEnd(editor, _point, _path);
	        if (always || !beforeRef || !Editor.isEdge(editor, _point, _path)) {
	          split = true;
	          var properties = Node.extractProps(node);
	          editor.apply({
	            type: 'split_node',
	            path: _path,
	            position,
	            properties
	          });
	        }
	        position = _path[_path.length - 1] + (split || isEnd ? 1 : 0);
	      }
	      if (options.at == null) {
	        var _point2 = afterRef.current || Editor.end(editor, []);
	        Transforms.select(editor, _point2);
	      }
	    } finally {
	      var _afterRef;
	      beforeRef.unref();
	      (_afterRef = afterRef) === null || _afterRef === void 0 || _afterRef.unref();
	    }
	  });
	};

	var unsetNodes = function unsetNodes(editor, props) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  if (!Array.isArray(props)) {
	    props = [props];
	  }
	  var obj = {};
	  for (var key of props) {
	    obj[key] = null;
	  }
	  Transforms.setNodes(editor, obj, options);
	};

	var unwrapNodes = function unwrapNodes(editor) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  Editor.withoutNormalizing(editor, () => {
	    var {
	      mode = 'lowest',
	      split = false,
	      voids = false
	    } = options;
	    var {
	      at = editor.selection,
	      match
	    } = options;
	    if (!at) {
	      return;
	    }
	    if (match == null) {
	      match = Path.isPath(at) ? matchPath(editor, at) : n => Element.isElement(n) && Editor.isBlock(editor, n);
	    }
	    if (Path.isPath(at)) {
	      at = Editor.range(editor, at);
	    }
	    var rangeRef = Range.isRange(at) ? Editor.rangeRef(editor, at) : null;
	    var matches = Editor.nodes(editor, {
	      at,
	      match,
	      mode,
	      voids
	    });
	    var pathRefs = Array.from(matches, _ref => {
	      var [, p] = _ref;
	      return Editor.pathRef(editor, p);
	    }
	    // unwrapNode will call liftNode which does not support splitting the node when nested.
	    // If we do not reverse the order and call it from top to the bottom, it will remove all blocks
	    // that wrap target node. So we reverse the order.
	    ).reverse();
	    var _loop = function _loop() {
	      var path = pathRef.unref();
	      var [node] = Editor.node(editor, path);
	      var range = Editor.range(editor, path);
	      if (split && rangeRef) {
	        range = Range.intersection(rangeRef.current, range);
	      }
	      Transforms.liftNodes(editor, {
	        at: range,
	        match: n => Element.isAncestor(node) && node.children.includes(n),
	        voids
	      });
	    };
	    for (var pathRef of pathRefs) {
	      _loop();
	    }
	    if (rangeRef) {
	      rangeRef.unref();
	    }
	  });
	};

	function ownKeys$f(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread$f(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$f(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$f(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	var wrapNodes = function wrapNodes(editor, element) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  Editor.withoutNormalizing(editor, () => {
	    var {
	      mode = 'lowest',
	      split = false,
	      voids = false
	    } = options;
	    var {
	      match,
	      at = editor.selection
	    } = options;
	    if (!at) {
	      return;
	    }
	    if (match == null) {
	      if (Path.isPath(at)) {
	        match = matchPath(editor, at);
	      } else if (editor.isInline(element)) {
	        match = n => Element.isElement(n) && Editor.isInline(editor, n) || Text.isText(n);
	      } else {
	        match = n => Element.isElement(n) && Editor.isBlock(editor, n);
	      }
	    }
	    if (split && Range.isRange(at)) {
	      var [start, end] = Range.edges(at);
	      var rangeRef = Editor.rangeRef(editor, at, {
	        affinity: 'inward'
	      });
	      Transforms.splitNodes(editor, {
	        at: end,
	        match,
	        voids
	      });
	      Transforms.splitNodes(editor, {
	        at: start,
	        match,
	        voids
	      });
	      at = rangeRef.unref();
	      if (options.at == null) {
	        Transforms.select(editor, at);
	      }
	    }
	    var roots = Array.from(Editor.nodes(editor, {
	      at,
	      match: editor.isInline(element) ? n => Element.isElement(n) && Editor.isBlock(editor, n) : n => Editor.isEditor(n),
	      mode: 'lowest',
	      voids
	    }));
	    var _loop = function _loop() {
	        var a = Range.isRange(at) ? Range.intersection(at, Editor.range(editor, rootPath)) : at;
	        if (!a) {
	          return 0; // continue
	        }
	        var matches = Array.from(Editor.nodes(editor, {
	          at: a,
	          match,
	          mode,
	          voids
	        }));
	        if (matches.length > 0) {
	          var [first] = matches;
	          var last = matches[matches.length - 1];
	          var [, firstPath] = first;
	          var [, lastPath] = last;
	          if (firstPath.length === 0 && lastPath.length === 0) {
	            // if there's no matching parent - usually means the node is an editor - don't do anything
	            return 0; // continue
	          }
	          var commonPath = Path.equals(firstPath, lastPath) ? Path.parent(firstPath) : Path.common(firstPath, lastPath);
	          var range = Editor.range(editor, firstPath, lastPath);
	          var commonNodeEntry = Editor.node(editor, commonPath);
	          var [commonNode] = commonNodeEntry;
	          var depth = commonPath.length + 1;
	          var wrapperPath = Path.next(lastPath.slice(0, depth));
	          var wrapper = _objectSpread$f(_objectSpread$f({}, element), {}, {
	            children: []
	          });
	          Transforms.insertNodes(editor, wrapper, {
	            at: wrapperPath,
	            voids
	          });
	          Transforms.moveNodes(editor, {
	            at: range,
	            match: n => Element.isAncestor(commonNode) && commonNode.children.includes(n),
	            to: wrapperPath.concat(0),
	            voids
	          });
	        }
	      },
	      _ret;
	    for (var [, rootPath] of roots) {
	      _ret = _loop();
	      if (_ret === 0) continue;
	    }
	  });
	};

	/**
	 * Create a new Slate `Editor` object.
	 */
	var createEditor$1 = () => {
	  var editor = {
	    children: [],
	    operations: [],
	    selection: null,
	    marks: null,
	    isElementReadOnly: () => false,
	    isInline: () => false,
	    isSelectable: () => true,
	    isVoid: () => false,
	    markableVoid: () => false,
	    onChange: () => {},
	    // Core
	    apply: function apply$1() {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	      return apply$7(editor, ...args);
	    },
	    // Editor
	    addMark: function addMark$1() {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	      return addMark(editor, ...args);
	    },
	    deleteBackward: function deleteBackward$1() {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	      return deleteBackward(editor, ...args);
	    },
	    deleteForward: function deleteForward$1() {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	      return deleteForward(editor, ...args);
	    },
	    deleteFragment: function deleteFragment$1() {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }
	      return deleteFragment(editor, ...args);
	    },
	    getFragment: function getFragment$1() {
	      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }
	      return getFragment(editor, ...args);
	    },
	    insertBreak: function insertBreak$1() {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	      return insertBreak(editor, ...args);
	    },
	    insertSoftBreak: function insertSoftBreak$1() {
	      for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
	        args[_key8] = arguments[_key8];
	      }
	      return insertSoftBreak(editor, ...args);
	    },
	    insertFragment: function insertFragment$1() {
	      for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
	        args[_key9] = arguments[_key9];
	      }
	      return insertFragment(editor, ...args);
	    },
	    insertNode: function insertNode$1() {
	      for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
	        args[_key10] = arguments[_key10];
	      }
	      return insertNode(editor, ...args);
	    },
	    insertText: function insertText$1() {
	      for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
	        args[_key11] = arguments[_key11];
	      }
	      return insertText(editor, ...args);
	    },
	    normalizeNode: function normalizeNode$1() {
	      for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
	        args[_key12] = arguments[_key12];
	      }
	      return normalizeNode(editor, ...args);
	    },
	    removeMark: function removeMark$1() {
	      for (var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
	        args[_key13] = arguments[_key13];
	      }
	      return removeMark(editor, ...args);
	    },
	    getDirtyPaths: function getDirtyPaths$1() {
	      for (var _len14 = arguments.length, args = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
	        args[_key14] = arguments[_key14];
	      }
	      return getDirtyPaths(editor, ...args);
	    },
	    shouldNormalize: function shouldNormalize$1() {
	      for (var _len15 = arguments.length, args = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
	        args[_key15] = arguments[_key15];
	      }
	      return shouldNormalize(editor, ...args);
	    },
	    // Editor interface
	    above: function above$1() {
	      for (var _len16 = arguments.length, args = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
	        args[_key16] = arguments[_key16];
	      }
	      return above(editor, ...args);
	    },
	    after: function after$1() {
	      for (var _len17 = arguments.length, args = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
	        args[_key17] = arguments[_key17];
	      }
	      return after(editor, ...args);
	    },
	    before: function before$1() {
	      for (var _len18 = arguments.length, args = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
	        args[_key18] = arguments[_key18];
	      }
	      return before(editor, ...args);
	    },
	    collapse: function collapse$1() {
	      for (var _len19 = arguments.length, args = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
	        args[_key19] = arguments[_key19];
	      }
	      return collapse(editor, ...args);
	    },
	    delete: function _delete() {
	      for (var _len20 = arguments.length, args = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
	        args[_key20] = arguments[_key20];
	      }
	      return deleteText(editor, ...args);
	    },
	    deselect: function deselect$1() {
	      for (var _len21 = arguments.length, args = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
	        args[_key21] = arguments[_key21];
	      }
	      return deselect(editor, ...args);
	    },
	    edges: function edges$1() {
	      for (var _len22 = arguments.length, args = new Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
	        args[_key22] = arguments[_key22];
	      }
	      return edges(editor, ...args);
	    },
	    elementReadOnly: function elementReadOnly$1() {
	      for (var _len23 = arguments.length, args = new Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
	        args[_key23] = arguments[_key23];
	      }
	      return elementReadOnly(editor, ...args);
	    },
	    end: function end$1() {
	      for (var _len24 = arguments.length, args = new Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {
	        args[_key24] = arguments[_key24];
	      }
	      return end(editor, ...args);
	    },
	    first: function first$1() {
	      for (var _len25 = arguments.length, args = new Array(_len25), _key25 = 0; _key25 < _len25; _key25++) {
	        args[_key25] = arguments[_key25];
	      }
	      return first(editor, ...args);
	    },
	    fragment: function fragment$1() {
	      for (var _len26 = arguments.length, args = new Array(_len26), _key26 = 0; _key26 < _len26; _key26++) {
	        args[_key26] = arguments[_key26];
	      }
	      return fragment(editor, ...args);
	    },
	    getMarks: function getMarks() {
	      for (var _len27 = arguments.length, args = new Array(_len27), _key27 = 0; _key27 < _len27; _key27++) {
	        args[_key27] = arguments[_key27];
	      }
	      return marks(editor, ...args);
	    },
	    hasBlocks: function hasBlocks$1() {
	      for (var _len28 = arguments.length, args = new Array(_len28), _key28 = 0; _key28 < _len28; _key28++) {
	        args[_key28] = arguments[_key28];
	      }
	      return hasBlocks(editor, ...args);
	    },
	    hasInlines: function hasInlines$1() {
	      for (var _len29 = arguments.length, args = new Array(_len29), _key29 = 0; _key29 < _len29; _key29++) {
	        args[_key29] = arguments[_key29];
	      }
	      return hasInlines(editor, ...args);
	    },
	    hasPath: function hasPath$1() {
	      for (var _len30 = arguments.length, args = new Array(_len30), _key30 = 0; _key30 < _len30; _key30++) {
	        args[_key30] = arguments[_key30];
	      }
	      return hasPath(editor, ...args);
	    },
	    hasTexts: function hasTexts$1() {
	      for (var _len31 = arguments.length, args = new Array(_len31), _key31 = 0; _key31 < _len31; _key31++) {
	        args[_key31] = arguments[_key31];
	      }
	      return hasTexts(editor, ...args);
	    },
	    insertNodes: function insertNodes$1() {
	      for (var _len32 = arguments.length, args = new Array(_len32), _key32 = 0; _key32 < _len32; _key32++) {
	        args[_key32] = arguments[_key32];
	      }
	      return insertNodes(editor, ...args);
	    },
	    isBlock: function isBlock$1() {
	      for (var _len33 = arguments.length, args = new Array(_len33), _key33 = 0; _key33 < _len33; _key33++) {
	        args[_key33] = arguments[_key33];
	      }
	      return isBlock(editor, ...args);
	    },
	    isEdge: function isEdge$1() {
	      for (var _len34 = arguments.length, args = new Array(_len34), _key34 = 0; _key34 < _len34; _key34++) {
	        args[_key34] = arguments[_key34];
	      }
	      return isEdge(editor, ...args);
	    },
	    isEmpty: function isEmpty$1() {
	      for (var _len35 = arguments.length, args = new Array(_len35), _key35 = 0; _key35 < _len35; _key35++) {
	        args[_key35] = arguments[_key35];
	      }
	      return isEmpty(editor, ...args);
	    },
	    isEnd: function isEnd$1() {
	      for (var _len36 = arguments.length, args = new Array(_len36), _key36 = 0; _key36 < _len36; _key36++) {
	        args[_key36] = arguments[_key36];
	      }
	      return isEnd(editor, ...args);
	    },
	    isNormalizing: function isNormalizing$1() {
	      for (var _len37 = arguments.length, args = new Array(_len37), _key37 = 0; _key37 < _len37; _key37++) {
	        args[_key37] = arguments[_key37];
	      }
	      return isNormalizing(editor, ...args);
	    },
	    isStart: function isStart$1() {
	      for (var _len38 = arguments.length, args = new Array(_len38), _key38 = 0; _key38 < _len38; _key38++) {
	        args[_key38] = arguments[_key38];
	      }
	      return isStart(editor, ...args);
	    },
	    last: function last$1() {
	      for (var _len39 = arguments.length, args = new Array(_len39), _key39 = 0; _key39 < _len39; _key39++) {
	        args[_key39] = arguments[_key39];
	      }
	      return last(editor, ...args);
	    },
	    leaf: function leaf$1() {
	      for (var _len40 = arguments.length, args = new Array(_len40), _key40 = 0; _key40 < _len40; _key40++) {
	        args[_key40] = arguments[_key40];
	      }
	      return leaf(editor, ...args);
	    },
	    levels: function levels$1() {
	      for (var _len41 = arguments.length, args = new Array(_len41), _key41 = 0; _key41 < _len41; _key41++) {
	        args[_key41] = arguments[_key41];
	      }
	      return levels(editor, ...args);
	    },
	    liftNodes: function liftNodes$1() {
	      for (var _len42 = arguments.length, args = new Array(_len42), _key42 = 0; _key42 < _len42; _key42++) {
	        args[_key42] = arguments[_key42];
	      }
	      return liftNodes(editor, ...args);
	    },
	    mergeNodes: function mergeNodes$1() {
	      for (var _len43 = arguments.length, args = new Array(_len43), _key43 = 0; _key43 < _len43; _key43++) {
	        args[_key43] = arguments[_key43];
	      }
	      return mergeNodes(editor, ...args);
	    },
	    move: function move$1() {
	      for (var _len44 = arguments.length, args = new Array(_len44), _key44 = 0; _key44 < _len44; _key44++) {
	        args[_key44] = arguments[_key44];
	      }
	      return move(editor, ...args);
	    },
	    moveNodes: function moveNodes$1() {
	      for (var _len45 = arguments.length, args = new Array(_len45), _key45 = 0; _key45 < _len45; _key45++) {
	        args[_key45] = arguments[_key45];
	      }
	      return moveNodes(editor, ...args);
	    },
	    next: function next$1() {
	      for (var _len46 = arguments.length, args = new Array(_len46), _key46 = 0; _key46 < _len46; _key46++) {
	        args[_key46] = arguments[_key46];
	      }
	      return next(editor, ...args);
	    },
	    node: function node$1$1() {
	      for (var _len47 = arguments.length, args = new Array(_len47), _key47 = 0; _key47 < _len47; _key47++) {
	        args[_key47] = arguments[_key47];
	      }
	      return node$1(editor, ...args);
	    },
	    nodes: function nodes$1() {
	      for (var _len48 = arguments.length, args = new Array(_len48), _key48 = 0; _key48 < _len48; _key48++) {
	        args[_key48] = arguments[_key48];
	      }
	      return nodes(editor, ...args);
	    },
	    normalize: function normalize$1$1() {
	      for (var _len49 = arguments.length, args = new Array(_len49), _key49 = 0; _key49 < _len49; _key49++) {
	        args[_key49] = arguments[_key49];
	      }
	      return normalize$1(editor, ...args);
	    },
	    parent: function parent$1() {
	      for (var _len50 = arguments.length, args = new Array(_len50), _key50 = 0; _key50 < _len50; _key50++) {
	        args[_key50] = arguments[_key50];
	      }
	      return parent$H(editor, ...args);
	    },
	    path: function path$1() {
	      for (var _len51 = arguments.length, args = new Array(_len51), _key51 = 0; _key51 < _len51; _key51++) {
	        args[_key51] = arguments[_key51];
	      }
	      return path$c(editor, ...args);
	    },
	    pathRef: function pathRef$1() {
	      for (var _len52 = arguments.length, args = new Array(_len52), _key52 = 0; _key52 < _len52; _key52++) {
	        args[_key52] = arguments[_key52];
	      }
	      return pathRef(editor, ...args);
	    },
	    pathRefs: function pathRefs$1() {
	      for (var _len53 = arguments.length, args = new Array(_len53), _key53 = 0; _key53 < _len53; _key53++) {
	        args[_key53] = arguments[_key53];
	      }
	      return pathRefs(editor, ...args);
	    },
	    point: function point$1() {
	      for (var _len54 = arguments.length, args = new Array(_len54), _key54 = 0; _key54 < _len54; _key54++) {
	        args[_key54] = arguments[_key54];
	      }
	      return point(editor, ...args);
	    },
	    pointRef: function pointRef$1() {
	      for (var _len55 = arguments.length, args = new Array(_len55), _key55 = 0; _key55 < _len55; _key55++) {
	        args[_key55] = arguments[_key55];
	      }
	      return pointRef(editor, ...args);
	    },
	    pointRefs: function pointRefs$1() {
	      for (var _len56 = arguments.length, args = new Array(_len56), _key56 = 0; _key56 < _len56; _key56++) {
	        args[_key56] = arguments[_key56];
	      }
	      return pointRefs(editor, ...args);
	    },
	    positions: function positions$1() {
	      for (var _len57 = arguments.length, args = new Array(_len57), _key57 = 0; _key57 < _len57; _key57++) {
	        args[_key57] = arguments[_key57];
	      }
	      return positions(editor, ...args);
	    },
	    previous: function previous$1() {
	      for (var _len58 = arguments.length, args = new Array(_len58), _key58 = 0; _key58 < _len58; _key58++) {
	        args[_key58] = arguments[_key58];
	      }
	      return previous(editor, ...args);
	    },
	    range: function range$1() {
	      for (var _len59 = arguments.length, args = new Array(_len59), _key59 = 0; _key59 < _len59; _key59++) {
	        args[_key59] = arguments[_key59];
	      }
	      return range(editor, ...args);
	    },
	    rangeRef: function rangeRef$1() {
	      for (var _len60 = arguments.length, args = new Array(_len60), _key60 = 0; _key60 < _len60; _key60++) {
	        args[_key60] = arguments[_key60];
	      }
	      return rangeRef(editor, ...args);
	    },
	    rangeRefs: function rangeRefs$1() {
	      for (var _len61 = arguments.length, args = new Array(_len61), _key61 = 0; _key61 < _len61; _key61++) {
	        args[_key61] = arguments[_key61];
	      }
	      return rangeRefs(editor, ...args);
	    },
	    removeNodes: function removeNodes$1() {
	      for (var _len62 = arguments.length, args = new Array(_len62), _key62 = 0; _key62 < _len62; _key62++) {
	        args[_key62] = arguments[_key62];
	      }
	      return removeNodes(editor, ...args);
	    },
	    select: function select$1() {
	      for (var _len63 = arguments.length, args = new Array(_len63), _key63 = 0; _key63 < _len63; _key63++) {
	        args[_key63] = arguments[_key63];
	      }
	      return select(editor, ...args);
	    },
	    setNodes: function setNodes$1() {
	      for (var _len64 = arguments.length, args = new Array(_len64), _key64 = 0; _key64 < _len64; _key64++) {
	        args[_key64] = arguments[_key64];
	      }
	      return setNodes(editor, ...args);
	    },
	    setNormalizing: function setNormalizing$1() {
	      for (var _len65 = arguments.length, args = new Array(_len65), _key65 = 0; _key65 < _len65; _key65++) {
	        args[_key65] = arguments[_key65];
	      }
	      return setNormalizing(editor, ...args);
	    },
	    setPoint: function setPoint$1() {
	      for (var _len66 = arguments.length, args = new Array(_len66), _key66 = 0; _key66 < _len66; _key66++) {
	        args[_key66] = arguments[_key66];
	      }
	      return setPoint(editor, ...args);
	    },
	    setSelection: function setSelection$1() {
	      for (var _len67 = arguments.length, args = new Array(_len67), _key67 = 0; _key67 < _len67; _key67++) {
	        args[_key67] = arguments[_key67];
	      }
	      return setSelection(editor, ...args);
	    },
	    splitNodes: function splitNodes$1() {
	      for (var _len68 = arguments.length, args = new Array(_len68), _key68 = 0; _key68 < _len68; _key68++) {
	        args[_key68] = arguments[_key68];
	      }
	      return splitNodes(editor, ...args);
	    },
	    start: function start$1() {
	      for (var _len69 = arguments.length, args = new Array(_len69), _key69 = 0; _key69 < _len69; _key69++) {
	        args[_key69] = arguments[_key69];
	      }
	      return start(editor, ...args);
	    },
	    string: function string$1() {
	      for (var _len70 = arguments.length, args = new Array(_len70), _key70 = 0; _key70 < _len70; _key70++) {
	        args[_key70] = arguments[_key70];
	      }
	      return string(editor, ...args);
	    },
	    unhangRange: function unhangRange$1() {
	      for (var _len71 = arguments.length, args = new Array(_len71), _key71 = 0; _key71 < _len71; _key71++) {
	        args[_key71] = arguments[_key71];
	      }
	      return unhangRange(editor, ...args);
	    },
	    unsetNodes: function unsetNodes$1() {
	      for (var _len72 = arguments.length, args = new Array(_len72), _key72 = 0; _key72 < _len72; _key72++) {
	        args[_key72] = arguments[_key72];
	      }
	      return unsetNodes(editor, ...args);
	    },
	    unwrapNodes: function unwrapNodes$1() {
	      for (var _len73 = arguments.length, args = new Array(_len73), _key73 = 0; _key73 < _len73; _key73++) {
	        args[_key73] = arguments[_key73];
	      }
	      return unwrapNodes(editor, ...args);
	    },
	    void: function _void() {
	      for (var _len74 = arguments.length, args = new Array(_len74), _key74 = 0; _key74 < _len74; _key74++) {
	        args[_key74] = arguments[_key74];
	      }
	      return getVoid(editor, ...args);
	    },
	    withoutNormalizing: function withoutNormalizing$1() {
	      for (var _len75 = arguments.length, args = new Array(_len75), _key75 = 0; _key75 < _len75; _key75++) {
	        args[_key75] = arguments[_key75];
	      }
	      return withoutNormalizing(editor, ...args);
	    },
	    wrapNodes: function wrapNodes$1() {
	      for (var _len76 = arguments.length, args = new Array(_len76), _key76 = 0; _key76 < _len76; _key76++) {
	        args[_key76] = arguments[_key76];
	      }
	      return wrapNodes(editor, ...args);
	    }
	  };
	  return editor;
	};

	// eslint-disable-next-line no-redeclare
	var History = {
	  /**
	   * Check if a value is a `History` object.
	   */
	  isHistory(value) {
	    return isPlainObject$1(value) && Array.isArray(value.redos) && Array.isArray(value.undos) && (value.redos.length === 0 || Operation.isOperationList(value.redos[0].operations)) && (value.undos.length === 0 || Operation.isOperationList(value.undos[0].operations));
	  }
	};
	var SAVING = new WeakMap();
	var MERGING = new WeakMap();
	// eslint-disable-next-line no-redeclare
	var HistoryEditor = {
	  /**
	   * Check if a value is a `HistoryEditor` object.
	   */
	  isHistoryEditor(value) {
	    return History.isHistory(value.history) && Editor.isEditor(value);
	  },
	  /**
	   * Get the merge flag's current value.
	   */
	  isMerging(editor) {
	    return MERGING.get(editor);
	  },
	  /**
	   * Get the saving flag's current value.
	   */
	  isSaving(editor) {
	    return SAVING.get(editor);
	  },
	  /**
	   * Redo to the previous saved state.
	   */
	  redo(editor) {
	    editor.redo();
	  },
	  /**
	   * Undo to the previous saved state.
	   */
	  undo(editor) {
	    editor.undo();
	  },
	  /**
	   * Apply a series of changes inside a synchronous `fn`, without merging any of
	   * the new operations into previous save point in the history.
	   */
	  withoutMerging(editor, fn) {
	    var prev = HistoryEditor.isMerging(editor);
	    MERGING.set(editor, false);
	    fn();
	    MERGING.set(editor, prev);
	  },
	  /**
	   * Apply a series of changes inside a synchronous `fn`, without saving any of
	   * their operations into the history.
	   */
	  withoutSaving(editor, fn) {
	    var prev = HistoryEditor.isSaving(editor);
	    SAVING.set(editor, false);
	    fn();
	    SAVING.set(editor, prev);
	  }
	};

	/**
	 * The `withHistory` plugin keeps track of the operation history of a Slate
	 * editor as operations are applied to it, using undo and redo stacks.
	 *
	 * If you are using TypeScript, you must extend Slate's CustomTypes to use
	 * this plugin.
	 *
	 * See https://docs.slatejs.org/concepts/11-typescript to learn how.
	 */
	var withHistory = editor => {
	  var e = editor;
	  var {
	    apply
	  } = e;
	  e.history = {
	    undos: [],
	    redos: []
	  };
	  e.redo = () => {
	    var {
	      history
	    } = e;
	    var {
	      redos
	    } = history;
	    if (redos.length > 0) {
	      var batch = redos[redos.length - 1];
	      if (batch.selectionBefore) {
	        Transforms.setSelection(e, batch.selectionBefore);
	      }
	      HistoryEditor.withoutSaving(e, () => {
	        Editor.withoutNormalizing(e, () => {
	          for (var op of batch.operations) {
	            e.apply(op);
	          }
	        });
	      });
	      history.redos.pop();
	      e.writeHistory('undos', batch);
	    }
	  };
	  e.undo = () => {
	    var {
	      history
	    } = e;
	    var {
	      undos
	    } = history;
	    if (undos.length > 0) {
	      var batch = undos[undos.length - 1];
	      HistoryEditor.withoutSaving(e, () => {
	        Editor.withoutNormalizing(e, () => {
	          var inverseOps = batch.operations.map(Operation.inverse).reverse();
	          for (var op of inverseOps) {
	            e.apply(op);
	          }
	          if (batch.selectionBefore) {
	            Transforms.setSelection(e, batch.selectionBefore);
	          }
	        });
	      });
	      e.writeHistory('redos', batch);
	      history.undos.pop();
	    }
	  };
	  e.apply = op => {
	    var {
	      operations,
	      history
	    } = e;
	    var {
	      undos
	    } = history;
	    var lastBatch = undos[undos.length - 1];
	    var lastOp = lastBatch && lastBatch.operations[lastBatch.operations.length - 1];
	    var save = HistoryEditor.isSaving(e);
	    var merge = HistoryEditor.isMerging(e);
	    if (save == null) {
	      save = shouldSave(op);
	    }
	    if (save) {
	      if (merge == null) {
	        if (lastBatch == null) {
	          merge = false;
	        } else if (operations.length !== 0) {
	          merge = true;
	        } else {
	          merge = shouldMerge(op, lastOp);
	        }
	      }
	      if (lastBatch && merge) {
	        lastBatch.operations.push(op);
	      } else {
	        var batch = {
	          operations: [op],
	          selectionBefore: e.selection
	        };
	        e.writeHistory('undos', batch);
	      }
	      while (undos.length > 100) {
	        undos.shift();
	      }
	      history.redos = [];
	    }
	    apply(op);
	  };
	  e.writeHistory = (stack, batch) => {
	    e.history[stack].push(batch);
	  };
	  return e;
	};
	/**
	 * Check whether to merge an operation into the previous operation.
	 */
	var shouldMerge = (op, prev) => {
	  if (prev && op.type === 'insert_text' && prev.type === 'insert_text' && op.offset === prev.offset + prev.text.length && Path.equals(op.path, prev.path)) {
	    return true;
	  }
	  if (prev && op.type === 'remove_text' && prev.type === 'remove_text' && op.offset + op.text.length === prev.offset && Path.equals(op.path, prev.path)) {
	    return true;
	  }
	  return false;
	};
	/**
	 * Check whether an operation needs to be saved to the history.
	 */
	var shouldSave = (op, prev) => {
	  if (op.type === 'set_selection') {
	    return false;
	  }
	  return true;
	};

	var fails$A = fails$T;

	var freezing = !fails$A(function () {
	  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
	  return Object.isExtensible(Object.preventExtensions({}));
	});

	var defineBuiltIn$6 = defineBuiltIn$b;

	var defineBuiltIns$3 = function (target, src, options) {
	  for (var key in src) {
	    if (options && options.unsafe && target[key]) target[key] = src[key];
	    else defineBuiltIn$6(target, key, src[key], options);
	  } return target;
	};

	var internalMetadata = {exports: {}};

	// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
	var fails$z = fails$T;

	var arrayBufferNonExtensible = fails$z(function () {
	  if (typeof ArrayBuffer == 'function') {
	    var buffer = new ArrayBuffer(8);
	    // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
	    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', { value: 8 });
	  }
	});

	var fails$y = fails$T;
	var isObject$q = isObject$B;
	var classof$a = classofRaw$5;
	var ARRAY_BUFFER_NON_EXTENSIBLE = arrayBufferNonExtensible;

	// eslint-disable-next-line es/no-object-isextensible -- safe
	var $isExtensible = Object.isExtensible;
	var FAILS_ON_PRIMITIVES$2 = fails$y(function () { $isExtensible(1); });

	// `Object.isExtensible` method
	// https://tc39.es/ecma262/#sec-object.isextensible
	var objectIsExtensible = (FAILS_ON_PRIMITIVES$2 || ARRAY_BUFFER_NON_EXTENSIBLE) ? function isExtensible(it) {
	  if (!isObject$q(it)) return false;
	  if (ARRAY_BUFFER_NON_EXTENSIBLE && classof$a(it) === 'ArrayBuffer') return false;
	  return $isExtensible ? $isExtensible(it) : true;
	} : $isExtensible;

	var $$L = _export$1;
	var uncurryThis$B = functionUncurryThis$1;
	var hiddenKeys$5 = hiddenKeys$b;
	var isObject$p = isObject$B;
	var hasOwn$c = hasOwnProperty_1$1;
	var defineProperty$6 = objectDefineProperty$1.f;
	var getOwnPropertyNamesModule$1 = objectGetOwnPropertyNames$1;
	var getOwnPropertyNamesExternalModule = objectGetOwnPropertyNamesExternal;
	var isExtensible$1 = objectIsExtensible;
	var uid$3 = uid$7;
	var FREEZING$1 = freezing;

	var REQUIRED = false;
	var METADATA = uid$3('meta');
	var id$2 = 0;

	var setMetadata = function (it) {
	  defineProperty$6(it, METADATA, { value: {
	    objectID: 'O' + id$2++, // object ID
	    weakData: {}          // weak collections IDs
	  } });
	};

	var fastKey$1 = function (it, create) {
	  // return a primitive with prefix
	  if (!isObject$p(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!hasOwn$c(it, METADATA)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible$1(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMetadata(it);
	  // return object ID
	  } return it[METADATA].objectID;
	};

	var getWeakData$1 = function (it, create) {
	  if (!hasOwn$c(it, METADATA)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible$1(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMetadata(it);
	  // return the store of weak collections IDs
	  } return it[METADATA].weakData;
	};

	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZING$1 && REQUIRED && isExtensible$1(it) && !hasOwn$c(it, METADATA)) setMetadata(it);
	  return it;
	};

	var enable = function () {
	  meta.enable = function () { /* empty */ };
	  REQUIRED = true;
	  var getOwnPropertyNames = getOwnPropertyNamesModule$1.f;
	  var splice = uncurryThis$B([].splice);
	  var test = {};
	  test[METADATA] = 1;

	  // prevent exposing of metadata key
	  if (getOwnPropertyNames(test).length) {
	    getOwnPropertyNamesModule$1.f = function (it) {
	      var result = getOwnPropertyNames(it);
	      for (var i = 0, length = result.length; i < length; i++) {
	        if (result[i] === METADATA) {
	          splice(result, i, 1);
	          break;
	        }
	      } return result;
	    };

	    $$L({ target: 'Object', stat: true, forced: true }, {
	      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
	    });
	  }
	};

	var meta = internalMetadata.exports = {
	  enable: enable,
	  fastKey: fastKey$1,
	  getWeakData: getWeakData$1,
	  onFreeze: onFreeze
	};

	hiddenKeys$5[METADATA] = true;

	var internalMetadataExports = internalMetadata.exports;

	var bind$f = functionBindContext$1;
	var call$j = functionCall$1;
	var anObject$g = anObject$q;
	var tryToString$4 = tryToString$8;
	var isArrayIteratorMethod = isArrayIteratorMethod$2;
	var lengthOfArrayLike$5 = lengthOfArrayLike$c;
	var isPrototypeOf$f = objectIsPrototypeOf$1;
	var getIterator = getIterator$2;
	var getIteratorMethod$1 = getIteratorMethod$9;
	var iteratorClose = iteratorClose$2;

	var $TypeError$e = TypeError;

	var Result = function (stopped, result) {
	  this.stopped = stopped;
	  this.result = result;
	};

	var ResultPrototype = Result.prototype;

	var iterate$8 = function (iterable, unboundFunction, options) {
	  var that = options && options.that;
	  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
	  var IS_RECORD = !!(options && options.IS_RECORD);
	  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
	  var INTERRUPTED = !!(options && options.INTERRUPTED);
	  var fn = bind$f(unboundFunction, that);
	  var iterator, iterFn, index, length, result, next, step;

	  var stop = function (condition) {
	    if (iterator) iteratorClose(iterator, 'normal', condition);
	    return new Result(true, condition);
	  };

	  var callFn = function (value) {
	    if (AS_ENTRIES) {
	      anObject$g(value);
	      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
	    } return INTERRUPTED ? fn(value, stop) : fn(value);
	  };

	  if (IS_RECORD) {
	    iterator = iterable.iterator;
	  } else if (IS_ITERATOR) {
	    iterator = iterable;
	  } else {
	    iterFn = getIteratorMethod$1(iterable);
	    if (!iterFn) throw new $TypeError$e(tryToString$4(iterable) + ' is not iterable');
	    // optimisation for array iterators
	    if (isArrayIteratorMethod(iterFn)) {
	      for (index = 0, length = lengthOfArrayLike$5(iterable); length > index; index++) {
	        result = callFn(iterable[index]);
	        if (result && isPrototypeOf$f(ResultPrototype, result)) return result;
	      } return new Result(false);
	    }
	    iterator = getIterator(iterable, iterFn);
	  }

	  next = IS_RECORD ? iterable.next : iterator.next;
	  while (!(step = call$j(next, iterator)).done) {
	    try {
	      result = callFn(step.value);
	    } catch (error) {
	      iteratorClose(iterator, 'throw', error);
	    }
	    if (typeof result == 'object' && result && isPrototypeOf$f(ResultPrototype, result)) return result;
	  } return new Result(false);
	};

	var isPrototypeOf$e = objectIsPrototypeOf$1;

	var $TypeError$d = TypeError;

	var anInstance$4 = function (it, Prototype) {
	  if (isPrototypeOf$e(Prototype, it)) return it;
	  throw new $TypeError$d('Incorrect invocation');
	};

	var $$K = _export$1;
	var global$r = global$G;
	var InternalMetadataModule$1 = internalMetadataExports;
	var fails$x = fails$T;
	var createNonEnumerableProperty$7 = createNonEnumerableProperty$d;
	var iterate$7 = iterate$8;
	var anInstance$3 = anInstance$4;
	var isCallable$k = isCallable$B;
	var isObject$o = isObject$B;
	var isNullOrUndefined$a = isNullOrUndefined$e;
	var setToStringTag$1 = setToStringTag$7;
	var defineProperty$5 = objectDefineProperty$1.f;
	var forEach$6 = arrayIteration$1.forEach;
	var DESCRIPTORS$e = descriptors$1;
	var InternalStateModule$4 = internalState$1;

	var setInternalState$3 = InternalStateModule$4.set;
	var internalStateGetterFor$2 = InternalStateModule$4.getterFor;

	var collection$2 = function (CONSTRUCTOR_NAME, wrapper, common) {
	  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
	  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var NativeConstructor = global$r[CONSTRUCTOR_NAME];
	  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
	  var exported = {};
	  var Constructor;

	  if (!DESCRIPTORS$e || !isCallable$k(NativeConstructor)
	    || !(IS_WEAK || NativePrototype.forEach && !fails$x(function () { new NativeConstructor().entries().next(); }))
	  ) {
	    // create collection constructor
	    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
	    InternalMetadataModule$1.enable();
	  } else {
	    Constructor = wrapper(function (target, iterable) {
	      setInternalState$3(anInstance$3(target, Prototype), {
	        type: CONSTRUCTOR_NAME,
	        collection: new NativeConstructor()
	      });
	      if (!isNullOrUndefined$a(iterable)) iterate$7(iterable, target[ADDER], { that: target, AS_ENTRIES: IS_MAP });
	    });

	    var Prototype = Constructor.prototype;

	    var getInternalState = internalStateGetterFor$2(CONSTRUCTOR_NAME);

	    forEach$6(['add', 'clear', 'delete', 'forEach', 'get', 'has', 'set', 'keys', 'values', 'entries'], function (KEY) {
	      var IS_ADDER = KEY === 'add' || KEY === 'set';
	      if (KEY in NativePrototype && !(IS_WEAK && KEY === 'clear')) {
	        createNonEnumerableProperty$7(Prototype, KEY, function (a, b) {
	          var collection = getInternalState(this).collection;
	          if (!IS_ADDER && IS_WEAK && !isObject$o(a)) return KEY === 'get' ? undefined : false;
	          var result = collection[KEY](a === 0 ? 0 : a, b);
	          return IS_ADDER ? this : result;
	        });
	      }
	    });

	    IS_WEAK || defineProperty$5(Prototype, 'size', {
	      configurable: true,
	      get: function () {
	        return getInternalState(this).collection.size;
	      }
	    });
	  }

	  setToStringTag$1(Constructor, CONSTRUCTOR_NAME, false, true);

	  exported[CONSTRUCTOR_NAME] = Constructor;
	  $$K({ global: true, forced: true }, exported);

	  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

	  return Constructor;
	};

	var uncurryThis$A = functionUncurryThis$1;
	var defineBuiltIns$2 = defineBuiltIns$3;
	var getWeakData = internalMetadataExports.getWeakData;
	var anInstance$2 = anInstance$4;
	var anObject$f = anObject$q;
	var isNullOrUndefined$9 = isNullOrUndefined$e;
	var isObject$n = isObject$B;
	var iterate$6 = iterate$8;
	var ArrayIterationModule = arrayIteration$1;
	var hasOwn$b = hasOwnProperty_1$1;
	var InternalStateModule$3 = internalState$1;

	var setInternalState$2 = InternalStateModule$3.set;
	var internalStateGetterFor$1 = InternalStateModule$3.getterFor;
	var find$5 = ArrayIterationModule.find;
	var findIndex = ArrayIterationModule.findIndex;
	var splice = uncurryThis$A([].splice);
	var id$1 = 0;

	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (state) {
	  return state.frozen || (state.frozen = new UncaughtFrozenStore());
	};

	var UncaughtFrozenStore = function () {
	  this.entries = [];
	};

	var findUncaughtFrozen = function (store, key) {
	  return find$5(store.entries, function (it) {
	    return it[0] === key;
	  });
	};

	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.entries.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = findIndex(this.entries, function (it) {
	      return it[0] === key;
	    });
	    if (~index) splice(this.entries, index, 1);
	    return !!~index;
	  }
	};

	var collectionWeak$1 = {
	  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
	    var Constructor = wrapper(function (that, iterable) {
	      anInstance$2(that, Prototype);
	      setInternalState$2(that, {
	        type: CONSTRUCTOR_NAME,
	        id: id$1++,
	        frozen: undefined
	      });
	      if (!isNullOrUndefined$9(iterable)) iterate$6(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
	    });

	    var Prototype = Constructor.prototype;

	    var getInternalState = internalStateGetterFor$1(CONSTRUCTOR_NAME);

	    var define = function (that, key, value) {
	      var state = getInternalState(that);
	      var data = getWeakData(anObject$f(key), true);
	      if (data === true) uncaughtFrozenStore(state).set(key, value);
	      else data[state.id] = value;
	      return that;
	    };

	    defineBuiltIns$2(Prototype, {
	      // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
	      // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
	      // https://tc39.es/ecma262/#sec-weakset.prototype.delete
	      'delete': function (key) {
	        var state = getInternalState(this);
	        if (!isObject$n(key)) return false;
	        var data = getWeakData(key);
	        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
	        return data && hasOwn$b(data, state.id) && delete data[state.id];
	      },
	      // `{ WeakMap, WeakSet }.prototype.has(key)` methods
	      // https://tc39.es/ecma262/#sec-weakmap.prototype.has
	      // https://tc39.es/ecma262/#sec-weakset.prototype.has
	      has: function has(key) {
	        var state = getInternalState(this);
	        if (!isObject$n(key)) return false;
	        var data = getWeakData(key);
	        if (data === true) return uncaughtFrozenStore(state).has(key);
	        return data && hasOwn$b(data, state.id);
	      }
	    });

	    defineBuiltIns$2(Prototype, IS_MAP ? {
	      // `WeakMap.prototype.get(key)` method
	      // https://tc39.es/ecma262/#sec-weakmap.prototype.get
	      get: function get(key) {
	        var state = getInternalState(this);
	        if (isObject$n(key)) {
	          var data = getWeakData(key);
	          if (data === true) return uncaughtFrozenStore(state).get(key);
	          return data ? data[state.id] : undefined;
	        }
	      },
	      // `WeakMap.prototype.set(key, value)` method
	      // https://tc39.es/ecma262/#sec-weakmap.prototype.set
	      set: function set(key, value) {
	        return define(this, key, value);
	      }
	    } : {
	      // `WeakSet.prototype.add(value)` method
	      // https://tc39.es/ecma262/#sec-weakset.prototype.add
	      add: function add(value) {
	        return define(this, value, true);
	      }
	    });

	    return Constructor;
	  }
	};

	var FREEZING = freezing;
	var global$q = global$G;
	var uncurryThis$z = functionUncurryThis$1;
	var defineBuiltIns$1 = defineBuiltIns$3;
	var InternalMetadataModule = internalMetadataExports;
	var collection$1 = collection$2;
	var collectionWeak = collectionWeak$1;
	var isObject$m = isObject$B;
	var enforceInternalState$1 = internalState$1.enforce;
	var fails$w = fails$T;
	var NATIVE_WEAK_MAP$1 = weakMapBasicDetection$1;

	var $Object$4 = Object;
	// eslint-disable-next-line es/no-array-isarray -- safe
	var isArray$a = Array.isArray;
	// eslint-disable-next-line es/no-object-isextensible -- safe
	var isExtensible = $Object$4.isExtensible;
	// eslint-disable-next-line es/no-object-isfrozen -- safe
	var isFrozen = $Object$4.isFrozen;
	// eslint-disable-next-line es/no-object-issealed -- safe
	var isSealed = $Object$4.isSealed;
	// eslint-disable-next-line es/no-object-freeze -- safe
	var freeze = $Object$4.freeze;
	// eslint-disable-next-line es/no-object-seal -- safe
	var seal = $Object$4.seal;

	var FROZEN = {};
	var SEALED = {};
	var IS_IE11 = !global$q.ActiveXObject && 'ActiveXObject' in global$q;
	var InternalWeakMap;

	var wrapper = function (init) {
	  return function WeakMap() {
	    return init(this, arguments.length ? arguments[0] : undefined);
	  };
	};

	// `WeakMap` constructor
	// https://tc39.es/ecma262/#sec-weakmap-constructor
	var $WeakMap = collection$1('WeakMap', wrapper, collectionWeak);
	var WeakMapPrototype = $WeakMap.prototype;
	var nativeSet = uncurryThis$z(WeakMapPrototype.set);

	// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
	var hasMSEdgeFreezingBug = function () {
	  return FREEZING && fails$w(function () {
	    var frozenArray = freeze([]);
	    nativeSet(new $WeakMap(), frozenArray, 1);
	    return !isFrozen(frozenArray);
	  });
	};

	// IE11 WeakMap frozen keys fix
	// We can't use feature detection because it crash some old IE builds
	// https://github.com/zloirock/core-js/issues/485
	if (NATIVE_WEAK_MAP$1) if (IS_IE11) {
	  InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
	  InternalMetadataModule.enable();
	  var nativeDelete = uncurryThis$z(WeakMapPrototype['delete']);
	  var nativeHas = uncurryThis$z(WeakMapPrototype.has);
	  var nativeGet = uncurryThis$z(WeakMapPrototype.get);
	  defineBuiltIns$1(WeakMapPrototype, {
	    'delete': function (key) {
	      if (isObject$m(key) && !isExtensible(key)) {
	        var state = enforceInternalState$1(this);
	        if (!state.frozen) state.frozen = new InternalWeakMap();
	        return nativeDelete(this, key) || state.frozen['delete'](key);
	      } return nativeDelete(this, key);
	    },
	    has: function has(key) {
	      if (isObject$m(key) && !isExtensible(key)) {
	        var state = enforceInternalState$1(this);
	        if (!state.frozen) state.frozen = new InternalWeakMap();
	        return nativeHas(this, key) || state.frozen.has(key);
	      } return nativeHas(this, key);
	    },
	    get: function get(key) {
	      if (isObject$m(key) && !isExtensible(key)) {
	        var state = enforceInternalState$1(this);
	        if (!state.frozen) state.frozen = new InternalWeakMap();
	        return nativeHas(this, key) ? nativeGet(this, key) : state.frozen.get(key);
	      } return nativeGet(this, key);
	    },
	    set: function set(key, value) {
	      if (isObject$m(key) && !isExtensible(key)) {
	        var state = enforceInternalState$1(this);
	        if (!state.frozen) state.frozen = new InternalWeakMap();
	        nativeHas(this, key) ? nativeSet(this, key, value) : state.frozen.set(key, value);
	      } else nativeSet(this, key, value);
	      return this;
	    }
	  });
	// Chakra Edge frozen keys fix
	} else if (hasMSEdgeFreezingBug()) {
	  defineBuiltIns$1(WeakMapPrototype, {
	    set: function set(key, value) {
	      var arrayIntegrityLevel;
	      if (isArray$a(key)) {
	        if (isFrozen(key)) arrayIntegrityLevel = FROZEN;
	        else if (isSealed(key)) arrayIntegrityLevel = SEALED;
	      }
	      nativeSet(this, key, value);
	      if (arrayIntegrityLevel === FROZEN) freeze(key);
	      if (arrayIntegrityLevel === SEALED) seal(key);
	      return this;
	    }
	  });
	}

	var path$b = path$q;

	var weakMap$2 = path$b.WeakMap;

	var parent$G = weakMap$2;


	var weakMap$1 = parent$G;

	var weakMap = weakMap$1;

	var _WeakMap$1 = /*@__PURE__*/getDefaultExportFromCjs(weakMap);

	// textarea - editor
	var EDITOR_TO_TEXTAREA = new _WeakMap$1();
	var TEXTAREA_TO_EDITOR = new _WeakMap$1();

	// bar - editor
	var TOOLBAR_TO_EDITOR = new _WeakMap$1();
	var EDITOR_TO_TOOLBAR = new _WeakMap$1();
	var HOVER_BAR_TO_EDITOR = new _WeakMap$1();
	var EDITOR_TO_HOVER_BAR = new _WeakMap$1();
	var BAR_ITEM_TO_EDITOR = new _WeakMap$1();
	var EDITOR_TO_PANEL_AND_MODAL = new _WeakMap$1();
	var PANEL_OR_MODAL_TO_EDITOR = new _WeakMap$1();

	// config
	var EDITOR_TO_CONFIG = new _WeakMap$1();

	// vdom 相关的属性
	var IS_FIRST_PATCH = new _WeakMap$1();
	var TEXTAREA_TO_PATCH_FN = new _WeakMap$1();
	var TEXTAREA_TO_VNODE = new _WeakMap$1();

	/**
	 * Two weak maps that allow us rebuild a path given a node. They are populated
	 * at render time such that after a render occurs we can always backtrack.
	 */
	var NODE_TO_INDEX = new _WeakMap$1();
	var NODE_TO_PARENT = new _WeakMap$1();

	/**
	 * Weak maps that allow us to go between Slate nodes and DOM nodes. These
	 * are used to resolve DOM event-related logic into Slate actions.
	 */
	var EDITOR_TO_ELEMENT = new _WeakMap$1();
	new _WeakMap$1();
	var ELEMENT_TO_NODE = new _WeakMap$1();
	var KEY_TO_ELEMENT = new _WeakMap$1();
	var NODE_TO_ELEMENT = new _WeakMap$1();
	var NODE_TO_KEY = new _WeakMap$1();
	var EDITOR_TO_WINDOW = new _WeakMap$1();

	/**
	 * Weak maps for storing editor-related state.
	 */
	var IS_FOCUSED = new _WeakMap$1();
	new _WeakMap$1();
	new _WeakMap$1();

	// /**
	//  * Weak map for associating the context `onChange` context with the plugin.
	//  */
	// export const EDITOR_TO_ON_CHANGE = new WeakMap<Editor, () => void>()

	// 正在更新，但尚未更新完的节点 path ，临时记录下
	// 例如，table 插入 col ，需要一行一行的插入，在更新期间，不能收到其他的（如 normalize）干扰
	new _WeakMap$1();

	// 保存 editor -> selection ，用于还原 editor 选区
	var EDITOR_TO_SELECTION = new _WeakMap$1();

	// editor -> eventEmitter 自定义事件
	var EDITOR_TO_EMITTER = new _WeakMap$1();

	// editor 是否可执行粘贴
	var EDITOR_TO_CAN_PASTE = new _WeakMap$1();

	var withConfig = function withConfig(editor) {
	  var e = editor;

	  // 获取 editor 配置信息
	  e.getConfig = function () {
	    var config = EDITOR_TO_CONFIG.get(e);
	    if (config == null) throw new Error('Can not get editor config');
	    return config;
	  };

	  // 获取 menu config
	  e.getMenuConfig = function (menuKey) {
	    var _e$getConfig = e.getConfig(),
	      _e$getConfig$MENU_CON = _e$getConfig.MENU_CONF,
	      MENU_CONF = _e$getConfig$MENU_CON === void 0 ? {} : _e$getConfig$MENU_CON;
	    return MENU_CONF[menuKey] || {};
	  };
	  return e;
	};

	var getBuiltIn$9 = getBuiltIn$k;
	var defineBuiltInAccessor$3 = defineBuiltInAccessor$5;
	var wellKnownSymbol$g = wellKnownSymbol$A;
	var DESCRIPTORS$d = descriptors$1;

	var SPECIES$6 = wellKnownSymbol$g('species');

	var setSpecies$2 = function (CONSTRUCTOR_NAME) {
	  var Constructor = getBuiltIn$9(CONSTRUCTOR_NAME);

	  if (DESCRIPTORS$d && Constructor && !Constructor[SPECIES$6]) {
	    defineBuiltInAccessor$3(Constructor, SPECIES$6, {
	      configurable: true,
	      get: function () { return this; }
	    });
	  }
	};

	var create$c = objectCreate$1;
	var defineBuiltInAccessor$2 = defineBuiltInAccessor$5;
	var defineBuiltIns = defineBuiltIns$3;
	var bind$e = functionBindContext$1;
	var anInstance$1 = anInstance$4;
	var isNullOrUndefined$8 = isNullOrUndefined$e;
	var iterate$5 = iterate$8;
	var defineIterator = iteratorDefine;
	var createIterResultObject = createIterResultObject$3;
	var setSpecies$1 = setSpecies$2;
	var DESCRIPTORS$c = descriptors$1;
	var fastKey = internalMetadataExports.fastKey;
	var InternalStateModule$2 = internalState$1;

	var setInternalState$1 = InternalStateModule$2.set;
	var internalStateGetterFor = InternalStateModule$2.getterFor;

	var collectionStrong$1 = {
	  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
	    var Constructor = wrapper(function (that, iterable) {
	      anInstance$1(that, Prototype);
	      setInternalState$1(that, {
	        type: CONSTRUCTOR_NAME,
	        index: create$c(null),
	        first: undefined,
	        last: undefined,
	        size: 0
	      });
	      if (!DESCRIPTORS$c) that.size = 0;
	      if (!isNullOrUndefined$8(iterable)) iterate$5(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
	    });

	    var Prototype = Constructor.prototype;

	    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

	    var define = function (that, key, value) {
	      var state = getInternalState(that);
	      var entry = getEntry(that, key);
	      var previous, index;
	      // change existing entry
	      if (entry) {
	        entry.value = value;
	      // create new entry
	      } else {
	        state.last = entry = {
	          index: index = fastKey(key, true),
	          key: key,
	          value: value,
	          previous: previous = state.last,
	          next: undefined,
	          removed: false
	        };
	        if (!state.first) state.first = entry;
	        if (previous) previous.next = entry;
	        if (DESCRIPTORS$c) state.size++;
	        else that.size++;
	        // add to index
	        if (index !== 'F') state.index[index] = entry;
	      } return that;
	    };

	    var getEntry = function (that, key) {
	      var state = getInternalState(that);
	      // fast case
	      var index = fastKey(key);
	      var entry;
	      if (index !== 'F') return state.index[index];
	      // frozen object case
	      for (entry = state.first; entry; entry = entry.next) {
	        if (entry.key === key) return entry;
	      }
	    };

	    defineBuiltIns(Prototype, {
	      // `{ Map, Set }.prototype.clear()` methods
	      // https://tc39.es/ecma262/#sec-map.prototype.clear
	      // https://tc39.es/ecma262/#sec-set.prototype.clear
	      clear: function clear() {
	        var that = this;
	        var state = getInternalState(that);
	        var data = state.index;
	        var entry = state.first;
	        while (entry) {
	          entry.removed = true;
	          if (entry.previous) entry.previous = entry.previous.next = undefined;
	          delete data[entry.index];
	          entry = entry.next;
	        }
	        state.first = state.last = undefined;
	        if (DESCRIPTORS$c) state.size = 0;
	        else that.size = 0;
	      },
	      // `{ Map, Set }.prototype.delete(key)` methods
	      // https://tc39.es/ecma262/#sec-map.prototype.delete
	      // https://tc39.es/ecma262/#sec-set.prototype.delete
	      'delete': function (key) {
	        var that = this;
	        var state = getInternalState(that);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.next;
	          var prev = entry.previous;
	          delete state.index[entry.index];
	          entry.removed = true;
	          if (prev) prev.next = next;
	          if (next) next.previous = prev;
	          if (state.first === entry) state.first = next;
	          if (state.last === entry) state.last = prev;
	          if (DESCRIPTORS$c) state.size--;
	          else that.size--;
	        } return !!entry;
	      },
	      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
	      // https://tc39.es/ecma262/#sec-map.prototype.foreach
	      // https://tc39.es/ecma262/#sec-set.prototype.foreach
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        var state = getInternalState(this);
	        var boundFunction = bind$e(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	        var entry;
	        while (entry = entry ? entry.next : state.first) {
	          boundFunction(entry.value, entry.key, this);
	          // revert to the last existing entry
	          while (entry && entry.removed) entry = entry.previous;
	        }
	      },
	      // `{ Map, Set}.prototype.has(key)` methods
	      // https://tc39.es/ecma262/#sec-map.prototype.has
	      // https://tc39.es/ecma262/#sec-set.prototype.has
	      has: function has(key) {
	        return !!getEntry(this, key);
	      }
	    });

	    defineBuiltIns(Prototype, IS_MAP ? {
	      // `Map.prototype.get(key)` method
	      // https://tc39.es/ecma262/#sec-map.prototype.get
	      get: function get(key) {
	        var entry = getEntry(this, key);
	        return entry && entry.value;
	      },
	      // `Map.prototype.set(key, value)` method
	      // https://tc39.es/ecma262/#sec-map.prototype.set
	      set: function set(key, value) {
	        return define(this, key === 0 ? 0 : key, value);
	      }
	    } : {
	      // `Set.prototype.add(value)` method
	      // https://tc39.es/ecma262/#sec-set.prototype.add
	      add: function add(value) {
	        return define(this, value = value === 0 ? 0 : value, value);
	      }
	    });
	    if (DESCRIPTORS$c) defineBuiltInAccessor$2(Prototype, 'size', {
	      configurable: true,
	      get: function () {
	        return getInternalState(this).size;
	      }
	    });
	    return Constructor;
	  },
	  setStrong: function (Constructor, CONSTRUCTOR_NAME, IS_MAP) {
	    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
	    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
	    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
	    // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
	    // https://tc39.es/ecma262/#sec-map.prototype.entries
	    // https://tc39.es/ecma262/#sec-map.prototype.keys
	    // https://tc39.es/ecma262/#sec-map.prototype.values
	    // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
	    // https://tc39.es/ecma262/#sec-set.prototype.entries
	    // https://tc39.es/ecma262/#sec-set.prototype.keys
	    // https://tc39.es/ecma262/#sec-set.prototype.values
	    // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
	    defineIterator(Constructor, CONSTRUCTOR_NAME, function (iterated, kind) {
	      setInternalState$1(this, {
	        type: ITERATOR_NAME,
	        target: iterated,
	        state: getInternalCollectionState(iterated),
	        kind: kind,
	        last: undefined
	      });
	    }, function () {
	      var state = getInternalIteratorState(this);
	      var kind = state.kind;
	      var entry = state.last;
	      // revert to the last existing entry
	      while (entry && entry.removed) entry = entry.previous;
	      // get next entry
	      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
	        // or finish the iteration
	        state.target = undefined;
	        return createIterResultObject(undefined, true);
	      }
	      // return step by kind
	      if (kind === 'keys') return createIterResultObject(entry.key, false);
	      if (kind === 'values') return createIterResultObject(entry.value, false);
	      return createIterResultObject([entry.key, entry.value], false);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

	    // `{ Map, Set }.prototype[@@species]` accessors
	    // https://tc39.es/ecma262/#sec-get-map-@@species
	    // https://tc39.es/ecma262/#sec-get-set-@@species
	    setSpecies$1(CONSTRUCTOR_NAME);
	  }
	};

	var collection = collection$2;
	var collectionStrong = collectionStrong$1;

	// `Set` constructor
	// https://tc39.es/ecma262/#sec-set-objects
	collection('Set', function (init) {
	  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
	}, collectionStrong);

	var path$a = path$q;

	var set$4 = path$a.Set;

	var parent$F = set$4;


	var set$3 = parent$F;

	var set$2 = set$3;

	var _Set$1 = /*@__PURE__*/getDefaultExportFromCjs(set$2);

	var eventEmitter = {exports: {}};

	var d$1 = {exports: {}};

	// ES3 safe
	var _undefined$1 = void 0;

	var is$5 = function (value) { return value !== _undefined$1 && value !== null; };

	var isValue$3 = is$5;

	// prettier-ignore
	var possibleTypes = { "object": true, "function": true, "undefined": true /* document.all */ };

	var is$4 = function (value) {
		if (!isValue$3(value)) return false;
		return hasOwnProperty.call(possibleTypes, typeof value);
	};

	var isObject$l = is$4;

	var is$3 = function (value) {
		if (!isObject$l(value)) return false;
		try {
			if (!value.constructor) return false;
			return value.constructor.prototype === value;
		} catch (error) {
			return false;
		}
	};

	var isPrototype$2 = is$3;

	var is$2 = function (value) {
		if (typeof value !== "function") return false;

		if (!hasOwnProperty.call(value, "length")) return false;

		try {
			if (typeof value.length !== "number") return false;
			if (typeof value.call !== "function") return false;
			if (typeof value.apply !== "function") return false;
		} catch (error) {
			return false;
		}

		return !isPrototype$2(value);
	};

	var isFunction$3 = is$2;

	var classRe = /^\s*class[\s{/}]/, functionToString$2 = Function.prototype.toString;

	var is$1 = function (value) {
		if (!isFunction$3(value)) return false;
		if (classRe.test(functionToString$2.call(value))) return false;
		return true;
	};

	// eslint-disable-next-line no-empty-function
	var noop$1 = function () {};

	var _undefined = noop$1(); // Support ES3 engines

	var isValue$2 = function (val) { return val !== _undefined && val !== null; };

	var shim$2;
	var hasRequiredShim$2;

	function requireShim$2 () {
		if (hasRequiredShim$2) return shim$2;
		hasRequiredShim$2 = 1;

		var isValue = isValue$2;

		var keys = Object.keys;

		shim$2 = function (object) { return keys(isValue(object) ? Object(object) : object); };
		return shim$2;
	}

	var isImplemented$2;
	var hasRequiredIsImplemented$2;

	function requireIsImplemented$2 () {
		if (hasRequiredIsImplemented$2) return isImplemented$2;
		hasRequiredIsImplemented$2 = 1;

		isImplemented$2 = function () {
			try {
				Object.keys("primitive");
				return true;
			} catch (e) {
				return false;
			}
		};
		return isImplemented$2;
	}

	var keys$4;
	var hasRequiredKeys;

	function requireKeys () {
		if (hasRequiredKeys) return keys$4;
		hasRequiredKeys = 1;

		keys$4 = requireIsImplemented$2()() ? Object.keys : requireShim$2();
		return keys$4;
	}

	var validValue;
	var hasRequiredValidValue;

	function requireValidValue () {
		if (hasRequiredValidValue) return validValue;
		hasRequiredValidValue = 1;

		var isValue = isValue$2;

		validValue = function (value) {
			if (!isValue(value)) throw new TypeError("Cannot use null or undefined");
			return value;
		};
		return validValue;
	}

	var shim$1;
	var hasRequiredShim$1;

	function requireShim$1 () {
		if (hasRequiredShim$1) return shim$1;
		hasRequiredShim$1 = 1;

		var keys  = requireKeys()
		  , value = requireValidValue()
		  , max   = Math.max;

		shim$1 = function (dest, src /*, …srcn*/) {
			var error, i, length = max(arguments.length, 2), assign;
			dest = Object(value(dest));
			assign = function (key) {
				try {
					dest[key] = src[key];
				} catch (e) {
					if (!error) error = e;
				}
			};
			for (i = 1; i < length; ++i) {
				src = arguments[i];
				keys(src).forEach(assign);
			}
			if (error !== undefined) throw error;
			return dest;
		};
		return shim$1;
	}

	var isImplemented$1;
	var hasRequiredIsImplemented$1;

	function requireIsImplemented$1 () {
		if (hasRequiredIsImplemented$1) return isImplemented$1;
		hasRequiredIsImplemented$1 = 1;

		isImplemented$1 = function () {
			var assign = Object.assign, obj;
			if (typeof assign !== "function") return false;
			obj = { foo: "raz" };
			assign(obj, { bar: "dwa" }, { trzy: "trzy" });
			return obj.foo + obj.bar + obj.trzy === "razdwatrzy";
		};
		return isImplemented$1;
	}

	var assign$5 = requireIsImplemented$1()() ? Object.assign : requireShim$1();

	var isValue$1 = isValue$2;

	var forEach$5 = Array.prototype.forEach, create$b = Object.create;

	var process$4 = function (src, obj) {
		var key;
		for (key in src) obj[key] = src[key];
	};

	// eslint-disable-next-line no-unused-vars
	var normalizeOptions = function (opts1 /*, …options*/) {
		var result = create$b(null);
		forEach$5.call(arguments, function (options) {
			if (!isValue$1(options)) return;
			process$4(Object(options), result);
		});
		return result;
	};

	var shim;
	var hasRequiredShim;

	function requireShim () {
		if (hasRequiredShim) return shim;
		hasRequiredShim = 1;

		var indexOf = String.prototype.indexOf;

		shim = function (searchString /*, position*/) {
			return indexOf.call(this, searchString, arguments[1]) > -1;
		};
		return shim;
	}

	var isImplemented;
	var hasRequiredIsImplemented;

	function requireIsImplemented () {
		if (hasRequiredIsImplemented) return isImplemented;
		hasRequiredIsImplemented = 1;

		var str = "razdwatrzy";

		isImplemented = function () {
			if (typeof str.contains !== "function") return false;
			return str.contains("dwa") === true && str.contains("foo") === false;
		};
		return isImplemented;
	}

	var contains$1 = requireIsImplemented()() ? String.prototype.contains : requireShim();

	var isValue         = is$5
	  , isPlainFunction = is$1
	  , assign$4          = assign$5
	  , normalizeOpts   = normalizeOptions
	  , contains        = contains$1;

	var d = (d$1.exports = function (dscr, value/*, options*/) {
		var c, e, w, options, desc;
		if (arguments.length < 2 || typeof dscr !== "string") {
			options = value;
			value = dscr;
			dscr = null;
		} else {
			options = arguments[2];
		}
		if (isValue(dscr)) {
			c = contains.call(dscr, "c");
			e = contains.call(dscr, "e");
			w = contains.call(dscr, "w");
		} else {
			c = w = true;
			e = false;
		}

		desc = { value: value, configurable: c, enumerable: e, writable: w };
		return !options ? desc : assign$4(normalizeOpts(options), desc);
	});

	d.gs = function (dscr, get, set/*, options*/) {
		var c, e, options, desc;
		if (typeof dscr !== "string") {
			options = set;
			set = get;
			get = dscr;
			dscr = null;
		} else {
			options = arguments[3];
		}
		if (!isValue(get)) {
			get = undefined;
		} else if (!isPlainFunction(get)) {
			options = get;
			get = set = undefined;
		} else if (!isValue(set)) {
			set = undefined;
		} else if (!isPlainFunction(set)) {
			options = set;
			set = undefined;
		}
		if (isValue(dscr)) {
			c = contains.call(dscr, "c");
			e = contains.call(dscr, "e");
		} else {
			c = true;
			e = false;
		}

		desc = { get: get, set: set, configurable: c, enumerable: e };
		return !options ? desc : assign$4(normalizeOpts(options), desc);
	};

	var dExports = d$1.exports;

	var validCallable = function (fn) {
		if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
		return fn;
	};

	(function (module, exports) {

		var d        = dExports
		  , callable = validCallable

		  , apply = Function.prototype.apply, call = Function.prototype.call
		  , create = Object.create, defineProperty = Object.defineProperty
		  , defineProperties = Object.defineProperties
		  , hasOwnProperty = Object.prototype.hasOwnProperty
		  , descriptor = { configurable: true, enumerable: false, writable: true }

		  , on, once, off, emit, methods, descriptors, base;

		on = function (type, listener) {
			var data;

			callable(listener);

			if (!hasOwnProperty.call(this, '__ee__')) {
				data = descriptor.value = create(null);
				defineProperty(this, '__ee__', descriptor);
				descriptor.value = null;
			} else {
				data = this.__ee__;
			}
			if (!data[type]) data[type] = listener;
			else if (typeof data[type] === 'object') data[type].push(listener);
			else data[type] = [data[type], listener];

			return this;
		};

		once = function (type, listener) {
			var once, self;

			callable(listener);
			self = this;
			on.call(this, type, once = function () {
				off.call(self, type, once);
				apply.call(listener, this, arguments);
			});

			once.__eeOnceListener__ = listener;
			return this;
		};

		off = function (type, listener) {
			var data, listeners, candidate, i;

			callable(listener);

			if (!hasOwnProperty.call(this, '__ee__')) return this;
			data = this.__ee__;
			if (!data[type]) return this;
			listeners = data[type];

			if (typeof listeners === 'object') {
				for (i = 0; (candidate = listeners[i]); ++i) {
					if ((candidate === listener) ||
							(candidate.__eeOnceListener__ === listener)) {
						if (listeners.length === 2) data[type] = listeners[i ? 0 : 1];
						else listeners.splice(i, 1);
					}
				}
			} else {
				if ((listeners === listener) ||
						(listeners.__eeOnceListener__ === listener)) {
					delete data[type];
				}
			}

			return this;
		};

		emit = function (type) {
			var i, l, listener, listeners, args;

			if (!hasOwnProperty.call(this, '__ee__')) return;
			listeners = this.__ee__[type];
			if (!listeners) return;

			if (typeof listeners === 'object') {
				l = arguments.length;
				args = new Array(l - 1);
				for (i = 1; i < l; ++i) args[i - 1] = arguments[i];

				listeners = listeners.slice();
				for (i = 0; (listener = listeners[i]); ++i) {
					apply.call(listener, this, args);
				}
			} else {
				switch (arguments.length) {
				case 1:
					call.call(listeners, this);
					break;
				case 2:
					call.call(listeners, this, arguments[1]);
					break;
				case 3:
					call.call(listeners, this, arguments[1], arguments[2]);
					break;
				default:
					l = arguments.length;
					args = new Array(l - 1);
					for (i = 1; i < l; ++i) {
						args[i - 1] = arguments[i];
					}
					apply.call(listeners, this, args);
				}
			}
		};

		methods = {
			on: on,
			once: once,
			off: off,
			emit: emit
		};

		descriptors = {
			on: d(on),
			once: d(once),
			off: d(off),
			emit: d(emit)
		};

		base = defineProperties({}, descriptors);

		module.exports = exports = function (o) {
			return (o == null) ? create(base) : defineProperties(Object(o), descriptors);
		};
		exports.methods = methods; 
	} (eventEmitter, eventEmitter.exports));

	var eventEmitterExports = eventEmitter.exports;
	var ee = /*@__PURE__*/getDefaultExportFromCjs(eventEmitterExports);

	/**
	 * 获取 editor 的 emitter 实例
	 * @param editor editor
	 */
	function getEmitter(editor) {
	  var emitter = EDITOR_TO_EMITTER.get(editor);
	  if (emitter == null) {
	    emitter = ee();
	    EDITOR_TO_EMITTER.set(editor, emitter);
	  }
	  return emitter;
	}

	// 记录下当前 editor 的 destroy listeners
	var EDITOR_TO_DESTROY_LISTENERS = new _WeakMap$1();
	function recordDestroyListeners(editor, fn) {
	  var listeners = EDITOR_TO_DESTROY_LISTENERS.get(editor);
	  if (listeners == null) {
	    listeners = new _Set$1();
	    EDITOR_TO_DESTROY_LISTENERS.set(editor, listeners);
	  }
	  listeners.add(fn);
	}
	function getDestroyListeners(editor) {
	  return EDITOR_TO_DESTROY_LISTENERS.get(editor) || new _Set$1();
	}
	function clearDestroyListeners(editor) {
	  EDITOR_TO_DESTROY_LISTENERS.set(editor, new _Set$1());
	}
	var withEmitter = function withEmitter(editor) {
	  var e = editor;

	  // 自定义事件
	  e.on = function (type, listener) {
	    var emitter = getEmitter(e);

	    // 绑定事件
	    emitter.on(type, listener);

	    // destroyed 事件需要记录下来，以便最后统一 off 掉
	    if (type === 'destroyed') recordDestroyListeners(e, listener);

	    // editor 销毁时，取消绑定 - 重要
	    if (type !== 'destroyed') {
	      var fn = function fn() {
	        return emitter.off(type, listener);
	      };
	      emitter.on('destroyed', fn);
	      recordDestroyListeners(e, fn); // 记录下来
	    }
	  };

	  e.once = function (type, listener) {
	    var emitter = getEmitter(e);
	    emitter.once(type, listener);
	  };
	  e.off = function (type, listener) {
	    var emitter = getEmitter(e);
	    emitter.off(type, listener);
	  };
	  e.emit = function (type) {
	    var _context;
	    var emitter = getEmitter(e);
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	    emitter.emit.apply(emitter, _concatInstanceProperty(_context = [type]).call(_context, args));

	    // editor 销毁时，off 掉 destroyed listeners
	    if (type === 'destroyed') {
	      var listeners = getDestroyListeners(e);
	      _forEachInstanceProperty(listeners).call(listeners, function (fn) {
	        return emitter.off('destroyed', fn);
	      });
	      clearDestroyListeners(e); // 清空 destroyed listeners
	    }
	  };

	  return e;
	};

	var check$2 = function (it) {
	  return it && it.Math === Math && it;
	};

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global$p =
	  // eslint-disable-next-line es/no-global-this -- safe
	  check$2(typeof globalThis == 'object' && globalThis) ||
	  check$2(typeof window == 'object' && window) ||
	  // eslint-disable-next-line no-restricted-globals -- safe
	  check$2(typeof self == 'object' && self) ||
	  check$2(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
	  check$2(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
	  // eslint-disable-next-line no-new-func -- fallback
	  (function () { return this; })() || Function('return this')();

	var shared$4 = {exports: {}};

	var global$o = global$p;

	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var defineProperty$4 = Object.defineProperty;

	var defineGlobalProperty$3 = function (key, value) {
	  try {
	    defineProperty$4(global$o, key, { value: value, configurable: true, writable: true });
	  } catch (error) {
	    global$o[key] = value;
	  } return value;
	};

	var global$n = global$p;
	var defineGlobalProperty$2 = defineGlobalProperty$3;

	var SHARED = '__core-js_shared__';
	var store$3 = global$n[SHARED] || defineGlobalProperty$2(SHARED, {});

	var sharedStore = store$3;

	var store$2 = sharedStore;

	(shared$4.exports = function (key, value) {
	  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: '3.33.3',
	  mode: 'global',
	  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
	  license: 'https://github.com/zloirock/core-js/blob/v3.33.3/LICENSE',
	  source: 'https://github.com/zloirock/core-js'
	});

	var sharedExports = shared$4.exports;

	var fails$v = function (exec) {
	  try {
	    return !!exec();
	  } catch (error) {
	    return true;
	  }
	};

	var fails$u = fails$v;

	var functionBindNative = !fails$u(function () {
	  // eslint-disable-next-line es/no-function-prototype-bind -- safe
	  var test = (function () { /* empty */ }).bind();
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return typeof test != 'function' || test.hasOwnProperty('prototype');
	});

	var NATIVE_BIND$4 = functionBindNative;

	var FunctionPrototype$4 = Function.prototype;
	var call$i = FunctionPrototype$4.call;
	var uncurryThisWithBind = NATIVE_BIND$4 && FunctionPrototype$4.bind.bind(call$i, call$i);

	var functionUncurryThis = NATIVE_BIND$4 ? uncurryThisWithBind : function (fn) {
	  return function () {
	    return call$i.apply(fn, arguments);
	  };
	};

	// we can't use just `it == null` since of `document.all` special case
	// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
	var isNullOrUndefined$7 = function (it) {
	  return it === null || it === undefined;
	};

	var isNullOrUndefined$6 = isNullOrUndefined$7;

	var $TypeError$c = TypeError;

	// `RequireObjectCoercible` abstract operation
	// https://tc39.es/ecma262/#sec-requireobjectcoercible
	var requireObjectCoercible$c = function (it) {
	  if (isNullOrUndefined$6(it)) throw new $TypeError$c("Can't call method on " + it);
	  return it;
	};

	var requireObjectCoercible$b = requireObjectCoercible$c;

	var $Object$3 = Object;

	// `ToObject` abstract operation
	// https://tc39.es/ecma262/#sec-toobject
	var toObject$7 = function (argument) {
	  return $Object$3(requireObjectCoercible$b(argument));
	};

	var uncurryThis$y = functionUncurryThis;
	var toObject$6 = toObject$7;

	var hasOwnProperty$6 = uncurryThis$y({}.hasOwnProperty);

	// `HasOwnProperty` abstract operation
	// https://tc39.es/ecma262/#sec-hasownproperty
	// eslint-disable-next-line es/no-object-hasown -- safe
	var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
	  return hasOwnProperty$6(toObject$6(it), key);
	};

	var uncurryThis$x = functionUncurryThis;

	var id = 0;
	var postfix = Math.random();
	var toString$l = uncurryThis$x(1.0.toString);

	var uid$2 = function (key) {
	  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$l(++id + postfix, 36);
	};

	var engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

	var global$m = global$p;
	var userAgent$3 = engineUserAgent;

	var process$3 = global$m.process;
	var Deno$1 = global$m.Deno;
	var versions = process$3 && process$3.versions || Deno$1 && Deno$1.version;
	var v8 = versions && versions.v8;
	var match, version;

	if (v8) {
	  match = v8.split('.');
	  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
	  // but their correct versions are not interesting for us
	  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
	}

	// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
	// so check `userAgent` even if `.v8` exists, but 0
	if (!version && userAgent$3) {
	  match = userAgent$3.match(/Edge\/(\d+)/);
	  if (!match || match[1] >= 74) {
	    match = userAgent$3.match(/Chrome\/(\d+)/);
	    if (match) version = +match[1];
	  }
	}

	var engineV8Version = version;

	/* eslint-disable es/no-symbol -- required for testing */
	var V8_VERSION$2 = engineV8Version;
	var fails$t = fails$v;
	var global$l = global$p;

	var $String$5 = global$l.String;

	// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
	var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$t(function () {
	  var symbol = Symbol('symbol detection');
	  // Chrome 38 Symbol has incorrect toString conversion
	  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
	  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
	  // of course, fail.
	  return !$String$5(symbol) || !(Object(symbol) instanceof Symbol) ||
	    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
	    !Symbol.sham && V8_VERSION$2 && V8_VERSION$2 < 41;
	});

	/* eslint-disable es/no-symbol -- required for testing */
	var NATIVE_SYMBOL$1 = symbolConstructorDetection;

	var useSymbolAsUid = NATIVE_SYMBOL$1
	  && !Symbol.sham
	  && typeof Symbol.iterator == 'symbol';

	var global$k = global$p;
	var shared$3 = sharedExports;
	var hasOwn$a = hasOwnProperty_1;
	var uid$1 = uid$2;
	var NATIVE_SYMBOL = symbolConstructorDetection;
	var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

	var Symbol$7 = global$k.Symbol;
	var WellKnownSymbolsStore = shared$3('wks');
	var createWellKnownSymbol = USE_SYMBOL_AS_UID$1 ? Symbol$7['for'] || Symbol$7 : Symbol$7 && Symbol$7.withoutSetter || uid$1;

	var wellKnownSymbol$f = function (name) {
	  if (!hasOwn$a(WellKnownSymbolsStore, name)) {
	    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn$a(Symbol$7, name)
	      ? Symbol$7[name]
	      : createWellKnownSymbol('Symbol.' + name);
	  } return WellKnownSymbolsStore[name];
	};

	var wellKnownSymbol$e = wellKnownSymbol$f;

	var TO_STRING_TAG$2 = wellKnownSymbol$e('toStringTag');
	var test$1 = {};

	test$1[TO_STRING_TAG$2] = 'z';

	var toStringTagSupport = String(test$1) === '[object z]';

	var documentAll$2 = typeof document == 'object' && document.all;

	// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
	// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
	var IS_HTMLDDA = typeof documentAll$2 == 'undefined' && documentAll$2 !== undefined;

	var documentAll_1 = {
	  all: documentAll$2,
	  IS_HTMLDDA: IS_HTMLDDA
	};

	var $documentAll$1 = documentAll_1;

	var documentAll$1 = $documentAll$1.all;

	// `IsCallable` abstract operation
	// https://tc39.es/ecma262/#sec-iscallable
	var isCallable$j = $documentAll$1.IS_HTMLDDA ? function (argument) {
	  return typeof argument == 'function' || argument === documentAll$1;
	} : function (argument) {
	  return typeof argument == 'function';
	};

	var objectDefineProperty = {};

	var fails$s = fails$v;

	// Detect IE8's incomplete defineProperty implementation
	var descriptors = !fails$s(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
	});

	var isCallable$i = isCallable$j;
	var $documentAll = documentAll_1;

	var documentAll = $documentAll.all;

	var isObject$k = $documentAll.IS_HTMLDDA ? function (it) {
	  return typeof it == 'object' ? it !== null : isCallable$i(it) || it === documentAll;
	} : function (it) {
	  return typeof it == 'object' ? it !== null : isCallable$i(it);
	};

	var global$j = global$p;
	var isObject$j = isObject$k;

	var document$3 = global$j.document;
	// typeof document.createElement is 'object' in old IE
	var EXISTS$1 = isObject$j(document$3) && isObject$j(document$3.createElement);

	var documentCreateElement$1 = function (it) {
	  return EXISTS$1 ? document$3.createElement(it) : {};
	};

	var DESCRIPTORS$b = descriptors;
	var fails$r = fails$v;
	var createElement$2 = documentCreateElement$1;

	// Thanks to IE8 for its funny defineProperty
	var ie8DomDefine = !DESCRIPTORS$b && !fails$r(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty(createElement$2('div'), 'a', {
	    get: function () { return 7; }
	  }).a !== 7;
	});

	var DESCRIPTORS$a = descriptors;
	var fails$q = fails$v;

	// V8 ~ Chrome 36-
	// https://bugs.chromium.org/p/v8/issues/detail?id=3334
	var v8PrototypeDefineBug = DESCRIPTORS$a && fails$q(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
	    value: 42,
	    writable: false
	  }).prototype !== 42;
	});

	var isObject$i = isObject$k;

	var $String$4 = String;
	var $TypeError$b = TypeError;

	// `Assert: Type(argument) is Object`
	var anObject$e = function (argument) {
	  if (isObject$i(argument)) return argument;
	  throw new $TypeError$b($String$4(argument) + ' is not an object');
	};

	var NATIVE_BIND$3 = functionBindNative;

	var call$h = Function.prototype.call;

	var functionCall = NATIVE_BIND$3 ? call$h.bind(call$h) : function () {
	  return call$h.apply(call$h, arguments);
	};

	var global$i = global$p;
	var isCallable$h = isCallable$j;

	var aFunction = function (argument) {
	  return isCallable$h(argument) ? argument : undefined;
	};

	var getBuiltIn$8 = function (namespace, method) {
	  return arguments.length < 2 ? aFunction(global$i[namespace]) : global$i[namespace] && global$i[namespace][method];
	};

	var uncurryThis$w = functionUncurryThis;

	var objectIsPrototypeOf = uncurryThis$w({}.isPrototypeOf);

	var getBuiltIn$7 = getBuiltIn$8;
	var isCallable$g = isCallable$j;
	var isPrototypeOf$d = objectIsPrototypeOf;
	var USE_SYMBOL_AS_UID = useSymbolAsUid;

	var $Object$2 = Object;

	var isSymbol$5 = USE_SYMBOL_AS_UID ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  var $Symbol = getBuiltIn$7('Symbol');
	  return isCallable$g($Symbol) && isPrototypeOf$d($Symbol.prototype, $Object$2(it));
	};

	var $String$3 = String;

	var tryToString$3 = function (argument) {
	  try {
	    return $String$3(argument);
	  } catch (error) {
	    return 'Object';
	  }
	};

	var isCallable$f = isCallable$j;
	var tryToString$2 = tryToString$3;

	var $TypeError$a = TypeError;

	// `Assert: IsCallable(argument) is true`
	var aCallable$9 = function (argument) {
	  if (isCallable$f(argument)) return argument;
	  throw new $TypeError$a(tryToString$2(argument) + ' is not a function');
	};

	var aCallable$8 = aCallable$9;
	var isNullOrUndefined$5 = isNullOrUndefined$7;

	// `GetMethod` abstract operation
	// https://tc39.es/ecma262/#sec-getmethod
	var getMethod$4 = function (V, P) {
	  var func = V[P];
	  return isNullOrUndefined$5(func) ? undefined : aCallable$8(func);
	};

	var call$g = functionCall;
	var isCallable$e = isCallable$j;
	var isObject$h = isObject$k;

	var $TypeError$9 = TypeError;

	// `OrdinaryToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-ordinarytoprimitive
	var ordinaryToPrimitive$1 = function (input, pref) {
	  var fn, val;
	  if (pref === 'string' && isCallable$e(fn = input.toString) && !isObject$h(val = call$g(fn, input))) return val;
	  if (isCallable$e(fn = input.valueOf) && !isObject$h(val = call$g(fn, input))) return val;
	  if (pref !== 'string' && isCallable$e(fn = input.toString) && !isObject$h(val = call$g(fn, input))) return val;
	  throw new $TypeError$9("Can't convert object to primitive value");
	};

	var call$f = functionCall;
	var isObject$g = isObject$k;
	var isSymbol$4 = isSymbol$5;
	var getMethod$3 = getMethod$4;
	var ordinaryToPrimitive = ordinaryToPrimitive$1;
	var wellKnownSymbol$d = wellKnownSymbol$f;

	var $TypeError$8 = TypeError;
	var TO_PRIMITIVE = wellKnownSymbol$d('toPrimitive');

	// `ToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-toprimitive
	var toPrimitive$1 = function (input, pref) {
	  if (!isObject$g(input) || isSymbol$4(input)) return input;
	  var exoticToPrim = getMethod$3(input, TO_PRIMITIVE);
	  var result;
	  if (exoticToPrim) {
	    if (pref === undefined) pref = 'default';
	    result = call$f(exoticToPrim, input, pref);
	    if (!isObject$g(result) || isSymbol$4(result)) return result;
	    throw new $TypeError$8("Can't convert object to primitive value");
	  }
	  if (pref === undefined) pref = 'number';
	  return ordinaryToPrimitive(input, pref);
	};

	var toPrimitive = toPrimitive$1;
	var isSymbol$3 = isSymbol$5;

	// `ToPropertyKey` abstract operation
	// https://tc39.es/ecma262/#sec-topropertykey
	var toPropertyKey$3 = function (argument) {
	  var key = toPrimitive(argument, 'string');
	  return isSymbol$3(key) ? key : key + '';
	};

	var DESCRIPTORS$9 = descriptors;
	var IE8_DOM_DEFINE$1 = ie8DomDefine;
	var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
	var anObject$d = anObject$e;
	var toPropertyKey$2 = toPropertyKey$3;

	var $TypeError$7 = TypeError;
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var $defineProperty = Object.defineProperty;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
	var ENUMERABLE = 'enumerable';
	var CONFIGURABLE$1 = 'configurable';
	var WRITABLE = 'writable';

	// `Object.defineProperty` method
	// https://tc39.es/ecma262/#sec-object.defineproperty
	objectDefineProperty.f = DESCRIPTORS$9 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
	  anObject$d(O);
	  P = toPropertyKey$2(P);
	  anObject$d(Attributes);
	  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
	    var current = $getOwnPropertyDescriptor$1(O, P);
	    if (current && current[WRITABLE]) {
	      O[P] = Attributes.value;
	      Attributes = {
	        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
	        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
	        writable: false
	      };
	    }
	  } return $defineProperty(O, P, Attributes);
	} : $defineProperty : function defineProperty(O, P, Attributes) {
	  anObject$d(O);
	  P = toPropertyKey$2(P);
	  anObject$d(Attributes);
	  if (IE8_DOM_DEFINE$1) try {
	    return $defineProperty(O, P, Attributes);
	  } catch (error) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$7('Accessors not supported');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};

	var makeBuiltIn$3 = {exports: {}};

	var DESCRIPTORS$8 = descriptors;
	var hasOwn$9 = hasOwnProperty_1;

	var FunctionPrototype$3 = Function.prototype;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getDescriptor = DESCRIPTORS$8 && Object.getOwnPropertyDescriptor;

	var EXISTS = hasOwn$9(FunctionPrototype$3, 'name');
	// additional protection from minified / mangled / dropped function names
	var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
	var CONFIGURABLE = EXISTS && (!DESCRIPTORS$8 || (DESCRIPTORS$8 && getDescriptor(FunctionPrototype$3, 'name').configurable));

	var functionName = {
	  EXISTS: EXISTS,
	  PROPER: PROPER,
	  CONFIGURABLE: CONFIGURABLE
	};

	var uncurryThis$v = functionUncurryThis;
	var isCallable$d = isCallable$j;
	var store$1 = sharedStore;

	var functionToString$1 = uncurryThis$v(Function.toString);

	// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
	if (!isCallable$d(store$1.inspectSource)) {
	  store$1.inspectSource = function (it) {
	    return functionToString$1(it);
	  };
	}

	var inspectSource$3 = store$1.inspectSource;

	var global$h = global$p;
	var isCallable$c = isCallable$j;

	var WeakMap$4 = global$h.WeakMap;

	var weakMapBasicDetection = isCallable$c(WeakMap$4) && /native code/.test(String(WeakMap$4));

	var createPropertyDescriptor$5 = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};

	var DESCRIPTORS$7 = descriptors;
	var definePropertyModule$5 = objectDefineProperty;
	var createPropertyDescriptor$4 = createPropertyDescriptor$5;

	var createNonEnumerableProperty$6 = DESCRIPTORS$7 ? function (object, key, value) {
	  return definePropertyModule$5.f(object, key, createPropertyDescriptor$4(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};

	var shared$2 = sharedExports;
	var uid = uid$2;

	var keys$3 = shared$2('keys');

	var sharedKey$2 = function (key) {
	  return keys$3[key] || (keys$3[key] = uid(key));
	};

	var hiddenKeys$4 = {};

	var NATIVE_WEAK_MAP = weakMapBasicDetection;
	var global$g = global$p;
	var isObject$f = isObject$k;
	var createNonEnumerableProperty$5 = createNonEnumerableProperty$6;
	var hasOwn$8 = hasOwnProperty_1;
	var shared$1 = sharedStore;
	var sharedKey$1 = sharedKey$2;
	var hiddenKeys$3 = hiddenKeys$4;

	var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
	var TypeError$2 = global$g.TypeError;
	var WeakMap$3 = global$g.WeakMap;
	var set$1, get, has;

	var enforce = function (it) {
	  return has(it) ? get(it) : set$1(it, {});
	};

	var getterFor = function (TYPE) {
	  return function (it) {
	    var state;
	    if (!isObject$f(it) || (state = get(it)).type !== TYPE) {
	      throw new TypeError$2('Incompatible receiver, ' + TYPE + ' required');
	    } return state;
	  };
	};

	if (NATIVE_WEAK_MAP || shared$1.state) {
	  var store = shared$1.state || (shared$1.state = new WeakMap$3());
	  /* eslint-disable no-self-assign -- prototype methods protection */
	  store.get = store.get;
	  store.has = store.has;
	  store.set = store.set;
	  /* eslint-enable no-self-assign -- prototype methods protection */
	  set$1 = function (it, metadata) {
	    if (store.has(it)) throw new TypeError$2(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    store.set(it, metadata);
	    return metadata;
	  };
	  get = function (it) {
	    return store.get(it) || {};
	  };
	  has = function (it) {
	    return store.has(it);
	  };
	} else {
	  var STATE = sharedKey$1('state');
	  hiddenKeys$3[STATE] = true;
	  set$1 = function (it, metadata) {
	    if (hasOwn$8(it, STATE)) throw new TypeError$2(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    createNonEnumerableProperty$5(it, STATE, metadata);
	    return metadata;
	  };
	  get = function (it) {
	    return hasOwn$8(it, STATE) ? it[STATE] : {};
	  };
	  has = function (it) {
	    return hasOwn$8(it, STATE);
	  };
	}

	var internalState = {
	  set: set$1,
	  get: get,
	  has: has,
	  enforce: enforce,
	  getterFor: getterFor
	};

	var uncurryThis$u = functionUncurryThis;
	var fails$p = fails$v;
	var isCallable$b = isCallable$j;
	var hasOwn$7 = hasOwnProperty_1;
	var DESCRIPTORS$6 = descriptors;
	var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
	var inspectSource$2 = inspectSource$3;
	var InternalStateModule$1 = internalState;

	var enforceInternalState = InternalStateModule$1.enforce;
	var getInternalState$1 = InternalStateModule$1.get;
	var $String$2 = String;
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var defineProperty$3 = Object.defineProperty;
	var stringSlice$8 = uncurryThis$u(''.slice);
	var replace$5 = uncurryThis$u(''.replace);
	var join$1 = uncurryThis$u([].join);

	var CONFIGURABLE_LENGTH = DESCRIPTORS$6 && !fails$p(function () {
	  return defineProperty$3(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
	});

	var TEMPLATE = String(String).split('String');

	var makeBuiltIn$2 = makeBuiltIn$3.exports = function (value, name, options) {
	  if (stringSlice$8($String$2(name), 0, 7) === 'Symbol(') {
	    name = '[' + replace$5($String$2(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
	  }
	  if (options && options.getter) name = 'get ' + name;
	  if (options && options.setter) name = 'set ' + name;
	  if (!hasOwn$7(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
	    if (DESCRIPTORS$6) defineProperty$3(value, 'name', { value: name, configurable: true });
	    else value.name = name;
	  }
	  if (CONFIGURABLE_LENGTH && options && hasOwn$7(options, 'arity') && value.length !== options.arity) {
	    defineProperty$3(value, 'length', { value: options.arity });
	  }
	  try {
	    if (options && hasOwn$7(options, 'constructor') && options.constructor) {
	      if (DESCRIPTORS$6) defineProperty$3(value, 'prototype', { writable: false });
	    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
	    } else if (value.prototype) value.prototype = undefined;
	  } catch (error) { /* empty */ }
	  var state = enforceInternalState(value);
	  if (!hasOwn$7(state, 'source')) {
	    state.source = join$1(TEMPLATE, typeof name == 'string' ? name : '');
	  } return value;
	};

	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	// eslint-disable-next-line no-extend-native -- required
	Function.prototype.toString = makeBuiltIn$2(function toString() {
	  return isCallable$b(this) && getInternalState$1(this).source || inspectSource$2(this);
	}, 'toString');

	var makeBuiltInExports = makeBuiltIn$3.exports;

	var isCallable$a = isCallable$j;
	var definePropertyModule$4 = objectDefineProperty;
	var makeBuiltIn$1 = makeBuiltInExports;
	var defineGlobalProperty$1 = defineGlobalProperty$3;

	var defineBuiltIn$5 = function (O, key, value, options) {
	  if (!options) options = {};
	  var simple = options.enumerable;
	  var name = options.name !== undefined ? options.name : key;
	  if (isCallable$a(value)) makeBuiltIn$1(value, name, options);
	  if (options.global) {
	    if (simple) O[key] = value;
	    else defineGlobalProperty$1(key, value);
	  } else {
	    try {
	      if (!options.unsafe) delete O[key];
	      else if (O[key]) simple = true;
	    } catch (error) { /* empty */ }
	    if (simple) O[key] = value;
	    else definePropertyModule$4.f(O, key, {
	      value: value,
	      enumerable: false,
	      configurable: !options.nonConfigurable,
	      writable: !options.nonWritable
	    });
	  } return O;
	};

	var uncurryThis$t = functionUncurryThis;

	var toString$k = uncurryThis$t({}.toString);
	var stringSlice$7 = uncurryThis$t(''.slice);

	var classofRaw$2 = function (it) {
	  return stringSlice$7(toString$k(it), 8, -1);
	};

	var TO_STRING_TAG_SUPPORT$2 = toStringTagSupport;
	var isCallable$9 = isCallable$j;
	var classofRaw$1 = classofRaw$2;
	var wellKnownSymbol$c = wellKnownSymbol$f;

	var TO_STRING_TAG$1 = wellKnownSymbol$c('toStringTag');
	var $Object$1 = Object;

	// ES3 wrong here
	var CORRECT_ARGUMENTS = classofRaw$1(function () { return arguments; }()) === 'Arguments';

	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (error) { /* empty */ }
	};

	// getting tag from ES6+ `Object.prototype.toString`
	var classof$9 = TO_STRING_TAG_SUPPORT$2 ? classofRaw$1 : function (it) {
	  var O, tag, result;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (tag = tryGet(O = $Object$1(it), TO_STRING_TAG$1)) == 'string' ? tag
	    // builtinTag case
	    : CORRECT_ARGUMENTS ? classofRaw$1(O)
	    // ES3 arguments fallback
	    : (result = classofRaw$1(O)) === 'Object' && isCallable$9(O.callee) ? 'Arguments' : result;
	};

	var TO_STRING_TAG_SUPPORT$1 = toStringTagSupport;
	var classof$8 = classof$9;

	// `Object.prototype.toString` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.tostring
	var objectToString$2 = TO_STRING_TAG_SUPPORT$1 ? {}.toString : function toString() {
	  return '[object ' + classof$8(this) + ']';
	};

	var TO_STRING_TAG_SUPPORT = toStringTagSupport;
	var defineBuiltIn$4 = defineBuiltIn$5;
	var toString$j = objectToString$2;

	// `Object.prototype.toString` method
	// https://tc39.es/ecma262/#sec-object.prototype.tostring
	if (!TO_STRING_TAG_SUPPORT) {
	  defineBuiltIn$4(Object.prototype, 'toString', toString$j, { unsafe: true });
	}

	var classof$7 = classof$9;

	var $String$1 = String;

	var toString$i = function (argument) {
	  if (classof$7(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
	  return $String$1(argument);
	};

	var anObject$c = anObject$e;

	// `RegExp.prototype.flags` getter implementation
	// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
	var regexpFlags$1 = function () {
	  var that = anObject$c(this);
	  var result = '';
	  if (that.hasIndices) result += 'd';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.dotAll) result += 's';
	  if (that.unicode) result += 'u';
	  if (that.unicodeSets) result += 'v';
	  if (that.sticky) result += 'y';
	  return result;
	};

	var call$e = functionCall;
	var hasOwn$6 = hasOwnProperty_1;
	var isPrototypeOf$c = objectIsPrototypeOf;
	var regExpFlags = regexpFlags$1;

	var RegExpPrototype$2 = RegExp.prototype;

	var regexpGetFlags = function (R) {
	  var flags = R.flags;
	  return flags === undefined && !('flags' in RegExpPrototype$2) && !hasOwn$6(R, 'flags') && isPrototypeOf$c(RegExpPrototype$2, R)
	    ? call$e(regExpFlags, R) : flags;
	};

	var PROPER_FUNCTION_NAME$1 = functionName.PROPER;
	var defineBuiltIn$3 = defineBuiltIn$5;
	var anObject$b = anObject$e;
	var $toString = toString$i;
	var fails$o = fails$v;
	var getRegExpFlags = regexpGetFlags;

	var TO_STRING = 'toString';
	var RegExpPrototype$1 = RegExp.prototype;
	var nativeToString = RegExpPrototype$1[TO_STRING];

	var NOT_GENERIC = fails$o(function () { return nativeToString.call({ source: 'a', flags: 'b' }) !== '/a/b'; });
	// FF44- RegExp#toString has a wrong name
	var INCORRECT_NAME = PROPER_FUNCTION_NAME$1 && nativeToString.name !== TO_STRING;

	// `RegExp.prototype.toString` method
	// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
	if (NOT_GENERIC || INCORRECT_NAME) {
	  defineBuiltIn$3(RegExp.prototype, TO_STRING, function toString() {
	    var R = anObject$b(this);
	    var pattern = $toString(R.source);
	    var flags = $toString(getRegExpFlags(R));
	    return '/' + pattern + '/' + flags;
	  }, { unsafe: true });
	}

	var makeBuiltIn = makeBuiltInExports;
	var defineProperty$2 = objectDefineProperty;

	var defineBuiltInAccessor$1 = function (target, name, descriptor) {
	  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
	  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
	  return defineProperty$2.f(target, name, descriptor);
	};

	var DESCRIPTORS$5 = descriptors;
	var FUNCTION_NAME_EXISTS = functionName.EXISTS;
	var uncurryThis$s = functionUncurryThis;
	var defineBuiltInAccessor = defineBuiltInAccessor$1;

	var FunctionPrototype$2 = Function.prototype;
	var functionToString = uncurryThis$s(FunctionPrototype$2.toString);
	var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
	var regExpExec$2 = uncurryThis$s(nameRE.exec);
	var NAME = 'name';

	// Function instances `.name` property
	// https://tc39.es/ecma262/#sec-function-instances-name
	if (DESCRIPTORS$5 && !FUNCTION_NAME_EXISTS) {
	  defineBuiltInAccessor(FunctionPrototype$2, NAME, {
	    configurable: true,
	    get: function () {
	      try {
	        return regExpExec$2(nameRE, functionToString(this))[1];
	      } catch (error) {
	        return '';
	      }
	    }
	  });
	}

	var objectGetOwnPropertyDescriptor = {};

	var objectPropertyIsEnumerable = {};

	var $propertyIsEnumerable = {}.propertyIsEnumerable;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getOwnPropertyDescriptor$3 = Object.getOwnPropertyDescriptor;

	// Nashorn ~ JDK8 bug
	var NASHORN_BUG = getOwnPropertyDescriptor$3 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

	// `Object.prototype.propertyIsEnumerable` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
	objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
	  var descriptor = getOwnPropertyDescriptor$3(this, V);
	  return !!descriptor && descriptor.enumerable;
	} : $propertyIsEnumerable;

	var uncurryThis$r = functionUncurryThis;
	var fails$n = fails$v;
	var classof$6 = classofRaw$2;

	var $Object = Object;
	var split = uncurryThis$r(''.split);

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var indexedObject = fails$n(function () {
	  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return !$Object('z').propertyIsEnumerable(0);
	}) ? function (it) {
	  return classof$6(it) === 'String' ? split(it, '') : $Object(it);
	} : $Object;

	// toObject with fallback for non-array-like ES3 strings
	var IndexedObject$3 = indexedObject;
	var requireObjectCoercible$a = requireObjectCoercible$c;

	var toIndexedObject$5 = function (it) {
	  return IndexedObject$3(requireObjectCoercible$a(it));
	};

	var DESCRIPTORS$4 = descriptors;
	var call$d = functionCall;
	var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
	var createPropertyDescriptor$3 = createPropertyDescriptor$5;
	var toIndexedObject$4 = toIndexedObject$5;
	var toPropertyKey$1 = toPropertyKey$3;
	var hasOwn$5 = hasOwnProperty_1;
	var IE8_DOM_DEFINE = ie8DomDefine;

	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

	// `Object.getOwnPropertyDescriptor` method
	// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
	objectGetOwnPropertyDescriptor.f = DESCRIPTORS$4 ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
	  O = toIndexedObject$4(O);
	  P = toPropertyKey$1(P);
	  if (IE8_DOM_DEFINE) try {
	    return $getOwnPropertyDescriptor(O, P);
	  } catch (error) { /* empty */ }
	  if (hasOwn$5(O, P)) return createPropertyDescriptor$3(!call$d(propertyIsEnumerableModule$1.f, O, P), O[P]);
	};

	var objectGetOwnPropertyNames = {};

	var ceil = Math.ceil;
	var floor$2 = Math.floor;

	// `Math.trunc` method
	// https://tc39.es/ecma262/#sec-math.trunc
	// eslint-disable-next-line es/no-math-trunc -- safe
	var mathTrunc = Math.trunc || function trunc(x) {
	  var n = +x;
	  return (n > 0 ? floor$2 : ceil)(n);
	};

	var trunc = mathTrunc;

	// `ToIntegerOrInfinity` abstract operation
	// https://tc39.es/ecma262/#sec-tointegerorinfinity
	var toIntegerOrInfinity$6 = function (argument) {
	  var number = +argument;
	  // eslint-disable-next-line no-self-compare -- NaN check
	  return number !== number || number === 0 ? 0 : trunc(number);
	};

	var toIntegerOrInfinity$5 = toIntegerOrInfinity$6;

	var max$2 = Math.max;
	var min$5 = Math.min;

	// Helper for a popular repeating case of the spec:
	// Let integer be ? ToInteger(index).
	// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
	var toAbsoluteIndex$2 = function (index, length) {
	  var integer = toIntegerOrInfinity$5(index);
	  return integer < 0 ? max$2(integer + length, 0) : min$5(integer, length);
	};

	var toIntegerOrInfinity$4 = toIntegerOrInfinity$6;

	var min$4 = Math.min;

	// `ToLength` abstract operation
	// https://tc39.es/ecma262/#sec-tolength
	var toLength$6 = function (argument) {
	  return argument > 0 ? min$4(toIntegerOrInfinity$4(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
	};

	var toLength$5 = toLength$6;

	// `LengthOfArrayLike` abstract operation
	// https://tc39.es/ecma262/#sec-lengthofarraylike
	var lengthOfArrayLike$4 = function (obj) {
	  return toLength$5(obj.length);
	};

	var toIndexedObject$3 = toIndexedObject$5;
	var toAbsoluteIndex$1 = toAbsoluteIndex$2;
	var lengthOfArrayLike$3 = lengthOfArrayLike$4;

	// `Array.prototype.{ indexOf, includes }` methods implementation
	var createMethod$3 = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIndexedObject$3($this);
	    var length = lengthOfArrayLike$3(O);
	    var index = toAbsoluteIndex$1(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare -- NaN check
	    if (IS_INCLUDES && el !== el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare -- NaN check
	      if (value !== value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) {
	      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

	var arrayIncludes = {
	  // `Array.prototype.includes` method
	  // https://tc39.es/ecma262/#sec-array.prototype.includes
	  includes: createMethod$3(true),
	  // `Array.prototype.indexOf` method
	  // https://tc39.es/ecma262/#sec-array.prototype.indexof
	  indexOf: createMethod$3(false)
	};

	var uncurryThis$q = functionUncurryThis;
	var hasOwn$4 = hasOwnProperty_1;
	var toIndexedObject$2 = toIndexedObject$5;
	var indexOf$5 = arrayIncludes.indexOf;
	var hiddenKeys$2 = hiddenKeys$4;

	var push$b = uncurryThis$q([].push);

	var objectKeysInternal = function (object, names) {
	  var O = toIndexedObject$2(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) !hasOwn$4(hiddenKeys$2, key) && hasOwn$4(O, key) && push$b(result, key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (hasOwn$4(O, key = names[i++])) {
	    ~indexOf$5(result, key) || push$b(result, key);
	  }
	  return result;
	};

	// IE8- don't enum bug keys
	var enumBugKeys$3 = [
	  'constructor',
	  'hasOwnProperty',
	  'isPrototypeOf',
	  'propertyIsEnumerable',
	  'toLocaleString',
	  'toString',
	  'valueOf'
	];

	var internalObjectKeys$1 = objectKeysInternal;
	var enumBugKeys$2 = enumBugKeys$3;

	var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

	// `Object.getOwnPropertyNames` method
	// https://tc39.es/ecma262/#sec-object.getownpropertynames
	// eslint-disable-next-line es/no-object-getownpropertynames -- safe
	objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return internalObjectKeys$1(O, hiddenKeys$1);
	};

	var objectGetOwnPropertySymbols = {};

	// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
	objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

	var getBuiltIn$6 = getBuiltIn$8;
	var uncurryThis$p = functionUncurryThis;
	var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
	var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
	var anObject$a = anObject$e;

	var concat$3 = uncurryThis$p([].concat);

	// all object keys, includes non-enumerable and symbols
	var ownKeys$9 = getBuiltIn$6('Reflect', 'ownKeys') || function ownKeys(it) {
	  var keys = getOwnPropertyNamesModule.f(anObject$a(it));
	  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
	  return getOwnPropertySymbols ? concat$3(keys, getOwnPropertySymbols(it)) : keys;
	};

	var hasOwn$3 = hasOwnProperty_1;
	var ownKeys$8 = ownKeys$9;
	var getOwnPropertyDescriptorModule$1 = objectGetOwnPropertyDescriptor;
	var definePropertyModule$3 = objectDefineProperty;

	var copyConstructorProperties$3 = function (target, source, exceptions) {
	  var keys = ownKeys$8(source);
	  var defineProperty = definePropertyModule$3.f;
	  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule$1.f;
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (!hasOwn$3(target, key) && !(exceptions && hasOwn$3(exceptions, key))) {
	      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
	    }
	  }
	};

	var fails$m = fails$v;
	var isCallable$8 = isCallable$j;

	var replacement = /#|\.prototype\./;

	var isForced$2 = function (feature, detection) {
	  var value = data[normalize(feature)];
	  return value === POLYFILL ? true
	    : value === NATIVE ? false
	    : isCallable$8(detection) ? fails$m(detection)
	    : !!detection;
	};

	var normalize = isForced$2.normalize = function (string) {
	  return String(string).replace(replacement, '.').toLowerCase();
	};

	var data = isForced$2.data = {};
	var NATIVE = isForced$2.NATIVE = 'N';
	var POLYFILL = isForced$2.POLYFILL = 'P';

	var isForced_1 = isForced$2;

	var global$f = global$p;
	var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
	var createNonEnumerableProperty$4 = createNonEnumerableProperty$6;
	var defineBuiltIn$2 = defineBuiltIn$5;
	var defineGlobalProperty = defineGlobalProperty$3;
	var copyConstructorProperties$2 = copyConstructorProperties$3;
	var isForced$1 = isForced_1;

	/*
	  options.target         - name of the target object
	  options.global         - target is the global object
	  options.stat           - export as static methods of target
	  options.proto          - export as prototype methods of target
	  options.real           - real prototype method for the `pure` version
	  options.forced         - export even if the native feature is available
	  options.bind           - bind methods to the target, required for the `pure` version
	  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
	  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
	  options.sham           - add a flag to not completely full polyfills
	  options.enumerable     - export as enumerable property
	  options.dontCallGetSet - prevent calling a getter on target
	  options.name           - the .name of the function if it does not match the key
	*/
	var _export = function (options, source) {
	  var TARGET = options.target;
	  var GLOBAL = options.global;
	  var STATIC = options.stat;
	  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
	  if (GLOBAL) {
	    target = global$f;
	  } else if (STATIC) {
	    target = global$f[TARGET] || defineGlobalProperty(TARGET, {});
	  } else {
	    target = (global$f[TARGET] || {}).prototype;
	  }
	  if (target) for (key in source) {
	    sourceProperty = source[key];
	    if (options.dontCallGetSet) {
	      descriptor = getOwnPropertyDescriptor$2(target, key);
	      targetProperty = descriptor && descriptor.value;
	    } else targetProperty = target[key];
	    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
	    // contained in target
	    if (!FORCED && targetProperty !== undefined) {
	      if (typeof sourceProperty == typeof targetProperty) continue;
	      copyConstructorProperties$2(sourceProperty, targetProperty);
	    }
	    // add a flag to not completely full polyfills
	    if (options.sham || (targetProperty && targetProperty.sham)) {
	      createNonEnumerableProperty$4(sourceProperty, 'sham', true);
	    }
	    defineBuiltIn$2(target, key, sourceProperty, options);
	  }
	};

	var fails$l = fails$v;
	var global$e = global$p;

	// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
	var $RegExp$2 = global$e.RegExp;

	var UNSUPPORTED_Y$2 = fails$l(function () {
	  var re = $RegExp$2('a', 'y');
	  re.lastIndex = 2;
	  return re.exec('abcd') !== null;
	});

	// UC Browser bug
	// https://github.com/zloirock/core-js/issues/1008
	var MISSED_STICKY = UNSUPPORTED_Y$2 || fails$l(function () {
	  return !$RegExp$2('a', 'y').sticky;
	});

	var BROKEN_CARET = UNSUPPORTED_Y$2 || fails$l(function () {
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
	  var re = $RegExp$2('^r', 'gy');
	  re.lastIndex = 2;
	  return re.exec('str') !== null;
	});

	var regexpStickyHelpers = {
	  BROKEN_CARET: BROKEN_CARET,
	  MISSED_STICKY: MISSED_STICKY,
	  UNSUPPORTED_Y: UNSUPPORTED_Y$2
	};

	var objectDefineProperties = {};

	var internalObjectKeys = objectKeysInternal;
	var enumBugKeys$1 = enumBugKeys$3;

	// `Object.keys` method
	// https://tc39.es/ecma262/#sec-object.keys
	// eslint-disable-next-line es/no-object-keys -- safe
	var objectKeys$2 = Object.keys || function keys(O) {
	  return internalObjectKeys(O, enumBugKeys$1);
	};

	var DESCRIPTORS$3 = descriptors;
	var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
	var definePropertyModule$2 = objectDefineProperty;
	var anObject$9 = anObject$e;
	var toIndexedObject$1 = toIndexedObject$5;
	var objectKeys$1 = objectKeys$2;

	// `Object.defineProperties` method
	// https://tc39.es/ecma262/#sec-object.defineproperties
	// eslint-disable-next-line es/no-object-defineproperties -- safe
	objectDefineProperties.f = DESCRIPTORS$3 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject$9(O);
	  var props = toIndexedObject$1(Properties);
	  var keys = objectKeys$1(Properties);
	  var length = keys.length;
	  var index = 0;
	  var key;
	  while (length > index) definePropertyModule$2.f(O, key = keys[index++], props[key]);
	  return O;
	};

	var getBuiltIn$5 = getBuiltIn$8;

	var html$3 = getBuiltIn$5('document', 'documentElement');

	/* global ActiveXObject -- old IE, WSH */
	var anObject$8 = anObject$e;
	var definePropertiesModule = objectDefineProperties;
	var enumBugKeys = enumBugKeys$3;
	var hiddenKeys = hiddenKeys$4;
	var html$2 = html$3;
	var documentCreateElement = documentCreateElement$1;
	var sharedKey = sharedKey$2;

	var GT = '>';
	var LT = '<';
	var PROTOTYPE = 'prototype';
	var SCRIPT = 'script';
	var IE_PROTO = sharedKey('IE_PROTO');

	var EmptyConstructor = function () { /* empty */ };

	var scriptTag = function (content) {
	  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
	};

	// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
	var NullProtoObjectViaActiveX = function (activeXDocument) {
	  activeXDocument.write(scriptTag(''));
	  activeXDocument.close();
	  var temp = activeXDocument.parentWindow.Object;
	  activeXDocument = null; // avoid memory leak
	  return temp;
	};

	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var NullProtoObjectViaIFrame = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = documentCreateElement('iframe');
	  var JS = 'java' + SCRIPT + ':';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  html$2.appendChild(iframe);
	  // https://github.com/zloirock/core-js/issues/475
	  iframe.src = String(JS);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(scriptTag('document.F=Object'));
	  iframeDocument.close();
	  return iframeDocument.F;
	};

	// Check for document.domain and active x support
	// No need to use active x approach when document.domain is not set
	// see https://github.com/es-shims/es5-shim/issues/150
	// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
	// avoid IE GC bug
	var activeXDocument;
	var NullProtoObject = function () {
	  try {
	    activeXDocument = new ActiveXObject('htmlfile');
	  } catch (error) { /* ignore */ }
	  NullProtoObject = typeof document != 'undefined'
	    ? document.domain && activeXDocument
	      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
	      : NullProtoObjectViaIFrame()
	    : NullProtoObjectViaActiveX(activeXDocument); // WSH
	  var length = enumBugKeys.length;
	  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
	  return NullProtoObject();
	};

	hiddenKeys[IE_PROTO] = true;

	// `Object.create` method
	// https://tc39.es/ecma262/#sec-object.create
	// eslint-disable-next-line es/no-object-create -- safe
	var objectCreate = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    EmptyConstructor[PROTOTYPE] = anObject$8(O);
	    result = new EmptyConstructor();
	    EmptyConstructor[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = NullProtoObject();
	  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
	};

	var fails$k = fails$v;
	var global$d = global$p;

	// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
	var $RegExp$1 = global$d.RegExp;

	var regexpUnsupportedDotAll = fails$k(function () {
	  var re = $RegExp$1('.', 's');
	  return !(re.dotAll && re.test('\n') && re.flags === 's');
	});

	var fails$j = fails$v;
	var global$c = global$p;

	// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
	var $RegExp = global$c.RegExp;

	var regexpUnsupportedNcg = fails$j(function () {
	  var re = $RegExp('(?<a>b)', 'g');
	  return re.exec('b').groups.a !== 'b' ||
	    'b'.replace(re, '$<a>c') !== 'bc';
	});

	/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
	/* eslint-disable regexp/no-useless-quantifier -- testing */
	var call$c = functionCall;
	var uncurryThis$o = functionUncurryThis;
	var toString$h = toString$i;
	var regexpFlags = regexpFlags$1;
	var stickyHelpers$1 = regexpStickyHelpers;
	var shared = sharedExports;
	var create$a = objectCreate;
	var getInternalState = internalState.get;
	var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
	var UNSUPPORTED_NCG = regexpUnsupportedNcg;

	var nativeReplace = shared('native-string-replace', String.prototype.replace);
	var nativeExec = RegExp.prototype.exec;
	var patchedExec = nativeExec;
	var charAt$3 = uncurryThis$o(''.charAt);
	var indexOf$4 = uncurryThis$o(''.indexOf);
	var replace$4 = uncurryThis$o(''.replace);
	var stringSlice$6 = uncurryThis$o(''.slice);

	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/;
	  var re2 = /b*/g;
	  call$c(nativeExec, re1, 'a');
	  call$c(nativeExec, re2, 'a');
	  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
	})();

	var UNSUPPORTED_Y$1 = stickyHelpers$1.BROKEN_CARET;

	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$1 || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

	if (PATCH) {
	  patchedExec = function exec(string) {
	    var re = this;
	    var state = getInternalState(re);
	    var str = toString$h(string);
	    var raw = state.raw;
	    var result, reCopy, lastIndex, match, i, object, group;

	    if (raw) {
	      raw.lastIndex = re.lastIndex;
	      result = call$c(patchedExec, raw, str);
	      re.lastIndex = raw.lastIndex;
	      return result;
	    }

	    var groups = state.groups;
	    var sticky = UNSUPPORTED_Y$1 && re.sticky;
	    var flags = call$c(regexpFlags, re);
	    var source = re.source;
	    var charsAdded = 0;
	    var strCopy = str;

	    if (sticky) {
	      flags = replace$4(flags, 'y', '');
	      if (indexOf$4(flags, 'g') === -1) {
	        flags += 'g';
	      }

	      strCopy = stringSlice$6(str, re.lastIndex);
	      // Support anchored sticky behavior.
	      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$3(str, re.lastIndex - 1) !== '\n')) {
	        source = '(?: ' + source + ')';
	        strCopy = ' ' + strCopy;
	        charsAdded++;
	      }
	      // ^(? + rx + ) is needed, in combination with some str slicing, to
	      // simulate the 'y' flag.
	      reCopy = new RegExp('^(?:' + source + ')', flags);
	    }

	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

	    match = call$c(nativeExec, sticky ? reCopy : re, strCopy);

	    if (sticky) {
	      if (match) {
	        match.input = stringSlice$6(match.input, charsAdded);
	        match[0] = stringSlice$6(match[0], charsAdded);
	        match.index = re.lastIndex;
	        re.lastIndex += match[0].length;
	      } else re.lastIndex = 0;
	    } else if (UPDATES_LAST_INDEX_WRONG && match) {
	      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
	      call$c(nativeReplace, match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }

	    if (match && groups) {
	      match.groups = object = create$a(null);
	      for (i = 0; i < groups.length; i++) {
	        group = groups[i];
	        object[group[0]] = match[group[1]];
	      }
	    }

	    return match;
	  };
	}

	var regexpExec$3 = patchedExec;

	var $$J = _export;
	var exec$3 = regexpExec$3;

	// `RegExp.prototype.exec` method
	// https://tc39.es/ecma262/#sec-regexp.prototype.exec
	$$J({ target: 'RegExp', proto: true, forced: /./.exec !== exec$3 }, {
	  exec: exec$3
	});

	var slice$1 = slice$5;

	var _sliceInstanceProperty = /*@__PURE__*/getDefaultExportFromCjs(slice$1);

	var from = from$4;

	var _Array$from = /*@__PURE__*/getDefaultExportFromCjs(from);

	var symbol = symbol$4;

	var _Symbol$1 = /*@__PURE__*/getDefaultExportFromCjs(symbol);

	var getIteratorMethod = getIteratorMethod$4;

	var _getIteratorMethod = /*@__PURE__*/getDefaultExportFromCjs(getIteratorMethod);

	var isArray$9 = isArray$g;

	var _Array$isArray = /*@__PURE__*/getDefaultExportFromCjs(isArray$9);

	function _arrayWithHoles(arr) {
	  if (_Array$isArray$1(arr)) return arr;
	}

	var DESCRIPTORS$2 = descriptors$1;
	var isArray$8 = isArray$l;

	var $TypeError$6 = TypeError;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

	// Safari < 13 does not throw an error in this case
	var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS$2 && !function () {
	  // makes no sense without proper strict mode support
	  if (this !== undefined) return true;
	  try {
	    // eslint-disable-next-line es/no-object-defineproperty -- safe
	    Object.defineProperty([], 'length', { writable: false }).length = 1;
	  } catch (error) {
	    return error instanceof TypeError;
	  }
	}();

	var arraySetLength = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
	  if (isArray$8(O) && !getOwnPropertyDescriptor$1(O, 'length').writable) {
	    throw new $TypeError$6('Cannot set read only .length');
	  } return O.length = length;
	} : function (O, length) {
	  return O.length = length;
	};

	var $$I = _export$1;
	var toObject$5 = toObject$f;
	var lengthOfArrayLike$2 = lengthOfArrayLike$c;
	var setArrayLength = arraySetLength;
	var doesNotExceedSafeInteger = doesNotExceedSafeInteger$2;
	var fails$i = fails$T;

	var INCORRECT_TO_LENGTH = fails$i(function () {
	  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
	});

	// V8 and Safari <= 15.4, FF < 23 throws InternalError
	// https://bugs.chromium.org/p/v8/issues/detail?id=12681
	var properErrorOnNonWritableLength = function () {
	  try {
	    // eslint-disable-next-line es/no-object-defineproperty -- safe
	    Object.defineProperty([], 'length', { writable: false }).push();
	  } catch (error) {
	    return error instanceof TypeError;
	  }
	};

	var FORCED$5 = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

	// `Array.prototype.push` method
	// https://tc39.es/ecma262/#sec-array.prototype.push
	$$I({ target: 'Array', proto: true, arity: 1, forced: FORCED$5 }, {
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  push: function push(item) {
	    var O = toObject$5(this);
	    var len = lengthOfArrayLike$2(O);
	    var argCount = arguments.length;
	    doesNotExceedSafeInteger(len + argCount);
	    for (var i = 0; i < argCount; i++) {
	      O[len] = arguments[i];
	      len++;
	    }
	    setArrayLength(O, len);
	    return len;
	  }
	});

	var getBuiltInPrototypeMethod$b = getBuiltInPrototypeMethod$g;

	var push$a = getBuiltInPrototypeMethod$b('Array', 'push');

	var isPrototypeOf$b = objectIsPrototypeOf$1;
	var method$9 = push$a;

	var ArrayPrototype$7 = Array.prototype;

	var push$9 = function (it) {
	  var own = it.push;
	  return it === ArrayPrototype$7 || (isPrototypeOf$b(ArrayPrototype$7, it) && own === ArrayPrototype$7.push) ? method$9 : own;
	};

	var parent$E = push$9;

	var push$8 = parent$E;

	var parent$D = push$8;

	var push$7 = parent$D;

	var parent$C = push$7;

	var push$6 = parent$C;

	var push$5 = push$6;

	var _pushInstanceProperty = /*@__PURE__*/getDefaultExportFromCjs(push$5);

	function _iterableToArrayLimit(r, l) {
	  var t = null == r ? null : "undefined" != typeof _Symbol$2 && _getIteratorMethod$1(r) || r["@@iterator"];
	  if (null != t) {
	    var e,
	      n,
	      i,
	      u,
	      a = [],
	      f = !0,
	      o = !1;
	    try {
	      if (i = (t = t.call(r)).next, 0 === l) {
	        if (Object(t) !== t) return;
	        f = !1;
	      } else for (; !(f = (e = i.call(t)).done) && (_pushInstanceProperty(a).call(a, e.value), a.length !== l); f = !0);
	    } catch (r) {
	      o = !0, n = r;
	    } finally {
	      try {
	        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
	      } finally {
	        if (o) throw n;
	      }
	    }
	    return a;
	  }
	}

	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}

	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$6(arr, i) || _nonIterableRest();
	}

	var $$H = _export$1;
	var $map = arrayIteration$1.map;
	var arrayMethodHasSpeciesSupport$2 = arrayMethodHasSpeciesSupport$6;

	var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport$2('map');

	// `Array.prototype.map` method
	// https://tc39.es/ecma262/#sec-array.prototype.map
	// with adding support of @@species
	$$H({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$1 }, {
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

	var getBuiltInPrototypeMethod$a = getBuiltInPrototypeMethod$g;

	var map$3 = getBuiltInPrototypeMethod$a('Array', 'map');

	var isPrototypeOf$a = objectIsPrototypeOf$1;
	var method$8 = map$3;

	var ArrayPrototype$6 = Array.prototype;

	var map$2 = function (it) {
	  var own = it.map;
	  return it === ArrayPrototype$6 || (isPrototypeOf$a(ArrayPrototype$6, it) && own === ArrayPrototype$6.map) ? method$8 : own;
	};

	var parent$B = map$2;

	var map$1 = parent$B;

	var map = map$1;

	var _mapInstanceProperty = /*@__PURE__*/getDefaultExportFromCjs(map);

	/* eslint-disable es/no-array-prototype-indexof -- required for testing */
	var $$G = _export$1;
	var uncurryThis$n = functionUncurryThisClause$1;
	var $indexOf = arrayIncludes$1.indexOf;
	var arrayMethodIsStrict$3 = arrayMethodIsStrict$5;

	var nativeIndexOf = uncurryThis$n([].indexOf);

	var NEGATIVE_ZERO = !!nativeIndexOf && 1 / nativeIndexOf([1], 1, -0) < 0;
	var FORCED$4 = NEGATIVE_ZERO || !arrayMethodIsStrict$3('indexOf');

	// `Array.prototype.indexOf` method
	// https://tc39.es/ecma262/#sec-array.prototype.indexof
	$$G({ target: 'Array', proto: true, forced: FORCED$4 }, {
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? nativeIndexOf(this, searchElement, fromIndex) || 0
	      : $indexOf(this, searchElement, fromIndex);
	  }
	});

	var getBuiltInPrototypeMethod$9 = getBuiltInPrototypeMethod$g;

	var indexOf$3 = getBuiltInPrototypeMethod$9('Array', 'indexOf');

	var isPrototypeOf$9 = objectIsPrototypeOf$1;
	var method$7 = indexOf$3;

	var ArrayPrototype$5 = Array.prototype;

	var indexOf$2 = function (it) {
	  var own = it.indexOf;
	  return it === ArrayPrototype$5 || (isPrototypeOf$9(ArrayPrototype$5, it) && own === ArrayPrototype$5.indexOf) ? method$7 : own;
	};

	var parent$A = indexOf$2;

	var indexOf$1 = parent$A;

	var indexOf = indexOf$1;

	var _indexOfInstanceProperty = /*@__PURE__*/getDefaultExportFromCjs(indexOf);

	var uncurryThis$m = functionUncurryThis;
	var requireObjectCoercible$9 = requireObjectCoercible$c;
	var toString$g = toString$i;

	var quot = /"/g;
	var replace$3 = uncurryThis$m(''.replace);

	// `CreateHTML` abstract operation
	// https://tc39.es/ecma262/#sec-createhtml
	var createHtml = function (string, tag, attribute, value) {
	  var S = toString$g(requireObjectCoercible$9(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + replace$3(toString$g(value), quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};

	var fails$h = fails$v;

	// check the existence of a method, lowercase
	// of a tag and escaping quotes in arguments
	var stringHtmlForced = function (METHOD_NAME) {
	  return fails$h(function () {
	    var test = ''[METHOD_NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  });
	};

	var $$F = _export;
	var createHTML$4 = createHtml;
	var forcedStringHTMLMethod$4 = stringHtmlForced;

	// `String.prototype.anchor` method
	// https://tc39.es/ecma262/#sec-string.prototype.anchor
	$$F({ target: 'String', proto: true, forced: forcedStringHTMLMethod$4('anchor') }, {
	  anchor: function anchor(name) {
	    return createHTML$4(this, 'a', 'name', name);
	  }
	});

	var fails$g = fails$v;

	var arrayMethodIsStrict$2 = function (METHOD_NAME, argument) {
	  var method = [][METHOD_NAME];
	  return !!method && fails$g(function () {
	    // eslint-disable-next-line no-useless-call -- required for testing
	    method.call(null, argument || function () { return 1; }, 1);
	  });
	};

	var $$E = _export;
	var uncurryThis$l = functionUncurryThis;
	var IndexedObject$2 = indexedObject;
	var toIndexedObject = toIndexedObject$5;
	var arrayMethodIsStrict$1 = arrayMethodIsStrict$2;

	var nativeJoin = uncurryThis$l([].join);

	var ES3_STRINGS = IndexedObject$2 !== Object;
	var FORCED$3 = ES3_STRINGS || !arrayMethodIsStrict$1('join', ',');

	// `Array.prototype.join` method
	// https://tc39.es/ecma262/#sec-array.prototype.join
	$$E({ target: 'Array', proto: true, forced: FORCED$3 }, {
	  join: function join(separator) {
	    return nativeJoin(toIndexedObject(this), separator === undefined ? ',' : separator);
	  }
	});

	var NATIVE_BIND$2 = functionBindNative;

	var FunctionPrototype$1 = Function.prototype;
	var apply$6 = FunctionPrototype$1.apply;
	var call$b = FunctionPrototype$1.call;

	// eslint-disable-next-line es/no-reflect -- safe
	var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND$2 ? call$b.bind(apply$6) : function () {
	  return call$b.apply(apply$6, arguments);
	});

	var classofRaw = classofRaw$2;
	var uncurryThis$k = functionUncurryThis;

	var functionUncurryThisClause = function (fn) {
	  // Nashorn bug:
	  //   https://github.com/zloirock/core-js/issues/1128
	  //   https://github.com/zloirock/core-js/issues/1130
	  if (classofRaw(fn) === 'Function') return uncurryThis$k(fn);
	};

	// TODO: Remove from `core-js@4` since it's moved to entry points

	var uncurryThis$j = functionUncurryThisClause;
	var defineBuiltIn$1 = defineBuiltIn$5;
	var regexpExec$2 = regexpExec$3;
	var fails$f = fails$v;
	var wellKnownSymbol$b = wellKnownSymbol$f;
	var createNonEnumerableProperty$3 = createNonEnumerableProperty$6;

	var SPECIES$5 = wellKnownSymbol$b('species');
	var RegExpPrototype = RegExp.prototype;

	var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
	  var SYMBOL = wellKnownSymbol$b(KEY);

	  var DELEGATES_TO_SYMBOL = !fails$f(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) !== 7;
	  });

	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$f(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;

	    if (KEY === 'split') {
	      // We can't use real regex here since it causes deoptimization
	      // and serious performance degradation in V8
	      // https://github.com/zloirock/core-js/issues/306
	      re = {};
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES$5] = function () { return re; };
	      re.flags = '';
	      re[SYMBOL] = /./[SYMBOL];
	    }

	    re.exec = function () {
	      execCalled = true;
	      return null;
	    };

	    re[SYMBOL]('');
	    return !execCalled;
	  });

	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    FORCED
	  ) {
	    var uncurriedNativeRegExpMethod = uncurryThis$j(/./[SYMBOL]);
	    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
	      var uncurriedNativeMethod = uncurryThis$j(nativeMethod);
	      var $exec = regexp.exec;
	      if ($exec === regexpExec$2 || $exec === RegExpPrototype.exec) {
	        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	          // The native String method already delegates to @@method (this
	          // polyfilled function), leasing to infinite recursion.
	          // We avoid it by directly calling the native @@method method.
	          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
	        }
	        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
	      }
	      return { done: false };
	    });

	    defineBuiltIn$1(String.prototype, KEY, methods[0]);
	    defineBuiltIn$1(RegExpPrototype, SYMBOL, methods[1]);
	  }

	  if (SHAM) createNonEnumerableProperty$3(RegExpPrototype[SYMBOL], 'sham', true);
	};

	var uncurryThis$i = functionUncurryThis;
	var toIntegerOrInfinity$3 = toIntegerOrInfinity$6;
	var toString$f = toString$i;
	var requireObjectCoercible$8 = requireObjectCoercible$c;

	var charAt$2 = uncurryThis$i(''.charAt);
	var charCodeAt = uncurryThis$i(''.charCodeAt);
	var stringSlice$5 = uncurryThis$i(''.slice);

	var createMethod$2 = function (CONVERT_TO_STRING) {
	  return function ($this, pos) {
	    var S = toString$f(requireObjectCoercible$8($this));
	    var position = toIntegerOrInfinity$3(pos);
	    var size = S.length;
	    var first, second;
	    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
	    first = charCodeAt(S, position);
	    return first < 0xD800 || first > 0xDBFF || position + 1 === size
	      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
	        ? CONVERT_TO_STRING
	          ? charAt$2(S, position)
	          : first
	        : CONVERT_TO_STRING
	          ? stringSlice$5(S, position, position + 2)
	          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
	  };
	};

	var stringMultibyte = {
	  // `String.prototype.codePointAt` method
	  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
	  codeAt: createMethod$2(false),
	  // `String.prototype.at` method
	  // https://github.com/mathiasbynens/String.prototype.at
	  charAt: createMethod$2(true)
	};

	var charAt$1 = stringMultibyte.charAt;

	// `AdvanceStringIndex` abstract operation
	// https://tc39.es/ecma262/#sec-advancestringindex
	var advanceStringIndex$3 = function (S, index, unicode) {
	  return index + (unicode ? charAt$1(S, index).length : 1);
	};

	var uncurryThis$h = functionUncurryThis;
	var toObject$4 = toObject$7;

	var floor$1 = Math.floor;
	var charAt = uncurryThis$h(''.charAt);
	var replace$2 = uncurryThis$h(''.replace);
	var stringSlice$4 = uncurryThis$h(''.slice);
	// eslint-disable-next-line redos/no-vulnerable -- safe
	var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

	// `GetSubstitution` abstract operation
	// https://tc39.es/ecma262/#sec-getsubstitution
	var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
	  var tailPos = position + matched.length;
	  var m = captures.length;
	  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	  if (namedCaptures !== undefined) {
	    namedCaptures = toObject$4(namedCaptures);
	    symbols = SUBSTITUTION_SYMBOLS;
	  }
	  return replace$2(replacement, symbols, function (match, ch) {
	    var capture;
	    switch (charAt(ch, 0)) {
	      case '$': return '$';
	      case '&': return matched;
	      case '`': return stringSlice$4(str, 0, position);
	      case "'": return stringSlice$4(str, tailPos);
	      case '<':
	        capture = namedCaptures[stringSlice$4(ch, 1, -1)];
	        break;
	      default: // \d\d?
	        var n = +ch;
	        if (n === 0) return match;
	        if (n > m) {
	          var f = floor$1(n / 10);
	          if (f === 0) return match;
	          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
	          return match;
	        }
	        capture = captures[n - 1];
	    }
	    return capture === undefined ? '' : capture;
	  });
	};

	var call$a = functionCall;
	var anObject$7 = anObject$e;
	var isCallable$7 = isCallable$j;
	var classof$5 = classofRaw$2;
	var regexpExec$1 = regexpExec$3;

	var $TypeError$5 = TypeError;

	// `RegExpExec` abstract operation
	// https://tc39.es/ecma262/#sec-regexpexec
	var regexpExecAbstract = function (R, S) {
	  var exec = R.exec;
	  if (isCallable$7(exec)) {
	    var result = call$a(exec, R, S);
	    if (result !== null) anObject$7(result);
	    return result;
	  }
	  if (classof$5(R) === 'RegExp') return call$a(regexpExec$1, R, S);
	  throw new $TypeError$5('RegExp#exec called on incompatible receiver');
	};

	var apply$5 = functionApply;
	var call$9 = functionCall;
	var uncurryThis$g = functionUncurryThis;
	var fixRegExpWellKnownSymbolLogic$2 = fixRegexpWellKnownSymbolLogic;
	var fails$e = fails$v;
	var anObject$6 = anObject$e;
	var isCallable$6 = isCallable$j;
	var isNullOrUndefined$4 = isNullOrUndefined$7;
	var toIntegerOrInfinity$2 = toIntegerOrInfinity$6;
	var toLength$4 = toLength$6;
	var toString$e = toString$i;
	var requireObjectCoercible$7 = requireObjectCoercible$c;
	var advanceStringIndex$2 = advanceStringIndex$3;
	var getMethod$2 = getMethod$4;
	var getSubstitution = getSubstitution$1;
	var regExpExec$1 = regexpExecAbstract;
	var wellKnownSymbol$a = wellKnownSymbol$f;

	var REPLACE = wellKnownSymbol$a('replace');
	var max$1 = Math.max;
	var min$3 = Math.min;
	var concat$2 = uncurryThis$g([].concat);
	var push$4 = uncurryThis$g([].push);
	var stringIndexOf$1 = uncurryThis$g(''.indexOf);
	var stringSlice$3 = uncurryThis$g(''.slice);

	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};

	// IE <= 11 replaces $0 with the whole match, as if it was $&
	// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
	var REPLACE_KEEPS_$0 = (function () {
	  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
	  return 'a'.replace(/./, '$0') === '$0';
	})();

	// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
	var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
	  if (/./[REPLACE]) {
	    return /./[REPLACE]('a', '$0') === '';
	  }
	  return false;
	})();

	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$e(function () {
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
	  return ''.replace(re, '$<a>') !== '7';
	});

	// @@replace logic
	fixRegExpWellKnownSymbolLogic$2('replace', function (_, nativeReplace, maybeCallNative) {
	  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

	  return [
	    // `String.prototype.replace` method
	    // https://tc39.es/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = requireObjectCoercible$7(this);
	      var replacer = isNullOrUndefined$4(searchValue) ? undefined : getMethod$2(searchValue, REPLACE);
	      return replacer
	        ? call$9(replacer, searchValue, O, replaceValue)
	        : call$9(nativeReplace, toString$e(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
	    function (string, replaceValue) {
	      var rx = anObject$6(this);
	      var S = toString$e(string);

	      if (
	        typeof replaceValue == 'string' &&
	        stringIndexOf$1(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
	        stringIndexOf$1(replaceValue, '$<') === -1
	      ) {
	        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
	        if (res.done) return res.value;
	      }

	      var functionalReplace = isCallable$6(replaceValue);
	      if (!functionalReplace) replaceValue = toString$e(replaceValue);

	      var global = rx.global;
	      var fullUnicode;
	      if (global) {
	        fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }

	      var results = [];
	      var result;
	      while (true) {
	        result = regExpExec$1(rx, S);
	        if (result === null) break;

	        push$4(results, result);
	        if (!global) break;

	        var matchStr = toString$e(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex$2(S, toLength$4(rx.lastIndex), fullUnicode);
	      }

	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];

	        var matched = toString$e(result[0]);
	        var position = max$1(min$3(toIntegerOrInfinity$2(result.index), S.length), 0);
	        var captures = [];
	        var replacement;
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) push$4(captures, maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = concat$2([matched], captures, position, S);
	          if (namedCaptures !== undefined) push$4(replacerArgs, namedCaptures);
	          replacement = toString$e(apply$5(replaceValue, undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += stringSlice$3(S, nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }

	      return accumulatedResult + stringSlice$3(S, nextSourcePosition);
	    }
	  ];
	}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

	var path$9 = path$q;
	var apply$4 = functionApply$1;

	// eslint-disable-next-line es/no-json -- safe
	if (!path$9.JSON) path$9.JSON = { stringify: JSON.stringify };

	// eslint-disable-next-line no-unused-vars -- required for `.length`
	var stringify$2 = function stringify(it, replacer, space) {
	  return apply$4(path$9.JSON.stringify, null, arguments);
	};

	var parent$z = stringify$2;

	var stringify$1 = parent$z;

	var stringify = stringify$1;

	var _JSON$stringify = /*@__PURE__*/getDefaultExportFromCjs(stringify);

	var $$D = _export$1;
	var $includes = arrayIncludes$1.includes;
	var fails$d = fails$T;

	// FF99+ bug
	var BROKEN_ON_SPARSE = fails$d(function () {
	  // eslint-disable-next-line es/no-array-prototype-includes -- detection
	  return !Array(1).includes();
	});

	// `Array.prototype.includes` method
	// https://tc39.es/ecma262/#sec-array.prototype.includes
	$$D({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

	var getBuiltInPrototypeMethod$8 = getBuiltInPrototypeMethod$g;

	var includes$4 = getBuiltInPrototypeMethod$8('Array', 'includes');

	var isObject$e = isObject$B;
	var classof$4 = classofRaw$5;
	var wellKnownSymbol$9 = wellKnownSymbol$A;

	var MATCH$2 = wellKnownSymbol$9('match');

	// `IsRegExp` abstract operation
	// https://tc39.es/ecma262/#sec-isregexp
	var isRegexp$1 = function (it) {
	  var isRegExp;
	  return isObject$e(it) && ((isRegExp = it[MATCH$2]) !== undefined ? !!isRegExp : classof$4(it) === 'RegExp');
	};

	var isRegExp$1 = isRegexp$1;

	var $TypeError$4 = TypeError;

	var notARegexp = function (it) {
	  if (isRegExp$1(it)) {
	    throw new $TypeError$4("The method doesn't accept regular expressions");
	  } return it;
	};

	var wellKnownSymbol$8 = wellKnownSymbol$A;

	var MATCH$1 = wellKnownSymbol$8('match');

	var correctIsRegexpLogic = function (METHOD_NAME) {
	  var regexp = /./;
	  try {
	    '/./'[METHOD_NAME](regexp);
	  } catch (error1) {
	    try {
	      regexp[MATCH$1] = false;
	      return '/./'[METHOD_NAME](regexp);
	    } catch (error2) { /* empty */ }
	  } return false;
	};

	var $$C = _export$1;
	var uncurryThis$f = functionUncurryThis$1;
	var notARegExp$2 = notARegexp;
	var requireObjectCoercible$6 = requireObjectCoercible$g;
	var toString$d = toString$r;
	var correctIsRegExpLogic$2 = correctIsRegexpLogic;

	var stringIndexOf = uncurryThis$f(''.indexOf);

	// `String.prototype.includes` method
	// https://tc39.es/ecma262/#sec-string.prototype.includes
	$$C({ target: 'String', proto: true, forced: !correctIsRegExpLogic$2('includes') }, {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~stringIndexOf(
	      toString$d(requireObjectCoercible$6(this)),
	      toString$d(notARegExp$2(searchString)),
	      arguments.length > 1 ? arguments[1] : undefined
	    );
	  }
	});

	var getBuiltInPrototypeMethod$7 = getBuiltInPrototypeMethod$g;

	var includes$3 = getBuiltInPrototypeMethod$7('String', 'includes');

	var isPrototypeOf$8 = objectIsPrototypeOf$1;
	var arrayMethod = includes$4;
	var stringMethod = includes$3;

	var ArrayPrototype$4 = Array.prototype;
	var StringPrototype$3 = String.prototype;

	var includes$2 = function (it) {
	  var own = it.includes;
	  if (it === ArrayPrototype$4 || (isPrototypeOf$8(ArrayPrototype$4, it) && own === ArrayPrototype$4.includes)) return arrayMethod;
	  if (typeof it == 'string' || it === StringPrototype$3 || (isPrototypeOf$8(StringPrototype$3, it) && own === StringPrototype$3.includes)) {
	    return stringMethod;
	  } return own;
	};

	var parent$y = includes$2;

	var includes$1 = parent$y;

	var includes = includes$1;

	var _includesInstanceProperty = /*@__PURE__*/getDefaultExportFromCjs(includes);

	// a string of all valid unicode whitespaces
	var whitespaces$3 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
	  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

	var uncurryThis$e = functionUncurryThis$1;
	var requireObjectCoercible$5 = requireObjectCoercible$g;
	var toString$c = toString$r;
	var whitespaces$2 = whitespaces$3;

	var replace$1 = uncurryThis$e(''.replace);
	var ltrim = RegExp('^[' + whitespaces$2 + ']+');
	var rtrim = RegExp('(^|[^' + whitespaces$2 + '])[' + whitespaces$2 + ']+$');

	// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
	var createMethod$1 = function (TYPE) {
	  return function ($this) {
	    var string = toString$c(requireObjectCoercible$5($this));
	    if (TYPE & 1) string = replace$1(string, ltrim, '');
	    if (TYPE & 2) string = replace$1(string, rtrim, '$1');
	    return string;
	  };
	};

	var stringTrim = {
	  // `String.prototype.{ trimLeft, trimStart }` methods
	  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
	  start: createMethod$1(1),
	  // `String.prototype.{ trimRight, trimEnd }` methods
	  // https://tc39.es/ecma262/#sec-string.prototype.trimend
	  end: createMethod$1(2),
	  // `String.prototype.trim` method
	  // https://tc39.es/ecma262/#sec-string.prototype.trim
	  trim: createMethod$1(3)
	};

	var global$b = global$G;
	var fails$c = fails$T;
	var uncurryThis$d = functionUncurryThis$1;
	var toString$b = toString$r;
	var trim$4 = stringTrim.trim;
	var whitespaces$1 = whitespaces$3;

	var $parseInt$1 = global$b.parseInt;
	var Symbol$6 = global$b.Symbol;
	var ITERATOR = Symbol$6 && Symbol$6.iterator;
	var hex = /^[+-]?0x/i;
	var exec$2 = uncurryThis$d(hex.exec);
	var FORCED$2 = $parseInt$1(whitespaces$1 + '08') !== 8 || $parseInt$1(whitespaces$1 + '0x16') !== 22
	  // MS Edge 18- broken with boxed symbols
	  || (ITERATOR && !fails$c(function () { $parseInt$1(Object(ITERATOR)); }));

	// `parseInt` method
	// https://tc39.es/ecma262/#sec-parseint-string-radix
	var numberParseInt = FORCED$2 ? function parseInt(string, radix) {
	  var S = trim$4(toString$b(string));
	  return $parseInt$1(S, (radix >>> 0) || (exec$2(hex, S) ? 16 : 10));
	} : $parseInt$1;

	var $$B = _export$1;
	var $parseInt = numberParseInt;

	// `parseInt` method
	// https://tc39.es/ecma262/#sec-parseint-string-radix
	$$B({ global: true, forced: parseInt !== $parseInt }, {
	  parseInt: $parseInt
	});

	var path$8 = path$q;

	var _parseInt$3 = path$8.parseInt;

	var parent$x = _parseInt$3;

	var _parseInt$2 = parent$x;

	var _parseInt = _parseInt$2;

	var _parseInt$1 = /*@__PURE__*/getDefaultExportFromCjs(_parseInt);

	var $$A = _export$1;
	var uncurryThis$c = functionUncurryThisClause$1;
	var toLength$3 = toLength$8;
	var toString$a = toString$r;
	var notARegExp$1 = notARegexp;
	var requireObjectCoercible$4 = requireObjectCoercible$g;
	var correctIsRegExpLogic$1 = correctIsRegexpLogic;

	// eslint-disable-next-line es/no-string-prototype-endswith -- safe
	var nativeEndsWith = uncurryThis$c(''.endsWith);
	var slice = uncurryThis$c(''.slice);
	var min$2 = Math.min;

	var CORRECT_IS_REGEXP_LOGIC$1 = correctIsRegExpLogic$1('endsWith');

	// `String.prototype.endsWith` method
	// https://tc39.es/ecma262/#sec-string.prototype.endswith
	$$A({ target: 'String', proto: true, forced: !CORRECT_IS_REGEXP_LOGIC$1 }, {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = toString$a(requireObjectCoercible$4(this));
	    notARegExp$1(searchString);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = that.length;
	    var end = endPosition === undefined ? len : min$2(toLength$3(endPosition), len);
	    var search = toString$a(searchString);
	    return nativeEndsWith
	      ? nativeEndsWith(that, search, end)
	      : slice(that, end - search.length, end) === search;
	  }
	});

	var getBuiltInPrototypeMethod$6 = getBuiltInPrototypeMethod$g;

	var endsWith$3 = getBuiltInPrototypeMethod$6('String', 'endsWith');

	var isPrototypeOf$7 = objectIsPrototypeOf$1;
	var method$6 = endsWith$3;

	var StringPrototype$2 = String.prototype;

	var endsWith$2 = function (it) {
	  var own = it.endsWith;
	  return typeof it == 'string' || it === StringPrototype$2
	    || (isPrototypeOf$7(StringPrototype$2, it) && own === StringPrototype$2.endsWith) ? method$6 : own;
	};

	var parent$w = endsWith$2;

	var endsWith$1 = parent$w;

	var endsWith = endsWith$1;

	var _endsWithInstanceProperty = /*@__PURE__*/getDefaultExportFromCjs(endsWith);

	var uncurryThis$b = functionUncurryThisClause;
	var aCallable$7 = aCallable$9;
	var NATIVE_BIND$1 = functionBindNative;

	var bind$d = uncurryThis$b(uncurryThis$b.bind);

	// optional / simple context binding
	var functionBindContext = function (fn, that) {
	  aCallable$7(fn);
	  return that === undefined ? fn : NATIVE_BIND$1 ? bind$d(fn, that) : function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};

	var classof$3 = classofRaw$2;

	// `IsArray` abstract operation
	// https://tc39.es/ecma262/#sec-isarray
	// eslint-disable-next-line es/no-array-isarray -- safe
	var isArray$7 = Array.isArray || function isArray(argument) {
	  return classof$3(argument) === 'Array';
	};

	var uncurryThis$a = functionUncurryThis;
	var fails$b = fails$v;
	var isCallable$5 = isCallable$j;
	var classof$2 = classof$9;
	var getBuiltIn$4 = getBuiltIn$8;
	var inspectSource$1 = inspectSource$3;

	var noop = function () { /* empty */ };
	var empty$1 = [];
	var construct$4 = getBuiltIn$4('Reflect', 'construct');
	var constructorRegExp = /^\s*(?:class|function)\b/;
	var exec$1 = uncurryThis$a(constructorRegExp.exec);
	var INCORRECT_TO_STRING = !constructorRegExp.test(noop);

	var isConstructorModern = function isConstructor(argument) {
	  if (!isCallable$5(argument)) return false;
	  try {
	    construct$4(noop, empty$1, argument);
	    return true;
	  } catch (error) {
	    return false;
	  }
	};

	var isConstructorLegacy = function isConstructor(argument) {
	  if (!isCallable$5(argument)) return false;
	  switch (classof$2(argument)) {
	    case 'AsyncFunction':
	    case 'GeneratorFunction':
	    case 'AsyncGeneratorFunction': return false;
	  }
	  try {
	    // we can't check .prototype since constructors produced by .bind haven't it
	    // `Function#toString` throws on some built-it function in some legacy engines
	    // (for example, `DOMQuad` and similar in FF41-)
	    return INCORRECT_TO_STRING || !!exec$1(constructorRegExp, inspectSource$1(argument));
	  } catch (error) {
	    return true;
	  }
	};

	isConstructorLegacy.sham = true;

	// `IsConstructor` abstract operation
	// https://tc39.es/ecma262/#sec-isconstructor
	var isConstructor$3 = !construct$4 || fails$b(function () {
	  var called;
	  return isConstructorModern(isConstructorModern.call)
	    || !isConstructorModern(Object)
	    || !isConstructorModern(function () { called = true; })
	    || called;
	}) ? isConstructorLegacy : isConstructorModern;

	var isArray$6 = isArray$7;
	var isConstructor$2 = isConstructor$3;
	var isObject$d = isObject$k;
	var wellKnownSymbol$7 = wellKnownSymbol$f;

	var SPECIES$4 = wellKnownSymbol$7('species');
	var $Array$1 = Array;

	// a part of `ArraySpeciesCreate` abstract operation
	// https://tc39.es/ecma262/#sec-arrayspeciescreate
	var arraySpeciesConstructor$1 = function (originalArray) {
	  var C;
	  if (isArray$6(originalArray)) {
	    C = originalArray.constructor;
	    // cross-realm fallback
	    if (isConstructor$2(C) && (C === $Array$1 || isArray$6(C.prototype))) C = undefined;
	    else if (isObject$d(C)) {
	      C = C[SPECIES$4];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? $Array$1 : C;
	};

	var arraySpeciesConstructor = arraySpeciesConstructor$1;

	// `ArraySpeciesCreate` abstract operation
	// https://tc39.es/ecma262/#sec-arrayspeciescreate
	var arraySpeciesCreate$1 = function (originalArray, length) {
	  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
	};

	var bind$c = functionBindContext;
	var uncurryThis$9 = functionUncurryThis;
	var IndexedObject$1 = indexedObject;
	var toObject$3 = toObject$7;
	var lengthOfArrayLike$1 = lengthOfArrayLike$4;
	var arraySpeciesCreate = arraySpeciesCreate$1;

	var push$3 = uncurryThis$9([].push);

	// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
	var createMethod = function (TYPE) {
	  var IS_MAP = TYPE === 1;
	  var IS_FILTER = TYPE === 2;
	  var IS_SOME = TYPE === 3;
	  var IS_EVERY = TYPE === 4;
	  var IS_FIND_INDEX = TYPE === 6;
	  var IS_FILTER_REJECT = TYPE === 7;
	  var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
	  return function ($this, callbackfn, that, specificCreate) {
	    var O = toObject$3($this);
	    var self = IndexedObject$1(O);
	    var boundFunction = bind$c(callbackfn, that);
	    var length = lengthOfArrayLike$1(self);
	    var index = 0;
	    var create = specificCreate || arraySpeciesCreate;
	    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
	    var value, result;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      value = self[index];
	      result = boundFunction(value, index, O);
	      if (TYPE) {
	        if (IS_MAP) target[index] = result; // map
	        else if (result) switch (TYPE) {
	          case 3: return true;              // some
	          case 5: return value;             // find
	          case 6: return index;             // findIndex
	          case 2: push$3(target, value);      // filter
	        } else switch (TYPE) {
	          case 4: return false;             // every
	          case 7: push$3(target, value);      // filterReject
	        }
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
	  };
	};

	var arrayIteration = {
	  // `Array.prototype.forEach` method
	  // https://tc39.es/ecma262/#sec-array.prototype.foreach
	  forEach: createMethod(0),
	  // `Array.prototype.map` method
	  // https://tc39.es/ecma262/#sec-array.prototype.map
	  map: createMethod(1),
	  // `Array.prototype.filter` method
	  // https://tc39.es/ecma262/#sec-array.prototype.filter
	  filter: createMethod(2),
	  // `Array.prototype.some` method
	  // https://tc39.es/ecma262/#sec-array.prototype.some
	  some: createMethod(3),
	  // `Array.prototype.every` method
	  // https://tc39.es/ecma262/#sec-array.prototype.every
	  every: createMethod(4),
	  // `Array.prototype.find` method
	  // https://tc39.es/ecma262/#sec-array.prototype.find
	  find: createMethod(5),
	  // `Array.prototype.findIndex` method
	  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
	  findIndex: createMethod(6),
	  // `Array.prototype.filterReject` method
	  // https://github.com/tc39/proposal-array-filtering
	  filterReject: createMethod(7)
	};

	var wellKnownSymbol$6 = wellKnownSymbol$f;
	var create$9 = objectCreate;
	var defineProperty$1 = objectDefineProperty.f;

	var UNSCOPABLES = wellKnownSymbol$6('unscopables');
	var ArrayPrototype$3 = Array.prototype;

	// Array.prototype[@@unscopables]
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	if (ArrayPrototype$3[UNSCOPABLES] === undefined) {
	  defineProperty$1(ArrayPrototype$3, UNSCOPABLES, {
	    configurable: true,
	    value: create$9(null)
	  });
	}

	// add a key to Array.prototype[@@unscopables]
	var addToUnscopables$1 = function (key) {
	  ArrayPrototype$3[UNSCOPABLES][key] = true;
	};

	var $$z = _export;
	var $find$1 = arrayIteration.find;
	var addToUnscopables = addToUnscopables$1;

	var FIND$1 = 'find';
	var SKIPS_HOLES$1 = true;

	// Shouldn't skip holes
	// eslint-disable-next-line es/no-array-prototype-find -- testing
	if (FIND$1 in []) Array(1)[FIND$1](function () { SKIPS_HOLES$1 = false; });

	// `Array.prototype.find` method
	// https://tc39.es/ecma262/#sec-array.prototype.find
	$$z({ target: 'Array', proto: true, forced: SKIPS_HOLES$1 }, {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables(FIND$1);

	var fails$a = fails$v;
	var wellKnownSymbol$5 = wellKnownSymbol$f;
	var V8_VERSION$1 = engineV8Version;

	var SPECIES$3 = wellKnownSymbol$5('species');

	var arrayMethodHasSpeciesSupport$1 = function (METHOD_NAME) {
	  // We can't use this feature detection in V8 since it causes
	  // deoptimization and serious performance degradation
	  // https://github.com/zloirock/core-js/issues/677
	  return V8_VERSION$1 >= 51 || !fails$a(function () {
	    var array = [];
	    var constructor = array.constructor = {};
	    constructor[SPECIES$3] = function () {
	      return { foo: 1 };
	    };
	    return array[METHOD_NAME](Boolean).foo !== 1;
	  });
	};

	var $$y = _export;
	var $filter = arrayIteration.filter;
	var arrayMethodHasSpeciesSupport = arrayMethodHasSpeciesSupport$1;

	var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

	// `Array.prototype.filter` method
	// https://tc39.es/ecma262/#sec-array.prototype.filter
	// with adding support of @@species
	$$y({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

	/**
	 * List of HTML void tag names.
	 *
	 * @type {Array<string>}
	 */
	const htmlVoidElements = [
	  'area',
	  'base',
	  'basefont',
	  'bgsound',
	  'br',
	  'col',
	  'command',
	  'embed',
	  'frame',
	  'hr',
	  'image',
	  'img',
	  'input',
	  'keygen',
	  'link',
	  'meta',
	  'param',
	  'source',
	  'track',
	  'wbr'
	];

	/**
	 * SSR Window 3.0.0
	 * Better handling for window object in SSR environment
	 * https://github.com/nolimits4web/ssr-window
	 *
	 * Copyright 2020, Vladimir Kharlampidi
	 *
	 * Licensed under MIT
	 *
	 * Released on: November 9, 2020
	 */
	/* eslint-disable no-param-reassign */
	function isObject$c(obj) {
	    return (obj !== null &&
	        typeof obj === 'object' &&
	        'constructor' in obj &&
	        obj.constructor === Object);
	}
	function extend(target, src) {
	    if (target === void 0) { target = {}; }
	    if (src === void 0) { src = {}; }
	    Object.keys(src).forEach(function (key) {
	        if (typeof target[key] === 'undefined')
	            target[key] = src[key];
	        else if (isObject$c(src[key]) &&
	            isObject$c(target[key]) &&
	            Object.keys(src[key]).length > 0) {
	            extend(target[key], src[key]);
	        }
	    });
	}

	var ssrDocument = {
	    body: {},
	    addEventListener: function () { },
	    removeEventListener: function () { },
	    activeElement: {
	        blur: function () { },
	        nodeName: '',
	    },
	    querySelector: function () {
	        return null;
	    },
	    querySelectorAll: function () {
	        return [];
	    },
	    getElementById: function () {
	        return null;
	    },
	    createEvent: function () {
	        return {
	            initEvent: function () { },
	        };
	    },
	    createElement: function () {
	        return {
	            children: [],
	            childNodes: [],
	            style: {},
	            setAttribute: function () { },
	            getElementsByTagName: function () {
	                return [];
	            },
	        };
	    },
	    createElementNS: function () {
	        return {};
	    },
	    importNode: function () {
	        return null;
	    },
	    location: {
	        hash: '',
	        host: '',
	        hostname: '',
	        href: '',
	        origin: '',
	        pathname: '',
	        protocol: '',
	        search: '',
	    },
	};
	function getDocument() {
	    var doc = typeof document !== 'undefined' ? document : {};
	    extend(doc, ssrDocument);
	    return doc;
	}

	var ssrWindow = {
	    document: ssrDocument,
	    navigator: {
	        userAgent: '',
	    },
	    location: {
	        hash: '',
	        host: '',
	        hostname: '',
	        href: '',
	        origin: '',
	        pathname: '',
	        protocol: '',
	        search: '',
	    },
	    history: {
	        replaceState: function () { },
	        pushState: function () { },
	        go: function () { },
	        back: function () { },
	    },
	    CustomEvent: function CustomEvent() {
	        return this;
	    },
	    addEventListener: function () { },
	    removeEventListener: function () { },
	    getComputedStyle: function () {
	        return {
	            getPropertyValue: function () {
	                return '';
	            },
	        };
	    },
	    Image: function () { },
	    Date: function () { },
	    screen: {},
	    setTimeout: function () { },
	    clearTimeout: function () { },
	    matchMedia: function () {
	        return {};
	    },
	    requestAnimationFrame: function (callback) {
	        if (typeof setTimeout === 'undefined') {
	            callback();
	            return null;
	        }
	        return setTimeout(callback, 0);
	    },
	    cancelAnimationFrame: function (id) {
	        if (typeof setTimeout === 'undefined') {
	            return;
	        }
	        clearTimeout(id);
	    },
	};
	function getWindow() {
	    var win = typeof window !== 'undefined' ? window : {};
	    extend(win, ssrWindow);
	    return win;
	}

	/**
	 * Dom7 3.0.0
	 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
	 * https://framework7.io/docs/dom7.html
	 *
	 * Copyright 2020, Vladimir Kharlampidi
	 *
	 * Licensed under MIT
	 *
	 * Released on: November 9, 2020
	 */

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}

	function _getPrototypeOf$1(o) {
	  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf$1(o);
	}

	function _setPrototypeOf$1(o, p) {
	  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };

	  return _setPrototypeOf$1(o, p);
	}

	function _isNativeReflectConstruct$f() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
	  if (Reflect.construct.sham) return false;
	  if (typeof Proxy === "function") return true;

	  try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
	    return true;
	  } catch (e) {
	    return false;
	  }
	}

	function _construct(Parent, args, Class) {
	  if (_isNativeReflectConstruct$f()) {
	    _construct = Reflect.construct;
	  } else {
	    _construct = function _construct(Parent, args, Class) {
	      var a = [null];
	      a.push.apply(a, args);
	      var Constructor = Function.bind.apply(Parent, a);
	      var instance = new Constructor();
	      if (Class) _setPrototypeOf$1(instance, Class.prototype);
	      return instance;
	    };
	  }

	  return _construct.apply(null, arguments);
	}

	function _isNativeFunction(fn) {
	  return Function.toString.call(fn).indexOf("[native code]") !== -1;
	}

	function _wrapNativeSuper(Class) {
	  var _cache = typeof Map === "function" ? new Map() : undefined;

	  _wrapNativeSuper = function _wrapNativeSuper(Class) {
	    if (Class === null || !_isNativeFunction(Class)) return Class;

	    if (typeof Class !== "function") {
	      throw new TypeError("Super expression must either be null or a function");
	    }

	    if (typeof _cache !== "undefined") {
	      if (_cache.has(Class)) return _cache.get(Class);

	      _cache.set(Class, Wrapper);
	    }

	    function Wrapper() {
	      return _construct(Class, arguments, _getPrototypeOf$1(this).constructor);
	    }

	    Wrapper.prototype = Object.create(Class.prototype, {
	      constructor: {
	        value: Wrapper,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    return _setPrototypeOf$1(Wrapper, Class);
	  };

	  return _wrapNativeSuper(Class);
	}

	function _assertThisInitialized$1(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }

	  return self;
	}

	/* eslint-disable no-proto */
	function makeReactive(obj) {
	  var proto = obj.__proto__;
	  Object.defineProperty(obj, '__proto__', {
	    get: function get() {
	      return proto;
	    },
	    set: function set(value) {
	      proto.__proto__ = value;
	    }
	  });
	}

	var Dom7 = /*#__PURE__*/function (_Array) {
	  _inheritsLoose(Dom7, _Array);

	  function Dom7(items) {
	    var _this;

	    _this = _Array.call.apply(_Array, [this].concat(items)) || this;
	    makeReactive(_assertThisInitialized$1(_this));
	    return _this;
	  }

	  return Dom7;
	}( /*#__PURE__*/_wrapNativeSuper(Array));

	function arrayFlat(arr) {
	  if (arr === void 0) {
	    arr = [];
	  }

	  var res = [];
	  arr.forEach(function (el) {
	    if (Array.isArray(el)) {
	      res.push.apply(res, arrayFlat(el));
	    } else {
	      res.push(el);
	    }
	  });
	  return res;
	}
	function arrayFilter(arr, callback) {
	  return Array.prototype.filter.call(arr, callback);
	}
	function arrayUnique(arr) {
	  var uniqueArray = [];

	  for (var i = 0; i < arr.length; i += 1) {
	    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
	  }

	  return uniqueArray;
	}
	function toCamelCase(string) {
	  return string.toLowerCase().replace(/-(.)/g, function (match, group) {
	    return group.toUpperCase();
	  });
	}

	function qsa(selector, context) {
	  if (typeof selector !== 'string') {
	    return [selector];
	  }

	  var a = [];
	  var res = context.querySelectorAll(selector);

	  for (var i = 0; i < res.length; i += 1) {
	    a.push(res[i]);
	  }

	  return a;
	}

	function $$x(selector, context) {
	  var window = getWindow();
	  var document = getDocument();
	  var arr = [];

	  if (!context && selector instanceof Dom7) {
	    return selector;
	  }

	  if (!selector) {
	    return new Dom7(arr);
	  }

	  if (typeof selector === 'string') {
	    var html = selector.trim();

	    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
	      var toCreate = 'div';
	      if (html.indexOf('<li') === 0) toCreate = 'ul';
	      if (html.indexOf('<tr') === 0) toCreate = 'tbody';
	      if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
	      if (html.indexOf('<tbody') === 0) toCreate = 'table';
	      if (html.indexOf('<option') === 0) toCreate = 'select';
	      var tempParent = document.createElement(toCreate);
	      tempParent.innerHTML = html;

	      for (var i = 0; i < tempParent.childNodes.length; i += 1) {
	        arr.push(tempParent.childNodes[i]);
	      }
	    } else {
	      arr = qsa(selector.trim(), context || document);
	    } // arr = qsa(selector, document);

	  } else if (selector.nodeType || selector === window || selector === document) {
	    arr.push(selector);
	  } else if (Array.isArray(selector)) {
	    if (selector instanceof Dom7) return selector;
	    arr = selector;
	  }

	  return new Dom7(arrayUnique(arr));
	}

	$$x.fn = Dom7.prototype;

	function addClass() {
	  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
	    classes[_key] = arguments[_key];
	  }

	  var classNames = arrayFlat(classes.map(function (c) {
	    return c.split(' ');
	  }));
	  this.forEach(function (el) {
	    var _el$classList;

	    (_el$classList = el.classList).add.apply(_el$classList, classNames);
	  });
	  return this;
	}

	function removeClass() {
	  for (var _len2 = arguments.length, classes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    classes[_key2] = arguments[_key2];
	  }

	  var classNames = arrayFlat(classes.map(function (c) {
	    return c.split(' ');
	  }));
	  this.forEach(function (el) {
	    var _el$classList2;

	    (_el$classList2 = el.classList).remove.apply(_el$classList2, classNames);
	  });
	  return this;
	}

	function hasClass() {
	  for (var _len4 = arguments.length, classes = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	    classes[_key4] = arguments[_key4];
	  }

	  var classNames = arrayFlat(classes.map(function (c) {
	    return c.split(' ');
	  }));
	  return arrayFilter(this, function (el) {
	    return classNames.filter(function (className) {
	      return el.classList.contains(className);
	    }).length > 0;
	  }).length > 0;
	}

	function attr(attrs, value) {
	  if (arguments.length === 1 && typeof attrs === 'string') {
	    // Get attr
	    if (this[0]) return this[0].getAttribute(attrs);
	    return undefined;
	  } // Set attrs


	  for (var i = 0; i < this.length; i += 1) {
	    if (arguments.length === 2) {
	      // String
	      this[i].setAttribute(attrs, value);
	    } else {
	      // Object
	      for (var attrName in attrs) {
	        this[i][attrName] = attrs[attrName];
	        this[i].setAttribute(attrName, attrs[attrName]);
	      }
	    }
	  }

	  return this;
	}

	function removeAttr(attr) {
	  for (var i = 0; i < this.length; i += 1) {
	    this[i].removeAttribute(attr);
	  }

	  return this;
	}

	function dataset() {
	  var el = this[0];
	  if (!el) return undefined;
	  var dataset = {}; // eslint-disable-line

	  if (el.dataset) {
	    for (var dataKey in el.dataset) {
	      dataset[dataKey] = el.dataset[dataKey];
	    }
	  } else {
	    for (var i = 0; i < el.attributes.length; i += 1) {
	      var _attr = el.attributes[i];

	      if (_attr.name.indexOf('data-') >= 0) {
	        dataset[toCamelCase(_attr.name.split('data-')[1])] = _attr.value;
	      }
	    }
	  }

	  for (var key in dataset) {
	    if (dataset[key] === 'false') dataset[key] = false;else if (dataset[key] === 'true') dataset[key] = true;else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
	  }

	  return dataset;
	}

	function val(value) {
	  if (typeof value === 'undefined') {
	    // get value
	    var el = this[0];
	    if (!el) return undefined;

	    if (el.multiple && el.nodeName.toLowerCase() === 'select') {
	      var values = [];

	      for (var i = 0; i < el.selectedOptions.length; i += 1) {
	        values.push(el.selectedOptions[i].value);
	      }

	      return values;
	    }

	    return el.value;
	  } // set value


	  for (var _i = 0; _i < this.length; _i += 1) {
	    var _el = this[_i];

	    if (Array.isArray(value) && _el.multiple && _el.nodeName.toLowerCase() === 'select') {
	      for (var j = 0; j < _el.options.length; j += 1) {
	        _el.options[j].selected = value.indexOf(_el.options[j].value) >= 0;
	      }
	    } else {
	      _el.value = value;
	    }
	  }

	  return this;
	}

	function on() {
	  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	    args[_key5] = arguments[_key5];
	  }

	  var eventType = args[0],
	      targetSelector = args[1],
	      listener = args[2],
	      capture = args[3];

	  if (typeof args[1] === 'function') {
	    eventType = args[0];
	    listener = args[1];
	    capture = args[2];
	    targetSelector = undefined;
	  }

	  if (!capture) capture = false;

	  function handleLiveEvent(e) {
	    var target = e.target;
	    if (!target) return;
	    var eventData = e.target.dom7EventData || [];

	    if (eventData.indexOf(e) < 0) {
	      eventData.unshift(e);
	    }

	    if ($$x(target).is(targetSelector)) listener.apply(target, eventData);else {
	      var _parents = $$x(target).parents(); // eslint-disable-line


	      for (var k = 0; k < _parents.length; k += 1) {
	        if ($$x(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
	      }
	    }
	  }

	  function handleEvent(e) {
	    var eventData = e && e.target ? e.target.dom7EventData || [] : [];

	    if (eventData.indexOf(e) < 0) {
	      eventData.unshift(e);
	    }

	    listener.apply(this, eventData);
	  }

	  var events = eventType.split(' ');
	  var j;

	  for (var i = 0; i < this.length; i += 1) {
	    var el = this[i];

	    if (!targetSelector) {
	      for (j = 0; j < events.length; j += 1) {
	        var event = events[j];
	        if (!el.dom7Listeners) el.dom7Listeners = {};
	        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
	        el.dom7Listeners[event].push({
	          listener: listener,
	          proxyListener: handleEvent
	        });
	        el.addEventListener(event, handleEvent, capture);
	      }
	    } else {
	      // Live events
	      for (j = 0; j < events.length; j += 1) {
	        var _event = events[j];
	        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
	        if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];

	        el.dom7LiveListeners[_event].push({
	          listener: listener,
	          proxyListener: handleLiveEvent
	        });

	        el.addEventListener(_event, handleLiveEvent, capture);
	      }
	    }
	  }

	  return this;
	}

	function off() {
	  for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	    args[_key6] = arguments[_key6];
	  }

	  var eventType = args[0],
	      targetSelector = args[1],
	      listener = args[2],
	      capture = args[3];

	  if (typeof args[1] === 'function') {
	    eventType = args[0];
	    listener = args[1];
	    capture = args[2];
	    targetSelector = undefined;
	  }

	  if (!capture) capture = false;
	  var events = eventType.split(' ');

	  for (var i = 0; i < events.length; i += 1) {
	    var event = events[i];

	    for (var j = 0; j < this.length; j += 1) {
	      var el = this[j];
	      var handlers = void 0;

	      if (!targetSelector && el.dom7Listeners) {
	        handlers = el.dom7Listeners[event];
	      } else if (targetSelector && el.dom7LiveListeners) {
	        handlers = el.dom7LiveListeners[event];
	      }

	      if (handlers && handlers.length) {
	        for (var k = handlers.length - 1; k >= 0; k -= 1) {
	          var handler = handlers[k];

	          if (listener && handler.listener === listener) {
	            el.removeEventListener(event, handler.proxyListener, capture);
	            handlers.splice(k, 1);
	          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
	            el.removeEventListener(event, handler.proxyListener, capture);
	            handlers.splice(k, 1);
	          } else if (!listener) {
	            el.removeEventListener(event, handler.proxyListener, capture);
	            handlers.splice(k, 1);
	          }
	        }
	      }
	    }
	  }

	  return this;
	}

	function width() {
	  var window = getWindow();

	  if (this[0] === window) {
	    return window.innerWidth;
	  }

	  if (this.length > 0) {
	    return parseFloat(this.css('width'));
	  }

	  return null;
	}

	function height() {
	  var window = getWindow();

	  if (this[0] === window) {
	    return window.innerHeight;
	  }

	  if (this.length > 0) {
	    return parseFloat(this.css('height'));
	  }

	  return null;
	}

	function offset() {
	  if (this.length > 0) {
	    var window = getWindow();
	    var document = getDocument();
	    var el = this[0];
	    var box = el.getBoundingClientRect();
	    var body = document.body;
	    var clientTop = el.clientTop || body.clientTop || 0;
	    var clientLeft = el.clientLeft || body.clientLeft || 0;
	    var scrollTop = el === window ? window.scrollY : el.scrollTop;
	    var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
	    return {
	      top: box.top + scrollTop - clientTop,
	      left: box.left + scrollLeft - clientLeft
	    };
	  }

	  return null;
	}

	function hide() {
	  for (var i = 0; i < this.length; i += 1) {
	    this[i].style.display = 'none';
	  }

	  return this;
	}

	function show() {
	  var window = getWindow();

	  for (var i = 0; i < this.length; i += 1) {
	    var el = this[i];

	    if (el.style.display === 'none') {
	      el.style.display = '';
	    }

	    if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') {
	      // Still not visible
	      el.style.display = 'block';
	    }
	  }

	  return this;
	}

	function css(props, value) {
	  var window = getWindow();
	  var i;

	  if (arguments.length === 1) {
	    if (typeof props === 'string') {
	      // .css('width')
	      if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
	    } else {
	      // .css({ width: '100px' })
	      for (i = 0; i < this.length; i += 1) {
	        for (var _prop in props) {
	          this[i].style[_prop] = props[_prop];
	        }
	      }

	      return this;
	    }
	  }

	  if (arguments.length === 2 && typeof props === 'string') {
	    // .css('width', '100px')
	    for (i = 0; i < this.length; i += 1) {
	      this[i].style[props] = value;
	    }

	    return this;
	  }

	  return this;
	}

	function each(callback) {
	  if (!callback) return this;
	  this.forEach(function (el, index) {
	    callback.apply(el, [el, index]);
	  });
	  return this;
	}

	function filter(callback) {
	  var result = arrayFilter(this, callback);
	  return $$x(result);
	}

	function html$1(html) {
	  if (typeof html === 'undefined') {
	    return this[0] ? this[0].innerHTML : null;
	  }

	  for (var i = 0; i < this.length; i += 1) {
	    this[i].innerHTML = html;
	  }

	  return this;
	}

	function text(text) {
	  if (typeof text === 'undefined') {
	    return this[0] ? this[0].textContent.trim() : null;
	  }

	  for (var i = 0; i < this.length; i += 1) {
	    this[i].textContent = text;
	  }

	  return this;
	}

	function is(selector) {
	  var window = getWindow();
	  var document = getDocument();
	  var el = this[0];
	  var compareWith;
	  var i;
	  if (!el || typeof selector === 'undefined') return false;

	  if (typeof selector === 'string') {
	    if (el.matches) return el.matches(selector);
	    if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
	    if (el.msMatchesSelector) return el.msMatchesSelector(selector);
	    compareWith = $$x(selector);

	    for (i = 0; i < compareWith.length; i += 1) {
	      if (compareWith[i] === el) return true;
	    }

	    return false;
	  }

	  if (selector === document) {
	    return el === document;
	  }

	  if (selector === window) {
	    return el === window;
	  }

	  if (selector.nodeType || selector instanceof Dom7) {
	    compareWith = selector.nodeType ? [selector] : selector;

	    for (i = 0; i < compareWith.length; i += 1) {
	      if (compareWith[i] === el) return true;
	    }

	    return false;
	  }

	  return false;
	}

	function append() {
	  var newChild;
	  var document = getDocument();

	  for (var k = 0; k < arguments.length; k += 1) {
	    newChild = k < 0 || arguments.length <= k ? undefined : arguments[k];

	    for (var i = 0; i < this.length; i += 1) {
	      if (typeof newChild === 'string') {
	        var tempDiv = document.createElement('div');
	        tempDiv.innerHTML = newChild;

	        while (tempDiv.firstChild) {
	          this[i].appendChild(tempDiv.firstChild);
	        }
	      } else if (newChild instanceof Dom7) {
	        for (var j = 0; j < newChild.length; j += 1) {
	          this[i].appendChild(newChild[j]);
	        }
	      } else {
	        this[i].appendChild(newChild);
	      }
	    }
	  }

	  return this;
	}

	function prepend(newChild) {
	  var document = getDocument();
	  var i;
	  var j;

	  for (i = 0; i < this.length; i += 1) {
	    if (typeof newChild === 'string') {
	      var tempDiv = document.createElement('div');
	      tempDiv.innerHTML = newChild;

	      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
	        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
	      }
	    } else if (newChild instanceof Dom7) {
	      for (j = 0; j < newChild.length; j += 1) {
	        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
	      }
	    } else {
	      this[i].insertBefore(newChild, this[i].childNodes[0]);
	    }
	  }

	  return this;
	}

	function parent$v(selector) {
	  var parents = []; // eslint-disable-line

	  for (var i = 0; i < this.length; i += 1) {
	    if (this[i].parentNode !== null) {
	      if (selector) {
	        if ($$x(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
	      } else {
	        parents.push(this[i].parentNode);
	      }
	    }
	  }

	  return $$x(parents);
	}

	function parents(selector) {
	  var parents = []; // eslint-disable-line

	  for (var i = 0; i < this.length; i += 1) {
	    var _parent = this[i].parentNode; // eslint-disable-line

	    while (_parent) {
	      if (selector) {
	        if ($$x(_parent).is(selector)) parents.push(_parent);
	      } else {
	        parents.push(_parent);
	      }

	      _parent = _parent.parentNode;
	    }
	  }

	  return $$x(parents);
	}

	function find$4(selector) {
	  var foundElements = [];

	  for (var i = 0; i < this.length; i += 1) {
	    var found = this[i].querySelectorAll(selector);

	    for (var j = 0; j < found.length; j += 1) {
	      foundElements.push(found[j]);
	    }
	  }

	  return $$x(foundElements);
	}

	function children(selector) {
	  var children = []; // eslint-disable-line

	  for (var i = 0; i < this.length; i += 1) {
	    var childNodes = this[i].children;

	    for (var j = 0; j < childNodes.length; j += 1) {
	      if (!selector || $$x(childNodes[j]).is(selector)) {
	        children.push(childNodes[j]);
	      }
	    }
	  }

	  return $$x(children);
	}

	function remove() {
	  for (var i = 0; i < this.length; i += 1) {
	    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
	  }

	  return this;
	}

	function empty() {
	  for (var i = 0; i < this.length; i += 1) {
	    var el = this[i];

	    if (el.nodeType === 1) {
	      for (var j = 0; j < el.childNodes.length; j += 1) {
	        if (el.childNodes[j].parentNode) {
	          el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
	        }
	      }

	      el.textContent = '';
	    }
	  }

	  return this;
	}


	function scrollTop() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }

	  var top = args[0],
	      duration = args[1],
	      easing = args[2],
	      callback = args[3];

	  if (args.length === 3 && typeof easing === 'function') {
	    top = args[0];
	    duration = args[1];
	    callback = args[2];
	    easing = args[3];
	  }

	  var dom = this;

	  if (typeof top === 'undefined') {
	    if (dom.length > 0) return dom[0].scrollTop;
	    return null;
	  }

	  return dom.scrollTo(undefined, top, duration, easing, callback);
	}

	function scrollLeft() {
	  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    args[_key3] = arguments[_key3];
	  }

	  var left = args[0],
	      duration = args[1],
	      easing = args[2],
	      callback = args[3];

	  if (args.length === 3 && typeof easing === 'function') {
	    left = args[0];
	    duration = args[1];
	    callback = args[2];
	    easing = args[3];
	  }

	  var dom = this;

	  if (typeof left === 'undefined') {
	    if (dom.length > 0) return dom[0].scrollLeft;
	    return null;
	  }

	  return dom.scrollTo(left, undefined, duration, easing, callback);
	}

	var noTrigger = 'resize scroll'.split(' ');

	function shortcut(name) {
	  function eventHandler() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    if (typeof args[0] === 'undefined') {
	      for (var i = 0; i < this.length; i += 1) {
	        if (noTrigger.indexOf(name) < 0) {
	          if (name in this[i]) this[i][name]();else {
	            $$x(this[i]).trigger(name);
	          }
	        }
	      }

	      return this;
	    }

	    return this.on.apply(this, [name].concat(args));
	  }

	  return eventHandler;
	}

	var click = shortcut('click');
	var focus = shortcut('focus');

	if (css) $$x.fn.css = css;
	if (append) $$x.fn.append = append;
	if (prepend) $$x.fn.prepend = prepend;
	if (addClass) $$x.fn.addClass = addClass;
	if (removeClass) $$x.fn.removeClass = removeClass;
	if (hasClass) $$x.fn.hasClass = hasClass;
	if (on) $$x.fn.on = on;
	if (off) $$x.fn.off = off;
	if (focus) $$x.fn.focus = focus;
	if (attr) $$x.fn.attr = attr;
	if (removeAttr) $$x.fn.removeAttr = removeAttr;
	if (hide) $$x.fn.hide = hide;
	if (show) $$x.fn.show = show;
	if (click) $$x.fn.click = click;
	if (scrollTop) $$x.fn.scrollTop = scrollTop;
	if (scrollLeft) $$x.fn.scrollLeft = scrollLeft;
	if (offset) $$x.fn.offset = offset;
	if (width) $$x.fn.width = width;
	if (height) $$x.fn.height = height;
	if (parent$v) $$x.fn.parent = parent$v;
	if (parents) $$x.fn.parents = parents;
	if (is) $$x.fn.is = is;
	if (dataset) $$x.fn.dataset = dataset;
	if (val) $$x.fn.val = val;
	if (text) $$x.fn.text = text;
	if (html$1) $$x.fn.html = html$1;
	if (children) $$x.fn.children = children;
	if (remove) $$x.fn.remove = remove;
	if (find$4) $$x.fn.find = find$4;
	if (filter) $$x.fn.filter = filter;
	if (each) $$x.fn.each = each;
	if (empty) $$x.fn.empty = empty;

	// ------------------------------- 分割线，以下内容参考 slate-react dom.ts -------------------------------

	/**
	 * Returns the host window of a DOM node
	 */
	var getDefaultView = function getDefaultView(value) {
	  return value && value.ownerDocument && value.ownerDocument.defaultView || null;
	};

	/**
	 * Check if a DOM node is a comment node.
	 */
	var isDOMComment = function isDOMComment(value) {
	  return isDOMNode(value) && value.nodeType === 8;
	};

	/**
	 * Check if a DOM node is an element node.
	 */
	var isDOMElement = function isDOMElement(value) {
	  return isDOMNode(value) && value.nodeType === 1;
	};

	/**
	 * Check if a value is a DOM node.
	 */
	var isDOMNode = function isDOMNode(value) {
	  var window = getDefaultView(value);
	  return !!window &&
	  // @ts-ignore
	  value instanceof window.Node;
	};

	/**
	 * Check if a value is a DOM selection.
	 */
	var isDOMSelection = function isDOMSelection(value) {
	  var window = value && value.anchorNode && getDefaultView(value.anchorNode);
	  return !!window && value instanceof window.Selection;
	};

	/**
	 * Check if a DOM node is an element node.
	 */
	var isDOMText = function isDOMText(value) {
	  return isDOMNode(value) && value.nodeType === 3;
	};

	/**
	 * Checks whether a paste event is a plaintext-only event.
	 */
	var isPlainTextOnlyPaste = function isPlainTextOnlyPaste(event) {
	  return event.clipboardData && event.clipboardData.getData('text/plain') !== '' && event.clipboardData.types.length === 1;
	};

	/**
	 * Normalize a DOM point so that it always refers to a text node.
	 */
	var normalizeDOMPoint = function normalizeDOMPoint(domPoint) {
	  var _domPoint = _slicedToArray(domPoint, 2),
	    node = _domPoint[0],
	    offset = _domPoint[1];

	  // If it's an element node, its offset refers to the index of its children
	  // including comment nodes, so try to find the right text child node.
	  if (isDOMElement(node) && node.childNodes.length) {
	    var isLast = offset === node.childNodes.length;
	    var index = isLast ? offset - 1 : offset;
	    // If the editable child found is in front of input offset, we instead seek to its end
	    // 如果编辑区域的内容被发现在输入光标位置前面，也就是光标位置不正常，则修正光标的位置到结尾
	    var _getEditableChildAndI = getEditableChildAndIndex(node, index, isLast ? 'backward' : 'forward');
	    var _getEditableChildAndI2 = _slicedToArray(_getEditableChildAndI, 2);
	    node = _getEditableChildAndI2[0];
	    index = _getEditableChildAndI2[1];
	    isLast = index < offset;

	    // If the node has children, traverse until we have a leaf node. Leaf nodes
	    // can be either text nodes, or other void DOM nodes.
	    while (isDOMElement(node) && node.childNodes.length) {
	      var i = isLast ? node.childNodes.length - 1 : 0;
	      node = getEditableChild(node, i, isLast ? 'backward' : 'forward');
	    }

	    // Determine the new offset inside the text node.
	    offset = isLast && node.textContent != null ? node.textContent.length : 0;
	  }

	  // Return the node and offset.
	  return [node, offset];
	};

	/**
	 * Determines wether the active element is nested within a shadowRoot
	 */
	var hasShadowRoot = function hasShadowRoot() {
	  return !!(window.document.activeElement && window.document.activeElement.shadowRoot);
	};

	/**
	 * Get the element with the specified id
	 */
	var getElementById = function getElementById(id) {
	  var _window$document$getE, _window$document$acti;
	  return (_window$document$getE = window.document.getElementById(id)) !== null && _window$document$getE !== void 0 ? _window$document$getE : ((_window$document$acti = window.document.activeElement) === null || _window$document$acti === void 0 || (_window$document$acti = _window$document$acti.shadowRoot) === null || _window$document$acti === void 0 ? void 0 : _window$document$acti.getElementById(id)) || null;
	};

	/**
	 * Get the nearest editable child and index at `index` in a `parent`, preferring `direction`.
	 */
	var getEditableChildAndIndex = function getEditableChildAndIndex(parent, index, direction) {
	  var childNodes = parent.childNodes;
	  var child = childNodes[index];
	  var i = index;
	  var triedForward = false;
	  var triedBackward = false;

	  // While the child is a comment node, or an element node with no children,
	  // keep iterating to find a sibling non-void, non-comment node.
	  while (isDOMComment(child) || isDOMElement(child) && child.childNodes.length === 0 || isDOMElement(child) && child.getAttribute('contenteditable') === 'false') {
	    if (triedForward && triedBackward) {
	      break;
	    }
	    if (i >= childNodes.length) {
	      triedForward = true;
	      i = index - 1;
	      direction = 'backward';
	      continue;
	    }
	    if (i < 0) {
	      triedBackward = true;
	      i = index + 1;
	      direction = 'forward';
	      continue;
	    }
	    child = childNodes[i];
	    index = i;
	    i += direction === 'forward' ? 1 : -1;
	  }
	  return [child, index];
	};

	/**
	 * Get the nearest editable child at `index` in a `parent`, preferring
	 * `direction`.
	 */

	var getEditableChild = function getEditableChild(parent, index, direction) {
	  var _getEditableChildAndI3 = getEditableChildAndIndex(parent, index, direction),
	    _getEditableChildAndI4 = _slicedToArray(_getEditableChildAndI3, 1),
	    child = _getEditableChildAndI4[0];
	  return child;
	};

	/**
	 * Get a plaintext representation of the content of a node, accounting for block
	 * elements which get a newline appended.
	 *
	 * The domNode must be attached to the DOM.
	 */
	var getPlainText = function getPlainText(domNode) {
	  var text = '';
	  if (isDOMText(domNode) && domNode.nodeValue) {
	    return domNode.nodeValue;
	  }
	  if (isDOMElement(domNode)) {
	    for (var _i = 0, _Array$from$1 = _Array$from(domNode.childNodes); _i < _Array$from$1.length; _i++) {
	      var childNode = _Array$from$1[_i];
	      text += getPlainText(childNode);
	    }
	    var display = getComputedStyle(domNode).getPropertyValue('display');
	    if (display === 'block' || display === 'list' || display === 'table-row' || domNode.tagName === 'BR') {
	      text += '\n';
	    }
	  }
	  return text;
	};

	/**
	 * 在下级节点中找到第一个 void elem
	 * @param elem elem
	 */
	function getFirstVoidChild(elem) {
	  // 深度优先遍历
	  var stack = [];
	  stack.push(elem);
	  var num = 0;

	  // 开始遍历
	  while (stack.length > 0) {
	    var curElem = stack.pop();
	    if (curElem == null) break;
	    num++;
	    if (num > 10000) break;
	    var nodeName = curElem.nodeName,
	      nodeType = curElem.nodeType;
	    if (nodeType === 1) {
	      var name = nodeName.toLowerCase();
	      if (_includesInstanceProperty(htmlVoidElements).call(htmlVoidElements, name) ||
	      // 补充一些
	      name === 'iframe' || name === 'video') {
	        return curElem; // 得到 void elem 并返回
	      }

	      // 继续遍历子节点
	      var _children = curElem.children || [];
	      var length = _children.length;
	      if (length) {
	        for (var i = length - 1; i >= 0; i--) {
	          // 注意，需要**逆序**追加自节点
	          stack.push(_children[i]);
	        }
	      }
	    }
	  }

	  // 未找到结果，返回 null
	  return null;
	}

	/**
	 * 遍历一个 elem 内所有的 text node ，执行函数
	 * @param elem elem
	 * @param handler handler
	 */
	function walkTextNodes(elem, handler) {
	  // void elem 内部的 text 不处理
	  if (elem instanceof HTMLElement && elem.dataset.slateVoid === 'true') return;
	  for (var nodes = elem.childNodes, i = nodes.length; i--;) {
	    var node = nodes[i];
	    var nodeType = node.nodeType;
	    if (nodeType == 3) {
	      // 匹配到 text node ，执行函数
	      handler(node, elem);
	    } else if (nodeType == 1 || nodeType == 9 || nodeType == 11) {
	      // 继续遍历子节点
	      walkTextNodes(node, handler);
	    }
	  }
	}

	/** Detect free variable `global` from Node.js. */

	var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

	var _freeGlobal = freeGlobal$1;

	var freeGlobal = _freeGlobal;

	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

	/** Used as a reference to the global object. */
	var root$8 = freeGlobal || freeSelf || Function('return this')();

	var _root = root$8;

	var root$7 = _root;

	/** Built-in value references. */
	var Symbol$5 = root$7.Symbol;

	var _Symbol = Symbol$5;

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */

	function copyArray$1(source, array) {
	  var index = -1,
	      length = source.length;

	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}

	var _copyArray = copyArray$1;

	var Symbol$4 = _Symbol;

	/** Used for built-in method references. */
	var objectProto$6 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString$1 = objectProto$6.toString;

	/** Built-in value references. */
	var symToStringTag$1 = Symbol$4 ? Symbol$4.toStringTag : undefined;

	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag$1(value) {
	  var isOwn = hasOwnProperty$5.call(value, symToStringTag$1),
	      tag = value[symToStringTag$1];

	  try {
	    value[symToStringTag$1] = undefined;
	    var unmasked = true;
	  } catch (e) {}

	  var result = nativeObjectToString$1.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag$1] = tag;
	    } else {
	      delete value[symToStringTag$1];
	    }
	  }
	  return result;
	}

	var _getRawTag = getRawTag$1;

	/** Used for built-in method references. */

	var objectProto$5 = Object.prototype;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto$5.toString;

	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString$1(value) {
	  return nativeObjectToString.call(value);
	}

	var _objectToString = objectToString$1;

	var Symbol$3 = _Symbol,
	    getRawTag = _getRawTag,
	    objectToString = _objectToString;

	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';

	/** Built-in value references. */
	var symToStringTag = Symbol$3 ? Symbol$3.toStringTag : undefined;

	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag$6(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}

	var _baseGetTag = baseGetTag$6;

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */

	function isObject$b(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}

	var isObject_1 = isObject$b;

	var baseGetTag$5 = _baseGetTag,
	    isObject$a = isObject_1;

	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag$1 = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';

	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction$2(value) {
	  if (!isObject$a(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag$5(value);
	  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
	}

	var isFunction_1 = isFunction$2;

	var root$6 = _root;

	/** Used to detect overreaching core-js shims. */
	var coreJsData$1 = root$6['__core-js_shared__'];

	var _coreJsData = coreJsData$1;

	var coreJsData = _coreJsData;

	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());

	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked$1(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}

	var _isMasked = isMasked$1;

	/** Used for built-in method references. */

	var funcProto$1 = Function.prototype;

	/** Used to resolve the decompiled source of functions. */
	var funcToString$1 = funcProto$1.toString;

	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource$2(func) {
	  if (func != null) {
	    try {
	      return funcToString$1.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}

	var _toSource = toSource$2;

	var isFunction$1 = isFunction_1,
	    isMasked = _isMasked,
	    isObject$9 = isObject_1,
	    toSource$1 = _toSource;

	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;

	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto$4 = Object.prototype;

	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;

	/** Used to check objects for own properties. */
	var hasOwnProperty$4 = objectProto$4.hasOwnProperty;

	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty$4).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);

	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative$1(value) {
	  if (!isObject$9(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource$1(value));
	}

	var _baseIsNative = baseIsNative$1;

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */

	function getValue$1(object, key) {
	  return object == null ? undefined : object[key];
	}

	var _getValue = getValue$1;

	var baseIsNative = _baseIsNative,
	    getValue = _getValue;

	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative$5(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}

	var _getNative = getNative$5;

	var getNative$4 = _getNative,
	    root$5 = _root;

	/* Built-in method references that are verified to be native. */
	var DataView$1 = getNative$4(root$5, 'DataView');

	var _DataView = DataView$1;

	var getNative$3 = _getNative,
	    root$4 = _root;

	/* Built-in method references that are verified to be native. */
	var Map$2 = getNative$3(root$4, 'Map');

	var _Map = Map$2;

	var getNative$2 = _getNative,
	    root$3 = _root;

	/* Built-in method references that are verified to be native. */
	var Promise$3 = getNative$2(root$3, 'Promise');

	var _Promise$2 = Promise$3;

	var getNative$1 = _getNative,
	    root$2 = _root;

	/* Built-in method references that are verified to be native. */
	var Set$2 = getNative$1(root$2, 'Set');

	var _Set = Set$2;

	var getNative = _getNative,
	    root$1 = _root;

	/* Built-in method references that are verified to be native. */
	var WeakMap$2 = getNative(root$1, 'WeakMap');

	var _WeakMap = WeakMap$2;

	var DataView = _DataView,
	    Map$1 = _Map,
	    Promise$2 = _Promise$2,
	    Set$1 = _Set,
	    WeakMap$1 = _WeakMap,
	    baseGetTag$4 = _baseGetTag,
	    toSource = _toSource;

	/** `Object#toString` result references. */
	var mapTag$2 = '[object Map]',
	    objectTag$1 = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag$2 = '[object Set]',
	    weakMapTag$1 = '[object WeakMap]';

	var dataViewTag$1 = '[object DataView]';

	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map$1),
	    promiseCtorString = toSource(Promise$2),
	    setCtorString = toSource(Set$1),
	    weakMapCtorString = toSource(WeakMap$1);

	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag$1 = baseGetTag$4;

	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag$1(new DataView(new ArrayBuffer(1))) != dataViewTag$1) ||
	    (Map$1 && getTag$1(new Map$1) != mapTag$2) ||
	    (Promise$2 && getTag$1(Promise$2.resolve()) != promiseTag) ||
	    (Set$1 && getTag$1(new Set$1) != setTag$2) ||
	    (WeakMap$1 && getTag$1(new WeakMap$1) != weakMapTag$1)) {
	  getTag$1 = function(value) {
	    var result = baseGetTag$4(value),
	        Ctor = result == objectTag$1 ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';

	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag$1;
	        case mapCtorString: return mapTag$2;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag$2;
	        case weakMapCtorString: return weakMapTag$1;
	      }
	    }
	    return result;
	  };
	}

	var _getTag = getTag$1;

	/** Used as references for various `Number` constants. */

	var MAX_SAFE_INTEGER$1 = 9007199254740991;

	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength$2(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
	}

	var isLength_1 = isLength$2;

	var isFunction = isFunction_1,
	    isLength$1 = isLength_1;

	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike$3(value) {
	  return value != null && isLength$1(value.length) && !isFunction(value);
	}

	var isArrayLike_1 = isArrayLike$3;

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */

	var isArray$5 = Array.isArray;

	var isArray_1 = isArray$5;

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */

	function isObjectLike$5(value) {
	  return value != null && typeof value == 'object';
	}

	var isObjectLike_1 = isObjectLike$5;

	var baseGetTag$3 = _baseGetTag,
	    isArray$4 = isArray_1,
	    isObjectLike$4 = isObjectLike_1;

	/** `Object#toString` result references. */
	var stringTag$1 = '[object String]';

	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString$1(value) {
	  return typeof value == 'string' ||
	    (!isArray$4(value) && isObjectLike$4(value) && baseGetTag$3(value) == stringTag$1);
	}

	var isString_1 = isString$1;

	/**
	 * Converts `iterator` to an array.
	 *
	 * @private
	 * @param {Object} iterator The iterator to convert.
	 * @returns {Array} Returns the converted array.
	 */

	function iteratorToArray$1(iterator) {
	  var data,
	      result = [];

	  while (!(data = iterator.next()).done) {
	    result.push(data.value);
	  }
	  return result;
	}

	var _iteratorToArray = iteratorToArray$1;

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */

	function mapToArray$1(map) {
	  var index = -1,
	      result = Array(map.size);

	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}

	var _mapToArray = mapToArray$1;

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */

	function setToArray$1(set) {
	  var index = -1,
	      result = Array(set.size);

	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}

	var _setToArray = setToArray$1;

	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */

	function asciiToArray$1(string) {
	  return string.split('');
	}

	var _asciiToArray = asciiToArray$1;

	/** Used to compose unicode character classes. */

	var rsAstralRange$2 = '\\ud800-\\udfff',
	    rsComboMarksRange$3 = '\\u0300-\\u036f',
	    reComboHalfMarksRange$3 = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange$3 = '\\u20d0-\\u20ff',
	    rsComboRange$3 = rsComboMarksRange$3 + reComboHalfMarksRange$3 + rsComboSymbolsRange$3,
	    rsVarRange$2 = '\\ufe0e\\ufe0f';

	/** Used to compose unicode capture groups. */
	var rsZWJ$2 = '\\u200d';

	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ$2 + rsAstralRange$2  + rsComboRange$3 + rsVarRange$2 + ']');

	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode$2(string) {
	  return reHasUnicode.test(string);
	}

	var _hasUnicode = hasUnicode$2;

	/** Used to compose unicode character classes. */

	var rsAstralRange$1 = '\\ud800-\\udfff',
	    rsComboMarksRange$2 = '\\u0300-\\u036f',
	    reComboHalfMarksRange$2 = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange$2 = '\\u20d0-\\u20ff',
	    rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2,
	    rsVarRange$1 = '\\ufe0e\\ufe0f';

	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange$1 + ']',
	    rsCombo$2 = '[' + rsComboRange$2 + ']',
	    rsFitz$1 = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier$1 = '(?:' + rsCombo$2 + '|' + rsFitz$1 + ')',
	    rsNonAstral$1 = '[^' + rsAstralRange$1 + ']',
	    rsRegional$1 = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair$1 = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ$1 = '\\u200d';

	/** Used to compose unicode regexes. */
	var reOptMod$1 = rsModifier$1 + '?',
	    rsOptVar$1 = '[' + rsVarRange$1 + ']?',
	    rsOptJoin$1 = '(?:' + rsZWJ$1 + '(?:' + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsOptVar$1 + reOptMod$1 + ')*',
	    rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1,
	    rsSymbol = '(?:' + [rsNonAstral$1 + rsCombo$2 + '?', rsCombo$2, rsRegional$1, rsSurrPair$1, rsAstral].join('|') + ')';

	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz$1 + '(?=' + rsFitz$1 + ')|' + rsSymbol + rsSeq$1, 'g');

	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray$1(string) {
	  return string.match(reUnicode) || [];
	}

	var _unicodeToArray = unicodeToArray$1;

	var asciiToArray = _asciiToArray,
	    hasUnicode$1 = _hasUnicode,
	    unicodeToArray = _unicodeToArray;

	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray$2(string) {
	  return hasUnicode$1(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}

	var _stringToArray = stringToArray$2;

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */

	function arrayMap$2(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);

	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}

	var _arrayMap = arrayMap$2;

	var arrayMap$1 = _arrayMap;

	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues$1(object, props) {
	  return arrayMap$1(props, function(key) {
	    return object[key];
	  });
	}

	var _baseValues = baseValues$1;

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */

	function baseTimes$1(n, iteratee) {
	  var index = -1,
	      result = Array(n);

	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}

	var _baseTimes = baseTimes$1;

	var baseGetTag$2 = _baseGetTag,
	    isObjectLike$3 = isObjectLike_1;

	/** `Object#toString` result references. */
	var argsTag$1 = '[object Arguments]';

	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments$1(value) {
	  return isObjectLike$3(value) && baseGetTag$2(value) == argsTag$1;
	}

	var _baseIsArguments = baseIsArguments$1;

	var baseIsArguments = _baseIsArguments,
	    isObjectLike$2 = isObjectLike_1;

	/** Used for built-in method references. */
	var objectProto$3 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$3 = objectProto$3.hasOwnProperty;

	/** Built-in value references. */
	var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;

	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments$1 = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike$2(value) && hasOwnProperty$3.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};

	var isArguments_1 = isArguments$1;

	var isBuffer$1 = {exports: {}};

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */

	function stubFalse() {
	  return false;
	}

	var stubFalse_1 = stubFalse;

	isBuffer$1.exports;

	(function (module, exports) {
		var root = _root,
		    stubFalse = stubFalse_1;

		/** Detect free variable `exports`. */
		var freeExports = exports && !exports.nodeType && exports;

		/** Detect free variable `module`. */
		var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

		/** Detect the popular CommonJS extension `module.exports`. */
		var moduleExports = freeModule && freeModule.exports === freeExports;

		/** Built-in value references. */
		var Buffer = moduleExports ? root.Buffer : undefined;

		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

		/**
		 * Checks if `value` is a buffer.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.3.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
		 * @example
		 *
		 * _.isBuffer(new Buffer(2));
		 * // => true
		 *
		 * _.isBuffer(new Uint8Array(2));
		 * // => false
		 */
		var isBuffer = nativeIsBuffer || stubFalse;

		module.exports = isBuffer; 
	} (isBuffer$1, isBuffer$1.exports));

	var isBufferExports = isBuffer$1.exports;

	/** Used as references for various `Number` constants. */

	var MAX_SAFE_INTEGER = 9007199254740991;

	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;

	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex$1(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;

	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}

	var _isIndex = isIndex$1;

	var baseGetTag$1 = _baseGetTag,
	    isLength = isLength_1,
	    isObjectLike$1 = isObjectLike_1;

	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag$1 = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag$1 = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';

	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';

	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag$1] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag$1] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;

	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray$1(value) {
	  return isObjectLike$1(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag$1(value)];
	}

	var _baseIsTypedArray = baseIsTypedArray$1;

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */

	function baseUnary$1(func) {
	  return function(value) {
	    return func(value);
	  };
	}

	var _baseUnary = baseUnary$1;

	var _nodeUtil = {exports: {}};

	_nodeUtil.exports;

	(function (module, exports) {
		var freeGlobal = _freeGlobal;

		/** Detect free variable `exports`. */
		var freeExports = exports && !exports.nodeType && exports;

		/** Detect free variable `module`. */
		var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

		/** Detect the popular CommonJS extension `module.exports`. */
		var moduleExports = freeModule && freeModule.exports === freeExports;

		/** Detect free variable `process` from Node.js. */
		var freeProcess = moduleExports && freeGlobal.process;

		/** Used to access faster Node.js helpers. */
		var nodeUtil = (function() {
		  try {
		    // Use `util.types` for Node.js 10+.
		    var types = freeModule && freeModule.require && freeModule.require('util').types;

		    if (types) {
		      return types;
		    }

		    // Legacy `process.binding('util')` for Node.js < 10.
		    return freeProcess && freeProcess.binding && freeProcess.binding('util');
		  } catch (e) {}
		}());

		module.exports = nodeUtil; 
	} (_nodeUtil, _nodeUtil.exports));

	var _nodeUtilExports = _nodeUtil.exports;

	var baseIsTypedArray = _baseIsTypedArray,
	    baseUnary = _baseUnary,
	    nodeUtil = _nodeUtilExports;

	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray$1 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

	var isTypedArray_1 = isTypedArray$1;

	var baseTimes = _baseTimes,
	    isArguments = isArguments_1,
	    isArray$3 = isArray_1,
	    isBuffer = isBufferExports,
	    isIndex = _isIndex,
	    isTypedArray = isTypedArray_1;

	/** Used for built-in method references. */
	var objectProto$2 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys$1(value, inherited) {
	  var isArr = isArray$3(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;

	  for (var key in value) {
	    if ((inherited || hasOwnProperty$2.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	var _arrayLikeKeys = arrayLikeKeys$1;

	/** Used for built-in method references. */

	var objectProto$1 = Object.prototype;

	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype$1(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$1;

	  return value === proto;
	}

	var _isPrototype = isPrototype$1;

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */

	function overArg$1(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}

	var _overArg = overArg$1;

	var overArg = _overArg;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys$2 = overArg(Object.keys, Object);

	var _nativeKeys = nativeKeys$2;

	var isPrototype = _isPrototype,
	    nativeKeys$1 = _nativeKeys;

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$1 = objectProto.hasOwnProperty;

	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys$1(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys$1(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty$1.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}

	var _baseKeys = baseKeys$1;

	var arrayLikeKeys = _arrayLikeKeys,
	    baseKeys = _baseKeys,
	    isArrayLike$2 = isArrayLike_1;

	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys$2(object) {
	  return isArrayLike$2(object) ? arrayLikeKeys(object) : baseKeys(object);
	}

	var keys_1 = keys$2;

	var baseValues = _baseValues,
	    keys$1 = keys_1;

	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values$1(object) {
	  return object == null ? [] : baseValues(object, keys$1(object));
	}

	var values_1 = values$1;

	var Symbol$2 = _Symbol,
	    copyArray = _copyArray,
	    getTag = _getTag,
	    isArrayLike$1 = isArrayLike_1,
	    isString = isString_1,
	    iteratorToArray = _iteratorToArray,
	    mapToArray = _mapToArray,
	    setToArray = _setToArray,
	    stringToArray$1 = _stringToArray,
	    values = values_1;

	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';

	/** Built-in value references. */
	var symIterator = Symbol$2 ? Symbol$2.iterator : undefined;

	/**
	 * Converts `value` to an array.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the converted array.
	 * @example
	 *
	 * _.toArray({ 'a': 1, 'b': 2 });
	 * // => [1, 2]
	 *
	 * _.toArray('abc');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toArray(1);
	 * // => []
	 *
	 * _.toArray(null);
	 * // => []
	 */
	function toArray(value) {
	  if (!value) {
	    return [];
	  }
	  if (isArrayLike$1(value)) {
	    return isString(value) ? stringToArray$1(value) : copyArray(value);
	  }
	  if (symIterator && value[symIterator]) {
	    return iteratorToArray(value[symIterator]());
	  }
	  var tag = getTag(value),
	      func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

	  return func(value);
	}

	var toArray_1 = toArray;

	var toArray$1 = /*@__PURE__*/getDefaultExportFromCjs(toArray_1);

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    _Object$defineProperty(target, _toPropertyKey$1(descriptor.key), descriptor);
	  }
	}
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  _Object$defineProperty(Constructor, "prototype", {
	    writable: false
	  });
	  return Constructor;
	}

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	/**
	 * An auto-incrementing identifier for keys.
	 */

	var n$1 = 0;

	/**
	 * A class that keeps track of a key string. We use a full class here because we
	 * want to be able to use them as keys in `WeakMap` objects.
	 */
	var Key = /*#__PURE__*/_createClass(function Key() {
	  _classCallCheck(this, Key);
	  this.id = "".concat(n$1++);
	});

	var $$w = _export$1;
	var global$a = global$G;

	// `globalThis` object
	// https://tc39.es/ecma262/#sec-globalthis
	$$w({ global: true, forced: global$a.globalThis !== global$a }, {
	  globalThis: global$a
	});

	var globalThis$6 = global$G;

	var parent$u = globalThis$6;

	var globalThis$5 = parent$u;

	var parent$t = globalThis$5;

	var globalThis$4 = parent$t;

	// TODO: remove from `core-js@4`


	var parent$s = globalThis$4;

	var globalThis$3 = parent$s;

	var globalThis$2 = globalThis$3;

	var globalThis$1 = globalThis$2;

	var _globalThis = /*@__PURE__*/getDefaultExportFromCjs(globalThis$1);

	typeof _globalThis.navigator !== 'undefined' && typeof _globalThis.window !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !_globalThis.window.MSStream;
	var IS_APPLE = typeof navigator !== 'undefined' && /Mac OS X/.test(navigator.userAgent);
	var IS_FIREFOX = typeof navigator !== 'undefined' && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent);
	var IS_SAFARI = typeof navigator !== 'undefined' && /Version\/[\d\.]+.*Safari/.test(navigator.userAgent); // eslint-disable-line

	// "modern" Edge was released at 79.x
	var IS_EDGE_LEGACY = typeof navigator !== 'undefined' && /Edge?\/(?:[0-6][0-9]|[0-7][0-8])(?:\.)/i.test(navigator.userAgent);

	// Native beforeInput events don't work well with react on Chrome 75 and older, Chrome 76+ can use beforeInput
	var IS_CHROME_LEGACY = typeof navigator !== 'undefined' && /Chrome?\/(?:[0-7][0-5]|[0-6][0-9])(?:\.)/i.test(navigator.userAgent);
	var IS_CHROME = typeof navigator !== 'undefined' && /Chrome/i.test(navigator.userAgent);

	// @ts-ignore 判断浏览器是否支持 beforeinput 事件 https://www.caniuse.com/?search=beforeinput
	// COMPAT: Firefox/Edge Legacy don't support the `beforeinput` event
	// Chrome Legacy doesn't support `beforeinput` correctly
	var HAS_BEFORE_INPUT_SUPPORT = !IS_CHROME_LEGACY && !IS_EDGE_LEGACY &&
	// globalThis is undefined in older browsers
	typeof _globalThis !== 'undefined' && _globalThis.InputEvent &&
	// @ts-ignore The `getTargetRanges` property isn't recognized.
	typeof _globalThis.InputEvent.prototype.getTargetRanges === 'function';

	function _createForOfIteratorHelper$5(o, allowArrayLike) { var it = typeof _Symbol$1 !== "undefined" && _getIteratorMethod(o) || o["@@iterator"]; if (!it) { if (_Array$isArray(o) || (it = _unsupportedIterableToArray$5(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
	function _unsupportedIterableToArray$5(o, minLen) { var _context5; if (!o) return; if (typeof o === "string") return _arrayLikeToArray$5(o, minLen); var n = _sliceInstanceProperty(_context5 = Object.prototype.toString.call(o)).call(_context5, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen); }
	function _arrayLikeToArray$5(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

	/**
	 * 自定义全局 command
	 */
	var DomEditor = {
	  /**
	   * Return the host window of the current editor.
	   */
	  getWindow: function getWindow(editor) {
	    var window = EDITOR_TO_WINDOW.get(editor);
	    if (!window) {
	      throw new Error('Unable to find a host window element for this editor');
	    }
	    return window;
	  },
	  /**
	   * Find a key for a Slate node.
	   * key 即一个累加不重复的 id ，每一个 slate node 都对对应一个 key ，意思相当于 node.id
	   */
	  findKey: function findKey(editor, node) {
	    var key = NODE_TO_KEY.get(node);

	    // 如果没绑定，就立马新建一个 key 来绑定
	    if (!key) {
	      key = new Key();
	      NODE_TO_KEY.set(node, key);
	    }
	    return key;
	  },
	  setNewKey: function setNewKey(node) {
	    var key = new Key();
	    NODE_TO_KEY.set(node, key);
	  },
	  /**
	   * Find the path of Slate node.
	   * path 是一个数组，代表 slate node 的位置 https://docs.slatejs.org/concepts/03-locations#path
	   */
	  findPath: function findPath(editor, node) {
	    var path = [];
	    var child = node;

	    // eslint-disable-next-line
	    while (true) {
	      var parent = NODE_TO_PARENT.get(child);
	      if (parent == null) {
	        if (Editor.isEditor(child)) {
	          // 已到达最顶层，返回 patch
	          return path;
	        } else {
	          break;
	        }
	      }

	      // 获取该节点在父节点中的 index
	      var i = NODE_TO_INDEX.get(child);
	      if (i == null) {
	        break;
	      }

	      // 拼接 patch
	      path.unshift(i);

	      // 继续向上递归
	      child = parent;
	    }
	    throw new Error("Unable to find the path for Slate node: ".concat(_JSON$stringify(node)));
	  },
	  /**
	   * Find the DOM node that implements DocumentOrShadowRoot for the editor.
	   */
	  findDocumentOrShadowRoot: function findDocumentOrShadowRoot(editor) {
	    if (editor.isDestroyed) {
	      return window.document;
	    }
	    var el = DomEditor.toDOMNode(editor, editor);
	    var root = el.getRootNode();
	    if ((root instanceof Document || root instanceof ShadowRoot) && root.getSelection != null) {
	      return root;
	    }
	    return el.ownerDocument;
	  },
	  /**
	   * 获取父节点
	   * @param editor editor
	   * @param node cur node
	   */
	  getParentNode: function getParentNode(editor, node) {
	    return NODE_TO_PARENT.get(node) || null;
	  },
	  /**
	   * 获取当前节点的所有父节点
	   * @param editor editor
	   * @param node cur node
	   */
	  getParentsNodes: function getParentsNodes(editor, node) {
	    var nodes = [];
	    var curNode = node;
	    while (curNode !== editor && curNode != null) {
	      var parentNode = DomEditor.getParentNode(editor, curNode);
	      if (parentNode == null) {
	        break;
	      } else {
	        nodes.push(parentNode);
	        curNode = parentNode;
	      }
	    }
	    return nodes;
	  },
	  /**
	   * 获取当前节点对应的顶级节点
	   * @param editor editor
	   * @param curNode cur node
	   */
	  getTopNode: function getTopNode(editor, curNode) {
	    var path = DomEditor.findPath(editor, curNode);
	    var topPath = [path[0]];
	    return Node.get(editor, topPath);
	  },
	  /**
	   * Find the native DOM element from a Slate node or editor.
	   */
	  toDOMNode: function toDOMNode(editor, node) {
	    var domNode;
	    var isEditor = Editor.isEditor(node);
	    if (isEditor) {
	      domNode = EDITOR_TO_ELEMENT.get(editor);
	    } else {
	      var key = DomEditor.findKey(editor, node);
	      domNode = KEY_TO_ELEMENT.get(key);
	    }
	    if (!domNode) {
	      throw new Error("Cannot resolve a DOM node from Slate node: ".concat(_JSON$stringify(node)));
	    }
	    return domNode;
	  },
	  /**
	   * Check if a DOM node is within the editor.
	   */
	  hasDOMNode: function hasDOMNode(editor, target) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	      editable: false
	    };
	    var _options$editable = options.editable,
	      editable = _options$editable === void 0 ? false : _options$editable;
	    var editorEl = DomEditor.toDOMNode(editor, editor);
	    var targetEl;

	    // COMPAT: In Firefox, reading `target.nodeType` will throw an error if
	    // target is originating from an internal "restricted" element (e.g. a
	    // stepper arrow on a number input). (2018/05/04)
	    // https://github.com/ianstormtaylor/slate/issues/1819
	    try {
	      targetEl = isDOMElement(target) ? target : target.parentElement;
	    } catch (err) {
	      var _context;
	      if (!_includesInstanceProperty(_context = err.message).call(_context, 'Permission denied to access property "nodeType"')) {
	        throw err;
	      }
	    }
	    if (!targetEl) {
	      return false;
	    }
	    return (
	      // 祖先节点中包括 data-slate-editor 属性，即 textarea
	      targetEl.closest("[data-slate-editor]") === editorEl && (
	      // 通过参数 editable 控制开启是否验证是可编辑元素或零宽字符
	      !editable || targetEl.isContentEditable || !!targetEl.getAttribute('data-slate-zero-width'))
	    );
	  },
	  /**
	   * Find a native DOM range from a Slate `range`.
	   *
	   * Notice: the returned range will always be ordinal regardless of the direction of Slate `range` due to DOM API limit.
	   *
	   * there is no way to create a reverse DOM Range using Range.setStart/setEnd
	   * according to https://dom.spec.whatwg.org/#concept-range-bp-set.
	   */
	  toDOMRange: function toDOMRange(editor, range) {
	    var anchor = range.anchor,
	      focus = range.focus;
	    var isBackward = Range.isBackward(range);
	    var domAnchor = DomEditor.toDOMPoint(editor, anchor);
	    var domFocus = Range.isCollapsed(range) ? domAnchor : DomEditor.toDOMPoint(editor, focus);
	    var window = DomEditor.getWindow(editor);
	    var domRange = window.document.createRange();
	    var _ref = isBackward ? domFocus : domAnchor,
	      _ref2 = _slicedToArray(_ref, 2),
	      startNode = _ref2[0],
	      startOffset = _ref2[1];
	    var _ref3 = isBackward ? domAnchor : domFocus,
	      _ref4 = _slicedToArray(_ref3, 2),
	      endNode = _ref4[0],
	      endOffset = _ref4[1];

	    // A slate Point at zero-width Leaf always has an offset of 0 but a native DOM selection at
	    // zero-width node has an offset of 1 so we have to check if we are in a zero-width node and
	    // adjust the offset accordingly.
	    var startEl = isDOMElement(startNode) ? startNode : startNode.parentElement;
	    var isStartAtZeroWidth = !!startEl.getAttribute('data-slate-zero-width');
	    var endEl = isDOMElement(endNode) ? endNode : endNode.parentElement;
	    var isEndAtZeroWidth = !!endEl.getAttribute('data-slate-zero-width');
	    domRange.setStart(startNode, isStartAtZeroWidth ? 1 : startOffset);
	    domRange.setEnd(endNode, isEndAtZeroWidth ? 1 : endOffset);
	    return domRange;
	  },
	  /**
	   * Find a native DOM selection point from a Slate point.
	   */
	  toDOMPoint: function toDOMPoint(editor, point) {
	    var _Editor$node = Editor.node(editor, point.path),
	      _Editor$node2 = _slicedToArray(_Editor$node, 1),
	      node = _Editor$node2[0];
	    var el = DomEditor.toDOMNode(editor, node);
	    var domPoint;

	    // If we're inside a void node, force the offset to 0, otherwise the zero
	    // width spacing character will result in an incorrect offset of 1
	    if (Editor.void(editor, {
	      at: point
	    })) {
	      // void 节点，offset 必须为 0
	      point = {
	        path: point.path,
	        offset: 0
	      };
	    }

	    // For each leaf, we need to isolate its content, which means filtering
	    // to its direct text and zero-width spans. (We have to filter out any
	    // other siblings that may have been rendered alongside them.)
	    var selector = "[data-slate-string], [data-slate-zero-width]";
	    var texts = _Array$from(el.querySelectorAll(selector));
	    var start = 0;
	    var _iterator = _createForOfIteratorHelper$5(texts),
	      _step;
	    try {
	      for (_iterator.s(); !(_step = _iterator.n()).done;) {
	        var text = _step.value;
	        var domNode = text.childNodes[0];
	        if (domNode == null || domNode.textContent == null) {
	          continue;
	        }
	        var length = domNode.textContent.length;
	        var attr = text.getAttribute('data-slate-length');
	        var trueLength = attr == null ? length : _parseInt$1(attr, 10);
	        var end = start + trueLength;
	        if (point.offset <= end) {
	          var offset = Math.min(length, Math.max(0, point.offset - start));
	          domPoint = [domNode, offset];
	          break;
	        }
	        start = end;
	      }
	    } catch (err) {
	      _iterator.e(err);
	    } finally {
	      _iterator.f();
	    }
	    if (!domPoint) {
	      throw new Error("Cannot resolve a DOM point from Slate point: ".concat(_JSON$stringify(point)));
	    }
	    return domPoint;
	  },
	  /**
	   * Find a Slate node from a native DOM `element`.
	   */
	  toSlateNode: function toSlateNode(editor, domNode) {
	    var domEl = isDOMElement(domNode) ? domNode : domNode.parentElement;
	    if (domEl && !domEl.hasAttribute('data-slate-node')) {
	      domEl = domEl.closest("[data-slate-node]");
	    }
	    var node = domEl ? ELEMENT_TO_NODE.get(domEl) : null;
	    if (!node) {
	      throw new Error("Cannot resolve a Slate node from DOM node: ".concat(domEl));
	    }
	    return node;
	  },
	  /**
	   * Get the target range from a DOM `event`.
	   */
	  findEventRange: function findEventRange(editor, event) {
	    if ('nativeEvent' in event) {
	      // 兼容 react 的合成事件，DOM 事件中没什么用
	      event = event.nativeEvent;
	    }
	    var _event = event,
	      x = _event.clientX,
	      y = _event.clientY,
	      target = _event.target;
	    if (x == null || y == null) {
	      throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(event));
	    }
	    var node = DomEditor.toSlateNode(editor, event.target);
	    var path = DomEditor.findPath(editor, node);

	    // If the drop target is inside a void node, move it into either the
	    // next or previous node, depending on which side the `x` and `y`
	    // coordinates are closest to.
	    if (Editor.isVoid(editor, node)) {
	      var rect = target.getBoundingClientRect();
	      var isPrev = editor.isInline(node) ? x - rect.left < rect.left + rect.width - x : y - rect.top < rect.top + rect.height - y;
	      var edge = Editor.point(editor, path, {
	        edge: isPrev ? 'start' : 'end'
	      });
	      var point = isPrev ? Editor.before(editor, edge) : Editor.after(editor, edge);
	      if (point) {
	        var _range = Editor.range(editor, point);
	        return _range;
	      }
	    }

	    // Else resolve a range from the caret position where the drop occured.
	    var domRange;
	    var _this$getWindow = this.getWindow(editor),
	      document = _this$getWindow.document;

	    // COMPAT: In Firefox, `caretRangeFromPoint` doesn't exist. (2016/07/25)
	    if (document.caretRangeFromPoint) {
	      domRange = document.caretRangeFromPoint(x, y);
	    } else {
	      var position = document.caretPositionFromPoint(x, y);
	      if (position) {
	        domRange = document.createRange();
	        domRange.setStart(position.offsetNode, position.offset);
	        domRange.setEnd(position.offsetNode, position.offset);
	      }
	    }
	    if (!domRange) {
	      throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(event));
	    }

	    // Resolve a Slate range from the DOM range.
	    var range = DomEditor.toSlateRange(editor, domRange, {
	      exactMatch: false,
	      suppressThrow: false
	    });
	    return range;
	  },
	  /**
	   * Find a Slate range from a DOM range or selection.
	   */
	  toSlateRange: function toSlateRange(editor, domRange, options) {
	    var exactMatch = options.exactMatch,
	      suppressThrow = options.suppressThrow;
	    var el = isDOMSelection(domRange) ? domRange.anchorNode : domRange.startContainer;
	    var anchorNode;
	    var anchorOffset;
	    var focusNode;
	    var focusOffset;
	    var isCollapsed;
	    if (el) {
	      if (isDOMSelection(domRange)) {
	        anchorNode = domRange.anchorNode;
	        anchorOffset = domRange.anchorOffset;
	        focusNode = domRange.focusNode;
	        focusOffset = domRange.focusOffset;
	        // COMPAT: There's a bug in chrome that always returns `true` for
	        // `isCollapsed` for a Selection that comes from a ShadowRoot.
	        // (2020/08/08)
	        // https://bugs.chromium.org/p/chromium/issues/detail?id=447523
	        if (IS_CHROME && hasShadowRoot()) {
	          isCollapsed = domRange.anchorNode === domRange.focusNode && domRange.anchorOffset === domRange.focusOffset;
	        } else {
	          isCollapsed = domRange.isCollapsed;
	        }
	      } else {
	        anchorNode = domRange.startContainer;
	        anchorOffset = domRange.startOffset;
	        focusNode = domRange.endContainer;
	        focusOffset = domRange.endOffset;
	        isCollapsed = domRange.collapsed;
	      }
	    }
	    if (anchorNode == null || focusNode == null || anchorOffset == null || focusOffset == null) {
	      throw new Error("Cannot resolve a Slate range from DOM range: ".concat(domRange));
	    }
	    var anchor = DomEditor.toSlatePoint(editor, [anchorNode, anchorOffset], {
	      exactMatch: exactMatch,
	      suppressThrow: suppressThrow
	    });
	    if (!anchor) {
	      return null;
	    }
	    var focus = isCollapsed ? anchor : DomEditor.toSlatePoint(editor, [focusNode, focusOffset], {
	      exactMatch: exactMatch,
	      suppressThrow: suppressThrow
	    });
	    if (!focus) {
	      return null;
	    }

	    // return { anchor, focus } as unknown as T extends true ? Range | null : Range

	    var range = {
	      anchor: anchor,
	      focus: focus
	    };
	    // if the selection is a hanging range that ends in a void
	    // and the DOM focus is an Element
	    // (meaning that the selection ends before the element)
	    // unhang the range to avoid mistakenly including the void
	    if (Range.isExpanded(range) && Range.isForward(range) && isDOMElement(focusNode) && Editor.void(editor, {
	      at: range.focus,
	      mode: 'highest'
	    })) {
	      range = Editor.unhangRange(editor, range, {
	        voids: true
	      });
	    }
	    return range;
	  },
	  /**
	   * Find a Slate point from a DOM selection's `domNode` and `domOffset`.
	   */
	  toSlatePoint: function toSlatePoint(editor, domPoint, options) {
	    var exactMatch = options.exactMatch,
	      suppressThrow = options.suppressThrow;
	    var _ref5 = exactMatch ? domPoint : normalizeDOMPoint(domPoint),
	      _ref6 = _slicedToArray(_ref5, 2),
	      nearestNode = _ref6[0],
	      nearestOffset = _ref6[1];
	    var parentNode = nearestNode.parentNode;
	    var textNode = null;
	    var offset = 0;
	    if (parentNode) {
	      var _domNode$textContent;
	      var voidNode = parentNode.closest('[data-slate-void="true"]');
	      var leafNode = parentNode.closest('[data-slate-leaf]');
	      var domNode = null;

	      // Calculate how far into the text node the `nearestNode` is, so that we
	      // can determine what the offset relative to the text node is.
	      if (leafNode) {
	        var _context2;
	        textNode = leafNode.closest('[data-slate-node="text"]');
	        var _window = DomEditor.getWindow(editor);
	        var range = _window.document.createRange();
	        range.setStart(textNode, 0);
	        range.setEnd(nearestNode, nearestOffset);
	        var contents = range.cloneContents();
	        var removals = _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(toArray$1(contents.querySelectorAll('[data-slate-zero-width]'))), _toConsumableArray(toArray$1(contents.querySelectorAll('[contenteditable=false]'))));
	        _forEachInstanceProperty(removals).call(removals, function (el) {
	          el.parentNode.removeChild(el);
	        });

	        // COMPAT: Edge has a bug where Range.prototype.toString() will
	        // convert \n into \r\n. The bug causes a loop when slate-react
	        // attempts to reposition its cursor to match the native position. Use
	        // textContent.length instead.
	        // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10291116/
	        offset = contents.textContent.length;
	        domNode = textNode;
	      } else if (voidNode) {
	        // For void nodes, the element with the offset key will be a cousin, not an
	        // ancestor, so find it by going down from the nearest void parent.
	        leafNode = voidNode.querySelector('[data-slate-leaf]');

	        // COMPAT: In read-only editors the leaf is not rendered.
	        if (!leafNode) {
	          offset = 1;
	        } else {
	          var _context3;
	          textNode = leafNode.closest('[data-slate-node="text"]');
	          domNode = leafNode;
	          offset = domNode.textContent.length;
	          _forEachInstanceProperty(_context3 = domNode.querySelectorAll('[data-slate-zero-width]')).call(_context3, function (el) {
	            offset -= el.textContent.length;
	          });
	        }
	      }
	      if (domNode && offset === domNode.textContent.length && (
	      // COMPAT: If the parent node is a Slate zero-width space, editor is
	      // because the text node should have no characters. However, during IME
	      // composition the ASCII characters will be prepended to the zero-width
	      // space, so subtract 1 from the offset to account for the zero-width
	      // space character.
	      parentNode.hasAttribute('data-slate-zero-width') ||
	      // COMPAT: In Firefox, `range.cloneContents()` returns an extra trailing '\n'
	      // when the document ends with a new-line character. This results in the offset
	      // length being off by one, so we need to subtract one to account for this.
	      IS_FIREFOX && (_domNode$textContent = domNode.textContent) !== null && _domNode$textContent !== void 0 && _endsWithInstanceProperty(_domNode$textContent).call(_domNode$textContent, '\n'))) {
	        offset--;
	      }
	    }
	    if (!textNode) {
	      if (suppressThrow) {
	        return null;
	      }
	      throw new Error("Cannot resolve a Slate point from DOM point: ".concat(domPoint));
	    }

	    // COMPAT: If someone is clicking from one Slate editor into another,
	    // the select event fires twice, once for the old editor's `element`
	    // first, and then afterwards for the correct `element`. (2017/03/03)
	    var slateNode = DomEditor.toSlateNode(editor, textNode);
	    var path = DomEditor.findPath(editor, slateNode);
	    return {
	      path: path,
	      offset: offset
	    };
	  },
	  hasRange: function hasRange(editor, range) {
	    var anchor = range.anchor,
	      focus = range.focus;
	    return Editor.hasPath(editor, anchor.path) && Editor.hasPath(editor, focus.path);
	  },
	  getNodeType: function getNodeType(node) {
	    if (Element.isElement(node)) {
	      return node.type;
	    }
	    return '';
	  },
	  checkNodeType: function checkNodeType(node, type) {
	    return this.getNodeType(node) === type;
	  },
	  getNodesStr: function getNodesStr(nodes) {
	    return _mapInstanceProperty(nodes).call(nodes, function (node) {
	      return Node.string(node);
	    }).join('');
	  },
	  getSelectedElems: function getSelectedElems(editor) {
	    var elems = [];
	    var nodeEntries = Editor.nodes(editor, {
	      universal: true
	    });
	    var _iterator2 = _createForOfIteratorHelper$5(nodeEntries),
	      _step2;
	    try {
	      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
	        var nodeEntry = _step2.value;
	        var _nodeEntry = _slicedToArray(nodeEntry, 1),
	          node = _nodeEntry[0];
	        if (Element.isElement(node)) elems.push(node);
	      }
	    } catch (err) {
	      _iterator2.e(err);
	    } finally {
	      _iterator2.f();
	    }
	    return elems;
	  },
	  getSelectedNodeByType: function getSelectedNodeByType(editor, type) {
	    var _this = this;
	    var _Editor$nodes = Editor.nodes(editor, {
	        match: function match(n) {
	          return _this.checkNodeType(n, type);
	        },
	        universal: true
	      }),
	      _Editor$nodes2 = _slicedToArray(_Editor$nodes, 1),
	      nodeEntry = _Editor$nodes2[0];
	    if (nodeEntry == null) return null;
	    return nodeEntry[0];
	  },
	  getSelectedTextNode: function getSelectedTextNode(editor) {
	    var _Editor$nodes3 = Editor.nodes(editor, {
	        match: function match(n) {
	          return Text.isText(n);
	        },
	        universal: true
	      }),
	      _Editor$nodes4 = _slicedToArray(_Editor$nodes3, 1),
	      nodeEntry = _Editor$nodes4[0];
	    if (nodeEntry == null) return null;
	    return nodeEntry[0];
	  },
	  isNodeSelected: function isNodeSelected(editor, node) {
	    var _Editor$nodes5 = Editor.nodes(editor, {
	        match: function match(n) {
	          return n === node;
	        },
	        universal: true
	      }),
	      _Editor$nodes6 = _slicedToArray(_Editor$nodes5, 1),
	      nodeEntry = _Editor$nodes6[0];
	    if (nodeEntry == null) return false;
	    var _nodeEntry2 = _slicedToArray(nodeEntry, 1),
	      n = _nodeEntry2[0];
	    if (n === node) return true;
	    return false;
	  },
	  isSelectionAtLineEnd: function isSelectionAtLineEnd(editor, path) {
	    var selection = editor.selection;
	    if (!selection) return false;
	    var isAtLineEnd = Editor.isEnd(editor, selection.anchor, path) || Editor.isEnd(editor, selection.focus, path);
	    return isAtLineEnd;
	  },
	  // 获取 textarea 实例
	  getTextarea: function getTextarea(editor) {
	    var textarea = EDITOR_TO_TEXTAREA.get(editor);
	    if (textarea == null) throw new Error('Cannot find textarea instance by editor');
	    return textarea;
	  },
	  // 获取 toolbar 实例
	  getToolbar: function getToolbar(editor) {
	    return EDITOR_TO_TOOLBAR.get(editor) || null;
	  },
	  // 获取 hoverbar 实例
	  getHoverbar: function getHoverbar(editor) {
	    return EDITOR_TO_HOVER_BAR.get(editor) || null;
	  },
	  // 格式化 editor content
	  normalizeContent: function normalizeContent(editor) {
	    var _context4;
	    _forEachInstanceProperty(_context4 = editor.children).call(_context4, function (node, index) {
	      editor.normalizeNode([node, [index]]);
	    });
	  },
	  /**
	   * 获取：距离触发 maxLength，还可以插入多少字符
	   * @param editor editor
	   */
	  getLeftLengthOfMaxLength: function getLeftLengthOfMaxLength(editor) {
	    var _editor$getConfig = editor.getConfig(),
	      maxLength = _editor$getConfig.maxLength,
	      onMaxLength = _editor$getConfig.onMaxLength;

	    // 未设置 maxLength ，则返回 number 最大值
	    if (typeof maxLength !== 'number' || maxLength <= 0) return Infinity;
	    var editorText = editor.getText().replace(/\r|\n|(\r\n)/g, ''); // 去掉换行
	    var curLength = editorText.length;
	    var leftLength = maxLength - curLength;
	    if (leftLength <= 0) {
	      // 触发 maxLength 限制，不再继续插入文字
	      if (onMaxLength) onMaxLength(editor);
	    }
	    return leftLength;
	  },
	  // 清理暴露的 text 节点（拼音输入时经常出现）
	  cleanExposedTexNodeInSelectionBlock: function cleanExposedTexNodeInSelectionBlock(editor) {
	    // 有时候全选删除新增的文本节点可能不在段落内，因此遍历textArea删除掉
	    var _DomEditor$getTextare = DomEditor.getTextarea(editor),
	      $textArea = _DomEditor$getTextare.$textArea;
	    var childNodes = $textArea === null || $textArea === void 0 ? void 0 : $textArea[0].childNodes;
	    if (childNodes) {
	      for (var _i = 0, _Array$from2 = _Array$from(childNodes); _i < _Array$from2.length; _i++) {
	        var node = _Array$from2[_i];
	        if (node.nodeType === 3) {
	          node.remove();
	        } else {
	          break;
	        }
	      }
	    }
	    var nodeEntries = Editor.nodes(editor, {
	      match: function match(n) {
	        if (Element.isElement(n)) {
	          if (!editor.isInline(n)) {
	            // 匹配 block element
	            return true;
	          }
	        }
	        return false;
	      },
	      universal: true
	    });
	    var _iterator3 = _createForOfIteratorHelper$5(nodeEntries),
	      _step3;
	    try {
	      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
	        var nodeEntry = _step3.value;
	        if (nodeEntry != null) {
	          var n = nodeEntry[0];
	          var elem = DomEditor.toDOMNode(editor, n);

	          // 只遍历 elem 范围，考虑性能
	          walkTextNodes(elem, function (textNode, parent) {
	            var $parent = $$x(parent);
	            if ($parent.attr('data-slate-string')) {
	              return; // 正常的 text
	            }

	            if ($parent.attr('data-slate-zero-width')) {
	              return; // 正常的 text
	            }

	            if ($parent.attr('data-s-e-reserve')) {
	              return; // 故意保留的节点
	            }

	            // 暴露的 text node ，删除
	            parent.removeChild(textNode);
	          });
	        }
	      }
	    } catch (err) {
	      _iterator3.e(err);
	    } finally {
	      _iterator3.f();
	    }
	  },
	  /**
	   * 是否是编辑器里最后一个元素
	   * @param editor editor
	   * @param node node
	   */
	  isLastNode: function isLastNode(editor, node) {
	    var editorChildren = editor.children || [];
	    var editorChildrenLength = editorChildren.length;
	    return editorChildren[editorChildrenLength - 1] === node;
	  },
	  /**
	   * 生成空白 paragraph
	   */
	  genEmptyParagraph: function genEmptyParagraph() {
	    return {
	      type: 'paragraph',
	      children: [{
	        text: ''
	      }]
	    };
	  },
	  /**
	   * 是否选中了 void node
	   * @param editor editor
	   */
	  isSelectedVoidNode: function isSelectedVoidNode(editor) {
	    var voidNodes = Editor.nodes(editor, {
	      match: function match(n) {
	        return editor.isVoid(n);
	      }
	    });
	    var len = 0;
	    var _iterator4 = _createForOfIteratorHelper$5(voidNodes),
	      _step4;
	    try {
	      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
	        var n = _step4.value;
	        len++;
	      }
	    } catch (err) {
	      _iterator4.e(err);
	    } finally {
	      _iterator4.f();
	    }
	    return len > 0;
	  },
	  /**
	   * 选区是否在一个空行
	   * @param editor editor
	   */
	  isSelectedEmptyParagraph: function isSelectedEmptyParagraph(editor) {
	    var selection = editor.selection;
	    if (selection == null) return false;
	    if (Range.isExpanded(selection)) return false;
	    var selectedNode = DomEditor.getSelectedNodeByType(editor, 'paragraph');
	    if (selectedNode === null) return false;
	    var children = selectedNode.children;
	    if (children.length !== 1) return false;
	    var text = children[0].text;
	    if (text === '') return true;
	  },
	  /**
	   * 当前 path 指向的 node ，是否是空的（无内容）
	   * @param editor editor
	   * @param path path
	   */
	  isEmptyPath: function isEmptyPath(editor, path) {
	    var entry = Editor.node(editor, path);
	    if (entry == null) return false;
	    var _entry = _slicedToArray(entry, 1),
	      node = _entry[0];
	    var children = node.children;
	    if (children.length === 1) {
	      var text = children[0].text;
	      if (text === '') return true; // 内容为空
	    }

	    return false;
	  }
	};

	function genElemId(id) {
	  return "s-e-element-".concat(id);
	}
	function genTextId(id) {
	  return "s-e-text-".concat(id);
	}

	var doRectsIntersect = function doRectsIntersect(rect, compareRect) {
	  var middle = (compareRect.top + compareRect.bottom) / 2;
	  return rect.top <= middle && rect.bottom >= middle;
	};
	var areRangesSameLine = function areRangesSameLine(editor, range1, range2) {
	  var rect1 = DomEditor.toDOMRange(editor, range1).getBoundingClientRect();
	  var rect2 = DomEditor.toDOMRange(editor, range2).getBoundingClientRect();
	  return doRectsIntersect(rect1, rect2) && doRectsIntersect(rect2, rect1);
	};

	/**
	 * A helper utility that returns the end portion of a `Range`
	 * which is located on a single line.
	 *
	 * @param {Editor} editor The editor object to compare against
	 * @param {Range} parentRange The parent range to compare against
	 * @returns {Range} A valid portion of the parentRange which is one a single line
	 */
	var findCurrentLineRange = function findCurrentLineRange(editor, parentRange) {
	  var parentRangeBoundary = Editor.range(editor, Range.end(parentRange));
	  var positions = _Array$from(Editor.positions(editor, {
	    at: parentRange
	  }));
	  var left = 0;
	  var right = positions.length;
	  var middle = Math.floor(right / 2);
	  if (areRangesSameLine(editor, Editor.range(editor, positions[left]), parentRangeBoundary)) {
	    return Editor.range(editor, positions[left], parentRangeBoundary);
	  }
	  if (positions.length < 2) {
	    return Editor.range(editor, positions[positions.length - 1], parentRangeBoundary);
	  }
	  while (middle !== positions.length && middle !== left) {
	    if (areRangesSameLine(editor, Editor.range(editor, positions[middle]), parentRangeBoundary)) {
	      right = middle;
	    } else {
	      left = middle;
	    }
	    middle = Math.floor((left + right) / 2);
	  }
	  return Editor.range(editor, positions[right], parentRangeBoundary);
	};

	function ownKeys$7(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread$6(e) { for (var r = 1; r < arguments.length; r++) { var _context3, _context4; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context3 = ownKeys$7(Object(t), !0)).call(_context3, function (r) { _defineProperty$1(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context4 = ownKeys$7(Object(t))).call(_context4, function (r) { _Object$defineProperty$1(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
	function _createForOfIteratorHelper$4(o, allowArrayLike) { var it = typeof _Symbol$1 !== "undefined" && _getIteratorMethod(o) || o["@@iterator"]; if (!it) { if (_Array$isArray(o) || (it = _unsupportedIterableToArray$4(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
	function _unsupportedIterableToArray$4(o, minLen) { var _context2; if (!o) return; if (typeof o === "string") return _arrayLikeToArray$4(o, minLen); var n = _sliceInstanceProperty(_context2 = Object.prototype.toString.call(o)).call(_context2, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen); }
	function _arrayLikeToArray$4(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	var withContent = function withContent(editor) {
	  var e = editor;
	  var onChange = e.onChange,
	    insertText = e.insertText,
	    apply = e.apply,
	    deleteBackward = e.deleteBackward;
	  e.insertText = function (text) {
	    var _e$getConfig = e.getConfig(),
	      readOnly = _e$getConfig.readOnly;
	    if (readOnly) return;
	    insertText(text);
	  };

	  // 重写 apply 方法
	  // apply 方法非常重要，它最终执行 operation https://docs.slatejs.org/concepts/05-operations
	  // operation 的接口定义参考 slate src/interfaces/operation.ts
	  e.apply = function (op) {
	    var matches = [];
	    switch (op.type) {
	      case 'insert_text':
	      case 'remove_text':
	      case 'set_node':
	        {
	          var _iterator = _createForOfIteratorHelper$4(Editor.levels(e, {
	              at: op.path
	            })),
	            _step;
	          try {
	            for (_iterator.s(); !(_step = _iterator.n()).done;) {
	              var _step$value = _slicedToArray(_step.value, 2),
	                node = _step$value[0],
	                path = _step$value[1];
	              // 在当前节点寻找
	              var key = DomEditor.findKey(e, node);
	              matches.push([path, key]);
	            }
	          } catch (err) {
	            _iterator.e(err);
	          } finally {
	            _iterator.f();
	          }
	          break;
	        }
	      case 'insert_node':
	      case 'remove_node':
	      case 'merge_node':
	      case 'split_node':
	        {
	          var _iterator2 = _createForOfIteratorHelper$4(Editor.levels(e, {
	              at: Path.parent(op.path)
	            })),
	            _step2;
	          try {
	            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
	              var _step2$value = _slicedToArray(_step2.value, 2),
	                _node = _step2$value[0],
	                _path = _step2$value[1];
	              // 在父节点寻找
	              var _key = DomEditor.findKey(e, _node);
	              matches.push([_path, _key]);
	            }
	          } catch (err) {
	            _iterator2.e(err);
	          } finally {
	            _iterator2.f();
	          }
	          break;
	        }
	      case 'move_node':
	        {
	          var _iterator3 = _createForOfIteratorHelper$4(Editor.levels(e, {
	              at: Path.common(Path.parent(op.path), Path.parent(op.newPath))
	            })),
	            _step3;
	          try {
	            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
	              var _step3$value = _slicedToArray(_step3.value, 2),
	                _node2 = _step3$value[0],
	                _path2 = _step3$value[1];
	              var _key2 = DomEditor.findKey(e, _node2);
	              matches.push([_path2, _key2]);
	            }
	          } catch (err) {
	            _iterator3.e(err);
	          } finally {
	            _iterator3.f();
	          }
	          break;
	        }
	    }

	    // 执行原本的 apply - 重要！！！
	    apply(op);

	    // 绑定 node 和 key
	    for (var _i = 0, _matches = matches; _i < _matches.length; _i++) {
	      var _matches$_i = _slicedToArray(_matches[_i], 2),
	        _path3 = _matches$_i[0],
	        _key3 = _matches$_i[1];
	      var _Editor$node = Editor.node(e, _path3),
	        _Editor$node2 = _slicedToArray(_Editor$node, 1),
	        _node3 = _Editor$node2[0];
	      NODE_TO_KEY.set(_node3, _key3);
	    }
	  };
	  e.deleteBackward = function (unit) {
	    if (unit !== 'line') {
	      return deleteBackward(unit);
	    }
	    if (editor.selection && Range.isCollapsed(editor.selection)) {
	      var parentBlockEntry = Editor.above(editor, {
	        match: function match(n) {
	          return Editor.isBlock(editor, n);
	        },
	        at: editor.selection
	      });
	      if (parentBlockEntry) {
	        var _parentBlockEntry = _slicedToArray(parentBlockEntry, 2),
	          parentBlockPath = _parentBlockEntry[1];
	        var parentElementRange = Editor.range(editor, parentBlockPath, editor.selection.anchor);
	        var currentLineRange = findCurrentLineRange(e, parentElementRange);
	        if (!Range.isCollapsed(currentLineRange)) {
	          Transforms.delete(editor, {
	            at: currentLineRange
	          });
	        }
	      }
	    }
	  };

	  // 重写 onchange API
	  e.onChange = function () {
	    // 记录当前选区
	    var selection = e.selection;
	    if (selection != null) {
	      EDITOR_TO_SELECTION.set(e, selection);
	    }
	    // 触发配置的 change 事件
	    e.emit('change');
	    onChange();
	  };

	  // tab
	  e.handleTab = function () {
	    e.insertText('    ');
	  };

	  // 获取 text
	  e.getText = function () {
	    var _e$children = e.children,
	      children = _e$children === void 0 ? [] : _e$children;
	    return _mapInstanceProperty(children).call(children, function (child) {
	      return Node.string(child);
	    }).join('\n');
	  };

	  // 获取选区文字
	  e.getSelectionText = function () {
	    var selection = e.selection;
	    if (selection == null) return '';
	    return Editor.string(editor, selection);
	  };

	  // 根据 type 获取 elems
	  e.getElemsByType = function (type) {
	    var isPrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    var elems = [];

	    // 获取 editor 所有 nodes
	    var nodeEntries = Editor.nodes(e, {
	      at: [],
	      universal: true
	    });
	    var _iterator4 = _createForOfIteratorHelper$4(nodeEntries),
	      _step4;
	    try {
	      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
	        var nodeEntry = _step4.value;
	        var _nodeEntry = _slicedToArray(nodeEntry, 1),
	          node = _nodeEntry[0];
	        if (Element.isElement(node)) {
	          var _context;
	          // 判断 type （前缀 or 全等）
	          var flag = isPrefix ? _indexOfInstanceProperty(_context = node.type).call(_context, type) >= 0 : node.type === type;
	          if (flag) {
	            var key = DomEditor.findKey(e, node);
	            var id = genElemId(key.id);

	            // node + id
	            elems.push(_objectSpread$6(_objectSpread$6({}, node), {}, {
	              id: id
	            }));
	          }
	        }
	      }
	    } catch (err) {
	      _iterator4.e(err);
	    } finally {
	      _iterator4.f();
	    }
	    return elems;
	  };

	  // 根据 type 前缀，获取 elems
	  e.getElemsByTypePrefix = function (typePrefix) {
	    return e.getElemsByType(typePrefix, true);
	  };

	  /**
	   * 判断 editor 是否为空（只有一个空 paragraph）
	   */
	  e.isEmpty = function () {
	    var _e$children2 = e.children,
	      children = _e$children2 === void 0 ? [] : _e$children2;
	    if (children.length > 1) return false; // >1 个顶级节点

	    var firstNode = children[0];
	    if (firstNode == null) return true; // editor.children 空数组

	    if (Element.isElement(firstNode) && firstNode.type === 'paragraph') {
	      var _firstNode$children = firstNode.children,
	        texts = _firstNode$children === void 0 ? [] : _firstNode$children;
	      if (texts.length > 1) return false; // >1 text node

	      var t = texts[0];
	      if (t == null) return true; // 无 text 节点

	      if (Text.isText(t) && t.text === '') return true; // 只有一个 text 且是空字符串
	    }

	    return false;
	  };

	  /**
	   * 清空内容
	   */
	  e.clear = function () {
	    var initialEditorValue = [{
	      type: 'paragraph',
	      children: [{
	        text: ''
	      }]
	    }];
	    Transforms.delete(e, {
	      at: {
	        anchor: Editor.start(e, []),
	        focus: Editor.end(e, [])
	      }
	    });
	    if (e.children.length === 0) {
	      Transforms.insertNodes(e, initialEditorValue);
	    }
	  };
	  e.getParentNode = function (node) {
	    return DomEditor.getParentNode(e, node);
	  };
	  return e;
	};

	/* global Bun -- Bun case */
	var engineIsBun = typeof Bun == 'function' && Bun && typeof Bun.version == 'string';

	var $TypeError$3 = TypeError;

	var validateArgumentsLength$2 = function (passed, required) {
	  if (passed < required) throw new $TypeError$3('Not enough arguments');
	  return passed;
	};

	var global$9 = global$G;
	var apply$3 = functionApply$1;
	var isCallable$4 = isCallable$B;
	var ENGINE_IS_BUN = engineIsBun;
	var USER_AGENT = engineUserAgent$1;
	var arraySlice$3 = arraySlice$5;
	var validateArgumentsLength$1 = validateArgumentsLength$2;

	var Function$2 = global$9.Function;
	// dirty IE9- and Bun 0.3.0- checks
	var WRAP = /MSIE .\./.test(USER_AGENT) || ENGINE_IS_BUN && (function () {
	  var version = global$9.Bun.version.split('.');
	  return version.length < 3 || version[0] === '0' && (version[1] < 3 || version[1] === '3' && version[2] === '0');
	})();

	// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
	// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
	// https://github.com/oven-sh/bun/issues/1633
	var schedulersFix$2 = function (scheduler, hasTimeArg) {
	  var firstParamIndex = hasTimeArg ? 2 : 1;
	  return WRAP ? function (handler, timeout /* , ...arguments */) {
	    var boundArgs = validateArgumentsLength$1(arguments.length, 1) > firstParamIndex;
	    var fn = isCallable$4(handler) ? handler : Function$2(handler);
	    var params = boundArgs ? arraySlice$3(arguments, firstParamIndex) : [];
	    var callback = boundArgs ? function () {
	      apply$3(fn, this, params);
	    } : fn;
	    return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
	  } : scheduler;
	};

	var $$v = _export$1;
	var global$8 = global$G;
	var schedulersFix$1 = schedulersFix$2;

	var setInterval = schedulersFix$1(global$8.setInterval, true);

	// Bun / IE9- setInterval additional parameters fix
	// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
	$$v({ global: true, bind: true, forced: global$8.setInterval !== setInterval }, {
	  setInterval: setInterval
	});

	var $$u = _export$1;
	var global$7 = global$G;
	var schedulersFix = schedulersFix$2;

	var setTimeout$3 = schedulersFix(global$7.setTimeout, true);

	// Bun / IE9- setTimeout additional parameters fix
	// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
	$$u({ global: true, bind: true, forced: global$7.setTimeout !== setTimeout$3 }, {
	  setTimeout: setTimeout$3
	});

	var path$7 = path$q;

	var setTimeout$2 = path$7.setTimeout;

	var setTimeout$1 = setTimeout$2;

	var _setTimeout = /*@__PURE__*/getDefaultExportFromCjs(setTimeout$1);

	var ID$1 = 1;

	/**
	 * `withDOM` adds DOM specific behaviors to the editor.
	 */
	var withDOM = function withDOM(editor) {
	  var e = editor;
	  e.id = "wangEditor-".concat(ID$1++);
	  e.isDestroyed = false;
	  e.isFullScreen = false;

	  // focus
	  e.focus = function (isEnd) {
	    var el = DomEditor.toDOMNode(e, e);
	    el.focus({
	      preventScroll: true
	    });
	    IS_FOCUSED.set(e, true);

	    // 恢复选区
	    if (isEnd) {
	      // 选区定位到结尾
	      var end = Editor.end(e, []);
	      Transforms.select(e, end);
	    } else {
	      var selection = EDITOR_TO_SELECTION.get(e);
	      if (selection) {
	        Transforms.select(e, selection); // 选区定位到之前的位置
	      } else {
	        Transforms.select(e, Editor.start(e, [])); // 选区定位到开始
	      }
	    }
	  };

	  // isFocused
	  e.isFocused = function () {
	    return !!IS_FOCUSED.get(e);
	  };

	  // blur
	  e.blur = function () {
	    var el = DomEditor.toDOMNode(e, e);
	    el.blur();

	    // 手动执行一次光标 deselect, 触发 onchange 回调，改变 Toolbar 的状态
	    Transforms.deselect(e);
	    IS_FOCUSED.set(e, false);
	  };

	  // 手动更新试图
	  e.updateView = function () {
	    var textarea = DomEditor.getTextarea(e);
	    textarea.changeViewState();
	    var toolbar = DomEditor.getToolbar(e);
	    toolbar && toolbar.changeToolbarState();
	    var hoverbar = DomEditor.getHoverbar(e);
	    hoverbar && hoverbar.changeHoverbarState();
	  };

	  // destroy
	  e.destroy = function () {
	    // 销毁相关实例（会销毁 DOM）
	    if (e.isDestroyed) return;
	    // fix https://github.com/wangeditor-team/wangEditor-v5/issues/457
	    var textarea = DomEditor.getTextarea(e);
	    textarea.destroy();
	    EDITOR_TO_TEXTAREA.delete(e);
	    TEXTAREA_TO_EDITOR.delete(textarea);
	    var toolbar = DomEditor.getToolbar(e);
	    if (toolbar) {
	      toolbar.destroy();
	      EDITOR_TO_TOOLBAR.delete(e);
	      TOOLBAR_TO_EDITOR.delete(toolbar);
	    }
	    var hoverbar = DomEditor.getHoverbar(e);
	    if (hoverbar) {
	      hoverbar.destroy();
	      EDITOR_TO_HOVER_BAR.delete(e);
	      HOVER_BAR_TO_EDITOR.delete(hoverbar);
	    }

	    // 修改属性
	    e.isDestroyed = true;

	    // 触发自定义事件
	    e.emit('destroyed');
	  };

	  // scroll to elem
	  e.scrollToElem = function (id) {
	    var _e$getConfig = e.getConfig(),
	      scroll = _e$getConfig.scroll;
	    if (!scroll) {
	      // 没有设置编辑区域滚动，则不能用
	      var info = '编辑器禁用了 scroll ，编辑器内容无法滚动，请自行实现该功能';
	      info += '\nYou has disabled editor scroll, please do this yourself';
	      console.warn(info);
	      return;
	    }
	    var $elem = $$x("#".concat(id));
	    if ($elem.length === 0) return;

	    // $elem 不在 editor DOM 范围之内
	    var elem = $elem[0];
	    if (!DomEditor.hasDOMNode(e, elem)) {
	      var _info = "Element (found by id is '".concat(id, "') is not in editor DOM");
	      _info += "\n \u901A\u8FC7 id '".concat(id, "' \u627E\u5230\u7684 element \u4E0D\u5728 editor DOM \u4E4B\u5185");
	      console.error(_info, elem);
	      return;
	    }
	    var textarea = DomEditor.getTextarea(e);
	    var $container = textarea.$container,
	      $scroll = textarea.$scroll;
	    var _$elem$offset = $elem.offset(),
	      elemTop = _$elem$offset.top;
	    var _$container$offset = $container.offset(),
	      containerTop = _$container$offset.top;

	    // 滚动到指定元素
	    $scroll[0].scrollBy({
	      top: elemTop - containerTop,
	      behavior: 'smooth'
	    });
	  };

	  // showProgressBar
	  e.showProgressBar = function (progress) {
	    // progress 值范围： 0 - 100
	    if (progress < 1) return;

	    // 显示进度条
	    var textarea = DomEditor.getTextarea(e);
	    textarea.changeProgress(progress);
	  };

	  // 隐藏 panel 或 modal
	  e.hidePanelOrModal = function () {
	    var set = EDITOR_TO_PANEL_AND_MODAL.get(e);
	    if (set == null) return;
	    _forEachInstanceProperty(set).call(set, function (panelOrModal) {
	      return panelOrModal.hide();
	    });
	  };
	  e.enable = function () {
	    var config = e.getConfig();
	    config.readOnly = false;

	    // 更新视图
	    e.updateView();
	  };
	  e.disable = function () {
	    var config = e.getConfig();
	    config.readOnly = true;

	    // 更新视图
	    e.updateView();
	  };
	  e.isDisabled = function () {
	    var config = e.getConfig();
	    return config.readOnly;
	  };
	  e.toDOMNode = function (node) {
	    return DomEditor.toDOMNode(e, node);
	  };
	  e.fullScreen = function () {
	    if (e.isFullScreen) return;
	    var $toolbarBox = null;
	    var toolbar = DomEditor.getToolbar(e);
	    if (toolbar) {
	      $toolbarBox = toolbar.$box;
	    }
	    var textarea = DomEditor.getTextarea(e);
	    var $textAreaBox = textarea.$box;
	    var $parent = $textAreaBox.parent();
	    if ($toolbarBox && $toolbarBox.parent()[0] !== $parent[0]) {
	      // toolbar DOM 父节点，和 editor DOM 父节点不一致，则不能设置全屏
	      var info = 'Can not set full screen, cause toolbar DOM parent is not equal to textarea DOM parent';
	      info += '\n不能设置全屏，因为 toolbar DOM 父节点和 textarea DOM 父节点不一致';
	      throw new Error(info);
	    }

	    // 设置全屏
	    $parent.addClass('s-e-full-screen-container');

	    // 设置 z-index
	    var curZIndex = $parent.css('z-index');
	    $parent.attr('data-z-index', curZIndex.toString());

	    // 记录属性
	    e.isFullScreen = true;

	    // 触发自定义事件
	    e.emit('fullScreen');
	  };
	  e.unFullScreen = function () {
	    if (!e.isFullScreen) return;
	    var textarea = DomEditor.getTextarea(e);
	    var $textAreaBox = textarea.$box;
	    var $parent = $textAreaBox.parent();

	    // 解决#issue175, 编辑器取消全屏 - element dialog组件会被隐藏
	    _setTimeout(function () {
	      // 取消全屏
	      $parent.removeClass('s-e-full-screen-container');

	      // 记录属性
	      e.isFullScreen = false;

	      // 触发自定义事件
	      e.emit('unFullScreen');
	    }, 200);
	  };

	  /**
	   * 获取编辑区域 DOM 容器
	   */
	  e.getEditableContainer = function () {
	    var textarea = DomEditor.getTextarea(e);
	    return textarea.$container[0];
	  };
	  return e;
	};

	var $$t = _export;
	var toObject$2 = toObject$7;
	var nativeKeys = objectKeys$2;
	var fails$9 = fails$v;

	var FAILS_ON_PRIMITIVES$1 = fails$9(function () { nativeKeys(1); });

	// `Object.keys` method
	// https://tc39.es/ecma262/#sec-object.keys
	$$t({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES$1 }, {
	  keys: function keys(it) {
	    return nativeKeys(toObject$2(it));
	  }
	});

	var isObject$8 = isObject$k;
	var classof$1 = classofRaw$2;
	var wellKnownSymbol$4 = wellKnownSymbol$f;

	var MATCH = wellKnownSymbol$4('match');

	// `IsRegExp` abstract operation
	// https://tc39.es/ecma262/#sec-isregexp
	var isRegexp = function (it) {
	  var isRegExp;
	  return isObject$8(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof$1(it) === 'RegExp');
	};

	var isConstructor$1 = isConstructor$3;
	var tryToString$1 = tryToString$3;

	var $TypeError$2 = TypeError;

	// `Assert: IsConstructor(argument) is true`
	var aConstructor$4 = function (argument) {
	  if (isConstructor$1(argument)) return argument;
	  throw new $TypeError$2(tryToString$1(argument) + ' is not a constructor');
	};

	var anObject$5 = anObject$e;
	var aConstructor$3 = aConstructor$4;
	var isNullOrUndefined$3 = isNullOrUndefined$7;
	var wellKnownSymbol$3 = wellKnownSymbol$f;

	var SPECIES$2 = wellKnownSymbol$3('species');

	// `SpeciesConstructor` abstract operation
	// https://tc39.es/ecma262/#sec-speciesconstructor
	var speciesConstructor$4 = function (O, defaultConstructor) {
	  var C = anObject$5(O).constructor;
	  var S;
	  return C === undefined || isNullOrUndefined$3(S = anObject$5(C)[SPECIES$2]) ? defaultConstructor : aConstructor$3(S);
	};

	var toPropertyKey = toPropertyKey$3;
	var definePropertyModule$1 = objectDefineProperty;
	var createPropertyDescriptor$2 = createPropertyDescriptor$5;

	var createProperty$1 = function (object, key, value) {
	  var propertyKey = toPropertyKey(key);
	  if (propertyKey in object) definePropertyModule$1.f(object, propertyKey, createPropertyDescriptor$2(0, value));
	  else object[propertyKey] = value;
	};

	var toAbsoluteIndex = toAbsoluteIndex$2;
	var lengthOfArrayLike = lengthOfArrayLike$4;
	var createProperty = createProperty$1;

	var $Array = Array;
	var max = Math.max;

	var arraySliceSimple = function (O, start, end) {
	  var length = lengthOfArrayLike(O);
	  var k = toAbsoluteIndex(start, length);
	  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
	  var result = $Array(max(fin - k, 0));
	  var n = 0;
	  for (; k < fin; k++, n++) createProperty(result, n, O[k]);
	  result.length = n;
	  return result;
	};

	var apply$2 = functionApply;
	var call$8 = functionCall;
	var uncurryThis$8 = functionUncurryThis;
	var fixRegExpWellKnownSymbolLogic$1 = fixRegexpWellKnownSymbolLogic;
	var anObject$4 = anObject$e;
	var isNullOrUndefined$2 = isNullOrUndefined$7;
	var isRegExp = isRegexp;
	var requireObjectCoercible$3 = requireObjectCoercible$c;
	var speciesConstructor$3 = speciesConstructor$4;
	var advanceStringIndex$1 = advanceStringIndex$3;
	var toLength$2 = toLength$6;
	var toString$9 = toString$i;
	var getMethod$1 = getMethod$4;
	var arraySlice$2 = arraySliceSimple;
	var callRegExpExec = regexpExecAbstract;
	var regexpExec = regexpExec$3;
	var stickyHelpers = regexpStickyHelpers;
	var fails$8 = fails$v;

	var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
	var MAX_UINT32 = 0xFFFFFFFF;
	var min$1 = Math.min;
	var $push = [].push;
	var exec = uncurryThis$8(/./.exec);
	var push$2 = uncurryThis$8($push);
	var stringSlice$2 = uncurryThis$8(''.slice);

	// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	// Weex JS has frozen built-in prototypes, so use try / catch wrapper
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails$8(function () {
	  // eslint-disable-next-line regexp/no-empty-group -- required for testing
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
	});

	// @@split logic
	fixRegExpWellKnownSymbolLogic$1('split', function (SPLIT, nativeSplit, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'.split(/(b)*/)[1] === 'c' ||
	    // eslint-disable-next-line regexp/no-empty-group -- required for testing
	    'test'.split(/(?:)/, -1).length !== 4 ||
	    'ab'.split(/(?:ab)*/).length !== 2 ||
	    '.'.split(/(.?)(.?)/).length !== 4 ||
	    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
	    '.'.split(/()()/).length > 1 ||
	    ''.split(/.?/).length
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = toString$9(requireObjectCoercible$3(this));
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (separator === undefined) return [string];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) {
	        return call$8(nativeSplit, string, separator, lim);
	      }
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = call$8(regexpExec, separatorCopy, string)) {
	        lastIndex = separatorCopy.lastIndex;
	        if (lastIndex > lastLastIndex) {
	          push$2(output, stringSlice$2(string, lastLastIndex, match.index));
	          if (match.length > 1 && match.index < string.length) apply$2($push, output, arraySlice$2(match, 1));
	          lastLength = match[0].length;
	          lastLastIndex = lastIndex;
	          if (output.length >= lim) break;
	        }
	        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string.length) {
	        if (lastLength || !exec(separatorCopy, '')) push$2(output, '');
	      } else push$2(output, stringSlice$2(string, lastLastIndex));
	      return output.length > lim ? arraySlice$2(output, 0, lim) : output;
	    };
	  // Chakra, V8
	  } else if ('0'.split(undefined, 0).length) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : call$8(nativeSplit, this, separator, limit);
	    };
	  } else internalSplit = nativeSplit;

	  return [
	    // `String.prototype.split` method
	    // https://tc39.es/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = requireObjectCoercible$3(this);
	      var splitter = isNullOrUndefined$2(separator) ? undefined : getMethod$1(separator, SPLIT);
	      return splitter
	        ? call$8(splitter, separator, O, limit)
	        : call$8(internalSplit, toString$9(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (string, limit) {
	      var rx = anObject$4(this);
	      var S = toString$9(string);
	      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

	      if (res.done) return res.value;

	      var C = speciesConstructor$3(rx, RegExp);

	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (UNSUPPORTED_Y ? 'g' : 'y');

	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
	        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice$2(S, q) : S);
	        var e;
	        if (
	          z === null ||
	          (e = min$1(toLength$2(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
	        ) {
	          q = advanceStringIndex$1(S, q, unicodeMatching);
	        } else {
	          push$2(A, stringSlice$2(S, p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            push$2(A, z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      push$2(A, stringSlice$2(S, p));
	      return A;
	    }
	  ];
	}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);

	var PROPER_FUNCTION_NAME = functionName$1.PROPER;
	var fails$7 = fails$T;
	var whitespaces = whitespaces$3;

	var non = '\u200B\u0085\u180E';

	// check that a method works with the correct list
	// of whitespaces and has a correct name
	var stringTrimForced = function (METHOD_NAME) {
	  return fails$7(function () {
	    return !!whitespaces[METHOD_NAME]()
	      || non[METHOD_NAME]() !== non
	      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
	  });
	};

	var $$s = _export$1;
	var $trim = stringTrim.trim;
	var forcedStringTrimMethod = stringTrimForced;

	// `String.prototype.trim` method
	// https://tc39.es/ecma262/#sec-string.prototype.trim
	$$s({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
	  trim: function trim() {
	    return $trim(this);
	  }
	});

	var getBuiltInPrototypeMethod$5 = getBuiltInPrototypeMethod$g;

	var trim$3 = getBuiltInPrototypeMethod$5('String', 'trim');

	var isPrototypeOf$6 = objectIsPrototypeOf$1;
	var method$5 = trim$3;

	var StringPrototype$1 = String.prototype;

	var trim$2 = function (it) {
	  var own = it.trim;
	  return typeof it == 'string' || it === StringPrototype$1
	    || (isPrototypeOf$6(StringPrototype$1, it) && own === StringPrototype$1.trim) ? method$5 : own;
	};

	var parent$r = trim$2;

	var trim$1 = parent$r;

	var trim = trim$1;

	var _trimInstanceProperty = /*@__PURE__*/getDefaultExportFromCjs(trim);

	function _createForOfIteratorHelper$3(o, allowArrayLike) { var it = typeof _Symbol$1 !== "undefined" && _getIteratorMethod(o) || o["@@iterator"]; if (!it) { if (_Array$isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
	function _unsupportedIterableToArray$3(o, minLen) { var _context4; if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = _sliceInstanceProperty(_context4 = Object.prototype.toString.call(o)).call(_context4, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }
	function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	var withEventData = function withEventData(editor) {
	  var e = editor;
	  var insertText = e.insertText;
	    e.insertFragment;
	  e.setFragmentData = function (data) {
	    var _context, _context3;
	    var selection = e.selection;
	    if (!selection) {
	      return;
	    }

	    // 获取开始、结束两个 point { path, offset }
	    var _Range$edges = Range.edges(selection),
	      _Range$edges2 = _slicedToArray(_Range$edges, 2),
	      start = _Range$edges2[0],
	      end = _Range$edges2[1];
	    // Editor.void - Match a void node in the current branch of the editor.
	    var startVoid = Editor.void(e, {
	      at: start.path
	    });
	    var endVoid = Editor.void(e, {
	      at: end.path
	    });
	    if (Range.isCollapsed(selection) && !startVoid) {
	      return;
	    }

	    // Create a fake selection so that we can add a Base64-encoded copy of the
	    // fragment to the HTML, to decode on future pastes.
	    var domRange = DomEditor.toDOMRange(e, selection);
	    var contents = domRange.cloneContents();
	    var attach = contents.childNodes[0];

	    // Make sure attach is non-empty, since empty nodes will not get copied.
	    _forEachInstanceProperty(_context = contents.childNodes).call(_context, function (node) {
	      var _context2;
	      if (node.textContent && _trimInstanceProperty(_context2 = node.textContent).call(_context2) !== '') {
	        attach = node;
	      }
	    });

	    // COMPAT: If the end node is a void node, we need to move the end of the
	    // range from the void node's spacer span, to the end of the void node's
	    // content, since the spacer is before void's content in the DOM.
	    if (endVoid) {
	      var _endVoid = _slicedToArray(endVoid, 1),
	        voidNode = _endVoid[0];
	      var r = domRange.cloneRange();
	      var domNode = DomEditor.toDOMNode(e, voidNode);
	      r.setEndAfter(domNode);
	      contents = r.cloneContents();
	    }

	    // COMPAT: If the start node is a void node, we need to attach the encoded
	    // fragment to the void node's content node instead of the spacer, because
	    // attaching it to empty `<div>/<span>` nodes will end up having it erased by
	    // most browsers. (2018/04/27)
	    if (startVoid) {
	      attach = contents.querySelector('[data-slate-spacer]');
	    }

	    // Remove any zero-width space spans from the cloned DOM so that they don't
	    // show up elsewhere when pasted.
	    _forEachInstanceProperty(_context3 = _Array$from(contents.querySelectorAll('[data-slate-zero-width]'))).call(_context3, function (zw) {
	      var isNewline = zw.getAttribute('data-slate-zero-width') === 'n';
	      zw.textContent = isNewline ? '\n' : '';
	    });

	    // Set a `data-slate-fragment` attribute on a non-empty node, so it shows up
	    // in the HTML, and can be used for intra-Slate pasting. If it's a text
	    // node, wrap it in a `<span>` so we have something to set an attribute on.
	    if (isDOMText(attach)) {
	      var span = attach.ownerDocument.createElement('span');
	      // COMPAT: In Chrome and Safari, if we don't add the `white-space` style
	      // then leading and trailing spaces will be ignored. (2017/09/21)
	      span.style.whiteSpace = 'pre';
	      span.appendChild(attach);
	      contents.appendChild(span);
	      attach = span;
	    }
	    var fragment = e.getFragment();
	    var string = _JSON$stringify(fragment);
	    var encoded = window.btoa(encodeURIComponent(string));
	    attach.setAttribute('data-slate-fragment', encoded);
	    data.setData('application/x-slate-fragment', encoded);

	    // Add the content to a <div> so that we can get its inner HTML.
	    var div = contents.ownerDocument.createElement('div');
	    div.appendChild(contents);
	    div.setAttribute('hidden', 'true');
	    contents.ownerDocument.body.appendChild(div);
	    data.setData('text/html', div.innerHTML);
	    data.setData('text/plain', getPlainText(div));
	    contents.ownerDocument.body.removeChild(div);
	    return data;
	  };
	  e.insertData = function (data) {
	    var fragment = data.getData('application/x-slate-fragment');
	    if (fragment) {
	      var decoded = decodeURIComponent(window.atob(fragment));
	      var parsed = JSON.parse(decoded);
	      e.insertFragment(parsed);
	      return;
	    }
	    var text = data.getData('text/plain');
	    data.getData('text/html');
	    // const rtf = data.getData('text/rtf')

	    // if (html) {
	    //   e.dangerouslyInsertHtml(html);
	    //   return;
	    // }

	    if (text) {
	      var lines = text.split(/\r\n|\r|\n/);
	      var split = false;
	      var _iterator = _createForOfIteratorHelper$3(lines),
	        _step;
	      try {
	        for (_iterator.s(); !(_step = _iterator.n()).done;) {
	          var line = _step.value;
	          if (split) {
	            Transforms.splitNodes(e, {
	              always: true
	            });
	          }
	          insertText(line);
	          split = true;
	        }
	      } catch (err) {
	        _iterator.e(err);
	      } finally {
	        _iterator.f();
	      }
	      return;
	    }
	  };
	  return e;
	};

	var hasOwn$2 = hasOwnProperty_1$1;
	var ownKeys$6 = ownKeys$h;
	var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor$1;
	var definePropertyModule = objectDefineProperty$1;

	var copyConstructorProperties$1 = function (target, source, exceptions) {
	  var keys = ownKeys$6(source);
	  var defineProperty = definePropertyModule.f;
	  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (!hasOwn$2(target, key) && !(exceptions && hasOwn$2(exceptions, key))) {
	      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
	    }
	  }
	};

	var isObject$7 = isObject$B;
	var createNonEnumerableProperty$2 = createNonEnumerableProperty$d;

	// `InstallErrorCause` abstract operation
	// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
	var installErrorCause$1 = function (O, options) {
	  if (isObject$7(options) && 'cause' in options) {
	    createNonEnumerableProperty$2(O, 'cause', options.cause);
	  }
	};

	var uncurryThis$7 = functionUncurryThis$1;

	var $Error$1 = Error;
	var replace = uncurryThis$7(''.replace);

	var TEST = (function (arg) { return String(new $Error$1(arg).stack); })('zxcasd');
	// eslint-disable-next-line redos/no-vulnerable -- safe
	var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
	var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

	var errorStackClear = function (stack, dropEntries) {
	  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error$1.prepareStackTrace) {
	    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
	  } return stack;
	};

	var fails$6 = fails$T;
	var createPropertyDescriptor$1 = createPropertyDescriptor$b;

	var errorStackInstallable = !fails$6(function () {
	  var error = new Error('a');
	  if (!('stack' in error)) return true;
	  // eslint-disable-next-line es/no-object-defineproperty -- safe
	  Object.defineProperty(error, 'stack', createPropertyDescriptor$1(1, 7));
	  return error.stack !== 7;
	});

	var createNonEnumerableProperty$1 = createNonEnumerableProperty$d;
	var clearErrorStack = errorStackClear;
	var ERROR_STACK_INSTALLABLE = errorStackInstallable;

	// non-standard V8
	var captureStackTrace = Error.captureStackTrace;

	var errorStackInstall = function (error, C, stack, dropEntries) {
	  if (ERROR_STACK_INSTALLABLE) {
	    if (captureStackTrace) captureStackTrace(error, C);
	    else createNonEnumerableProperty$1(error, 'stack', clearErrorStack(stack, dropEntries));
	  }
	};

	var toString$8 = toString$r;

	var normalizeStringArgument$1 = function (argument, $default) {
	  return argument === undefined ? arguments.length < 2 ? '' : $default : toString$8(argument);
	};

	var $$r = _export$1;
	var isPrototypeOf$5 = objectIsPrototypeOf$1;
	var getPrototypeOf$5 = objectGetPrototypeOf;
	var setPrototypeOf$6 = objectSetPrototypeOf;
	var copyConstructorProperties = copyConstructorProperties$1;
	var create$8 = objectCreate$1;
	var createNonEnumerableProperty = createNonEnumerableProperty$d;
	var createPropertyDescriptor = createPropertyDescriptor$b;
	var installErrorCause = installErrorCause$1;
	var installErrorStack = errorStackInstall;
	var iterate$4 = iterate$8;
	var normalizeStringArgument = normalizeStringArgument$1;
	var wellKnownSymbol$2 = wellKnownSymbol$A;

	var TO_STRING_TAG = wellKnownSymbol$2('toStringTag');
	var $Error = Error;
	var push$1 = [].push;

	var $AggregateError = function AggregateError(errors, message /* , options */) {
	  var isInstance = isPrototypeOf$5(AggregateErrorPrototype, this);
	  var that;
	  if (setPrototypeOf$6) {
	    that = setPrototypeOf$6(new $Error(), isInstance ? getPrototypeOf$5(this) : AggregateErrorPrototype);
	  } else {
	    that = isInstance ? this : create$8(AggregateErrorPrototype);
	    createNonEnumerableProperty(that, TO_STRING_TAG, 'Error');
	  }
	  if (message !== undefined) createNonEnumerableProperty(that, 'message', normalizeStringArgument(message));
	  installErrorStack(that, $AggregateError, that.stack, 1);
	  if (arguments.length > 2) installErrorCause(that, arguments[2]);
	  var errorsArray = [];
	  iterate$4(errors, push$1, { that: errorsArray });
	  createNonEnumerableProperty(that, 'errors', errorsArray);
	  return that;
	};

	if (setPrototypeOf$6) setPrototypeOf$6($AggregateError, $Error);
	else copyConstructorProperties($AggregateError, $Error, { name: true });

	var AggregateErrorPrototype = $AggregateError.prototype = create$8($Error.prototype, {
	  constructor: createPropertyDescriptor(1, $AggregateError),
	  message: createPropertyDescriptor(1, ''),
	  name: createPropertyDescriptor(1, 'AggregateError')
	});

	// `AggregateError` constructor
	// https://tc39.es/ecma262/#sec-aggregate-error-constructor
	$$r({ global: true, constructor: true, arity: 2 }, {
	  AggregateError: $AggregateError
	});

	var global$6 = global$G;
	var classof = classofRaw$5;

	var engineIsNode = classof(global$6.process) === 'process';

	var isConstructor = isConstructor$7;
	var tryToString = tryToString$8;

	var $TypeError$1 = TypeError;

	// `Assert: IsConstructor(argument) is true`
	var aConstructor$2 = function (argument) {
	  if (isConstructor(argument)) return argument;
	  throw new $TypeError$1(tryToString(argument) + ' is not a constructor');
	};

	var anObject$3 = anObject$q;
	var aConstructor$1 = aConstructor$2;
	var isNullOrUndefined$1 = isNullOrUndefined$e;
	var wellKnownSymbol$1 = wellKnownSymbol$A;

	var SPECIES$1 = wellKnownSymbol$1('species');

	// `SpeciesConstructor` abstract operation
	// https://tc39.es/ecma262/#sec-speciesconstructor
	var speciesConstructor$2 = function (O, defaultConstructor) {
	  var C = anObject$3(O).constructor;
	  var S;
	  return C === undefined || isNullOrUndefined$1(S = anObject$3(C)[SPECIES$1]) ? defaultConstructor : aConstructor$1(S);
	};

	var userAgent$2 = engineUserAgent$1;

	// eslint-disable-next-line redos/no-vulnerable -- safe
	var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$2);

	var global$5 = global$G;
	var apply$1 = functionApply$1;
	var bind$b = functionBindContext$1;
	var isCallable$3 = isCallable$B;
	var hasOwn$1 = hasOwnProperty_1$1;
	var fails$5 = fails$T;
	var html = html$5;
	var arraySlice$1 = arraySlice$5;
	var createElement$1 = documentCreateElement$3;
	var validateArgumentsLength = validateArgumentsLength$2;
	var IS_IOS$1 = engineIsIos;
	var IS_NODE$3 = engineIsNode;

	var set = global$5.setImmediate;
	var clear = global$5.clearImmediate;
	var process$2 = global$5.process;
	var Dispatch = global$5.Dispatch;
	var Function$1 = global$5.Function;
	var MessageChannel = global$5.MessageChannel;
	var String$1 = global$5.String;
	var counter = 0;
	var queue$2 = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var $location, defer, channel, port;

	fails$5(function () {
	  // Deno throws a ReferenceError on `location` access without `--location` flag
	  $location = global$5.location;
	});

	var run = function (id) {
	  if (hasOwn$1(queue$2, id)) {
	    var fn = queue$2[id];
	    delete queue$2[id];
	    fn();
	  }
	};

	var runner = function (id) {
	  return function () {
	    run(id);
	  };
	};

	var eventListener = function (event) {
	  run(event.data);
	};

	var globalPostMessageDefer = function (id) {
	  // old engines have not location.origin
	  global$5.postMessage(String$1(id), $location.protocol + '//' + $location.host);
	};

	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!set || !clear) {
	  set = function setImmediate(handler) {
	    validateArgumentsLength(arguments.length, 1);
	    var fn = isCallable$3(handler) ? handler : Function$1(handler);
	    var args = arraySlice$1(arguments, 1);
	    queue$2[++counter] = function () {
	      apply$1(fn, undefined, args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clear = function clearImmediate(id) {
	    delete queue$2[id];
	  };
	  // Node.js 0.8-
	  if (IS_NODE$3) {
	    defer = function (id) {
	      process$2.nextTick(runner(id));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(runner(id));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  // except iOS - https://github.com/zloirock/core-js/issues/624
	  } else if (MessageChannel && !IS_IOS$1) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = eventListener;
	    defer = bind$b(port.postMessage, port);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (
	    global$5.addEventListener &&
	    isCallable$3(global$5.postMessage) &&
	    !global$5.importScripts &&
	    $location && $location.protocol !== 'file:' &&
	    !fails$5(globalPostMessageDefer)
	  ) {
	    defer = globalPostMessageDefer;
	    global$5.addEventListener('message', eventListener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in createElement$1('script')) {
	    defer = function (id) {
	      html.appendChild(createElement$1('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(runner(id), 0);
	    };
	  }
	}

	var task$1 = {
	  set: set,
	  clear: clear
	};

	var Queue$2 = function () {
	  this.head = null;
	  this.tail = null;
	};

	Queue$2.prototype = {
	  add: function (item) {
	    var entry = { item: item, next: null };
	    var tail = this.tail;
	    if (tail) tail.next = entry;
	    else this.head = entry;
	    this.tail = entry;
	  },
	  get: function () {
	    var entry = this.head;
	    if (entry) {
	      var next = this.head = entry.next;
	      if (next === null) this.tail = null;
	      return entry.item;
	    }
	  }
	};

	var queue$1 = Queue$2;

	var userAgent$1 = engineUserAgent$1;

	var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$1) && typeof Pebble != 'undefined';

	var userAgent = engineUserAgent$1;

	var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent);

	var global$4 = global$G;
	var bind$a = functionBindContext$1;
	var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor$1.f;
	var macrotask = task$1.set;
	var Queue$1 = queue$1;
	var IS_IOS = engineIsIos;
	var IS_IOS_PEBBLE = engineIsIosPebble;
	var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
	var IS_NODE$2 = engineIsNode;

	var MutationObserver = global$4.MutationObserver || global$4.WebKitMutationObserver;
	var document$2 = global$4.document;
	var process$1 = global$4.process;
	var Promise$1 = global$4.Promise;
	// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
	var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global$4, 'queueMicrotask');
	var microtask$1 = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
	var notify$1, toggle, node, promise$6, then;

	// modern engines have queueMicrotask method
	if (!microtask$1) {
	  var queue = new Queue$1();

	  var flush = function () {
	    var parent, fn;
	    if (IS_NODE$2 && (parent = process$1.domain)) parent.exit();
	    while (fn = queue.get()) try {
	      fn();
	    } catch (error) {
	      if (queue.head) notify$1();
	      throw error;
	    }
	    if (parent) parent.enter();
	  };

	  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
	  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
	  if (!IS_IOS && !IS_NODE$2 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
	    toggle = true;
	    node = document$2.createTextNode('');
	    new MutationObserver(flush).observe(node, { characterData: true });
	    notify$1 = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    promise$6 = Promise$1.resolve(undefined);
	    // workaround of WebKit ~ iOS Safari 10.1 bug
	    promise$6.constructor = Promise$1;
	    then = bind$a(promise$6.then, promise$6);
	    notify$1 = function () {
	      then(flush);
	    };
	  // Node.js without promises
	  } else if (IS_NODE$2) {
	    notify$1 = function () {
	      process$1.nextTick(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessage
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    // `webpack` dev server bug on IE global methods - use bind(fn, global)
	    macrotask = bind$a(macrotask, global$4);
	    notify$1 = function () {
	      macrotask(flush);
	    };
	  }

	  microtask$1 = function (fn) {
	    if (!queue.head) notify$1();
	    queue.add(fn);
	  };
	}

	var microtask_1 = microtask$1;

	var hostReportErrors$1 = function (a, b) {
	  try {
	    // eslint-disable-next-line no-console -- safe
	    arguments.length === 1 ? console.error(a) : console.error(a, b);
	  } catch (error) { /* empty */ }
	};

	var perform$6 = function (exec) {
	  try {
	    return { error: false, value: exec() };
	  } catch (error) {
	    return { error: true, value: error };
	  }
	};

	var global$3 = global$G;

	var promiseNativeConstructor = global$3.Promise;

	/* global Deno -- Deno case */
	var engineIsDeno = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';

	var IS_DENO$1 = engineIsDeno;
	var IS_NODE$1 = engineIsNode;

	var engineIsBrowser = !IS_DENO$1 && !IS_NODE$1
	  && typeof window == 'object'
	  && typeof document == 'object';

	var global$2 = global$G;
	var NativePromiseConstructor$5 = promiseNativeConstructor;
	var isCallable$2 = isCallable$B;
	var isForced = isForced_1$1;
	var inspectSource = inspectSource$5;
	var wellKnownSymbol = wellKnownSymbol$A;
	var IS_BROWSER = engineIsBrowser;
	var IS_DENO = engineIsDeno;
	var V8_VERSION = engineV8Version$1;

	var NativePromisePrototype$2 = NativePromiseConstructor$5 && NativePromiseConstructor$5.prototype;
	var SPECIES = wellKnownSymbol('species');
	var SUBCLASSING = false;
	var NATIVE_PROMISE_REJECTION_EVENT$1 = isCallable$2(global$2.PromiseRejectionEvent);

	var FORCED_PROMISE_CONSTRUCTOR$5 = isForced('Promise', function () {
	  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor$5);
	  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor$5);
	  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	  // We can't detect it synchronously, so just check versions
	  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
	  // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
	  if (!(NativePromisePrototype$2['catch'] && NativePromisePrototype$2['finally'])) return true;
	  // We can't use @@species feature detection in V8 since it causes
	  // deoptimization and performance degradation
	  // https://github.com/zloirock/core-js/issues/679
	  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
	    // Detect correctness of subclassing with @@species support
	    var promise = new NativePromiseConstructor$5(function (resolve) { resolve(1); });
	    var FakePromise = function (exec) {
	      exec(function () { /* empty */ }, function () { /* empty */ });
	    };
	    var constructor = promise.constructor = {};
	    constructor[SPECIES] = FakePromise;
	    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
	    if (!SUBCLASSING) return true;
	  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT$1;
	});

	var promiseConstructorDetection = {
	  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$5,
	  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$1,
	  SUBCLASSING: SUBCLASSING
	};

	var newPromiseCapability$2 = {};

	var aCallable$6 = aCallable$e;

	var $TypeError = TypeError;

	var PromiseCapability = function (C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw new $TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aCallable$6(resolve);
	  this.reject = aCallable$6(reject);
	};

	// `NewPromiseCapability` abstract operation
	// https://tc39.es/ecma262/#sec-newpromisecapability
	newPromiseCapability$2.f = function (C) {
	  return new PromiseCapability(C);
	};

	var $$q = _export$1;
	var IS_NODE = engineIsNode;
	var global$1 = global$G;
	var call$7 = functionCall$1;
	var defineBuiltIn = defineBuiltIn$b;
	var setToStringTag = setToStringTag$7;
	var setSpecies = setSpecies$2;
	var aCallable$5 = aCallable$e;
	var isCallable$1 = isCallable$B;
	var isObject$6 = isObject$B;
	var anInstance = anInstance$4;
	var speciesConstructor$1 = speciesConstructor$2;
	var task = task$1.set;
	var microtask = microtask_1;
	var hostReportErrors = hostReportErrors$1;
	var perform$5 = perform$6;
	var Queue = queue$1;
	var InternalStateModule = internalState$1;
	var NativePromiseConstructor$4 = promiseNativeConstructor;
	var PromiseConstructorDetection = promiseConstructorDetection;
	var newPromiseCapabilityModule$7 = newPromiseCapability$2;

	var PROMISE = 'Promise';
	var FORCED_PROMISE_CONSTRUCTOR$4 = PromiseConstructorDetection.CONSTRUCTOR;
	var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
	PromiseConstructorDetection.SUBCLASSING;
	var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
	var setInternalState = InternalStateModule.set;
	var NativePromisePrototype$1 = NativePromiseConstructor$4 && NativePromiseConstructor$4.prototype;
	var PromiseConstructor = NativePromiseConstructor$4;
	var PromisePrototype = NativePromisePrototype$1;
	var TypeError$1 = global$1.TypeError;
	var document$1 = global$1.document;
	var process = global$1.process;
	var newPromiseCapability$1 = newPromiseCapabilityModule$7.f;
	var newGenericPromiseCapability = newPromiseCapability$1;

	var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$1.dispatchEvent);
	var UNHANDLED_REJECTION = 'unhandledrejection';
	var REJECTION_HANDLED = 'rejectionhandled';
	var PENDING = 0;
	var FULFILLED = 1;
	var REJECTED = 2;
	var HANDLED = 1;
	var UNHANDLED = 2;

	var Internal, OwnPromiseCapability, PromiseWrapper;

	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject$6(it) && isCallable$1(then = it.then) ? then : false;
	};

	var callReaction = function (reaction, state) {
	  var value = state.value;
	  var ok = state.state === FULFILLED;
	  var handler = ok ? reaction.ok : reaction.fail;
	  var resolve = reaction.resolve;
	  var reject = reaction.reject;
	  var domain = reaction.domain;
	  var result, then, exited;
	  try {
	    if (handler) {
	      if (!ok) {
	        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
	        state.rejection = HANDLED;
	      }
	      if (handler === true) result = value;
	      else {
	        if (domain) domain.enter();
	        result = handler(value); // can throw
	        if (domain) {
	          domain.exit();
	          exited = true;
	        }
	      }
	      if (result === reaction.promise) {
	        reject(new TypeError$1('Promise-chain cycle'));
	      } else if (then = isThenable(result)) {
	        call$7(then, result, resolve, reject);
	      } else resolve(result);
	    } else reject(value);
	  } catch (error) {
	    if (domain && !exited) domain.exit();
	    reject(error);
	  }
	};

	var notify = function (state, isReject) {
	  if (state.notified) return;
	  state.notified = true;
	  microtask(function () {
	    var reactions = state.reactions;
	    var reaction;
	    while (reaction = reactions.get()) {
	      callReaction(reaction, state);
	    }
	    state.notified = false;
	    if (isReject && !state.rejection) onUnhandled(state);
	  });
	};

	var dispatchEvent = function (name, promise, reason) {
	  var event, handler;
	  if (DISPATCH_EVENT) {
	    event = document$1.createEvent('Event');
	    event.promise = promise;
	    event.reason = reason;
	    event.initEvent(name, false, true);
	    global$1.dispatchEvent(event);
	  } else event = { promise: promise, reason: reason };
	  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global$1['on' + name])) handler(event);
	  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
	};

	var onUnhandled = function (state) {
	  call$7(task, global$1, function () {
	    var promise = state.facade;
	    var value = state.value;
	    var IS_UNHANDLED = isUnhandled(state);
	    var result;
	    if (IS_UNHANDLED) {
	      result = perform$5(function () {
	        if (IS_NODE) {
	          process.emit('unhandledRejection', value, promise);
	        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
	      if (result.error) throw result.value;
	    }
	  });
	};

	var isUnhandled = function (state) {
	  return state.rejection !== HANDLED && !state.parent;
	};

	var onHandleUnhandled = function (state) {
	  call$7(task, global$1, function () {
	    var promise = state.facade;
	    if (IS_NODE) {
	      process.emit('rejectionHandled', promise);
	    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
	  });
	};

	var bind$9 = function (fn, state, unwrap) {
	  return function (value) {
	    fn(state, value, unwrap);
	  };
	};

	var internalReject = function (state, value, unwrap) {
	  if (state.done) return;
	  state.done = true;
	  if (unwrap) state = unwrap;
	  state.value = value;
	  state.state = REJECTED;
	  notify(state, true);
	};

	var internalResolve = function (state, value, unwrap) {
	  if (state.done) return;
	  state.done = true;
	  if (unwrap) state = unwrap;
	  try {
	    if (state.facade === value) throw new TypeError$1("Promise can't be resolved itself");
	    var then = isThenable(value);
	    if (then) {
	      microtask(function () {
	        var wrapper = { done: false };
	        try {
	          call$7(then, value,
	            bind$9(internalResolve, wrapper, state),
	            bind$9(internalReject, wrapper, state)
	          );
	        } catch (error) {
	          internalReject(wrapper, error, state);
	        }
	      });
	    } else {
	      state.value = value;
	      state.state = FULFILLED;
	      notify(state, false);
	    }
	  } catch (error) {
	    internalReject({ done: false }, error, state);
	  }
	};

	// constructor polyfill
	if (FORCED_PROMISE_CONSTRUCTOR$4) {
	  // 25.4.3.1 Promise(executor)
	  PromiseConstructor = function Promise(executor) {
	    anInstance(this, PromisePrototype);
	    aCallable$5(executor);
	    call$7(Internal, this);
	    var state = getInternalPromiseState(this);
	    try {
	      executor(bind$9(internalResolve, state), bind$9(internalReject, state));
	    } catch (error) {
	      internalReject(state, error);
	    }
	  };

	  PromisePrototype = PromiseConstructor.prototype;

	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  Internal = function Promise(executor) {
	    setInternalState(this, {
	      type: PROMISE,
	      done: false,
	      notified: false,
	      parent: false,
	      reactions: new Queue(),
	      rejection: false,
	      state: PENDING,
	      value: undefined
	    });
	  };

	  // `Promise.prototype.then` method
	  // https://tc39.es/ecma262/#sec-promise.prototype.then
	  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
	    var state = getInternalPromiseState(this);
	    var reaction = newPromiseCapability$1(speciesConstructor$1(this, PromiseConstructor));
	    state.parent = true;
	    reaction.ok = isCallable$1(onFulfilled) ? onFulfilled : true;
	    reaction.fail = isCallable$1(onRejected) && onRejected;
	    reaction.domain = IS_NODE ? process.domain : undefined;
	    if (state.state === PENDING) state.reactions.add(reaction);
	    else microtask(function () {
	      callReaction(reaction, state);
	    });
	    return reaction.promise;
	  });

	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    var state = getInternalPromiseState(promise);
	    this.promise = promise;
	    this.resolve = bind$9(internalResolve, state);
	    this.reject = bind$9(internalReject, state);
	  };

	  newPromiseCapabilityModule$7.f = newPromiseCapability$1 = function (C) {
	    return C === PromiseConstructor || C === PromiseWrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}

	$$q({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR$4 }, {
	  Promise: PromiseConstructor
	});

	setToStringTag(PromiseConstructor, PROMISE, false, true);
	setSpecies(PROMISE);

	var NativePromiseConstructor$3 = promiseNativeConstructor;
	var checkCorrectnessOfIteration = checkCorrectnessOfIteration$2;
	var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;

	var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$3 || !checkCorrectnessOfIteration(function (iterable) {
	  NativePromiseConstructor$3.all(iterable).then(undefined, function () { /* empty */ });
	});

	var $$p = _export$1;
	var call$6 = functionCall$1;
	var aCallable$4 = aCallable$e;
	var newPromiseCapabilityModule$6 = newPromiseCapability$2;
	var perform$4 = perform$6;
	var iterate$3 = iterate$8;
	var PROMISE_STATICS_INCORRECT_ITERATION$3 = promiseStaticsIncorrectIteration;

	// `Promise.all` method
	// https://tc39.es/ecma262/#sec-promise.all
	$$p({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION$3 }, {
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapabilityModule$6.f(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform$4(function () {
	      var $promiseResolve = aCallable$4(C.resolve);
	      var values = [];
	      var counter = 0;
	      var remaining = 1;
	      iterate$3(iterable, function (promise) {
	        var index = counter++;
	        var alreadyCalled = false;
	        remaining++;
	        call$6($promiseResolve, C, promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.error) reject(result.value);
	    return capability.promise;
	  }
	});

	var $$o = _export$1;
	var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;
	var NativePromiseConstructor$2 = promiseNativeConstructor;

	NativePromiseConstructor$2 && NativePromiseConstructor$2.prototype;

	// `Promise.prototype.catch` method
	// https://tc39.es/ecma262/#sec-promise.prototype.catch
	$$o({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR$2, real: true }, {
	  'catch': function (onRejected) {
	    return this.then(undefined, onRejected);
	  }
	});

	var $$n = _export$1;
	var call$5 = functionCall$1;
	var aCallable$3 = aCallable$e;
	var newPromiseCapabilityModule$5 = newPromiseCapability$2;
	var perform$3 = perform$6;
	var iterate$2 = iterate$8;
	var PROMISE_STATICS_INCORRECT_ITERATION$2 = promiseStaticsIncorrectIteration;

	// `Promise.race` method
	// https://tc39.es/ecma262/#sec-promise.race
	$$n({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION$2 }, {
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapabilityModule$5.f(C);
	    var reject = capability.reject;
	    var result = perform$3(function () {
	      var $promiseResolve = aCallable$3(C.resolve);
	      iterate$2(iterable, function (promise) {
	        call$5($promiseResolve, C, promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.error) reject(result.value);
	    return capability.promise;
	  }
	});

	var $$m = _export$1;
	var call$4 = functionCall$1;
	var newPromiseCapabilityModule$4 = newPromiseCapability$2;
	var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;

	// `Promise.reject` method
	// https://tc39.es/ecma262/#sec-promise.reject
	$$m({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR$1 }, {
	  reject: function reject(r) {
	    var capability = newPromiseCapabilityModule$4.f(this);
	    call$4(capability.reject, undefined, r);
	    return capability.promise;
	  }
	});

	var anObject$2 = anObject$q;
	var isObject$5 = isObject$B;
	var newPromiseCapability = newPromiseCapability$2;

	var promiseResolve$2 = function (C, x) {
	  anObject$2(C);
	  if (isObject$5(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};

	var $$l = _export$1;
	var getBuiltIn$3 = getBuiltIn$k;
	var IS_PURE = isPure;
	var NativePromiseConstructor$1 = promiseNativeConstructor;
	var FORCED_PROMISE_CONSTRUCTOR = promiseConstructorDetection.CONSTRUCTOR;
	var promiseResolve$1 = promiseResolve$2;

	var PromiseConstructorWrapper = getBuiltIn$3('Promise');
	var CHECK_WRAPPER = !FORCED_PROMISE_CONSTRUCTOR;

	// `Promise.resolve` method
	// https://tc39.es/ecma262/#sec-promise.resolve
	$$l({ target: 'Promise', stat: true, forced: IS_PURE  }, {
	  resolve: function resolve(x) {
	    return promiseResolve$1(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor$1 : this, x);
	  }
	});

	var $$k = _export$1;
	var call$3 = functionCall$1;
	var aCallable$2 = aCallable$e;
	var newPromiseCapabilityModule$3 = newPromiseCapability$2;
	var perform$2 = perform$6;
	var iterate$1 = iterate$8;
	var PROMISE_STATICS_INCORRECT_ITERATION$1 = promiseStaticsIncorrectIteration;

	// `Promise.allSettled` method
	// https://tc39.es/ecma262/#sec-promise.allsettled
	$$k({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION$1 }, {
	  allSettled: function allSettled(iterable) {
	    var C = this;
	    var capability = newPromiseCapabilityModule$3.f(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform$2(function () {
	      var promiseResolve = aCallable$2(C.resolve);
	      var values = [];
	      var counter = 0;
	      var remaining = 1;
	      iterate$1(iterable, function (promise) {
	        var index = counter++;
	        var alreadyCalled = false;
	        remaining++;
	        call$3(promiseResolve, C, promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[index] = { status: 'fulfilled', value: value };
	          --remaining || resolve(values);
	        }, function (error) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[index] = { status: 'rejected', reason: error };
	          --remaining || resolve(values);
	        });
	      });
	      --remaining || resolve(values);
	    });
	    if (result.error) reject(result.value);
	    return capability.promise;
	  }
	});

	var $$j = _export$1;
	var call$2 = functionCall$1;
	var aCallable$1 = aCallable$e;
	var getBuiltIn$2 = getBuiltIn$k;
	var newPromiseCapabilityModule$2 = newPromiseCapability$2;
	var perform$1 = perform$6;
	var iterate = iterate$8;
	var PROMISE_STATICS_INCORRECT_ITERATION = promiseStaticsIncorrectIteration;

	var PROMISE_ANY_ERROR = 'No one promise resolved';

	// `Promise.any` method
	// https://tc39.es/ecma262/#sec-promise.any
	$$j({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
	  any: function any(iterable) {
	    var C = this;
	    var AggregateError = getBuiltIn$2('AggregateError');
	    var capability = newPromiseCapabilityModule$2.f(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform$1(function () {
	      var promiseResolve = aCallable$1(C.resolve);
	      var errors = [];
	      var counter = 0;
	      var remaining = 1;
	      var alreadyResolved = false;
	      iterate(iterable, function (promise) {
	        var index = counter++;
	        var alreadyRejected = false;
	        remaining++;
	        call$2(promiseResolve, C, promise).then(function (value) {
	          if (alreadyRejected || alreadyResolved) return;
	          alreadyResolved = true;
	          resolve(value);
	        }, function (error) {
	          if (alreadyRejected || alreadyResolved) return;
	          alreadyRejected = true;
	          errors[index] = error;
	          --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
	        });
	      });
	      --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
	    });
	    if (result.error) reject(result.value);
	    return capability.promise;
	  }
	});

	var $$i = _export$1;
	var NativePromiseConstructor = promiseNativeConstructor;
	var fails$4 = fails$T;
	var getBuiltIn$1 = getBuiltIn$k;
	var isCallable = isCallable$B;
	var speciesConstructor = speciesConstructor$2;
	var promiseResolve = promiseResolve$2;

	var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

	// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
	var NON_GENERIC = !!NativePromiseConstructor && fails$4(function () {
	  // eslint-disable-next-line unicorn/no-thenable -- required for testing
	  NativePromisePrototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
	});

	// `Promise.prototype.finally` method
	// https://tc39.es/ecma262/#sec-promise.prototype.finally
	$$i({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
	  'finally': function (onFinally) {
	    var C = speciesConstructor(this, getBuiltIn$1('Promise'));
	    var isFunction = isCallable(onFinally);
	    return this.then(
	      isFunction ? function (x) {
	        return promiseResolve(C, onFinally()).then(function () { return x; });
	      } : onFinally,
	      isFunction ? function (e) {
	        return promiseResolve(C, onFinally()).then(function () { throw e; });
	      } : onFinally
	    );
	  }
	});

	var path$6 = path$q;

	var promise$5 = path$6.Promise;

	var parent$q = promise$5;


	var promise$4 = parent$q;

	var promise$3 = promise$4;

	var _Promise$1 = /*@__PURE__*/getDefaultExportFromCjs(promise$3);

	// 异步任务
	function promiseResolveThen(fn) {
	  _Promise$1.resolve().then(fn);
	}

	/**
	 * 获取 textContainer 尺寸和定位
	 * @param editor editor
	 */
	function getTextContainerRect(editor) {
	  var textarea = DomEditor.getTextarea(editor);

	  // 获取 textareaContainer
	  var $textareaContainer = textarea.$container;
	  var width = $textareaContainer.width();
	  var height = $textareaContainer.height();
	  var _$textareaContainer$o = $textareaContainer.offset(),
	    top = _$textareaContainer$o.top,
	    left = _$textareaContainer$o.left;
	  return {
	    top: top,
	    left: left,
	    width: width,
	    height: height
	  };
	}

	/**
	 * 根据选区，计算定位（用于 modal hoverbar）
	 * @param editor editor
	 */
	function getPositionBySelection(editor) {
	  // 默认情况下 { top: 0, left: 0 }
	  var defaultStyle = {
	    top: '0',
	    left: '0'
	  };
	  var selection = editor.selection;
	  if (selection == null) return defaultStyle; // 默认 position

	  // 获取 textContainer rect
	  var containerRect = getTextContainerRect(editor);
	  if (containerRect == null) return defaultStyle; // 默认 position
	  var containerTop = containerRect.top,
	    containerLeft = containerRect.left,
	    containerWidth = containerRect.width,
	    containerHeight = containerRect.height;

	  // 获取当前选区的 rect
	  var range = DomEditor.toDOMRange(editor, selection);
	  var rangeRect = range.getClientRects()[0];
	  if (rangeRect == null) return defaultStyle; // 默认 position
	  rangeRect.width;
	    var rangeHeight = rangeRect.height,
	    rangeTop = rangeRect.top,
	    rangeLeft = rangeRect.left;

	  // 存储计算结构
	  var positionStyle = {};

	  // 获取 选区 top left 和 container top left 的差值（< 0 则使用 0）
	  var relativeTop = rangeTop - containerTop;
	  var relativeLeft = rangeLeft - containerLeft;

	  // 判断水平位置： modal/bar 显示在选区左侧，还是右侧？
	  if (relativeLeft > containerWidth / 2) {
	    // 选区 left 大于 containerWidth/2 （选区在 container 的右侧），则 modal/bar 显示在选区左侧
	    var r = containerWidth - relativeLeft;
	    positionStyle.right = "".concat(r + 5, "px"); // 5px 间隔
	  } else {
	    // 否则（选区在 container 的左侧），modal/bar 显示在选区右侧
	    positionStyle.left = "".concat(relativeLeft + 5, "px"); // 5px 间隔
	  }

	  // 判断垂直的位置： modal/bar 显示在选区上面，还是下面？
	  if (relativeTop > containerHeight / 2) {
	    // 选区 top  > containerHeight/2 （选区在 container 的下半部分），则 modal/bar 显示在选区的上面
	    var b = containerHeight - relativeTop;
	    positionStyle.bottom = "".concat(b + 5, "px"); // 5px 间隔
	  } else {
	    // 否则（选区在 container 的上半部分），则 modal/bar 显示在选区的下面
	    var t = relativeTop + rangeHeight;
	    if (t < 0) t = 0;
	    positionStyle.top = "".concat(t + 5, "px"); // 5px 间隔
	  }

	  return positionStyle;
	}

	/**
	 * 根据 node ，计算定位（用于 modal hoverbar）
	 * @param editor editor
	 * @param node slate node
	 * @param type 'modal'/'bar'
	 */
	function getPositionByNode(editor, node) {
	  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'modal';
	  // 默认情况下 { top: 0, left: 0 }
	  var defaultStyle = {
	    top: '0',
	    left: '0'
	  };
	  var selection = editor.selection;
	  if (selection == null) return defaultStyle; // 默认 position

	  // 根据 node 获取 elem
	  var isVoidElem = Element.isElement(node) && editor.isVoid(node);
	  var isInlineElem = Element.isElement(node) && editor.isInline(node);
	  var elem = NODE_TO_ELEMENT.get(node);
	  if (elem == null) return defaultStyle; // 默认 position
	  var _elem$getBoundingClie = elem.getBoundingClientRect(),
	    elemTop = _elem$getBoundingClie.top,
	    elemLeft = _elem$getBoundingClie.left,
	    elemHeight = _elem$getBoundingClie.height,
	    elemWidth = _elem$getBoundingClie.width;
	  if (isVoidElem) {
	    // void node ，重新计算 top 和 height
	    var voidElem = getFirstVoidChild(elem);
	    if (voidElem != null) {
	      var _voidElem$getBounding = voidElem.getBoundingClientRect(),
	        top = _voidElem$getBounding.top,
	        height = _voidElem$getBounding.height;
	      elemTop = top;
	      elemHeight = height;
	    }
	  }

	  // 获取 textContainer rect
	  var containerRect = getTextContainerRect(editor);
	  if (containerRect == null) return defaultStyle; // 默认 position
	  var containerTop = containerRect.top,
	    containerLeft = containerRect.left,
	    containerWidth = containerRect.width,
	    containerHeight = containerRect.height;

	  // 存储计算结构
	  var positionStyle = {};

	  // 获取 elem top left 和 container top left 的差值（< 0 则使用 0）
	  var relativeTop = elemTop - containerTop;
	  var relativeLeft = elemLeft - containerLeft;
	  if (type === 'bar') {
	    // bar - 1. left 对齐 elem.left ；2. 尽量显示在 elem 上方
	    positionStyle.left = "".concat(relativeLeft, "px");
	    if (relativeTop > 40) {
	      // top > 40 则显示在上方
	      positionStyle.bottom = "".concat(containerHeight - relativeTop + 5, "px"); // 5px 间隙
	    } else {
	      // 否则，显示在下方
	      positionStyle.top = "".concat(relativeTop + elemHeight + 5, "px"); // 5px 间隙
	    }

	    return positionStyle;
	  }
	  if (type === 'modal') {
	    // modal - 1. top 和 elem 需要计算，尽量不遮挡 elem

	    // 水平
	    if (!isVoidElem) {
	      // 非 void node - left 和 elem left 对齐
	      positionStyle.left = "".concat(relativeLeft, "px");
	    } else {
	      if (isInlineElem) {
	        // inline void node 需要计算
	        if (relativeLeft > (containerWidth - elemWidth) / 2) {
	          // elem 在 container 的右侧，则 modal 显示在 elem 左侧
	          positionStyle.right = "".concat(containerWidth - relativeLeft + 5, "px");
	        } else {
	          // 否则 elem 在 container 左侧，则 modal 显示在 elem 右侧
	          positionStyle.left = "".concat(relativeLeft + elemWidth + 5, "px");
	        }
	      } else {
	        // block void node 水平靠左即可
	        positionStyle.left = "20px";
	      }
	    }

	    // 垂直
	    if (isVoidElem) {
	      // void node - top 和 elem top 对齐
	      var t = relativeTop;
	      if (t < 0) t = 0; // top 不能小于 0
	      positionStyle.top = "".concat(t, "px");
	    } else {
	      // 非 void node ，计算 top
	      if (relativeTop > (containerHeight - elemHeight) / 2) {
	        // elem 在 container 的下半部分，则 modal 显示在 elem 上方
	        positionStyle.bottom = "".concat(containerHeight - relativeTop + 5, "px");
	      } else {
	        // elem 在 container 的上半部分，则 modal 显示在 elem 下方
	        var _t = relativeTop + elemHeight;
	        if (_t < 0) _t = 0;
	        positionStyle.top = "".concat(_t + 5, "px");
	      }
	    }
	    return positionStyle;
	  }
	  throw new Error("type '".concat(type, "' is invalid"));
	}

	/**
	 * 异步修正 position ，不能超出 textContainer 边界
	 * @param editor editor
	 * @param $positionElem modal/bar
	 */
	function correctPosition(editor, $positionElem) {
	  // 异步，否则 DOM 尚未渲染
	  promiseResolveThen(function () {
	    // 获取 textContainer rect
	    var containerRect = getTextContainerRect(editor);
	    if (containerRect == null) return;
	    var containerTop = containerRect.top,
	      containerLeft = containerRect.left,
	      containerWidth = containerRect.width,
	      containerHeight = containerRect.height;

	    // 获取 modal bar 的 rect
	    var _$positionElem$offset = $positionElem.offset(),
	      positionElemTop = _$positionElem$offset.top,
	      positionElemLeft = _$positionElem$offset.left;
	    var positionElemWidth = $positionElem.width();
	    var positionElemHeight = $positionElem.height();
	    var relativeTop = positionElemTop - containerTop;
	    var relativeLeft = positionElemLeft - containerLeft;

	    // 获取 modal bar 设置的 style
	    var styleStr = $positionElem.attr('style');
	    if (_indexOfInstanceProperty(styleStr).call(styleStr, 'top') >= 0) {
	      // 设置了 top ，则有可能超过 textContainer 的下边界
	      var d = relativeTop + positionElemHeight - containerHeight;
	      if (d > 0) {
	        // 已超过 textContainer 的下边界，则上移
	        var curTopStr = $positionElem.css('top');
	        var curTop = _parseInt$1(curTopStr.toString());
	        var newTop = curTop - d;
	        if (newTop < 0) newTop = 0; // 不能超过 textContainer 上边界
	        $positionElem.css('top', "".concat(newTop, "px"));
	      }
	    }
	    if (_indexOfInstanceProperty(styleStr).call(styleStr, 'bottom') >= 0) {
	      // 设置了 bottom ，则有可能超过 textContainer 的上边界
	      if (positionElemTop < 0) {
	        // 已超出了上边界
	        var curBottomStr = $positionElem.css('bottom');
	        var curBottom = _parseInt$1(curBottomStr.toString());
	        var newBottom = curBottom - Math.abs(positionElemTop); // 保证上边界和 textContainer 对齐即可，下边界不管
	        $positionElem.css('bottom', "".concat(newBottom, "px"));
	      }
	    }
	    if (_indexOfInstanceProperty(styleStr).call(styleStr, 'left') >= 0) {
	      // 设置了 left ，则有可能超过 textContainer 的右边界
	      var _d = relativeLeft + positionElemWidth - containerWidth;
	      if (_d > 0) {
	        // 已超过 textContainer 的右边界，需左移
	        var curLeftStr = $positionElem.css('left');
	        var curLeft = _parseInt$1(curLeftStr.toString());
	        var newLeft = curLeft - _d;
	        if (newLeft < 0) newLeft = 0; // 不能超过 textContainer 左边界
	        $positionElem.css('left', "".concat(newLeft, "px"));
	      }
	    }
	    if (_indexOfInstanceProperty(styleStr).call(styleStr, 'right') >= 0) {
	      // 设置了 right ，则有可能超过 textContainer 的左边界
	      if (positionElemLeft < 0) {
	        // 已超出了左边界
	        var curRightStr = $positionElem.css('right');
	        var curRight = _parseInt$1(curRightStr.toString());
	        var newRight = curRight - Math.abs(positionElemLeft); // 保证左边界和 textContainer 对齐即可，右边界不管
	        $positionElem.css('right', "".concat(newRight, "px"));
	      }
	    }
	  });
	}

	var withSelection = function withSelection(editor) {
	  var e = editor;
	  // 选中
	  // e.select = (at) => {
	  //   Transforms.select(e, at);
	  // };

	  // 取消选中
	  // e.deselect = () => {
	  //   const { selection } = e;
	  //   const root = DomEditor.findDocumentOrShadowRoot(e);
	  //   const domSelection = root.getSelection();

	  //   if (domSelection && domSelection.rangeCount > 0) {
	  //     domSelection.removeAllRanges();
	  //   }

	  //   if (selection) {
	  //     Transforms.deselect(editor);
	  //   }
	  // };

	  // // 移动光标
	  // e.move = (distance, reverse = false) => {
	  //   if (!distance) return;
	  //   if (distance < 0) return;

	  //   Transforms.move(editor, {
	  //     distance,
	  //     unit: "character",
	  //     reverse,
	  //   });
	  // };

	  // // 反向移动光标
	  // e.moveReverse = (distance) => {
	  //   e.move(distance, true);
	  // };

	  /**
	   * 还原选区
	   */
	  e.restoreSelection = function () {
	    var selection = EDITOR_TO_SELECTION.get(e);
	    if (selection == null) return;
	    e.focus();
	    Transforms.select(e, selection);
	  };

	  /**
	   * 获取选区的 position
	   */
	  e.getSelectionPosition = function () {
	    return getPositionBySelection(e);
	  };

	  /**
	   * 获取 node 的 position
	   */
	  e.getNodePosition = function (node) {
	    return getPositionByNode(e, node);
	  };

	  /**
	   * 是否全选
	   */
	  e.isSelectedAll = function () {
	    var selection = e.selection;
	    if (selection == null) return false;
	    var _Range$edges = Range.edges(selection),
	      _Range$edges2 = _slicedToArray(_Range$edges, 2),
	      start1 = _Range$edges2[0],
	      end1 = _Range$edges2[1]; // 获取当前选取的开始、结束 point
	    var _Editor$edges = Editor.edges(e, []),
	      _Editor$edges2 = _slicedToArray(_Editor$edges, 2),
	      start2 = _Editor$edges2[0],
	      end2 = _Editor$edges2[1]; // 获取编辑器全部的开始、结束 point

	    if (Point.equals(start1, start2) && Point.equals(end1, end2)) {
	      return true;
	    }
	    return false;
	  };

	  /**
	   * 全选
	   */
	  e.selectAll = function () {
	    var start = Editor.start(e, []);
	    var end = Editor.end(e, []);
	    Transforms.select(e, {
	      anchor: start,
	      focus: end
	    });
	  };
	  return e;
	};

	/**
	 * createEditor 未传递 selector 时，绑定 node 的关系（ NODE_TO_PARENT, NODE_TO_INDEX 等 ）
	 * @param node node
	 * @param index index
	 * @param parent parent node
	 * @param editor editor
	 */
	function bindNodeRelation(node, index, parent, editor) {
	  // 设置相关 weakMap 信息
	  NODE_TO_INDEX.set(node, index);
	  NODE_TO_PARENT.set(node, parent);
	  if (Element.isElement(node)) {
	    var _node$children = node.children,
	      children = _node$children === void 0 ? [] : _node$children;
	    _forEachInstanceProperty(children).call(children, function (child, i) {
	      return bindNodeRelation(child, i, node, editor);
	    }); // 递归子节点

	    var isVoid = Editor.isVoid(editor, node);
	    if (isVoid) {
	      var _Node$texts = Node.texts(node),
	        _Node$texts2 = _slicedToArray(_Node$texts, 1),
	        _Node$texts2$ = _slicedToArray(_Node$texts2[0], 1),
	        text = _Node$texts2$[0];
	      // 记录 text 相关 weakMap
	      NODE_TO_INDEX.set(text, 0);
	      NODE_TO_PARENT.set(text, node);
	    }
	  }
	}

	var uncurryThis$6 = functionUncurryThis$1;
	var aCallable = aCallable$e;
	var isObject$4 = isObject$B;
	var hasOwn = hasOwnProperty_1$1;
	var arraySlice = arraySlice$5;
	var NATIVE_BIND = functionBindNative$1;

	var $Function = Function;
	var concat$1 = uncurryThis$6([].concat);
	var join = uncurryThis$6([].join);
	var factories = {};

	var construct$3 = function (C, argsLength, args) {
	  if (!hasOwn(factories, argsLength)) {
	    var list = [];
	    var i = 0;
	    for (; i < argsLength; i++) list[i] = 'a[' + i + ']';
	    factories[argsLength] = $Function('C,a', 'return new C(' + join(list, ',') + ')');
	  } return factories[argsLength](C, args);
	};

	// `Function.prototype.bind` method implementation
	// https://tc39.es/ecma262/#sec-function.prototype.bind
	// eslint-disable-next-line es/no-function-prototype-bind -- detection
	var functionBind = NATIVE_BIND ? $Function.bind : function bind(that /* , ...args */) {
	  var F = aCallable(this);
	  var Prototype = F.prototype;
	  var partArgs = arraySlice(arguments, 1);
	  var boundFunction = function bound(/* args... */) {
	    var args = concat$1(partArgs, arraySlice(arguments));
	    return this instanceof boundFunction ? construct$3(F, args.length, args) : F.apply(that, args);
	  };
	  if (isObject$4(Prototype)) boundFunction.prototype = Prototype;
	  return boundFunction;
	};

	// TODO: Remove from `core-js@4`
	var $$h = _export$1;
	var bind$8 = functionBind;

	// `Function.prototype.bind` method
	// https://tc39.es/ecma262/#sec-function.prototype.bind
	// eslint-disable-next-line es/no-function-prototype-bind -- detection
	$$h({ target: 'Function', proto: true, forced: Function.bind !== bind$8 }, {
	  bind: bind$8
	});

	var getBuiltInPrototypeMethod$4 = getBuiltInPrototypeMethod$g;

	var bind$7 = getBuiltInPrototypeMethod$4('Function', 'bind');

	var isPrototypeOf$4 = objectIsPrototypeOf$1;
	var method$4 = bind$7;

	var FunctionPrototype = Function.prototype;

	var bind$6 = function (it) {
	  var own = it.bind;
	  return it === FunctionPrototype || (isPrototypeOf$4(FunctionPrototype, it) && own === FunctionPrototype.bind) ? method$4 : own;
	};

	var parent$p = bind$6;

	var bind$5 = parent$p;

	var bind$4 = bind$5;

	var _bindInstanceProperty$1 = /*@__PURE__*/getDefaultExportFromCjs(bind$4);

	function createElement(tagName, options) {
	    return document.createElement(tagName, options);
	}
	function createElementNS(namespaceURI, qualifiedName, options) {
	    return document.createElementNS(namespaceURI, qualifiedName, options);
	}
	function createDocumentFragment() {
	    return parseFragment(document.createDocumentFragment());
	}
	function createTextNode(text) {
	    return document.createTextNode(text);
	}
	function createComment(text) {
	    return document.createComment(text);
	}
	function insertBefore(parentNode, newNode, referenceNode) {
	    if (isDocumentFragment$1(parentNode)) {
	        let node = parentNode;
	        while (node && isDocumentFragment$1(node)) {
	            const fragment = parseFragment(node);
	            node = fragment.parent;
	        }
	        parentNode = node !== null && node !== void 0 ? node : parentNode;
	    }
	    if (isDocumentFragment$1(newNode)) {
	        newNode = parseFragment(newNode, parentNode);
	    }
	    if (referenceNode && isDocumentFragment$1(referenceNode)) {
	        referenceNode = parseFragment(referenceNode).firstChildNode;
	    }
	    parentNode.insertBefore(newNode, referenceNode);
	}
	function removeChild(node, child) {
	    node.removeChild(child);
	}
	function appendChild(node, child) {
	    if (isDocumentFragment$1(child)) {
	        child = parseFragment(child, node);
	    }
	    node.appendChild(child);
	}
	function parentNode(node) {
	    if (isDocumentFragment$1(node)) {
	        while (node && isDocumentFragment$1(node)) {
	            const fragment = parseFragment(node);
	            node = fragment.parent;
	        }
	        return node !== null && node !== void 0 ? node : null;
	    }
	    return node.parentNode;
	}
	function nextSibling(node) {
	    var _a;
	    if (isDocumentFragment$1(node)) {
	        const fragment = parseFragment(node);
	        const parent = parentNode(fragment);
	        if (parent && fragment.lastChildNode) {
	            const children = Array.from(parent.childNodes);
	            const index = children.indexOf(fragment.lastChildNode);
	            return (_a = children[index + 1]) !== null && _a !== void 0 ? _a : null;
	        }
	        return null;
	    }
	    return node.nextSibling;
	}
	function tagName(elm) {
	    return elm.tagName;
	}
	function setTextContent(node, text) {
	    node.textContent = text;
	}
	function getTextContent(node) {
	    return node.textContent;
	}
	function isElement$1(node) {
	    return node.nodeType === 1;
	}
	function isText(node) {
	    return node.nodeType === 3;
	}
	function isComment(node) {
	    return node.nodeType === 8;
	}
	function isDocumentFragment$1(node) {
	    return node.nodeType === 11;
	}
	function parseFragment(fragmentNode, parentNode) {
	    var _a, _b, _c;
	    const fragment = fragmentNode;
	    (_a = fragment.parent) !== null && _a !== void 0 ? _a : (fragment.parent = parentNode !== null && parentNode !== void 0 ? parentNode : null);
	    (_b = fragment.firstChildNode) !== null && _b !== void 0 ? _b : (fragment.firstChildNode = fragmentNode.firstChild);
	    (_c = fragment.lastChildNode) !== null && _c !== void 0 ? _c : (fragment.lastChildNode = fragmentNode.lastChild);
	    return fragment;
	}
	const htmlDomApi = {
	    createElement,
	    createElementNS,
	    createTextNode,
	    createDocumentFragment,
	    createComment,
	    insertBefore,
	    removeChild,
	    appendChild,
	    parentNode,
	    nextSibling,
	    tagName,
	    setTextContent,
	    getTextContent,
	    isElement: isElement$1,
	    isText,
	    isComment,
	    isDocumentFragment: isDocumentFragment$1,
	};

	function vnode(sel, data, children, text, elm) {
	    const key = data === undefined ? undefined : data.key;
	    return { sel, data, children, text, elm, key };
	}

	const array = Array.isArray;
	function primitive(s) {
	    return (typeof s === "string" ||
	        typeof s === "number" ||
	        s instanceof String ||
	        s instanceof Number);
	}

	function isUndef(s) {
	    return s === undefined;
	}
	function isDef(s) {
	    return s !== undefined;
	}
	const emptyNode = vnode("", {}, [], undefined, undefined);
	function sameVnode(vnode1, vnode2) {
	    var _a, _b;
	    const isSameKey = vnode1.key === vnode2.key;
	    const isSameIs = ((_a = vnode1.data) === null || _a === void 0 ? void 0 : _a.is) === ((_b = vnode2.data) === null || _b === void 0 ? void 0 : _b.is);
	    const isSameSel = vnode1.sel === vnode2.sel;
	    const isSameTextOrFragment = !vnode1.sel && vnode1.sel === vnode2.sel
	        ? typeof vnode1.text === typeof vnode2.text
	        : true;
	    return isSameSel && isSameKey && isSameIs && isSameTextOrFragment;
	}
	/**
	 * @todo Remove this function when the document fragment is considered stable.
	 */
	function documentFragmentIsNotSupported() {
	    throw new Error("The document fragment is not supported on this platform.");
	}
	function isElement(api, vnode) {
	    return api.isElement(vnode);
	}
	function isDocumentFragment(api, vnode) {
	    return api.isDocumentFragment(vnode);
	}
	function createKeyToOldIdx(children, beginIdx, endIdx) {
	    var _a;
	    const map = {};
	    for (let i = beginIdx; i <= endIdx; ++i) {
	        const key = (_a = children[i]) === null || _a === void 0 ? void 0 : _a.key;
	        if (key !== undefined) {
	            map[key] = i;
	        }
	    }
	    return map;
	}
	const hooks = [
	    "create",
	    "update",
	    "remove",
	    "destroy",
	    "pre",
	    "post",
	];
	function init(modules, domApi, options) {
	    const cbs = {
	        create: [],
	        update: [],
	        remove: [],
	        destroy: [],
	        pre: [],
	        post: [],
	    };
	    const api = domApi !== undefined ? domApi : htmlDomApi;
	    for (const hook of hooks) {
	        for (const module of modules) {
	            const currentHook = module[hook];
	            if (currentHook !== undefined) {
	                cbs[hook].push(currentHook);
	            }
	        }
	    }
	    function emptyNodeAt(elm) {
	        const id = elm.id ? "#" + elm.id : "";
	        // elm.className doesn't return a string when elm is an SVG element inside a shadowRoot.
	        // https://stackoverflow.com/questions/29454340/detecting-classname-of-svganimatedstring
	        const classes = elm.getAttribute("class");
	        const c = classes ? "." + classes.split(" ").join(".") : "";
	        return vnode(api.tagName(elm).toLowerCase() + id + c, {}, [], undefined, elm);
	    }
	    function emptyDocumentFragmentAt(frag) {
	        return vnode(undefined, {}, [], undefined, frag);
	    }
	    function createRmCb(childElm, listeners) {
	        return function rmCb() {
	            if (--listeners === 0) {
	                const parent = api.parentNode(childElm);
	                api.removeChild(parent, childElm);
	            }
	        };
	    }
	    function createElm(vnode, insertedVnodeQueue) {
	        var _a, _b, _c, _d;
	        let i;
	        let data = vnode.data;
	        if (data !== undefined) {
	            const init = (_a = data.hook) === null || _a === void 0 ? void 0 : _a.init;
	            if (isDef(init)) {
	                init(vnode);
	                data = vnode.data;
	            }
	        }
	        const children = vnode.children;
	        const sel = vnode.sel;
	        if (sel === "!") {
	            if (isUndef(vnode.text)) {
	                vnode.text = "";
	            }
	            vnode.elm = api.createComment(vnode.text);
	        }
	        else if (sel !== undefined) {
	            // Parse selector
	            const hashIdx = sel.indexOf("#");
	            const dotIdx = sel.indexOf(".", hashIdx);
	            const hash = hashIdx > 0 ? hashIdx : sel.length;
	            const dot = dotIdx > 0 ? dotIdx : sel.length;
	            const tag = hashIdx !== -1 || dotIdx !== -1
	                ? sel.slice(0, Math.min(hash, dot))
	                : sel;
	            const elm = (vnode.elm =
	                isDef(data) && isDef((i = data.ns))
	                    ? api.createElementNS(i, tag, data)
	                    : api.createElement(tag, data));
	            if (hash < dot)
	                elm.setAttribute("id", sel.slice(hash + 1, dot));
	            if (dotIdx > 0)
	                elm.setAttribute("class", sel.slice(dot + 1).replace(/\./g, " "));
	            for (i = 0; i < cbs.create.length; ++i)
	                cbs.create[i](emptyNode, vnode);
	            if (array(children)) {
	                for (i = 0; i < children.length; ++i) {
	                    const ch = children[i];
	                    if (ch != null) {
	                        api.appendChild(elm, createElm(ch, insertedVnodeQueue));
	                    }
	                }
	            }
	            else if (primitive(vnode.text)) {
	                api.appendChild(elm, api.createTextNode(vnode.text));
	            }
	            const hook = vnode.data.hook;
	            if (isDef(hook)) {
	                (_b = hook.create) === null || _b === void 0 ? void 0 : _b.call(hook, emptyNode, vnode);
	                if (hook.insert) {
	                    insertedVnodeQueue.push(vnode);
	                }
	            }
	        }
	        else if (((_c = options === null || options === void 0 ? void 0 : options.experimental) === null || _c === void 0 ? void 0 : _c.fragments) && vnode.children) {
	            vnode.elm = ((_d = api.createDocumentFragment) !== null && _d !== void 0 ? _d : documentFragmentIsNotSupported)();
	            for (i = 0; i < cbs.create.length; ++i)
	                cbs.create[i](emptyNode, vnode);
	            for (i = 0; i < vnode.children.length; ++i) {
	                const ch = vnode.children[i];
	                if (ch != null) {
	                    api.appendChild(vnode.elm, createElm(ch, insertedVnodeQueue));
	                }
	            }
	        }
	        else {
	            vnode.elm = api.createTextNode(vnode.text);
	        }
	        return vnode.elm;
	    }
	    function addVnodes(parentElm, before, vnodes, startIdx, endIdx, insertedVnodeQueue) {
	        for (; startIdx <= endIdx; ++startIdx) {
	            const ch = vnodes[startIdx];
	            if (ch != null) {
	                api.insertBefore(parentElm, createElm(ch, insertedVnodeQueue), before);
	            }
	        }
	    }
	    function invokeDestroyHook(vnode) {
	        var _a, _b;
	        const data = vnode.data;
	        if (data !== undefined) {
	            (_b = (_a = data === null || data === void 0 ? void 0 : data.hook) === null || _a === void 0 ? void 0 : _a.destroy) === null || _b === void 0 ? void 0 : _b.call(_a, vnode);
	            for (let i = 0; i < cbs.destroy.length; ++i)
	                cbs.destroy[i](vnode);
	            if (vnode.children !== undefined) {
	                for (let j = 0; j < vnode.children.length; ++j) {
	                    const child = vnode.children[j];
	                    if (child != null && typeof child !== "string") {
	                        invokeDestroyHook(child);
	                    }
	                }
	            }
	        }
	    }
	    function removeVnodes(parentElm, vnodes, startIdx, endIdx) {
	        var _a, _b;
	        for (; startIdx <= endIdx; ++startIdx) {
	            let listeners;
	            let rm;
	            const ch = vnodes[startIdx];
	            if (ch != null) {
	                if (isDef(ch.sel)) {
	                    invokeDestroyHook(ch);
	                    listeners = cbs.remove.length + 1;
	                    rm = createRmCb(ch.elm, listeners);
	                    for (let i = 0; i < cbs.remove.length; ++i)
	                        cbs.remove[i](ch, rm);
	                    const removeHook = (_b = (_a = ch === null || ch === void 0 ? void 0 : ch.data) === null || _a === void 0 ? void 0 : _a.hook) === null || _b === void 0 ? void 0 : _b.remove;
	                    if (isDef(removeHook)) {
	                        removeHook(ch, rm);
	                    }
	                    else {
	                        rm();
	                    }
	                }
	                else if (ch.children) {
	                    // Fragment node
	                    invokeDestroyHook(ch);
	                    removeVnodes(parentElm, ch.children, 0, ch.children.length - 1);
	                }
	                else {
	                    // Text node
	                    api.removeChild(parentElm, ch.elm);
	                }
	            }
	        }
	    }
	    function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue) {
	        let oldStartIdx = 0;
	        let newStartIdx = 0;
	        let oldEndIdx = oldCh.length - 1;
	        let oldStartVnode = oldCh[0];
	        let oldEndVnode = oldCh[oldEndIdx];
	        let newEndIdx = newCh.length - 1;
	        let newStartVnode = newCh[0];
	        let newEndVnode = newCh[newEndIdx];
	        let oldKeyToIdx;
	        let idxInOld;
	        let elmToMove;
	        let before;
	        while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
	            if (oldStartVnode == null) {
	                oldStartVnode = oldCh[++oldStartIdx]; // Vnode might have been moved left
	            }
	            else if (oldEndVnode == null) {
	                oldEndVnode = oldCh[--oldEndIdx];
	            }
	            else if (newStartVnode == null) {
	                newStartVnode = newCh[++newStartIdx];
	            }
	            else if (newEndVnode == null) {
	                newEndVnode = newCh[--newEndIdx];
	            }
	            else if (sameVnode(oldStartVnode, newStartVnode)) {
	                patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
	                oldStartVnode = oldCh[++oldStartIdx];
	                newStartVnode = newCh[++newStartIdx];
	            }
	            else if (sameVnode(oldEndVnode, newEndVnode)) {
	                patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
	                oldEndVnode = oldCh[--oldEndIdx];
	                newEndVnode = newCh[--newEndIdx];
	            }
	            else if (sameVnode(oldStartVnode, newEndVnode)) {
	                // Vnode moved right
	                patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
	                api.insertBefore(parentElm, oldStartVnode.elm, api.nextSibling(oldEndVnode.elm));
	                oldStartVnode = oldCh[++oldStartIdx];
	                newEndVnode = newCh[--newEndIdx];
	            }
	            else if (sameVnode(oldEndVnode, newStartVnode)) {
	                // Vnode moved left
	                patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
	                api.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
	                oldEndVnode = oldCh[--oldEndIdx];
	                newStartVnode = newCh[++newStartIdx];
	            }
	            else {
	                if (oldKeyToIdx === undefined) {
	                    oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
	                }
	                idxInOld = oldKeyToIdx[newStartVnode.key];
	                if (isUndef(idxInOld)) {
	                    // New element
	                    api.insertBefore(parentElm, createElm(newStartVnode, insertedVnodeQueue), oldStartVnode.elm);
	                }
	                else {
	                    elmToMove = oldCh[idxInOld];
	                    if (elmToMove.sel !== newStartVnode.sel) {
	                        api.insertBefore(parentElm, createElm(newStartVnode, insertedVnodeQueue), oldStartVnode.elm);
	                    }
	                    else {
	                        patchVnode(elmToMove, newStartVnode, insertedVnodeQueue);
	                        oldCh[idxInOld] = undefined;
	                        api.insertBefore(parentElm, elmToMove.elm, oldStartVnode.elm);
	                    }
	                }
	                newStartVnode = newCh[++newStartIdx];
	            }
	        }
	        if (newStartIdx <= newEndIdx) {
	            before = newCh[newEndIdx + 1] == null ? null : newCh[newEndIdx + 1].elm;
	            addVnodes(parentElm, before, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
	        }
	        if (oldStartIdx <= oldEndIdx) {
	            removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
	        }
	    }
	    function patchVnode(oldVnode, vnode, insertedVnodeQueue) {
	        var _a, _b, _c, _d, _e, _f, _g, _h;
	        const hook = (_a = vnode.data) === null || _a === void 0 ? void 0 : _a.hook;
	        (_b = hook === null || hook === void 0 ? void 0 : hook.prepatch) === null || _b === void 0 ? void 0 : _b.call(hook, oldVnode, vnode);
	        const elm = (vnode.elm = oldVnode.elm);
	        if (oldVnode === vnode)
	            return;
	        if (vnode.data !== undefined ||
	            (isDef(vnode.text) && vnode.text !== oldVnode.text)) {
	            (_c = vnode.data) !== null && _c !== void 0 ? _c : (vnode.data = {});
	            (_d = oldVnode.data) !== null && _d !== void 0 ? _d : (oldVnode.data = {});
	            for (let i = 0; i < cbs.update.length; ++i)
	                cbs.update[i](oldVnode, vnode);
	            (_g = (_f = (_e = vnode.data) === null || _e === void 0 ? void 0 : _e.hook) === null || _f === void 0 ? void 0 : _f.update) === null || _g === void 0 ? void 0 : _g.call(_f, oldVnode, vnode);
	        }
	        const oldCh = oldVnode.children;
	        const ch = vnode.children;
	        if (isUndef(vnode.text)) {
	            if (isDef(oldCh) && isDef(ch)) {
	                if (oldCh !== ch)
	                    updateChildren(elm, oldCh, ch, insertedVnodeQueue);
	            }
	            else if (isDef(ch)) {
	                if (isDef(oldVnode.text))
	                    api.setTextContent(elm, "");
	                addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
	            }
	            else if (isDef(oldCh)) {
	                removeVnodes(elm, oldCh, 0, oldCh.length - 1);
	            }
	            else if (isDef(oldVnode.text)) {
	                api.setTextContent(elm, "");
	            }
	        }
	        else if (oldVnode.text !== vnode.text) {
	            if (isDef(oldCh)) {
	                removeVnodes(elm, oldCh, 0, oldCh.length - 1);
	            }
	            api.setTextContent(elm, vnode.text);
	        }
	        (_h = hook === null || hook === void 0 ? void 0 : hook.postpatch) === null || _h === void 0 ? void 0 : _h.call(hook, oldVnode, vnode);
	    }
	    return function patch(oldVnode, vnode) {
	        let i, elm, parent;
	        const insertedVnodeQueue = [];
	        for (i = 0; i < cbs.pre.length; ++i)
	            cbs.pre[i]();
	        if (isElement(api, oldVnode)) {
	            oldVnode = emptyNodeAt(oldVnode);
	        }
	        else if (isDocumentFragment(api, oldVnode)) {
	            oldVnode = emptyDocumentFragmentAt(oldVnode);
	        }
	        if (sameVnode(oldVnode, vnode)) {
	            patchVnode(oldVnode, vnode, insertedVnodeQueue);
	        }
	        else {
	            elm = oldVnode.elm;
	            parent = api.parentNode(elm);
	            createElm(vnode, insertedVnodeQueue);
	            if (parent !== null) {
	                api.insertBefore(parent, vnode.elm, api.nextSibling(elm));
	                removeVnodes(parent, [oldVnode], 0, 0);
	            }
	        }
	        for (i = 0; i < insertedVnodeQueue.length; ++i) {
	            insertedVnodeQueue[i].data.hook.insert(insertedVnodeQueue[i]);
	        }
	        for (i = 0; i < cbs.post.length; ++i)
	            cbs.post[i]();
	        return vnode;
	    };
	}

	function addNS(data, children, sel) {
	    data.ns = "http://www.w3.org/2000/svg";
	    if (sel !== "foreignObject" && children !== undefined) {
	        for (let i = 0; i < children.length; ++i) {
	            const child = children[i];
	            if (typeof child === "string")
	                continue;
	            const childData = child.data;
	            if (childData !== undefined) {
	                addNS(childData, child.children, child.sel);
	            }
	        }
	    }
	}
	function h(sel, b, c) {
	    let data = {};
	    let children;
	    let text;
	    let i;
	    if (c !== undefined) {
	        if (b !== null) {
	            data = b;
	        }
	        if (array(c)) {
	            children = c;
	        }
	        else if (primitive(c)) {
	            text = c.toString();
	        }
	        else if (c && c.sel) {
	            children = [c];
	        }
	    }
	    else if (b !== undefined && b !== null) {
	        if (array(b)) {
	            children = b;
	        }
	        else if (primitive(b)) {
	            text = b.toString();
	        }
	        else if (b && b.sel) {
	            children = [b];
	        }
	        else {
	            data = b;
	        }
	    }
	    if (children !== undefined) {
	        for (i = 0; i < children.length; ++i) {
	            if (primitive(children[i]))
	                children[i] = vnode(undefined, undefined, undefined, children[i], undefined);
	        }
	    }
	    if (sel[0] === "s" &&
	        sel[1] === "v" &&
	        sel[2] === "g" &&
	        (sel.length === 3 || sel[3] === "." || sel[3] === "#")) {
	        addNS(data, children, sel);
	    }
	    return vnode(sel, data, children, text, undefined);
	}

	const xlinkNS = "http://www.w3.org/1999/xlink";
	const xmlNS = "http://www.w3.org/XML/1998/namespace";
	const colonChar = 58;
	const xChar = 120;
	function updateAttrs(oldVnode, vnode) {
	    let key;
	    const elm = vnode.elm;
	    let oldAttrs = oldVnode.data.attrs;
	    let attrs = vnode.data.attrs;
	    if (!oldAttrs && !attrs)
	        return;
	    if (oldAttrs === attrs)
	        return;
	    oldAttrs = oldAttrs || {};
	    attrs = attrs || {};
	    // update modified attributes, add new attributes
	    for (key in attrs) {
	        const cur = attrs[key];
	        const old = oldAttrs[key];
	        if (old !== cur) {
	            if (cur === true) {
	                elm.setAttribute(key, "");
	            }
	            else if (cur === false) {
	                elm.removeAttribute(key);
	            }
	            else {
	                if (key.charCodeAt(0) !== xChar) {
	                    elm.setAttribute(key, cur);
	                }
	                else if (key.charCodeAt(3) === colonChar) {
	                    // Assume xml namespace
	                    elm.setAttributeNS(xmlNS, key, cur);
	                }
	                else if (key.charCodeAt(5) === colonChar) {
	                    // Assume xlink namespace
	                    elm.setAttributeNS(xlinkNS, key, cur);
	                }
	                else {
	                    elm.setAttribute(key, cur);
	                }
	            }
	        }
	    }
	    // remove removed attributes
	    // use `in` operator since the previous `for` iteration uses it (.i.e. add even attributes with undefined value)
	    // the other option is to remove all attributes with value == undefined
	    for (key in oldAttrs) {
	        if (!(key in attrs)) {
	            elm.removeAttribute(key);
	        }
	    }
	}
	const attributesModule = {
	    create: updateAttrs,
	    update: updateAttrs,
	};

	function updateClass(oldVnode, vnode) {
	    let cur;
	    let name;
	    const elm = vnode.elm;
	    let oldClass = oldVnode.data.class;
	    let klass = vnode.data.class;
	    if (!oldClass && !klass)
	        return;
	    if (oldClass === klass)
	        return;
	    oldClass = oldClass || {};
	    klass = klass || {};
	    for (name in oldClass) {
	        if (oldClass[name] && !Object.prototype.hasOwnProperty.call(klass, name)) {
	            // was `true` and now not provided
	            elm.classList.remove(name);
	        }
	    }
	    for (name in klass) {
	        cur = klass[name];
	        if (cur !== oldClass[name]) {
	            elm.classList[cur ? "add" : "remove"](name);
	        }
	    }
	}
	const classModule = { create: updateClass, update: updateClass };

	const CAPS_REGEX = /[A-Z]/g;
	function updateDataset(oldVnode, vnode) {
	    const elm = vnode.elm;
	    let oldDataset = oldVnode.data.dataset;
	    let dataset = vnode.data.dataset;
	    let key;
	    if (!oldDataset && !dataset)
	        return;
	    if (oldDataset === dataset)
	        return;
	    oldDataset = oldDataset || {};
	    dataset = dataset || {};
	    const d = elm.dataset;
	    for (key in oldDataset) {
	        if (!dataset[key]) {
	            if (d) {
	                if (key in d) {
	                    delete d[key];
	                }
	            }
	            else {
	                elm.removeAttribute("data-" + key.replace(CAPS_REGEX, "-$&").toLowerCase());
	            }
	        }
	    }
	    for (key in dataset) {
	        if (oldDataset[key] !== dataset[key]) {
	            if (d) {
	                d[key] = dataset[key];
	            }
	            else {
	                elm.setAttribute("data-" + key.replace(CAPS_REGEX, "-$&").toLowerCase(), dataset[key]);
	            }
	        }
	    }
	}
	const datasetModule = {
	    create: updateDataset,
	    update: updateDataset,
	};

	function invokeHandler(handler, vnode, event) {
	    if (typeof handler === "function") {
	        // call function handler
	        handler.call(vnode, event, vnode);
	    }
	    else if (typeof handler === "object") {
	        // call multiple handlers
	        for (let i = 0; i < handler.length; i++) {
	            invokeHandler(handler[i], vnode, event);
	        }
	    }
	}
	function handleEvent(event, vnode) {
	    const name = event.type;
	    const on = vnode.data.on;
	    // call event handler(s) if exists
	    if (on && on[name]) {
	        invokeHandler(on[name], vnode, event);
	    }
	}
	function createListener() {
	    return function handler(event) {
	        handleEvent(event, handler.vnode);
	    };
	}
	function updateEventListeners(oldVnode, vnode) {
	    const oldOn = oldVnode.data.on;
	    const oldListener = oldVnode.listener;
	    const oldElm = oldVnode.elm;
	    const on = vnode && vnode.data.on;
	    const elm = (vnode && vnode.elm);
	    let name;
	    // optimization for reused immutable handlers
	    if (oldOn === on) {
	        return;
	    }
	    // remove existing listeners which no longer used
	    if (oldOn && oldListener) {
	        // if element changed or deleted we remove all existing listeners unconditionally
	        if (!on) {
	            for (name in oldOn) {
	                // remove listener if element was changed or existing listeners removed
	                oldElm.removeEventListener(name, oldListener, false);
	            }
	        }
	        else {
	            for (name in oldOn) {
	                // remove listener if existing listener removed
	                if (!on[name]) {
	                    oldElm.removeEventListener(name, oldListener, false);
	                }
	            }
	        }
	    }
	    // add new listeners which has not already attached
	    if (on) {
	        // reuse existing listener or create new
	        const listener = (vnode.listener =
	            oldVnode.listener || createListener());
	        // update vnode for listener
	        listener.vnode = vnode;
	        // if element changed or added we add all needed listeners unconditionally
	        if (!oldOn) {
	            for (name in on) {
	                // add listener if element was changed or new listeners added
	                elm.addEventListener(name, listener, false);
	            }
	        }
	        else {
	            for (name in on) {
	                // add listener if new listener added
	                if (!oldOn[name]) {
	                    elm.addEventListener(name, listener, false);
	                }
	            }
	        }
	    }
	}
	const eventListenersModule = {
	    create: updateEventListeners,
	    update: updateEventListeners,
	    destroy: updateEventListeners,
	};

	function updateProps(oldVnode, vnode) {
	    let key;
	    let cur;
	    let old;
	    const elm = vnode.elm;
	    let oldProps = oldVnode.data.props;
	    let props = vnode.data.props;
	    if (!oldProps && !props)
	        return;
	    if (oldProps === props)
	        return;
	    oldProps = oldProps || {};
	    props = props || {};
	    for (key in props) {
	        cur = props[key];
	        old = oldProps[key];
	        if (old !== cur && (key !== "value" || elm[key] !== cur)) {
	            elm[key] = cur;
	        }
	    }
	}
	const propsModule = { create: updateProps, update: updateProps };

	// Bindig `requestAnimationFrame` like this fixes a bug in IE/Edge. See #360 and #409.
	const raf = (typeof window !== "undefined" &&
	    window.requestAnimationFrame.bind(window)) ||
	    setTimeout;
	const nextFrame = function (fn) {
	    raf(function () {
	        raf(fn);
	    });
	};
	let reflowForced = false;
	function setNextFrame(obj, prop, val) {
	    nextFrame(function () {
	        obj[prop] = val;
	    });
	}
	function updateStyle(oldVnode, vnode) {
	    let cur;
	    let name;
	    const elm = vnode.elm;
	    let oldStyle = oldVnode.data.style;
	    let style = vnode.data.style;
	    if (!oldStyle && !style)
	        return;
	    if (oldStyle === style)
	        return;
	    oldStyle = oldStyle || {};
	    style = style || {};
	    const oldHasDel = "delayed" in oldStyle;
	    for (name in oldStyle) {
	        if (!style[name]) {
	            if (name[0] === "-" && name[1] === "-") {
	                elm.style.removeProperty(name);
	            }
	            else {
	                elm.style[name] = "";
	            }
	        }
	    }
	    for (name in style) {
	        cur = style[name];
	        if (name === "delayed" && style.delayed) {
	            for (const name2 in style.delayed) {
	                cur = style.delayed[name2];
	                if (!oldHasDel || cur !== oldStyle.delayed[name2]) {
	                    setNextFrame(elm.style, name2, cur);
	                }
	            }
	        }
	        else if (name !== "remove" && cur !== oldStyle[name]) {
	            if (name[0] === "-" && name[1] === "-") {
	                elm.style.setProperty(name, cur);
	            }
	            else {
	                elm.style[name] = cur;
	            }
	        }
	    }
	}
	function applyDestroyStyle(vnode) {
	    let style;
	    let name;
	    const elm = vnode.elm;
	    const s = vnode.data.style;
	    if (!s || !(style = s.destroy))
	        return;
	    for (name in style) {
	        elm.style[name] = style[name];
	    }
	}
	function applyRemoveStyle(vnode, rm) {
	    const s = vnode.data.style;
	    if (!s || !s.remove) {
	        rm();
	        return;
	    }
	    if (!reflowForced) {
	        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
	        vnode.elm.offsetLeft;
	        reflowForced = true;
	    }
	    let name;
	    const elm = vnode.elm;
	    let i = 0;
	    const style = s.remove;
	    let amount = 0;
	    const applied = [];
	    for (name in style) {
	        applied.push(name);
	        elm.style[name] = style[name];
	    }
	    const compStyle = getComputedStyle(elm);
	    const props = compStyle["transition-property"].split(", ");
	    for (; i < props.length; ++i) {
	        if (applied.indexOf(props[i]) !== -1)
	            amount++;
	    }
	    elm.addEventListener("transitionend", function (ev) {
	        if (ev.target === elm)
	            --amount;
	        if (amount === 0)
	            rm();
	    });
	}
	function forceReflow() {
	    reflowForced = false;
	}
	const styleModule = {
	    pre: forceReflow,
	    create: updateStyle,
	    update: updateStyle,
	    destroy: applyDestroyStyle,
	    remove: applyRemoveStyle,
	};

	var DESCRIPTORS$1 = descriptors$1;
	var uncurryThis$5 = functionUncurryThis$1;
	var call$1 = functionCall$1;
	var fails$3 = fails$T;
	var objectKeys = objectKeys$5;
	var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols$1;
	var propertyIsEnumerableModule = objectPropertyIsEnumerable$1;
	var toObject$1 = toObject$f;
	var IndexedObject = indexedObject$1;

	// eslint-disable-next-line es/no-object-assign -- safe
	var $assign = Object.assign;
	// eslint-disable-next-line es/no-object-defineproperty -- required for testing
	var defineProperty = Object.defineProperty;
	var concat = uncurryThis$5([].concat);

	// `Object.assign` method
	// https://tc39.es/ecma262/#sec-object.assign
	var objectAssign = !$assign || fails$3(function () {
	  // should have correct order of operations (Edge bug)
	  if (DESCRIPTORS$1 && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
	    enumerable: true,
	    get: function () {
	      defineProperty(this, 'b', {
	        value: 3,
	        enumerable: false
	      });
	    }
	  }), { b: 2 })).b !== 1) return true;
	  // should work with symbols and should have deterministic property order (V8 bug)
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line es/no-symbol -- safe
	  var symbol = Symbol('assign detection');
	  var alphabet = 'abcdefghijklmnopqrst';
	  A[symbol] = 7;
	  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
	  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
	  var T = toObject$1(target);
	  var argumentsLength = arguments.length;
	  var index = 1;
	  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
	  var propertyIsEnumerable = propertyIsEnumerableModule.f;
	  while (argumentsLength > index) {
	    var S = IndexedObject(arguments[index++]);
	    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS$1 || call$1(propertyIsEnumerable, S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;

	var $$g = _export$1;
	var assign$3 = objectAssign;

	// `Object.assign` method
	// https://tc39.es/ecma262/#sec-object.assign
	// eslint-disable-next-line es/no-object-assign -- required for testing
	$$g({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign$3 }, {
	  assign: assign$3
	});

	var path$5 = path$q;

	var assign$2 = path$5.Object.assign;

	var parent$o = assign$2;

	var assign$1 = parent$o;

	var assign = assign$1;

	var _Object$assign = /*@__PURE__*/getDefaultExportFromCjs(assign);

	// ------------------------------------ render style ------------------------------------

	// 存储：处理文本样式的函数，如 b u color 等
	var RENDER_STYLE_HANDLER_LIST = [];

	/**
	 * 注册处理文本样式的函数
	 * @param fn 处理文本样式的函数
	 */
	function registerStyleHandler(fn) {
	  RENDER_STYLE_HANDLER_LIST.push(fn);
	}

	// ------------------------------------ render elem ------------------------------------

	// 注册 render element 配置
	var RENDER_ELEM_CONF = {};

	/**
	 * 注册 render elem 函数
	 * @param conf { type, renderElem } ，type 即 node.type
	 */
	function registerRenderElemConf(conf) {
	  var type = conf.type,
	    renderElem = conf.renderElem;
	  var key = type || '';

	  // 如果 key 重复了，就后者覆盖前者
	  RENDER_ELEM_CONF[key] = renderElem;
	}

	/**
	 * 默认的 render elem
	 * @param elemNode elem
	 * @param editor editor
	 * @param children children vnode
	 * @returns vnode
	 */
	function defaultRender(elemNode, children, editor) {
	  var Tag = editor.isInline(elemNode) ? 'span' : 'div';
	  var vnode = h(Tag, {
	    props: {}
	  }, children);
	  return vnode;
	}

	/**
	 * 根据 elemNode.type 获取 renderElement 函数
	 * @param type elemNode.type
	 */
	function getRenderElem(type) {
	  var fn = RENDER_ELEM_CONF[type];
	  return fn || defaultRender;
	}

	/**
	 * 渲染样式
	 * @param elem slate elem node
	 * @param vnode elem Vnode
	 */
	function renderStyle$4(elem, vnode) {
	  var newVnode = vnode;
	  _forEachInstanceProperty(RENDER_STYLE_HANDLER_LIST).call(RENDER_STYLE_HANDLER_LIST, function (styleHandler) {
	    newVnode = styleHandler(elem, vnode);
	  });
	  return newVnode;
	}

	function renderElement(elemNode, editor) {
	  var key = DomEditor.findKey(editor, elemNode);
	  // const readOnly = editor.isDisabled()
	  var isInline = editor.isInline(elemNode);
	  var isVoid = Editor.isVoid(editor, elemNode);
	  var domId = genElemId(key.id);
	  var attrs = {
	    id: domId,
	    key: key.id,
	    'data-slate-node': 'element',
	    'data-slate-inline': isInline
	  };

	  // 根据 type 生成 vnode 的函数
	  var type = elemNode.type,
	    _elemNode$children = elemNode.children,
	    children = _elemNode$children === void 0 ? [] : _elemNode$children;
	  var renderElem = getRenderElem(type);
	  var childrenVnode;
	  if (isVoid) {
	    childrenVnode = null; // void 节点 render elem 时不传入 children
	  } else {
	    childrenVnode = _mapInstanceProperty(children).call(children, function (child, index) {
	      return node2Vnode(child, index, elemNode, editor);
	    });
	  }

	  // 创建 vnode
	  var vnode = renderElem(elemNode, childrenVnode, editor);

	  // void node 要特殊处理
	  if (isVoid) {
	    attrs['data-slate-void'] = true;

	    // 如果这里设置 contentEditable = false ，那图片就无法删除了 ？？？
	    // if (!readOnly && isInline) {
	    //     attrs.contentEditable = false
	    // }

	    var Tag = isInline ? 'span' : 'div';
	    var _Node$texts = Node.texts(elemNode),
	      _Node$texts2 = _slicedToArray(_Node$texts, 1),
	      _Node$texts2$ = _slicedToArray(_Node$texts2[0], 1),
	      text = _Node$texts2$[0];
	    var textVnode = node2Vnode(text, 0, elemNode, editor);
	    var textWrapperVnode = h(Tag, {
	      'data-slate-spacer': true,
	      style: {
	        height: '0',
	        color: 'transparent',
	        outline: 'none',
	        position: 'absolute'
	      }
	    }, textVnode);

	    // 重写 vnode
	    vnode = h(Tag, {
	      // 设置 position: relative，保证 absolute 的 textWrapperVnode 不乱跑
	      style: {
	        position: 'relative'
	      }
	    }, [vnode, textWrapperVnode]);

	    // 记录 text 相关 weakMap
	    NODE_TO_INDEX.set(text, 0);
	    NODE_TO_PARENT.set(text, elemNode);
	  }

	  // 添加 element 属性
	  if (vnode.data == null) vnode.data = {};
	  _Object$assign(vnode.data, attrs);

	  // 添加文本相关的样式，如 text-align
	  if (!isVoid && !isInline) {
	    // 非 void + 非 inline
	    vnode = renderStyle$4(elemNode, vnode);
	  }

	  // 更新 element 相关的 weakMap
	  promiseResolveThen(function () {
	    // 异步，否则拿不到 DOM 节点
	    var dom = getElementById(domId);
	    if (dom == null) return;
	    KEY_TO_ELEMENT.set(key, dom);
	    NODE_TO_ELEMENT.set(elemNode, dom);
	    ELEMENT_TO_NODE.set(dom, elemNode);
	  });
	  return vnode;
	}

	function str(text) {
	  var isTrailing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  return h('span', {
	    'data-slate-string': true
	  }, isTrailing ? text + '\n' : text);
	}
	function zeroWidthStr() {
	  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var isLineBreak = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  return h('span', {
	    'data-slate-zero-width': isLineBreak ? 'n' : 'z',
	    'data-slate-length': length
	  }, ["\uFEFF", isLineBreak ? h('br') : '']);
	}
	function genTextVnode(leafNode) {
	  var isLast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var textNode = arguments.length > 2 ? arguments[2] : undefined;
	  var parent = arguments.length > 3 ? arguments[3] : undefined;
	  var editor = arguments.length > 4 ? arguments[4] : undefined;
	  var text = leafNode.text;
	  var path = DomEditor.findPath(editor, textNode);
	  var parentPath = Path.parent(path);
	  if (Editor.isEditor(parent)) {
	    throw new Error("Text node ".concat(_JSON$stringify(textNode), " parent is Editor"));
	  }

	  // COMPAT: Render text inside void nodes with a zero-width space.
	  // So the node can contain selection but the text is not visible.
	  if (editor.isVoid(parent)) {
	    return zeroWidthStr(Node.string(parent).length);
	  }

	  // COMPAT: If this is the last text node in an empty block, render a zero-
	  // width space that will convert into a line break when copying and pasting
	  // to support expected plain text.
	  if (text === '' && parent.children[parent.children.length - 1] === textNode && !editor.isInline(parent) && Editor.string(editor, parentPath) === '') {
	    return zeroWidthStr(0, true);
	  }

	  // COMPAT: If the text is empty, it's because it's on the edge of an inline
	  // node, so we render a zero-width space so that the selection can be
	  // inserted next to it still.
	  if (text === '') {
	    return zeroWidthStr();
	  }

	  // COMPAT: Browsers will collapse trailing new lines at the end of blocks,
	  // so we need to add an extra trailing new lines to prevent that.
	  if (isLast && _sliceInstanceProperty(text).call(text, -1) === '\n') {
	    return str(text, true);
	  }
	  return str(text);
	}

	/**
	 * 给字符串增加样式
	 * @param leafNode slate text leaf node
	 * @param textVnode textVnode
	 */
	function addTextVnodeStyle(leafNode, textVnode) {
	  var newTextVnode = textVnode;
	  _forEachInstanceProperty(RENDER_STYLE_HANDLER_LIST).call(RENDER_STYLE_HANDLER_LIST, function (styleHandler) {
	    newTextVnode = styleHandler(leafNode, newTextVnode);
	  });
	  return newTextVnode;
	}

	function renderText(textNode, parent, editor) {
	  if (textNode.text == null) throw new Error("Current node is not slate Text ".concat(_JSON$stringify(textNode)));
	  var key = DomEditor.findKey(editor, textNode);

	  // 根据 decorate 将 text 拆分为多个叶子节点 text[]
	  var _editor$getConfig = editor.getConfig(),
	    decorate = _editor$getConfig.decorate;
	  if (decorate == null) throw new Error("Can not get config.decorate");
	  var path = DomEditor.findPath(editor, textNode);
	  var ds = decorate([textNode, path]);
	  var leaves = Text.decorations(textNode, ds);
	  // 生成 leaves vnode
	  var leavesVnode = _mapInstanceProperty(leaves).call(leaves, function (leafNode, index) {
	    // 文字和样式
	    var isLast = index === leaves.length - 1;
	    var strVnode = genTextVnode(leafNode, isLast, textNode, parent, editor);
	    strVnode = addTextVnodeStyle(leafNode, strVnode);
	    // 生成每一个 leaf 节点
	    return h('span', {
	      attrs: {
	        'data-slate-leaf': true,
	        style: 'padding-left: 0.1px'
	      }
	    }, strVnode);
	  });
	  // 生成 text vnode
	  var textId = genTextId(key.id);
	  var vnode = h('span', {
	    'data-slate-node': 'text',
	    id: textId,
	    key: key.id
	  }, /* 一个 text 可能包含多个 leaf */
	  leavesVnode);

	  // 更新 weak-map
	  promiseResolveThen(function () {
	    // 异步，否则拿不到 DOM
	    var dom = getElementById(textId);
	    if (dom == null) return;
	    KEY_TO_ELEMENT.set(key, dom);
	    NODE_TO_ELEMENT.set(textNode, dom);
	    ELEMENT_TO_NODE.set(dom, textNode);
	  });
	  return vnode;
	}

	/**
	 * 根据 slate node 生成 snabbdom vnode
	 * @param node node
	 * @param index node index in parent.children
	 * @param parent parent node
	 * @param editor editor
	 */
	function node2Vnode(node, index, parent, editor) {
	  // 设置相关 weakMap 信息
	  NODE_TO_INDEX.set(node, index);
	  NODE_TO_PARENT.set(node, parent);
	  var vnode;
	  if (Element.isElement(node)) {
	    // element
	    vnode = renderElement(node, editor);
	  } else {
	    // text
	    vnode = renderText(node, parent, editor);
	  }
	  return vnode;
	}

	var $$f = _export$1;
	var uncurryThis$4 = functionUncurryThisClause$1;
	var toLength$1 = toLength$8;
	var toString$7 = toString$r;
	var notARegExp = notARegexp;
	var requireObjectCoercible$2 = requireObjectCoercible$g;
	var correctIsRegExpLogic = correctIsRegexpLogic;

	// eslint-disable-next-line es/no-string-prototype-startswith -- safe
	var nativeStartsWith = uncurryThis$4(''.startsWith);
	var stringSlice$1 = uncurryThis$4(''.slice);
	var min = Math.min;

	var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');

	// `String.prototype.startsWith` method
	// https://tc39.es/ecma262/#sec-string.prototype.startswith
	$$f({ target: 'String', proto: true, forced: !CORRECT_IS_REGEXP_LOGIC }, {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = toString$7(requireObjectCoercible$2(this));
	    notARegExp(searchString);
	    var index = toLength$1(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = toString$7(searchString);
	    return nativeStartsWith
	      ? nativeStartsWith(that, search, index)
	      : stringSlice$1(that, index, index + search.length) === search;
	  }
	});

	var getBuiltInPrototypeMethod$3 = getBuiltInPrototypeMethod$g;

	var startsWith$3 = getBuiltInPrototypeMethod$3('String', 'startsWith');

	var isPrototypeOf$3 = objectIsPrototypeOf$1;
	var method$3 = startsWith$3;

	var StringPrototype = String.prototype;

	var startsWith$2 = function (it) {
	  var own = it.startsWith;
	  return typeof it == 'string' || it === StringPrototype
	    || (isPrototypeOf$3(StringPrototype, it) && own === StringPrototype.startsWith) ? method$3 : own;
	};

	var parent$n = startsWith$2;

	var startsWith$1 = parent$n;

	var startsWith = startsWith$1;

	var _startsWithInstanceProperty = /*@__PURE__*/getDefaultExportFromCjs(startsWith);

	var baseGetTag = _baseGetTag,
	    isObjectLike = isObjectLike_1;

	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';

	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol$2(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}

	var isSymbol_1 = isSymbol$2;

	var Symbol$1 = _Symbol,
	    arrayMap = _arrayMap,
	    isArray$2 = isArray_1,
	    isSymbol$1 = isSymbol_1;

	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;

	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;

	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString$1(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray$2(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString$1) + '';
	  }
	  if (isSymbol$1(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}

	var _baseToString = baseToString$1;

	var baseToString = _baseToString;

	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString$6(value) {
	  return value == null ? '' : baseToString(value);
	}

	var toString_1 = toString$6;

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */

	function baseSlice$1(array, start, end) {
	  var index = -1,
	      length = array.length;

	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;

	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}

	var _baseSlice = baseSlice$1;

	var baseSlice = _baseSlice;

	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice$1(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}

	var _castSlice = castSlice$1;

	var castSlice = _castSlice,
	    hasUnicode = _hasUnicode,
	    stringToArray = _stringToArray,
	    toString$5 = toString_1;

	/**
	 * Creates a function like `_.lowerFirst`.
	 *
	 * @private
	 * @param {string} methodName The name of the `String` case method to use.
	 * @returns {Function} Returns the new case function.
	 */
	function createCaseFirst$1(methodName) {
	  return function(string) {
	    string = toString$5(string);

	    var strSymbols = hasUnicode(string)
	      ? stringToArray(string)
	      : undefined;

	    var chr = strSymbols
	      ? strSymbols[0]
	      : string.charAt(0);

	    var trailing = strSymbols
	      ? castSlice(strSymbols, 1).join('')
	      : string.slice(1);

	    return chr[methodName]() + trailing;
	  };
	}

	var _createCaseFirst = createCaseFirst$1;

	var createCaseFirst = _createCaseFirst;

	/**
	 * Converts the first character of `string` to upper case.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.upperFirst('fred');
	 * // => 'Fred'
	 *
	 * _.upperFirst('FRED');
	 * // => 'FRED'
	 */
	var upperFirst$1 = createCaseFirst('toUpperCase');

	var upperFirst_1 = upperFirst$1;

	var toString$4 = toString_1,
	    upperFirst = upperFirst_1;

	/**
	 * Converts the first character of `string` to upper case and the remaining
	 * to lower case.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to capitalize.
	 * @returns {string} Returns the capitalized string.
	 * @example
	 *
	 * _.capitalize('FRED');
	 * // => 'Fred'
	 */
	function capitalize$1(string) {
	  return upperFirst(toString$4(string).toLowerCase());
	}

	var capitalize_1 = capitalize$1;

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */

	function arrayReduce$1(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;

	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}

	var _arrayReduce = arrayReduce$1;

	/**
	 * The base implementation of `_.propertyOf` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Function} Returns the new accessor function.
	 */

	function basePropertyOf$1(object) {
	  return function(key) {
	    return object == null ? undefined : object[key];
	  };
	}

	var _basePropertyOf = basePropertyOf$1;

	var basePropertyOf = _basePropertyOf;

	/** Used to map Latin Unicode letters to basic Latin letters. */
	var deburredLetters = {
	  // Latin-1 Supplement block.
	  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	  '\xc7': 'C',  '\xe7': 'c',
	  '\xd0': 'D',  '\xf0': 'd',
	  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	  '\xd1': 'N',  '\xf1': 'n',
	  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	  '\xc6': 'Ae', '\xe6': 'ae',
	  '\xde': 'Th', '\xfe': 'th',
	  '\xdf': 'ss',
	  // Latin Extended-A block.
	  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	  '\u0134': 'J',  '\u0135': 'j',
	  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	  '\u0174': 'W',  '\u0175': 'w',
	  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	  '\u0132': 'IJ', '\u0133': 'ij',
	  '\u0152': 'Oe', '\u0153': 'oe',
	  '\u0149': "'n", '\u017f': 's'
	};

	/**
	 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	 * letters to basic Latin letters.
	 *
	 * @private
	 * @param {string} letter The matched letter to deburr.
	 * @returns {string} Returns the deburred letter.
	 */
	var deburrLetter$1 = basePropertyOf(deburredLetters);

	var _deburrLetter = deburrLetter$1;

	var deburrLetter = _deburrLetter,
	    toString$3 = toString_1;

	/** Used to match Latin Unicode letters (excluding mathematical operators). */
	var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

	/** Used to compose unicode character classes. */
	var rsComboMarksRange$1 = '\\u0300-\\u036f',
	    reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange$1 = '\\u20d0-\\u20ff',
	    rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1;

	/** Used to compose unicode capture groups. */
	var rsCombo$1 = '[' + rsComboRange$1 + ']';

	/**
	 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	 */
	var reComboMark = RegExp(rsCombo$1, 'g');

	/**
	 * Deburrs `string` by converting
	 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	 * letters to basic Latin letters and removing
	 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to deburr.
	 * @returns {string} Returns the deburred string.
	 * @example
	 *
	 * _.deburr('déjà vu');
	 * // => 'deja vu'
	 */
	function deburr$1(string) {
	  string = toString$3(string);
	  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	}

	var deburr_1 = deburr$1;

	/** Used to match words composed of alphanumeric characters. */

	var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

	/**
	 * Splits an ASCII `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function asciiWords$1(string) {
	  return string.match(reAsciiWord) || [];
	}

	var _asciiWords = asciiWords$1;

	/** Used to detect strings that need a more robust regexp to match words. */

	var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

	/**
	 * Checks if `string` contains a word composed of Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a word is found, else `false`.
	 */
	function hasUnicodeWord$1(string) {
	  return reHasUnicodeWord.test(string);
	}

	var _hasUnicodeWord = hasUnicodeWord$1;

	/** Used to compose unicode character classes. */

	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsDingbatRange = '\\u2700-\\u27bf',
	    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	    rsPunctuationRange = '\\u2000-\\u206f',
	    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	    rsVarRange = '\\ufe0e\\ufe0f',
	    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

	/** Used to compose unicode capture groups. */
	var rsApos$1 = "['\u2019]",
	    rsBreak = '[' + rsBreakRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsDigits = '\\d+',
	    rsDingbat = '[' + rsDingbatRange + ']',
	    rsLower = '[' + rsLowerRange + ']',
	    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsUpper = '[' + rsUpperRange + ']',
	    rsZWJ = '\\u200d';

	/** Used to compose unicode regexes. */
	var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	    rsOptContrLower = '(?:' + rsApos$1 + '(?:d|ll|m|re|s|t|ve))?',
	    rsOptContrUpper = '(?:' + rsApos$1 + '(?:D|LL|M|RE|S|T|VE))?',
	    reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

	/** Used to match complex or compound words. */
	var reUnicodeWord = RegExp([
	  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	  rsUpper + '+' + rsOptContrUpper,
	  rsOrdUpper,
	  rsOrdLower,
	  rsDigits,
	  rsEmoji
	].join('|'), 'g');

	/**
	 * Splits a Unicode `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function unicodeWords$1(string) {
	  return string.match(reUnicodeWord) || [];
	}

	var _unicodeWords = unicodeWords$1;

	var asciiWords = _asciiWords,
	    hasUnicodeWord = _hasUnicodeWord,
	    toString$2 = toString_1,
	    unicodeWords = _unicodeWords;

	/**
	 * Splits `string` into an array of its words.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {RegExp|string} [pattern] The pattern to match words.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the words of `string`.
	 * @example
	 *
	 * _.words('fred, barney, & pebbles');
	 * // => ['fred', 'barney', 'pebbles']
	 *
	 * _.words('fred, barney, & pebbles', /[^, ]+/g);
	 * // => ['fred', 'barney', '&', 'pebbles']
	 */
	function words$1(string, pattern, guard) {
	  string = toString$2(string);
	  pattern = guard ? undefined : pattern;

	  if (pattern === undefined) {
	    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	  }
	  return string.match(pattern) || [];
	}

	var words_1 = words$1;

	var arrayReduce = _arrayReduce,
	    deburr = deburr_1,
	    words = words_1;

	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]";

	/** Used to match apostrophes. */
	var reApos = RegExp(rsApos, 'g');

	/**
	 * Creates a function like `_.camelCase`.
	 *
	 * @private
	 * @param {Function} callback The function to combine each word.
	 * @returns {Function} Returns the new compounder function.
	 */
	function createCompounder$1(callback) {
	  return function(string) {
	    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	  };
	}

	var _createCompounder = createCompounder$1;

	var capitalize = capitalize_1,
	    createCompounder = _createCompounder;

	/**
	 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the camel cased string.
	 * @example
	 *
	 * _.camelCase('Foo Bar');
	 * // => 'fooBar'
	 *
	 * _.camelCase('--foo-bar--');
	 * // => 'fooBar'
	 *
	 * _.camelCase('__FOO_BAR__');
	 * // => 'fooBar'
	 */
	var camelCase = createCompounder(function(result, word, index) {
	  word = word.toLowerCase();
	  return result + (index ? capitalize(word) : word);
	});

	var camelCase_1 = camelCase;

	var camelCase$1 = /*@__PURE__*/getDefaultExportFromCjs(camelCase_1);

	/**
	 * 创建 snabbdom patch
	 * @returns snabbdom patch 函数
	 */
	function genPatchFn() {
	  var patch = init([
	  // Init patch function with chosen modules
	  classModule,
	  // makes it easy to toggle classes
	  propsModule,
	  // for setting properties on DOM elements
	  styleModule,
	  // handles styling on elements with support for animations
	  datasetModule, eventListenersModule,
	  // attaches event listeners
	  attributesModule]);
	  return patch;
	}

	// vnode.data 保留属性，参考 snabbdom VNodeData
	var DATA_PRESERVE_KEYS = ['props', 'attrs', 'style', 'dataset', 'on', 'hook'];

	/**
	 * 整理 vnode.data ，将暴露出来的零散属性（如 id className data-xxx）放在 data.props 或 data.dataset
	 * @param vnode vnode
	 */
	function normalizeVnodeData(vnode) {
	  var _vnode$data = vnode.data,
	    data = _vnode$data === void 0 ? {} : _vnode$data,
	    _vnode$children = vnode.children,
	    children = _vnode$children === void 0 ? [] : _vnode$children;
	  var dataKeys = _Object$keys(data);
	  _forEachInstanceProperty(dataKeys).call(dataKeys, function (key) {
	    var value = data[key];

	    // 赋值 key
	    if (key === 'key') {
	      vnode.key = value;
	      return;
	    }

	    // 忽略 data 保留属性
	    if (_includesInstanceProperty(DATA_PRESERVE_KEYS).call(DATA_PRESERVE_KEYS, key)) return;

	    // dataset
	    if (_startsWithInstanceProperty(key).call(key, 'data-')) {
	      var datasetKey = _sliceInstanceProperty(key).call(key, 5); // 截取掉最前面的 'data-'
	      datasetKey = camelCase$1(datasetKey); // 转为驼峰写法

	      // 存储到 data.dataset
	      addVnodeDataset(vnode, _defineProperty$1({}, datasetKey, value));
	      delete data[key]; // 删掉原有的属性
	      return;
	    }

	    // 其他的，都算 props ，存储到 props
	    addVnodeProp(vnode, _defineProperty$1({}, key, value));
	    delete data[key]; // 删掉原有的属性
	  });

	  // 遍历 children
	  if (children.length > 0) {
	    _forEachInstanceProperty(children).call(children, function (child) {
	      if (typeof child === 'string') return;
	      normalizeVnodeData(child);
	    });
	  }
	}

	/**
	 * 给 vnode 添加 prop
	 * @param vnode vnode
	 * @param newProp { key: val }
	 */
	function addVnodeProp(vnode, newProp) {
	  if (vnode.data == null) vnode.data = {};
	  var data = vnode.data;
	  if (data.props == null) data.props = {};
	  _Object$assign(data.props, newProp);
	}

	/**
	 * 给 vnode 添加 dataset
	 * @param vnode vnode
	 * @param newDataset { key: val }
	 */
	function addVnodeDataset(vnode, newDataset) {
	  if (vnode.data == null) vnode.data = {};
	  var data = vnode.data;
	  if (data.dataset == null) data.dataset = {};
	  _Object$assign(data.dataset, newDataset);
	}

	/**
	 * 给 vnode 添加样式
	 * @param vnode vnode
	 * @param newStyle { key: val }
	 */
	function addVnodeStyle(vnode, newStyle) {
	  if (vnode.data == null) vnode.data = {};
	  var data = vnode.data;
	  if (data.style == null) data.style = {};
	  _Object$assign(data.style, newStyle);
	}

	/**
	 * 生成编辑区域节点的 vnode
	 * @param elemId elemId
	 * @param readOnly readOnly
	 */
	function genRootVnode(elemId) {
	  var readOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  return h("div#".concat(elemId), {
	    props: {
	      contentEditable: readOnly ? false : true
	    }
	  });
	  // 其他属性在 genRootElem 中定，这里不用重复写
	}

	function genRootElem(elemId) {
	  var $elem = $$x("<div\n        id=\"".concat(elemId, "\"\n        data-slate-editor\n        data-slate-node=\"value\"\n        suppressContentEditableWarning\n        role=\"textarea\"\n        spellCheck=\"true\"\n        autoCorrect=\"true\"\n        autoCapitalize=\"true\"\n    ></div>"));

	  // role="textarea" - 增强语义，div 语义太弱

	  return $elem;
	}
	function updateView(editable, editor) {
	  var $scroll = editable.$scroll;
	  var elemId = "s-e-editable-".concat(editable.id);
	  var _editor$getConfig = editor.getConfig();
	    _editor$getConfig.readOnly;
	    var autoFocus = _editor$getConfig.autoFocus;
	  // 生成 newVnode
	  var newVnode = genRootVnode(elemId, false);
	  var content = editor.children || [];
	  newVnode.children = _mapInstanceProperty(content).call(content, function (node, i) {
	    var vnode = node2Vnode(node, i, editor, editor);
	    normalizeVnodeData(vnode); // 整理 vnode.data 以符合 snabbdom 的要求
	    return vnode;
	  });
	  var textareaElem;
	  var isFirstPatch = IS_FIRST_PATCH.get(editable);
	  if (isFirstPatch == null) isFirstPatch = true;
	  if (isFirstPatch) {
	    var $editable = genRootElem(elemId);
	    $scroll.append($editable);
	    editable.$editable = $editable;
	    textareaElem = $editable[0];
	    // 再生成 patch 函数，并执行
	    var patchFn = genPatchFn();
	    patchFn(textareaElem, newVnode);

	    // 存储相关信息
	    IS_FIRST_PATCH.set(editable, false); // 不再是第一次 patch
	    TEXTAREA_TO_PATCH_FN.set(editable, patchFn); // 存储 patch 函数
	  } else {
	    // 不是第一次 patch
	    var curVnode = TEXTAREA_TO_VNODE.get(editable);
	    var _patchFn = TEXTAREA_TO_PATCH_FN.get(editable);
	    if (curVnode == null || _patchFn == null) return;
	    textareaElem = curVnode.elm;
	    _patchFn(curVnode, newVnode);
	  }
	  if (textareaElem == null) {
	    textareaElem = document.getElementById(elemId);

	    // 通过 getElementById 获取的有可能是 null （销毁、重建时，可能会发生这种情况）
	    if (textareaElem == null) return;
	  }

	  // focus
	  var isFocused;
	  if (isFirstPatch) {
	    // 初次渲染
	    isFocused = autoFocus;
	  } else {
	    // 非初次渲染
	    isFocused = editor.isFocused();
	  }
	  if (isFocused) {
	    textareaElem.focus({
	      preventScroll: true // 必须添加 preventScroll 选项，否则弹窗或者编辑器失焦会导致编辑区域自动滚动到顶部
	    });
	  }

	  // 存储相关信息
	  if (isFirstPatch) {
	    var window = getDefaultView(textareaElem);
	    window && EDITOR_TO_WINDOW.set(editor, window);
	  }
	  EDITOR_TO_ELEMENT.set(editor, textareaElem); // 存储 editor -> elem 对应关系
	  NODE_TO_ELEMENT.set(editor, textareaElem);
	  ELEMENT_TO_NODE.set(textareaElem, editor);
	  TEXTAREA_TO_VNODE.set(editable, newVnode); // 存储 vnode
	}

	/**
	 * Check if the target is editable and in the editor.
	 */
	function hasEditableTarget(editor, target) {
	  return isDOMNode(target) && DomEditor.hasDOMNode(editor, target, {
	    editable: true
	  });
	}

	/**
	 * Check if the target is inside void and in an non-readonly editor.
	 */
	function isTargetInsideNonReadonlyVoid(editor, target) {
	  var _editor$getConfig = editor.getConfig(),
	    readOnly = _editor$getConfig.readOnly;
	  if (readOnly) return false;
	  var slateNode = hasTarget(editor, target) && DomEditor.toSlateNode(editor, target);
	  return Editor.isVoid(editor, slateNode);
	}

	/**
	 * Check if the target is in the editor.
	 */
	function hasTarget(editor, target) {
	  return isDOMNode(target) && DomEditor.hasDOMNode(editor, target);
	}

	function handleBeforeInput(e, editable, editor) {
	  var event = e;
	  var _editor$getConfig = editor.getConfig(),
	    readOnly = _editor$getConfig.readOnly;
	  if (!HAS_BEFORE_INPUT_SUPPORT) return; // 有些浏览器完全不支持 beforeInput ，会用 keypress 和 keydown 兼容
	  if (readOnly) return;
	  if (!hasEditableTarget(editor, event.target)) return;
	  var selection = editor.selection;
	  var type = event.inputType;
	  var data = event.dataTransfer || event.data || undefined;

	  // These two types occur while a user is composing text and can't be
	  // cancelled. Let them through and wait for the composition to end.
	  if (type === 'insertCompositionText' || type === 'deleteCompositionText') {
	    return;
	  }

	  // 阻止默认行为，劫持所有的富文本输入
	  event.preventDefault();
	  // COMPAT: For the deleting forward/backward input types we don't want
	  // to change the selection because it is the range that will be deleted,
	  // and those commands determine that for themselves.
	  if (!_startsWithInstanceProperty(type).call(type, 'delete') || _startsWithInstanceProperty(type).call(type, 'deleteBy')) {
	    var _event$getTargetRange = event.getTargetRanges(),
	      _event$getTargetRange2 = _slicedToArray(_event$getTargetRange, 1),
	      targetRange = _event$getTargetRange2[0];
	    if (targetRange) {
	      var range = DomEditor.toSlateRange(editor, targetRange, {
	        exactMatch: false,
	        suppressThrow: false
	      });
	      if (!selection || !Range.equals(selection, range)) {
	        Transforms.select(editor, range);
	      }
	    }
	  }

	  // COMPAT: If the selection is expanded, even if the command seems like
	  // a delete forward/backward command it should delete the selection.
	  if (selection && Range.isExpanded(selection) && _startsWithInstanceProperty(type).call(type, 'delete')) {
	    var direction = _endsWithInstanceProperty(type).call(type, 'Backward') ? 'backward' : 'forward';
	    Editor.deleteFragment(editor, {
	      direction: direction
	    });
	    return;
	  }

	  // 根据 beforeInput 的 event.inputType
	  switch (type) {
	    case 'deleteByComposition':
	    case 'deleteByCut':
	    case 'deleteByDrag':
	      {
	        Editor.deleteFragment(editor);
	        break;
	      }
	    case 'deleteContent':
	    case 'deleteContentForward':
	      {
	        Editor.deleteForward(editor);
	        break;
	      }
	    case 'deleteContentBackward':
	      {
	        Editor.deleteBackward(editor);
	        break;
	      }
	    case 'deleteEntireSoftLine':
	      {
	        Editor.deleteBackward(editor, {
	          unit: 'line'
	        });
	        Editor.deleteForward(editor, {
	          unit: 'line'
	        });
	        break;
	      }
	    case 'deleteHardLineBackward':
	      {
	        Editor.deleteBackward(editor, {
	          unit: 'block'
	        });
	        break;
	      }
	    case 'deleteSoftLineBackward':
	      {
	        Editor.deleteBackward(editor, {
	          unit: 'line'
	        });
	        break;
	      }
	    case 'deleteHardLineForward':
	      {
	        Editor.deleteForward(editor, {
	          unit: 'block'
	        });
	        break;
	      }
	    case 'deleteSoftLineForward':
	      {
	        Editor.deleteForward(editor, {
	          unit: 'line'
	        });
	        break;
	      }
	    case 'deleteWordBackward':
	      {
	        Editor.deleteBackward(editor, {
	          unit: 'word'
	        });
	        break;
	      }
	    case 'deleteWordForward':
	      {
	        Editor.deleteForward(editor, {
	          unit: 'word'
	        });
	        break;
	      }
	    case 'insertLineBreak':
	    case 'insertParagraph':
	      {
	        Editor.insertBreak(editor);
	        break;
	      }
	    case 'insertFromDrop':
	    case 'insertFromPaste':
	    case 'insertFromYank':
	    case 'insertReplacementText':
	    case 'insertText':
	      {
	        if (type === 'insertFromPaste') {
	          if (!EDITOR_TO_CAN_PASTE.get(editor)) break; // 不可默认粘贴
	        }

	        if (data instanceof DataTransfer) {
	          // 这里处理非纯文本（如 html 图片文件等）的粘贴。对于纯文本的粘贴，使用 paste 事件
	          editor.insertData(data);
	        } else if (typeof data === 'string') {
	          Editor.insertText(editor, data);
	        }
	        break;
	      }
	  }
	}

	function handleOnBlur(e, editable, editor) {
	  var event = e;
	  var isUpdatingSelection = editable.isUpdatingSelection,
	    latestElement = editable.latestElement;
	  var _editor$getConfig = editor.getConfig(),
	    readOnly = _editor$getConfig.readOnly;
	  if (readOnly) return;
	  if (isUpdatingSelection) return;
	  if (!hasEditableTarget(editor, event.target)) return;
	  var root = DomEditor.findDocumentOrShadowRoot(editor);

	  // COMPAT: If the current `activeElement` is still the previous
	  // one, this is due to the window being blurred when the tab
	  // itself becomes unfocused, so we want to abort early to allow to
	  // editor to stay focused when the tab becomes focused again.
	  if (latestElement === root.activeElement) return;

	  // relatedTarget 即 blur 之后又 focus 到了哪个元素，如果没有则是 null
	  var relatedTarget = event.relatedTarget;
	  var el = DomEditor.toDOMNode(editor, editor);

	  // COMPAT: The event should be ignored if the focus is returning
	  // to the editor from an embedded editable element (eg. an <input>
	  // element inside a void node).
	  if (relatedTarget === el) {
	    return;
	  }

	  // COMPAT: The event should be ignored if the focus is moving from
	  // the editor to inside a void node's spacer element.
	  if (isDOMElement(relatedTarget) && relatedTarget.hasAttribute('data-slate-spacer')) {
	    return;
	  }

	  // COMPAT: The event should be ignored if the focus is moving to a
	  // non- editable section of an element that isn't a void node (eg.
	  // a list item of the check list example).
	  if (relatedTarget != null && isDOMNode(relatedTarget) && DomEditor.hasDOMNode(editor, relatedTarget)) {
	    var node = DomEditor.toSlateNode(editor, relatedTarget);
	    if (Element.isElement(node) && !editor.isVoid(node)) {
	      return;
	    }
	  }

	  // COMPAT: Safari doesn't always remove the selection even if the content-
	  // editable element no longer has focus. Refer to:
	  // https://stackoverflow.com/questions/12353247/force-contenteditable-div-to-stop-accepting-input-after-it-loses-focus-under-web
	  // 修复在 Safari 下，即使 contenteditable 元素非聚焦状态，并不会删除所选内容
	  if (IS_SAFARI) {
	    var domSelection = root.getSelection();
	    domSelection === null || domSelection === void 0 || domSelection.removeAllRanges();
	  }

	  // 检验完毕，可正式触发 onblur
	  IS_FOCUSED.delete(editor);
	}

	function handleOnFocus(event, textarea, editor) {
	  var el = DomEditor.toDOMNode(editor, editor);
	  var root = DomEditor.findDocumentOrShadowRoot(editor);
	  textarea.latestElement = root.activeElement;

	  // COMPAT: If the editor has nested editable elements, the focus
	  // can go to them. In Firefox, this must be prevented because it
	  // results in issues with keyboard navigation. (2017/03/30)
	  if (IS_FIREFOX && event.target !== el) {
	    el.focus();
	    return;
	  }
	  IS_FOCUSED.set(editor, true);
	}

	function handleOnClick(event, textarea, editor) {
	  var _editor$getConfig = editor.getConfig(),
	    readOnly = _editor$getConfig.readOnly;
	  if (readOnly) return;
	  if (!hasTarget(editor, event.target)) return;
	  if (!isDOMNode(event.target)) return;
	  var node = DomEditor.toSlateNode(editor, event.target);
	  var path = DomEditor.findPath(editor, node);

	  // At this time, the Slate document may be arbitrarily different,
	  // because onClick handlers can change the document before we get here.
	  // Therefore we must check that this path actually exists,
	  // and that it still refers to the same node.
	  if (Editor.hasPath(editor, path)) {
	    var lookupNode = Node.get(editor, path);
	    if (lookupNode === node) {
	      var start = Editor.start(editor, path);
	      var end = Editor.end(editor, path);
	      var startVoid = Editor.void(editor, {
	        at: start
	      });
	      var endVoid = Editor.void(editor, {
	        at: end
	      });
	      if (startVoid && endVoid && Path.equals(startVoid[1], endVoid[1])) {
	        var range = Editor.range(editor, start);
	        Transforms.select(editor, range);
	      }
	    }
	  }
	}

	const t=t=>"object"==typeof t&&null!=t&&1===t.nodeType,e$1=(t,e)=>(!e||"hidden"!==t)&&("visible"!==t&&"clip"!==t),n=(t,n)=>{if(t.clientHeight<t.scrollHeight||t.clientWidth<t.scrollWidth){const o=getComputedStyle(t,null);return e$1(o.overflowY,n)||e$1(o.overflowX,n)||(t=>{const e=(t=>{if(!t.ownerDocument||!t.ownerDocument.defaultView)return null;try{return t.ownerDocument.defaultView.frameElement}catch(t){return null}})(t);return !!e&&(e.clientHeight<t.scrollHeight||e.clientWidth<t.scrollWidth)})(t)}return !1},o$1=(t,e,n,o,l,r,i,s)=>r<t&&i>e||r>t&&i<e?0:r<=t&&s<=n||i>=e&&s>=n?r-t-o:i>e&&s<n||r<t&&s>n?i-e+l:0,l=t=>{const e=t.parentElement;return null==e?t.getRootNode().host||null:e},r=(e,r)=>{var i,s,d,h;if("undefined"==typeof document)return [];const{scrollMode:c,block:f,inline:u,boundary:a,skipOverflowHiddenElements:g}=r,p="function"==typeof a?a:t=>t!==a;if(!t(e))throw new TypeError("Invalid target");const m=document.scrollingElement||document.documentElement,w=[];let W=e;for(;t(W)&&p(W);){if(W=l(W),W===m){w.push(W);break}null!=W&&W===document.body&&n(W)&&!n(document.documentElement)||null!=W&&n(W,g)&&w.push(W);}const b=null!=(s=null==(i=window.visualViewport)?void 0:i.width)?s:innerWidth,H=null!=(h=null==(d=window.visualViewport)?void 0:d.height)?h:innerHeight,{scrollX:y,scrollY:M}=window,{height:v,width:E,top:x,right:C,bottom:I,left:R}=e.getBoundingClientRect(),{top:T,right:B,bottom:F,left:V}=(t=>{const e=window.getComputedStyle(t);return {top:parseFloat(e.scrollMarginTop)||0,right:parseFloat(e.scrollMarginRight)||0,bottom:parseFloat(e.scrollMarginBottom)||0,left:parseFloat(e.scrollMarginLeft)||0}})(e);let k="start"===f||"nearest"===f?x-T:"end"===f?I+F:x+v/2-T+F,D="center"===u?R+E/2-V+B:"end"===u?C+B:R-V;const L=[];for(let t=0;t<w.length;t++){const e=w[t],{height:n,width:l,top:r,right:i,bottom:s,left:d}=e.getBoundingClientRect();if("if-needed"===c&&x>=0&&R>=0&&I<=H&&C<=b&&x>=r&&I<=s&&R>=d&&C<=i)return L;const h=getComputedStyle(e),a=parseInt(h.borderLeftWidth,10),g=parseInt(h.borderTopWidth,10),p=parseInt(h.borderRightWidth,10),W=parseInt(h.borderBottomWidth,10);let T=0,B=0;const F="offsetWidth"in e?e.offsetWidth-e.clientWidth-a-p:0,V="offsetHeight"in e?e.offsetHeight-e.clientHeight-g-W:0,S="offsetWidth"in e?0===e.offsetWidth?0:l/e.offsetWidth:0,X="offsetHeight"in e?0===e.offsetHeight?0:n/e.offsetHeight:0;if(m===e)T="start"===f?k:"end"===f?k-H:"nearest"===f?o$1(M,M+H,H,g,W,M+k,M+k+v,v):k-H/2,B="start"===u?D:"center"===u?D-b/2:"end"===u?D-b:o$1(y,y+b,b,a,p,y+D,y+D+E,E),T=Math.max(0,T+M),B=Math.max(0,B+y);else {T="start"===f?k-r-g:"end"===f?k-s+W+V:"nearest"===f?o$1(r,s,n,g,W+V,k,k+v,v):k-(r+n/2)+V/2,B="start"===u?D-d-a:"center"===u?D-(d+l/2)+F/2:"end"===u?D-i+p+F:o$1(d,i,l,a,p+F,D,D+E,E);const{scrollLeft:t,scrollTop:h}=e;T=0===X?0:Math.max(0,Math.min(h+T/X,e.scrollHeight-n/X+V)),B=0===S?0:Math.max(0,Math.min(t+B/S,e.scrollWidth-l/S+F)),k+=h-T,D+=t-B;}L.push({el:e,top:T,left:B});}return L};

	const o=t=>!1===t?{block:"end",inline:"nearest"}:(t=>t===Object(t)&&0!==Object.keys(t).length)(t)?t:{block:"start",inline:"nearest"};function e(e,r$1){if(!e.isConnected||!(t=>{let o=t;for(;o&&o.parentNode;){if(o.parentNode===document)return !0;o=o.parentNode instanceof ShadowRoot?o.parentNode.host:o.parentNode;}return !1})(e))return;const n=(t=>{const o=window.getComputedStyle(t);return {top:parseFloat(o.scrollMarginTop)||0,right:parseFloat(o.scrollMarginRight)||0,bottom:parseFloat(o.scrollMarginBottom)||0,left:parseFloat(o.scrollMarginLeft)||0}})(e);if((t=>"object"==typeof t&&"function"==typeof t.behavior)(r$1))return r$1.behavior(r(e,r$1));const l="boolean"==typeof r$1||null==r$1?void 0:r$1.behavior;for(const{el:a,top:i,left:s}of r(e,o(r$1))){const t=i-n.top+n.bottom,o=s-n.left+n.right;a.scroll({top:t,left:o,behavior:l});}}

	/**
	 * editor onchange 时，将 editor selection 同步给 DOM
	 * @param textarea textarea
	 * @param editor editor
	 * @param focus 是否强制更新选区
	 */
	function editorSelectionToDOM(textarea, editor) {
	  var focus = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	  var selection = editor.selection;
	  var config = editor.getConfig();
	  var root = DomEditor.findDocumentOrShadowRoot(editor);
	  var domSelection = root.getSelection();
	  if (!domSelection) return;
	  if (textarea.isComposing && !focus) return;
	  if (!editor.isFocused()) return;
	  var hasDomSelection = domSelection.type !== 'None';

	  // If the DOM selection is properly unset, we're done.
	  if (!selection && !hasDomSelection) return;

	  // verify that the dom selection is in the editor
	  var editorElement = EDITOR_TO_ELEMENT.get(editor);
	  var hasDomSelectionInEditor = false;
	  if (editorElement.contains(domSelection.anchorNode) && editorElement.contains(domSelection.focusNode)) {
	    hasDomSelectionInEditor = true;
	  }

	  // If the DOM selection is in the editor and the editor selection is already correct, we're done.
	  if (hasDomSelection && hasDomSelectionInEditor && selection) {
	    var slateRange = DomEditor.toSlateRange(editor, domSelection, {
	      exactMatch: true,
	      // domSelection is not necessarily a valid Slate range
	      // (e.g. when clicking on contentEditable:false element)
	      suppressThrow: true
	    });
	    if (slateRange && Range.equals(slateRange, selection)) {
	      var canReturn = true;

	      // 选区在 table 时，需要特殊处理
	      if (Range.isCollapsed(selection)) {
	        var anchorNode = domSelection.anchorNode,
	          anchorOffset = domSelection.anchorOffset;
	        if (anchorNode === editorElement) {
	          var childNodes = editorElement.childNodes;
	          var tableElem;

	          // 光标在 table 前面时
	          tableElem = childNodes[anchorOffset];
	          if (tableElem && tableElem.matches('table')) {
	            canReturn = false; // 不能就此结束，需要重置光标
	          }

	          // 光标在 table 后面时
	          tableElem = childNodes[anchorOffset - 1];
	          if (tableElem && tableElem.matches('table')) {
	            canReturn = false; // 不能就此结束，需要重置光标
	          }
	        }
	      }

	      // 其他情况，就此结束
	      if (canReturn) return;
	    }
	  }

	  // when <Editable/> is being controlled through external value
	  // then its children might just change - DOM responds to it on its own
	  // but Slate's value is not being updated through any operation
	  // and thus it doesn't transform selection on its own
	  if (selection && !DomEditor.hasRange(editor, selection)) {
	    editor.selection = DomEditor.toSlateRange(editor, domSelection, {
	      exactMatch: false,
	      suppressThrow: false
	    });
	    return;
	  }

	  // Otherwise the DOM selection is out of sync, so update it.
	  textarea.isUpdatingSelection = true;
	  var newDomRange = selection && DomEditor.toDOMRange(editor, selection);
	  if (newDomRange) {
	    if (Range.isBackward(selection)) {
	      domSelection.setBaseAndExtent(newDomRange.endContainer, newDomRange.endOffset, newDomRange.startContainer, newDomRange.startOffset);
	    } else {
	      domSelection.setBaseAndExtent(newDomRange.startContainer, newDomRange.startOffset, newDomRange.endContainer, newDomRange.endOffset);
	    }

	    // 滚动到选区
	    var leafEl = newDomRange.startContainer.parentElement;
	    var spacer = leafEl.closest('[data-slate-spacer]');

	    // 这个 if 防止选中图片时发生滚动
	    if (!spacer) {
	      var _context;
	      leafEl.getBoundingClientRect = _bindInstanceProperty$1(_context = newDomRange.getBoundingClientRect).call(_context, newDomRange);
	      var body = document.body;
	      e(leafEl, {
	        scrollMode: 'if-needed',
	        boundary: config.scroll ? editorElement.parentElement : body,
	        // issue 4215
	        block: 'end',
	        behavior: 'smooth'
	      });
	      // @ts-ignore
	      delete leafEl.getBoundingClientRect;
	    }
	  } else {
	    domSelection.removeAllRanges();
	  }
	  _setTimeout(function () {
	    // COMPAT: In Firefox, it's not enough to create a range, you also need
	    // to focus the contenteditable element too. (2016/11/16)
	    if (newDomRange && IS_FIREFOX) {
	      editorElement.focus();
	    }
	    textarea.isUpdatingSelection = false;
	  });
	}

	/**
	 * DOM selection change 时，把 DOM selection 同步给 slate
	 * @param textarea textarea
	 * @param editor editor
	 */
	function DOMSelectionToEditor(textarea, editor) {
	  var isComposing = textarea.isComposing,
	    isUpdatingSelection = textarea.isUpdatingSelection,
	    isDraggingInternally = textarea.isDraggingInternally;
	  var config = editor.getConfig();
	  if (config.readOnly) return;
	  if (isComposing) return;
	  if (isUpdatingSelection) return;
	  if (isDraggingInternally) return;
	  var root = DomEditor.findDocumentOrShadowRoot(editor);
	  var activeElement = root.activeElement;
	  var el = DomEditor.toDOMNode(editor, editor);
	  var domSelection = root.getSelection();
	  if (activeElement === el) {
	    textarea.latestElement = activeElement;
	    IS_FOCUSED.set(editor, true);
	  } else {
	    IS_FOCUSED.delete(editor);
	  }
	  if (!domSelection) {
	    return Transforms.deselect(editor);
	  }
	  var anchorNode = domSelection.anchorNode,
	    focusNode = domSelection.focusNode;
	  var anchorNodeSelectable = hasEditableTarget(editor, anchorNode) || isTargetInsideNonReadonlyVoid(editor, anchorNode);
	  var focusNodeSelectable = hasEditableTarget(editor, focusNode) || isTargetInsideNonReadonlyVoid(editor, focusNode);
	  if (anchorNodeSelectable && focusNodeSelectable) {
	    var range = DomEditor.toSlateRange(editor, domSelection, {
	      exactMatch: false,
	      suppressThrow: false
	    });
	    Transforms.select(editor, range);
	  } else {
	    Transforms.deselect(editor);
	  }
	}

	var EDITOR_TO_TEXT = new _WeakMap$1();
	var EDITOR_TO_START_CONTAINER = new _WeakMap$1();

	/**
	 * composition start 事件
	 * @param e event
	 * @param textarea textarea
	 * @param editor editor
	 */
	function handleCompositionStart(e, textarea, editor) {
	  var event = e;
	  if (!hasEditableTarget(editor, event.target)) return;
	  var selection = editor.selection;
	  if (selection && Range.isExpanded(selection)) {
	    Editor.deleteFragment(editor);
	    _Promise$1.resolve().then(function () {
	      // deleteFragment 会在一个 Promise 后更新 dom，导致浏览器选区不正确
	      // 因此这里延迟一下再设置选区，使选区在正确位置
	      // 这里 model 选区没有发生变化，不能使用 editor.restoreSelection
	      // restoreSelection 会对比前后 model 选区是否相同，相同就不更新了
	      editorSelectionToDOM(textarea, editor, true);
	    });
	  }
	  if (selection && Range.isCollapsed(selection)) {
	    // 记录下 dom text ，以便触发 maxLength 时使用
	    var domRange = DomEditor.toDOMRange(editor, selection);
	    var startContainer = domRange.startContainer;
	    var curText = startContainer.textContent || '';
	    EDITOR_TO_TEXT.set(editor, curText);

	    // 记录下 dom range startContainer
	    EDITOR_TO_START_CONTAINER.set(editor, startContainer);
	  }
	  textarea.isComposing = true;

	  // 隐藏 placeholder
	  // hidePlaceholder(textarea, editor);
	}

	/**
	 * composition update 事件
	 * @param e event
	 * @param textarea textarea
	 * @param editor editor
	 */
	function handleCompositionUpdate(event, textarea, editor) {
	  if (!hasEditableTarget(editor, event.target)) return;
	  textarea.isComposing = true;
	}

	/**
	 * composition end 事件
	 * @param e event
	 * @param textarea textarea
	 * @param editor editor
	 */
	function handleCompositionEnd(e, textarea, editor) {
	  var event = e;
	  if (!hasEditableTarget(editor, event.target)) return;
	  textarea.isComposing = false;
	  var selection = editor.selection;
	  if (selection == null) return;

	  // 清理可能暴露的 text 节点
	  // 例如 chrome 在链接后面，输入拼音，就会出现有暴露出来的 text node
	  if (IS_CHROME || IS_FIREFOX) {
	    DomEditor.cleanExposedTexNodeInSelectionBlock(editor);
	  }

	  // 在中文输入法下，浏览器的默认行为会使一些dom产生不可逆的变化
	  // 比如在 Safari 中 url 后面输入，初始是 a > span > spans
	  // 输入后变成 span > span > a
	  // 因此需要设置新的 key 来强刷整行
	  var start = Range.isBackward(selection) ? selection.focus : selection.anchor;
	  var _Editor$node = Editor.node(editor, [start.path[0]]),
	    _Editor$node2 = _slicedToArray(_Editor$node, 1),
	    paragraph = _Editor$node2[0];
	  for (var i = 0; i < start.path.length; i++) {
	    var _context;
	    var _Editor$node3 = Editor.node(editor, _sliceInstanceProperty(_context = start.path).call(_context, 0, i + 1)),
	      _Editor$node4 = _slicedToArray(_Editor$node3, 1),
	      node = _Editor$node4[0];
	    if (Element.isElement(node)) {
	      if ((IS_SAFARI || IS_FIREFOX) && node.type === 'link' || node.type === 'code') {
	        DomEditor.setNewKey(paragraph);
	        break;
	      }
	    }
	  }
	  var data = event.data;
	  if (!data) return;

	  // 检查 maxLength -【注意】这里只处理拼音输入的 maxLength 限制。其他限制，在插件 with-max-length.ts 中处理
	  var _editor$getConfig = editor.getConfig(),
	    maxLength = _editor$getConfig.maxLength;
	  if (maxLength) {
	    var leftLengthOfMaxLength = DomEditor.getLeftLengthOfMaxLength(editor);
	    if (leftLengthOfMaxLength < data.length) {
	      var domRange = DomEditor.toDOMRange(editor, selection);
	      domRange.startContainer.textContent = EDITOR_TO_TEXT.get(editor) || '';
	      if (leftLengthOfMaxLength > 0) {
	        // 剩余长度 >0 ，但小于 data 长度，截取一部分插入
	        Editor.insertText(editor, _sliceInstanceProperty(data).call(data, 0, leftLengthOfMaxLength));
	      }
	      textarea.changeViewState(); // 重新定位光标
	    } else {
	      Editor.insertText(editor, data);
	    }
	  } else {
	    Editor.insertText(editor, data);
	  }

	  // 检查拼音输入是否夸 DOM 节点了，解决 wangEditor-v5/issues/47
	  if (!IS_SAFARI) {
	    _setTimeout(function () {
	      var selection = editor.selection;
	      if (selection == null) return;
	      var oldStartContainer = EDITOR_TO_START_CONTAINER.get(editor); // 拼音输入开始时的 text node
	      if (oldStartContainer == null) return;
	      var curStartContainer = DomEditor.toDOMRange(editor, selection).startContainer; // 拼音输入结束时的 text node
	      if (curStartContainer === oldStartContainer) {
	        // 拼音输入的开始和结束，都在同一个 text node ，则不做处理
	        return;
	      }
	      // 否则，拼音输入的开始和结束，不是同一个 text node ，则将第一个 text node 重新设置 text
	      oldStartContainer.textContent = EDITOR_TO_TEXT.get(editor) || '';
	    });
	  }
	}

	var $$e = _export$1;
	var $some = arrayIteration$1.some;
	var arrayMethodIsStrict = arrayMethodIsStrict$5;

	var STRICT_METHOD = arrayMethodIsStrict('some');

	// `Array.prototype.some` method
	// https://tc39.es/ecma262/#sec-array.prototype.some
	$$e({ target: 'Array', proto: true, forced: !STRICT_METHOD }, {
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

	var getBuiltInPrototypeMethod$2 = getBuiltInPrototypeMethod$g;

	var some$3 = getBuiltInPrototypeMethod$2('Array', 'some');

	var isPrototypeOf$2 = objectIsPrototypeOf$1;
	var method$2 = some$3;

	var ArrayPrototype$2 = Array.prototype;

	var some$2 = function (it) {
	  var own = it.some;
	  return it === ArrayPrototype$2 || (isPrototypeOf$2(ArrayPrototype$2, it) && own === ArrayPrototype$2.some) ? method$2 : own;
	};

	var parent$m = some$2;

	var some$1 = parent$m;

	var some = some$1;

	var _someInstanceProperty = /*@__PURE__*/getDefaultExportFromCjs(some);

	function _createForOfIteratorHelper$2(o, allowArrayLike) { var it = typeof _Symbol$1 !== "undefined" && _getIteratorMethod(o) || o["@@iterator"]; if (!it) { if (_Array$isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
	function _unsupportedIterableToArray$2(o, minLen) { var _context; if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = _sliceInstanceProperty(_context = Object.prototype.toString.call(o)).call(_context, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }
	function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	/**
	 * Constants.
	 */

	var IS_MAC = typeof window != 'undefined' && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);
	var MODIFIERS = {
	  alt: 'altKey',
	  control: 'ctrlKey',
	  meta: 'metaKey',
	  shift: 'shiftKey'
	};
	var ALIASES = {
	  add: '+',
	  break: 'pause',
	  cmd: 'meta',
	  command: 'meta',
	  ctl: 'control',
	  ctrl: 'control',
	  del: 'delete',
	  down: 'arrowdown',
	  esc: 'escape',
	  ins: 'insert',
	  left: 'arrowleft',
	  mod: IS_MAC ? 'meta' : 'control',
	  opt: 'alt',
	  option: 'alt',
	  return: 'enter',
	  right: 'arrowright',
	  space: ' ',
	  spacebar: ' ',
	  up: 'arrowup',
	  win: 'meta',
	  windows: 'meta'
	};
	var CODES = {
	  backspace: 8,
	  tab: 9,
	  enter: 13,
	  shift: 16,
	  control: 17,
	  alt: 18,
	  pause: 19,
	  capslock: 20,
	  escape: 27,
	  ' ': 32,
	  pageup: 33,
	  pagedown: 34,
	  end: 35,
	  home: 36,
	  arrowleft: 37,
	  arrowup: 38,
	  arrowright: 39,
	  arrowdown: 40,
	  insert: 45,
	  delete: 46,
	  meta: 91,
	  numlock: 144,
	  scrolllock: 145,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	};
	for (var f = 1; f < 20; f++) {
	  CODES['f' + f] = 111 + f;
	}

	/**
	 * Is hotkey?
	 */

	function isHotkey(hotkey, options, event) {
	  if (options && !('byKey' in options)) {
	    event = options;
	    options = null;
	  }
	  if (!_Array$isArray(hotkey)) {
	    hotkey = [hotkey];
	  }
	  var array = _mapInstanceProperty(hotkey).call(hotkey, function (string) {
	    return parseHotkey(string, options);
	  });
	  var check = function check(e) {
	    return _someInstanceProperty(array).call(array, function (object) {
	      return compareHotkey(object, e);
	    });
	  };
	  var ret = event == null ? check : check(event);
	  return ret;
	}
	function isKeyHotkey(hotkey, event) {
	  return isHotkey(hotkey, {
	    byKey: true
	  }, event);
	}

	/**
	 * Parse.
	 */

	function parseHotkey(hotkey, options) {
	  var byKey = options && options.byKey;
	  var ret = {};

	  // Special case to handle the `+` key since we use it as a separator.
	  hotkey = hotkey.replace('++', '+add');
	  var values = hotkey.split('+');
	  var length = values.length;

	  // Ensure that all the modifiers are set to false unless the hotkey has them.
	  for (var k in MODIFIERS) {
	    ret[MODIFIERS[k]] = false;
	  }
	  var _iterator = _createForOfIteratorHelper$2(values),
	    _step;
	  try {
	    for (_iterator.s(); !(_step = _iterator.n()).done;) {
	      var value = _step.value;
	      var optional = _endsWithInstanceProperty(value).call(value, '?') && value.length > 1;
	      if (optional) {
	        value = _sliceInstanceProperty(value).call(value, 0, -1);
	      }
	      var name = toKeyName(value);
	      var modifier = MODIFIERS[name];
	      if (value.length > 1 && !modifier && !ALIASES[value] && !CODES[name]) {
	        throw new TypeError("Unknown modifier: \"".concat(value, "\""));
	      }
	      if (length === 1 || !modifier) {
	        if (byKey) {
	          ret.key = name;
	        } else {
	          ret.which = toKeyCode(value);
	        }
	      }
	      if (modifier) {
	        ret[modifier] = optional ? null : true;
	      }
	    }
	  } catch (err) {
	    _iterator.e(err);
	  } finally {
	    _iterator.f();
	  }
	  return ret;
	}

	/**
	 * Compare.
	 */

	function compareHotkey(object, event) {
	  for (var key in object) {
	    var expected = object[key];
	    var actual = void 0;
	    if (expected == null) {
	      continue;
	    }
	    if (key === 'key' && event.key != null) {
	      actual = event.key.toLowerCase();
	    } else if (key === 'which') {
	      actual = expected === 91 && event.which === 93 ? 91 : event.which;
	    } else {
	      actual = event[key];
	    }
	    if (actual == null && expected === false) {
	      continue;
	    }
	    if (actual !== expected) {
	      return false;
	    }
	  }
	  return true;
	}

	/**
	 * Utils.
	 */

	function toKeyCode(name) {
	  name = toKeyName(name);
	  var code = CODES[name] || name.toUpperCase().charCodeAt(0);
	  return code;
	}
	function toKeyName(name) {
	  name = name.toLowerCase();
	  name = ALIASES[name] || name;
	  return name;
	}

	/**
	 * Hotkey mappings for each platform.
	 */
	var HOTKEYS = {
	  bold: 'mod+b',
	  compose: ['down', 'left', 'right', 'up', 'backspace', 'enter'],
	  moveBackward: 'left',
	  moveForward: 'right',
	  moveWordBackward: 'ctrl+left',
	  moveWordForward: 'ctrl+right',
	  deleteBackward: 'shift?+backspace',
	  deleteForward: 'shift?+delete',
	  extendBackward: 'shift+left',
	  extendForward: 'shift+right',
	  italic: 'mod+i',
	  splitBlock: 'shift?+enter',
	  undo: 'mod+z',
	  tab: 'tab',
	  selectAll: 'mod+a'
	};
	var APPLE_HOTKEYS = {
	  moveLineBackward: 'opt+up',
	  moveLineForward: 'opt+down',
	  moveWordBackward: 'opt+left',
	  moveWordForward: 'opt+right',
	  deleteBackward: ['ctrl+backspace', 'ctrl+h'],
	  deleteForward: ['ctrl+delete', 'ctrl+d'],
	  deleteLineBackward: 'cmd+shift?+backspace',
	  deleteLineForward: ['cmd+shift?+delete', 'ctrl+k'],
	  deleteWordBackward: 'opt+shift?+backspace',
	  deleteWordForward: 'opt+shift?+delete',
	  extendLineBackward: 'opt+shift+up',
	  extendLineForward: 'opt+shift+down',
	  redo: 'cmd+shift+z',
	  transposeCharacter: 'ctrl+t'
	};
	var WINDOWS_HOTKEYS = {
	  deleteWordBackward: 'ctrl+shift?+backspace',
	  deleteWordForward: 'ctrl+shift?+delete',
	  redo: ['ctrl+y', 'ctrl+shift+z']
	};

	/**
	 * Create a platform-aware hotkey checker.
	 */
	var create$7 = function create(key) {
	  var generic = HOTKEYS[key];
	  var apple = APPLE_HOTKEYS[key];
	  var windows = WINDOWS_HOTKEYS[key];
	  var isGeneric = generic && isKeyHotkey(generic);
	  var isApple = apple && isKeyHotkey(apple);
	  var isWindows = windows && isKeyHotkey(windows);
	  return function (event) {
	    if (isGeneric && isGeneric(event)) return true;
	    if (IS_APPLE && isApple && isApple(event)) return true;
	    if (!IS_APPLE && isWindows && isWindows(event)) return true;
	    return false;
	  };
	};

	/**
	 * Hotkeys.
	 */
	var Hotkeys = {
	  isBold: create$7('bold'),
	  isCompose: create$7('compose'),
	  isMoveBackward: create$7('moveBackward'),
	  isMoveForward: create$7('moveForward'),
	  isDeleteBackward: create$7('deleteBackward'),
	  isDeleteForward: create$7('deleteForward'),
	  isDeleteLineBackward: create$7('deleteLineBackward'),
	  isDeleteLineForward: create$7('deleteLineForward'),
	  isDeleteWordBackward: create$7('deleteWordBackward'),
	  isDeleteWordForward: create$7('deleteWordForward'),
	  isExtendBackward: create$7('extendBackward'),
	  isExtendForward: create$7('extendForward'),
	  isExtendLineBackward: create$7('extendLineBackward'),
	  isExtendLineForward: create$7('extendLineForward'),
	  isItalic: create$7('italic'),
	  isMoveLineBackward: create$7('moveLineBackward'),
	  isMoveLineForward: create$7('moveLineForward'),
	  isMoveWordBackward: create$7('moveWordBackward'),
	  isMoveWordForward: create$7('moveWordForward'),
	  isRedo: create$7('redo'),
	  isSplitBlock: create$7('splitBlock'),
	  isTransposeCharacter: create$7('transposeCharacter'),
	  isUndo: create$7('undo'),
	  isTab: create$7('tab'),
	  isSelectAll: create$7('selectAll')
	};

	function ownKeys$5(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread$5(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys$5(Object(t), !0)).call(_context, function (r) { _defineProperty$1(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys$5(Object(t))).call(_context2, function (r) { _Object$defineProperty$1(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
	function preventDefault(event) {
	  event.preventDefault();
	}

	// 触发 menu 快捷键
	function triggerMenuHotKey(editor, event) {
	  var toolbar = EDITOR_TO_TOOLBAR.get(editor);
	  var toolbarMenus = toolbar && toolbar.getMenus();
	  var hoverbar = EDITOR_TO_HOVER_BAR.get(editor);
	  var hoverbarMenus = hoverbar && hoverbar.getMenus();

	  // 合并所有 menus
	  var allMenus = _objectSpread$5(_objectSpread$5({}, toolbarMenus), hoverbarMenus);
	  for (var key in allMenus) {
	    var menu = allMenus[key];
	    var hotkey = menu.hotkey;
	    if (hotkey && isHotkey(hotkey, event)) {
	      var disabled = menu.isDisabled(editor);
	      if (!disabled) {
	        var val = menu.getValue(editor);
	        menu.exec(editor, val); // 执行 menu 命令
	      }
	    }
	  }
	}

	function handleOnKeydown(e, textarea, editor) {
	  var event = e;
	  var selection = editor.selection;
	  var _editor$getConfig = editor.getConfig(),
	    readOnly = _editor$getConfig.readOnly;
	  if (readOnly) return;
	  if (textarea.isComposing) return;
	  if (!hasEditableTarget(editor, event.target)) return;

	  // 触发 menu 快捷键
	  triggerMenuHotKey(editor, event);

	  // tab
	  if (Hotkeys.isTab(event)) {
	    preventDefault(event);
	    editor.handleTab();
	    return;
	  }

	  // COMPAT: Since we prevent the default behavior on
	  // `beforeinput` events, the browser doesn't think there's ever
	  // any history stack to undo or redo, so we have to manage these
	  // hotkeys ourselves. (2019/11/06)
	  if (Hotkeys.isRedo(event)) {
	    preventDefault(event);
	    if (typeof editor.redo === 'function') {
	      editor.redo();
	    }
	    return;
	  }
	  if (Hotkeys.isUndo(event)) {
	    preventDefault(event);
	    if (typeof editor.undo === 'function') {
	      editor.undo();
	    }
	    return;
	  }

	  // COMPAT: Certain browsers don't handle the selection updates
	  // properly. In Chrome, the selection isn't properly extended.
	  // And in Firefox, the selection isn't properly collapsed.
	  // (2017/10/17)
	  if (Hotkeys.isMoveLineBackward(event)) {
	    preventDefault(event);
	    Transforms.move(editor, {
	      unit: 'line',
	      reverse: true
	    }); // Transforms.move 修改 selection
	    return;
	  }
	  if (Hotkeys.isMoveLineForward(event)) {
	    preventDefault(event);
	    Transforms.move(editor, {
	      unit: 'line'
	    });
	    return;
	  }
	  if (Hotkeys.isExtendLineBackward(event)) {
	    preventDefault(event);
	    Transforms.move(editor, {
	      unit: 'line',
	      edge: 'focus',
	      reverse: true
	    });
	    return;
	  }
	  if (Hotkeys.isExtendLineForward(event)) {
	    preventDefault(event);
	    Transforms.move(editor, {
	      unit: 'line',
	      edge: 'focus'
	    });
	    return;
	  }

	  // COMPAT: If a void node is selected, or a zero-width text node
	  // adjacent to an inline is selected, we need to handle these
	  // hotkeys manually because browsers won't be able to skip over
	  // the void node with the zero-width space not being an empty
	  // string.
	  // todo 移动 word 考虑 Node 排版模式是否为 rtl 的情况
	  if (Hotkeys.isMoveBackward(event)) {
	    preventDefault(event);
	    if (selection && Range.isCollapsed(selection)) {
	      Transforms.move(editor, {
	        reverse: true
	      });
	    } else {
	      Transforms.collapse(editor, {
	        edge: 'start'
	      });
	    }
	    return;
	  }
	  if (Hotkeys.isMoveForward(event)) {
	    preventDefault(event);
	    if (selection && Range.isCollapsed(selection)) {
	      Transforms.move(editor);
	    } else {
	      Transforms.collapse(editor, {
	        edge: 'end'
	      });
	    }
	    return;
	  }
	  if (Hotkeys.isMoveWordBackward(event)) {
	    preventDefault(event);
	    if (selection && Range.isExpanded(selection)) {
	      Transforms.collapse(editor, {
	        edge: 'focus'
	      });
	    }
	    Transforms.move(editor, {
	      unit: 'word',
	      reverse: true
	    });
	    return;
	  }
	  if (Hotkeys.isMoveWordForward(event)) {
	    preventDefault(event);
	    if (selection && Range.isExpanded(selection)) {
	      Transforms.collapse(editor, {
	        edge: 'focus'
	      });
	    }
	    Transforms.move(editor, {
	      unit: 'word'
	    });
	    return;
	  }
	  if (Hotkeys.isSelectAll(event)) {
	    preventDefault(event);
	    editor.selectAll();
	    return;
	  }

	  // COMPAT: Certain browsers don't support the `beforeinput` event, so we
	  // fall back to guessing at the input intention for hotkeys.
	  // COMPAT: In iOS, some of these hotkeys are handled in the
	  if (!HAS_BEFORE_INPUT_SUPPORT) {
	    // 这里是兼容不完全支持 beforeInput 的浏览器。对于支持 beforeInput 的浏览器，会用 beforeinput 事件处理
	    // 这里兼容了 beforeInput 的一些功能键（如回车、删除等）没有文本输入。文本输入使用 keypress 兼容。

	    // We don't have a core behavior for these, but they change the
	    // DOM if we don't prevent them, so we have to.
	    if (Hotkeys.isBold(event) || Hotkeys.isItalic(event) || Hotkeys.isTransposeCharacter(event)) {
	      preventDefault(event);
	      return;
	    }
	    if (Hotkeys.isSplitBlock(event)) {
	      preventDefault(event);
	      Editor.insertBreak(editor);
	      return;
	    }
	    if (Hotkeys.isDeleteBackward(event)) {
	      preventDefault(event);
	      if (selection && Range.isExpanded(selection)) {
	        Editor.deleteFragment(editor, {
	          direction: 'backward'
	        });
	      } else {
	        Editor.deleteBackward(editor);
	      }
	      return;
	    }
	    if (Hotkeys.isDeleteForward(event)) {
	      preventDefault(event);
	      if (selection && Range.isExpanded(selection)) {
	        Editor.deleteFragment(editor, {
	          direction: 'forward'
	        });
	      } else {
	        Editor.deleteForward(editor);
	      }
	      return;
	    }
	    if (Hotkeys.isDeleteLineBackward(event)) {
	      preventDefault(event);
	      if (selection && Range.isExpanded(selection)) {
	        Editor.deleteFragment(editor, {
	          direction: 'backward'
	        });
	      } else {
	        Editor.deleteBackward(editor, {
	          unit: 'line'
	        });
	      }
	      return;
	    }
	    if (Hotkeys.isDeleteLineForward(event)) {
	      preventDefault(event);
	      if (selection && Range.isExpanded(selection)) {
	        Editor.deleteFragment(editor, {
	          direction: 'forward'
	        });
	      } else {
	        Editor.deleteForward(editor, {
	          unit: 'line'
	        });
	      }
	      return;
	    }
	    if (Hotkeys.isDeleteWordBackward(event)) {
	      preventDefault(event);
	      if (selection && Range.isExpanded(selection)) {
	        Editor.deleteFragment(editor, {
	          direction: 'backward'
	        });
	      } else {
	        Editor.deleteBackward(editor, {
	          unit: 'word'
	        });
	      }
	      return;
	    }
	    if (Hotkeys.isDeleteWordForward(event)) {
	      preventDefault(event);
	      if (selection && Range.isExpanded(selection)) {
	        Editor.deleteFragment(editor, {
	          direction: 'forward'
	        });
	      } else {
	        Editor.deleteForward(editor, {
	          unit: 'word'
	        });
	      }
	      return;
	    }
	  } else {
	    if (IS_CHROME || IS_SAFARI) {
	      // COMPAT: Chrome and Safari support `beforeinput` event but do not fire
	      // an event when deleting backwards in a selected void inline node
	      // 修复在 Chrome 和 Safari 中删除内容时，内联空节点被选中
	      if (selection && (Hotkeys.isDeleteBackward(event) || Hotkeys.isDeleteForward(event)) && Range.isCollapsed(selection)) {
	        var currentNode = Node.parent(editor, selection.anchor.path);
	        if (Element.isElement(currentNode) && Editor.isVoid(editor, currentNode) && Editor.isInline(editor, currentNode)) {
	          event.preventDefault();
	          Transforms.delete(editor, {
	            unit: 'block'
	          });
	          return;
	        }
	      }
	    }
	  }
	}

	// 【注意】虽然 keypress 事件已经过时（建议用 keydown 取代），但这里是为了兼容 beforeinput ，所以不会在高级浏览器生效，不用升级 keydown

	function handleKeypress(event, textarea, editor) {
	  // 这里是兼容不完全支持 beforeInput 的浏览器。对于支持 beforeInput 的浏览器，会用 beforeinput 事件处理
	  if (HAS_BEFORE_INPUT_SUPPORT) return;
	  var _editor$getConfig = editor.getConfig(),
	    readOnly = _editor$getConfig.readOnly;
	  if (readOnly) return;
	  if (!hasEditableTarget(editor, event.target)) return;
	  event.preventDefault();
	  var text = event.key;

	  // 这里只兼容 beforeInput 的 insertText 类型，其他的（如删除、换行）使用 keydown 来兼容
	  Editor.insertText(editor, text);
	}

	function handleOnCopy(e, textarea, editor) {
	  var event = e;
	  if (!hasEditableTarget(editor, event.target)) return;
	  event.preventDefault();
	  var data = event.clipboardData;
	  if (data == null) return;
	  editor.setFragmentData(data);
	}

	function handleOnCut(e, textarea, editor) {
	  var event = e;
	  var selection = editor.selection;
	  var _editor$getConfig = editor.getConfig(),
	    readOnly = _editor$getConfig.readOnly;
	  if (readOnly) return;
	  if (!hasEditableTarget(editor, event.target)) return;
	  event.preventDefault();
	  var data = event.clipboardData;
	  if (data == null) return;
	  editor.setFragmentData(data);
	  if (selection) {
	    if (Range.isExpanded(selection)) {
	      Editor.deleteFragment(editor);
	    } else {
	      var node = Node.parent(editor, selection.anchor.path);
	      if (Editor.isVoid(editor, node)) {
	        Transforms.delete(editor);
	      }
	    }
	  }
	}

	function handleOnPaste(e, textarea, editor) {
	  EDITOR_TO_CAN_PASTE.set(editor, true); // 标记为：可执行默认粘贴

	  var event = e;
	  var _editor$getConfig = editor.getConfig(),
	    readOnly = _editor$getConfig.readOnly;
	  if (readOnly) return;
	  if (!hasEditableTarget(editor, event.target)) return;
	  var _editor$getConfig2 = editor.getConfig(),
	    customPaste = _editor$getConfig2.customPaste;
	  if (customPaste) {
	    var res = customPaste(editor, event);
	    if (res === false) {
	      // 自行实现粘贴，不执行默认粘贴
	      EDITOR_TO_CAN_PASTE.set(editor, false); // 标记为：不可执行默认粘贴
	      return;
	    }
	  }

	  // 如果支持 beforeInput 且不是纯粘贴文本（如 html、图片文件），则使用 beforeInput 来实现
	  // 这里只处理：不支持 beforeInput 或者 粘贴纯文本
	  if (HAS_BEFORE_INPUT_SUPPORT && !isPlainTextOnlyPaste(event)) return;
	  event.preventDefault();
	  var data = event.clipboardData;
	  if (data == null) return;
	  editor.insertData(data);
	}

	function handleOnDragstart(e, textarea, editor) {
	  var event = e;
	  if (!hasTarget(editor, event.target)) return;
	  var _editor$getConfig = editor.getConfig(),
	    readOnly = _editor$getConfig.readOnly;
	  if (readOnly) return;
	  var node = DomEditor.toSlateNode(editor, event.target);
	  var path = DomEditor.findPath(editor, node);
	  var voidMatch = Editor.isVoid(editor, node) || Editor.void(editor, {
	    at: path,
	    voids: true
	  });

	  // If starting a drag on a void node, make sure it is selected
	  // so that it shows up in the selection's fragment.
	  if (voidMatch) {
	    var range = Editor.range(editor, path);
	    Transforms.select(editor, range);
	  }
	  var data = event.dataTransfer;
	  if (data == null) return;
	  textarea.isDraggingInternally = true;
	  editor.setFragmentData(data);
	}
	function handleOnDragover(event, textarea, editor) {
	  if (!hasTarget(editor, event.target)) return;

	  // Only when the target is void, call `preventDefault` to signal
	  // that drops are allowed. Editable content is droppable by
	  // default, and calling `preventDefault` hides the cursor.
	  var node = DomEditor.toSlateNode(editor, event.target);
	  if (Editor.isVoid(editor, node)) {
	    event.preventDefault();
	  }
	}
	function handleOnDragend(e, textarea, editor) {
	  var event = e;
	  var _editor$getConfig2 = editor.getConfig(),
	    readOnly = _editor$getConfig2.readOnly;
	  if (readOnly) return;
	  if (!textarea.isDraggingInternally) return;
	  if (!hasTarget(editor, event.target)) return;
	  textarea.isDraggingInternally = false;
	}

	function handleOnDrop(e, textarea, editor) {
	  var event = e;
	  var data = event.dataTransfer;
	  var _editor$getConfig = editor.getConfig(),
	    readOnly = _editor$getConfig.readOnly;
	  if (readOnly) return;
	  if (!hasTarget(editor, event.target)) return;
	  if (data == null) return;
	  if (HAS_BEFORE_INPUT_SUPPORT) {
	    if (IS_SAFARI) {
	      // safari 不支持拖拽文件
	      if (data.files.length > 0) return;
	    }
	  }
	  event.preventDefault();

	  // Keep a reference to the dragged range before updating selection
	  var draggedRange = editor.selection;
	  var range = DomEditor.findEventRange(editor, event);
	  Transforms.select(editor, range);
	  if (textarea.isDraggingInternally) {
	    if (draggedRange) {
	      Transforms.delete(editor, {
	        at: draggedRange
	      });
	    }
	    textarea.isDraggingInternally = false;
	  }
	  editor.insertData(data);

	  // When dragging from another source into the editor, it's possible
	  // that the current editor does not have focus.
	  if (!editor.isFocused()) {
	    editor.focus();
	  }
	}

	var eventConf = {
	  beforeinput: handleBeforeInput,
	  blur: handleOnBlur,
	  focus: handleOnFocus,
	  click: handleOnClick,
	  compositionstart: handleCompositionStart,
	  compositionend: handleCompositionEnd,
	  compositionupdate: handleCompositionUpdate,
	  keydown: handleOnKeydown,
	  keypress: handleKeypress,
	  copy: handleOnCopy,
	  cut: handleOnCut,
	  paste: handleOnPaste,
	  dragover: handleOnDragover,
	  dragstart: handleOnDragstart,
	  dragend: handleOnDragend,
	  drop: handleOnDrop
	};

	var root = _root;

	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now$4 = function() {
	  return root.Date.now();
	};

	var now_1 = now$4;

	/** Used to match a single whitespace character. */

	var reWhitespace = /\s/;

	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */
	function trimmedEndIndex$1(string) {
	  var index = string.length;

	  while (index-- && reWhitespace.test(string.charAt(index))) {}
	  return index;
	}

	var _trimmedEndIndex = trimmedEndIndex$1;

	var trimmedEndIndex = _trimmedEndIndex;

	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;

	/**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */
	function baseTrim$1(string) {
	  return string
	    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	    : string;
	}

	var _baseTrim = baseTrim$1;

	var baseTrim = _baseTrim,
	    isObject$3 = isObject_1,
	    isSymbol = isSymbol_1;

	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;

	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;

	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;

	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;

	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber$1(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject$3(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject$3(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = baseTrim(value);
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}

	var toNumber_1 = toNumber$1;

	var isObject$2 = isObject_1,
	    now$3 = now_1,
	    toNumber = toNumber_1;

	/** Error message constants. */
	var FUNC_ERROR_TEXT$1 = 'Expected a function';

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;

	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce$1(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;

	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT$1);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject$2(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }

	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;

	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }

	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }

	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;

	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }

	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;

	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }

	  function timerExpired() {
	    var time = now$3();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }

	  function trailingEdge(time) {
	    timerId = undefined;

	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }

	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }

	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now$3());
	  }

	  function debounced() {
	    var time = now$3(),
	        isInvoking = shouldInvoke(time);

	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;

	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        clearTimeout(timerId);
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}

	var debounce_1 = debounce$1;

	var debounce$2 = /*@__PURE__*/getDefaultExportFromCjs(debounce_1);

	var debounce = debounce_1,
	    isObject$1 = isObject_1;

	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';

	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;

	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject$1(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}

	var throttle_1 = throttle;

	var throttle$1 = /*@__PURE__*/getDefaultExportFromCjs(throttle_1);

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */

	function arrayEach$1(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;

	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}

	var _arrayEach = arrayEach$1;

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */

	function createBaseFor$1(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;

	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}

	var _createBaseFor = createBaseFor$1;

	var createBaseFor = _createBaseFor;

	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor$1 = createBaseFor();

	var _baseFor = baseFor$1;

	var baseFor = _baseFor,
	    keys = keys_1;

	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn$1(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}

	var _baseForOwn = baseForOwn$1;

	var isArrayLike = isArrayLike_1;

	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach$1(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);

	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}

	var _createBaseEach = createBaseEach$1;

	var baseForOwn = _baseForOwn,
	    createBaseEach = _createBaseEach;

	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach$1 = createBaseEach(baseForOwn);

	var _baseEach = baseEach$1;

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */

	function identity$1(value) {
	  return value;
	}

	var identity_1 = identity$1;

	var identity = identity_1;

	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction$1(value) {
	  return typeof value == 'function' ? value : identity;
	}

	var _castFunction = castFunction$1;

	var arrayEach = _arrayEach,
	    baseEach = _baseEach,
	    castFunction = _castFunction,
	    isArray$1 = isArray_1;

	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach$3(collection, iteratee) {
	  var func = isArray$1(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}

	var forEach_1 = forEach$3;

	var forEach$4 = /*@__PURE__*/getDefaultExportFromCjs(forEach_1);

	var ID = 1;
	var Editable = /*#__PURE__*/function () {
	  function Editable(boxSelector) {
	    var _this = this;
	    _classCallCheck(this, Editable);
	    _defineProperty$1(this, "onDOMSelectionChange", throttle$1(function () {
	      var editor = _this.editorInstance;
	      DOMSelectionToEditor(_this, editor);
	    }, 100));
	    this.id = ID++;
	    // 初始化box
	    var $box = $$x(boxSelector);
	    this.$box = $box;
	    // 初始化container
	    var $container = $$x("<div class=\"s-e-container\"></div>");
	    this.$container = $container;
	    $box.append($container);
	    // 初始化滚动区域
	    var $scroll = $$x("<div class=\"s-e-scroll\"></div>");
	    $container.append($scroll);
	    this.$scroll = $scroll;

	    // 异步等待editable DOM更新后
	    promiseResolveThen(function () {
	      var _context;
	      var editor = _this.editorInstance;
	      var window = DomEditor.getWindow(editor);

	      // 监听 selection change
	      window.document.addEventListener('selectionchange', _this.onDOMSelectionChange);
	      // editor 销毁时，解绑 selection change
	      editor.on('destroyed', function () {
	        window.document.removeEventListener('selectionchange', _this.onDOMSelectionChange);
	      });

	      // editor onchange 时触发用户配置的 onChange （需要在 changeViewState 后执行）
	      var _editor$getConfig = editor.getConfig(),
	        onChange = _editor$getConfig.onChange;
	      if (onChange) {
	        editor.on('change', function () {
	          return onChange(editor);
	        });
	      }

	      // 点击编辑区域，关闭 panel
	      $container.on('click', function () {
	        return editor.hidePanelOrModal();
	      });

	      // editor onchange 时更新视图
	      editor.on('change', _bindInstanceProperty$1(_context = _this.changeViewState).call(_context, _this));

	      // 监听 onfocus onblur
	      _this.onFocusAndOnBlur();
	      _this.bindEvent();
	    });
	  }
	  _createClass(Editable, [{
	    key: "editorInstance",
	    get: function get() {
	      var editor = TEXTAREA_TO_EDITOR.get(this);
	      if (editor == null) throw new Error('Can not get editor instance');
	      return editor;
	    }
	  }, {
	    key: "changeViewState",
	    value: function changeViewState() {
	      var _this2 = this;
	      var editor = this.editorInstance;

	      // 更新
	      updateView(this, editor);

	      // 同步选区（异步，否则拿不到 DOM 渲染结果，vdom）
	      promiseResolveThen(function () {
	        editorSelectionToDOM(_this2, editor);
	      });
	    }
	  }, {
	    key: "bindEvent",
	    value: function bindEvent() {
	      var _this3 = this;
	      var $editable = this.$editable;
	        this.$scroll;
	      var editor = this.editorInstance;
	      if ($editable == null) return;

	      // 遍历所有事件类型，绑定
	      // 遍历所有事件类型，绑定
	      forEach$4(eventConf, function (fn, eventType) {
	        $editable.on(eventType, function (event) {
	          fn(event, _this3, editor);
	        });
	      });
	    }
	  }, {
	    key: "onFocusAndOnBlur",
	    value: function onFocusAndOnBlur() {
	      var _this4 = this;
	      var editor = this.editorInstance;
	      var _editor$getConfig2 = editor.getConfig(),
	        onBlur = _editor$getConfig2.onBlur,
	        onFocus = _editor$getConfig2.onFocus;
	      this.latestEditorSelection = editor.selection;
	      editor.on('change', function () {
	        if (_this4.latestEditorSelection == null && editor.selection != null) {
	          // 异步触发 focus
	          _setTimeout(function () {
	            return onFocus && onFocus(editor);
	          });
	        } else if (_this4.latestEditorSelection != null && editor.selection == null) {
	          // 异步触发 blur
	          _setTimeout(function () {
	            return onBlur && onBlur(editor);
	          });
	        }
	        _this4.latestEditorSelection = editor.selection; // 重新记录 selection
	      });
	    }

	    /**
	     * 销毁 textarea
	     */
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      // 销毁 DOM （只销毁最外层 DOM 即可）
	      this.$container.remove();
	    }
	  }]);
	  return Editable;
	}();

	function ownKeys$4(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread$4(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys$4(Object(t), !0)).call(_context, function (r) { _defineProperty$1(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys$4(Object(t))).call(_context2, function (r) { _Object$defineProperty$1(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
	// menu item 的工厂函数 - 集合
	var MENU_ITEM_FACTORIES = {};

	/**
	 * 注册菜单配置
	 * @param registerMenuConf { key, factory, config } ，各个 menu key 不能重复
	 * @param customConfig 自定义 menu config
	 */
	function registerMenu(registerMenuConf, customConfig) {
	  var key = registerMenuConf.key,
	    factory = registerMenuConf.factory,
	    config = registerMenuConf.config;

	  // 合并 config
	  _objectSpread$4(_objectSpread$4({}, config), customConfig || {});

	  // 注册 menu
	  if (MENU_ITEM_FACTORIES[key] != null) {
	    return;
	  }
	  MENU_ITEM_FACTORIES[key] = factory;
	}

	var BaseButton = /*#__PURE__*/function () {
	  function BaseButton(key, menu) {
	    var _this = this;
	    _classCallCheck(this, BaseButton);
	    this.$elem = $$x("<div class=\"s-e-bar-item\"></div>");
	    this.$button = $$x("<button type=\"button\"></button>");
	    this.disabled = false;
	    this.menu = menu;

	    // 验证 tag
	    var tag = menu.tag,
	      width = menu.width;
	    if (tag !== 'button') throw new Error("Invalid tag '".concat(tag, "', expected 'button'"));

	    // ----------------- 初始化 dom -----------------
	    var title = menu.title,
	      _menu$hotkey = menu.hotkey,
	      hotkey = _menu$hotkey === void 0 ? '' : _menu$hotkey,
	      _menu$iconSvg = menu.iconSvg,
	      iconSvg = _menu$iconSvg === void 0 ? '' : _menu$iconSvg;
	    var $button = this.$button;
	    if (iconSvg) {
	      var $svg = $$x(iconSvg);
	      $button.append($svg);
	    } else {
	      // 无 icon 则显示 title
	      $button.text(title);
	    }
	    if (width) {
	      $button.css('width', "".concat(width, "px"));
	    }
	    $button.attr('data-menu-key', key); // menu key
	    $button.attr('title', title + '\n' + hotkey); // menu key
	    this.$elem.append($button);

	    // ----------------- 异步绑定事件 -----------------
	    promiseResolveThen(function () {
	      return _this.init();
	    });
	  }
	  _createClass(BaseButton, [{
	    key: "init",
	    value: function init() {
	      var _this2 = this;
	      // 设置 button 属性
	      this.setActive();
	      this.setDisabled();

	      // button click
	      this.$button.on('click', function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	        var editor = getEditorInstance(_this2);
	        editor.hidePanelOrModal(); // 隐藏当前的各种 panel

	        if (_this2.disabled) return;
	        _this2.exec(); // 执行 menu.exec
	        _this2.onButtonClick(); // 执行其他的逻辑
	      });
	    }
	  }, {
	    key: "onButtonClick",
	    value: function onButtonClick() {}
	  }, {
	    key: "exec",
	    value: function exec() {
	      var editor = getEditorInstance(this);
	      var menu = this.menu;
	      var value = menu.getValue(editor);
	      menu.exec(editor, value);
	    }
	  }, {
	    key: "setActive",
	    value: function setActive() {
	      var editor = getEditorInstance(this);
	      var $button = this.$button;
	      var active = this.menu.isActive(editor);
	      var className = 'active';
	      if (active) {
	        // 设置为 active
	        $button.addClass(className);
	      } else {
	        // 取消 active
	        $button.removeClass(className);
	      }
	    }
	  }, {
	    key: "setDisabled",
	    value: function setDisabled() {
	      var editor = getEditorInstance(this);
	      var $button = this.$button;
	      var disabled = this.menu.isDisabled(editor);
	      if (editor.selection == null || editor.isDisabled()) {
	        // 未选中，或者 readOnly ，强行设置为 disabled
	        disabled = true;
	      }

	      // 永远 enable
	      if (this.menu.alwaysEnable) disabled = false;
	      var className = 'disabled';
	      if (disabled) {
	        // 设置为 disabled
	        $button.addClass(className);
	      } else {
	        // 取消 disabled
	        $button.removeClass(className);
	      }
	      this.disabled = disabled; // 记录下来
	    }
	  }, {
	    key: "changeMenuState",
	    value: function changeMenuState() {
	      this.setActive();
	      this.setDisabled();
	    }
	  }]);
	  return BaseButton;
	}();

	var $$d = _export$1;
	var getBuiltIn = getBuiltIn$k;
	var apply = functionApply$1;
	var bind$3 = functionBind;
	var aConstructor = aConstructor$2;
	var anObject$1 = anObject$q;
	var isObject = isObject$B;
	var create$6 = objectCreate$1;
	var fails$2 = fails$T;

	var nativeConstruct = getBuiltIn('Reflect', 'construct');
	var ObjectPrototype = Object.prototype;
	var push = [].push;

	// `Reflect.construct` method
	// https://tc39.es/ecma262/#sec-reflect.construct
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails$2(function () {
	  function F() { /* empty */ }
	  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
	});

	var ARGS_BUG = !fails$2(function () {
	  nativeConstruct(function () { /* empty */ });
	});

	var FORCED$1 = NEW_TARGET_BUG || ARGS_BUG;

	$$d({ target: 'Reflect', stat: true, forced: FORCED$1, sham: FORCED$1 }, {
	  construct: function construct(Target, args /* , newTarget */) {
	    aConstructor(Target);
	    anObject$1(args);
	    var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
	    if (Target === newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      apply(push, $args, args);
	      return new (apply(bind$3, Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create$6(isObject(proto) ? proto : ObjectPrototype);
	    var result = apply(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});

	var path$4 = path$q;

	var construct$2 = path$4.Reflect.construct;

	var parent$l = construct$2;

	var construct$1 = parent$l;

	var construct = construct$1;

	var _Reflect$construct = /*@__PURE__*/getDefaultExportFromCjs(construct);

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	  return self;
	}

	// TODO: Remove from `core-js@4`
	var $$c = _export$1;
	var DESCRIPTORS = descriptors$1;
	var create$5 = objectCreate$1;

	// `Object.create` method
	// https://tc39.es/ecma262/#sec-object.create
	$$c({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
	  create: create$5
	});

	var path$3 = path$q;

	var Object$1 = path$3.Object;

	var create$4 = function create(P, D) {
	  return Object$1.create(P, D);
	};

	var parent$k = create$4;

	var create$3 = parent$k;

	var parent$j = create$3;

	var create$2 = parent$j;

	var parent$i = create$2;

	var create$1 = parent$i;

	var create = create$1;

	var _Object$create = /*@__PURE__*/getDefaultExportFromCjs(create);

	var $$b = _export$1;
	var setPrototypeOf$5 = objectSetPrototypeOf;

	// `Object.setPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.setprototypeof
	$$b({ target: 'Object', stat: true }, {
	  setPrototypeOf: setPrototypeOf$5
	});

	var path$2 = path$q;

	var setPrototypeOf$4 = path$2.Object.setPrototypeOf;

	var parent$h = setPrototypeOf$4;

	var setPrototypeOf$3 = parent$h;

	var parent$g = setPrototypeOf$3;

	var setPrototypeOf$2 = parent$g;

	var parent$f = setPrototypeOf$2;

	var setPrototypeOf$1 = parent$f;

	var setPrototypeOf = setPrototypeOf$1;

	var _Object$setPrototypeOf = /*@__PURE__*/getDefaultExportFromCjs(setPrototypeOf);

	var parent$e = bind$5;

	var bind$2 = parent$e;

	var parent$d = bind$2;

	var bind$1 = parent$d;

	var bind = bind$1;

	var _bindInstanceProperty = /*@__PURE__*/getDefaultExportFromCjs(bind);

	function _setPrototypeOf(o, p) {
	  var _context;
	  _setPrototypeOf = _Object$setPrototypeOf ? _bindInstanceProperty(_context = _Object$setPrototypeOf).call(_context) : function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	  return _setPrototypeOf(o, p);
	}

	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	  subClass.prototype = _Object$create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  _Object$defineProperty(subClass, "prototype", {
	    writable: false
	  });
	  if (superClass) _setPrototypeOf(subClass, superClass);
	}

	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
	    return call;
	  } else if (call !== void 0) {
	    throw new TypeError("Derived constructors may only return object or undefined");
	  }
	  return _assertThisInitialized(self);
	}

	var $$a = _export$1;
	var fails$1 = fails$T;
	var toObject = toObject$f;
	var nativeGetPrototypeOf = objectGetPrototypeOf;
	var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

	var FAILS_ON_PRIMITIVES = fails$1(function () { nativeGetPrototypeOf(1); });

	// `Object.getPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.getprototypeof
	$$a({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
	  getPrototypeOf: function getPrototypeOf(it) {
	    return nativeGetPrototypeOf(toObject(it));
	  }
	});

	var path$1 = path$q;

	var getPrototypeOf$4 = path$1.Object.getPrototypeOf;

	var parent$c = getPrototypeOf$4;

	var getPrototypeOf$3 = parent$c;

	var parent$b = getPrototypeOf$3;

	var getPrototypeOf$2 = parent$b;

	var parent$a = getPrototypeOf$2;

	var getPrototypeOf$1 = parent$a;

	var getPrototypeOf = getPrototypeOf$1;

	var _Object$getPrototypeOf = /*@__PURE__*/getDefaultExportFromCjs(getPrototypeOf);

	function _getPrototypeOf(o) {
	  var _context;
	  _getPrototypeOf = _Object$setPrototypeOf ? _bindInstanceProperty(_context = _Object$getPrototypeOf).call(_context) : function _getPrototypeOf(o) {
	    return o.__proto__ || _Object$getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}

	// TODO: Remove from `core-js@4`
	var $$9 = _export$1;
	var uncurryThis$3 = functionUncurryThis$1;

	var $Date = Date;
	var thisTimeValue = uncurryThis$3($Date.prototype.getTime);

	// `Date.now` method
	// https://tc39.es/ecma262/#sec-date.now
	$$9({ target: 'Date', stat: true }, {
	  now: function now() {
	    return thisTimeValue(new $Date());
	  }
	});

	var path = path$q;

	var now$2 = path.Date.now;

	var parent$9 = now$2;

	var now$1 = parent$9;

	var now = now$1;

	var _Date$now = /*@__PURE__*/getDefaultExportFromCjs(now);

	var PanelAndModal = /*#__PURE__*/function () {
	  // 显示时的时间戳

	  function PanelAndModal(editor) {
	    _classCallCheck(this, PanelAndModal);
	    _defineProperty$1(this, "type", void 0);
	    _defineProperty$1(this, "$elem", void 0);
	    _defineProperty$1(this, "isShow", false);
	    _defineProperty$1(this, "showTime", 0);
	    this.record(editor);
	  }

	  /**
	   * 记录下来，以便隐藏，API editor.hidePanelOrModal
	   */
	  _createClass(PanelAndModal, [{
	    key: "record",
	    value: function record(editor) {
	      var set = EDITOR_TO_PANEL_AND_MODAL.get(editor);
	      if (set == null) {
	        set = new _Set$1();
	        EDITOR_TO_PANEL_AND_MODAL.set(editor, set);
	      }
	      set.add(this);
	      PANEL_OR_MODAL_TO_EDITOR.set(this, editor);
	    }
	  }, {
	    key: "renderContent",
	    value: function renderContent(contentElem) {
	      var $elem = this.$elem;
	      $elem.empty(); // 先清空，再填充内容
	      $elem.append(contentElem);

	      // 添加自己额外的 elem
	      var $selfElem = this.genSelfElem();
	      if ($selfElem) {
	        $elem.append($selfElem);
	      }
	    }
	  }, {
	    key: "appendTo",
	    value: function appendTo($menuElem) {
	      var $elem = this.$elem;
	      $menuElem.append($elem);
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (this.isShow) return;
	      this.showTime = _Date$now();
	      var $elem = this.$elem;
	      $elem.show();
	      this.isShow = true;

	      // 触发事件
	      var editor = PANEL_OR_MODAL_TO_EDITOR.get(this);
	      if (editor) editor.emit('modalOrPanelShow', this);
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (!this.isShow) return;
	      var now = _Date$now();
	      if (now - this.showTime < 200) {
	        // 刚显示的，不要立刻隐藏（避免频繁触发 show/hide ）
	        return;
	      }
	      var $elem = this.$elem;
	      $elem.hide();
	      this.isShow = false;

	      // 触发事件
	      var editor = PANEL_OR_MODAL_TO_EDITOR.get(this);
	      if (editor) editor.emit('modalOrPanelHide');
	    }
	  }]);
	  return PanelAndModal;
	}();

	/**
	 * 【注意】svg 字符串的长度 ，否则会导致代码体积过大
	 * 尽量选择 https://www.iconfont.cn/collections/detail?spm=a313x.7781069.0.da5a778a4&cid=20293
	 * 找不到再从 iconfont.com 搜索
	 */

	// 对号
	var SVG_CHECK_MARK = '<svg viewBox="0 0 1446 1024"><path d="M574.116299 786.736392 1238.811249 48.517862C1272.390222 11.224635 1329.414799 7.827718 1366.75664 41.450462 1403.840015 74.840484 1406.731043 132.084741 1373.10189 169.433699L655.118888 966.834607C653.072421 969.716875 650.835807 972.514337 648.407938 975.210759 615.017957 1012.29409 558.292155 1015.652019 521.195664 982.250188L72.778218 578.493306C35.910826 545.297758 32.859041 488.584019 66.481825 451.242134 99.871807 414.158803 156.597563 410.800834 193.694055 444.202665L574.116299 786.736392Z"></path></svg>';

	// 向下的箭头
	var SVG_DOWN_ARROW = '<svg viewBox="0 0 1024 1024"><path d="M498.7 655.8l-197.6-268c-8.1-10.9-0.3-26.4 13.3-26.4h395.2c13.6 0 21.4 15.4 13.3 26.4l-197.6 268c-6.6 9-20 9-26.6 0z"></path></svg>';

	// 关闭
	var SVG_CLOSE = '<svg viewBox="0 0 1024 1024"><path d="M1024 896.1024l-128 128L512 640 128 1024 0 896 384 512 0 128 128 0 512 384 896.1024 0l128 128L640 512z"></path></svg>';

	function _createSuper$e(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$e(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	function _isNativeReflectConstruct$e() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var Modal = /*#__PURE__*/function (_PanelAndModal) {
	  _inherits(Modal, _PanelAndModal);
	  var _super = _createSuper$e(Modal);
	  function Modal(editor) {
	    var _this;
	    var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    _classCallCheck(this, Modal);
	    _this = _super.call(this, editor);
	    _defineProperty$1(_assertThisInitialized(_this), "type", 'modal');
	    _defineProperty$1(_assertThisInitialized(_this), "$elem", $$x("<div class=\"s-e-modal\"></div>"));
	    _defineProperty$1(_assertThisInitialized(_this), "width", 0);
	    if (width) _this.width = width;
	    var _assertThisInitialize = _assertThisInitialized(_this),
	      $elem = _assertThisInitialize.$elem;

	    // mousedown 阻止冒泡，因为在 $textContainer 通过 mousedown 隐藏 panel & modal
	    $elem.on('click', function (e) {
	      return e.stopPropagation();
	    });

	    // esc 关闭 modal
	    $elem.on('keyup', function (e) {
	      var event = e;
	      if (event.code === 'Escape') {
	        _this.hide();
	        editor.restoreSelection(); // 还原选区
	      }
	    });
	    return _this;
	  }

	  /**
	   * 生成要添加到 modal $elem 的元素
	   * 【注意】不要直接 append 到 modal $elem ，因为它每次都会清空 html('')
	   */
	  _createClass(Modal, [{
	    key: "genSelfElem",
	    value: function genSelfElem() {
	      var _this2 = this;
	      // 关闭按钮
	      var $closeButton = $$x("<span class=\"btn-close\">".concat(SVG_CLOSE, "</span>"));
	      var editor = PANEL_OR_MODAL_TO_EDITOR.get(this);
	      $closeButton.on('click', function () {
	        _this2.hide();
	        editor === null || editor === void 0 || editor.restoreSelection();
	      });
	      return $closeButton;
	    }
	  }, {
	    key: "setStyle",
	    value: function setStyle(positionStyle) {
	      var width = this.width,
	        $elem = this.$elem;
	      $elem.attr('style', ''); // 先清空 style ，再重新设置

	      if (width) $elem.css('width', "".concat(width, "px"));
	      $elem.css(positionStyle);
	    }
	  }]);
	  return Modal;
	}(PanelAndModal);

	// ---------------------------------- 分割线 ----------------------------------

	/**
	 * 生成 modal input elems
	 * @param labelText label text
	 * @param inputId input dom id
	 * @param placeholder input placeholder
	 * @returns [$container, $input]
	 */
	function genModalInputElems(labelText, inputId, placeholder) {
	  var _context, _context2;
	  var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'text';
	  var $container = $$x('<label class="babel-container"></label>');
	  $container.append("<span>".concat(labelText, "</span>"));
	  var $input = $$x(_concatInstanceProperty(_context = _concatInstanceProperty(_context2 = "<input type=\"".concat(type, "\" id=\"")).call(_context2, inputId, "\" placeholder=\"")).call(_context, placeholder || '', "\">"));
	  $container.append($input);
	  return [$container[0], $input[0]];
	}
	function genModalSelectElems(labelText, selectId, placeholder) {
	  var _context4, _context5;
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	  var $container = $$x('<label class="babel-container"></label>');
	  $container.append("<span>".concat(labelText, "</span>"));
	  var optionHTML = '';
	  for (var i = 0; i < options.length; i++) {
	    var _context3;
	    optionHTML += _concatInstanceProperty(_context3 = "<option value=\"".concat(options[i].value, "\">")).call(_context3, options[i].name, "</option>");
	  }
	  var $select = $$x(_concatInstanceProperty(_context4 = _concatInstanceProperty(_context5 = "<select  id=\"".concat(selectId, "\" placeholder=\"")).call(_context5, placeholder || '', "\">\n      ")).call(_context4, optionHTML, "\n    </select>"));
	  $container.append($select);
	  return [$container[0], $select[0]];
	}

	/**
	 * 生成 modal button elems
	 * @param buttonId button dom id
	 * @param buttonText button text
	 * @returns [ $container, $button ]
	 */
	function genModalButtonElems(buttonId, buttonText) {
	  var _context7;
	  var $buttonContainer = $$x('<div class="button-container"></div>');
	  var $button = $$x(_concatInstanceProperty(_context7 = "<button type=\"button\" id=\"".concat(buttonId, "\">")).call(_context7, buttonText, "</button>"));
	  $buttonContainer.append($button);
	  return [$buttonContainer[0], $button[0]];
	}

	function _createSuper$d(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$d(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	function _isNativeReflectConstruct$d() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var ModalButton = /*#__PURE__*/function (_BaseButton) {
	  _inherits(ModalButton, _BaseButton);
	  var _super = _createSuper$d(ModalButton);
	  function ModalButton(key, menu) {
	    var _this;
	    var inGroup = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	    _classCallCheck(this, ModalButton);
	    _this = _super.call(this, key, menu, inGroup);
	    _defineProperty$1(_assertThisInitialized(_this), "$body", $$x('body'));
	    _defineProperty$1(_assertThisInitialized(_this), "modal", null);
	    _defineProperty$1(_assertThisInitialized(_this), "menu", void 0);
	    _this.menu = menu;
	    return _this;
	  }
	  _createClass(ModalButton, [{
	    key: "onButtonClick",
	    value: function onButtonClick() {
	      if (this.menu.showModal) {
	        this.handleModal();
	      }
	    }

	    /**
	     * 获取 modal 定位
	     */
	  }, {
	    key: "getPosition",
	    value: function getPosition() {
	      var editor = getEditorInstance(this);
	      var positionNode = this.menu.getModalPositionNode(editor);
	      if (Element.isElement(positionNode)) {
	        // elem node ，按 node 定位
	        return getPositionByNode(editor, positionNode, 'modal');
	      }

	      // 其他情况（如 positionNode == null 或是 text node）则按选区定位
	      return getPositionBySelection(editor);
	    }

	    // 显示/隐藏 modal
	  }, {
	    key: "handleModal",
	    value: function handleModal() {
	      var editor = getEditorInstance(this);
	      var menu = this.menu;
	      if (this.modal == null) {
	        // 初次创建
	        var modal = new Modal(editor, menu.modalWidth);
	        this.renderAndShowModal(modal, true);

	        // 记录下来，防止重复创建
	        this.modal = modal;
	      } else {
	        // 不是初次创建
	        var _modal = this.modal;
	        if (_modal.isShow) {
	          // 当前处于显示状态，则隐藏
	          _modal.hide();
	        } else {
	          // 当前未处于显示状态，则重新渲染内容 ，并显示
	          this.renderAndShowModal(_modal, false);
	        }
	      }
	    }

	    /**
	     * 渲染并显示 modal
	     * @param modal modal
	     * @param firstTime 是否第一次显示 modal
	     */
	  }, {
	    key: "renderAndShowModal",
	    value: function renderAndShowModal(modal) {
	      var firstTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var editor = getEditorInstance(this);
	      var menu = this.menu;
	      if (menu.getModalContentElem == null) return;
	      var textarea = DomEditor.getTextarea(editor);
	      var toolbar = DomEditor.getToolbar(editor);
	      var _ref = (toolbar === null || toolbar === void 0 ? void 0 : toolbar.getConfig()) || {},
	        modalAppendToBody = _ref.modalAppendToBody;
	      var contentElem = menu.getModalContentElem(editor);
	      modal.renderContent(contentElem);
	      if (modalAppendToBody) {
	        // appendTo body 时，用户自己设置 modal 定位
	        modal.setStyle({
	          left: '0',
	          right: '0'
	        });
	      } else {
	        // 计算并设置 modal position
	        var positionStyle = this.getPosition();
	        modal.setStyle(positionStyle);
	      }
	      if (firstTime) {
	        if (modalAppendToBody) {
	          modal.appendTo(this.$body);
	        } else {
	          modal.appendTo(textarea.$container);
	        }
	      }
	      modal.show();
	      if (!modalAppendToBody) {
	        // 修正 modal 定位，避免超出 textContainer 边界（ appendTo body 则不用设置，用户自己设置 ）
	        correctPosition(editor, modal.$elem);
	      }

	      // 让 editor 失焦，否则点击 modal 触发 onChange 会导致 modal 隐藏
	      _setTimeout(function () {
	        editor.blur();
	      });
	    }
	  }]);
	  return ModalButton;
	}(BaseButton);

	function _createSuper$c(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$c(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	function _isNativeReflectConstruct$c() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var DropPanel = /*#__PURE__*/function (_PanelAndModal) {
	  _inherits(DropPanel, _PanelAndModal);
	  var _super = _createSuper$c(DropPanel);
	  function DropPanel(editor) {
	    var _this;
	    _classCallCheck(this, DropPanel);
	    _this = _super.call(this, editor);
	    _defineProperty$1(_assertThisInitialized(_this), "type", 'dropPanel');
	    _defineProperty$1(_assertThisInitialized(_this), "$elem", $$x("<div class=\"s-e-drop-panel\"></div>"));
	    return _this;
	  }
	  _createClass(DropPanel, [{
	    key: "genSelfElem",
	    value: function genSelfElem() {
	      return null;
	    }
	  }]);
	  return DropPanel;
	}(PanelAndModal);

	function _createSuper$b(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$b(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	function _isNativeReflectConstruct$b() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var DropPanelButton = /*#__PURE__*/function (_BaseButton) {
	  _inherits(DropPanelButton, _BaseButton);
	  var _super = _createSuper$b(DropPanelButton);
	  function DropPanelButton(key, menu) {
	    var _this;
	    var inGroup = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	    _classCallCheck(this, DropPanelButton);
	    _this = _super.call(this, key, menu, inGroup);
	    _defineProperty$1(_assertThisInitialized(_this), "dropPanel", null);
	    _defineProperty$1(_assertThisInitialized(_this), "menu", void 0);
	    _this.menu = menu;
	    if (menu.showDropPanel) {
	      var $arrow = $$x(SVG_DOWN_ARROW);
	      _this.$button.append($arrow);
	    }
	    return _this;
	  }

	  // button 点击之后
	  _createClass(DropPanelButton, [{
	    key: "onButtonClick",
	    value: function onButtonClick() {
	      if (this.menu.showDropPanel) {
	        this.handleDropPanel();
	      }
	    }

	    // 显示/隐藏 dropPanel
	  }, {
	    key: "handleDropPanel",
	    value: function handleDropPanel() {
	      var menu = this.menu;
	      if (menu.getPanelContentElem == null) return;
	      var editor = getEditorInstance(this);
	      if (this.dropPanel == null) {
	        // 初次创建
	        var _dropPanel = new DropPanel(editor);
	        var contentElem = menu.getPanelContentElem(editor);
	        _dropPanel.renderContent(contentElem);
	        _dropPanel.appendTo(this.$elem);
	        _dropPanel.show();

	        // 记录下来，防止重复创建
	        this.dropPanel = _dropPanel;
	      } else {
	        // 不是初次创建
	        var _dropPanel2 = this.dropPanel;
	        if (_dropPanel2.isShow) {
	          // 当前处于显示状态，则隐藏
	          _dropPanel2.hide();
	        } else {
	          // 当前未处于显示状态，则重新渲染内容 ，并显示
	          var _contentElem = menu.getPanelContentElem(editor);
	          _dropPanel2.renderContent(_contentElem);
	          _dropPanel2.show();
	        }
	      }

	      // 判断 dropPanel 的位置：在菜单右侧/左侧
	      var dropPanel = this.dropPanel;
	      if (dropPanel.isShow) {
	        var $menu = this.$elem;
	        var _$menu$offset = $menu.offset(),
	          left = _$menu$offset.left; // 菜单元素 left

	        var $toolbar = $menu.parents('.s-e-bar');
	        var _$toolbar$offset = $toolbar.offset(),
	          toolbarLeft = _$toolbar$offset.left; // toolbar left
	        var toolbarWidth = $toolbar.width(); // toolbar width
	        var halfToolbarWidth = toolbarWidth / 2; // toolbar width 的 1/2

	        if (left - toolbarLeft >= halfToolbarWidth) {
	          // 菜单在 toolbar 的右半部分，则 dropPanel 要显示在菜单左侧
	          dropPanel.$elem.css({
	            left: 'none',
	            right: '0'
	          });
	        } else {
	          // 菜单在 toolbar 左半部分，则 dropPanel 显示在菜单右侧
	          dropPanel.$elem.css({
	            left: '0',
	            right: 'none'
	          });
	        }
	      }
	    }
	  }]);
	  return DropPanelButton;
	}(BaseButton);

	function _createSuper$a(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$a(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	function _isNativeReflectConstruct$a() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

	// “对号”icon
	function gen$SelectedIcon() {
	  return $$x(SVG_CHECK_MARK);
	}
	var SelectList = /*#__PURE__*/function (_PanelAndModal) {
	  _inherits(SelectList, _PanelAndModal);
	  var _super = _createSuper$a(SelectList);
	  function SelectList(editor, width) {
	    var _this;
	    _classCallCheck(this, SelectList);
	    _this = _super.call(this, editor);
	    _defineProperty$1(_assertThisInitialized(_this), "type", 'selectList');
	    _defineProperty$1(_assertThisInitialized(_this), "$elem", $$x("<div class=\"s-e-select-list\"></div>"));
	    if (width) {
	      _this.$elem.css('width', "".concat(width, "px"));
	    }
	    _this.$elem.on('click', function (e) {
	      // selectList 如有滚动条，可能会点击拖拽，参考 https://github.com/wangeditor-team/wangEditor-v5/issues/325
	      // 此时需要阻止冒泡，因为在 $container.on('mousedown', () => editor.hidePanelOrModal()) ，$container 就是 `.s-e-text-container`
	      e.stopPropagation();
	    });
	    return _this;
	  }

	  /**
	   * 渲染 list
	   * @param options select options
	   */
	  _createClass(SelectList, [{
	    key: "renderList",
	    value: function renderList(options) {
	      var $elem = this.$elem;
	      $elem.empty(); // 先清空内容，再重新渲染

	      var $list = $$x("<ul></ul>");
	      _forEachInstanceProperty(options).call(options, function (opt) {
	        var _context;
	        var value = opt.value,
	          text = opt.text,
	          selected = opt.selected,
	          styleForRenderMenuList = opt.styleForRenderMenuList;
	        var $li = $$x("<li data-value=\"".concat(value, "\"></li>")); // 【注意】必须用 <li> 必须用 data-value！！！

	        if (styleForRenderMenuList) {
	          $li.css(styleForRenderMenuList);
	        }
	        if (selected) {
	          var $selectedIcon = gen$SelectedIcon();
	          $li.append($selectedIcon);
	          $li.addClass('selected');
	        }
	        $li.append($$x(_concatInstanceProperty(_context = "<span data-value=\"".concat(value, "\">")).call(_context, text, "</span>")));
	        $li.attr('title', text);
	        $list.append($li);
	      });
	      $elem.append($list);
	    }
	  }, {
	    key: "genSelfElem",
	    value: function genSelfElem() {
	      return null;
	    }
	  }]);
	  return SelectList;
	}(PanelAndModal);

	// 根据 option value 获取 text
	function getOptionText(options, value) {
	  var length = options.length;
	  var text = '';
	  for (var i = 0; i < length; i++) {
	    var opt = options[i];
	    if (opt.value === value) {
	      text = opt.text;
	      break;
	    }
	  }
	  return text;
	}
	var BarItemSelect = /*#__PURE__*/function () {
	  function BarItemSelect(key, menu) {
	    var _this = this;
	    _classCallCheck(this, BarItemSelect);
	    _defineProperty$1(this, "$elem", $$x("<div class=\"s-e-bar-item\"></div>"));
	    _defineProperty$1(this, "$button", $$x("<button type=\"button\" class=\"select-button\"></button>"));
	    _defineProperty$1(this, "menu", void 0);
	    _defineProperty$1(this, "disabled", false);
	    _defineProperty$1(this, "selectList", null);
	    // 验证 tag
	    var tag = menu.tag;
	      menu.title;
	      var width = menu.width;
	      menu.iconSvg;
	      menu.hotkey;
	    if (tag !== 'select') throw new Error("Invalid tag '".concat(tag, "', expected 'select'"));

	    // 初始化 dom
	    var $button = this.$button;
	    if (width) {
	      $button.css('width', "".concat(width, "px"));
	    }
	    $button.attr('data-menu-key', key); // menu key
	    // addTooltip($button, iconSvg, title, hotkey, inGroup); // 设置 tooltip
	    this.$elem.append($button);
	    this.menu = menu;

	    // 异步绑定事件
	    promiseResolveThen(function () {
	      return _this.init();
	    });
	  }
	  _createClass(BarItemSelect, [{
	    key: "init",
	    value: function init() {
	      var _this2 = this;
	      // 设置 select 属性
	      this.setSelectedValue();

	      // select button click
	      this.$button.on('click', function (e) {
	        e.preventDefault();
	        var editor = getEditorInstance(_this2);
	        editor.hidePanelOrModal(); // 隐藏当前的各种 panel
	        _this2.trigger();
	      });
	    }
	  }, {
	    key: "trigger",
	    value: function trigger() {
	      var _this3 = this;
	      var editor = getEditorInstance(this);
	      if (editor.isDisabled()) return;
	      if (this.disabled) return;
	      var menu = this.menu;

	      // 显示下拉列表
	      if (this.selectList == null) {
	        // 初次创建，渲染 list 并显示
	        this.selectList = new SelectList(editor, menu.selectPanelWidth);
	        var selectList = this.selectList;
	        var options = menu.getOptions(editor);
	        selectList.renderList(options);
	        selectList.appendTo(this.$elem);
	        selectList.show();

	        // 初次创建，绑定事件
	        selectList.$elem.on('click', 'li', function (e) {
	          var target = e.target;
	          if (target == null) return;
	          e.preventDefault();
	          var $li = $$x(target);
	          var val = $li.attr('data-value');
	          _this3.onChange(val);
	        });
	      } else {
	        // 不是初次创建
	        var _selectList = this.selectList;
	        if (_selectList.isShow) {
	          // 当前处于显示状态，则隐藏
	          _selectList.hide();
	        } else {
	          // 当前未处于显示状态，则重新渲染 list ，并显示
	          var _options = menu.getOptions(editor); // 每次都要重新获取 options ，因为选中项可能会变化
	          _selectList.renderList(_options);
	          _selectList.show();
	        }
	      }
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(value) {
	      var editor = getEditorInstance(this);
	      var menu = this.menu;
	      menu.exec && menu.exec(editor, value);
	      editor.hidePanelOrModal(); // 隐藏 modal
	    }
	  }, {
	    key: "setSelectedValue",
	    value: function setSelectedValue() {
	      var editor = getEditorInstance(this);
	      var menu = this.menu;
	      var value = menu.getValue(editor);
	      var options = menu.getOptions(editor);
	      var optText = getOptionText(options, value.toString());
	      var $button = this.$button;
	      var $downArrow = $$x(SVG_DOWN_ARROW); // 向下的箭头图标
	      $button.empty();
	      $button.text(optText);
	      $button.append($downArrow);
	    }
	  }, {
	    key: "setDisabled",
	    value: function setDisabled() {
	      var editor = getEditorInstance(this);
	      var menu = this.menu;
	      var disabled = menu.isDisabled(editor);
	      var $button = this.$button;
	      if (editor.selection == null || editor.isDisabled()) {
	        // 未选中，或者 readOnly ，强行设置为 disabled
	        disabled = true;
	      }
	      var className = 'disabled';
	      if (disabled) {
	        // 设置为 disabled
	        $button.addClass(className);
	      } else {
	        // 取消 disabled
	        $button.removeClass(className);
	      }
	      this.disabled = disabled; // 记录下来
	    }
	  }, {
	    key: "changeMenuState",
	    value: function changeMenuState() {
	      this.setSelectedValue();
	      this.setDisabled();
	    }
	  }]);
	  return BarItemSelect;
	}();

	// menu -> barItem
	var MENU_TO_BAR_ITEM = new _WeakMap$1();
	function getEditorInstance(item) {
	  var editor = BAR_ITEM_TO_EDITOR.get(item);
	  if (editor == null) throw new Error('Can not get editor instance');
	  return editor;
	}

	/**
	 * 创建 bar button/select
	 * @param key menu key
	 * @param menu menu
	 * @param inGroup 在 groupButton 中
	 */
	function createBarItem(key, menu) {
	  var inGroup = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	  var barItem = MENU_TO_BAR_ITEM.get(menu);
	  if (barItem) return barItem;

	  // 缓存没有则创建
	  var tag = menu.tag,
	    showDropPanel = menu.showDropPanel,
	    showModal = menu.showModal;
	  if (tag === 'button') {
	    if (showDropPanel) {
	      barItem = new DropPanelButton(key, menu, inGroup);
	    } else if (showModal) {
	      barItem = new ModalButton(key, menu, inGroup);
	    } else {
	      barItem = new BaseButton(key, menu, inGroup);
	    }
	  }
	  if (tag === 'select') {
	    barItem = new BarItemSelect(key, menu, inGroup);
	  }
	  if (barItem == null) throw new Error("Invalid tag in menu ".concat(_JSON$stringify(menu)));

	  // 记录缓存
	  MENU_TO_BAR_ITEM.set(menu, barItem);
	  return barItem;
	}

	function _createForOfIteratorHelper$1(o, allowArrayLike) { var it = typeof _Symbol$1 !== "undefined" && _getIteratorMethod(o) || o["@@iterator"]; if (!it) { if (_Array$isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
	function _unsupportedIterableToArray$1(o, minLen) { var _context3; if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = _sliceInstanceProperty(_context3 = Object.prototype.toString.call(o)).call(_context3, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }
	function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	var Toolbar = /*#__PURE__*/function () {
	  function Toolbar(boxSelector, config) {
	    var _this = this;
	    _classCallCheck(this, Toolbar);
	    /**
	     * editor onChange 时触发（涉及 DOM 操作，加防抖）
	     */
	    _defineProperty$1(this, "changeToolbarState", debounce$2(function () {
	      var _context;
	      _forEachInstanceProperty(_context = _this.toolbarItems).call(_context, function (toolbarItem) {
	        toolbarItem.changeMenuState();
	      });
	    }, 200));
	    this.config = config;
	    // console.log(this.config);
	    this.$toolbar = $$x("<div class=\"s-e-bar s-e-toolbar\"></div>");
	    var $box;
	    //  初始化 DOM
	    if (boxSelector) {
	      $box = $$x(boxSelector);
	    } else {
	      $box = $$x("<div class=\"s-e-toolbar-box\"></div>");
	    }
	    if ($box.length === 0) {
	      throw new Error("Cannot find toolbar DOM by selector '".concat(boxSelector, "'"));
	    }
	    this.$box = $box;
	    var $toolbar = this.$toolbar;
	    $toolbar.on('mousedown', function (e) {
	      return e.preventDefault();
	    }, {
	      passive: false
	    }); // 防止点击失焦
	    $box.append($toolbar);
	    this.menus = {};
	    this.toolbarItems = [];

	    // 异步，否则拿不到 editor 实例
	    promiseResolveThen(function () {
	      _this.registerItems();

	      // 创建完，先模拟一次 onchange
	      _this.changeToolbarState();

	      // 监听 editor onchange
	      var editor = _this.getEditorInstance();
	      editor.on('change', _this.changeToolbarState);
	    });
	  }
	  _createClass(Toolbar, [{
	    key: "getMenus",
	    value: function getMenus() {
	      return this.menus;
	    }
	  }, {
	    key: "getConfig",
	    value: function getConfig() {
	      return this.config;
	    }
	  }, {
	    key: "getEditorInstance",
	    value: function getEditorInstance() {
	      var editor = TOOLBAR_TO_EDITOR.get(this);
	      if (editor == null) throw new Error('Can not get editor instance');
	      return editor;
	    }
	  }, {
	    key: "registerItems",
	    value: function registerItems() {
	      var toolbarKeys = this.config.toolbarKeys;
	      var _iterator = _createForOfIteratorHelper$1(toolbarKeys),
	        _step;
	      try {
	        for (_iterator.s(); !(_step = _iterator.n()).done;) {
	          var key = _step.value;
	          if (key == '|') {
	            // bar item 分割线
	            var $barItemDivider = $$x('<div class="s-e-bar-divider"></div>');
	            this.$toolbar.append($barItemDivider);
	            continue;
	          }
	          this.registerSingleItem(key, this);
	        }
	      } catch (err) {
	        _iterator.e(err);
	      } finally {
	        _iterator.f();
	      }
	    }
	  }, {
	    key: "registerSingleItem",
	    value: function registerSingleItem(key, container) {
	      var editor = this.getEditorInstance();
	      // 尝试从缓存中获取
	      var menus = this.menus;
	      var menu = menus[key];
	      if (menu == null) {
	        // 缓存中没有，则创建
	        var factory = MENU_ITEM_FACTORIES[key];
	        if (factory == null) {
	          throw new Error("Not found menu item factory by key '".concat(key, "'"));
	        }
	        if (typeof factory !== 'function') {
	          throw new Error("Menu item factory (key='".concat(key, "') is not a function"));
	        }

	        // 创建 toolbarItem 并记录缓存
	        menu = factory();
	        menus[key] = menu;
	      } else {
	        var _context2;
	        console.warn(_concatInstanceProperty(_context2 = "Duplicated toolbar menu key '".concat(key, "'\n\u91CD\u590D\u6CE8\u518C\u4E86\u83DC\u5355\u680F menu '")).call(_context2, key, "'"));
	      }
	      var toolbarItem = createBarItem(key, menu);
	      this.toolbarItems.push(toolbarItem);
	      // 保存 toolbarItem 和 editor 的关系
	      BAR_ITEM_TO_EDITOR.set(toolbarItem, editor);
	      // barItem 添加到 toolbar
	      var toolbar = container;
	      toolbar.$toolbar.append(toolbarItem.$elem);
	    }
	  }, {
	    key: "destroy",
	    value:
	    /**
	     * 销毁 toolbar
	     */
	    function destroy() {
	      // 销毁 DOM
	      this.$toolbar.remove();

	      // 清空属性
	      this.menus = {};
	      this.toolbarItems = [];
	    }
	  }]);
	  return Toolbar;
	}();

	function createToolbar (editor, option) {
	  if (editor == null) {
	    throw new Error("Cannot create toolbar, because editor is null");
	  }
	  var selector = option.selector;

	  // 创建 toolbar ，并记录和 editor 关系
	  var toolbar = new Toolbar(selector, option);
	  TOOLBAR_TO_EDITOR.set(toolbar, editor);
	  EDITOR_TO_TOOLBAR.set(editor, toolbar);
	  return toolbar;
	}

	var call = functionCall;
	var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
	var anObject = anObject$e;
	var isNullOrUndefined = isNullOrUndefined$7;
	var toLength = toLength$6;
	var toString$1 = toString$i;
	var requireObjectCoercible$1 = requireObjectCoercible$c;
	var getMethod = getMethod$4;
	var advanceStringIndex = advanceStringIndex$3;
	var regExpExec = regexpExecAbstract;

	// @@match logic
	fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.es/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = requireObjectCoercible$1(this);
	      var matcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, MATCH);
	      return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString$1(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
	    function (string) {
	      var rx = anObject(this);
	      var S = toString$1(string);
	      var res = maybeCallNative(nativeMatch, rx, S);

	      if (res.done) return res.value;

	      if (!rx.global) return regExpExec(rx, S);

	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = toString$1(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});

	/**
	 * 是否选中了 text （用于 text hoverbarKeys）
	 * @param editor editor
	 * @param n node
	 */
	function isSelectedText(editor, n) {
	  var selection = editor.selection;
	  if (selection == null) return false; // 无选区
	  if (Range.isCollapsed(selection)) return false; // 未选中文字，选区的是折叠的

	  var selectedElems = DomEditor.getSelectedElems(editor);
	  var notMatch = _someInstanceProperty(selectedElems).call(selectedElems, function (elem) {
	    var _context;
	    if (editor.isVoid(elem)) return true;
	    var type = elem.type;
	    if (_includesInstanceProperty(_context = ['pre', 'code', 'table']).call(_context, type)) return true;
	  });
	  if (notMatch) return false;
	  if (Text.isText(n)) return true; // 匹配 text node
	  return false;
	}
	var HoverBar = /*#__PURE__*/function () {
	  function HoverBar() {
	    var _this = this;
	    _classCallCheck(this, HoverBar);
	    _defineProperty$1(this, "$elem", $$x('<div class="s-e-bar s-e-hover-bar s-e-bar-hidden"></div>'));
	    _defineProperty$1(this, "menus", {});
	    _defineProperty$1(this, "hoverbarItems", []);
	    _defineProperty$1(this, "prevSelectedNode", null);
	    // 上一次选中的 node
	    _defineProperty$1(this, "isShow", false);
	    /**
	     * editor onChange 时触发（涉及 DOM 操作，加防抖）
	     */
	    _defineProperty$1(this, "changeHoverbarState", debounce$2(function () {
	      // 获取选中的 node ，以及对应的 menu keys
	      var isShow = _this.isShow;
	      var _ref = _this.getSelectedNodeAndMenuKeys() || {},
	        _ref$node = _ref.node,
	        node = _ref$node === void 0 ? null : _ref$node,
	        _ref$menuKeys = _ref.menuKeys,
	        menuKeys = _ref$menuKeys === void 0 ? [] : _ref$menuKeys;
	      if (node != null) {
	        _this.changeItemsState(); // 更新菜单状态
	      }

	      if (node && Element.isElement(node)) {
	        // 选中了 elem node（不可以是 text node）
	        if (isShow) {
	          // hoverbar 当前已显示
	          var samePath = _this.isSamePath(node, _this.prevSelectedNode);
	          if (samePath) {
	            // 和之前选中的 node path 相同 —— 满足这些条件，即终止
	            return;
	          }
	        }
	      }

	      // 选择了新的 node（或选区是 null），先隐藏
	      _this.hideAndClean();
	      if (node != null) {
	        // 选中了新的 node
	        _this.registerItems(menuKeys);
	        _this.setPosition(node);
	        _this.show();
	      }

	      // 最后，重新记录 prevSelectedNode ，重要
	      _this.prevSelectedNode = node;
	    }, 200));
	    // 异步，否则获取不到 DOM 和 editor
	    promiseResolveThen(function () {
	      var _context2;
	      var editor = _this.getEditorInstance();

	      // 将 elem 渲染为 DOM
	      var $elem = _this.$elem;
	      // @ts-ignore
	      $elem.on('mousedown', function (e) {
	        return e.preventDefault();
	      }, {
	        passive: false
	      }); // 防止点击失焦
	      var textarea = DomEditor.getTextarea(editor);
	      textarea.$container.append($elem);

	      // 绑定 editor onchange
	      editor.on('change', _this.changeHoverbarState);

	      // 滚动时隐藏
	      var hideAndClean = _bindInstanceProperty$1(_context2 = _this.hideAndClean).call(_context2, _this);
	      editor.on('scroll', hideAndClean);
	    });
	  }
	  _createClass(HoverBar, [{
	    key: "getMenus",
	    value: function getMenus() {
	      return this.menus;
	    }
	  }, {
	    key: "hideAndClean",
	    value: function hideAndClean() {
	      var $elem = this.$elem;
	      $elem.removeClass('s-e-bar-show').addClass('s-e-bar-hidden');

	      // 及时先清空内容，否则影响下次
	      this.hoverbarItems = [];
	      $elem.empty();
	      this.isShow = false;
	    }

	    /**
	     * 判断 hoverbar 是否在网页下部？
	     * 如果是，SelectList 和 DropPanel 要显示在 hoverbar 上面
	     */
	  }, {
	    key: "checkPositionBottom",
	    value: function checkPositionBottom() {
	      var $elem = this.$elem;
	      var isBottom = false;
	      var _window = window,
	        innerHeight = _window.innerHeight;
	      var minDistance = 360; // 距离底部最小 360px
	      if (innerHeight && innerHeight >= minDistance) {
	        var _$elem$0$getBoundingC = $elem[0].getBoundingClientRect(),
	          bottom = _$elem$0$getBoundingC.bottom;
	        if (innerHeight - bottom < minDistance) {
	          // hoverbar 距离底部不足 360
	          isBottom = true;
	        }
	      }
	      if (isBottom) {
	        $elem.addClass('s-e-bar-bottom');
	      } else {
	        $elem.removeClass('s-e-bar-bottom');
	      }
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      this.$elem.removeClass('s-e-bar-hidden').addClass('s-e-bar-show');
	      this.isShow = true;

	      // 判断 hoverbar 是否在网页下部
	      this.checkPositionBottom();
	    }
	  }, {
	    key: "changeItemsState",
	    value: function changeItemsState() {
	      var _this2 = this;
	      promiseResolveThen(function () {
	        var _context3;
	        _forEachInstanceProperty(_context3 = _this2.hoverbarItems).call(_context3, function (item) {
	          item.changeMenuState();
	        });
	      });
	    }
	  }, {
	    key: "registerItems",
	    value: function registerItems(menuKeys) {
	      var _this3 = this;
	      var $elem = this.$elem;
	      _forEachInstanceProperty(menuKeys).call(menuKeys, function (key) {
	        if (key === '|') {
	          // 分割线
	          var $divider = $$x('<div class="s-e-bar-divider"></div>');
	          $elem.append($divider);
	          return;
	        }

	        // 正常菜单
	        _this3.registerSingleItem(key);
	      });
	    }

	    // 注册单个 bar item
	  }, {
	    key: "registerSingleItem",
	    value: function registerSingleItem(key) {
	      var editor = this.getEditorInstance();

	      // 尝试从缓存中获取
	      var menus = this.menus;
	      var menu = menus[key];
	      if (menu == null) {
	        // 缓存获取失败，则重新创建
	        var factory = MENU_ITEM_FACTORIES[key];
	        if (factory == null) {
	          throw new Error("Not found menu item factory by key '".concat(key, "'"));
	        }
	        if (typeof factory !== 'function') {
	          throw new Error("Menu item factory (key='".concat(key, "') is not a function"));
	        }

	        // 创建 barItem 并记录缓存
	        menu = factory();
	        menus[key] = menu;
	      }
	      var barItem = createBarItem(key, menu);
	      this.hoverbarItems.push(barItem);

	      // 保存 barItem 和 editor 的关系
	      BAR_ITEM_TO_EDITOR.set(barItem, editor);

	      // 添加 DOM
	      var $elem = this.$elem;
	      $elem.append(barItem.$elem);
	    }
	  }, {
	    key: "setPosition",
	    value: function setPosition(node) {
	      var editor = this.getEditorInstance();
	      var $elem = this.$elem;
	      $elem.attr('style', ''); // 先清空 style ，再重新设置

	      if (Element.isElement(node)) {
	        // 根据 elem node 定位
	        var positionStyle = getPositionByNode(editor, node, 'bar');
	        $elem.css(positionStyle);
	        // correctPosition(editor, $elem); // 修正 position 避免超出 textContainer 边界
	        return;
	      }
	      if (Text.isText(node)) {
	        // text node ，根据选区定位
	        var _positionStyle = getPositionBySelection(editor);
	        $elem.css(_positionStyle);
	        // correctPosition(editor, $elem); // 修正 position 避免超出 textContainer 边界
	        return;
	      }
	      // 其他情况，非 elem 非 text ，不处理
	      throw new Error('hoverbar.setPosition error, current selected node is not elem nor text');
	    }

	    /**
	     * 获取选中的 node ，以及对应的 menu keys
	     */
	  }, {
	    key: "getSelectedNodeAndMenuKeys",
	    value: function getSelectedNodeAndMenuKeys() {
	      var editor = this.getEditorInstance();
	      if (editor.selection == null) {
	        return null;
	      }

	      // 获取 hover bar 配置
	      var keysConf = this.getHoverbarKeysConf();
	      // 开始匹配
	      var matchNode = null;
	      var matchMenuKeys = [];
	      var _loop = function _loop(elemType) {
	        var conf = keysConf[elemType];
	        var match = conf.match,
	          _conf$menuKeys = conf.menuKeys,
	          menuKeys = _conf$menuKeys === void 0 ? [] : _conf$menuKeys;

	        // 定义了 match 则用 match 。未定义 match 则用 elemType
	        var matchFn = match ? match : function (editor, n) {
	          return DomEditor.checkNodeType(n, elemType);
	        };
	        var _Editor$nodes = Editor.nodes(editor, {
	            match: function match(n) {
	              return matchFn(editor, n);
	            },
	            universal: true
	          }),
	          _Editor$nodes2 = _slicedToArray(_Editor$nodes, 1),
	          nodeEntry = _Editor$nodes2[0];

	        // 匹配成功（找到第一个就停止，不再继续找了）
	        if (nodeEntry != null) {
	          matchNode = nodeEntry[0];
	          matchMenuKeys = menuKeys;
	          return 1; // break
	        }
	      };
	      for (var elemType in keysConf) {
	        if (_loop(elemType)) break;
	      }

	      // 未匹配成功
	      if (matchNode == null || matchMenuKeys.length === 0) return null;

	      // 匹配成功
	      return {
	        node: matchNode,
	        menuKeys: matchMenuKeys
	      };
	    }
	  }, {
	    key: "getEditorInstance",
	    value: function getEditorInstance() {
	      var editor = HOVER_BAR_TO_EDITOR.get(this);
	      if (editor == null) throw new Error('Can not get editor instance');
	      return editor;
	    }
	  }, {
	    key: "getHoverbarKeysConf",
	    value: function getHoverbarKeysConf() {
	      var editor = this.getEditorInstance();
	      var _editor$getConfig = editor.getConfig(),
	        _editor$getConfig$hov = _editor$getConfig.hoverbarKeys,
	        hoverbarKeys = _editor$getConfig$hov === void 0 ? {} : _editor$getConfig$hov;
	      var textHoverbarKeys = hoverbarKeys.text;
	      if (textHoverbarKeys && textHoverbarKeys.match == null) {
	        // 对 text hoverbarKeys 增加 match 函数（否则无法判断是否选中了 text）
	        textHoverbarKeys.match = isSelectedText;
	      }
	      return hoverbarKeys;
	    }

	    /**
	     * 检查两个 node 是否 path 相等
	     */
	  }, {
	    key: "isSamePath",
	    value: function isSamePath(node1, node2) {
	      if (node1 == null || node2 == null) {
	        return false;
	      }
	      var path1 = DomEditor.findPath(null, node1);
	      var path2 = DomEditor.findPath(null, node2);
	      var res = Path.equals(path1, path2);
	      return res;
	    }

	    /**
	     * 销毁 hoverbar
	     */
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      // fix https://github.com/wangeditor-team/wangEditor-v5/issues/410
	      this.changeHoverbarState.cancel();
	      // 销毁 DOM
	      this.$elem.remove();

	      // 清空属性
	      this.menus = {};
	      this.hoverbarItems = [];
	      this.prevSelectedNode = null;
	    }
	  }]);
	  return HoverBar;
	}();

	function coreCreateEditor (option) {
	  var _option$selector = option.selector,
	    selector = _option$selector === void 0 ? '' : _option$selector,
	    _option$config = option.config,
	    config = _option$config === void 0 ? {} : _option$config,
	    _option$content = option.content,
	    content = _option$content === void 0 ? [] : _option$content,
	    _option$plugins = option.plugins,
	    plugins = _option$plugins === void 0 ? [] : _option$plugins;
	  var editor = withHistory(withEmitter(withSelection(withContent(withConfig(withDOM(withEventData(createEditor$1())))))));

	  // 处理配置
	  var editorConfig = config;
	  EDITOR_TO_CONFIG.set(editor, editorConfig);
	  var _editorConfig$hoverba = editorConfig.hoverbarKeys,
	    hoverbarKeys = _editorConfig$hoverba === void 0 ? {} : _editorConfig$hoverba,
	    hideToolbar = editorConfig.hideToolbar;
	  // console.log(hideToolbar);

	  // 注册第三方插件
	  _forEachInstanceProperty(plugins).call(plugins, function (plugin) {
	    if (typeof plugin === 'function') editor = plugin(editor);
	  });

	  // 初始化内容
	  if (content) {
	    editor.children = content;
	  }

	  // console.log(editor);

	  if (selector) {
	    var editable = new Editable(selector);
	    var toolbar = createToolbar(editor, editorConfig);
	    editable.$box.prepend(toolbar.$box);
	    // console.log(focusShowToolbar);
	    if (hideToolbar) {
	      toolbar.$box.hide();
	    }
	    TEXTAREA_TO_EDITOR.set(editable, editor);
	    EDITOR_TO_TEXTAREA.set(editor, editable);
	    // 初始化渲染
	    editable.changeViewState();

	    // 创建 hoverbar DOM
	    var hoverbar;
	    if (_Object$keys(hoverbarKeys).length > 0) {
	      hoverbar = new HoverBar();
	      HOVER_BAR_TO_EDITOR.set(hoverbar, editor);
	      EDITOR_TO_HOVER_BAR.set(editor, hoverbar);
	    }

	    // 隐藏 panel and modal
	    // editor.on('change', () => {
	    //   editor.hidePanelOrModal()
	    // })
	    editor.on('scroll', function () {
	      editor.hidePanelOrModal();
	    });
	  } else {
	    var _context;
	    // 未传入 selector ，则遍历 content ，绑定一些 WeakMap 关系 （ NODE_TO_PARENT, NODE_TO_INDEX 等 ）
	    _forEachInstanceProperty(_context = editor.children).call(_context, function (node, i) {
	      return bindNodeRelation(node, i, editor, editor);
	    });
	  }
	  return editor;
	}

	var COMMON_TOOLBAR_KEYS = ['bold', 'underline', 'italic', 'through', 'clearStyle', '|', 'insertLink', 'insertButton', '|', 'uploadImage', 'color', 'bgColor', '|', 'fontSize', 'lineHeight'];
	var COMMON_HOVERBAR_KEYS = {
	  text: {
	    menuKeys: ['bold', 'clearStyle', '|', 'insertLink']
	  },
	  link: {
	    menuKeys: ['editLink', 'unLink', 'viewLink']
	  },
	  button: {
	    menuKeys: ['editButton', 'execButton']
	  },
	  image: {
	    menuKeys: ['verticalAlignTopImage', 'verticalAlignMiddleImage', 'verticalAlignBottomImage', '|', 'editImage', 'deleteImage']
	  }
	};

	function registerModule(module) {
	  var menus = module.menus,
	    renderElems = module.renderElems,
	    renderStyle = module.renderStyle,
	    editorPlugins = module.editorPlugins;
	  // 菜单
	  if (menus) {
	    _forEachInstanceProperty(menus).call(menus, function (menu) {
	      return registerMenu(menu);
	    });
	  }
	  // Element
	  if (renderElems) {
	    _forEachInstanceProperty(renderElems).call(renderElems, function (renderElemConf) {
	      return registerRenderElemConf(renderElemConf);
	    });
	  }
	  // Text
	  if (renderStyle) {
	    registerStyleHandler(renderStyle);
	  }

	  // eidtor 插件
	  if (editorPlugins) {
	    _forEachInstanceProperty(editorPlugins).call(editorPlugins, function (plugin) {
	      return registerPlugin(plugin);
	    });
	  }
	}

	var $$8 = _export;
	var createHTML$3 = createHtml;
	var forcedStringHTMLMethod$3 = stringHtmlForced;

	// `String.prototype.bold` method
	// https://tc39.es/ecma262/#sec-string.prototype.bold
	$$8({ target: 'String', proto: true, forced: forcedStringHTMLMethod$3('bold') }, {
	  bold: function bold() {
	    return createHTML$3(this, 'b', '', '');
	  }
	});

	var $$7 = _export;
	var createHTML$2 = createHtml;
	var forcedStringHTMLMethod$2 = stringHtmlForced;

	// `String.prototype.italics` method
	// https://tc39.es/ecma262/#sec-string.prototype.italics
	$$7({ target: 'String', proto: true, forced: forcedStringHTMLMethod$2('italics') }, {
	  italics: function italics() {
	    return createHTML$2(this, 'i', '', '');
	  }
	});

	var $$6 = _export;
	var createHTML$1 = createHtml;
	var forcedStringHTMLMethod$1 = stringHtmlForced;

	// `String.prototype.sub` method
	// https://tc39.es/ecma262/#sec-string.prototype.sub
	$$6({ target: 'String', proto: true, forced: forcedStringHTMLMethod$1('sub') }, {
	  sub: function sub() {
	    return createHTML$1(this, 'sub', '', '');
	  }
	});

	var $$5 = _export;
	var createHTML = createHtml;
	var forcedStringHTMLMethod = stringHtmlForced;

	// `String.prototype.sup` method
	// https://tc39.es/ecma262/#sec-string.prototype.sup
	$$5({ target: 'String', proto: true, forced: forcedStringHTMLMethod('sup') }, {
	  sup: function sup() {
	    return createHTML(this, 'sup', '', '');
	  }
	});

	/**
	 * 添加样式
	 * @param node slate text
	 * @param vnode vnode
	 * @returns vnode
	 */
	function renderStyle$3(node, vnode) {
	  var bold = node.bold,
	    italic = node.italic,
	    underline = node.underline;
	    node.code;
	    var through = node.through;
	    node.sub;
	    node.sup;
	  var styleVnode = vnode;

	  // color bgColor 在另外的菜单

	  if (bold) {
	    styleVnode = h('strong', {}, styleVnode);
	  }
	  if (italic) {
	    styleVnode = h('em', {}, styleVnode);
	  }
	  if (underline) {
	    styleVnode = h('u', {}, styleVnode);
	  }
	  if (through) {
	    styleVnode = h('s', {}, styleVnode);
	  }
	  return styleVnode;
	}

	/**
	 * 【注意】svg 字符串的长度 ，否则会导致代码体积过大
	 * 尽量选择 https://www.iconfont.cn/collections/detail?spm=a313x.7781069.0.da5a778a4&cid=20293
	 * 找不到再从 iconfont.com 搜索
	 */

	// 加粗
	var BOLD_SVG = '<svg viewBox="0 0 1024 1024"><path d="M707.872 484.64A254.88 254.88 0 0 0 768 320c0-141.152-114.848-256-256-256H192v896h384c141.152 0 256-114.848 256-256a256.096 256.096 0 0 0-124.128-219.36zM384 192h101.504c55.968 0 101.504 57.408 101.504 128s-45.536 128-101.504 128H384V192z m159.008 640H384v-256h159.008c58.464 0 106.016 57.408 106.016 128s-47.552 128-106.016 128z"></path></svg>';

	// 下划线
	var UNDER_LINE_SVG = '<svg viewBox="0 0 1024 1024"><path d="M704 64l128 0 0 416c0 159.072-143.264 288-320 288s-320-128.928-320-288l0-416 128 0 0 416c0 40.16 18.24 78.688 51.36 108.512 36.896 33.216 86.848 51.488 140.64 51.488s103.744-18.304 140.64-51.488c33.12-29.792 51.36-68.352 51.36-108.512l0-416zM192 832l640 0 0 128-640 0z"></path></svg>';

	// 斜体
	var ITALIC_SVG = '<svg viewBox="0 0 1024 1024"><path d="M896 64v64h-128L448 896h128v64H128v-64h128L576 128h-128V64z"></path></svg>';

	// 删除线
	var THROUGH_SVG = '<svg viewBox="0 0 1024 1024"><path d="M1024 512v64h-234.496c27.52 38.496 42.496 82.688 42.496 128 0 70.88-36.672 139.04-100.576 186.976C672.064 935.488 594.144 960 512 960s-160.064-24.512-219.424-69.024C228.64 843.04 192 774.88 192 704h128c0 69.376 87.936 128 192 128s192-58.624 192-128-87.936-128-192-128H0v-64h299.52a385.984 385.984 0 0 1-6.944-5.024C228.64 459.04 192 390.88 192 320s36.672-139.04 100.576-186.976C351.936 88.512 429.856 64 512 64s160.064 24.512 219.424 69.024C795.328 180.96 832 249.12 832 320h-128c0-69.376-87.936-128-192-128s-192 58.624-192 128 87.936 128 192 128c78.976 0 154.048 22.688 212.48 64H1024z"></path></svg>';

	// 清除格式
	var ERASER_SVG = '<svg viewBox="0 0 1024 1024"><path d="M969.382408 288.738615l-319.401123-270.852152a67.074236 67.074236 0 0 0-96.459139 5.74922l-505.931379 574.922021a68.35184 68.35184 0 0 0-17.886463 47.910169 74.101061 74.101061 0 0 0 24.274486 47.910168l156.50655 132.232065h373.060512L975.131628 383.281347a67.074236 67.074236 0 0 0-5.74922-96.459139z m-440.134747 433.746725H264.144729l-90.071117-78.572676c-5.74922-5.74922-12.137243-12.137243-12.137243-17.886463a36.411728 36.411728 0 0 1 5.749221-24.274485l210.804741-240.828447 265.102932 228.691204z m-439.495945 180.781036h843.218964a60.047411 60.047411 0 1 1 0 120.733624H89.751716a60.047411 60.047411 0 1 1 0-120.733624z m0 0"></path></svg>';

	// 链接
	var LINK_SVG = '<svg viewBox="0 0 1024 1024"><path d="M440.224 635.776a51.84 51.84 0 0 1-36.768-15.232c-95.136-95.136-95.136-249.92 0-345.056l192-192C641.536 37.408 702.816 12.032 768 12.032s126.432 25.376 172.544 71.456c95.136 95.136 95.136 249.92 0 345.056l-87.776 87.776a51.968 51.968 0 1 1-73.536-73.536l87.776-87.776a140.16 140.16 0 0 0 0-197.984c-26.432-26.432-61.6-40.992-99.008-40.992s-72.544 14.56-99.008 40.992l-192 192a140.16 140.16 0 0 0 0 197.984 51.968 51.968 0 0 1-36.768 88.768z"></path><path d="M256 1012a242.4 242.4 0 0 1-172.544-71.456c-95.136-95.136-95.136-249.92 0-345.056l87.776-87.776a51.968 51.968 0 1 1 73.536 73.536l-87.776 87.776a140.16 140.16 0 0 0 0 197.984c26.432 26.432 61.6 40.992 99.008 40.992s72.544-14.56 99.008-40.992l192-192a140.16 140.16 0 0 0 0-197.984 51.968 51.968 0 1 1 73.536-73.536c95.136 95.136 95.136 249.92 0 345.056l-192 192A242.4 242.4 0 0 1 256 1012z"></path></svg>';

	// 取消链接
	var UN_LINK_SVG = '<svg viewBox="0 0 1024 1024"><path d="M608.16328 811.815036c9.371954 9.371954 9.371954 24.56788 0 33.941834l-89.347563 89.347564c-118.525421 118.523421-311.38448 118.531421-429.919901 0-118.527421-118.529421-118.527421-311.39048 0-429.917901l89.349564-89.349563c9.371954-9.371954 24.56788-9.371954 33.941834 0l79.195613 79.195613c9.371954 9.371954 9.371954 24.56788 0 33.941834l-89.349563 89.347564c-56.143726 56.145726-56.143726 147.49928 0 203.645005 56.143726 56.143726 147.49928 56.145726 203.647005 0l89.347564-89.347563c9.371954-9.371954 24.56788-9.371954 33.941834 0l79.193613 79.195613z m-113.135447-520.429459c9.371954 9.371954 24.56788 9.371954 33.941834 0l89.347564-89.347564c56.143726-56.149726 147.49928-56.145726 203.647006 0 56.143726 56.145726 56.143726 147.49928 0 203.645006l-89.349564 89.347564c-9.371954 9.371954-9.371954 24.56788 0 33.941834l79.195613 79.195613c9.371954 9.371954 24.56788 9.371954 33.941834 0l89.349564-89.349563c118.529421-118.529421 118.529421-311.38848 0-429.917901-118.531421-118.527421-311.38848-118.527421-429.919901 0l-89.347563 89.347564c-9.371954 9.371954-9.371954 24.56788 0 33.941834l79.193613 79.195613z m469.653707 718.556492l45.253779-45.253779c18.745908-18.745908 18.745908-49.13776 0-67.881669L127.195629 14.062931c-18.745908-18.745908-49.13776-18.745908-67.881669 0L14.058181 59.31871c-18.745908 18.745908-18.745908 49.13776 0 67.881669l882.74169 882.74169c18.745908 18.743908 49.13776 18.743908 67.881669 0z"></path></svg>';

	// 编辑
	var PENCIL_SVG = '<svg viewBox="0 0 1024 1024"><path d="M864 0a160 160 0 0 1 128 256l-64 64-224-224 64-64c26.752-20.096 59.968-32 96-32zM64 736l-64 288 288-64 592-592-224-224L64 736z m651.584-372.416l-448 448-55.168-55.168 448-448 55.168 55.168z"></path></svg>';

	// 外部（链接）
	var EXTERNAL_SVG = '<svg viewBox="0 0 1024 1024"><path d="M924.402464 1023.068211H0.679665V99.345412h461.861399v98.909208H99.596867v725.896389h725.896389V561.206811h98.909208z" p-id="10909"></path><path d="M930.805104 22.977336l69.965436 69.965436-453.492405 453.492404-69.965435-69.901489z" p-id="10910"></path><path d="M1022.464381 304.030081h-98.917201V99.345412H709.230573V0.428211h313.233808z"></path></svg>';

	// 字体颜色
	var FONT_COLOR_SVG = '<svg viewBox="0 0 1024 1024"><path d="M64 864h896v96H64zM360.58 576h302.85l81.53 224h102.16L579.24 64H444.77L176.89 800h102.16l81.53-224zM512 159.96L628.49 480H395.52L512 159.96z"></path></svg>';

	// 背景颜色
	var BG_COLOR_SVG = '<svg viewBox="0 0 1024 1024"><path d="M510.030769 315.076923l84.676923 196.923077h-177.230769l76.8-196.923077h15.753846zM945.230769 157.538462v708.923076c0 43.323077-35.446154 78.769231-78.769231 78.769231H157.538462c-43.323077 0-78.769231-35.446154-78.769231-78.769231V157.538462c0-43.323077 35.446154-78.769231 78.769231-78.769231h708.923076c43.323077 0 78.769231 35.446154 78.769231 78.769231z m-108.307692 643.938461L600.615385 216.615385c-5.907692-11.815385-15.753846-19.692308-29.538462-19.692308h-139.815385c-11.815385 0-23.630769 7.876923-27.56923 19.692308l-216.615385 584.861538c-3.938462 11.815385 3.938462 25.6 17.723077 25.6h80.738462c11.815385 0 23.630769-9.846154 27.56923-21.661538l63.015385-175.261539h263.876923l68.923077 175.261539c3.938462 11.815385 15.753846 21.661538 27.569231 21.661538h80.738461c13.784615 0 23.630769-13.784615 19.692308-25.6z"></path></svg>';

	// 清空（颜色）
	var CLEAN_SVG = '<svg viewBox="0 0 1024 1024"><path d="M236.8 128L896 787.2V128H236.8z m614.4 704L192 172.8V832h659.2zM192 64h704c38.4 0 64 25.6 64 64v704c0 38.4-25.6 64-64 64H192c-38.4 0-64-25.6-64-64V128c0-38.4 25.6-64 64-64z"></path></svg>';

	// 垃圾桶（删除）
	var TRASH_SVG = '<svg viewBox="0 0 1024 1024"><path d="M826.8032 356.5312c-19.328 0-36.3776 15.6928-36.3776 35.0464v524.2624c0 19.328-16 34.56-35.328 34.56H264.9344c-19.328 0-35.5072-15.3088-35.5072-34.56V390.0416c0-19.328-14.1568-35.0464-33.5104-35.0464s-33.5104 15.6928-33.5104 35.0464V915.712c0 57.9328 44.6208 108.288 102.528 108.288H755.2c57.9328 0 108.0832-50.4576 108.0832-108.288V391.4752c-0.1024-19.2512-17.1264-34.944-36.48-34.944z" p-id="9577"></path><path d="M437.1712 775.7568V390.6048c0-19.328-14.1568-35.0464-33.5104-35.0464s-33.5104 15.616-33.5104 35.0464v385.152c0 19.328 14.1568 35.0464 33.5104 35.0464s33.5104-15.7184 33.5104-35.0464zM649.7024 775.7568V390.6048c0-19.328-17.0496-35.0464-36.3776-35.0464s-36.3776 15.616-36.3776 35.0464v385.152c0 19.328 17.0496 35.0464 36.3776 35.0464s36.3776-15.7184 36.3776-35.0464zM965.0432 217.0368h-174.6176V145.5104c0-57.9328-47.2064-101.76-104.6528-101.76h-350.976c-57.8304 0-105.3952 43.8528-105.3952 101.76v71.5264H54.784c-19.4304 0-35.0464 14.1568-35.0464 33.5104 0 19.328 15.616 33.5104 35.0464 33.5104h910.3616c19.328 0 35.0464-14.1568 35.0464-33.5104 0-19.3536-15.6928-33.5104-35.1488-33.5104z m-247.3728 0H297.3952V145.5104c0-19.328 18.2016-34.7648 37.4272-34.7648h350.976c19.1488 0 31.872 15.1296 31.872 34.7648v71.5264z"></path></svg>';

	// fontSize
	var FONT_SIZE_SVG = '<svg viewBox="0 0 1024 1024"><path d="M64 512h384v128h-128V1024h-128V640h-128z m896-256H708.2496v768h-136.4992V256H320V128h640z"></path></svg>';

	// 行高
	var LINE_HEIGHT_SVG = '<svg viewBox="0 0 1024 1024"><path d="M964 788a8 8 0 0 1 8 8v98a8 8 0 0 1-8 8H438a8 8 0 0 1-8-8v-98a8 8 0 0 1 8-8h526zM198.93 144.306c6.668-5.798 16.774-5.094 22.573 1.574l122.26 140.582a16 16 0 0 1 3.927 10.5c0 8.836-7.164 16-16 16h-61.8a8 8 0 0 0-8 8v390.077h69.819a16 16 0 0 1 10.502 3.928c6.666 5.8 7.37 15.906 1.57 22.573L221.476 878.123a16 16 0 0 1-1.57 1.57c-6.668 5.8-16.774 5.097-22.574-1.57L75.051 737.538a16 16 0 0 1-3.928-10.5c0-8.837 7.163-16 16-16h69.822V312.96H87.127a16 16 0 0 1-10.502-3.928c-6.666-5.8-7.37-15.906-1.57-22.573l122.303-140.582a16 16 0 0 1 1.572-1.572zM964 465a8 8 0 0 1 8 8v98a8 8 0 0 1-8 8H438a8 8 0 0 1-8-8v-98a8 8 0 0 1 8-8h526z m0-323a8 8 0 0 1 8 8v98a8 8 0 0 1-8 8H438a8 8 0 0 1-8-8v-98a8 8 0 0 1 8-8h526z"></path></svg>';

	// 上传图片
	var UPLOAD_IMAGE_SVG = '<svg viewBox="0 0 1024 1024"><path d="M828.708571 585.045333a48.761905 48.761905 0 0 0-48.737523 48.761905v18.529524l-72.143238-72.167619a135.972571 135.972571 0 0 0-191.585524 0l-34.133334 34.133333-120.880762-120.953905a138.898286 138.898286 0 0 0-191.585523 0l-72.167619 72.167619V292.400762a48.786286 48.786286 0 0 1 48.761904-48.761905h341.23581a48.737524 48.737524 0 0 0 34.474667-83.285333 48.737524 48.737524 0 0 0-34.474667-14.287238H146.236952A146.212571 146.212571 0 0 0 0 292.400762v585.289143A146.358857 146.358857 0 0 0 146.236952 1024h584.996572a146.212571 146.212571 0 0 0 146.236952-146.310095V633.807238a48.786286 48.786286 0 0 0-48.761905-48.761905zM146.261333 926.45181a48.737524 48.737524 0 0 1-48.761904-48.761905v-174.128762l141.409523-141.458286a38.497524 38.497524 0 0 1 53.126096 0l154.526476 154.624 209.627428 209.724953H146.236952z m633.734096-48.761905c-0.073143 9.337905-3.145143 18.383238-8.777143 25.843809l-219.843048-220.94019 34.133333-34.133334a37.546667 37.546667 0 0 1 53.613715 0l140.873143 141.897143V877.714286zM1009.615238 160.231619L863.329524 13.897143a48.737524 48.737524 0 0 0-16.091429-10.24c-11.849143-4.87619-25.161143-4.87619-37.059047 0a48.761905 48.761905 0 0 0-16.067048 10.24l-146.236952 146.334476a49.005714 49.005714 0 0 0 69.217523 69.241905l62.902858-63.390476v272.627809a48.761905 48.761905 0 1 0 97.475047 0V166.083048l62.902857 63.390476a48.737524 48.737524 0 0 0 69.217524 0 48.761905 48.761905 0 0 0 0-69.241905z"></path></svg>';

	// 居上对齐
	var VERTICAL_ALIGIN_TOP_SVG = '<svg viewBox="0 0 1024 1024"><path d="M859.9 168H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM518.3 355c-3.2-4.1-9.4-4.1-12.6 0l-112 141.7c-4.1 5.2-0.4 12.9 6.3 12.9h73.9V848c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V509.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 355z"></path></svg>';

	// 居中对齐
	var VERTICAL_ALIGIN_MIDDLE_SVG = '<svg viewBox="0 0 1024 1024" ><path d="M859.9 474H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM506.3 399.3c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7 0.4-11.7-5.7-11.7H550V104c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v156h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.6zM517.7 624.7c-2.9-3.7-8.5-3.7-11.3 0L405.6 752.3c-3.7 4.7-0.4 11.7 5.7 11.7H474v156c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V764h62.8c6 0 9.4-7 5.7-11.7L517.7 624.7z" ></path></svg>';

	// 居下对齐
	var VERTICAL_ALIGIN_BOTTOM_SVG = '<svg viewBox="0 0 1024 1024" ><path d="M859.9 780H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM505.7 669c3.2 4.1 9.4 4.1 12.6 0l112-141.7c4.1-5.2 0.4-12.9-6.3-12.9h-74.1V176c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8z" ></path></svg>';

	// 插入按钮
	var BUTTON_SVG = '<svg viewBox="0 0 1024 1024" ><path d="M389.12 671.36a90.24 90.24 0 0 0 37.76-80 90.24 90.24 0 0 0-18.56-58.88 88.32 88.32 0 0 0-54.4-28.8 90.24 90.24 0 0 0 42.24-29.44 85.76 85.76 0 0 0 15.36-51.84 82.56 82.56 0 0 0-28.8-64 124.16 124.16 0 0 0-83.2-24.96H134.4v360.96h165.12a161.28 161.28 0 0 0 89.6-23.04zM192 376.96h96a87.68 87.68 0 0 1 53.76 12.8 45.44 45.44 0 0 1 16.64 39.04 53.12 53.12 0 0 1-16.64 42.88 94.08 94.08 0 0 1-55.04 12.8H192z m0 270.08V529.92h101.76a95.36 95.36 0 0 1 58.24 14.08 54.4 54.4 0 0 1 19.2 46.72 49.28 49.28 0 0 1-24.32 45.44 118.4 118.4 0 0 1-55.04 10.88zM503.04 627.2a71.68 71.68 0 0 0 14.08 48 64 64 0 0 0 49.28 17.28h42.88v-44.16H576a22.4 22.4 0 0 1-14.72-5.12 28.16 28.16 0 0 1-4.48-16V475.52h60.16v-44.16h-60.8V346.24l-53.12 22.4v64H454.4v44.16h48.64zM712.96 535.04a78.72 78.72 0 0 1 21.76-49.92 55.04 55.04 0 0 1 39.68-16c40.96 0 64 22.4 64 64v156.8h53.76V531.2c0-71.68-33.28-107.52-97.92-107.52a93.44 93.44 0 0 0-44.16 10.24 114.56 114.56 0 0 0-34.56 29.44v-32h-56.32v261.12h53.76z" fill="#5A5A5A" p-id="4057"></path><path d="M102.4 870.4h819.2A102.4 102.4 0 0 0 1024 768V256a102.4 102.4 0 0 0-102.4-102.4H102.4A102.4 102.4 0 0 0 0 256v512a102.4 102.4 0 0 0 102.4 102.4zM64 256a38.4 38.4 0 0 1 38.4-38.4h819.2a38.4 38.4 0 0 1 38.4 38.4v512a38.4 38.4 0 0 1-38.4 38.4H102.4A38.4 38.4 0 0 1 64 768z"></path></svg>';
	var CLICK_BUTTON_SVG = '<svg viewBox="0 0 1024 1024" ><path d="M955.140191 657.686057L482.322585 376.382253c-17.251919-10.262738-28.340465-2.425236-24.684192 17.409508l100.538811 543.990599c3.666506 19.828604 16.083304 22.576181 27.628244 6.077415 0 0 64.233953-92.081185 116.91478-148.294464l101.060697 150.524248c9.646708 14.33652 29.105898 18.077727 43.275619 8.336876l33.92567-23.452132c14.148231-9.760295 17.830087-29.519314 8.207939-43.884486L788.174482 736.668922c67.536162-27.991518 162.961512-51.606355 162.961512-51.606354 19.460214-4.800329 21.261233-17.116843 4.004197-27.376511z" fill="" p-id="6022"></path><path d="M491.223303 891.487987H219.679793c-49.051159 0-88.897679-38.494733-88.897679-85.863576v-594.520435c0-47.365774 39.84652-85.924975 88.897679-85.924975v0.057305h583.463612c48.995901 0 88.843444 38.556131 88.843444 85.924975v346.19779h65.833381V211.160257c0-83.677794-69.426209-151.757333-154.681942-151.757332h-583.458495c-85.305875 0-154.672732 68.079538-154.672732 151.757332v594.519412c0 83.625606 69.366857 151.702074 154.672732 151.702074h271.542486v-65.893756z"></path></svg>';

	function isMenuDisabled$2(editor, mark) {
	  if (editor.selection == null) return true;
	  var _Editor$nodes = Editor.nodes(editor, {
	      match: function match(n) {
	        var type = DomEditor.getNodeType(n);
	        if (type === 'pre') return true; // 代码块
	        if (Editor.isVoid(editor, n)) return true; // void node

	        return false;
	      },
	      universal: true
	    }),
	    _Editor$nodes2 = _slicedToArray(_Editor$nodes, 1),
	    match = _Editor$nodes2[0];

	  // 命中，则禁用
	  if (match) return true;
	  return false;
	}
	function removeMarks(editor, textNode) {
	  // 遍历 text node 属性，清除样式
	  var keys = _Object$keys(textNode);
	  _forEachInstanceProperty(keys).call(keys, function (key) {
	    if (key === 'text') {
	      // 保留 text 属性，text node 必须的
	      return;
	    }
	    // 其他属性，全部清除
	    Editor.removeMark(editor, key);
	  });
	}

	var BaseMenu$2 = /*#__PURE__*/function () {
	  function BaseMenu() {
	    _classCallCheck(this, BaseMenu);
	    _defineProperty$1(this, "mark", void 0);
	    _defineProperty$1(this, "marksNeedToRemove", []);
	    // 增加 mark 的同时，需要移除哪些 mark （互斥，不能共存的）
	    _defineProperty$1(this, "title", void 0);
	    _defineProperty$1(this, "iconSvg", void 0);
	    _defineProperty$1(this, "hotkey", void 0);
	    _defineProperty$1(this, "tag", 'button');
	  }
	  _createClass(BaseMenu, [{
	    key: "getValue",
	    value:
	    /**
	     * 获取：是否有 mark
	     * @param editor editor
	     */
	    function getValue(editor) {
	      var mark = this.mark;
	      var curMarks = Editor.marks(editor);

	      // 当 curMarks 存在时，说明用户手动设置，以 curMarks 为准
	      if (curMarks) {
	        return curMarks[mark];
	      } else {
	        var _Editor$nodes = Editor.nodes(editor, {
	            // @ts-ignore
	            match: function match(n) {
	              return n[mark] === true;
	            }
	          }),
	          _Editor$nodes2 = _slicedToArray(_Editor$nodes, 1),
	          match = _Editor$nodes2[0];
	        return !!match;
	      }
	    }
	  }, {
	    key: "isActive",
	    value: function isActive(editor) {
	      var isMark = this.getValue(editor);
	      return !!isMark;
	    }
	  }, {
	    key: "isDisabled",
	    value: function isDisabled(editor) {
	      return isMenuDisabled$2(editor, this.mark);
	    }

	    /**
	     * 执行命令
	     * @param editor editor
	     * @param value 是否有 mark
	     */
	  }, {
	    key: "exec",
	    value: function exec(editor, value) {
	      var mark = this.mark,
	        marksNeedToRemove = this.marksNeedToRemove;
	      if (value) {
	        // 已，则取消
	        editor.removeMark(mark);
	      } else {
	        // 没有，则执行
	        editor.addMark(mark, true);

	        // 移除互斥、不能共存的 marks
	        if (marksNeedToRemove) {
	          _forEachInstanceProperty(marksNeedToRemove).call(marksNeedToRemove, function (m) {
	            return editor.removeMark(m);
	          });
	        }
	      }
	    }
	  }]);
	  return BaseMenu;
	}();

	function _createSuper$9(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$9(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	function _isNativeReflectConstruct$9() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var BoldMenu = /*#__PURE__*/function (_BaseMenu) {
	  _inherits(BoldMenu, _BaseMenu);
	  var _super = _createSuper$9(BoldMenu);
	  function BoldMenu() {
	    var _context;
	    var _this;
	    _classCallCheck(this, BoldMenu);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, _concatInstanceProperty(_context = [this]).call(_context, args));
	    _defineProperty$1(_assertThisInitialized(_this), "mark", 'bold');
	    _defineProperty$1(_assertThisInitialized(_this), "title", '加粗');
	    _defineProperty$1(_assertThisInitialized(_this), "iconSvg", BOLD_SVG);
	    _defineProperty$1(_assertThisInitialized(_this), "hotkey", 'mod+b');
	    return _this;
	  }
	  return _createClass(BoldMenu);
	}(BaseMenu$2);

	function _createSuper$8(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$8(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	function _isNativeReflectConstruct$8() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var ItalicMenu = /*#__PURE__*/function (_BaseMenu) {
	  _inherits(ItalicMenu, _BaseMenu);
	  var _super = _createSuper$8(ItalicMenu);
	  function ItalicMenu() {
	    var _context;
	    var _this;
	    _classCallCheck(this, ItalicMenu);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, _concatInstanceProperty(_context = [this]).call(_context, args));
	    _defineProperty$1(_assertThisInitialized(_this), "mark", 'italic');
	    _defineProperty$1(_assertThisInitialized(_this), "title", '斜体');
	    _defineProperty$1(_assertThisInitialized(_this), "iconSvg", ITALIC_SVG);
	    _defineProperty$1(_assertThisInitialized(_this), "hotkey", 'mod+i');
	    return _this;
	  }
	  return _createClass(ItalicMenu);
	}(BaseMenu$2);

	function _createSuper$7(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$7(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	function _isNativeReflectConstruct$7() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var ThroughMenu = /*#__PURE__*/function (_BaseMenu) {
	  _inherits(ThroughMenu, _BaseMenu);
	  var _super = _createSuper$7(ThroughMenu);
	  function ThroughMenu() {
	    var _context;
	    var _this;
	    _classCallCheck(this, ThroughMenu);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, _concatInstanceProperty(_context = [this]).call(_context, args));
	    _defineProperty$1(_assertThisInitialized(_this), "mark", 'through');
	    _defineProperty$1(_assertThisInitialized(_this), "title", '删除线');
	    _defineProperty$1(_assertThisInitialized(_this), "iconSvg", THROUGH_SVG);
	    _defineProperty$1(_assertThisInitialized(_this), "hotkey", 'mod+shift+x');
	    return _this;
	  }
	  return _createClass(ThroughMenu);
	}(BaseMenu$2);

	function _createSuper$6(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$6(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	function _isNativeReflectConstruct$6() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var UnderlineMenu = /*#__PURE__*/function (_BaseMenu) {
	  _inherits(UnderlineMenu, _BaseMenu);
	  var _super = _createSuper$6(UnderlineMenu);
	  function UnderlineMenu() {
	    var _context;
	    var _this;
	    _classCallCheck(this, UnderlineMenu);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, _concatInstanceProperty(_context = [this]).call(_context, args));
	    _defineProperty$1(_assertThisInitialized(_this), "mark", 'underline');
	    _defineProperty$1(_assertThisInitialized(_this), "title", '下划线');
	    _defineProperty$1(_assertThisInitialized(_this), "iconSvg", UNDER_LINE_SVG);
	    _defineProperty$1(_assertThisInitialized(_this), "hotkey", 'mod+u');
	    return _this;
	  }
	  return _createClass(UnderlineMenu);
	}(BaseMenu$2);

	function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof _Symbol$1 !== "undefined" && _getIteratorMethod(o) || o["@@iterator"]; if (!it) { if (_Array$isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
	function _unsupportedIterableToArray(o, minLen) { var _context; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = _sliceInstanceProperty(_context = Object.prototype.toString.call(o)).call(_context, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	var ClearStyleMenu = /*#__PURE__*/function () {
	  function ClearStyleMenu() {
	    _classCallCheck(this, ClearStyleMenu);
	    _defineProperty$1(this, "title", '清除样式');
	    _defineProperty$1(this, "iconSvg", ERASER_SVG);
	    _defineProperty$1(this, "tag", 'button');
	  }
	  _createClass(ClearStyleMenu, [{
	    key: "getValue",
	    value: function getValue(editor) {
	      return '';
	    }
	  }, {
	    key: "isActive",
	    value: function isActive(editor) {
	      return false;
	    }
	  }, {
	    key: "isDisabled",
	    value: function isDisabled(editor) {
	      return isMenuDisabled$2(editor);
	    }

	    /**
	     * 执行命令
	     * @param editor editor
	     * @param value 是否有 mark
	     */
	  }, {
	    key: "exec",
	    value: function exec(editor, value) {
	      // 获取所有 text node
	      var nodeEntries = Editor.nodes(editor, {
	        match: function match(n) {
	          return Text.isText(n);
	        },
	        universal: true
	      });
	      var _iterator = _createForOfIteratorHelper(nodeEntries),
	        _step;
	      try {
	        for (_iterator.s(); !(_step = _iterator.n()).done;) {
	          var nodeEntry = _step.value;
	          // 单个 text node
	          var n = nodeEntry[0];
	          removeMarks(editor, n);
	        }
	      } catch (err) {
	        _iterator.e(err);
	      } finally {
	        _iterator.f();
	      }
	    }
	  }]);
	  return ClearStyleMenu;
	}();

	var boldMenuConf = {
	  key: 'bold',
	  factory: function factory() {
	    return new BoldMenu();
	  }
	};
	var italicMenuConf = {
	  key: 'italic',
	  factory: function factory() {
	    return new ItalicMenu();
	  }
	};
	var throughMenuConf = {
	  key: 'through',
	  factory: function factory() {
	    return new ThroughMenu();
	  }
	};
	var underlineMenuConf = {
	  key: 'underline',
	  factory: function factory() {
	    return new UnderlineMenu();
	  }
	};
	var clearStyleMenuConf = {
	  key: 'clearStyle',
	  factory: function factory() {
	    return new ClearStyleMenu();
	  }
	};

	var textStyle = {
	  renderStyle: renderStyle$3,
	  menus: [boldMenuConf, italicMenuConf, underlineMenuConf, throughMenuConf, clearStyleMenuConf]
	};

	var $$4 = _export$1;
	var newPromiseCapabilityModule$1 = newPromiseCapability$2;

	// `Promise.withResolvers` method
	// https://github.com/tc39/proposal-promise-with-resolvers
	$$4({ target: 'Promise', stat: true }, {
	  withResolvers: function withResolvers() {
	    var promiseCapability = newPromiseCapabilityModule$1.f(this);
	    return {
	      promise: promiseCapability.promise,
	      resolve: promiseCapability.resolve,
	      reject: promiseCapability.reject
	    };
	  }
	});

	var parent$8 = promise$4;


	var promise$2 = parent$8;

	// TODO: Remove from `core-js@4`
	var $$3 = _export$1;
	var newPromiseCapabilityModule = newPromiseCapability$2;
	var perform = perform$6;

	// `Promise.try` method
	// https://github.com/tc39/proposal-promise-try
	$$3({ target: 'Promise', stat: true, forced: true }, {
	  'try': function (callbackfn) {
	    var promiseCapability = newPromiseCapabilityModule.f(this);
	    var result = perform(callbackfn);
	    (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
	    return promiseCapability.promise;
	  }
	});

	var parent$7 = promise$2;
	// TODO: Remove from `core-js@4`





	var promise$1 = parent$7;

	var promise = promise$1;

	var _Promise = /*@__PURE__*/getDefaultExportFromCjs(promise);

	function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
	  try {
	    var info = gen[key](arg);
	    var value = info.value;
	  } catch (error) {
	    reject(error);
	    return;
	  }
	  if (info.done) {
	    resolve(value);
	  } else {
	    _Promise.resolve(value).then(_next, _throw);
	  }
	}
	function _asyncToGenerator(fn) {
	  return function () {
	    var self = this,
	      args = arguments;
	    return new _Promise(function (resolve, reject) {
	      var gen = fn.apply(self, args);
	      function _next(value) {
	        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
	      }
	      function _throw(err) {
	        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
	      }
	      _next(undefined);
	    });
	  };
	}

	var regeneratorRuntime$1 = {exports: {}};

	var _typeof = {exports: {}};

	(function (module) {
		var _Symbol = symbol$1;
		var _Symbol$iterator = iterator$1;
		function _typeof(o) {
		  "@babel/helpers - typeof";

		  return (module.exports = _typeof = "function" == typeof _Symbol && "symbol" == typeof _Symbol$iterator ? function (o) {
		    return typeof o;
		  } : function (o) {
		    return o && "function" == typeof _Symbol && o.constructor === _Symbol && o !== _Symbol.prototype ? "symbol" : typeof o;
		  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
		}
		module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports; 
	} (_typeof));

	var _typeofExports = _typeof.exports;

	var parent$6 = forEach$8;

	var forEach$2 = parent$6;

	var parent$5 = forEach$2;

	var forEach$1 = parent$5;

	var forEach = forEach$1;

	var $$2 = _export$1;
	var uncurryThis$2 = functionUncurryThis$1;
	var isArray = isArray$l;

	var nativeReverse = uncurryThis$2([].reverse);
	var test = [1, 2];

	// `Array.prototype.reverse` method
	// https://tc39.es/ecma262/#sec-array.prototype.reverse
	// fix for Safari 12.0 bug
	// https://bugs.webkit.org/show_bug.cgi?id=188794
	$$2({ target: 'Array', proto: true, forced: String(test) === String(test.reverse()) }, {
	  reverse: function reverse() {
	    // eslint-disable-next-line no-self-assign -- dirty hack
	    if (isArray(this)) this.length = this.length;
	    return nativeReverse(this);
	  }
	});

	var getBuiltInPrototypeMethod$1 = getBuiltInPrototypeMethod$g;

	var reverse$5 = getBuiltInPrototypeMethod$1('Array', 'reverse');

	var isPrototypeOf$1 = objectIsPrototypeOf$1;
	var method$1 = reverse$5;

	var ArrayPrototype$1 = Array.prototype;

	var reverse$4 = function (it) {
	  var own = it.reverse;
	  return it === ArrayPrototype$1 || (isPrototypeOf$1(ArrayPrototype$1, it) && own === ArrayPrototype$1.reverse) ? method$1 : own;
	};

	var parent$4 = reverse$4;

	var reverse$3 = parent$4;

	var parent$3 = reverse$3;

	var reverse$2 = parent$3;

	var parent$2 = reverse$2;

	var reverse$1 = parent$2;

	var reverse = reverse$1;

	(function (module) {
		var _typeof = _typeofExports["default"];
		var _Object$defineProperty = defineProperty$7;
		var _Symbol = symbol$1;
		var _Object$create = create;
		var _Object$getPrototypeOf = getPrototypeOf;
		var _forEachInstanceProperty = forEach;
		var _pushInstanceProperty = push$5;
		var _Object$setPrototypeOf = setPrototypeOf;
		var _Promise = promise;
		var _reverseInstanceProperty = reverse;
		var _sliceInstanceProperty = slice$2;
		function _regeneratorRuntime() {
		  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
		    return e;
		  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
		  var t,
		    e = {},
		    r = Object.prototype,
		    n = r.hasOwnProperty,
		    o = _Object$defineProperty || function (t, e, r) {
		      t[e] = r.value;
		    },
		    i = "function" == typeof _Symbol ? _Symbol : {},
		    a = i.iterator || "@@iterator",
		    c = i.asyncIterator || "@@asyncIterator",
		    u = i.toStringTag || "@@toStringTag";
		  function define(t, e, r) {
		    return _Object$defineProperty(t, e, {
		      value: r,
		      enumerable: !0,
		      configurable: !0,
		      writable: !0
		    }), t[e];
		  }
		  try {
		    define({}, "");
		  } catch (t) {
		    define = function define(t, e, r) {
		      return t[e] = r;
		    };
		  }
		  function wrap(t, e, r, n) {
		    var i = e && e.prototype instanceof Generator ? e : Generator,
		      a = _Object$create(i.prototype),
		      c = new Context(n || []);
		    return o(a, "_invoke", {
		      value: makeInvokeMethod(t, r, c)
		    }), a;
		  }
		  function tryCatch(t, e, r) {
		    try {
		      return {
		        type: "normal",
		        arg: t.call(e, r)
		      };
		    } catch (t) {
		      return {
		        type: "throw",
		        arg: t
		      };
		    }
		  }
		  e.wrap = wrap;
		  var h = "suspendedStart",
		    l = "suspendedYield",
		    f = "executing",
		    s = "completed",
		    y = {};
		  function Generator() {}
		  function GeneratorFunction() {}
		  function GeneratorFunctionPrototype() {}
		  var p = {};
		  define(p, a, function () {
		    return this;
		  });
		  var d = _Object$getPrototypeOf,
		    v = d && d(d(values([])));
		  v && v !== r && n.call(v, a) && (p = v);
		  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = _Object$create(p);
		  function defineIteratorMethods(t) {
		    var _context;
		    _forEachInstanceProperty(_context = ["next", "throw", "return"]).call(_context, function (e) {
		      define(t, e, function (t) {
		        return this._invoke(e, t);
		      });
		    });
		  }
		  function AsyncIterator(t, e) {
		    function invoke(r, o, i, a) {
		      var c = tryCatch(t[r], t, o);
		      if ("throw" !== c.type) {
		        var u = c.arg,
		          h = u.value;
		        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
		          invoke("next", t, i, a);
		        }, function (t) {
		          invoke("throw", t, i, a);
		        }) : e.resolve(h).then(function (t) {
		          u.value = t, i(u);
		        }, function (t) {
		          return invoke("throw", t, i, a);
		        });
		      }
		      a(c.arg);
		    }
		    var r;
		    o(this, "_invoke", {
		      value: function value(t, n) {
		        function callInvokeWithMethodAndArg() {
		          return new e(function (e, r) {
		            invoke(t, n, e, r);
		          });
		        }
		        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
		      }
		    });
		  }
		  function makeInvokeMethod(e, r, n) {
		    var o = h;
		    return function (i, a) {
		      if (o === f) throw new Error("Generator is already running");
		      if (o === s) {
		        if ("throw" === i) throw a;
		        return {
		          value: t,
		          done: !0
		        };
		      }
		      for (n.method = i, n.arg = a;;) {
		        var c = n.delegate;
		        if (c) {
		          var u = maybeInvokeDelegate(c, n);
		          if (u) {
		            if (u === y) continue;
		            return u;
		          }
		        }
		        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
		          if (o === h) throw o = s, n.arg;
		          n.dispatchException(n.arg);
		        } else "return" === n.method && n.abrupt("return", n.arg);
		        o = f;
		        var p = tryCatch(e, r, n);
		        if ("normal" === p.type) {
		          if (o = n.done ? s : l, p.arg === y) continue;
		          return {
		            value: p.arg,
		            done: n.done
		          };
		        }
		        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
		      }
		    };
		  }
		  function maybeInvokeDelegate(e, r) {
		    var n = r.method,
		      o = e.iterator[n];
		    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
		    var i = tryCatch(o, e.iterator, r.arg);
		    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
		    var a = i.arg;
		    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
		  }
		  function pushTryEntry(t) {
		    var _context2;
		    var e = {
		      tryLoc: t[0]
		    };
		    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), _pushInstanceProperty(_context2 = this.tryEntries).call(_context2, e);
		  }
		  function resetTryEntry(t) {
		    var e = t.completion || {};
		    e.type = "normal", delete e.arg, t.completion = e;
		  }
		  function Context(t) {
		    this.tryEntries = [{
		      tryLoc: "root"
		    }], _forEachInstanceProperty(t).call(t, pushTryEntry, this), this.reset(!0);
		  }
		  function values(e) {
		    if (e || "" === e) {
		      var r = e[a];
		      if (r) return r.call(e);
		      if ("function" == typeof e.next) return e;
		      if (!isNaN(e.length)) {
		        var o = -1,
		          i = function next() {
		            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
		            return next.value = t, next.done = !0, next;
		          };
		        return i.next = i;
		      }
		    }
		    throw new TypeError(_typeof(e) + " is not iterable");
		  }
		  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
		    value: GeneratorFunctionPrototype,
		    configurable: !0
		  }), o(GeneratorFunctionPrototype, "constructor", {
		    value: GeneratorFunction,
		    configurable: !0
		  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
		    var e = "function" == typeof t && t.constructor;
		    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
		  }, e.mark = function (t) {
		    return _Object$setPrototypeOf ? _Object$setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = _Object$create(g), t;
		  }, e.awrap = function (t) {
		    return {
		      __await: t
		    };
		  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
		    return this;
		  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
		    void 0 === i && (i = _Promise);
		    var a = new AsyncIterator(wrap(t, r, n, o), i);
		    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
		      return t.done ? t.value : a.next();
		    });
		  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
		    return this;
		  }), define(g, "toString", function () {
		    return "[object Generator]";
		  }), e.keys = function (t) {
		    var e = Object(t),
		      r = [];
		    for (var n in e) _pushInstanceProperty(r).call(r, n);
		    return _reverseInstanceProperty(r).call(r), function next() {
		      for (; r.length;) {
		        var t = r.pop();
		        if (t in e) return next.value = t, next.done = !1, next;
		      }
		      return next.done = !0, next;
		    };
		  }, e.values = values, Context.prototype = {
		    constructor: Context,
		    reset: function reset(e) {
		      var _context3;
		      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, _forEachInstanceProperty(_context3 = this.tryEntries).call(_context3, resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+_sliceInstanceProperty(r).call(r, 1)) && (this[r] = t);
		    },
		    stop: function stop() {
		      this.done = !0;
		      var t = this.tryEntries[0].completion;
		      if ("throw" === t.type) throw t.arg;
		      return this.rval;
		    },
		    dispatchException: function dispatchException(e) {
		      if (this.done) throw e;
		      var r = this;
		      function handle(n, o) {
		        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
		      }
		      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
		        var i = this.tryEntries[o],
		          a = i.completion;
		        if ("root" === i.tryLoc) return handle("end");
		        if (i.tryLoc <= this.prev) {
		          var c = n.call(i, "catchLoc"),
		            u = n.call(i, "finallyLoc");
		          if (c && u) {
		            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
		            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
		          } else if (c) {
		            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
		          } else {
		            if (!u) throw new Error("try statement without catch or finally");
		            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
		          }
		        }
		      }
		    },
		    abrupt: function abrupt(t, e) {
		      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
		        var o = this.tryEntries[r];
		        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
		          var i = o;
		          break;
		        }
		      }
		      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
		      var a = i ? i.completion : {};
		      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
		    },
		    complete: function complete(t, e) {
		      if ("throw" === t.type) throw t.arg;
		      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
		    },
		    finish: function finish(t) {
		      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
		        var r = this.tryEntries[e];
		        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
		      }
		    },
		    "catch": function _catch(t) {
		      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
		        var r = this.tryEntries[e];
		        if (r.tryLoc === t) {
		          var n = r.completion;
		          if ("throw" === n.type) {
		            var o = n.arg;
		            resetTryEntry(r);
		          }
		          return o;
		        }
		      }
		      throw new Error("illegal catch attempt");
		    },
		    delegateYield: function delegateYield(e, r, n) {
		      return this.delegate = {
		        iterator: values(e),
		        resultName: r,
		        nextLoc: n
		      }, "next" === this.method && (this.arg = t), y;
		    }
		  }, e;
		}
		module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports; 
	} (regeneratorRuntime$1));

	var regeneratorRuntimeExports = regeneratorRuntime$1.exports;

	// TODO(Babel 8): Remove this file.

	var runtime = regeneratorRuntimeExports();
	var regenerator = runtime;

	// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
	try {
	  regeneratorRuntime = runtime;
	} catch (accidentalStrictMode) {
	  if (typeof globalThis === "object") {
	    globalThis.regeneratorRuntime = runtime;
	  } else {
	    Function("r", "regeneratorRuntime = r")(runtime);
	  }
	}

	var _regeneratorRuntime = /*@__PURE__*/getDefaultExportFromCjs(regenerator);

	function replaceSymbols(str) {
	  return str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}

	function ownKeys$3(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread$3(e) { for (var r = 1; r < arguments.length; r++) { var _context5, _context6; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context5 = ownKeys$3(Object(t), !0)).call(_context5, function (r) { _defineProperty$1(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context6 = ownKeys$3(Object(t))).call(_context6, function (r) { _Object$defineProperty$1(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }

	/**
	 * 检查图片信息，支持 async fn
	 * @param src image src
	 * @param alt image alt
	 * @param href image href
	 */
	function checkImage(src, alt, href) {
	  // 1. 返回 true ，说明检查通过
	  // 2. 返回一个字符串，说明检查未通过，编辑器会阻止图片插入。会 alert 出错误信息（即返回的字符串）
	  // 3. 返回 undefined（即没有任何返回），说明检查未通过，编辑器会阻止图片插入
	  return true;
	}

	/**
	 * parse image src
	 * @param src image src
	 * @returns new src
	 */
	function parseImageSrc(src) {
	  return src;
	}
	function check$1(_x, _x2, _x3) {
	  return _check$1.apply(this, arguments);
	}
	function _check$1() {
	  _check$1 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(menuKey, editor, src) {
	    return _regeneratorRuntime.wrap(function _callee$(_context) {
	      while (1) switch (_context.prev = _context.next) {
	        case 0:
	          return _context.abrupt("return", checkImage());
	        case 3:
	        case "end":
	          return _context.stop();
	      }
	    }, _callee);
	  }));
	  return _check$1.apply(this, arguments);
	}
	function parseSrc(_x4, _x5, _x6) {
	  return _parseSrc.apply(this, arguments);
	}
	function _parseSrc() {
	  _parseSrc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(menuKey, editor, src) {
	    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
	      while (1) switch (_context2.prev = _context2.next) {
	        case 0:
	          return _context2.abrupt("return", parseImageSrc(src));
	        case 1:
	        case "end":
	          return _context2.stop();
	      }
	    }, _callee2);
	  }));
	  return _parseSrc.apply(this, arguments);
	}
	function insertImageNode(_x7, _x8) {
	  return _insertImageNode.apply(this, arguments);
	}
	function _insertImageNode() {
	  _insertImageNode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(editor, src) {
	    var alt,
	      href,
	      style,
	      res,
	      parsedSrc,
	      image,
	      _args3 = arguments;
	    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
	      while (1) switch (_context3.prev = _context3.next) {
	        case 0:
	          alt = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : '';
	          href = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : '';
	          style = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : {};
	          // 还原选区
	          editor.restoreSelection();
	          _context3.next = 6;
	          return check$1('insertImage', editor, src, alt, href);
	        case 6:
	          res = _context3.sent;
	          if (res) {
	            _context3.next = 9;
	            break;
	          }
	          return _context3.abrupt("return");
	        case 9:
	          _context3.next = 11;
	          return parseSrc('insertImage', editor, src);
	        case 11:
	          parsedSrc = _context3.sent;
	          // 新建一个 image node
	          image = {
	            type: 'image',
	            src: replaceSymbols(parsedSrc),
	            href: href,
	            alt: alt,
	            style: _objectSpread$3({
	              width: '200px',
	              verticalAlign: 'middle'
	            }, style),
	            children: [{
	              text: ''
	            }] // 【注意】void node 需要一个空 text 作为 children
	          }; // 如果 blur ，则恢复选区

	          if (editor.selection === null) {
	            editor.restoreSelection();
	          }
	          // 如果当前正好选中了图片，则 move 一下（如：连续上传多张图片时）
	          if (DomEditor.getSelectedNodeByType(editor, 'image')) {
	            Transforms.move(editor, {
	              distance: 1,
	              unit: 'character',
	              reverse: false
	            });
	          }
	          if (!isInsertImageMenuDisabled(editor)) {
	            _context3.next = 17;
	            break;
	          }
	          return _context3.abrupt("return");
	        case 17:
	          // 插入图片
	          Transforms.insertNodes(editor, image);
	        case 18:
	        case "end":
	          return _context3.stop();
	      }
	    }, _callee3);
	  }));
	  return _insertImageNode.apply(this, arguments);
	}
	function updateImageNode(_x9, _x10) {
	  return _updateImageNode.apply(this, arguments);
	}

	/**
	 * 判断菜单是否要 disabled
	 * @param editor editor
	 */
	function _updateImageNode() {
	  _updateImageNode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(editor, src) {
	    var alt,
	      href,
	      style,
	      res,
	      parsedSrc,
	      selectedImageNode,
	      _selectedImageNode$st,
	      curStyle,
	      nodeProps,
	      _args4 = arguments;
	    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
	      while (1) switch (_context4.prev = _context4.next) {
	        case 0:
	          alt = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : '';
	          href = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : '';
	          style = _args4.length > 4 && _args4[4] !== undefined ? _args4[4] : {};
	          _context4.next = 5;
	          return check$1('editImage', editor, src, alt, href);
	        case 5:
	          res = _context4.sent;
	          if (res) {
	            _context4.next = 8;
	            break;
	          }
	          return _context4.abrupt("return");
	        case 8:
	          _context4.next = 10;
	          return parseSrc('editImage', editor, src);
	        case 10:
	          parsedSrc = _context4.sent;
	          selectedImageNode = DomEditor.getSelectedNodeByType(editor, 'image');
	          if (!(selectedImageNode == null)) {
	            _context4.next = 14;
	            break;
	          }
	          return _context4.abrupt("return");
	        case 14:
	          _selectedImageNode$st = selectedImageNode.style, curStyle = _selectedImageNode$st === void 0 ? {} : _selectedImageNode$st; // 修改图片
	          nodeProps = {
	            src: parsedSrc,
	            alt: alt,
	            href: href,
	            style: _objectSpread$3(_objectSpread$3({}, curStyle), style)
	          };
	          Transforms.setNodes(editor, nodeProps, {
	            match: function match(n) {
	              return DomEditor.checkNodeType(n, 'image');
	            }
	          });

	          // 回调
	          DomEditor.getSelectedNodeByType(editor, 'image');
	        case 18:
	        case "end":
	          return _context4.stop();
	      }
	    }, _callee4);
	  }));
	  return _updateImageNode.apply(this, arguments);
	}
	function isInsertImageMenuDisabled(editor) {
	  var selection = editor.selection;
	  if (selection == null) return true;
	  if (!Range.isCollapsed(selection)) return true; // 选区非折叠，禁用

	  var _Editor$nodes = Editor.nodes(editor, {
	      match: function match(n) {
	        var type = DomEditor.getNodeType(n);
	        if (type === 'code') return true; // 代码块
	        if (type === 'pre') return true; // 代码块
	        if (type === 'link') return true; // 链接
	        if (type === 'list-item') return true; // list
	        if (_startsWithInstanceProperty(type).call(type, 'header')) return true; // 标题
	        if (type === 'blockquote') return true; // 引用
	        if (Editor.isVoid(editor, n)) return true; // void

	        return false;
	      },
	      universal: true
	    }),
	    _Editor$nodes2 = _slicedToArray(_Editor$nodes, 1),
	    match = _Editor$nodes2[0];
	  if (match) return true;
	  return false;
	}

	var WrappedWellKnownSymbolModule = wellKnownSymbolWrapped;

	var asyncIterator$2 = WrappedWellKnownSymbolModule.f('asyncIterator');

	var parent$1 = asyncIterator$2;

	var asyncIterator$1 = parent$1;

	var asyncIterator = asyncIterator$1;

	var _Symbol$asyncIterator = /*@__PURE__*/getDefaultExportFromCjs(asyncIterator);

	var iterator = iterator$4;

	var _Symbol$iterator = /*@__PURE__*/getDefaultExportFromCjs(iterator);

	function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof _Symbol$1 && (t = _Symbol$asyncIterator, o = _Symbol$iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
	function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return _Promise$1.reject(new TypeError(r + " is not an object.")); var n = r.done; return _Promise$1.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(r) { var n = this.s.return; return void 0 === n ? _Promise$1.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, throw: function _throw(r) { var n = this.s.return; return void 0 === n ? _Promise$1.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }

	/**
	 * 插入 base64 格式
	 * @param editor editor
	 * @param file file
	 */
	function insertBase64(_x, _x2) {
	  return _insertBase.apply(this, arguments);
	}
	/**
	 * 上传图片
	 * @param editor editor
	 * @param files files
	 */
	function _insertBase() {
	  _insertBase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(editor, file) {
	    return _regeneratorRuntime.wrap(function _callee$(_context) {
	      while (1) switch (_context.prev = _context.next) {
	        case 0:
	          return _context.abrupt("return", new _Promise$1(function (resolve) {
	            var reader = new FileReader();
	            reader.readAsDataURL(file);
	            reader.onload = function () {
	              var result = reader.result;
	              if (!result) return;
	              var src = result.toString();
	              var href = _indexOfInstanceProperty(src).call(src, 'data:image') === 0 ? '' : src; // base64 格式则不设置 href
	              insertImageNode(editor, src, file.name, href);
	              resolve('ok');
	            };
	          }));
	        case 1:
	        case "end":
	          return _context.stop();
	      }
	    }, _callee);
	  }));
	  return _insertBase.apply(this, arguments);
	}
	function uploadImages (_x3, _x4) {
	  return _ref.apply(this, arguments);
	}
	function _ref() {
	  _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(editor, files) {
	    var fileList, _editor$getMenuConfig, customUpload, base64LimitSize, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, size;
	    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
	      while (1) switch (_context2.prev = _context2.next) {
	        case 0:
	          if (!(files == null)) {
	            _context2.next = 2;
	            break;
	          }
	          return _context2.abrupt("return");
	        case 2:
	          fileList = _sliceInstanceProperty(Array.prototype).call(files); // 获取菜单配置
	          _editor$getMenuConfig = editor.getMenuConfig('uploadImage'), customUpload = _editor$getMenuConfig.customUpload, base64LimitSize = _editor$getMenuConfig.base64LimitSize; // 按顺序上传
	          _iteratorAbruptCompletion = false;
	          _didIteratorError = false;
	          _context2.prev = 6;
	          _iterator = _asyncIterator(fileList);
	        case 8:
	          _context2.next = 10;
	          return _iterator.next();
	        case 10:
	          if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
	            _context2.next = 24;
	            break;
	          }
	          file = _step.value;
	          size = file.size; // size kb
	          if (!(base64LimitSize && size <= base64LimitSize)) {
	            _context2.next = 18;
	            break;
	          }
	          _context2.next = 16;
	          return insertBase64(editor, file);
	        case 16:
	          _context2.next = 21;
	          break;
	        case 18:
	          if (!customUpload) {
	            _context2.next = 21;
	            break;
	          }
	          _context2.next = 21;
	          return customUpload(file, function (src, alt, href, style) {
	            return insertImageNode(editor, src, alt, href, style);
	          });
	        case 21:
	          _iteratorAbruptCompletion = false;
	          _context2.next = 8;
	          break;
	        case 24:
	          _context2.next = 30;
	          break;
	        case 26:
	          _context2.prev = 26;
	          _context2.t0 = _context2["catch"](6);
	          _didIteratorError = true;
	          _iteratorError = _context2.t0;
	        case 30:
	          _context2.prev = 30;
	          _context2.prev = 31;
	          if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
	            _context2.next = 35;
	            break;
	          }
	          _context2.next = 35;
	          return _iterator.return();
	        case 35:
	          _context2.prev = 35;
	          if (!_didIteratorError) {
	            _context2.next = 38;
	            break;
	          }
	          throw _iteratorError;
	        case 38:
	          return _context2.finish(35);
	        case 39:
	          return _context2.finish(30);
	        case 40:
	        case "end":
	          return _context2.stop();
	      }
	    }, _callee2, null, [[6, 26, 30, 40], [31,, 35, 39]]);
	  }));
	  return _ref.apply(this, arguments);
	}

	function withImage(editor) {
	  var isInline = editor.isInline,
	    isVoid = editor.isVoid;
	    editor.insertNode;
	  var newEditor = editor;

	  // 重写 isInline
	  newEditor.isInline = function (elem) {
	    var type = elem.type;
	    if (type === 'image') {
	      return true;
	    }
	    return isInline(elem);
	  };

	  // 重写 isVoid
	  newEditor.isVoid = function (elem) {
	    var type = elem.type;
	    if (type === 'image') {
	      return true;
	    }
	    return isVoid(elem);
	  };

	  // 返回 editor ，重要！
	  return newEditor;
	}
	function withUploadImage(editor) {
	  var insertData = editor.insertData;
	  var newEditor = editor;

	  // 重写 insertData - 粘贴图片、拖拽上传图片
	  newEditor.insertData = function (data) {
	    if (isInsertImageMenuDisabled(newEditor)) {
	      insertData(data);
	      return;
	    }

	    // 如有 text ，则优先粘贴 text
	    var text = data.getData('text/plain');
	    if (text) {
	      insertData(data);
	      return;
	    }

	    // 获取文件
	    var files = data.files;
	    if (files.length <= 0) {
	      insertData(data);
	      return;
	    }

	    // 判断是否有图片文件（可能是其他类型的文件）
	    var fileList = _sliceInstanceProperty(Array.prototype).call(files);
	    var _hasImageFiles = _someInstanceProperty(fileList).call(fileList, function (file) {
	      var _file$type$split = file.type.split('/'),
	        _file$type$split2 = _slicedToArray(_file$type$split, 1),
	        mime = _file$type$split2[0];
	      return mime === 'image';
	    });
	    if (_hasImageFiles) {
	      // 有图片文件，则上传图片
	      uploadImages(editor, files);
	    } else {
	      // 如果没有， 则继续 insertData
	      insertData(data);
	    }
	  };

	  // 返回 editor ，重要！
	  return newEditor;
	}

	// 生成默认配置
	function genUploadImageConfig() {
	  return {
	    server: '',
	    // server API 地址，需用户配置

	    fieldName: 'wangeditor-uploaded-image',
	    // formData 中，文件的 key
	    maxFileSize: 2 * 1024 * 1024,
	    // 2M
	    maxNumberOfFiles: 100,
	    // 最多上传 xx 张图片
	    allowedFileTypes: ['image/*'],
	    meta: {
	      // 自定义上传参数，例如传递验证的 token 等。参数会被添加到 formData 中，一起上传到服务端。
	      // 例如：token: 'xxxxx', x: 100
	    },
	    metaWithUrl: false,
	    // headers: {
	    //   // 自定义 http headers
	    //   // 例如：Accept: 'text/x-json', a: 100,
	    // },
	    withCredentials: false,
	    timeout: 10 * 1000,
	    // 10s

	    // 自定义插入图片，用户配置
	    // customInsert: (res, insertFn) => {},

	    // 自定义上传图片，用户配置
	    // customUpload: (file, insertFn) => {},

	    // 小于 xxx 就插入 base64
	    base64LimitSize: 0

	    // 自定义选择，并上传图片，如：图床 （用户配置）
	    // customBrowseAndUpload: insertFn => {},
	  };
	}

	var UploadImage = /*#__PURE__*/function () {
	  function UploadImage() {
	    _classCallCheck(this, UploadImage);
	    _defineProperty$1(this, "title", '上传图片');
	    _defineProperty$1(this, "iconSvg", UPLOAD_IMAGE_SVG);
	    _defineProperty$1(this, "tag", 'button');
	  }
	  _createClass(UploadImage, [{
	    key: "getValue",
	    value: function getValue(editor) {
	      // 插入菜单，不需要 value
	      return '';
	    }
	  }, {
	    key: "isActive",
	    value: function isActive(editor) {
	      // 任何时候，都不用激活 menu
	      return false;
	    }
	  }, {
	    key: "isDisabled",
	    value: function isDisabled(editor) {
	      return isInsertImageMenuDisabled(editor);
	    }
	  }, {
	    key: "getMenuConfig",
	    value: function getMenuConfig(editor) {
	      // 获取配置，见 `./config.js`
	      return genUploadImageConfig();
	    }
	  }, {
	    key: "exec",
	    value: function exec(editor, value) {
	      var _this$getMenuConfig = this.getMenuConfig(editor),
	        _this$getMenuConfig$a = _this$getMenuConfig.allowedFileTypes,
	        allowedFileTypes = _this$getMenuConfig$a === void 0 ? [] : _this$getMenuConfig$a,
	        customBrowseAndUpload = _this$getMenuConfig.customBrowseAndUpload;

	      // 自定义选择图片，并上传，如图床
	      if (customBrowseAndUpload) {
	        customBrowseAndUpload(function (src, alt, href) {
	          return insertImageNode(editor, src, alt, href);
	        });
	        return;
	      }

	      // 设置选择文件的类型
	      var acceptAttr = '';
	      if (allowedFileTypes.length > 0) {
	        acceptAttr = "accept=\"".concat(allowedFileTypes.join(', '), "\"");
	      }

	      // 添加 file input（每次重新创建 input）
	      var $body = $$x('body');
	      var $inputFile = $$x("<input type=\"file\" ".concat(acceptAttr, " multiple/>"));
	      $inputFile.hide();
	      $body.append($inputFile);
	      $inputFile.click();
	      // 选中文件
	      $inputFile.on('change', function () {
	        var files = $inputFile[0].files;
	        uploadImages(editor, files); // 上传文件
	      });
	    }
	  }]);
	  return UploadImage;
	}();

	var DeleteImage = /*#__PURE__*/function () {
	  function DeleteImage() {
	    _classCallCheck(this, DeleteImage);
	    _defineProperty$1(this, "title", '删除图片');
	    _defineProperty$1(this, "iconSvg", TRASH_SVG);
	    _defineProperty$1(this, "tag", 'button');
	  }
	  _createClass(DeleteImage, [{
	    key: "getValue",
	    value: function getValue(editor) {
	      // 无需获取 val
	      return '';
	    }
	  }, {
	    key: "isActive",
	    value: function isActive(editor) {
	      // 无需 active
	      return false;
	    }
	  }, {
	    key: "isDisabled",
	    value: function isDisabled(editor) {
	      if (editor.selection == null) return true;
	      var imageNode = DomEditor.getSelectedNodeByType(editor, 'image');
	      if (imageNode == null) {
	        // 选区未处于 image node ，则禁用
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: "exec",
	    value: function exec(editor, value) {
	      if (this.isDisabled(editor)) return;
	      // 删除图片
	      Transforms.removeNodes(editor, {
	        match: function match(n) {
	          return DomEditor.checkNodeType(n, 'image');
	        }
	      });
	    }
	  }]);
	  return DeleteImage;
	}();

	var $$1 = _export$1;
	var $find = arrayIteration$1.find;

	var FIND = 'find';
	var SKIPS_HOLES = true;

	// Shouldn't skip holes
	// eslint-disable-next-line es/no-array-prototype-find -- testing
	if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

	// `Array.prototype.find` method
	// https://tc39.es/ecma262/#sec-array.prototype.find
	$$1({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

	var getBuiltInPrototypeMethod = getBuiltInPrototypeMethod$g;

	var find$3 = getBuiltInPrototypeMethod('Array', 'find');

	var isPrototypeOf = objectIsPrototypeOf$1;
	var method = find$3;

	var ArrayPrototype = Array.prototype;

	var find$2 = function (it) {
	  var own = it.find;
	  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.find) ? method : own;
	};

	var parent = find$2;

	var find$1 = parent;

	var find = find$1;

	var _findInstanceProperty = /*@__PURE__*/getDefaultExportFromCjs(find);

	/**
	 * 生成唯一的 DOM ID
	 */
	function genDomID$4() {
	  return 's-e-edit-image-' + _parseInt$1(Math.random() * 100);
	}
	var EditImage = /*#__PURE__*/function () {
	  function EditImage() {
	    _classCallCheck(this, EditImage);
	    _defineProperty$1(this, "title", '编辑图片');
	    _defineProperty$1(this, "iconSvg", PENCIL_SVG);
	    _defineProperty$1(this, "tag", 'button');
	    _defineProperty$1(this, "showModal", true);
	    // 点击 button 时显示 modal
	    _defineProperty$1(this, "modalWidth", 300);
	    _defineProperty$1(this, "$content", null);
	    _defineProperty$1(this, "srcInputId", genDomID$4());
	    _defineProperty$1(this, "altInputId", genDomID$4());
	    _defineProperty$1(this, "widthInputId", genDomID$4());
	    _defineProperty$1(this, "heightInputId", genDomID$4());
	    _defineProperty$1(this, "buttonId", genDomID$4());
	  }
	  _createClass(EditImage, [{
	    key: "getValue",
	    value: function getValue(editor) {
	      // 编辑图片，用不到 getValue
	      return '';
	    }
	  }, {
	    key: "getImageNode",
	    value: function getImageNode(editor) {
	      return DomEditor.getSelectedNodeByType(editor, 'image');
	    }
	  }, {
	    key: "isActive",
	    value: function isActive(editor) {
	      // 无需 active
	      return false;
	    }
	  }, {
	    key: "exec",
	    value: function exec(editor, value) {
	      // 点击菜单时，弹出 modal 之前，不需要执行其他代码
	      // 此处空着即可
	    }
	  }, {
	    key: "isDisabled",
	    value: function isDisabled(editor) {
	      var selection = editor.selection;
	      if (selection == null) return true;
	      if (!Range.isCollapsed(selection)) return true; // 选区非折叠，禁用

	      var imageNode = DomEditor.getSelectedNodeByType(editor, 'image');

	      // 未匹配到 image node 则禁用
	      if (imageNode == null) return true;
	      return false;
	    }
	  }, {
	    key: "getModalPositionNode",
	    value: function getModalPositionNode(editor) {
	      return this.getImageNode(editor);
	    }
	  }, {
	    key: "getModalContentElem",
	    value: function getModalContentElem(editor) {
	      var _this = this;
	      var srcInputId = this.srcInputId,
	        altInputId = this.altInputId,
	        widthInputId = this.widthInputId,
	        heightInputId = this.heightInputId,
	        buttonId = this.buttonId;
	      var selectedImageNode = this.getImageNode(editor);
	      if (selectedImageNode == null) {
	        throw new Error('Not found selected image node');
	      }

	      // 获取 input button elem
	      var _genModalInputElems = genModalInputElems('地址', srcInputId),
	        _genModalInputElems2 = _slicedToArray(_genModalInputElems, 2),
	        srcContainerElem = _genModalInputElems2[0],
	        inputSrcElem = _genModalInputElems2[1];
	      var $inputSrc = $$x(inputSrcElem);
	      var _genModalInputElems3 = genModalInputElems('描述', altInputId),
	        _genModalInputElems4 = _slicedToArray(_genModalInputElems3, 2),
	        altContainerElem = _genModalInputElems4[0],
	        inputAltElem = _genModalInputElems4[1];
	      var $inputAlt = $$x(inputAltElem);
	      var _genModalInputElems5 = genModalInputElems('宽', widthInputId),
	        _genModalInputElems6 = _slicedToArray(_genModalInputElems5, 2),
	        widthContainerElem = _genModalInputElems6[0],
	        inputWidthElem = _genModalInputElems6[1];
	      var $inputWidth = $$x(inputWidthElem);
	      var _genModalInputElems7 = genModalInputElems('高', heightInputId),
	        _genModalInputElems8 = _slicedToArray(_genModalInputElems7, 2),
	        heightContainerElem = _genModalInputElems8[0],
	        impurtHeightElem = _genModalInputElems8[1];
	      var $inputHeight = $$x(impurtHeightElem);
	      var _genModalButtonElems = genModalButtonElems(buttonId, '确认'),
	        _genModalButtonElems2 = _slicedToArray(_genModalButtonElems, 1),
	        buttonContainerElem = _genModalButtonElems2[0];
	      if (this.$content == null) {
	        // 第一次渲染
	        var _$content = $$x('<div></div>');

	        // 绑定事件
	        _$content.on('click', "#".concat(buttonId), function (e) {
	          e.preventDefault();
	          var src = _findInstanceProperty(_$content).call(_$content, "#".concat(srcInputId)).val();
	          var alt = _findInstanceProperty(_$content).call(_$content, "#".concat(altInputId)).val();
	          var width = _findInstanceProperty(_$content).call(_$content, "#".concat(widthInputId)).val();
	          if (width !== 'auto') {
	            width = isNaN(_parseInt$1(width)) ? undefined : _parseInt$1(width) + 'px';
	          }
	          var height = _findInstanceProperty(_$content).call(_$content, "#".concat(heightInputId)).val();
	          if (height !== 'auto') {
	            height = isNaN(_parseInt$1(height)) ? undefined : _parseInt$1(height) + 'px';
	          }
	          var style = {};
	          if (width) {
	            style.width = width;
	          }
	          if (height) {
	            style.height = height;
	          }
	          _this.updateImage(editor, src, alt, '', style);
	          editor.hidePanelOrModal(); // 隐藏 modal
	        });

	        // 记录属性，重要
	        this.$content = _$content;
	      }
	      var $content = this.$content;
	      $content.empty(); // 先清空内容

	      // append inputs and button
	      $content.append(srcContainerElem);
	      $content.append(altContainerElem);
	      $content.append(widthContainerElem);
	      $content.append(heightContainerElem);
	      $content.append(buttonContainerElem);

	      // 设置 input val
	      var src = selectedImageNode.src,
	        _selectedImageNode$al = selectedImageNode.alt,
	        alt = _selectedImageNode$al === void 0 ? '' : _selectedImageNode$al;
	        selectedImageNode.href;
	        var _selectedImageNode$st = selectedImageNode.style,
	        _selectedImageNode$st2 = _selectedImageNode$st.width,
	        width = _selectedImageNode$st2 === void 0 ? 'auto' : _selectedImageNode$st2,
	        _selectedImageNode$st3 = _selectedImageNode$st.height,
	        height = _selectedImageNode$st3 === void 0 ? 'auto' : _selectedImageNode$st3;
	      $inputSrc.val(src);
	      $inputAlt.val(alt);
	      $inputWidth.val(width);
	      $inputHeight.val(height);

	      // focus 一个 input（异步，此时 DOM 尚未渲染）
	      _setTimeout(function () {
	        $inputSrc.focus();
	      });
	      return $content[0];
	    }
	  }, {
	    key: "updateImage",
	    value: function updateImage(editor, src) {
	      var alt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	      var href = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	      var style = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	      if (!src) return;

	      // 还原选区
	      editor.restoreSelection();
	      if (this.isDisabled(editor)) return;

	      // 修改图片信息
	      updateImageNode(editor, src, alt, href, style);
	    }
	  }]);
	  return EditImage;
	}();

	function ownKeys$2(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys$2(Object(t), !0)).call(_context, function (r) { _defineProperty$1(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys$2(Object(t))).call(_context2, function (r) { _Object$defineProperty$1(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
	var VerticalAlignBase = /*#__PURE__*/function () {
	  function VerticalAlignBase() {
	    _classCallCheck(this, VerticalAlignBase);
	    _defineProperty$1(this, "title", void 0);
	    // 菜单标题
	    _defineProperty$1(this, "tag", 'button');
	    _defineProperty$1(this, "value", void 0);
	  }
	  _createClass(VerticalAlignBase, [{
	    key: "getValue",
	    value:
	    // css width 的值

	    function getValue(editor) {
	      // 无需获取 val
	      return '';
	    }
	  }, {
	    key: "isActive",
	    value: function isActive(editor) {
	      // 无需 active
	      return false;
	    }
	  }, {
	    key: "getSelectedNode",
	    value: function getSelectedNode(editor) {
	      return DomEditor.getSelectedNodeByType(editor, 'image');
	    }
	  }, {
	    key: "isDisabled",
	    value: function isDisabled(editor) {
	      if (editor.selection == null) return true;
	      var imageNode = this.getSelectedNode(editor);
	      if (imageNode == null) {
	        // 选区未处于 image node ，则禁用
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: "exec",
	    value: function exec(editor, value) {
	      if (this.isDisabled(editor)) return;
	      var imageNode = this.getSelectedNode(editor);
	      if (imageNode == null) return;

	      // 隐藏 hoverbar
	      var hoverbar = DomEditor.getHoverbar(editor);
	      if (hoverbar) hoverbar.hideAndClean();
	      var _imageNode$style = imageNode.style,
	        style = _imageNode$style === void 0 ? {} : _imageNode$style;
	      var props = {
	        style: _objectSpread$2(_objectSpread$2({}, style), {}, {
	          verticalAlign: this.value
	        })
	      };
	      Transforms.setNodes(editor, props, {
	        match: function match(n) {
	          return DomEditor.checkNodeType(n, 'image');
	        }
	      });
	    }
	  }]);
	  return VerticalAlignBase;
	}();

	function _createSuper$5(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$5(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	function _isNativeReflectConstruct$5() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var VerticalAlignTop = /*#__PURE__*/function (_VerticalAlignBase) {
	  _inherits(VerticalAlignTop, _VerticalAlignBase);
	  var _super = _createSuper$5(VerticalAlignTop);
	  function VerticalAlignTop() {
	    var _context;
	    var _this;
	    _classCallCheck(this, VerticalAlignTop);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, _concatInstanceProperty(_context = [this]).call(_context, args));
	    _defineProperty$1(_assertThisInitialized(_this), "title", '顶部对齐');
	    // 菜单标题
	    _defineProperty$1(_assertThisInitialized(_this), "iconSvg", VERTICAL_ALIGIN_TOP_SVG);
	    _defineProperty$1(_assertThisInitialized(_this), "value", 'top');
	    return _this;
	  } // vertical-align 的值
	  return _createClass(VerticalAlignTop);
	}(VerticalAlignBase);

	function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var VerticalAlignMiddle = /*#__PURE__*/function (_VerticalAlignBase) {
	  _inherits(VerticalAlignMiddle, _VerticalAlignBase);
	  var _super = _createSuper$4(VerticalAlignMiddle);
	  function VerticalAlignMiddle() {
	    var _context;
	    var _this;
	    _classCallCheck(this, VerticalAlignMiddle);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, _concatInstanceProperty(_context = [this]).call(_context, args));
	    _defineProperty$1(_assertThisInitialized(_this), "title", '居中对齐');
	    // 菜单标题
	    _defineProperty$1(_assertThisInitialized(_this), "iconSvg", VERTICAL_ALIGIN_MIDDLE_SVG);
	    _defineProperty$1(_assertThisInitialized(_this), "value", 'middle');
	    return _this;
	  } // vertical-align 的值
	  return _createClass(VerticalAlignMiddle);
	}(VerticalAlignBase);

	function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var VerticalAlignBottom = /*#__PURE__*/function (_VerticalAlignBase) {
	  _inherits(VerticalAlignBottom, _VerticalAlignBase);
	  var _super = _createSuper$3(VerticalAlignBottom);
	  function VerticalAlignBottom() {
	    var _context;
	    var _this;
	    _classCallCheck(this, VerticalAlignBottom);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, _concatInstanceProperty(_context = [this]).call(_context, args));
	    _defineProperty$1(_assertThisInitialized(_this), "title", '底部对齐');
	    // 菜单标题
	    _defineProperty$1(_assertThisInitialized(_this), "iconSvg", VERTICAL_ALIGIN_BOTTOM_SVG);
	    _defineProperty$1(_assertThisInitialized(_this), "value", '');
	    return _this;
	  } // vertical-align 的值
	  return _createClass(VerticalAlignBottom);
	}(VerticalAlignBase);

	var uploadImageMenuConf = {
	  key: 'uploadImage',
	  factory: function factory() {
	    return new UploadImage();
	  }
	};
	var deleteImageMenuConf = {
	  key: 'deleteImage',
	  factory: function factory() {
	    return new DeleteImage();
	  }
	};
	var verticalAlignTopImageMenuConf = {
	  key: 'verticalAlignTopImage',
	  factory: function factory() {
	    return new VerticalAlignTop();
	  }
	};
	var verticalAlignMiddleImageMenuConf = {
	  key: 'verticalAlignMiddleImage',
	  factory: function factory() {
	    return new VerticalAlignMiddle();
	  }
	};
	var verticalAlignBottomImageMenuConf = {
	  key: 'verticalAlignBottomImage',
	  factory: function factory() {
	    return new VerticalAlignBottom();
	  }
	};
	var editImageMenuConf = {
	  key: 'editImage',
	  factory: function factory() {
	    return new EditImage();
	  }
	};

	var uncurryThis$1 = functionUncurryThis;

	// `thisNumberValue` abstract operation
	// https://tc39.es/ecma262/#sec-thisnumbervalue
	var thisNumberValue$1 = uncurryThis$1(1.0.valueOf);

	var toIntegerOrInfinity$1 = toIntegerOrInfinity$6;
	var toString = toString$i;
	var requireObjectCoercible = requireObjectCoercible$c;

	var $RangeError$1 = RangeError;

	// `String.prototype.repeat` method implementation
	// https://tc39.es/ecma262/#sec-string.prototype.repeat
	var stringRepeat = function repeat(count) {
	  var str = toString(requireObjectCoercible(this));
	  var result = '';
	  var n = toIntegerOrInfinity$1(count);
	  if (n < 0 || n === Infinity) throw new $RangeError$1('Wrong number of repetitions');
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
	  return result;
	};

	var $ = _export;
	var uncurryThis = functionUncurryThis;
	var toIntegerOrInfinity = toIntegerOrInfinity$6;
	var thisNumberValue = thisNumberValue$1;
	var $repeat = stringRepeat;
	var fails = fails$v;

	var $RangeError = RangeError;
	var $String = String;
	var floor = Math.floor;
	var repeat = uncurryThis($repeat);
	var stringSlice = uncurryThis(''.slice);
	var nativeToFixed = uncurryThis(1.0.toFixed);

	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};

	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};

	var multiply = function (data, n, c) {
	  var index = -1;
	  var c2 = c;
	  while (++index < 6) {
	    c2 += n * data[index];
	    data[index] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};

	var divide = function (data, n) {
	  var index = 6;
	  var c = 0;
	  while (--index >= 0) {
	    c += data[index];
	    data[index] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};

	var dataToString = function (data) {
	  var index = 6;
	  var s = '';
	  while (--index >= 0) {
	    if (s !== '' || index === 0 || data[index] !== 0) {
	      var t = $String(data[index]);
	      s = s === '' ? t : s + repeat('0', 7 - t.length) + t;
	    }
	  } return s;
	};

	var FORCED = fails(function () {
	  return nativeToFixed(0.00008, 3) !== '0.000' ||
	    nativeToFixed(0.9, 0) !== '1' ||
	    nativeToFixed(1.255, 2) !== '1.25' ||
	    nativeToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
	}) || !fails(function () {
	  // V8 ~ Android 4.3-
	  nativeToFixed({});
	});

	// `Number.prototype.toFixed` method
	// https://tc39.es/ecma262/#sec-number.prototype.tofixed
	$({ target: 'Number', proto: true, forced: FORCED }, {
	  toFixed: function toFixed(fractionDigits) {
	    var number = thisNumberValue(this);
	    var fractDigits = toIntegerOrInfinity(fractionDigits);
	    var data = [0, 0, 0, 0, 0, 0];
	    var sign = '';
	    var result = '0';
	    var e, z, j, k;

	    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
	    if (fractDigits < 0 || fractDigits > 20) throw new $RangeError('Incorrect fraction digits');
	    // eslint-disable-next-line no-self-compare -- NaN check
	    if (number !== number) return 'NaN';
	    if (number <= -1e21 || number >= 1e21) return $String(number);
	    if (number < 0) {
	      sign = '-';
	      number = -number;
	    }
	    if (number > 1e-21) {
	      e = log(number * pow(2, 69, 1)) - 69;
	      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(data, 0, z);
	        j = fractDigits;
	        while (j >= 7) {
	          multiply(data, 1e7, 0);
	          j -= 7;
	        }
	        multiply(data, pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(data, 1 << 23);
	          j -= 23;
	        }
	        divide(data, 1 << j);
	        multiply(data, 1, 1);
	        divide(data, 2);
	        result = dataToString(data);
	      } else {
	        multiply(data, 0, z);
	        multiply(data, 1 << -e, 0);
	        result = dataToString(data) + repeat('0', fractDigits);
	      }
	    }
	    if (fractDigits > 0) {
	      k = result.length;
	      result = sign + (k <= fractDigits
	        ? '0.' + repeat('0', fractDigits - k) + result
	        : stringSlice(result, 0, k - fractDigits) + '.' + stringSlice(result, k - fractDigits));
	    } else {
	      result = sign + result;
	    } return result;
	  }
	});

	function ownKeys$1(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys$1(Object(t), !0)).call(_context, function (r) { _defineProperty$1(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys$1(Object(t))).call(_context2, function (r) { _Object$defineProperty$1(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
	function genContainerId(editor, elemNode) {
	  var _DomEditor$findKey = DomEditor.findKey(editor, elemNode),
	    id = _DomEditor$findKey.id; // node 唯一 id
	  return "s-e-image-container-".concat(id);
	}

	/**
	 * 未选中时，渲染 image container
	 */
	function renderContainer(editor, elemNode, imageVnode, imageInfo) {
	  var width = imageInfo.width,
	    height = imageInfo.height,
	    verticalAlign = imageInfo.verticalAlign;
	  var style = {};
	  if (width) style.width = width;
	  if (height) style.height = height;
	  if (verticalAlign) style.verticalAlign = verticalAlign;
	  var containerId = genContainerId(editor, elemNode);
	  return h('div', {
	    id: containerId,
	    style: style,
	    className: 's-e-image-container'
	  }, [imageVnode]);
	}

	/**
	 * 选中状态下，渲染 image container（渲染拖拽容器，修改图片尺寸）
	 */
	function renderResizeContainer(editor, elemNode, imageVnode, imageInfo) {
	  var $body = $$x('body');
	  var containerId = genContainerId(editor, elemNode);
	  var width = imageInfo.width,
	    height = imageInfo.height,
	    verticalAlign = imageInfo.verticalAlign;
	  var originalX = 0;
	  var originalWith = 0;
	  var originalHeight = 0;
	  var revers = false; // 是否反转。如向右拖拽 right-top 需增加宽度（非反转），但向右拖拽 left-top 则需要减少宽度（反转）
	  var $container = null;
	  function getContainerElem() {
	    var $container = $$x("#".concat(containerId));
	    if ($container.length === 0) throw new Error('Cannot find image container elem');
	    return $container;
	  }

	  /**
	   * 初始化。监听事件，记录原始数据
	   */
	  function init(clientX) {
	    $container = getContainerElem();

	    // 记录当前 x 坐标值
	    originalX = clientX;

	    // 记录 img 原始宽高
	    var $img = _findInstanceProperty($container).call($container, 'img');
	    if ($img.length === 0) throw new Error('Cannot find image elem');
	    originalWith = $img.width();
	    originalHeight = $img.height();

	    // 监听 mousemove
	    $body.on('mousemove', onMousemove);

	    // 监听 mouseup
	    $body.on('mouseup', onMouseup);

	    // 隐藏 hoverbar
	    var hoverbar = DomEditor.getHoverbar(editor);
	    if (hoverbar) hoverbar.hideAndClean();
	  }

	  // mouseover callback （节流）
	  var onMousemove = throttle$1(function (e) {
	    e.preventDefault();
	    var clientX = e.clientX;
	    var gap = revers ? originalX - clientX : clientX - originalX; // 考虑是否反转
	    var newWidth = originalWith + gap;
	    var newHeight = originalHeight * (newWidth / originalWith); // 根据 width ，按比例计算 height

	    // 实时修改 img 宽高 -【注意】这里只修改 DOM ，mouseup 时再统一不修改 node
	    if ($container == null) return;
	    if (newWidth <= 15 || newHeight <= 15) return; // 最小就是 15px

	    $container.css('width', "".concat(newWidth, "px"));
	    $container.css('height', "".concat(newHeight, "px"));
	  }, 100);
	  function onMouseup(e) {
	    // 取消监听 mousemove
	    $body.off('mousemove', onMousemove);
	    if ($container == null) return;
	    var newWidth = $container.width().toFixed(2);
	    var newHeight = $container.height().toFixed(2);

	    // 修改 node
	    var props = {
	      style: _objectSpread$1(_objectSpread$1({}, elemNode.style), {}, {
	        width: "".concat(newWidth, "px"),
	        height: "".concat(newHeight, "px")
	      })
	    };
	    Transforms.setNodes(editor, props, {
	      at: DomEditor.findPath(editor, elemNode)
	    });

	    // 取消监听 mouseup
	    $body.off('mouseup', onMouseup);
	  }
	  var style = {};
	  if (width) style.width = width;
	  if (height) style.height = height;
	  if (verticalAlign) style.verticalAlign = verticalAlign;
	  // style.boxShadow = '0 0 0 1px #B4D5FF' // 自定义 selected 样式，因为有拖拽触手
	  return h('div', {
	    id: containerId,
	    style: style,
	    className: 's-e-image-container s-e-selected-image-container',
	    on: {
	      // 统一绑定拖拽触手的 mousedown 事件
	      mousedown: function mousedown(e) {
	        var $target = $$x(e.target);
	        if (!$target.hasClass('s-e-image-dragger')) {
	          // target 不是 .s-e-image-dragger 拖拽触手，则忽略
	          return;
	        }
	        e.preventDefault();
	        if ($target.hasClass('left-top') || $target.hasClass('left-bottom')) {
	          revers = true; // 反转。向右拖拽，减少宽度
	        }

	        init(e.clientX); // 初始化
	      }
	    }
	  }, [imageVnode, /* 拖拽的触手，会统一在上级 DOM 绑定拖拽事件 */
	  h('div', {
	    className: 's-e-image-dragger left-top'
	  }), h('div', {
	    className: 's-e-image-dragger right-top'
	  }), h('div', {
	    className: 's-e-image-dragger left-bottom'
	  }), h('div', {
	    className: 's-e-image-dragger right-bottom'
	  })]);
	}
	function renderImage(elemNode, children, editor) {
	  var src = elemNode.src,
	    _elemNode$alt = elemNode.alt,
	    alt = _elemNode$alt === void 0 ? '' : _elemNode$alt,
	    _elemNode$href = elemNode.href,
	    href = _elemNode$href === void 0 ? '' : _elemNode$href,
	    _elemNode$style = elemNode.style,
	    style = _elemNode$style === void 0 ? {} : _elemNode$style;
	  var _style$width = style.width,
	    width = _style$width === void 0 ? '' : _style$width,
	    _style$height = style.height,
	    height = _style$height === void 0 ? '' : _style$height,
	    _style$verticalAlign = style.verticalAlign,
	    verticalAlign = _style$verticalAlign === void 0 ? '' : _style$verticalAlign;
	  var selected = DomEditor.isNodeSelected(editor, elemNode); // 图片是否选中

	  var imageStyle = {};
	  if (width) imageStyle.width = 'inherit';
	  if (height) imageStyle.height = 'inherit';

	  // 【注意】void node 中，renderElem 不用处理 children 。core 会统一处理。
	  var vnode = h('img', {
	    style: imageStyle,
	    src: src,
	    alt: alt,
	    'data-href': href
	  });
	  var isDisabled = editor.isDisabled();
	  if (selected && !isDisabled) {
	    // 选中，未禁用 - 渲染 resize container
	    return renderResizeContainer(editor, elemNode, vnode, {
	      width: width,
	      height: height,
	      verticalAlign: verticalAlign
	    });
	  }

	  // 其他，渲染普通 image container
	  return renderContainer(editor, elemNode, vnode, {
	    width: width,
	    height: height,
	    verticalAlign: verticalAlign
	  });
	}
	var renderImageConf = {
	  type: 'image',
	  // 和 elemNode.type 一致
	  renderElem: renderImage
	};

	var uploadImage = {
	  renderElems: [renderImageConf],
	  menus: [uploadImageMenuConf, deleteImageMenuConf, editImageMenuConf, verticalAlignTopImageMenuConf, verticalAlignMiddleImageMenuConf, verticalAlignBottomImageMenuConf],
	  editorPlugins: [withImage, withUploadImage]
	};

	/**
	 * 添加样式
	 * @param node text node
	 * @param vnode vnode
	 * @returns vnode
	 */
	function renderStyle$2(node, vnode) {
	  var color = node.color,
	    bgColor = node.bgColor;
	  var styleVnode = vnode;
	  if (color) {
	    addVnodeStyle(styleVnode, {
	      color: color
	    });
	  }
	  if (bgColor) {
	    addVnodeStyle(styleVnode, {
	      backgroundColor: bgColor
	    });
	  }
	  return styleVnode;
	}

	var COLORS = ['rgb(0, 0, 0)', 'rgb(38, 38, 38)', 'rgb(89, 89, 89)', 'rgb(140, 140, 140)', 'rgb(191, 191, 191)', 'rgb(217, 217, 217)', 'rgb(233, 233, 233)', 'rgb(245, 245, 245)', 'rgb(250, 250, 250)', 'rgb(255, 255, 255)',
	// 10
	'rgb(225, 60, 57)', 'rgb(231, 95, 51)', 'rgb(235, 144, 58)', 'rgb(245, 219, 77)', 'rgb(114, 192, 64)', 'rgb(89, 191, 192)', 'rgb(66, 144, 247)', 'rgb(54, 88, 226)', 'rgb(106, 57, 201)', 'rgb(216, 68, 147)',
	// 10
	'rgb(251, 233, 230)', 'rgb(252, 237, 225)', 'rgb(252, 239, 212)', 'rgb(252, 251, 207)', 'rgb(231, 246, 213)', 'rgb(218, 244, 240)', 'rgb(217, 237, 250)', 'rgb(224, 232, 250)', 'rgb(237, 225, 248)', 'rgb(246, 226, 234)',
	// 10
	'rgb(255, 163, 158)', 'rgb(255, 187, 150)', 'rgb(255, 213, 145)', 'rgb(255, 251, 143)', 'rgb(183, 235, 143)', 'rgb(135, 232, 222)', 'rgb(145, 213, 255)', 'rgb(173, 198, 255)', 'rgb(211, 173, 247)', 'rgb(255, 173, 210)',
	// 10
	'rgb(255, 77, 79)', 'rgb(255, 122, 69)', 'rgb(255, 169, 64)', 'rgb(255, 236, 61)', 'rgb(115, 209, 61)', 'rgb(54, 207, 201)', 'rgb(64, 169, 255)', 'rgb(89, 126, 247)', 'rgb(146, 84, 222)', 'rgb(247, 89, 171)',
	// 10
	'rgb(207, 19, 34)', 'rgb(212, 56, 13)', 'rgb(212, 107, 8)', 'rgb(212, 177, 6)', 'rgb(56, 158, 13)', 'rgb(8, 151, 156)', 'rgb(9, 109, 217)', 'rgb(29, 57, 196)', 'rgb(83, 29, 171)', 'rgb(196, 29, 127)',
	// 10
	'rgb(130, 0, 20)', 'rgb(135, 20, 0)', 'rgb(135, 56, 0)', 'rgb(97, 71, 0)', 'rgb(19, 82, 0)', 'rgb(0, 71, 79)', 'rgb(0, 58, 140)', 'rgb(6, 17, 120)', 'rgb(34, 7, 94)', 'rgb(120, 6, 80)' // 10
	];

	function genColors() {
	  return COLORS;
	}
	function genBgColors() {
	  return COLORS;
	}

	/**
	 * 判断是否rbg格式颜色值
	 * @param {String} rgba rgba字符串
	 * @return {boolean}
	 *
	 * @example
	 * // 传入rgb / rgba 格式的字符串进行判断
	 *  isRgb('rgba(0,0,0,1)') true
	 *  isRgb('rgb(0, 0, 0)') true
	 *  isRgb('rgb(a, b, c)') false
	 *  isRgb('0, 0, 0') false
	 */
	var isRgb = function isRgb(val) {
	  var regRgba = /rgba?\((\d{1,3}),(\d{1,3}),(\d{1,3})(,([.\d]+))?\)/;
	  return !!val.replace(/\s+/g, '').match(regRgba);
	};
	/**
	 * 判断是否Hex格式颜色值
	 * @param {String} hex #cccccc
	 * @return {boolean}
	 *
	 * @example
	 * // 传入rgb / rgba 格式的字符串进行判断
	 *  isHex('#ffffff') true
	 */
	var isHex = function isHex(val) {
	  return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/gi.test(val);
	};

	var BaseMenu$1 = /*#__PURE__*/function () {
	  function BaseMenu() {
	    _classCallCheck(this, BaseMenu);
	    _defineProperty$1(this, "title", void 0);
	    _defineProperty$1(this, "iconSvg", void 0);
	    _defineProperty$1(this, "tag", 'button');
	    _defineProperty$1(this, "showDropPanel", true);
	    // 点击 button 时显示 dropPanel
	    _defineProperty$1(this, "mark", void 0);
	    _defineProperty$1(this, "$content", null);
	  }
	  _createClass(BaseMenu, [{
	    key: "exec",
	    value: function exec(editor, value) {
	      // 点击菜单时，弹出 droPanel 之前，不需要执行其他代码
	      // 此处空着即可
	    }
	  }, {
	    key: "getValue",
	    value: function getValue(editor) {
	      var mark = this.mark;
	      var curMarks = Editor.marks(editor);
	      // @ts-ignore
	      if (curMarks && curMarks[mark]) return curMarks[mark];
	      return '';
	    }
	  }, {
	    key: "isActive",
	    value: function isActive(editor) {
	      var color = this.getValue(editor);
	      return !!color;
	    }
	  }, {
	    key: "isDisabled",
	    value: function isDisabled(editor) {
	      if (editor.selection == null) return true;
	      var _Editor$nodes = Editor.nodes(editor, {
	          match: function match(n) {
	            var type = DomEditor.getNodeType(n);
	            if (type === 'pre') return true; // 代码块
	            if (Editor.isVoid(editor, n)) return true; // void node

	            return false;
	          },
	          universal: true
	        }),
	        _Editor$nodes2 = _slicedToArray(_Editor$nodes, 1),
	        match = _Editor$nodes2[0];

	      // 命中，则禁用
	      if (match) return true;
	      return false;
	    }
	  }, {
	    key: "getPanelContentElem",
	    value: function getPanelContentElem(editor) {
	      var _context;
	      var mark = this.mark;
	      if (this.$content == null) {
	        // 第一次渲染
	        var _$content = $$x('<ul class="s-e-panel-content-color"></ul>');
	        _$content.on('click', "li", function (e) {
	          var target = e.target;
	          if (target == null) return;
	          e.preventDefault();
	          // 还原选区
	          editor.restoreSelection();
	          // 获取选区内容
	          var selection = editor.selection;
	          if (selection == null) return;
	          var $li = $$x(target);
	          var val = $li.attr('data-value');
	          // 修改文本样式
	          if (val === '0') {
	            Editor.removeMark(editor, mark);
	            editor.hidePanelOrModal(); // 隐藏 modal
	          } else if (val === 'custom') {
	            console.log(val);
	          } else if (val) {
	            Editor.addMark(editor, mark, val);
	            editor.hidePanelOrModal(); // 隐藏 modal
	          }
	        });

	        this.$content = _$content;
	      }
	      var $content = this.$content;
	      if ($content == null) return document.createElement('ul');
	      $content.empty(); // 清空之后再重置内容

	      // 当前选中文本的颜色之
	      var selectedColor = this.getValue(editor);

	      // 获取菜单配置
	      var colorConf = this.mark === 'color' ? genColors() : genBgColors();
	      var colors = colorConf;
	      // 根据菜单配置生成 panel content
	      _forEachInstanceProperty(colors).call(colors, function (color) {
	        var $block = $$x("<div class=\"color-block\" data-value=\"".concat(color, "\"></div>"));
	        $block.css('background-color', color);
	        var $li = $$x("<li data-value=\"".concat(color, "\"></li>"));
	        if (selectedColor === color) {
	          $li.addClass('active');
	        }
	        $li.append($block);
	        $content.append($li);
	      });

	      // 清除颜色
	      var clearText = '';
	      if (mark === 'color') clearText = '默认颜色';
	      if (mark === 'bgColor') clearText = '清除背景色';
	      var $clearLi = $$x(_concatInstanceProperty(_context = "\n      <li data-value=\"0\" class=\"clear\">\n        ".concat(CLEAN_SVG, "\n        ")).call(_context, clearText, "\n      </li>\n    "));
	      $content.prepend($clearLi);
	      var $customLi = $$x("\n      <li data-value=\"custom\" class=\"custom\">\n        <input class=\"color-input\" type=\"text\" value=\"".concat(selectedColor || '', "\" />\n        <button class=\"clear-color-input\">\u6E05\u7A7A</button>\n        <button class=\"confirm-color-input\">\u786E\u8BA4</button>\n      </li>\n    "));
	      $customLi.on('click', '.color-input', function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	        e.target.focus();
	      });
	      $customLi.on('mousedown', '.color-input', function (e) {
	        e.stopPropagation();
	      });
	      $customLi.on('input', '.color-input', function (e) {
	        e.stopPropagation();
	        var $input = $$x(e.target);
	        if (!$input) return;
	        var val = $input.val();
	        if (!val) return;
	        if (!isHex(val) && !isRgb(val)) {
	          $input.addClass('error');
	        } else {
	          $input.removeClass('error');
	        }
	      });
	      $customLi.on('click', '.clear-color-input', function (e) {
	        e.stopPropagation();
	        _findInstanceProperty($customLi).call($customLi, '.color-input')[0].value = '';
	      });
	      $customLi.on('click', '.confirm-color-input', function (e) {
	        e.stopPropagation();
	        var val = _findInstanceProperty($customLi).call($customLi, '.color-input').val();
	        if (!val) return;
	        // 判断是否正确的颜色值
	        if (isHex(val) || isRgb(val)) {
	          // 还原选区
	          editor.restoreSelection();
	          // 获取选区内容
	          var selection = editor.selection;
	          if (selection == null) return;
	          Editor.addMark(editor, mark, val);
	          editor.hidePanelOrModal(); // 隐藏 modal
	        }
	      });

	      $content.append($customLi);
	      return $content[0];
	    }
	  }]);
	  return BaseMenu;
	}();

	function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var ColorMenu = /*#__PURE__*/function (_BaseMenu) {
	  _inherits(ColorMenu, _BaseMenu);
	  var _super = _createSuper$2(ColorMenu);
	  function ColorMenu() {
	    var _context;
	    var _this;
	    _classCallCheck(this, ColorMenu);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, _concatInstanceProperty(_context = [this]).call(_context, args));
	    _defineProperty$1(_assertThisInitialized(_this), "title", '文字颜色');
	    _defineProperty$1(_assertThisInitialized(_this), "iconSvg", FONT_COLOR_SVG);
	    _defineProperty$1(_assertThisInitialized(_this), "mark", 'color');
	    return _this;
	  }
	  return _createClass(ColorMenu);
	}(BaseMenu$1);

	function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var BgColorMenu = /*#__PURE__*/function (_BaseMenu) {
	  _inherits(BgColorMenu, _BaseMenu);
	  var _super = _createSuper$1(BgColorMenu);
	  function BgColorMenu() {
	    var _context;
	    var _this;
	    _classCallCheck(this, BgColorMenu);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, _concatInstanceProperty(_context = [this]).call(_context, args));
	    _defineProperty$1(_assertThisInitialized(_this), "title", '背景色');
	    _defineProperty$1(_assertThisInitialized(_this), "iconSvg", BG_COLOR_SVG);
	    _defineProperty$1(_assertThisInitialized(_this), "mark", 'bgColor');
	    return _this;
	  }
	  return _createClass(BgColorMenu);
	}(BaseMenu$1);

	var colorMenuConf = {
	  key: 'color',
	  factory: function factory() {
	    return new ColorMenu();
	  },
	  // 默认的菜单菜单配置，将存储在 editorConfig.MENU_CONF[key] 中
	  // 创建编辑器时，可通过 editorConfig.MENU_CONF[key] = {...} 来修改
	  config: {
	    colors: genColors()
	  }
	};
	var bgColorMenuConf = {
	  key: 'bgColor',
	  factory: function factory() {
	    return new BgColorMenu();
	  },
	  config: {
	    colors: genBgColors()
	  }
	};

	var color = {
	  renderStyle: renderStyle$2,
	  menus: [colorMenuConf, bgColorMenuConf]
	};

	/**
	 * 添加样式
	 * @param node slate elem
	 * @param vnode vnode
	 * @returns vnode
	 */
	function renderStyle$1(node, vnode) {
	  if (!Element.isElement(node)) return vnode;
	  var lineHeight = node.lineHeight;
	  var styleVnode = vnode;
	  if (lineHeight) {
	    addVnodeStyle(styleVnode, {
	      lineHeight: lineHeight
	    });
	  }
	  return styleVnode;
	}

	function genLineHeightConfig() {
	  return ['12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px', '30px', '35px', '40px', '45px', '50px', '60px', '70px', '80px'];
	}

	var LineHeightMenu = /*#__PURE__*/function () {
	  function LineHeightMenu() {
	    _classCallCheck(this, LineHeightMenu);
	    _defineProperty$1(this, "title", '行高');
	    _defineProperty$1(this, "iconSvg", LINE_HEIGHT_SVG);
	    _defineProperty$1(this, "tag", 'select');
	    _defineProperty$1(this, "width", 80);
	  }
	  _createClass(LineHeightMenu, [{
	    key: "getOptions",
	    value: function getOptions(editor) {
	      var options = [];

	      // 获取配置，参考 './config.ts'
	      var lineHeightList = genLineHeightConfig();

	      // 生成 options
	      options.push({
	        text: '默认行高',
	        value: '' // this.getValue(editor) 未找到结果时，会返回 '' ，正好对应到这里
	      });

	      _forEachInstanceProperty(lineHeightList).call(lineHeightList, function (height) {
	        options.push({
	          text: height,
	          value: height
	        });
	      });

	      // 设置 selected
	      var curValue = this.getValue(editor);
	      _forEachInstanceProperty(options).call(options, function (opt) {
	        if (opt.value === curValue) {
	          opt.selected = true;
	        } else {
	          delete opt.selected;
	        }
	      });
	      return options;
	    }

	    /**
	     * 获取匹配的 node 节点
	     * @param editor editor
	     */
	  }, {
	    key: "getMatchNode",
	    value: function getMatchNode(editor) {
	      var _Editor$nodes = Editor.nodes(editor, {
	          match: function match(n) {
	            var _context;
	            var type = DomEditor.getNodeType(n);

	            // line-height 匹配如下类型的 node
	            if (_startsWithInstanceProperty(type).call(type, 'header')) return true;
	            if (_includesInstanceProperty(_context = ['paragraph', 'blockquote', 'list-item']).call(_context, type)) {
	              return true;
	            }
	            return false;
	          },
	          universal: true,
	          mode: 'highest' // 匹配最高层级
	        }),
	        _Editor$nodes2 = _slicedToArray(_Editor$nodes, 1),
	        nodeEntry = _Editor$nodes2[0];
	      if (nodeEntry == null) return null;
	      return nodeEntry[0];
	    }
	  }, {
	    key: "isActive",
	    value: function isActive(editor) {
	      // select menu 会显示 selected value ，用不到 active
	      return false;
	    }

	    /**
	     * 获取 node.lineHeight 的值（如 '1' '1.5'），没有则返回 ''
	     * @param editor editor
	     */
	  }, {
	    key: "getValue",
	    value: function getValue(editor) {
	      var node = this.getMatchNode(editor);
	      if (node == null) return '';
	      if (!Element.isElement(node)) return '';
	      return node.lineHeight || '';
	    }
	  }, {
	    key: "isDisabled",
	    value: function isDisabled(editor) {
	      if (editor.selection == null) return true; // 禁用

	      var node = this.getMatchNode(editor);
	      if (node == null) return true; // 未匹配到指定 node ，禁用

	      return false;
	    }
	  }, {
	    key: "exec",
	    value: function exec(editor, value) {
	      Transforms.setNodes(editor, {
	        lineHeight: value.toString()
	      }, {
	        mode: 'highest'
	      });
	    }
	  }]);
	  return LineHeightMenu;
	}();

	var lineHeightMenuConf = {
	  key: 'lineHeight',
	  factory: function factory() {
	    return new LineHeightMenu();
	  },
	  // 默认的菜单菜单配置，将存储在 editorConfig.MENU_CONF[key] 中
	  // 创建编辑器时，可通过 editorConfig.MENU_CONF[key] = {...} 来修改
	  config: {
	    lineHeightList: genLineHeightConfig()
	  }
	};

	var lineHeight = {
	  renderStyle: renderStyle$1,
	  menus: [lineHeightMenuConf]
	};

	/**
	 * 添加样式
	 * @param node slate elem
	 * @param vnode vnode
	 * @returns vnode
	 */
	function renderStyle(node, vnode) {
	  var fontSize = node.fontSize;
	    node.fontFamily;
	  var styleVnode = vnode;
	  if (fontSize) {
	    addVnodeStyle(styleVnode, {
	      fontSize: fontSize
	    });
	  }
	  // if (fontFamily) {
	  //   addVnodeStyle(styleVnode, { fontFamily });
	  // }

	  return styleVnode;
	}

	var BaseMenu = /*#__PURE__*/function () {
	  function BaseMenu() {
	    _classCallCheck(this, BaseMenu);
	    _defineProperty$1(this, "title", void 0);
	    _defineProperty$1(this, "iconSvg", void 0);
	    _defineProperty$1(this, "mark", void 0);
	    // 'fontSize'/'fontFamily'
	    _defineProperty$1(this, "tag", 'select');
	    _defineProperty$1(this, "width", 80);
	  }
	  _createClass(BaseMenu, [{
	    key: "getOptions",
	    value: function getOptions(editor) {}
	  }, {
	    key: "isActive",
	    value: function isActive(editor) {
	      // select menu 会显示 selected value ，用不到 active
	      return false;
	    }
	  }, {
	    key: "getValue",
	    value: function getValue(editor) {
	      var mark = this.mark;
	      var curMarks = Editor.marks(editor);
	      // @ts-ignore
	      if (curMarks && curMarks[mark]) return curMarks[mark];
	      return '';
	    }
	  }, {
	    key: "isDisabled",
	    value: function isDisabled(editor) {
	      if (editor.selection == null) return true;
	      this.mark;
	      var _Editor$nodes = Editor.nodes(editor, {
	          match: function match(n) {
	            var type = DomEditor.getNodeType(n);
	            if (type === 'pre') return true; // 代码块
	            if (Editor.isVoid(editor, n)) return true; // void node

	            return false;
	          },
	          universal: true
	        }),
	        _Editor$nodes2 = _slicedToArray(_Editor$nodes, 1),
	        match = _Editor$nodes2[0];

	      // 匹配到，则禁用
	      if (match) return true;
	      return false;
	    }
	  }, {
	    key: "exec",
	    value: function exec(editor, value) {
	      var mark = this.mark;
	      if (value) {
	        editor.addMark(mark, value);
	      } else {
	        editor.removeMark(mark);
	      }
	    }
	  }]);
	  return BaseMenu;
	}();

	function genFontSizeConfig() {
	  var fontSizeList = [
	  // 元素支持两种形式：1. 字符串；2. { name: 'xxx', value: 'xxx' }
	  '12px', {
	    name: '13px',
	    value: '13px'
	  }, '14px', '15px', '16px', '19px', {
	    name: '22px',
	    value: '22px'
	  }, '24px', '29px', '32px', '40px', '48px'];
	  return fontSizeList;
	}

	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var FontSizeMenu = /*#__PURE__*/function (_BaseMenu) {
	  _inherits(FontSizeMenu, _BaseMenu);
	  var _super = _createSuper(FontSizeMenu);
	  function FontSizeMenu() {
	    var _context;
	    var _this;
	    _classCallCheck(this, FontSizeMenu);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, _concatInstanceProperty(_context = [this]).call(_context, args));
	    _defineProperty$1(_assertThisInitialized(_this), "title", '字号');
	    _defineProperty$1(_assertThisInitialized(_this), "iconSvg", FONT_SIZE_SVG);
	    _defineProperty$1(_assertThisInitialized(_this), "mark", 'fontSize');
	    return _this;
	  }
	  _createClass(FontSizeMenu, [{
	    key: "getOptions",
	    value: function getOptions(editor) {
	      var options = [];

	      // 获取配置，参考 './config.ts'
	      var fontSizeList = genFontSizeConfig();

	      // 生成 options
	      options.push({
	        text: '默认字号',
	        value: '' // this.getValue(editor) 未找到结果时，会返回 '' ，正好对应到这里
	      });

	      _forEachInstanceProperty(fontSizeList).call(fontSizeList, function (size) {
	        if (typeof size === 'string') {
	          options.push({
	            text: size,
	            value: size
	          });
	        } else if (_typeof$2(size) === 'object') {
	          var name = size.name,
	            value = size.value;
	          options.push({
	            text: name,
	            value: value
	          });
	        }
	      });

	      // 设置 selected
	      var curValue = this.getValue(editor);
	      _forEachInstanceProperty(options).call(options, function (opt) {
	        if (opt.value === curValue) {
	          opt.selected = true;
	        } else {
	          delete opt.selected;
	        }
	      });
	      return options;
	    }
	  }]);
	  return FontSizeMenu;
	}(BaseMenu);

	var fontSizeMenuConf = {
	  key: 'fontSize',
	  factory: function factory() {
	    return new FontSizeMenu();
	  },
	  // 默认的菜单菜单配置，将存储在 editorConfig.MENU_CONF[key] 中
	  // 创建编辑器时，可通过 editorConfig.MENU_CONF[key] = {...} 来修改
	  config: {
	    fontSizeList: genFontSizeConfig()
	  }
	};

	var fontSizeAndFamily = {
	  renderStyle: renderStyle,
	  menus: [fontSizeMenuConf]
	};

	/* eslint-disable */
	var protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/;
	var localhostDomainRE = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/;
	var nonLocalhostDomainRE = /^[^\s\.]+\.\S{2,}$/;

	/**
	 * Loosely validate a URL `string`.
	 *
	 * @param {String} string
	 * @return {Boolean}
	 */

	function isUrl(string) {
	  if (typeof string !== 'string') {
	    return false;
	  }
	  var match = string.match(protocolAndDomainRE);
	  if (!match) {
	    return false;
	  }
	  var everythingAfterProtocol = match[1];
	  if (!everythingAfterProtocol) {
	    return false;
	  }
	  if (localhostDomainRE.test(everythingAfterProtocol) || nonLocalhostDomainRE.test(everythingAfterProtocol)) {
	    return true;
	  }
	  return false;
	}

	/**
	 * 校验 link
	 * @param menuKey menu key
	 * @param editor editor
	 * @param text menu text
	 * @param url menu url
	 */
	function check(_x, _x2, _x3, _x4) {
	  return _check.apply(this, arguments);
	}
	/**
	 * 转换链接 url
	 * @param menuKey menu key
	 * @param editor editor
	 * @param url url
	 * @returns parsedUrl
	 */
	function _check() {
	  _check = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(menuKey, editor, text, url) {
	    var _editor$getMenuConfig, checkLink, res;
	    return _regeneratorRuntime.wrap(function _callee$(_context2) {
	      while (1) switch (_context2.prev = _context2.next) {
	        case 0:
	          _editor$getMenuConfig = editor.getMenuConfig(menuKey), checkLink = _editor$getMenuConfig.checkLink;
	          if (!checkLink) {
	            _context2.next = 10;
	            break;
	          }
	          _context2.next = 4;
	          return checkLink(text, url);
	        case 4:
	          res = _context2.sent;
	          if (!(typeof res === 'string')) {
	            _context2.next = 8;
	            break;
	          }
	          // 检验未通过，提示信息
	          editor.alert(res, 'error');
	          return _context2.abrupt("return", false);
	        case 8:
	          if (!(res == null)) {
	            _context2.next = 10;
	            break;
	          }
	          return _context2.abrupt("return", false);
	        case 10:
	          return _context2.abrupt("return", true);
	        case 11:
	        case "end":
	          return _context2.stop();
	      }
	    }, _callee);
	  }));
	  return _check.apply(this, arguments);
	}
	function parse(_x5, _x6, _x7) {
	  return _parse.apply(this, arguments);
	}
	function _parse() {
	  _parse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(menuKey, editor, url) {
	    var _editor$getMenuConfig2, parseLinkUrl, newUrl;
	    return _regeneratorRuntime.wrap(function _callee2$(_context3) {
	      while (1) switch (_context3.prev = _context3.next) {
	        case 0:
	          _editor$getMenuConfig2 = editor.getMenuConfig(menuKey), parseLinkUrl = _editor$getMenuConfig2.parseLinkUrl;
	          if (!parseLinkUrl) {
	            _context3.next = 6;
	            break;
	          }
	          _context3.next = 4;
	          return parseLinkUrl(url);
	        case 4:
	          newUrl = _context3.sent;
	          return _context3.abrupt("return", newUrl);
	        case 6:
	          return _context3.abrupt("return", url);
	        case 7:
	        case "end":
	          return _context3.stop();
	      }
	    }, _callee2);
	  }));
	  return _parse.apply(this, arguments);
	}
	function isMenuDisabled$1(editor) {
	  if (editor.selection == null) return true;
	  var selectedElems = DomEditor.getSelectedElems(editor);
	  var notMatch = _someInstanceProperty(selectedElems).call(selectedElems, function (elem) {
	    var _context;
	    var type = elem.type;
	    if (editor.isVoid(elem)) return true;
	    if (_includesInstanceProperty(_context = ['pre', 'code', 'link']).call(_context, type)) return true;
	  });
	  if (notMatch) return true; // disabled
	  return false; // enable
	}

	/**
	 * 生成 link node
	 * @param url url
	 * @param text text
	 */
	function genLinkNode(url, text) {
	  var linkNode = {
	    type: 'link',
	    url: replaceSymbols(url),
	    children: text ? [{
	      text: text
	    }] : []
	  };
	  return linkNode;
	}

	/**
	 * 插入 link
	 * @param editor editor
	 * @param text text
	 * @param url url
	 */
	function insertLink(_x8, _x9, _x10) {
	  return _insertLink.apply(this, arguments);
	}

	/**
	 * 修改 link url
	 * @param editor editor
	 * @param text text
	 * @param url link url
	 */
	function _insertLink() {
	  _insertLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(editor, text, url) {
	    var checkRes, parsedUrl, selection, isCollapsed, linkNode, selectedText, _linkNode, _linkNode2;
	    return _regeneratorRuntime.wrap(function _callee3$(_context4) {
	      while (1) switch (_context4.prev = _context4.next) {
	        case 0:
	          if (url) {
	            _context4.next = 2;
	            break;
	          }
	          return _context4.abrupt("return");
	        case 2:
	          if (!text) text = url; // 无 text 则用 url 代替

	          // 还原选区
	          editor.restoreSelection();
	          if (!isMenuDisabled$1(editor)) {
	            _context4.next = 6;
	            break;
	          }
	          return _context4.abrupt("return");
	        case 6:
	          _context4.next = 8;
	          return check('insertLink', editor, text, url);
	        case 8:
	          checkRes = _context4.sent;
	          if (checkRes) {
	            _context4.next = 11;
	            break;
	          }
	          return _context4.abrupt("return");
	        case 11:
	          _context4.next = 13;
	          return parse('insertLink', editor, url);
	        case 13:
	          parsedUrl = _context4.sent;
	          // 判断选区是否折叠
	          selection = editor.selection;
	          if (!(selection == null)) {
	            _context4.next = 17;
	            break;
	          }
	          return _context4.abrupt("return");
	        case 17:
	          isCollapsed = Range.isCollapsed(selection); // 执行：插入链接
	          if (isCollapsed) {
	            // 链接前后插入空格，方便操作
	            editor.insertText(' ');
	            linkNode = genLinkNode(parsedUrl, text);
	            Transforms.insertNodes(editor, linkNode);

	            // https://github.com/wangeditor-team/wangEditor/issues/332
	            // 不能直接使用 insertText, 会造成添加的空格被添加到链接文本中，参考上面 issue，替换为 insertFragment 方式添加空格
	            editor.insertFragment([{
	              text: ' '
	            }]);
	          } else {
	            selectedText = Editor.string(editor, selection); // 选中的文字
	            if (selectedText !== text) {
	              // 选中的文字和输入的文字不一样，则删掉文字，插入链接
	              editor.deleteFragment();
	              _linkNode = genLinkNode(parsedUrl, text);
	              Transforms.insertNodes(editor, _linkNode);
	            } else {
	              // 选中的文字和输入的文字一样，则只包裹链接即可
	              _linkNode2 = genLinkNode(parsedUrl);
	              Transforms.wrapNodes(editor, _linkNode2, {
	                split: true
	              });
	              Transforms.collapse(editor, {
	                edge: 'end'
	              });
	            }
	          }
	        case 19:
	        case "end":
	          return _context4.stop();
	      }
	    }, _callee3);
	  }));
	  return _insertLink.apply(this, arguments);
	}
	function updateLink(_x11, _x12, _x13) {
	  return _updateLink.apply(this, arguments);
	}
	function _updateLink() {
	  _updateLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(editor, text, url) {
	    var checkRes, parsedUrl, props;
	    return _regeneratorRuntime.wrap(function _callee4$(_context5) {
	      while (1) switch (_context5.prev = _context5.next) {
	        case 0:
	          if (url) {
	            _context5.next = 2;
	            break;
	          }
	          return _context5.abrupt("return");
	        case 2:
	          _context5.next = 4;
	          return check('editLink', editor, text, url);
	        case 4:
	          checkRes = _context5.sent;
	          if (checkRes) {
	            _context5.next = 7;
	            break;
	          }
	          return _context5.abrupt("return");
	        case 7:
	          _context5.next = 9;
	          return parse('editLink', editor, url);
	        case 9:
	          parsedUrl = _context5.sent;
	          // 修改链接
	          props = {
	            url: replaceSymbols(parsedUrl)
	          };
	          Transforms.setNodes(editor, props, {
	            match: function match(n) {
	              return DomEditor.checkNodeType(n, 'link');
	            }
	          });
	        case 12:
	        case "end":
	          return _context5.stop();
	      }
	    }, _callee4);
	  }));
	  return _updateLink.apply(this, arguments);
	}

	function withLink(editor) {
	  var isInline = editor.isInline,
	    insertData = editor.insertData,
	    normalizeNode = editor.normalizeNode;
	    editor.insertNode;
	    editor.insertText;
	  var newEditor = editor;

	  // 重写 isInline
	  newEditor.isInline = function (elem) {
	    var type = elem.type;
	    if (type === 'link') {
	      return true;
	    }
	    return isInline(elem);
	  };

	  // 重写 insertData ，粘贴插入链接
	  newEditor.insertData = function (data) {
	    var text = data.getData('text/plain');
	    if (!isUrl(text)) {
	      // 非链接
	      insertData(data);
	      return;
	    }

	    // 插入链接
	    if (isMenuDisabled$1(newEditor)) return; // disabled
	    var selection = newEditor.selection;
	    if (selection == null) return;
	    var selectedText = Editor.string(newEditor, selection); // 获取选中的文字
	    insertLink(newEditor, selectedText, text);
	  };
	  newEditor.normalizeNode = function (_ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	      node = _ref2[0],
	      path = _ref2[1];
	    var type = DomEditor.getNodeType(node);
	    if (type !== 'link') {
	      // 未命中 link ，执行默认的 normalizeNode
	      return normalizeNode([node, path]);
	    }

	    // 如果链接内容为空，则删除
	    var str = Node.string(node);
	    if (str === '') {
	      return Transforms.removeNodes(newEditor, {
	        at: path
	      });
	    }
	    return normalizeNode([node, path]);
	  };

	  // 返回 editor ，重要！
	  return newEditor;
	}

	/**
	 * render link elem
	 * @param elemNode slate elem
	 * @param children children
	 * @param editor editor
	 * @returns vnode
	 */
	function renderLink(elemNode, children, editor) {
	  var url = elemNode.url,
	    _elemNode$target = elemNode.target,
	    target = _elemNode$target === void 0 ? '_blank' : _elemNode$target;
	  var vnode = h('a', {
	    href: url,
	    target: target
	  }, children);
	  return vnode;
	}
	var renderLinkConf = {
	  type: 'link',
	  // 和 elemNode.type 一致
	  renderElem: renderLink
	};

	/**
	 * 生成唯一的 DOM ID
	 */
	function genDomID$3() {
	  return 's-e-insert-link-' + _parseInt$1(Math.random() * 100);
	}
	var InsertLinkMenu = /*#__PURE__*/function () {
	  function InsertLinkMenu() {
	    _classCallCheck(this, InsertLinkMenu);
	    _defineProperty$1(this, "title", '插入链接');
	    _defineProperty$1(this, "iconSvg", LINK_SVG);
	    _defineProperty$1(this, "tag", 'button');
	    _defineProperty$1(this, "showModal", true);
	    // 点击 button 时显示 modal
	    _defineProperty$1(this, "modalWidth", 300);
	    _defineProperty$1(this, "$content", null);
	    _defineProperty$1(this, "textInputId", genDomID$3());
	    _defineProperty$1(this, "urlInputId", genDomID$3());
	    _defineProperty$1(this, "buttonId", genDomID$3());
	  }
	  _createClass(InsertLinkMenu, [{
	    key: "getValue",
	    value: function getValue(editor) {
	      // 插入菜单，不需要 value
	      return '';
	    }
	  }, {
	    key: "isActive",
	    value: function isActive(editor) {
	      // 任何时候，都不用激活 menu
	      return false;
	    }
	  }, {
	    key: "exec",
	    value: function exec(editor, value) {
	      // 点击菜单时，弹出 modal 之前，不需要执行其他代码
	      // 此处空着即可
	    }
	  }, {
	    key: "isDisabled",
	    value: function isDisabled(editor) {
	      return isMenuDisabled$1(editor);
	    }
	  }, {
	    key: "getModalPositionNode",
	    value: function getModalPositionNode(editor) {
	      return null; // modal 依据选区定位
	    }
	  }, {
	    key: "getModalContentElem",
	    value: function getModalContentElem(editor) {
	      var selection = editor.selection;
	      var textInputId = this.textInputId,
	        urlInputId = this.urlInputId,
	        buttonId = this.buttonId;

	      // 获取 input button elem
	      var _genModalInputElems = genModalInputElems('文本', textInputId),
	        _genModalInputElems2 = _slicedToArray(_genModalInputElems, 2),
	        textContainerElem = _genModalInputElems2[0],
	        inputTextElem = _genModalInputElems2[1];
	      var $inputText = $$x(inputTextElem);
	      var _genModalInputElems3 = genModalInputElems('url', urlInputId),
	        _genModalInputElems4 = _slicedToArray(_genModalInputElems3, 2),
	        urlContainerElem = _genModalInputElems4[0],
	        inputUrlElem = _genModalInputElems4[1];
	      var $inputUrl = $$x(inputUrlElem);
	      var _genModalButtonElems = genModalButtonElems(buttonId, '确认'),
	        _genModalButtonElems2 = _slicedToArray(_genModalButtonElems, 1),
	        buttonContainerElem = _genModalButtonElems2[0];
	      if (this.$content == null) {
	        // 第一次渲染
	        var _$content = $$x('<div></div>');
	        // 绑定事件（第一次渲染时绑定，不要重复绑定）
	        _$content.on('click', "#".concat(buttonId), function (e) {
	          e.preventDefault();
	          var text = _findInstanceProperty(_$content).call(_$content, "#".concat(textInputId)).val();
	          var url = _findInstanceProperty(_$content).call(_$content, "#".concat(urlInputId)).val();
	          insertLink(editor, text, url); // 插入链接
	          editor.hidePanelOrModal(); // 隐藏 modal
	        });
	        // 记录属性，重要
	        this.$content = _$content;
	      }
	      var $content = this.$content;
	      $content.empty(); // 先清空内容

	      // append inputs and button
	      $content.append(textContainerElem);
	      $content.append(urlContainerElem);
	      $content.append(buttonContainerElem);

	      // 设置 input val
	      if (selection == null || Range.isCollapsed(selection)) {
	        // 选区无内容
	        $inputText.val('');
	      } else {
	        // 选区有内容
	        var selectionText = Editor.string(editor, selection);
	        $inputText.val(selectionText);
	      }
	      $inputUrl.val('');

	      // focus 一个 input（异步，此时 DOM 尚未渲染）
	      _setTimeout(function () {
	        $inputText.focus();
	      });
	      return $content[0];
	    }
	  }]);
	  return InsertLinkMenu;
	}();

	/**
	 * 生成唯一的 DOM ID
	 */
	function genDomID$2() {
	  return 's-e-update-link-' + _parseInt$1(Math.random() * 100);
	}
	var EditLinkMenu = /*#__PURE__*/function () {
	  function EditLinkMenu() {
	    _classCallCheck(this, EditLinkMenu);
	    _defineProperty$1(this, "title", '编辑链接');
	    _defineProperty$1(this, "iconSvg", PENCIL_SVG);
	    _defineProperty$1(this, "tag", 'button');
	    _defineProperty$1(this, "showModal", true);
	    // 点击 button 时显示 modal
	    _defineProperty$1(this, "modalWidth", 300);
	    _defineProperty$1(this, "$content", null);
	    _defineProperty$1(this, "urlInputId", genDomID$2());
	    _defineProperty$1(this, "buttonId", genDomID$2());
	  }
	  _createClass(EditLinkMenu, [{
	    key: "getSelectedLinkElem",
	    value: function getSelectedLinkElem(editor) {
	      var node = DomEditor.getSelectedNodeByType(editor, 'link');
	      if (node == null) return null;
	      return node;
	    }

	    /**
	     * 获取 node.url
	     * @param editor editor
	     */
	  }, {
	    key: "getValue",
	    value: function getValue(editor) {
	      var linkElem = this.getSelectedLinkElem(editor);
	      if (linkElem) {
	        return linkElem.url || '';
	      }
	      return '';
	    }
	  }, {
	    key: "isActive",
	    value: function isActive(editor) {
	      // 无需 active
	      return false;
	    }
	  }, {
	    key: "exec",
	    value: function exec(editor, value) {
	      // 点击菜单时，弹出 modal 之前，不需要执行其他代码
	      // 此处空着即可
	    }
	  }, {
	    key: "isDisabled",
	    value: function isDisabled(editor) {
	      if (editor.selection == null) return true;
	      var linkElem = this.getSelectedLinkElem(editor);

	      // 未匹配到 link node 则禁用
	      if (linkElem == null) return true;
	      return false;
	    }

	    // modal 定位
	  }, {
	    key: "getModalPositionNode",
	    value: function getModalPositionNode(editor) {
	      return DomEditor.getSelectedNodeByType(editor, 'link');
	    }
	  }, {
	    key: "getModalContentElem",
	    value: function getModalContentElem(editor) {
	      var urlInputId = this.urlInputId,
	        buttonId = this.buttonId;

	      // 获取 input button elem
	      var _genModalInputElems = genModalInputElems('链接', urlInputId),
	        _genModalInputElems2 = _slicedToArray(_genModalInputElems, 2),
	        urlContainerElem = _genModalInputElems2[0],
	        inputUrlElem = _genModalInputElems2[1];
	      var $inputUrl = $$x(inputUrlElem);
	      var _genModalButtonElems = genModalButtonElems(buttonId, '确认'),
	        _genModalButtonElems2 = _slicedToArray(_genModalButtonElems, 1),
	        buttonContainerElem = _genModalButtonElems2[0];
	      if (this.$content == null) {
	        // 第一次渲染
	        var _$content = $$x('<div></div>');

	        // 绑定事件（第一次渲染时绑定，不要重复绑定）
	        _$content.on('click', "#".concat(buttonId), function (e) {
	          e.preventDefault();
	          editor.restoreSelection(); // 还原选区

	          var n = DomEditor.getSelectedNodeByType(editor, 'link');
	          var text = n ? Node.string(n) : '';
	          var url = _findInstanceProperty(_$content).call(_$content, "#".concat(urlInputId)).val();
	          updateLink(editor, text, url); // 修改链接

	          editor.hidePanelOrModal(); // 隐藏 modal
	        });
	        // 记录属性，重要
	        this.$content = _$content;
	      }
	      var $content = this.$content;
	      $content.empty(); // 先清空内容

	      // append input and button
	      $content.append(urlContainerElem);
	      $content.append(buttonContainerElem);

	      // 设置 input val
	      var url = this.getValue(editor);
	      $inputUrl.val(url);

	      // focus 一个 input（异步，此时 DOM 尚未渲染）
	      _setTimeout(function () {
	        $inputUrl.focus();
	      });
	      return $content[0];
	    }
	  }]);
	  return EditLinkMenu;
	}();

	var UnLink = /*#__PURE__*/function () {
	  function UnLink() {
	    _classCallCheck(this, UnLink);
	    _defineProperty$1(this, "title", '取消链接');
	    _defineProperty$1(this, "iconSvg", UN_LINK_SVG);
	    _defineProperty$1(this, "tag", 'button');
	  }
	  _createClass(UnLink, [{
	    key: "getValue",
	    value: function getValue(editor) {
	      // 无需获取 val
	      return '';
	    }
	  }, {
	    key: "isActive",
	    value: function isActive(editor) {
	      // 无需 active
	      return false;
	    }
	  }, {
	    key: "isDisabled",
	    value: function isDisabled(editor) {
	      if (editor.selection == null) return true;
	      var linkNode = DomEditor.getSelectedNodeByType(editor, 'link');
	      if (linkNode == null) {
	        // 选区未处于 link node ，则禁用
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: "exec",
	    value: function exec(editor, value) {
	      if (this.isDisabled(editor)) return;

	      // 取消链接
	      Transforms.unwrapNodes(editor, {
	        match: function match(n) {
	          return DomEditor.checkNodeType(n, 'link');
	        }
	      });
	    }
	  }]);
	  return UnLink;
	}();

	var ViewLink = /*#__PURE__*/function () {
	  function ViewLink() {
	    _classCallCheck(this, ViewLink);
	    _defineProperty$1(this, "title", '查看链接');
	    _defineProperty$1(this, "iconSvg", EXTERNAL_SVG);
	    _defineProperty$1(this, "tag", 'button');
	  }
	  _createClass(ViewLink, [{
	    key: "getSelectedLinkElem",
	    value: function getSelectedLinkElem(editor) {
	      var node = DomEditor.getSelectedNodeByType(editor, 'link');
	      if (node == null) return null;
	      return node;
	    }
	  }, {
	    key: "getValue",
	    value: function getValue(editor) {
	      var linkElem = this.getSelectedLinkElem(editor);
	      if (linkElem) {
	        return linkElem.url || '';
	      }
	      return '';
	    }
	  }, {
	    key: "isActive",
	    value: function isActive(editor) {
	      // 无需 active
	      return false;
	    }
	  }, {
	    key: "isDisabled",
	    value: function isDisabled(editor) {
	      if (editor.selection == null) return true;
	      var linkElem = this.getSelectedLinkElem(editor);
	      if (linkElem == null) {
	        // 选区未处于 link node ，则禁用
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: "exec",
	    value: function exec(editor, value) {
	      if (this.isDisabled(editor)) return;
	      if (!value || typeof value !== 'string') {
	        throw new Error("View link failed, link url is '".concat(value, "'"));
	      }

	      // 查看链接
	      window.open(value, '_blank');
	    }
	  }]);
	  return ViewLink;
	}();

	function genLinkMenuConfig() {
	  return {
	    /**
	     * 检查链接，支持 async fn
	     * @param text link text
	     * @param url link url
	     */
	    checkLink: function checkLink(text, url) {
	      // 1. 返回 true ，说明检查通过
	      // 2. 返回一个字符串，说明检查未通过，编辑器会阻止插入。会 alert 出错误信息（即返回的字符串）
	      // 3. 返回 undefined（即没有任何返回），说明检查未通过，编辑器会阻止插入
	      return true;
	    },
	    /**
	     * parse link url
	     * @param url url
	     * @returns newUrl
	     */
	    parseLinkUrl: function parseLinkUrl(url) {
	      return url;
	    }
	  };
	}

	var config = genLinkMenuConfig(); // menu config

	var insertLinkMenuConf = {
	  key: 'insertLink',
	  factory: function factory() {
	    return new InsertLinkMenu();
	  },
	  // 默认的菜单菜单配置，将存储在 editorConfig.MENU_CONF[key] 中
	  // 创建编辑器时，可通过 editorConfig.MENU_CONF[key] = {...} 来修改
	  config: config
	};
	var editLinkMenuConf = {
	  key: 'editLink',
	  factory: function factory() {
	    return new EditLinkMenu();
	  },
	  config: config
	};
	var unLinkMenuConf = {
	  key: 'unLink',
	  factory: function factory() {
	    return new UnLink();
	  }
	};
	var viewLinkMenuConf = {
	  key: 'viewLink',
	  factory: function factory() {
	    return new ViewLink();
	  }
	};

	var link = {
	  renderElems: [renderLinkConf],
	  menus: [insertLinkMenuConf, editLinkMenuConf, unLinkMenuConf, viewLinkMenuConf],
	  editorPlugins: [withLink]
	};

	function withButton(editor) {
	  var isInline = editor.isInline;
	    editor.isVoid;
	  var newEditor = editor;

	  // 重写 isInline
	  newEditor.isInline = function (elem) {
	    var type = elem.type;
	    if (type === 'button') {
	      return true;
	    }
	    return isInline(elem);
	  };

	  // 返回 editor ，重要！
	  return newEditor;
	}

	/**
	 * render button elem
	 * @param elemNode slate elem
	 * @param children children
	 * @param editor editor
	 * @returns vnode
	 */
	function renderButton(elemNode, children, editor) {
	  var _context;
	  var id = elemNode.id;
	    elemNode.text;
	    var key = elemNode.key;
	  var vnode = h('button', {
	    attrs: {
	      'data-editor-button': true,
	      'data-button-key': key,
	      'data-button-id': id
	    }
	  }, _concatInstanceProperty(_context = [
	  // 增加光标间隙
	  h('span', {
	    attrs: {
	      contenteditable: 'false',
	      style: 'font-size: 0'
	    }
	  }, ['&nbsp;'])]).call(_context, _toConsumableArray(children), [h('span', {
	    attrs: {
	      contenteditable: 'false',
	      style: 'font-size: 0'
	    }
	  }, ['&nbsp;'])]));
	  return vnode;
	}
	var renderButtonConf = {
	  type: 'button',
	  // 和 elemNode.type 一致
	  renderElem: renderButton
	};

	function isMenuDisabled(editor) {
	  if (editor.selection == null) return true;
	  var selectedElems = DomEditor.getSelectedElems(editor);
	  var notMatch = _someInstanceProperty(selectedElems).call(selectedElems, function (elem) {
	    var _context;
	    var type = elem.type;
	    if (editor.isVoid(elem)) return true;
	    if (_includesInstanceProperty(_context = ['pre', 'code', 'link']).call(_context, type)) return true;
	  });
	  if (notMatch) return true; // disabled
	  return false; // enable
	}

	/**
	 * 生成 button node
	 * @param text text
	 */
	function genButtonNode(text, key) {
	  var linkNode = {
	    type: 'button',
	    id: 'button-' + Math.random().toString(16).substring(2),
	    key: key,
	    data: null,
	    children: text ? [{
	      text: text
	    }, {
	      text: "\uFEFF"
	    }] : [{
	      text: "\uFEFF"
	    }]
	  };
	  return linkNode;
	}

	/**
	 * 插入 button
	 * @param editor editor
	 * @param text text
	 */
	function insertButton(_x, _x2, _x3) {
	  return _insertButton.apply(this, arguments);
	}

	/**
	 * 修改 button
	 * @param editor editor
	 */
	function _insertButton() {
	  _insertButton = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(editor, text, key) {
	    var selection, isCollapsed, buttonNode, _buttonNode;
	    return _regeneratorRuntime.wrap(function _callee$(_context2) {
	      while (1) switch (_context2.prev = _context2.next) {
	        case 0:
	          if (text) {
	            _context2.next = 2;
	            break;
	          }
	          return _context2.abrupt("return");
	        case 2:
	          // 还原选区
	          editor.restoreSelection();
	          if (!isMenuDisabled(editor)) {
	            _context2.next = 5;
	            break;
	          }
	          return _context2.abrupt("return");
	        case 5:
	          // 判断选区是否折叠
	          selection = editor.selection;
	          if (!(selection == null)) {
	            _context2.next = 8;
	            break;
	          }
	          return _context2.abrupt("return");
	        case 8:
	          isCollapsed = Range.isCollapsed(selection); // 执行：插入button
	          if (isCollapsed) {
	            buttonNode = genButtonNode(text, key);
	            Transforms.insertNodes(editor, buttonNode);
	          } else {
	            _buttonNode = genButtonNode(text, key);
	            Transforms.wrapNodes(editor, _buttonNode, {
	              split: true
	            });
	            Transforms.collapse(editor, {
	              edge: 'end'
	            });
	          }
	        case 10:
	        case "end":
	          return _context2.stop();
	      }
	    }, _callee);
	  }));
	  return _insertButton.apply(this, arguments);
	}
	function updateButton(_x4, _x5, _x6) {
	  return _updateButton.apply(this, arguments);
	}
	function _updateButton() {
	  _updateButton = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(editor, text, key) {
	    var props;
	    return _regeneratorRuntime.wrap(function _callee2$(_context3) {
	      while (1) switch (_context3.prev = _context3.next) {
	        case 0:
	          // 还原选区
	          editor.restoreSelection();

	          // 修改按钮
	          props = {
	            key: key
	          };
	          Transforms.setNodes(editor, props, {
	            match: function match(n) {
	              return DomEditor.checkNodeType(n, 'button');
	            }
	          });
	        case 3:
	        case "end":
	          return _context3.stop();
	      }
	    }, _callee2);
	  }));
	  return _updateButton.apply(this, arguments);
	}

	/**
	 * 生成唯一的 DOM ID
	 */
	function genDomID$1() {
	  return 's-e-insert-button-' + _parseInt$1(Math.random() * 100);
	}
	var InsertButtonMenu = /*#__PURE__*/function () {
	  function InsertButtonMenu() {
	    _classCallCheck(this, InsertButtonMenu);
	    _defineProperty$1(this, "title", '注释');
	    _defineProperty$1(this, "iconSvg", BUTTON_SVG);
	    _defineProperty$1(this, "tag", 'button');
	    _defineProperty$1(this, "showModal", true);
	    // 点击 button 时显示 modal
	    _defineProperty$1(this, "modalWidth", 300);
	    _defineProperty$1(this, "$content", null);
	    _defineProperty$1(this, "textInputId", genDomID$1());
	    _defineProperty$1(this, "keySelectId", genDomID$1());
	    _defineProperty$1(this, "buttonId", genDomID$1());
	  }
	  _createClass(InsertButtonMenu, [{
	    key: "getValue",
	    value: function getValue(editor) {
	      // 插入菜单，不需要 value
	      return '';
	    }
	  }, {
	    key: "isActive",
	    value: function isActive(editor) {
	      // 任何时候，都不用激活 menu
	      return false;
	    }
	  }, {
	    key: "exec",
	    value: function exec(editor, value) {
	      // 点击菜单时，弹出 modal 之前，不需要执行其他代码
	      // 此处空着即可
	    }
	  }, {
	    key: "isDisabled",
	    value: function isDisabled(editor) {
	      return isMenuDisabled(editor);
	    }
	  }, {
	    key: "getModalPositionNode",
	    value: function getModalPositionNode(editor) {
	      return null; // modal 依据选区定位
	    }
	  }, {
	    key: "getModalContentElem",
	    value: function getModalContentElem(editor) {
	      var selection = editor.selection;
	      var textInputId = this.textInputId,
	        keySelectId = this.keySelectId,
	        buttonId = this.buttonId;
	      var _editor$getMenuConfig = editor.getMenuConfig('button'),
	        _editor$getMenuConfig2 = _editor$getMenuConfig.options,
	        options = _editor$getMenuConfig2 === void 0 ? [] : _editor$getMenuConfig2;
	      // 获取 input button elem
	      var _genModalInputElems = genModalInputElems('文本', textInputId),
	        _genModalInputElems2 = _slicedToArray(_genModalInputElems, 2),
	        textContainerElem = _genModalInputElems2[0],
	        inputTextElem = _genModalInputElems2[1];
	      var $inputText = $$x(inputTextElem);
	      var _genModalSelectElems = genModalSelectElems('弹出样式', keySelectId, '请选择', options),
	        _genModalSelectElems2 = _slicedToArray(_genModalSelectElems, 2),
	        keyContainerElem = _genModalSelectElems2[0],
	        selectKeyElem = _genModalSelectElems2[1];
	      var $selectKey = $$x(selectKeyElem);
	      var _genModalButtonElems = genModalButtonElems(buttonId, '确认'),
	        _genModalButtonElems2 = _slicedToArray(_genModalButtonElems, 1),
	        buttonContainerElem = _genModalButtonElems2[0];
	      if (this.$content == null) {
	        // 第一次渲染
	        var _$content = $$x('<div></div>');

	        // 绑定事件（第一次渲染时绑定，不要重复绑定）
	        _$content.on('click', "#".concat(buttonId), function (e) {
	          e.preventDefault();
	          var text = _findInstanceProperty(_$content).call(_$content, "#".concat(textInputId)).val();
	          var key = _findInstanceProperty(_$content).call(_$content, "#".concat(keySelectId)).val();
	          insertButton(editor, text, key); // 插入button
	          editor.hidePanelOrModal(); // 隐藏 modal
	        });

	        // 记录属性，重要
	        this.$content = _$content;
	      }
	      var $content = this.$content;
	      $content.empty(); // 先清空内容

	      // append inputs and button
	      $content.append(textContainerElem);
	      $content.append(keyContainerElem);
	      $content.append(buttonContainerElem);

	      // 设置 input val
	      if (selection == null || Range.isCollapsed(selection)) {
	        // 选区无内容
	        $inputText.val('');
	      } else {
	        // 选区有内容
	        var selectionText = Editor.string(editor, selection);
	        $inputText.val(selectionText);
	      }
	      $selectKey.val('');

	      // focus 一个 input（异步，此时 DOM 尚未渲染）
	      _setTimeout(function () {
	        $inputText.focus();
	      });
	      return $content[0];
	    }
	  }]);
	  return InsertButtonMenu;
	}();

	/**
	 * 生成唯一的 DOM ID
	 */
	function genDomID() {
	  return 's-e-update-button-' + _parseInt$1(Math.random() * 100);
	}
	var EditButtonMenu = /*#__PURE__*/function () {
	  function EditButtonMenu() {
	    _classCallCheck(this, EditButtonMenu);
	    _defineProperty$1(this, "title", '编辑');
	    _defineProperty$1(this, "iconSvg", PENCIL_SVG);
	    _defineProperty$1(this, "tag", 'button');
	    _defineProperty$1(this, "showModal", true);
	    // 点击 button 时显示 modal
	    _defineProperty$1(this, "modalWidth", 300);
	    _defineProperty$1(this, "$content", null);
	    _defineProperty$1(this, "keySelectId", genDomID());
	    _defineProperty$1(this, "buttonId", genDomID());
	  }
	  _createClass(EditButtonMenu, [{
	    key: "getSelectedButtonElem",
	    value: function getSelectedButtonElem(editor) {
	      var node = DomEditor.getSelectedNodeByType(editor, 'button');
	      if (node == null) return null;
	      return node;
	    }

	    /**
	     * 获取 node.key
	     * @param editor editor
	     */
	  }, {
	    key: "getValue",
	    value: function getValue(editor) {
	      var buttonElem = this.getSelectedButtonElem(editor);
	      if (buttonElem) {
	        return buttonElem.key || '';
	      }
	      return '';
	    }
	  }, {
	    key: "isActive",
	    value: function isActive(editor) {
	      // 无需 active
	      return false;
	    }
	  }, {
	    key: "exec",
	    value: function exec(editor, value) {
	      // 点击菜单时，弹出 modal 之前，不需要执行其他代码
	      // 此处空着即可
	    }
	  }, {
	    key: "isDisabled",
	    value: function isDisabled(editor) {
	      if (editor.selection == null) return true;
	      var linkButton = this.getSelectedButtonElem(editor);

	      // 未匹配到 link node 则禁用
	      if (linkButton == null) return true;
	      return false;
	    }

	    // modal 定位
	  }, {
	    key: "getModalPositionNode",
	    value: function getModalPositionNode(editor) {
	      return null;
	    }
	  }, {
	    key: "getModalContentElem",
	    value: function getModalContentElem(editor) {
	      var keySelectId = this.keySelectId,
	        buttonId = this.buttonId;
	      var _editor$getMenuConfig = editor.getMenuConfig('button'),
	        _editor$getMenuConfig2 = _editor$getMenuConfig.options,
	        options = _editor$getMenuConfig2 === void 0 ? [] : _editor$getMenuConfig2;
	      var _genModalSelectElems = genModalSelectElems('按钮类型', keySelectId, '请选择', options),
	        _genModalSelectElems2 = _slicedToArray(_genModalSelectElems, 2),
	        keyContainerElem = _genModalSelectElems2[0],
	        selectKeyElem = _genModalSelectElems2[1];
	      var $selectKey = $$x(selectKeyElem);
	      var _genModalButtonElems = genModalButtonElems(buttonId, '确认'),
	        _genModalButtonElems2 = _slicedToArray(_genModalButtonElems, 1),
	        buttonContainerElem = _genModalButtonElems2[0];
	      if (this.$content == null) {
	        // 第一次渲染
	        var _$content = $$x('<div></div>');
	        // 绑定事件（第一次渲染时绑定，不要重复绑定）
	        _$content.on('click', "#".concat(buttonId), function (e) {
	          e.preventDefault();
	          DomEditor.getSelectedNodeByType(editor, 'button');
	          // console.log(n);
	          var key = _findInstanceProperty(_$content).call(_$content, "#".concat(keySelectId)).val();
	          updateButton(editor, '', key); // 插入button
	          editor.hidePanelOrModal(); // 隐藏 modal
	        });

	        // 记录属性，重要
	        this.$content = _$content;
	      }
	      var $content = this.$content;
	      $content.empty(); // 先清空内容

	      // append input and button
	      $content.append(keyContainerElem);
	      $content.append(buttonContainerElem);

	      // 设置 input val
	      var key = this.getValue(editor);
	      $selectKey.val(key);

	      // focus 一个 input（异步，此时 DOM 尚未渲染）
	      _setTimeout(function () {
	        $selectKey.focus();
	      });
	      return $content[0];
	    }
	  }]);
	  return EditButtonMenu;
	}();

	var ExecButton = /*#__PURE__*/function () {
	  function ExecButton() {
	    _classCallCheck(this, ExecButton);
	    _defineProperty$1(this, "title", '触发');
	    _defineProperty$1(this, "iconSvg", CLICK_BUTTON_SVG);
	    _defineProperty$1(this, "tag", 'button');
	  }
	  _createClass(ExecButton, [{
	    key: "getValue",
	    value: function getValue(editor) {
	      // 无需获取 val
	      return '';
	    }
	  }, {
	    key: "isActive",
	    value: function isActive(editor) {
	      // 无需 active
	      return false;
	    }
	  }, {
	    key: "isDisabled",
	    value: function isDisabled(editor) {
	      if (editor.selection == null) return true;
	      var buttonNode = DomEditor.getSelectedNodeByType(editor, 'button');
	      if (buttonNode == null) {
	        // 选区未处于 button node ，则禁用
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: "exec",
	    value: function exec(editor, value) {
	      if (this.isDisabled(editor)) return;
	      var buttonNode = DomEditor.getSelectedNodeByType(editor, 'button');
	      var key = buttonNode.key,
	        id = buttonNode.id,
	        data = buttonNode.data;
	      var _editor$getMenuConfig = editor.getMenuConfig('button'),
	        customExec = _editor$getMenuConfig.customExec;
	      // 执行
	      // 获取菜单配置
	      customExec(key, id, data);
	    }
	  }]);
	  return ExecButton;
	}();

	var insertButtonMenuConf = {
	  key: 'insertButton',
	  factory: function factory() {
	    return new InsertButtonMenu();
	  }
	};
	var editButtonMenuConf = {
	  key: 'editButton',
	  factory: function factory() {
	    return new EditButtonMenu();
	  }
	};
	var execButtonMenuConf = {
	  key: 'execButton',
	  factory: function factory() {
	    return new ExecButton();
	  }
	};

	var button = {
	  renderElems: [renderButtonConf],
	  menus: [insertButtonMenuConf, editButtonMenuConf, execButtonMenuConf],
	  editorPlugins: [withButton]
	};

	// 存插件
	var EDITOR_PLUGINS = [];
	function registerPlugin(plugin) {
	  EDITOR_PLUGINS.push(plugin);
	}
	function loadModules() {
	  registerModule(textStyle);
	  registerModule(uploadImage);
	  registerModule(color);
	  registerModule(lineHeight);
	  registerModule(fontSizeAndFamily);
	  registerModule(link);
	  registerModule(button);
	  return EDITOR_PLUGINS;
	}

	function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context2, _context3; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(t), !0)).call(_context2, function (r) { _defineProperty$1(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context3 = ownKeys(Object(t))).call(_context3, function (r) { _Object$defineProperty$1(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
	var defaultContent = [{
	  type: 'paragraph',
	  children: [{
	    text: '请输入内容'
	  }]
	}];
	var defaultConfig = {
	  readOnly: false,
	  autoFocus: false,
	  hideToolbar: false,
	  decorate: function decorate() {
	    return [];
	  },
	  toolbarKeys: COMMON_TOOLBAR_KEYS,
	  hoverbarKeys: COMMON_HOVERBAR_KEYS,
	  MENU_CONF: {
	    // 图片上传配置
	    uploadImage: {
	      base64LimitSize: 10000000000,
	      customUpload: null
	    },
	    // 按钮默认配置
	    button: {
	      options: [{
	        value: 'TEST_BUTTON_KEY',
	        name: '测试按钮类型'
	      }],
	      customExec: function customExec(key, data) {
	        return console.log('button click ', key, data);
	      }
	    }
	  },
	  onFocus: function onFocus() {},
	  onBlur: function onBlur() {},
	  onChange: function onChange() {}
	};

	/**
	 * 创建 editor 实例
	 */
	function createEditor() {
	  var _context;
	  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _option$selector = option.selector,
	    selector = _option$selector === void 0 ? '' : _option$selector,
	    _option$content = option.content,
	    content = _option$content === void 0 ? defaultContent : _option$content,
	    html = option.html,
	    _option$config = option.config,
	    config = _option$config === void 0 ? {} : _option$config;
	    option.mode;
	    var _option$plugins = option.plugins,
	    plugins = _option$plugins === void 0 ? [] : _option$plugins;
	  // console.log(config);

	  // 优先加载模块
	  var modulePlugins = loadModules();

	  // console.log(plugins);

	  var editor = coreCreateEditor({
	    selector: selector,
	    config: _objectSpread(_objectSpread({}, defaultConfig), config),
	    content: content,
	    html: html,
	    plugins: _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(plugins), _toConsumableArray(modulePlugins))
	  });
	  return editor;
	}

	exports.createEditor = createEditor;

}));
